function ItemTypeAndSubTypeComplete() {
    return(ItemList)
}

function ItemTypeAndSubTypeConsult(ItemId) {
    return(ItemList[ItemId])
}

export {ItemTypeAndSubTypeComplete, ItemTypeAndSubTypeConsult};

const ItemList = {

500: {"Type":"Healing","SubType":"NULL"},
501: {"Type":"Healing","SubType":"NULL"},
502: {"Type":"Healing","SubType":"NULL"},
503: {"Type":"Healing","SubType":"NULL"},
504: {"Type":"Healing","SubType":"NULL"},
505: {"Type":"Healing","SubType":"NULL"},
506: {"Type":"Healing","SubType":"NULL"},
507: {"Type":"Healing","SubType":"NULL"},
508: {"Type":"Healing","SubType":"NULL"},
509: {"Type":"Healing","SubType":"NULL"},
510: {"Type":"Healing","SubType":"NULL"},
511: {"Type":"Healing","SubType":"NULL"},
512: {"Type":"Healing","SubType":"NULL"},
513: {"Type":"Healing","SubType":"NULL"},
514: {"Type":"Healing","SubType":"NULL"},
515: {"Type":"Healing","SubType":"NULL"},
516: {"Type":"Healing","SubType":"NULL"},
517: {"Type":"Healing","SubType":"NULL"},
518: {"Type":"Healing","SubType":"NULL"},
519: {"Type":"Healing","SubType":"NULL"},
520: {"Type":"Healing","SubType":"NULL"},
521: {"Type":"Healing","SubType":"NULL"},
522: {"Type":"Healing","SubType":"NULL"},
523: {"Type":"Healing","SubType":"NULL"},
525: {"Type":"Healing","SubType":"NULL"},
526: {"Type":"Healing","SubType":"NULL"},
528: {"Type":"Healing","SubType":"NULL"},
529: {"Type":"Healing","SubType":"NULL"},
530: {"Type":"Healing","SubType":"NULL"},
531: {"Type":"Healing","SubType":"NULL"},
532: {"Type":"Healing","SubType":"NULL"},
533: {"Type":"Healing","SubType":"NULL"},
534: {"Type":"Healing","SubType":"NULL"},
535: {"Type":"Healing","SubType":"NULL"},
536: {"Type":"Healing","SubType":"NULL"},
537: {"Type":"Healing","SubType":"NULL"},
538: {"Type":"Healing","SubType":"NULL"},
539: {"Type":"Healing","SubType":"NULL"},
540: {"Type":"Healing","SubType":"NULL"},
541: {"Type":"Healing","SubType":"NULL"},
542: {"Type":"Healing","SubType":"NULL"},
543: {"Type":"Healing","SubType":"NULL"},
544: {"Type":"Healing","SubType":"NULL"},
545: {"Type":"Healing","SubType":"NULL"},
546: {"Type":"Healing","SubType":"NULL"},
547: {"Type":"Healing","SubType":"NULL"},
548: {"Type":"Healing","SubType":"NULL"},
549: {"Type":"Healing","SubType":"NULL"},
550: {"Type":"Healing","SubType":"NULL"},
551: {"Type":"Healing","SubType":"NULL"},
552: {"Type":"Healing","SubType":"NULL"},
553: {"Type":"Healing","SubType":"NULL"},
554: {"Type":"Healing","SubType":"NULL"},
555: {"Type":"Healing","SubType":"NULL"},
556: {"Type":"Healing","SubType":"NULL"},
557: {"Type":"Healing","SubType":"NULL"},
558: {"Type":"Healing","SubType":"NULL"},
559: {"Type":"Healing","SubType":"NULL"},
560: {"Type":"Healing","SubType":"NULL"},
561: {"Type":"Healing","SubType":"NULL"},
562: {"Type":"Healing","SubType":"NULL"},
563: {"Type":"Healing","SubType":"NULL"},
564: {"Type":"Healing","SubType":"NULL"},
565: {"Type":"Healing","SubType":"NULL"},
566: {"Type":"Healing","SubType":"NULL"},
567: {"Type":"Healing","SubType":"NULL"},
568: {"Type":"Healing","SubType":"NULL"},
569: {"Type":"Healing","SubType":"NULL"},
570: {"Type":"Healing","SubType":"NULL"},
571: {"Type":"Healing","SubType":"NULL"},
572: {"Type":"Healing","SubType":"NULL"},
573: {"Type":"Healing","SubType":"NULL"},
574: {"Type":"Healing","SubType":"NULL"},
575: {"Type":"Healing","SubType":"NULL"},
576: {"Type":"Healing","SubType":"NULL"},
577: {"Type":"Healing","SubType":"NULL"},
578: {"Type":"Healing","SubType":"NULL"},
579: {"Type":"Healing","SubType":"NULL"},
580: {"Type":"Healing","SubType":"NULL"},
581: {"Type":"Healing","SubType":"NULL"},
582: {"Type":"Healing","SubType":"NULL"},
583: {"Type":"Healing","SubType":"NULL"},
584: {"Type":"Healing","SubType":"NULL"},
585: {"Type":"DelayConsume","SubType":"NULL"},
586: {"Type":"Healing","SubType":"NULL"},
587: {"Type":"Healing","SubType":"NULL"},
588: {"Type":"Healing","SubType":"NULL"},
589: {"Type":"Healing","SubType":"NULL"},
590: {"Type":"Healing","SubType":"NULL"},
591: {"Type":"Healing","SubType":"NULL"},
592: {"Type":"Healing","SubType":"NULL"},
593: {"Type":"Healing","SubType":"NULL"},
594: {"Type":"Healing","SubType":"NULL"},
595: {"Type":"Healing","SubType":"NULL"},
596: {"Type":"Healing","SubType":"NULL"},
597: {"Type":"Healing","SubType":"NULL"},
598: {"Type":"Healing","SubType":"NULL"},
599: {"Type":"Healing","SubType":"NULL"},
601: {"Type":"DelayConsume","SubType":"NULL"},
602: {"Type":"DelayConsume","SubType":"NULL"},
603: {"Type":"Usable","SubType":"NULL"},
604: {"Type":"Usable","SubType":"NULL"},
605: {"Type":"DelayConsume","SubType":"NULL"},
606: {"Type":"DelayConsume","SubType":"NULL"},
607: {"Type":"Healing","SubType":"NULL"},
608: {"Type":"Healing","SubType":"NULL"},
609: {"Type":"Usable","SubType":"NULL"},
610: {"Type":"DelayConsume","SubType":"NULL"},
611: {"Type":"DelayConsume","SubType":"NULL"},
612: {"Type":"Usable","SubType":"NULL"},
613: {"Type":"Usable","SubType":"NULL"},
614: {"Type":"Usable","SubType":"NULL"},
615: {"Type":"Usable","SubType":"NULL"},
616: {"Type":"Usable","SubType":"NULL"},
617: {"Type":"Usable","SubType":"NULL"},
618: {"Type":"Usable","SubType":"NULL"},
619: {"Type":"Usable","SubType":"NULL"},
620: {"Type":"Usable","SubType":"NULL"},
621: {"Type":"Usable","SubType":"NULL"},
622: {"Type":"Usable","SubType":"NULL"},
623: {"Type":"Usable","SubType":"NULL"},
624: {"Type":"Usable","SubType":"NULL"},
625: {"Type":"Usable","SubType":"NULL"},
626: {"Type":"Usable","SubType":"NULL"},
627: {"Type":"Usable","SubType":"NULL"},
628: {"Type":"Usable","SubType":"NULL"},
629: {"Type":"Usable","SubType":"NULL"},
630: {"Type":"Usable","SubType":"NULL"},
631: {"Type":"Usable","SubType":"NULL"},
632: {"Type":"Usable","SubType":"NULL"},
633: {"Type":"Usable","SubType":"NULL"},
634: {"Type":"Usable","SubType":"NULL"},
635: {"Type":"Usable","SubType":"NULL"},
636: {"Type":"Usable","SubType":"NULL"},
637: {"Type":"Usable","SubType":"NULL"},
638: {"Type":"Usable","SubType":"NULL"},
639: {"Type":"Usable","SubType":"NULL"},
640: {"Type":"Usable","SubType":"NULL"},
641: {"Type":"Usable","SubType":"NULL"},
642: {"Type":"Usable","SubType":"NULL"},
643: {"Type":"Usable","SubType":"NULL"},
644: {"Type":"Usable","SubType":"NULL"},
645: {"Type":"Usable","SubType":"NULL"},
656: {"Type":"Usable","SubType":"NULL"},
657: {"Type":"Usable","SubType":"NULL"},
658: {"Type":"Usable","SubType":"NULL"},
659: {"Type":"Usable","SubType":"NULL"},
660: {"Type":"Usable","SubType":"NULL"},
661: {"Type":"Usable","SubType":"NULL"},
662: {"Type":"Usable","SubType":"NULL"},
663: {"Type":"Healing","SubType":"NULL"},
664: {"Type":"Usable","SubType":"NULL"},
665: {"Type":"Usable","SubType":"NULL"},
666: {"Type":"Usable","SubType":"NULL"},
667: {"Type":"Usable","SubType":"NULL"},
668: {"Type":"Usable","SubType":"NULL"},
669: {"Type":"Healing","SubType":"NULL"},
670: {"Type":"Etc","SubType":"NULL"},
671: {"Type":"Usable","SubType":"NULL"},
672: {"Type":"Etc","SubType":"NULL"},
673: {"Type":"Usable","SubType":"NULL"},
674: {"Type":"Etc","SubType":"NULL"},
675: {"Type":"Usable","SubType":"NULL"},
676: {"Type":"Etc","SubType":"NULL"},
677: {"Type":"Etc","SubType":"NULL"},
678: {"Type":"Usable","SubType":"NULL"},
679: {"Type":"Usable","SubType":"NULL"},
680: {"Type":"Healing","SubType":"NULL"},
681: {"Type":"Usable","SubType":"NULL"},
682: {"Type":"Usable","SubType":"NULL"},
683: {"Type":"Usable","SubType":"NULL"},
684: {"Type":"Usable","SubType":"NULL"},
685: {"Type":"Healing","SubType":"NULL"},
686: {"Type":"DelayConsume","SubType":"NULL"},
687: {"Type":"DelayConsume","SubType":"NULL"},
688: {"Type":"DelayConsume","SubType":"NULL"},
689: {"Type":"DelayConsume","SubType":"NULL"},
690: {"Type":"DelayConsume","SubType":"NULL"},
691: {"Type":"DelayConsume","SubType":"NULL"},
692: {"Type":"DelayConsume","SubType":"NULL"},
693: {"Type":"DelayConsume","SubType":"NULL"},
694: {"Type":"DelayConsume","SubType":"NULL"},
695: {"Type":"DelayConsume","SubType":"NULL"},
696: {"Type":"DelayConsume","SubType":"NULL"},
697: {"Type":"DelayConsume","SubType":"NULL"},
698: {"Type":"DelayConsume","SubType":"NULL"},
699: {"Type":"DelayConsume","SubType":"NULL"},
700: {"Type":"DelayConsume","SubType":"NULL"},
701: {"Type":"Etc","SubType":"NULL"},
702: {"Type":"Etc","SubType":"NULL"},
703: {"Type":"Etc","SubType":"NULL"},
704: {"Type":"Etc","SubType":"NULL"},
705: {"Type":"Etc","SubType":"NULL"},
706: {"Type":"Etc","SubType":"NULL"},
707: {"Type":"Etc","SubType":"NULL"},
708: {"Type":"Etc","SubType":"NULL"},
709: {"Type":"Etc","SubType":"NULL"},
710: {"Type":"Etc","SubType":"NULL"},
711: {"Type":"Etc","SubType":"NULL"},
712: {"Type":"Etc","SubType":"NULL"},
713: {"Type":"Etc","SubType":"NULL"},
714: {"Type":"Etc","SubType":"NULL"},
715: {"Type":"Etc","SubType":"NULL"},
716: {"Type":"Etc","SubType":"NULL"},
717: {"Type":"Etc","SubType":"NULL"},
718: {"Type":"Etc","SubType":"NULL"},
719: {"Type":"Etc","SubType":"NULL"},
720: {"Type":"Etc","SubType":"NULL"},
721: {"Type":"Etc","SubType":"NULL"},
722: {"Type":"Etc","SubType":"NULL"},
723: {"Type":"Etc","SubType":"NULL"},
724: {"Type":"Etc","SubType":"NULL"},
725: {"Type":"Etc","SubType":"NULL"},
726: {"Type":"Etc","SubType":"NULL"},
727: {"Type":"Etc","SubType":"NULL"},
728: {"Type":"Etc","SubType":"NULL"},
729: {"Type":"Etc","SubType":"NULL"},
730: {"Type":"Etc","SubType":"NULL"},
731: {"Type":"Etc","SubType":"NULL"},
732: {"Type":"Etc","SubType":"NULL"},
733: {"Type":"Etc","SubType":"NULL"},
734: {"Type":"Etc","SubType":"NULL"},
735: {"Type":"Etc","SubType":"NULL"},
736: {"Type":"Etc","SubType":"NULL"},
737: {"Type":"Etc","SubType":"NULL"},
738: {"Type":"Etc","SubType":"NULL"},
739: {"Type":"Etc","SubType":"NULL"},
740: {"Type":"Etc","SubType":"NULL"},
741: {"Type":"Etc","SubType":"NULL"},
742: {"Type":"Etc","SubType":"NULL"},
743: {"Type":"Etc","SubType":"NULL"},
744: {"Type":"Etc","SubType":"NULL"},
745: {"Type":"Etc","SubType":"NULL"},
746: {"Type":"Etc","SubType":"NULL"},
747: {"Type":"Etc","SubType":"NULL"},
748: {"Type":"Etc","SubType":"NULL"},
749: {"Type":"Etc","SubType":"NULL"},
750: {"Type":"Etc","SubType":"NULL"},
751: {"Type":"Etc","SubType":"NULL"},
752: {"Type":"Etc","SubType":"NULL"},
753: {"Type":"Etc","SubType":"NULL"},
754: {"Type":"Etc","SubType":"NULL"},
756: {"Type":"Etc","SubType":"NULL"},
757: {"Type":"Etc","SubType":"NULL"},
766: {"Type":"Etc","SubType":"NULL"},
793: {"Type":"Etc","SubType":"NULL"},
824: {"Type":"Etc","SubType":"NULL"},
901: {"Type":"Etc","SubType":"NULL"},
902: {"Type":"Etc","SubType":"NULL"},
903: {"Type":"Etc","SubType":"NULL"},
904: {"Type":"Etc","SubType":"NULL"},
905: {"Type":"Etc","SubType":"NULL"},
906: {"Type":"Etc","SubType":"NULL"},
907: {"Type":"Etc","SubType":"NULL"},
908: {"Type":"Etc","SubType":"NULL"},
909: {"Type":"Etc","SubType":"NULL"},
910: {"Type":"Etc","SubType":"NULL"},
911: {"Type":"Etc","SubType":"NULL"},
912: {"Type":"Etc","SubType":"NULL"},
913: {"Type":"Etc","SubType":"NULL"},
914: {"Type":"Etc","SubType":"NULL"},
915: {"Type":"Etc","SubType":"NULL"},
916: {"Type":"Etc","SubType":"NULL"},
917: {"Type":"Etc","SubType":"NULL"},
918: {"Type":"Etc","SubType":"NULL"},
919: {"Type":"Etc","SubType":"NULL"},
920: {"Type":"Etc","SubType":"NULL"},
921: {"Type":"Etc","SubType":"NULL"},
922: {"Type":"Etc","SubType":"NULL"},
923: {"Type":"Etc","SubType":"NULL"},
924: {"Type":"Etc","SubType":"NULL"},
925: {"Type":"Etc","SubType":"NULL"},
926: {"Type":"Etc","SubType":"NULL"},
928: {"Type":"Etc","SubType":"NULL"},
929: {"Type":"Etc","SubType":"NULL"},
930: {"Type":"Etc","SubType":"NULL"},
931: {"Type":"Etc","SubType":"NULL"},
932: {"Type":"Etc","SubType":"NULL"},
934: {"Type":"Etc","SubType":"NULL"},
935: {"Type":"Etc","SubType":"NULL"},
936: {"Type":"Etc","SubType":"NULL"},
937: {"Type":"Etc","SubType":"NULL"},
938: {"Type":"Etc","SubType":"NULL"},
939: {"Type":"Etc","SubType":"NULL"},
940: {"Type":"Etc","SubType":"NULL"},
941: {"Type":"Etc","SubType":"NULL"},
942: {"Type":"Etc","SubType":"NULL"},
943: {"Type":"Etc","SubType":"NULL"},
944: {"Type":"Etc","SubType":"NULL"},
945: {"Type":"Etc","SubType":"NULL"},
946: {"Type":"Etc","SubType":"NULL"},
947: {"Type":"Etc","SubType":"NULL"},
948: {"Type":"Etc","SubType":"NULL"},
949: {"Type":"Etc","SubType":"NULL"},
950: {"Type":"Etc","SubType":"NULL"},
951: {"Type":"Etc","SubType":"NULL"},
952: {"Type":"Etc","SubType":"NULL"},
953: {"Type":"Etc","SubType":"NULL"},
954: {"Type":"Etc","SubType":"NULL"},
955: {"Type":"Etc","SubType":"NULL"},
956: {"Type":"Etc","SubType":"NULL"},
957: {"Type":"Etc","SubType":"NULL"},
958: {"Type":"Etc","SubType":"NULL"},
959: {"Type":"Etc","SubType":"NULL"},
960: {"Type":"Etc","SubType":"NULL"},
961: {"Type":"Etc","SubType":"NULL"},
962: {"Type":"Etc","SubType":"NULL"},
963: {"Type":"Etc","SubType":"NULL"},
964: {"Type":"Etc","SubType":"NULL"},
965: {"Type":"Etc","SubType":"NULL"},
966: {"Type":"Etc","SubType":"NULL"},
967: {"Type":"Etc","SubType":"NULL"},
968: {"Type":"Etc","SubType":"NULL"},
969: {"Type":"Etc","SubType":"NULL"},
970: {"Type":"Etc","SubType":"NULL"},
971: {"Type":"Etc","SubType":"NULL"},
972: {"Type":"Etc","SubType":"NULL"},
973: {"Type":"Etc","SubType":"NULL"},
974: {"Type":"Etc","SubType":"NULL"},
975: {"Type":"Etc","SubType":"NULL"},
976: {"Type":"Etc","SubType":"NULL"},
978: {"Type":"Etc","SubType":"NULL"},
979: {"Type":"Etc","SubType":"NULL"},
980: {"Type":"Etc","SubType":"NULL"},
981: {"Type":"Etc","SubType":"NULL"},
982: {"Type":"Etc","SubType":"NULL"},
983: {"Type":"Etc","SubType":"NULL"},
984: {"Type":"Etc","SubType":"NULL"},
985: {"Type":"Etc","SubType":"NULL"},
986: {"Type":"Etc","SubType":"NULL"},
987: {"Type":"Etc","SubType":"NULL"},
988: {"Type":"Etc","SubType":"NULL"},
989: {"Type":"Etc","SubType":"NULL"},
990: {"Type":"Etc","SubType":"NULL"},
991: {"Type":"Etc","SubType":"NULL"},
992: {"Type":"Etc","SubType":"NULL"},
993: {"Type":"Etc","SubType":"NULL"},
994: {"Type":"Etc","SubType":"NULL"},
995: {"Type":"Etc","SubType":"NULL"},
996: {"Type":"Etc","SubType":"NULL"},
997: {"Type":"Etc","SubType":"NULL"},
998: {"Type":"Etc","SubType":"NULL"},
999: {"Type":"Etc","SubType":"NULL"},
1000: {"Type":"Etc","SubType":"NULL"},
1001: {"Type":"Etc","SubType":"NULL"},
1002: {"Type":"Etc","SubType":"NULL"},
1003: {"Type":"Etc","SubType":"NULL"},
1004: {"Type":"Etc","SubType":"NULL"},
1005: {"Type":"Etc","SubType":"NULL"},
1006: {"Type":"Etc","SubType":"NULL"},
1007: {"Type":"Etc","SubType":"NULL"},
1008: {"Type":"Etc","SubType":"NULL"},
1009: {"Type":"Etc","SubType":"NULL"},
1010: {"Type":"Etc","SubType":"NULL"},
1011: {"Type":"Etc","SubType":"NULL"},
1012: {"Type":"Etc","SubType":"NULL"},
1013: {"Type":"Etc","SubType":"NULL"},
1014: {"Type":"Etc","SubType":"NULL"},
1015: {"Type":"Etc","SubType":"NULL"},
1016: {"Type":"Etc","SubType":"NULL"},
1017: {"Type":"Etc","SubType":"NULL"},
1018: {"Type":"Etc","SubType":"NULL"},
1019: {"Type":"Etc","SubType":"NULL"},
1020: {"Type":"Etc","SubType":"NULL"},
1021: {"Type":"Etc","SubType":"NULL"},
1022: {"Type":"Etc","SubType":"NULL"},
1023: {"Type":"Etc","SubType":"NULL"},
1024: {"Type":"Etc","SubType":"NULL"},
1025: {"Type":"Etc","SubType":"NULL"},
1026: {"Type":"Etc","SubType":"NULL"},
1027: {"Type":"Etc","SubType":"NULL"},
1028: {"Type":"Etc","SubType":"NULL"},
1029: {"Type":"Etc","SubType":"NULL"},
1030: {"Type":"Etc","SubType":"NULL"},
1031: {"Type":"Etc","SubType":"NULL"},
1032: {"Type":"Etc","SubType":"NULL"},
1033: {"Type":"Etc","SubType":"NULL"},
1034: {"Type":"Etc","SubType":"NULL"},
1035: {"Type":"Etc","SubType":"NULL"},
1036: {"Type":"Etc","SubType":"NULL"},
1037: {"Type":"Etc","SubType":"NULL"},
1038: {"Type":"Etc","SubType":"NULL"},
1039: {"Type":"Etc","SubType":"NULL"},
1040: {"Type":"Etc","SubType":"NULL"},
1041: {"Type":"Etc","SubType":"NULL"},
1042: {"Type":"Etc","SubType":"NULL"},
1043: {"Type":"Etc","SubType":"NULL"},
1044: {"Type":"Etc","SubType":"NULL"},
1045: {"Type":"Etc","SubType":"NULL"},
1046: {"Type":"Etc","SubType":"NULL"},
1047: {"Type":"Etc","SubType":"NULL"},
1048: {"Type":"Etc","SubType":"NULL"},
1049: {"Type":"Etc","SubType":"NULL"},
1050: {"Type":"Etc","SubType":"NULL"},
1051: {"Type":"Etc","SubType":"NULL"},
1052: {"Type":"Etc","SubType":"NULL"},
1053: {"Type":"Etc","SubType":"NULL"},
1054: {"Type":"Etc","SubType":"NULL"},
1055: {"Type":"Etc","SubType":"NULL"},
1056: {"Type":"Etc","SubType":"NULL"},
1057: {"Type":"Etc","SubType":"NULL"},
1058: {"Type":"Etc","SubType":"NULL"},
1059: {"Type":"Etc","SubType":"NULL"},
1060: {"Type":"Etc","SubType":"NULL"},
1061: {"Type":"Etc","SubType":"NULL"},
1062: {"Type":"Etc","SubType":"NULL"},
1063: {"Type":"Etc","SubType":"NULL"},
1064: {"Type":"Etc","SubType":"NULL"},
1065: {"Type":"Etc","SubType":"NULL"},
1066: {"Type":"Etc","SubType":"NULL"},
1067: {"Type":"Etc","SubType":"NULL"},
1068: {"Type":"Etc","SubType":"NULL"},
1069: {"Type":"Etc","SubType":"NULL"},
1070: {"Type":"Etc","SubType":"NULL"},
1071: {"Type":"Etc","SubType":"NULL"},
1072: {"Type":"Etc","SubType":"NULL"},
1073: {"Type":"Etc","SubType":"NULL"},
1074: {"Type":"Etc","SubType":"NULL"},
1075: {"Type":"Etc","SubType":"NULL"},
1076: {"Type":"Etc","SubType":"NULL"},
1077: {"Type":"Etc","SubType":"NULL"},
1078: {"Type":"Etc","SubType":"NULL"},
1079: {"Type":"Etc","SubType":"NULL"},
1080: {"Type":"Etc","SubType":"NULL"},
1081: {"Type":"Etc","SubType":"NULL"},
1082: {"Type":"Etc","SubType":"NULL"},
1083: {"Type":"Etc","SubType":"NULL"},
1084: {"Type":"Etc","SubType":"NULL"},
1085: {"Type":"Etc","SubType":"NULL"},
1086: {"Type":"Etc","SubType":"NULL"},
1087: {"Type":"Etc","SubType":"NULL"},
1088: {"Type":"Etc","SubType":"NULL"},
1089: {"Type":"Etc","SubType":"NULL"},
1090: {"Type":"Etc","SubType":"NULL"},
1091: {"Type":"Etc","SubType":"NULL"},
1092: {"Type":"Etc","SubType":"NULL"},
1093: {"Type":"Etc","SubType":"NULL"},
1094: {"Type":"Etc","SubType":"NULL"},
1095: {"Type":"Etc","SubType":"NULL"},
1096: {"Type":"Etc","SubType":"NULL"},
1097: {"Type":"Etc","SubType":"NULL"},
1098: {"Type":"Etc","SubType":"NULL"},
1099: {"Type":"Etc","SubType":"NULL"},
1100: {"Type":"Weapon","SubType":"1hSword"},
1101: {"Type":"Weapon","SubType":"1hSword"},
1102: {"Type":"Weapon","SubType":"1hSword"},
1103: {"Type":"Weapon","SubType":"1hSword"},
1104: {"Type":"Weapon","SubType":"1hSword"},
1105: {"Type":"Weapon","SubType":"1hSword"},
1106: {"Type":"Weapon","SubType":"1hSword"},
1107: {"Type":"Weapon","SubType":"1hSword"},
1108: {"Type":"Weapon","SubType":"1hSword"},
1109: {"Type":"Weapon","SubType":"1hSword"},
1110: {"Type":"Weapon","SubType":"1hSword"},
1111: {"Type":"Weapon","SubType":"1hSword"},
1112: {"Type":"Weapon","SubType":"1hSword"},
1113: {"Type":"Weapon","SubType":"1hSword"},
1114: {"Type":"Weapon","SubType":"1hSword"},
1115: {"Type":"Weapon","SubType":"1hSword"},
1116: {"Type":"Weapon","SubType":"2hSword"},
1117: {"Type":"Weapon","SubType":"2hSword"},
1118: {"Type":"Weapon","SubType":"2hSword"},
1119: {"Type":"Weapon","SubType":"1hSword"},
1120: {"Type":"Weapon","SubType":"1hSword"},
1121: {"Type":"Weapon","SubType":"1hSword"},
1122: {"Type":"Weapon","SubType":"1hSword"},
1123: {"Type":"Weapon","SubType":"1hSword"},
1124: {"Type":"Weapon","SubType":"1hSword"},
1125: {"Type":"Weapon","SubType":"1hSword"},
1126: {"Type":"Weapon","SubType":"1hSword"},
1127: {"Type":"Weapon","SubType":"1hSword"},
1128: {"Type":"Weapon","SubType":"1hSword"},
1129: {"Type":"Weapon","SubType":"1hSword"},
1130: {"Type":"Weapon","SubType":"1hSword"},
1131: {"Type":"Weapon","SubType":"1hSword"},
1132: {"Type":"Weapon","SubType":"1hSword"},
1133: {"Type":"Weapon","SubType":"1hSword"},
1134: {"Type":"Weapon","SubType":"1hSword"},
1135: {"Type":"Weapon","SubType":"1hSword"},
1136: {"Type":"Weapon","SubType":"1hSword"},
1137: {"Type":"Weapon","SubType":"1hSword"},
1138: {"Type":"Weapon","SubType":"1hSword"},
1139: {"Type":"Weapon","SubType":"1hSword"},
1140: {"Type":"Weapon","SubType":"1hSword"},
1141: {"Type":"Weapon","SubType":"1hSword"},
1142: {"Type":"Weapon","SubType":"1hSword"},
1143: {"Type":"Weapon","SubType":"1hSword"},
1144: {"Type":"Weapon","SubType":"1hSword"},
1145: {"Type":"Weapon","SubType":"1hSword"},
1146: {"Type":"Weapon","SubType":"1hSword"},
1147: {"Type":"Weapon","SubType":"1hSword"},
1148: {"Type":"Weapon","SubType":"1hSword"},
1149: {"Type":"Weapon","SubType":"1hSword"},
1150: {"Type":"Weapon","SubType":"2hSword"},
1151: {"Type":"Weapon","SubType":"2hSword"},
1152: {"Type":"Weapon","SubType":"2hSword"},
1153: {"Type":"Weapon","SubType":"2hSword"},
1154: {"Type":"Weapon","SubType":"2hSword"},
1155: {"Type":"Weapon","SubType":"2hSword"},
1156: {"Type":"Weapon","SubType":"2hSword"},
1157: {"Type":"Weapon","SubType":"2hSword"},
1158: {"Type":"Weapon","SubType":"2hSword"},
1159: {"Type":"Weapon","SubType":"2hSword"},
1160: {"Type":"Weapon","SubType":"2hSword"},
1161: {"Type":"Weapon","SubType":"2hSword"},
1162: {"Type":"Weapon","SubType":"2hSword"},
1163: {"Type":"Weapon","SubType":"2hSword"},
1164: {"Type":"Weapon","SubType":"2hSword"},
1165: {"Type":"Weapon","SubType":"2hSword"},
1166: {"Type":"Weapon","SubType":"2hSword"},
1167: {"Type":"Weapon","SubType":"2hSword"},
1168: {"Type":"Weapon","SubType":"2hSword"},
1169: {"Type":"Weapon","SubType":"2hSword"},
1170: {"Type":"Weapon","SubType":"2hSword"},
1171: {"Type":"Weapon","SubType":"2hSword"},
1172: {"Type":"Weapon","SubType":"2hSword"},
1173: {"Type":"Weapon","SubType":"2hSword"},
1174: {"Type":"Weapon","SubType":"2hSword"},
1175: {"Type":"Weapon","SubType":"2hSword"},
1176: {"Type":"Weapon","SubType":"2hSword"},
1177: {"Type":"Weapon","SubType":"2hSword"},
1178: {"Type":"Weapon","SubType":"2hSword"},
1179: {"Type":"Weapon","SubType":"2hSword"},
1180: {"Type":"Weapon","SubType":"2hSword"},
1181: {"Type":"Weapon","SubType":"2hSword"},
1182: {"Type":"Weapon","SubType":"2hSword"},
1183: {"Type":"Weapon","SubType":"2hSword"},
1184: {"Type":"Weapon","SubType":"2hSword"},
1185: {"Type":"Weapon","SubType":"2hSword"},
1186: {"Type":"Weapon","SubType":"2hSword"},
1187: {"Type":"Weapon","SubType":"2hSword"},
1188: {"Type":"Weapon","SubType":"2hSword"},
1189: {"Type":"Weapon","SubType":"2hSword"},
1190: {"Type":"Weapon","SubType":"2hSword"},
1191: {"Type":"Weapon","SubType":"2hSword"},
1192: {"Type":"Weapon","SubType":"2hSword"},
1193: {"Type":"Weapon","SubType":"2hSword"},
1194: {"Type":"Weapon","SubType":"2hSword"},
1195: {"Type":"Weapon","SubType":"2hSword"},
1196: {"Type":"Weapon","SubType":"2hSword"},
1197: {"Type":"Weapon","SubType":"2hSword"},
1198: {"Type":"Weapon","SubType":"2hSword"},
1199: {"Type":"Weapon","SubType":"2hSword"},
1201: {"Type":"Weapon","SubType":"Dagger"},
1202: {"Type":"Weapon","SubType":"Dagger"},
1203: {"Type":"Weapon","SubType":"Dagger"},
1204: {"Type":"Weapon","SubType":"Dagger"},
1205: {"Type":"Weapon","SubType":"Dagger"},
1206: {"Type":"Weapon","SubType":"Dagger"},
1207: {"Type":"Weapon","SubType":"Dagger"},
1208: {"Type":"Weapon","SubType":"Dagger"},
1209: {"Type":"Weapon","SubType":"Dagger"},
1210: {"Type":"Weapon","SubType":"Dagger"},
1211: {"Type":"Weapon","SubType":"Dagger"},
1212: {"Type":"Weapon","SubType":"Dagger"},
1213: {"Type":"Weapon","SubType":"Dagger"},
1214: {"Type":"Weapon","SubType":"Dagger"},
1215: {"Type":"Weapon","SubType":"Dagger"},
1216: {"Type":"Weapon","SubType":"Dagger"},
1217: {"Type":"Weapon","SubType":"Dagger"},
1218: {"Type":"Weapon","SubType":"Dagger"},
1219: {"Type":"Weapon","SubType":"Dagger"},
1220: {"Type":"Weapon","SubType":"Dagger"},
1221: {"Type":"Weapon","SubType":"Dagger"},
1222: {"Type":"Weapon","SubType":"Dagger"},
1223: {"Type":"Weapon","SubType":"Dagger"},
1224: {"Type":"Weapon","SubType":"Dagger"},
1225: {"Type":"Weapon","SubType":"Dagger"},
1226: {"Type":"Weapon","SubType":"Dagger"},
1227: {"Type":"Weapon","SubType":"Dagger"},
1228: {"Type":"Weapon","SubType":"Dagger"},
1229: {"Type":"Weapon","SubType":"Dagger"},
1230: {"Type":"Weapon","SubType":"Dagger"},
1231: {"Type":"Weapon","SubType":"Dagger"},
1232: {"Type":"Weapon","SubType":"Dagger"},
1233: {"Type":"Weapon","SubType":"Dagger"},
1234: {"Type":"Weapon","SubType":"Dagger"},
1235: {"Type":"Weapon","SubType":"Dagger"},
1236: {"Type":"Weapon","SubType":"Dagger"},
1237: {"Type":"Weapon","SubType":"Dagger"},
1238: {"Type":"Weapon","SubType":"Dagger"},
1239: {"Type":"Weapon","SubType":"Dagger"},
1240: {"Type":"Weapon","SubType":"Dagger"},
1241: {"Type":"Weapon","SubType":"Dagger"},
1242: {"Type":"Weapon","SubType":"Dagger"},
1243: {"Type":"Weapon","SubType":"Dagger"},
1244: {"Type":"Weapon","SubType":"Dagger"},
1245: {"Type":"Weapon","SubType":"Dagger"},
1246: {"Type":"Weapon","SubType":"Dagger"},
1247: {"Type":"Weapon","SubType":"Dagger"},
1248: {"Type":"Weapon","SubType":"Dagger"},
1249: {"Type":"Weapon","SubType":"Dagger"},
1250: {"Type":"Weapon","SubType":"Katar"},
1251: {"Type":"Weapon","SubType":"Katar"},
1252: {"Type":"Weapon","SubType":"Katar"},
1253: {"Type":"Weapon","SubType":"Katar"},
1254: {"Type":"Weapon","SubType":"Katar"},
1255: {"Type":"Weapon","SubType":"Katar"},
1256: {"Type":"Weapon","SubType":"Katar"},
1257: {"Type":"Weapon","SubType":"Katar"},
1258: {"Type":"Weapon","SubType":"Katar"},
1259: {"Type":"Weapon","SubType":"Katar"},
1260: {"Type":"Weapon","SubType":"Katar"},
1261: {"Type":"Weapon","SubType":"Katar"},
1262: {"Type":"Weapon","SubType":"Katar"},
1263: {"Type":"Weapon","SubType":"Katar"},
1264: {"Type":"Weapon","SubType":"Katar"},
1265: {"Type":"Weapon","SubType":"Katar"},
1266: {"Type":"Weapon","SubType":"Katar"},
1267: {"Type":"Weapon","SubType":"Katar"},
1268: {"Type":"Weapon","SubType":"Katar"},
1269: {"Type":"Weapon","SubType":"Katar"},
1270: {"Type":"Weapon","SubType":"Katar"},
1271: {"Type":"Weapon","SubType":"Katar"},
1272: {"Type":"Weapon","SubType":"Katar"},
1273: {"Type":"Weapon","SubType":"Katar"},
1274: {"Type":"Weapon","SubType":"Katar"},
1275: {"Type":"Weapon","SubType":"Katar"},
1276: {"Type":"Weapon","SubType":"Katar"},
1277: {"Type":"Weapon","SubType":"Katar"},
1278: {"Type":"Weapon","SubType":"Katar"},
1279: {"Type":"Weapon","SubType":"Katar"},
1280: {"Type":"Weapon","SubType":"Katar"},
1281: {"Type":"Weapon","SubType":"Katar"},
1282: {"Type":"Weapon","SubType":"Katar"},
1283: {"Type":"Weapon","SubType":"Katar"},
1284: {"Type":"Weapon","SubType":"Katar"},
1285: {"Type":"Weapon","SubType":"Katar"},
1286: {"Type":"Weapon","SubType":"Katar"},
1287: {"Type":"Weapon","SubType":"Katar"},
1288: {"Type":"Weapon","SubType":"Katar"},
1289: {"Type":"Weapon","SubType":"Katar"},
1290: {"Type":"Weapon","SubType":"Katar"},
1291: {"Type":"Weapon","SubType":"Katar"},
1292: {"Type":"Weapon","SubType":"Katar"},
1293: {"Type":"Weapon","SubType":"Katar"},
1294: {"Type":"Weapon","SubType":"Katar"},
1295: {"Type":"Weapon","SubType":"Katar"},
1296: {"Type":"Weapon","SubType":"Katar"},
1297: {"Type":"Weapon","SubType":"Katar"},
1298: {"Type":"Weapon","SubType":"Katar"},
1299: {"Type":"Weapon","SubType":"Katar"},
1300: {"Type":"Weapon","SubType":"1hAxe"},
1301: {"Type":"Weapon","SubType":"1hAxe"},
1302: {"Type":"Weapon","SubType":"1hAxe"},
1303: {"Type":"Weapon","SubType":"1hAxe"},
1304: {"Type":"Weapon","SubType":"1hAxe"},
1305: {"Type":"Weapon","SubType":"1hAxe"},
1306: {"Type":"Weapon","SubType":"1hAxe"},
1307: {"Type":"Weapon","SubType":"1hAxe"},
1308: {"Type":"Weapon","SubType":"1hAxe"},
1309: {"Type":"Weapon","SubType":"1hAxe"},
1310: {"Type":"Weapon","SubType":"1hAxe"},
1311: {"Type":"Weapon","SubType":"1hAxe"},
1312: {"Type":"Weapon","SubType":"1hAxe"},
1313: {"Type":"Weapon","SubType":"1hAxe"},
1314: {"Type":"Weapon","SubType":"2hAxe"},
1315: {"Type":"Weapon","SubType":"2hAxe"},
1316: {"Type":"Weapon","SubType":"1hAxe"},
1317: {"Type":"Weapon","SubType":"1hAxe"},
1318: {"Type":"Weapon","SubType":"1hAxe"},
1319: {"Type":"Weapon","SubType":"1hAxe"},
1320: {"Type":"Weapon","SubType":"1hAxe"},
1321: {"Type":"Weapon","SubType":"1hAxe"},
1322: {"Type":"Weapon","SubType":"1hAxe"},
1323: {"Type":"Weapon","SubType":"1hAxe"},
1324: {"Type":"Weapon","SubType":"1hAxe"},
1325: {"Type":"Weapon","SubType":"1hAxe"},
1326: {"Type":"Weapon","SubType":"1hAxe"},
1327: {"Type":"Weapon","SubType":"1hAxe"},
1328: {"Type":"Weapon","SubType":"1hAxe"},
1329: {"Type":"Weapon","SubType":"1hAxe"},
1330: {"Type":"Weapon","SubType":"1hAxe"},
1331: {"Type":"Weapon","SubType":"1hAxe"},
1332: {"Type":"Weapon","SubType":"1hAxe"},
1333: {"Type":"Weapon","SubType":"1hAxe"},
1334: {"Type":"Weapon","SubType":"1hAxe"},
1335: {"Type":"Weapon","SubType":"1hAxe"},
1336: {"Type":"Weapon","SubType":"1hAxe"},
1337: {"Type":"Weapon","SubType":"1hAxe"},
1339: {"Type":"Weapon","SubType":"Huuma"},
1340: {"Type":"Weapon","SubType":"Mace"},
1341: {"Type":"Weapon","SubType":"1hAxe"},
1350: {"Type":"Weapon","SubType":"2hAxe"},
1351: {"Type":"Weapon","SubType":"2hAxe"},
1352: {"Type":"Weapon","SubType":"2hAxe"},
1353: {"Type":"Weapon","SubType":"2hAxe"},
1354: {"Type":"Weapon","SubType":"2hAxe"},
1355: {"Type":"Weapon","SubType":"2hAxe"},
1356: {"Type":"Weapon","SubType":"2hAxe"},
1357: {"Type":"Weapon","SubType":"2hAxe"},
1358: {"Type":"Weapon","SubType":"2hAxe"},
1359: {"Type":"Weapon","SubType":"2hAxe"},
1360: {"Type":"Weapon","SubType":"2hAxe"},
1361: {"Type":"Weapon","SubType":"2hAxe"},
1362: {"Type":"Weapon","SubType":"2hAxe"},
1363: {"Type":"Weapon","SubType":"2hAxe"},
1364: {"Type":"Weapon","SubType":"2hAxe"},
1365: {"Type":"Weapon","SubType":"2hAxe"},
1366: {"Type":"Weapon","SubType":"2hAxe"},
1367: {"Type":"Weapon","SubType":"2hAxe"},
1368: {"Type":"Weapon","SubType":"2hAxe"},
1369: {"Type":"Weapon","SubType":"2hAxe"},
1370: {"Type":"Weapon","SubType":"2hAxe"},
1371: {"Type":"Weapon","SubType":"2hAxe"},
1372: {"Type":"Weapon","SubType":"2hAxe"},
1373: {"Type":"Weapon","SubType":"2hAxe"},
1374: {"Type":"Weapon","SubType":"2hAxe"},
1375: {"Type":"Weapon","SubType":"2hAxe"},
1376: {"Type":"Weapon","SubType":"2hAxe"},
1377: {"Type":"Weapon","SubType":"2hAxe"},
1378: {"Type":"Weapon","SubType":"2hAxe"},
1379: {"Type":"Weapon","SubType":"2hAxe"},
1380: {"Type":"Weapon","SubType":"2hAxe"},
1381: {"Type":"Weapon","SubType":"2hAxe"},
1382: {"Type":"Weapon","SubType":"2hAxe"},
1383: {"Type":"Weapon","SubType":"2hAxe"},
1384: {"Type":"Weapon","SubType":"2hAxe"},
1385: {"Type":"Weapon","SubType":"2hAxe"},
1386: {"Type":"Weapon","SubType":"2hAxe"},
1387: {"Type":"Weapon","SubType":"2hAxe"},
1388: {"Type":"Weapon","SubType":"2hAxe"},
1389: {"Type":"Weapon","SubType":"2hAxe"},
1390: {"Type":"Weapon","SubType":"2hAxe"},
1391: {"Type":"Weapon","SubType":"2hAxe"},
1392: {"Type":"Weapon","SubType":"2hAxe"},
1393: {"Type":"Weapon","SubType":"2hAxe"},
1394: {"Type":"Weapon","SubType":"2hAxe"},
1395: {"Type":"Weapon","SubType":"2hAxe"},
1396: {"Type":"Weapon","SubType":"2hAxe"},
1397: {"Type":"Weapon","SubType":"2hAxe"},
1398: {"Type":"Weapon","SubType":"2hAxe"},
1399: {"Type":"Weapon","SubType":"2hAxe"},
1400: {"Type":"Weapon","SubType":"1hSpear"},
1401: {"Type":"Weapon","SubType":"1hSpear"},
1402: {"Type":"Weapon","SubType":"1hSpear"},
1403: {"Type":"Weapon","SubType":"1hSpear"},
1404: {"Type":"Weapon","SubType":"1hSpear"},
1405: {"Type":"Weapon","SubType":"1hSpear"},
1406: {"Type":"Weapon","SubType":"1hSpear"},
1407: {"Type":"Weapon","SubType":"1hSpear"},
1408: {"Type":"Weapon","SubType":"1hSpear"},
1409: {"Type":"Weapon","SubType":"1hSpear"},
1410: {"Type":"Weapon","SubType":"2hSpear"},
1411: {"Type":"Weapon","SubType":"2hSpear"},
1412: {"Type":"Weapon","SubType":"2hSpear"},
1413: {"Type":"Weapon","SubType":"1hSpear"},
1414: {"Type":"Weapon","SubType":"1hSpear"},
1415: {"Type":"Weapon","SubType":"1hSpear"},
1416: {"Type":"Weapon","SubType":"1hSpear"},
1417: {"Type":"Weapon","SubType":"1hSpear"},
1418: {"Type":"Weapon","SubType":"1hSpear"},
1419: {"Type":"Weapon","SubType":"1hSpear"},
1420: {"Type":"Weapon","SubType":"1hSpear"},
1421: {"Type":"Weapon","SubType":"1hSpear"},
1422: {"Type":"Weapon","SubType":"1hSpear"},
1423: {"Type":"Weapon","SubType":"1hSpear"},
1424: {"Type":"Weapon","SubType":"1hSpear"},
1425: {"Type":"Weapon","SubType":"1hSpear"},
1426: {"Type":"Weapon","SubType":"1hSpear"},
1427: {"Type":"Weapon","SubType":"1hSpear"},
1428: {"Type":"Weapon","SubType":"1hSpear"},
1429: {"Type":"Weapon","SubType":"1hSpear"},
1430: {"Type":"Weapon","SubType":"1hSpear"},
1431: {"Type":"Weapon","SubType":"1hSpear"},
1432: {"Type":"Weapon","SubType":"1hSpear"},
1433: {"Type":"Weapon","SubType":"1hSpear"},
1434: {"Type":"Weapon","SubType":"1hSpear"},
1435: {"Type":"Weapon","SubType":"1hSpear"},
1436: {"Type":"Weapon","SubType":"1hSpear"},
1437: {"Type":"Weapon","SubType":"1hSpear"},
1438: {"Type":"Weapon","SubType":"1hSpear"},
1439: {"Type":"Weapon","SubType":"1hSpear"},
1440: {"Type":"Weapon","SubType":"1hSpear"},
1441: {"Type":"Weapon","SubType":"1hSpear"},
1442: {"Type":"Weapon","SubType":"1hSpear"},
1443: {"Type":"Weapon","SubType":"1hSpear"},
1444: {"Type":"Weapon","SubType":"1hSpear"},
1445: {"Type":"Weapon","SubType":"1hSpear"},
1446: {"Type":"Weapon","SubType":"1hSpear"},
1447: {"Type":"Weapon","SubType":"1hSpear"},
1448: {"Type":"Weapon","SubType":"1hSpear"},
1449: {"Type":"Weapon","SubType":"1hSpear"},
1450: {"Type":"Weapon","SubType":"2hSpear"},
1451: {"Type":"Weapon","SubType":"2hSpear"},
1452: {"Type":"Weapon","SubType":"2hSpear"},
1453: {"Type":"Weapon","SubType":"2hSpear"},
1454: {"Type":"Weapon","SubType":"2hSpear"},
1455: {"Type":"Weapon","SubType":"2hSpear"},
1456: {"Type":"Weapon","SubType":"2hSpear"},
1457: {"Type":"Weapon","SubType":"2hSpear"},
1458: {"Type":"Weapon","SubType":"2hSpear"},
1459: {"Type":"Weapon","SubType":"2hSpear"},
1460: {"Type":"Weapon","SubType":"2hSpear"},
1461: {"Type":"Weapon","SubType":"2hSpear"},
1462: {"Type":"Weapon","SubType":"2hSpear"},
1463: {"Type":"Weapon","SubType":"2hSpear"},
1464: {"Type":"Weapon","SubType":"2hSpear"},
1465: {"Type":"Weapon","SubType":"2hSpear"},
1466: {"Type":"Weapon","SubType":"2hSpear"},
1467: {"Type":"Weapon","SubType":"2hSpear"},
1468: {"Type":"Weapon","SubType":"2hSpear"},
1469: {"Type":"Weapon","SubType":"2hSpear"},
1470: {"Type":"Weapon","SubType":"2hSpear"},
1471: {"Type":"Weapon","SubType":"2hSpear"},
1472: {"Type":"Weapon","SubType":"2hStaff"},
1473: {"Type":"Weapon","SubType":"2hStaff"},
1474: {"Type":"Weapon","SubType":"2hSpear"},
1475: {"Type":"Weapon","SubType":"2hSpear"},
1476: {"Type":"Weapon","SubType":"2hSpear"},
1477: {"Type":"Weapon","SubType":"2hSpear"},
1478: {"Type":"Weapon","SubType":"2hSpear"},
1479: {"Type":"Weapon","SubType":"2hSpear"},
1480: {"Type":"Weapon","SubType":"2hSpear"},
1481: {"Type":"Weapon","SubType":"2hSpear"},
1482: {"Type":"Weapon","SubType":"2hSpear"},
1483: {"Type":"Weapon","SubType":"2hSpear"},
1484: {"Type":"Weapon","SubType":"2hSpear"},
1485: {"Type":"Weapon","SubType":"2hSpear"},
1486: {"Type":"Weapon","SubType":"2hSpear"},
1487: {"Type":"Weapon","SubType":"2hSpear"},
1488: {"Type":"Weapon","SubType":"2hSpear"},
1489: {"Type":"Weapon","SubType":"2hSpear"},
1490: {"Type":"Weapon","SubType":"2hSpear"},
1491: {"Type":"Weapon","SubType":"2hSpear"},
1492: {"Type":"Weapon","SubType":"2hSpear"},
1493: {"Type":"Weapon","SubType":"2hSpear"},
1494: {"Type":"Weapon","SubType":"2hSpear"},
1495: {"Type":"Weapon","SubType":"2hSpear"},
1496: {"Type":"Weapon","SubType":"2hSpear"},
1497: {"Type":"Weapon","SubType":"2hSpear"},
1498: {"Type":"Weapon","SubType":"2hSpear"},
1499: {"Type":"Weapon","SubType":"2hSpear"},
1501: {"Type":"Weapon","SubType":"Mace"},
1502: {"Type":"Weapon","SubType":"Mace"},
1503: {"Type":"Weapon","SubType":"Mace"},
1504: {"Type":"Weapon","SubType":"Mace"},
1505: {"Type":"Weapon","SubType":"Mace"},
1506: {"Type":"Weapon","SubType":"Mace"},
1507: {"Type":"Weapon","SubType":"Mace"},
1508: {"Type":"Weapon","SubType":"Mace"},
1509: {"Type":"Weapon","SubType":"Mace"},
1510: {"Type":"Weapon","SubType":"Mace"},
1511: {"Type":"Weapon","SubType":"Mace"},
1512: {"Type":"Weapon","SubType":"Mace"},
1513: {"Type":"Weapon","SubType":"Mace"},
1514: {"Type":"Weapon","SubType":"Mace"},
1515: {"Type":"Weapon","SubType":"Mace"},
1516: {"Type":"Weapon","SubType":"Mace"},
1517: {"Type":"Weapon","SubType":"Mace"},
1518: {"Type":"Weapon","SubType":"Mace"},
1519: {"Type":"Weapon","SubType":"Mace"},
1520: {"Type":"Weapon","SubType":"Mace"},
1521: {"Type":"Weapon","SubType":"Mace"},
1522: {"Type":"Weapon","SubType":"Mace"},
1523: {"Type":"Weapon","SubType":"Mace"},
1524: {"Type":"Weapon","SubType":"Mace"},
1525: {"Type":"Weapon","SubType":"Mace"},
1526: {"Type":"Weapon","SubType":"Mace"},
1527: {"Type":"Weapon","SubType":"Mace"},
1528: {"Type":"Weapon","SubType":"Mace"},
1529: {"Type":"Weapon","SubType":"Mace"},
1530: {"Type":"Weapon","SubType":"Mace"},
1531: {"Type":"Weapon","SubType":"Mace"},
1532: {"Type":"Weapon","SubType":"Mace"},
1533: {"Type":"Weapon","SubType":"Mace"},
1534: {"Type":"Weapon","SubType":"Mace"},
1535: {"Type":"Weapon","SubType":"Mace"},
1536: {"Type":"Weapon","SubType":"Mace"},
1537: {"Type":"Weapon","SubType":"Mace"},
1538: {"Type":"Weapon","SubType":"Mace"},
1539: {"Type":"Weapon","SubType":"Mace"},
1540: {"Type":"Weapon","SubType":"Mace"},
1541: {"Type":"Weapon","SubType":"Mace"},
1542: {"Type":"Weapon","SubType":"Mace"},
1543: {"Type":"Weapon","SubType":"Mace"},
1544: {"Type":"Weapon","SubType":"Mace"},
1545: {"Type":"Weapon","SubType":"Mace"},
1546: {"Type":"Weapon","SubType":"Mace"},
1547: {"Type":"Weapon","SubType":"Mace"},
1548: {"Type":"Weapon","SubType":"Mace"},
1549: {"Type":"Weapon","SubType":"Mace"},
1550: {"Type":"Weapon","SubType":"Book"},
1551: {"Type":"Weapon","SubType":"Book"},
1552: {"Type":"Weapon","SubType":"Book"},
1553: {"Type":"Weapon","SubType":"Book"},
1554: {"Type":"Weapon","SubType":"Book"},
1555: {"Type":"Weapon","SubType":"Book"},
1556: {"Type":"Weapon","SubType":"Book"},
1557: {"Type":"Weapon","SubType":"Book"},
1558: {"Type":"Weapon","SubType":"Book"},
1559: {"Type":"Weapon","SubType":"Book"},
1560: {"Type":"Weapon","SubType":"Book"},
1561: {"Type":"Weapon","SubType":"Book"},
1562: {"Type":"Weapon","SubType":"Book"},
1563: {"Type":"Weapon","SubType":"Book"},
1564: {"Type":"Weapon","SubType":"Book"},
1565: {"Type":"Weapon","SubType":"Book"},
1566: {"Type":"Weapon","SubType":"Book"},
1567: {"Type":"Weapon","SubType":"Book"},
1568: {"Type":"Weapon","SubType":"Book"},
1569: {"Type":"Weapon","SubType":"Book"},
1570: {"Type":"Weapon","SubType":"Book"},
1571: {"Type":"Weapon","SubType":"Book"},
1572: {"Type":"Weapon","SubType":"Book"},
1573: {"Type":"Weapon","SubType":"Book"},
1574: {"Type":"Weapon","SubType":"Book"},
1575: {"Type":"Weapon","SubType":"Book"},
1576: {"Type":"Weapon","SubType":"Book"},
1577: {"Type":"Weapon","SubType":"Book"},
1578: {"Type":"Weapon","SubType":"Book"},
1579: {"Type":"Weapon","SubType":"Book"},
1580: {"Type":"Weapon","SubType":"Book"},
1581: {"Type":"Weapon","SubType":"Book"},
1582: {"Type":"Weapon","SubType":"Book"},
1583: {"Type":"Weapon","SubType":"Book"},
1584: {"Type":"Weapon","SubType":"Book"},
1585: {"Type":"Weapon","SubType":"Book"},
1586: {"Type":"Weapon","SubType":"Book"},
1587: {"Type":"Weapon","SubType":"Book"},
1588: {"Type":"Weapon","SubType":"Book"},
1589: {"Type":"Weapon","SubType":"Book"},
1590: {"Type":"Weapon","SubType":"Book"},
1591: {"Type":"Weapon","SubType":"Book"},
1592: {"Type":"Weapon","SubType":"Book"},
1593: {"Type":"Weapon","SubType":"Book"},
1594: {"Type":"Weapon","SubType":"Book"},
1595: {"Type":"Weapon","SubType":"Book"},
1596: {"Type":"Weapon","SubType":"Book"},
1597: {"Type":"Weapon","SubType":"Book"},
1598: {"Type":"Weapon","SubType":"Book"},
1599: {"Type":"Weapon","SubType":"Mace"},
1600: {"Type":"Weapon","SubType":"Staff"},
1601: {"Type":"Weapon","SubType":"Staff"},
1602: {"Type":"Weapon","SubType":"Staff"},
1603: {"Type":"Weapon","SubType":"Staff"},
1604: {"Type":"Weapon","SubType":"Staff"},
1605: {"Type":"Weapon","SubType":"Staff"},
1606: {"Type":"Weapon","SubType":"Staff"},
1607: {"Type":"Weapon","SubType":"Staff"},
1608: {"Type":"Weapon","SubType":"Staff"},
1609: {"Type":"Weapon","SubType":"Staff"},
1610: {"Type":"Weapon","SubType":"Staff"},
1611: {"Type":"Weapon","SubType":"Staff"},
1612: {"Type":"Weapon","SubType":"Staff"},
1613: {"Type":"Weapon","SubType":"Staff"},
1614: {"Type":"Weapon","SubType":"Staff"},
1615: {"Type":"Weapon","SubType":"Staff"},
1616: {"Type":"Weapon","SubType":"Staff"},
1617: {"Type":"Weapon","SubType":"Staff"},
1618: {"Type":"Weapon","SubType":"Staff"},
1619: {"Type":"Weapon","SubType":"Staff"},
1620: {"Type":"Weapon","SubType":"Staff"},
1621: {"Type":"Weapon","SubType":"Staff"},
1622: {"Type":"Weapon","SubType":"Staff"},
1623: {"Type":"Weapon","SubType":"Staff"},
1624: {"Type":"Weapon","SubType":"Staff"},
1625: {"Type":"Weapon","SubType":"Staff"},
1626: {"Type":"Weapon","SubType":"Staff"},
1627: {"Type":"Weapon","SubType":"Staff"},
1628: {"Type":"Weapon","SubType":"Staff"},
1629: {"Type":"Weapon","SubType":"Staff"},
1630: {"Type":"Weapon","SubType":"Staff"},
1631: {"Type":"Weapon","SubType":"Staff"},
1632: {"Type":"Weapon","SubType":"Staff"},
1633: {"Type":"Weapon","SubType":"Staff"},
1634: {"Type":"Weapon","SubType":"Staff"},
1635: {"Type":"Weapon","SubType":"Staff"},
1636: {"Type":"Weapon","SubType":"Staff"},
1637: {"Type":"Weapon","SubType":"Staff"},
1638: {"Type":"Weapon","SubType":"Staff"},
1639: {"Type":"Weapon","SubType":"Staff"},
1640: {"Type":"Weapon","SubType":"Staff"},
1641: {"Type":"Weapon","SubType":"Staff"},
1642: {"Type":"Weapon","SubType":"Staff"},
1643: {"Type":"Weapon","SubType":"Staff"},
1644: {"Type":"Weapon","SubType":"Staff"},
1645: {"Type":"Weapon","SubType":"Staff"},
1646: {"Type":"Weapon","SubType":"Staff"},
1647: {"Type":"Weapon","SubType":"Staff"},
1648: {"Type":"Weapon","SubType":"Staff"},
1649: {"Type":"Weapon","SubType":"Staff"},
1650: {"Type":"Weapon","SubType":"Staff"},
1651: {"Type":"Weapon","SubType":"Staff"},
1652: {"Type":"Weapon","SubType":"Staff"},
1653: {"Type":"Weapon","SubType":"Staff"},
1654: {"Type":"Weapon","SubType":"Staff"},
1655: {"Type":"Weapon","SubType":"Staff"},
1656: {"Type":"Weapon","SubType":"Staff"},
1657: {"Type":"Weapon","SubType":"Staff"},
1658: {"Type":"Weapon","SubType":"Staff"},
1659: {"Type":"Weapon","SubType":"Staff"},
1660: {"Type":"Weapon","SubType":"Staff"},
1661: {"Type":"Weapon","SubType":"Staff"},
1662: {"Type":"Weapon","SubType":"Staff"},
1663: {"Type":"Weapon","SubType":"Staff"},
1664: {"Type":"Weapon","SubType":"Mace"},
1665: {"Type":"Weapon","SubType":"Staff"},
1666: {"Type":"Weapon","SubType":"Staff"},
1667: {"Type":"Weapon","SubType":"Staff"},
1668: {"Type":"Weapon","SubType":"Staff"},
1669: {"Type":"Weapon","SubType":"Staff"},
1670: {"Type":"Weapon","SubType":"Staff"},
1671: {"Type":"Weapon","SubType":"Staff"},
1672: {"Type":"Weapon","SubType":"Staff"},
1673: {"Type":"Weapon","SubType":"Staff"},
1674: {"Type":"Weapon","SubType":"Staff"},
1675: {"Type":"Weapon","SubType":"Staff"},
1676: {"Type":"Weapon","SubType":"Staff"},
1677: {"Type":"Weapon","SubType":"Staff"},
1678: {"Type":"Weapon","SubType":"Staff"},
1679: {"Type":"Weapon","SubType":"Staff"},
1680: {"Type":"Weapon","SubType":"Staff"},
1681: {"Type":"Weapon","SubType":"Staff"},
1682: {"Type":"Weapon","SubType":"Staff"},
1683: {"Type":"Weapon","SubType":"Staff"},
1684: {"Type":"Weapon","SubType":"Staff"},
1685: {"Type":"Weapon","SubType":"Staff"},
1686: {"Type":"Weapon","SubType":"Staff"},
1687: {"Type":"Weapon","SubType":"Staff"},
1688: {"Type":"Weapon","SubType":"Staff"},
1689: {"Type":"Weapon","SubType":"Staff"},
1690: {"Type":"Weapon","SubType":"Staff"},
1691: {"Type":"Weapon","SubType":"Staff"},
1692: {"Type":"Weapon","SubType":"Staff"},
1693: {"Type":"Weapon","SubType":"Staff"},
1694: {"Type":"Weapon","SubType":"Staff"},
1695: {"Type":"Weapon","SubType":"Staff"},
1696: {"Type":"Weapon","SubType":"Staff"},
1697: {"Type":"Weapon","SubType":"Staff"},
1698: {"Type":"Weapon","SubType":"Staff"},
1699: {"Type":"Weapon","SubType":"Staff"},
1701: {"Type":"Weapon","SubType":"Bow"},
1702: {"Type":"Weapon","SubType":"Bow"},
1703: {"Type":"Weapon","SubType":"Bow"},
1704: {"Type":"Weapon","SubType":"Bow"},
1705: {"Type":"Weapon","SubType":"Bow"},
1706: {"Type":"Weapon","SubType":"Bow"},
1707: {"Type":"Weapon","SubType":"Bow"},
1708: {"Type":"Weapon","SubType":"Bow"},
1709: {"Type":"Weapon","SubType":"Bow"},
1710: {"Type":"Weapon","SubType":"Bow"},
1711: {"Type":"Weapon","SubType":"Bow"},
1712: {"Type":"Weapon","SubType":"Bow"},
1713: {"Type":"Weapon","SubType":"Bow"},
1714: {"Type":"Weapon","SubType":"Bow"},
1715: {"Type":"Weapon","SubType":"Bow"},
1716: {"Type":"Weapon","SubType":"Bow"},
1718: {"Type":"Weapon","SubType":"Bow"},
1719: {"Type":"Weapon","SubType":"Bow"},
1720: {"Type":"Weapon","SubType":"Bow"},
1721: {"Type":"Weapon","SubType":"Bow"},
1722: {"Type":"Weapon","SubType":"Bow"},
1723: {"Type":"Weapon","SubType":"Bow"},
1724: {"Type":"Weapon","SubType":"Bow"},
1725: {"Type":"Weapon","SubType":"Bow"},
1726: {"Type":"Weapon","SubType":"Bow"},
1727: {"Type":"Weapon","SubType":"Bow"},
1728: {"Type":"Weapon","SubType":"Bow"},
1729: {"Type":"Weapon","SubType":"Bow"},
1730: {"Type":"Weapon","SubType":"Bow"},
1731: {"Type":"Weapon","SubType":"Bow"},
1732: {"Type":"Weapon","SubType":"Bow"},
1733: {"Type":"Weapon","SubType":"Bow"},
1734: {"Type":"Weapon","SubType":"Bow"},
1735: {"Type":"Weapon","SubType":"Bow"},
1736: {"Type":"Weapon","SubType":"Bow"},
1737: {"Type":"Weapon","SubType":"Bow"},
1738: {"Type":"Weapon","SubType":"Bow"},
1739: {"Type":"Weapon","SubType":"Bow"},
1740: {"Type":"Weapon","SubType":"Bow"},
1741: {"Type":"Weapon","SubType":"Bow"},
1742: {"Type":"Weapon","SubType":"Bow"},
1743: {"Type":"Weapon","SubType":"Bow"},
1744: {"Type":"Weapon","SubType":"Bow"},
1745: {"Type":"Weapon","SubType":"Bow"},
1746: {"Type":"Weapon","SubType":"Bow"},
1747: {"Type":"Weapon","SubType":"Bow"},
1748: {"Type":"Weapon","SubType":"Bow"},
1749: {"Type":"Weapon","SubType":"Bow"},
1750: {"Type":"Ammo","SubType":"Arrow"},
1751: {"Type":"Ammo","SubType":"Arrow"},
1752: {"Type":"Ammo","SubType":"Arrow"},
1753: {"Type":"Ammo","SubType":"Arrow"},
1754: {"Type":"Ammo","SubType":"Arrow"},
1755: {"Type":"Ammo","SubType":"Arrow"},
1756: {"Type":"Ammo","SubType":"Arrow"},
1757: {"Type":"Ammo","SubType":"Arrow"},
1758: {"Type":"Ammo","SubType":"Arrow"},
1759: {"Type":"Ammo","SubType":"Arrow"},
1760: {"Type":"Ammo","SubType":"Arrow"},
1761: {"Type":"Ammo","SubType":"Arrow"},
1762: {"Type":"Ammo","SubType":"Arrow"},
1763: {"Type":"Ammo","SubType":"Arrow"},
1764: {"Type":"Ammo","SubType":"Arrow"},
1765: {"Type":"Ammo","SubType":"Arrow"},
1766: {"Type":"Ammo","SubType":"Arrow"},
1767: {"Type":"Ammo","SubType":"Arrow"},
1768: {"Type":"Ammo","SubType":"Arrow"},
1769: {"Type":"Ammo","SubType":"Arrow"},
1770: {"Type":"Ammo","SubType":"Arrow"},
1771: {"Type":"Ammo","SubType":"Dagger"},
1772: {"Type":"Ammo","SubType":"Arrow"},
1773: {"Type":"Ammo","SubType":"Arrow"},
1774: {"Type":"Ammo","SubType":"Arrow"},
1775: {"Type":"Ammo","SubType":"Arrow"},
1776: {"Type":"Ammo","SubType":"Arrow"},
1800: {"Type":"Weapon","SubType":"Knuckle"},
1801: {"Type":"Weapon","SubType":"Knuckle"},
1802: {"Type":"Weapon","SubType":"Knuckle"},
1803: {"Type":"Weapon","SubType":"Knuckle"},
1804: {"Type":"Weapon","SubType":"Knuckle"},
1805: {"Type":"Weapon","SubType":"Knuckle"},
1806: {"Type":"Weapon","SubType":"Knuckle"},
1807: {"Type":"Weapon","SubType":"Knuckle"},
1808: {"Type":"Weapon","SubType":"Knuckle"},
1809: {"Type":"Weapon","SubType":"Knuckle"},
1810: {"Type":"Weapon","SubType":"Knuckle"},
1811: {"Type":"Weapon","SubType":"Knuckle"},
1812: {"Type":"Weapon","SubType":"Knuckle"},
1813: {"Type":"Weapon","SubType":"Knuckle"},
1814: {"Type":"Weapon","SubType":"Knuckle"},
1815: {"Type":"Weapon","SubType":"Knuckle"},
1816: {"Type":"Weapon","SubType":"Knuckle"},
1817: {"Type":"Weapon","SubType":"Knuckle"},
1818: {"Type":"Weapon","SubType":"Knuckle"},
1819: {"Type":"Weapon","SubType":"Knuckle"},
1820: {"Type":"Weapon","SubType":"Knuckle"},
1821: {"Type":"Weapon","SubType":"Knuckle"},
1822: {"Type":"Weapon","SubType":"Knuckle"},
1823: {"Type":"Weapon","SubType":"Knuckle"},
1824: {"Type":"Weapon","SubType":"Knuckle"},
1825: {"Type":"Weapon","SubType":"Knuckle"},
1826: {"Type":"Weapon","SubType":"Knuckle"},
1827: {"Type":"Weapon","SubType":"Knuckle"},
1828: {"Type":"Weapon","SubType":"Knuckle"},
1829: {"Type":"Weapon","SubType":"Knuckle"},
1830: {"Type":"Weapon","SubType":"Knuckle"},
1831: {"Type":"Weapon","SubType":"Knuckle"},
1832: {"Type":"Weapon","SubType":"Knuckle"},
1833: {"Type":"Weapon","SubType":"Knuckle"},
1834: {"Type":"Weapon","SubType":"Knuckle"},
1835: {"Type":"Weapon","SubType":"Knuckle"},
1836: {"Type":"Weapon","SubType":"Knuckle"},
1837: {"Type":"Weapon","SubType":"Knuckle"},
1838: {"Type":"Weapon","SubType":"Knuckle"},
1839: {"Type":"Weapon","SubType":"Knuckle"},
1840: {"Type":"Weapon","SubType":"Knuckle"},
1841: {"Type":"Weapon","SubType":"Knuckle"},
1842: {"Type":"Weapon","SubType":"Knuckle"},
1843: {"Type":"Weapon","SubType":"Knuckle"},
1844: {"Type":"Weapon","SubType":"Knuckle"},
1845: {"Type":"Weapon","SubType":"Knuckle"},
1846: {"Type":"Weapon","SubType":"Knuckle"},
1847: {"Type":"Weapon","SubType":"Knuckle"},
1848: {"Type":"Weapon","SubType":"Knuckle"},
1857: {"Type":"Weapon","SubType":"Knuckle"},
1858: {"Type":"Weapon","SubType":"Knuckle"},
1859: {"Type":"Weapon","SubType":"Knuckle"},
1861: {"Type":"Weapon","SubType":"Knuckle"},
1862: {"Type":"Weapon","SubType":"Knuckle"},
1864: {"Type":"Weapon","SubType":"Knuckle"},
1865: {"Type":"Weapon","SubType":"Knuckle"},
1866: {"Type":"Weapon","SubType":"Knuckle"},
1867: {"Type":"Weapon","SubType":"Knuckle"},
1868: {"Type":"Weapon","SubType":"Mace"},
1869: {"Type":"Weapon","SubType":"Mace"},
1870: {"Type":"Weapon","SubType":"Knuckle"},
1871: {"Type":"Weapon","SubType":"Knuckle"},
1872: {"Type":"Weapon","SubType":"Knuckle"},
1873: {"Type":"Weapon","SubType":"Knuckle"},
1900: {"Type":"Weapon","SubType":"Musical"},
1901: {"Type":"Weapon","SubType":"Musical"},
1902: {"Type":"Weapon","SubType":"Musical"},
1903: {"Type":"Weapon","SubType":"Musical"},
1904: {"Type":"Weapon","SubType":"Musical"},
1905: {"Type":"Weapon","SubType":"Musical"},
1906: {"Type":"Weapon","SubType":"Musical"},
1907: {"Type":"Weapon","SubType":"Musical"},
1908: {"Type":"Weapon","SubType":"Musical"},
1909: {"Type":"Weapon","SubType":"Musical"},
1910: {"Type":"Weapon","SubType":"Musical"},
1911: {"Type":"Weapon","SubType":"Musical"},
1912: {"Type":"Weapon","SubType":"Musical"},
1913: {"Type":"Weapon","SubType":"Musical"},
1914: {"Type":"Weapon","SubType":"Musical"},
1915: {"Type":"Weapon","SubType":"Musical"},
1916: {"Type":"Weapon","SubType":"Musical"},
1917: {"Type":"Weapon","SubType":"Musical"},
1918: {"Type":"Weapon","SubType":"Musical"},
1919: {"Type":"Weapon","SubType":"Musical"},
1920: {"Type":"Weapon","SubType":"Musical"},
1921: {"Type":"Weapon","SubType":"Musical"},
1922: {"Type":"Weapon","SubType":"Musical"},
1923: {"Type":"Weapon","SubType":"Musical"},
1924: {"Type":"Weapon","SubType":"Musical"},
1925: {"Type":"Weapon","SubType":"Musical"},
1926: {"Type":"Weapon","SubType":"Musical"},
1927: {"Type":"Weapon","SubType":"Musical"},
1928: {"Type":"Weapon","SubType":"Musical"},
1929: {"Type":"Weapon","SubType":"Musical"},
1930: {"Type":"Weapon","SubType":"Musical"},
1931: {"Type":"Weapon","SubType":"Musical"},
1932: {"Type":"Weapon","SubType":"Musical"},
1933: {"Type":"Weapon","SubType":"Musical"},
1934: {"Type":"Weapon","SubType":"Musical"},
1935: {"Type":"Weapon","SubType":"Musical"},
1936: {"Type":"Weapon","SubType":"Musical"},
1937: {"Type":"Weapon","SubType":"Musical"},
1938: {"Type":"Weapon","SubType":"Musical"},
1939: {"Type":"Weapon","SubType":"Musical"},
1940: {"Type":"Weapon","SubType":"Musical"},
1941: {"Type":"Weapon","SubType":"Musical"},
1942: {"Type":"Weapon","SubType":"Musical"},
1943: {"Type":"Weapon","SubType":"Musical"},
1944: {"Type":"Weapon","SubType":"Musical"},
1945: {"Type":"Weapon","SubType":"Musical"},
1946: {"Type":"Weapon","SubType":"Musical"},
1947: {"Type":"Weapon","SubType":"Musical"},
1948: {"Type":"Weapon","SubType":"Musical"},
1949: {"Type":"Weapon","SubType":"Musical"},
1950: {"Type":"Weapon","SubType":"Whip"},
1951: {"Type":"Weapon","SubType":"Whip"},
1952: {"Type":"Weapon","SubType":"Whip"},
1953: {"Type":"Weapon","SubType":"Whip"},
1954: {"Type":"Weapon","SubType":"Whip"},
1955: {"Type":"Weapon","SubType":"Whip"},
1956: {"Type":"Weapon","SubType":"Whip"},
1957: {"Type":"Weapon","SubType":"Whip"},
1958: {"Type":"Weapon","SubType":"Whip"},
1959: {"Type":"Weapon","SubType":"Whip"},
1960: {"Type":"Weapon","SubType":"Whip"},
1961: {"Type":"Weapon","SubType":"Whip"},
1962: {"Type":"Weapon","SubType":"Whip"},
1963: {"Type":"Weapon","SubType":"Whip"},
1964: {"Type":"Weapon","SubType":"Whip"},
1965: {"Type":"Weapon","SubType":"Whip"},
1966: {"Type":"Weapon","SubType":"Whip"},
1967: {"Type":"Weapon","SubType":"Whip"},
1968: {"Type":"Weapon","SubType":"Whip"},
1969: {"Type":"Weapon","SubType":"Whip"},
1970: {"Type":"Weapon","SubType":"Whip"},
1971: {"Type":"Weapon","SubType":"Whip"},
1972: {"Type":"Weapon","SubType":"Whip"},
1973: {"Type":"Weapon","SubType":"Whip"},
1974: {"Type":"Weapon","SubType":"Whip"},
1975: {"Type":"Weapon","SubType":"Whip"},
1976: {"Type":"Weapon","SubType":"Whip"},
1977: {"Type":"Weapon","SubType":"Whip"},
1978: {"Type":"Weapon","SubType":"Whip"},
1979: {"Type":"Weapon","SubType":"Whip"},
1980: {"Type":"Weapon","SubType":"Whip"},
1981: {"Type":"Weapon","SubType":"Whip"},
1982: {"Type":"Weapon","SubType":"Whip"},
1983: {"Type":"Weapon","SubType":"Whip"},
1984: {"Type":"Weapon","SubType":"Whip"},
1985: {"Type":"Weapon","SubType":"Whip"},
1986: {"Type":"Weapon","SubType":"Whip"},
1987: {"Type":"Weapon","SubType":"Whip"},
1988: {"Type":"Weapon","SubType":"Whip"},
1989: {"Type":"Weapon","SubType":"Whip"},
1990: {"Type":"Weapon","SubType":"Whip"},
1991: {"Type":"Weapon","SubType":"Whip"},
1992: {"Type":"Weapon","SubType":"Whip"},
1993: {"Type":"Weapon","SubType":"Whip"},
1994: {"Type":"Weapon","SubType":"Whip"},
1995: {"Type":"Weapon","SubType":"Whip"},
1996: {"Type":"Weapon","SubType":"Whip"},
1997: {"Type":"Weapon","SubType":"Whip"},
1998: {"Type":"Weapon","SubType":"Whip"},
1999: {"Type":"Weapon","SubType":"Whip"},
2000: {"Type":"Weapon","SubType":"2hStaff"},
2001: {"Type":"Weapon","SubType":"2hStaff"},
2002: {"Type":"Weapon","SubType":"2hStaff"},
2003: {"Type":"Weapon","SubType":"2hStaff"},
2004: {"Type":"Weapon","SubType":"2hStaff"},
2005: {"Type":"Weapon","SubType":"2hStaff"},
2006: {"Type":"Weapon","SubType":"2hStaff"},
2007: {"Type":"Weapon","SubType":"2hStaff"},
2008: {"Type":"Weapon","SubType":"2hStaff"},
2009: {"Type":"Weapon","SubType":"2hStaff"},
2010: {"Type":"Weapon","SubType":"2hStaff"},
2011: {"Type":"Weapon","SubType":"2hStaff"},
2012: {"Type":"Weapon","SubType":"2hStaff"},
2013: {"Type":"Weapon","SubType":"2hStaff"},
2014: {"Type":"Weapon","SubType":"2hStaff"},
2015: {"Type":"Weapon","SubType":"2hStaff"},
2016: {"Type":"Weapon","SubType":"2hStaff"},
2017: {"Type":"Weapon","SubType":"2hStaff"},
2018: {"Type":"Weapon","SubType":"2hStaff"},
2019: {"Type":"Weapon","SubType":"2hStaff"},
2020: {"Type":"Weapon","SubType":"2hStaff"},
2021: {"Type":"Weapon","SubType":"Staff"},
2022: {"Type":"Weapon","SubType":"2hStaff"},
2023: {"Type":"Weapon","SubType":"2hStaff"},
2024: {"Type":"Weapon","SubType":"2hStaff"},
2025: {"Type":"Weapon","SubType":"2hStaff"},
2026: {"Type":"Weapon","SubType":"2hStaff"},
2027: {"Type":"Weapon","SubType":"2hStaff"},
2028: {"Type":"Weapon","SubType":"2hStaff"},
2029: {"Type":"Weapon","SubType":"2hStaff"},
2030: {"Type":"Weapon","SubType":"2hStaff"},
2031: {"Type":"Weapon","SubType":"2hStaff"},
2032: {"Type":"Weapon","SubType":"Staff"},
2033: {"Type":"Weapon","SubType":"2hStaff"},
2034: {"Type":"Weapon","SubType":"2hStaff"},
2035: {"Type":"Weapon","SubType":"2hStaff"},
2036: {"Type":"Weapon","SubType":"2hStaff"},
2037: {"Type":"Weapon","SubType":"2hStaff"},
2038: {"Type":"Weapon","SubType":"2hStaff"},
2039: {"Type":"Weapon","SubType":"2hStaff"},
2040: {"Type":"Weapon","SubType":"2hStaff"},
2041: {"Type":"Weapon","SubType":"2hStaff"},
2042: {"Type":"Weapon","SubType":"2hStaff"},
2043: {"Type":"Weapon","SubType":"2hStaff"},
2044: {"Type":"Weapon","SubType":"2hStaff"},
2045: {"Type":"Weapon","SubType":"2hStaff"},
2046: {"Type":"Weapon","SubType":"2hStaff"},
2047: {"Type":"Weapon","SubType":"2hStaff"},
2048: {"Type":"Weapon","SubType":"2hStaff"},
2049: {"Type":"Weapon","SubType":"2hStaff"},
2050: {"Type":"Weapon","SubType":"2hStaff"},
2051: {"Type":"Weapon","SubType":"2hStaff"},
2052: {"Type":"Weapon","SubType":"2hStaff"},
2053: {"Type":"Weapon","SubType":"2hStaff"},
2054: {"Type":"Weapon","SubType":"2hStaff"},
2055: {"Type":"Weapon","SubType":"2hStaff"},
2056: {"Type":"Weapon","SubType":"2hStaff"},
2057: {"Type":"Weapon","SubType":"2hStaff"},
2058: {"Type":"Weapon","SubType":"2hStaff"},
2059: {"Type":"Weapon","SubType":"2hStaff"},
2060: {"Type":"Weapon","SubType":"2hStaff"},
2061: {"Type":"Weapon","SubType":"2hStaff"},
2062: {"Type":"Weapon","SubType":"2hStaff"},
2063: {"Type":"Weapon","SubType":"2hStaff"},
2064: {"Type":"Weapon","SubType":"2hStaff"},
2101: {"Type":"Armor","SubType":"NULL"},
2102: {"Type":"Armor","SubType":"NULL"},
2103: {"Type":"Armor","SubType":"NULL"},
2104: {"Type":"Armor","SubType":"NULL"},
2105: {"Type":"Armor","SubType":"NULL"},
2106: {"Type":"Armor","SubType":"NULL"},
2107: {"Type":"Armor","SubType":"NULL"},
2108: {"Type":"Armor","SubType":"NULL"},
2109: {"Type":"Armor","SubType":"NULL"},
2110: {"Type":"Armor","SubType":"NULL"},
2111: {"Type":"Armor","SubType":"NULL"},
2112: {"Type":"Armor","SubType":"NULL"},
2113: {"Type":"Armor","SubType":"NULL"},
2114: {"Type":"Armor","SubType":"NULL"},
2115: {"Type":"Armor","SubType":"NULL"},
2116: {"Type":"Armor","SubType":"NULL"},
2117: {"Type":"Armor","SubType":"NULL"},
2118: {"Type":"Armor","SubType":"NULL"},
2119: {"Type":"Armor","SubType":"NULL"},
2120: {"Type":"Armor","SubType":"NULL"},
2121: {"Type":"Armor","SubType":"NULL"},
2122: {"Type":"Armor","SubType":"NULL"},
2123: {"Type":"Armor","SubType":"NULL"},
2124: {"Type":"Armor","SubType":"NULL"},
2125: {"Type":"Armor","SubType":"NULL"},
2126: {"Type":"Armor","SubType":"NULL"},
2127: {"Type":"Armor","SubType":"NULL"},
2128: {"Type":"Armor","SubType":"NULL"},
2129: {"Type":"Armor","SubType":"NULL"},
2130: {"Type":"Armor","SubType":"NULL"},
2131: {"Type":"Armor","SubType":"NULL"},
2132: {"Type":"Armor","SubType":"NULL"},
2133: {"Type":"Armor","SubType":"NULL"},
2134: {"Type":"Armor","SubType":"NULL"},
2135: {"Type":"Armor","SubType":"NULL"},
2136: {"Type":"Armor","SubType":"NULL"},
2137: {"Type":"Armor","SubType":"NULL"},
2138: {"Type":"Armor","SubType":"NULL"},
2139: {"Type":"Armor","SubType":"NULL"},
2140: {"Type":"Armor","SubType":"NULL"},
2141: {"Type":"Armor","SubType":"NULL"},
2142: {"Type":"Armor","SubType":"NULL"},
2143: {"Type":"Armor","SubType":"NULL"},
2144: {"Type":"Armor","SubType":"NULL"},
2145: {"Type":"Armor","SubType":"NULL"},
2146: {"Type":"Armor","SubType":"NULL"},
2147: {"Type":"Armor","SubType":"NULL"},
2148: {"Type":"Armor","SubType":"NULL"},
2149: {"Type":"Armor","SubType":"NULL"},
2150: {"Type":"Armor","SubType":"NULL"},
2151: {"Type":"Armor","SubType":"NULL"},
2152: {"Type":"Armor","SubType":"NULL"},
2153: {"Type":"Armor","SubType":"NULL"},
2154: {"Type":"Armor","SubType":"NULL"},
2155: {"Type":"Armor","SubType":"NULL"},
2156: {"Type":"Armor","SubType":"NULL"},
2157: {"Type":"Armor","SubType":"NULL"},
2158: {"Type":"Armor","SubType":"NULL"},
2159: {"Type":"Armor","SubType":"NULL"},
2160: {"Type":"Armor","SubType":"NULL"},
2161: {"Type":"Armor","SubType":"NULL"},
2162: {"Type":"Armor","SubType":"NULL"},
2163: {"Type":"Armor","SubType":"NULL"},
2164: {"Type":"Armor","SubType":"NULL"},
2165: {"Type":"Armor","SubType":"NULL"},
2166: {"Type":"Armor","SubType":"NULL"},
2167: {"Type":"Armor","SubType":"NULL"},
2168: {"Type":"Armor","SubType":"NULL"},
2169: {"Type":"Armor","SubType":"NULL"},
2170: {"Type":"Armor","SubType":"NULL"},
2171: {"Type":"Armor","SubType":"NULL"},
2172: {"Type":"Armor","SubType":"NULL"},
2173: {"Type":"Armor","SubType":"NULL"},
2174: {"Type":"Armor","SubType":"NULL"},
2175: {"Type":"Armor","SubType":"NULL"},
2176: {"Type":"Armor","SubType":"NULL"},
2177: {"Type":"Armor","SubType":"NULL"},
2178: {"Type":"Armor","SubType":"NULL"},
2179: {"Type":"Armor","SubType":"NULL"},
2180: {"Type":"Armor","SubType":"NULL"},
2181: {"Type":"Armor","SubType":"NULL"},
2182: {"Type":"Armor","SubType":"NULL"},
2183: {"Type":"Armor","SubType":"NULL"},
2184: {"Type":"Armor","SubType":"NULL"},
2185: {"Type":"Armor","SubType":"NULL"},
2186: {"Type":"Armor","SubType":"NULL"},
2187: {"Type":"Armor","SubType":"NULL"},
2188: {"Type":"Armor","SubType":"NULL"},
2189: {"Type":"Armor","SubType":"NULL"},
2190: {"Type":"Armor","SubType":"NULL"},
2191: {"Type":"Armor","SubType":"NULL"},
2192: {"Type":"Armor","SubType":"NULL"},
2193: {"Type":"Armor","SubType":"NULL"},
2194: {"Type":"Armor","SubType":"NULL"},
2195: {"Type":"Armor","SubType":"NULL"},
2196: {"Type":"Armor","SubType":"NULL"},
2197: {"Type":"Armor","SubType":"NULL"},
2198: {"Type":"Armor","SubType":"NULL"},
2199: {"Type":"Armor","SubType":"NULL"},
2201: {"Type":"Armor","SubType":"NULL"},
2202: {"Type":"Armor","SubType":"NULL"},
2203: {"Type":"Armor","SubType":"NULL"},
2204: {"Type":"Armor","SubType":"NULL"},
2205: {"Type":"Armor","SubType":"NULL"},
2206: {"Type":"Armor","SubType":"NULL"},
2207: {"Type":"Armor","SubType":"NULL"},
2208: {"Type":"Armor","SubType":"NULL"},
2209: {"Type":"Armor","SubType":"NULL"},
2210: {"Type":"Armor","SubType":"NULL"},
2211: {"Type":"Armor","SubType":"NULL"},
2212: {"Type":"Armor","SubType":"NULL"},
2213: {"Type":"Armor","SubType":"NULL"},
2214: {"Type":"Armor","SubType":"NULL"},
2215: {"Type":"Armor","SubType":"NULL"},
2216: {"Type":"Armor","SubType":"NULL"},
2217: {"Type":"Armor","SubType":"NULL"},
2218: {"Type":"Armor","SubType":"NULL"},
2219: {"Type":"Armor","SubType":"NULL"},
2220: {"Type":"Armor","SubType":"NULL"},
2221: {"Type":"Armor","SubType":"NULL"},
2222: {"Type":"Armor","SubType":"NULL"},
2223: {"Type":"Armor","SubType":"NULL"},
2224: {"Type":"Armor","SubType":"NULL"},
2225: {"Type":"Armor","SubType":"NULL"},
2226: {"Type":"Armor","SubType":"NULL"},
2227: {"Type":"Armor","SubType":"NULL"},
2228: {"Type":"Armor","SubType":"NULL"},
2229: {"Type":"Armor","SubType":"NULL"},
2230: {"Type":"Armor","SubType":"NULL"},
2231: {"Type":"Armor","SubType":"NULL"},
2232: {"Type":"Armor","SubType":"NULL"},
2233: {"Type":"Armor","SubType":"NULL"},
2234: {"Type":"Armor","SubType":"NULL"},
2235: {"Type":"Armor","SubType":"NULL"},
2236: {"Type":"Armor","SubType":"NULL"},
2237: {"Type":"Armor","SubType":"NULL"},
2238: {"Type":"Armor","SubType":"NULL"},
2239: {"Type":"Armor","SubType":"NULL"},
2240: {"Type":"Armor","SubType":"NULL"},
2241: {"Type":"Armor","SubType":"NULL"},
2242: {"Type":"Armor","SubType":"NULL"},
2243: {"Type":"Armor","SubType":"NULL"},
2244: {"Type":"Armor","SubType":"NULL"},
2245: {"Type":"Armor","SubType":"NULL"},
2246: {"Type":"Armor","SubType":"NULL"},
2247: {"Type":"Armor","SubType":"NULL"},
2248: {"Type":"Armor","SubType":"NULL"},
2249: {"Type":"Armor","SubType":"NULL"},
2250: {"Type":"Armor","SubType":"NULL"},
2251: {"Type":"Armor","SubType":"NULL"},
2252: {"Type":"Armor","SubType":"NULL"},
2253: {"Type":"Armor","SubType":"NULL"},
2254: {"Type":"Armor","SubType":"NULL"},
2255: {"Type":"Armor","SubType":"NULL"},
2256: {"Type":"Armor","SubType":"NULL"},
2257: {"Type":"Armor","SubType":"NULL"},
2258: {"Type":"Armor","SubType":"NULL"},
2259: {"Type":"Armor","SubType":"NULL"},
2260: {"Type":"Armor","SubType":"NULL"},
2261: {"Type":"Armor","SubType":"NULL"},
2262: {"Type":"Armor","SubType":"NULL"},
2263: {"Type":"Armor","SubType":"NULL"},
2264: {"Type":"Armor","SubType":"NULL"},
2265: {"Type":"Armor","SubType":"NULL"},
2266: {"Type":"Armor","SubType":"NULL"},
2267: {"Type":"Armor","SubType":"NULL"},
2268: {"Type":"Armor","SubType":"NULL"},
2269: {"Type":"Armor","SubType":"NULL"},
2270: {"Type":"Armor","SubType":"NULL"},
2271: {"Type":"Armor","SubType":"NULL"},
2272: {"Type":"Armor","SubType":"NULL"},
2273: {"Type":"Armor","SubType":"NULL"},
2274: {"Type":"Armor","SubType":"NULL"},
2275: {"Type":"Armor","SubType":"NULL"},
2276: {"Type":"Armor","SubType":"NULL"},
2277: {"Type":"Armor","SubType":"NULL"},
2278: {"Type":"Armor","SubType":"NULL"},
2279: {"Type":"Armor","SubType":"NULL"},
2280: {"Type":"Armor","SubType":"NULL"},
2281: {"Type":"Armor","SubType":"NULL"},
2282: {"Type":"Armor","SubType":"NULL"},
2283: {"Type":"Armor","SubType":"NULL"},
2284: {"Type":"Armor","SubType":"NULL"},
2285: {"Type":"Armor","SubType":"NULL"},
2286: {"Type":"Armor","SubType":"NULL"},
2287: {"Type":"Armor","SubType":"NULL"},
2288: {"Type":"Armor","SubType":"NULL"},
2289: {"Type":"Armor","SubType":"NULL"},
2290: {"Type":"Armor","SubType":"NULL"},
2291: {"Type":"Armor","SubType":"NULL"},
2292: {"Type":"Armor","SubType":"NULL"},
2293: {"Type":"Armor","SubType":"NULL"},
2294: {"Type":"Armor","SubType":"NULL"},
2295: {"Type":"Armor","SubType":"NULL"},
2296: {"Type":"Armor","SubType":"NULL"},
2297: {"Type":"Armor","SubType":"NULL"},
2298: {"Type":"Armor","SubType":"NULL"},
2299: {"Type":"Armor","SubType":"NULL"},
2301: {"Type":"Armor","SubType":"NULL"},
2302: {"Type":"Armor","SubType":"NULL"},
2303: {"Type":"Armor","SubType":"NULL"},
2304: {"Type":"Armor","SubType":"NULL"},
2305: {"Type":"Armor","SubType":"NULL"},
2306: {"Type":"Armor","SubType":"NULL"},
2307: {"Type":"Armor","SubType":"NULL"},
2308: {"Type":"Armor","SubType":"NULL"},
2309: {"Type":"Armor","SubType":"NULL"},
2310: {"Type":"Armor","SubType":"NULL"},
2311: {"Type":"Armor","SubType":"NULL"},
2312: {"Type":"Armor","SubType":"NULL"},
2313: {"Type":"Armor","SubType":"NULL"},
2314: {"Type":"Armor","SubType":"NULL"},
2315: {"Type":"Armor","SubType":"NULL"},
2316: {"Type":"Armor","SubType":"NULL"},
2317: {"Type":"Armor","SubType":"NULL"},
2318: {"Type":"Armor","SubType":"NULL"},
2319: {"Type":"Armor","SubType":"NULL"},
2320: {"Type":"Armor","SubType":"NULL"},
2321: {"Type":"Armor","SubType":"NULL"},
2322: {"Type":"Armor","SubType":"NULL"},
2323: {"Type":"Armor","SubType":"NULL"},
2324: {"Type":"Armor","SubType":"NULL"},
2325: {"Type":"Armor","SubType":"NULL"},
2326: {"Type":"Armor","SubType":"NULL"},
2327: {"Type":"Armor","SubType":"NULL"},
2328: {"Type":"Armor","SubType":"NULL"},
2329: {"Type":"Armor","SubType":"NULL"},
2330: {"Type":"Armor","SubType":"NULL"},
2331: {"Type":"Armor","SubType":"NULL"},
2332: {"Type":"Armor","SubType":"NULL"},
2333: {"Type":"Armor","SubType":"NULL"},
2334: {"Type":"Armor","SubType":"NULL"},
2335: {"Type":"Armor","SubType":"NULL"},
2336: {"Type":"Armor","SubType":"NULL"},
2337: {"Type":"Armor","SubType":"NULL"},
2338: {"Type":"Armor","SubType":"NULL"},
2339: {"Type":"Armor","SubType":"NULL"},
2340: {"Type":"Armor","SubType":"NULL"},
2341: {"Type":"Armor","SubType":"NULL"},
2342: {"Type":"Armor","SubType":"NULL"},
2343: {"Type":"Armor","SubType":"NULL"},
2344: {"Type":"Armor","SubType":"NULL"},
2345: {"Type":"Armor","SubType":"NULL"},
2346: {"Type":"Armor","SubType":"NULL"},
2347: {"Type":"Armor","SubType":"NULL"},
2348: {"Type":"Armor","SubType":"NULL"},
2349: {"Type":"Armor","SubType":"NULL"},
2350: {"Type":"Armor","SubType":"NULL"},
2351: {"Type":"Armor","SubType":"NULL"},
2352: {"Type":"Armor","SubType":"NULL"},
2353: {"Type":"Armor","SubType":"NULL"},
2354: {"Type":"Armor","SubType":"NULL"},
2355: {"Type":"Armor","SubType":"NULL"},
2356: {"Type":"Armor","SubType":"NULL"},
2357: {"Type":"Armor","SubType":"NULL"},
2358: {"Type":"Armor","SubType":"NULL"},
2359: {"Type":"Armor","SubType":"NULL"},
2360: {"Type":"Armor","SubType":"NULL"},
2361: {"Type":"Armor","SubType":"NULL"},
2362: {"Type":"Armor","SubType":"NULL"},
2363: {"Type":"Armor","SubType":"NULL"},
2364: {"Type":"Armor","SubType":"NULL"},
2365: {"Type":"Armor","SubType":"NULL"},
2366: {"Type":"Armor","SubType":"NULL"},
2367: {"Type":"Armor","SubType":"NULL"},
2368: {"Type":"Armor","SubType":"NULL"},
2369: {"Type":"Armor","SubType":"NULL"},
2370: {"Type":"Armor","SubType":"NULL"},
2371: {"Type":"Armor","SubType":"NULL"},
2372: {"Type":"Armor","SubType":"NULL"},
2373: {"Type":"Armor","SubType":"NULL"},
2374: {"Type":"Armor","SubType":"NULL"},
2375: {"Type":"Armor","SubType":"NULL"},
2376: {"Type":"Armor","SubType":"NULL"},
2377: {"Type":"Armor","SubType":"NULL"},
2378: {"Type":"Armor","SubType":"NULL"},
2379: {"Type":"Armor","SubType":"NULL"},
2380: {"Type":"Armor","SubType":"NULL"},
2381: {"Type":"Armor","SubType":"NULL"},
2382: {"Type":"Armor","SubType":"NULL"},
2383: {"Type":"Armor","SubType":"NULL"},
2384: {"Type":"Armor","SubType":"NULL"},
2385: {"Type":"Armor","SubType":"NULL"},
2386: {"Type":"Armor","SubType":"NULL"},
2387: {"Type":"Armor","SubType":"NULL"},
2388: {"Type":"Armor","SubType":"NULL"},
2389: {"Type":"Armor","SubType":"NULL"},
2390: {"Type":"Armor","SubType":"NULL"},
2391: {"Type":"Armor","SubType":"NULL"},
2392: {"Type":"Armor","SubType":"NULL"},
2393: {"Type":"Armor","SubType":"NULL"},
2394: {"Type":"Armor","SubType":"NULL"},
2395: {"Type":"Armor","SubType":"NULL"},
2396: {"Type":"Armor","SubType":"NULL"},
2397: {"Type":"Armor","SubType":"NULL"},
2398: {"Type":"Armor","SubType":"NULL"},
2399: {"Type":"Armor","SubType":"NULL"},
2400: {"Type":"Armor","SubType":"NULL"},
2401: {"Type":"Armor","SubType":"NULL"},
2402: {"Type":"Armor","SubType":"NULL"},
2403: {"Type":"Armor","SubType":"NULL"},
2404: {"Type":"Armor","SubType":"NULL"},
2405: {"Type":"Armor","SubType":"NULL"},
2406: {"Type":"Armor","SubType":"NULL"},
2407: {"Type":"Armor","SubType":"NULL"},
2408: {"Type":"Armor","SubType":"NULL"},
2409: {"Type":"Armor","SubType":"NULL"},
2410: {"Type":"Armor","SubType":"NULL"},
2411: {"Type":"Armor","SubType":"NULL"},
2412: {"Type":"Armor","SubType":"NULL"},
2413: {"Type":"Armor","SubType":"NULL"},
2414: {"Type":"Armor","SubType":"NULL"},
2415: {"Type":"Armor","SubType":"NULL"},
2416: {"Type":"Armor","SubType":"NULL"},
2417: {"Type":"Armor","SubType":"NULL"},
2418: {"Type":"Armor","SubType":"NULL"},
2419: {"Type":"Armor","SubType":"NULL"},
2420: {"Type":"Armor","SubType":"NULL"},
2421: {"Type":"Armor","SubType":"NULL"},
2422: {"Type":"Armor","SubType":"NULL"},
2423: {"Type":"Armor","SubType":"NULL"},
2424: {"Type":"Armor","SubType":"NULL"},
2425: {"Type":"Armor","SubType":"NULL"},
2426: {"Type":"Armor","SubType":"NULL"},
2427: {"Type":"Armor","SubType":"NULL"},
2428: {"Type":"Armor","SubType":"NULL"},
2429: {"Type":"Armor","SubType":"NULL"},
2430: {"Type":"Armor","SubType":"NULL"},
2431: {"Type":"Armor","SubType":"NULL"},
2432: {"Type":"Armor","SubType":"NULL"},
2433: {"Type":"Armor","SubType":"NULL"},
2434: {"Type":"Armor","SubType":"NULL"},
2435: {"Type":"Armor","SubType":"NULL"},
2436: {"Type":"Armor","SubType":"NULL"},
2437: {"Type":"Armor","SubType":"NULL"},
2438: {"Type":"Armor","SubType":"NULL"},
2439: {"Type":"Armor","SubType":"NULL"},
2440: {"Type":"Armor","SubType":"NULL"},
2441: {"Type":"Armor","SubType":"NULL"},
2442: {"Type":"Armor","SubType":"NULL"},
2443: {"Type":"Armor","SubType":"NULL"},
2444: {"Type":"Armor","SubType":"NULL"},
2445: {"Type":"Armor","SubType":"NULL"},
2446: {"Type":"Armor","SubType":"NULL"},
2447: {"Type":"Armor","SubType":"NULL"},
2448: {"Type":"Armor","SubType":"NULL"},
2449: {"Type":"Armor","SubType":"NULL"},
2450: {"Type":"Armor","SubType":"NULL"},
2451: {"Type":"Armor","SubType":"NULL"},
2452: {"Type":"Armor","SubType":"NULL"},
2453: {"Type":"Armor","SubType":"NULL"},
2454: {"Type":"Armor","SubType":"NULL"},
2455: {"Type":"Armor","SubType":"NULL"},
2456: {"Type":"Armor","SubType":"NULL"},
2457: {"Type":"Armor","SubType":"NULL"},
2458: {"Type":"Armor","SubType":"NULL"},
2459: {"Type":"Armor","SubType":"NULL"},
2460: {"Type":"Armor","SubType":"NULL"},
2461: {"Type":"Armor","SubType":"NULL"},
2462: {"Type":"Armor","SubType":"NULL"},
2463: {"Type":"Armor","SubType":"NULL"},
2464: {"Type":"Armor","SubType":"NULL"},
2465: {"Type":"Armor","SubType":"NULL"},
2466: {"Type":"Armor","SubType":"NULL"},
2467: {"Type":"Armor","SubType":"NULL"},
2468: {"Type":"Armor","SubType":"NULL"},
2469: {"Type":"Armor","SubType":"NULL"},
2470: {"Type":"Armor","SubType":"NULL"},
2471: {"Type":"Armor","SubType":"NULL"},
2472: {"Type":"Armor","SubType":"NULL"},
2473: {"Type":"Armor","SubType":"NULL"},
2474: {"Type":"Armor","SubType":"NULL"},
2475: {"Type":"Armor","SubType":"NULL"},
2476: {"Type":"Armor","SubType":"NULL"},
2477: {"Type":"Armor","SubType":"NULL"},
2478: {"Type":"Armor","SubType":"NULL"},
2479: {"Type":"Armor","SubType":"NULL"},
2480: {"Type":"Armor","SubType":"NULL"},
2481: {"Type":"Armor","SubType":"NULL"},
2482: {"Type":"Armor","SubType":"NULL"},
2483: {"Type":"Armor","SubType":"NULL"},
2484: {"Type":"Armor","SubType":"NULL"},
2485: {"Type":"Armor","SubType":"NULL"},
2486: {"Type":"Armor","SubType":"NULL"},
2487: {"Type":"Armor","SubType":"NULL"},
2488: {"Type":"Armor","SubType":"NULL"},
2489: {"Type":"Armor","SubType":"NULL"},
2490: {"Type":"Armor","SubType":"NULL"},
2491: {"Type":"Armor","SubType":"NULL"},
2492: {"Type":"Armor","SubType":"NULL"},
2493: {"Type":"Armor","SubType":"NULL"},
2494: {"Type":"Armor","SubType":"NULL"},
2495: {"Type":"Armor","SubType":"NULL"},
2496: {"Type":"Armor","SubType":"NULL"},
2497: {"Type":"Armor","SubType":"NULL"},
2498: {"Type":"Armor","SubType":"NULL"},
2499: {"Type":"Armor","SubType":"NULL"},
2501: {"Type":"Armor","SubType":"NULL"},
2502: {"Type":"Armor","SubType":"NULL"},
2503: {"Type":"Armor","SubType":"NULL"},
2504: {"Type":"Armor","SubType":"NULL"},
2505: {"Type":"Armor","SubType":"NULL"},
2506: {"Type":"Armor","SubType":"NULL"},
2507: {"Type":"Armor","SubType":"NULL"},
2508: {"Type":"Armor","SubType":"NULL"},
2509: {"Type":"Armor","SubType":"NULL"},
2510: {"Type":"Armor","SubType":"NULL"},
2511: {"Type":"Armor","SubType":"NULL"},
2512: {"Type":"Armor","SubType":"NULL"},
2513: {"Type":"Armor","SubType":"NULL"},
2514: {"Type":"Armor","SubType":"NULL"},
2515: {"Type":"Armor","SubType":"NULL"},
2516: {"Type":"Armor","SubType":"NULL"},
2517: {"Type":"Armor","SubType":"NULL"},
2518: {"Type":"Armor","SubType":"NULL"},
2519: {"Type":"Armor","SubType":"NULL"},
2520: {"Type":"Armor","SubType":"NULL"},
2521: {"Type":"Armor","SubType":"NULL"},
2522: {"Type":"Armor","SubType":"NULL"},
2523: {"Type":"Armor","SubType":"NULL"},
2524: {"Type":"Armor","SubType":"NULL"},
2525: {"Type":"Armor","SubType":"NULL"},
2526: {"Type":"Armor","SubType":"NULL"},
2527: {"Type":"Armor","SubType":"NULL"},
2528: {"Type":"Armor","SubType":"NULL"},
2529: {"Type":"Armor","SubType":"NULL"},
2530: {"Type":"Armor","SubType":"NULL"},
2531: {"Type":"Armor","SubType":"NULL"},
2532: {"Type":"Armor","SubType":"NULL"},
2533: {"Type":"Armor","SubType":"NULL"},
2534: {"Type":"Armor","SubType":"NULL"},
2535: {"Type":"Armor","SubType":"NULL"},
2536: {"Type":"Armor","SubType":"NULL"},
2537: {"Type":"Armor","SubType":"NULL"},
2538: {"Type":"Armor","SubType":"NULL"},
2539: {"Type":"Armor","SubType":"NULL"},
2540: {"Type":"Armor","SubType":"NULL"},
2541: {"Type":"Armor","SubType":"NULL"},
2542: {"Type":"Armor","SubType":"NULL"},
2543: {"Type":"Armor","SubType":"NULL"},
2544: {"Type":"Armor","SubType":"NULL"},
2545: {"Type":"Armor","SubType":"NULL"},
2546: {"Type":"Armor","SubType":"NULL"},
2547: {"Type":"Armor","SubType":"NULL"},
2548: {"Type":"Armor","SubType":"NULL"},
2549: {"Type":"Armor","SubType":"NULL"},
2550: {"Type":"Armor","SubType":"NULL"},
2551: {"Type":"Armor","SubType":"NULL"},
2552: {"Type":"Armor","SubType":"NULL"},
2553: {"Type":"Armor","SubType":"NULL"},
2554: {"Type":"Armor","SubType":"NULL"},
2555: {"Type":"Armor","SubType":"NULL"},
2556: {"Type":"Armor","SubType":"NULL"},
2557: {"Type":"Armor","SubType":"NULL"},
2558: {"Type":"Armor","SubType":"NULL"},
2559: {"Type":"Armor","SubType":"NULL"},
2560: {"Type":"Armor","SubType":"NULL"},
2561: {"Type":"Armor","SubType":"NULL"},
2562: {"Type":"Armor","SubType":"NULL"},
2563: {"Type":"Armor","SubType":"NULL"},
2564: {"Type":"Armor","SubType":"NULL"},
2565: {"Type":"Armor","SubType":"NULL"},
2566: {"Type":"Armor","SubType":"NULL"},
2567: {"Type":"Armor","SubType":"NULL"},
2568: {"Type":"Armor","SubType":"NULL"},
2569: {"Type":"Armor","SubType":"NULL"},
2570: {"Type":"Armor","SubType":"NULL"},
2571: {"Type":"Armor","SubType":"NULL"},
2572: {"Type":"Armor","SubType":"NULL"},
2573: {"Type":"Armor","SubType":"NULL"},
2574: {"Type":"Armor","SubType":"NULL"},
2575: {"Type":"Armor","SubType":"NULL"},
2576: {"Type":"Armor","SubType":"NULL"},
2577: {"Type":"Armor","SubType":"NULL"},
2578: {"Type":"Armor","SubType":"NULL"},
2579: {"Type":"Armor","SubType":"NULL"},
2580: {"Type":"Armor","SubType":"NULL"},
2581: {"Type":"Armor","SubType":"NULL"},
2582: {"Type":"Armor","SubType":"NULL"},
2583: {"Type":"Armor","SubType":"NULL"},
2584: {"Type":"Armor","SubType":"NULL"},
2585: {"Type":"Armor","SubType":"NULL"},
2586: {"Type":"Armor","SubType":"NULL"},
2587: {"Type":"Armor","SubType":"NULL"},
2588: {"Type":"Armor","SubType":"NULL"},
2589: {"Type":"Armor","SubType":"NULL"},
2590: {"Type":"Armor","SubType":"NULL"},
2591: {"Type":"Armor","SubType":"NULL"},
2592: {"Type":"Armor","SubType":"NULL"},
2593: {"Type":"Armor","SubType":"NULL"},
2594: {"Type":"Armor","SubType":"NULL"},
2595: {"Type":"Armor","SubType":"NULL"},
2596: {"Type":"Armor","SubType":"NULL"},
2597: {"Type":"Armor","SubType":"NULL"},
2598: {"Type":"Armor","SubType":"NULL"},
2599: {"Type":"Armor","SubType":"NULL"},
2601: {"Type":"Armor","SubType":"NULL"},
2602: {"Type":"Armor","SubType":"NULL"},
2603: {"Type":"Armor","SubType":"NULL"},
2604: {"Type":"Armor","SubType":"NULL"},
2605: {"Type":"Armor","SubType":"NULL"},
2606: {"Type":"Armor","SubType":"NULL"},
2607: {"Type":"Armor","SubType":"NULL"},
2608: {"Type":"Armor","SubType":"NULL"},
2609: {"Type":"Armor","SubType":"NULL"},
2610: {"Type":"Armor","SubType":"NULL"},
2611: {"Type":"Armor","SubType":"NULL"},
2612: {"Type":"Armor","SubType":"NULL"},
2613: {"Type":"Armor","SubType":"NULL"},
2614: {"Type":"Armor","SubType":"NULL"},
2615: {"Type":"Armor","SubType":"NULL"},
2616: {"Type":"Armor","SubType":"NULL"},
2617: {"Type":"Armor","SubType":"NULL"},
2618: {"Type":"Armor","SubType":"NULL"},
2619: {"Type":"Armor","SubType":"NULL"},
2620: {"Type":"Armor","SubType":"NULL"},
2621: {"Type":"Armor","SubType":"NULL"},
2622: {"Type":"Armor","SubType":"NULL"},
2623: {"Type":"Armor","SubType":"NULL"},
2624: {"Type":"Armor","SubType":"NULL"},
2625: {"Type":"Armor","SubType":"NULL"},
2626: {"Type":"Armor","SubType":"NULL"},
2627: {"Type":"Armor","SubType":"NULL"},
2628: {"Type":"Armor","SubType":"NULL"},
2629: {"Type":"Armor","SubType":"NULL"},
2630: {"Type":"Armor","SubType":"NULL"},
2631: {"Type":"Armor","SubType":"NULL"},
2632: {"Type":"Armor","SubType":"NULL"},
2633: {"Type":"Armor","SubType":"NULL"},
2634: {"Type":"Armor","SubType":"NULL"},
2635: {"Type":"Armor","SubType":"NULL"},
2636: {"Type":"Armor","SubType":"NULL"},
2637: {"Type":"Armor","SubType":"NULL"},
2638: {"Type":"Armor","SubType":"NULL"},
2639: {"Type":"Armor","SubType":"NULL"},
2640: {"Type":"Armor","SubType":"NULL"},
2641: {"Type":"Armor","SubType":"NULL"},
2642: {"Type":"Armor","SubType":"NULL"},
2643: {"Type":"Armor","SubType":"NULL"},
2644: {"Type":"Armor","SubType":"NULL"},
2645: {"Type":"Armor","SubType":"NULL"},
2646: {"Type":"Armor","SubType":"NULL"},
2647: {"Type":"Armor","SubType":"NULL"},
2648: {"Type":"Armor","SubType":"NULL"},
2649: {"Type":"Armor","SubType":"NULL"},
2650: {"Type":"Armor","SubType":"NULL"},
2651: {"Type":"Armor","SubType":"NULL"},
2652: {"Type":"Armor","SubType":"NULL"},
2653: {"Type":"Armor","SubType":"NULL"},
2654: {"Type":"Armor","SubType":"NULL"},
2655: {"Type":"Armor","SubType":"NULL"},
2656: {"Type":"Armor","SubType":"NULL"},
2657: {"Type":"Armor","SubType":"NULL"},
2658: {"Type":"Armor","SubType":"NULL"},
2659: {"Type":"Armor","SubType":"NULL"},
2660: {"Type":"Armor","SubType":"NULL"},
2661: {"Type":"Armor","SubType":"NULL"},
2662: {"Type":"Armor","SubType":"NULL"},
2663: {"Type":"Armor","SubType":"NULL"},
2664: {"Type":"Armor","SubType":"NULL"},
2665: {"Type":"Armor","SubType":"NULL"},
2666: {"Type":"Armor","SubType":"NULL"},
2667: {"Type":"Armor","SubType":"NULL"},
2668: {"Type":"Armor","SubType":"NULL"},
2669: {"Type":"Armor","SubType":"NULL"},
2670: {"Type":"Armor","SubType":"NULL"},
2671: {"Type":"Armor","SubType":"NULL"},
2672: {"Type":"Armor","SubType":"NULL"},
2673: {"Type":"Armor","SubType":"NULL"},
2674: {"Type":"Armor","SubType":"NULL"},
2675: {"Type":"Armor","SubType":"NULL"},
2676: {"Type":"Armor","SubType":"NULL"},
2677: {"Type":"Armor","SubType":"NULL"},
2678: {"Type":"Armor","SubType":"NULL"},
2679: {"Type":"Armor","SubType":"NULL"},
2680: {"Type":"Armor","SubType":"NULL"},
2681: {"Type":"Armor","SubType":"NULL"},
2682: {"Type":"Armor","SubType":"NULL"},
2683: {"Type":"Armor","SubType":"NULL"},
2684: {"Type":"Armor","SubType":"NULL"},
2685: {"Type":"Armor","SubType":"NULL"},
2686: {"Type":"Armor","SubType":"NULL"},
2687: {"Type":"Armor","SubType":"NULL"},
2688: {"Type":"Armor","SubType":"NULL"},
2689: {"Type":"Armor","SubType":"NULL"},
2690: {"Type":"Armor","SubType":"NULL"},
2691: {"Type":"Armor","SubType":"NULL"},
2692: {"Type":"Armor","SubType":"NULL"},
2693: {"Type":"Armor","SubType":"NULL"},
2694: {"Type":"Armor","SubType":"NULL"},
2695: {"Type":"Armor","SubType":"NULL"},
2696: {"Type":"Armor","SubType":"NULL"},
2697: {"Type":"Armor","SubType":"NULL"},
2698: {"Type":"Armor","SubType":"NULL"},
2699: {"Type":"Armor","SubType":"NULL"},
2700: {"Type":"Armor","SubType":"NULL"},
2701: {"Type":"Armor","SubType":"NULL"},
2702: {"Type":"Armor","SubType":"NULL"},
2703: {"Type":"Armor","SubType":"NULL"},
2704: {"Type":"Armor","SubType":"NULL"},
2705: {"Type":"Armor","SubType":"NULL"},
2706: {"Type":"Armor","SubType":"NULL"},
2707: {"Type":"Armor","SubType":"NULL"},
2708: {"Type":"Armor","SubType":"NULL"},
2709: {"Type":"Armor","SubType":"NULL"},
2710: {"Type":"Armor","SubType":"NULL"},
2711: {"Type":"Armor","SubType":"NULL"},
2712: {"Type":"Armor","SubType":"NULL"},
2713: {"Type":"Armor","SubType":"NULL"},
2714: {"Type":"Armor","SubType":"NULL"},
2715: {"Type":"Armor","SubType":"NULL"},
2716: {"Type":"Armor","SubType":"NULL"},
2717: {"Type":"Armor","SubType":"NULL"},
2718: {"Type":"Armor","SubType":"NULL"},
2719: {"Type":"Armor","SubType":"NULL"},
2720: {"Type":"Armor","SubType":"NULL"},
2721: {"Type":"Armor","SubType":"NULL"},
2722: {"Type":"Armor","SubType":"NULL"},
2723: {"Type":"Armor","SubType":"NULL"},
2724: {"Type":"Armor","SubType":"NULL"},
2725: {"Type":"Armor","SubType":"NULL"},
2726: {"Type":"Armor","SubType":"NULL"},
2727: {"Type":"Armor","SubType":"NULL"},
2728: {"Type":"Armor","SubType":"NULL"},
2729: {"Type":"Armor","SubType":"NULL"},
2730: {"Type":"Armor","SubType":"NULL"},
2731: {"Type":"Armor","SubType":"NULL"},
2732: {"Type":"Armor","SubType":"NULL"},
2733: {"Type":"Armor","SubType":"NULL"},
2734: {"Type":"Armor","SubType":"NULL"},
2735: {"Type":"Armor","SubType":"NULL"},
2736: {"Type":"Armor","SubType":"NULL"},
2737: {"Type":"Armor","SubType":"NULL"},
2738: {"Type":"Armor","SubType":"NULL"},
2739: {"Type":"Armor","SubType":"NULL"},
2740: {"Type":"Armor","SubType":"NULL"},
2741: {"Type":"Armor","SubType":"NULL"},
2742: {"Type":"Armor","SubType":"NULL"},
2743: {"Type":"Armor","SubType":"NULL"},
2744: {"Type":"Armor","SubType":"NULL"},
2745: {"Type":"Armor","SubType":"NULL"},
2746: {"Type":"Armor","SubType":"NULL"},
2747: {"Type":"Armor","SubType":"NULL"},
2748: {"Type":"Armor","SubType":"NULL"},
2749: {"Type":"Armor","SubType":"NULL"},
2750: {"Type":"Armor","SubType":"NULL"},
2751: {"Type":"Armor","SubType":"NULL"},
2752: {"Type":"Armor","SubType":"NULL"},
2753: {"Type":"Armor","SubType":"NULL"},
2754: {"Type":"Armor","SubType":"NULL"},
2755: {"Type":"Armor","SubType":"NULL"},
2756: {"Type":"Armor","SubType":"NULL"},
2757: {"Type":"Armor","SubType":"NULL"},
2758: {"Type":"Armor","SubType":"NULL"},
2759: {"Type":"Armor","SubType":"NULL"},
2760: {"Type":"Armor","SubType":"NULL"},
2761: {"Type":"Armor","SubType":"NULL"},
2762: {"Type":"Armor","SubType":"NULL"},
2763: {"Type":"Armor","SubType":"NULL"},
2764: {"Type":"Armor","SubType":"NULL"},
2765: {"Type":"Armor","SubType":"NULL"},
2766: {"Type":"Armor","SubType":"NULL"},
2767: {"Type":"Armor","SubType":"NULL"},
2768: {"Type":"Armor","SubType":"NULL"},
2769: {"Type":"Armor","SubType":"NULL"},
2770: {"Type":"Armor","SubType":"NULL"},
2771: {"Type":"Armor","SubType":"NULL"},
2772: {"Type":"Armor","SubType":"NULL"},
2773: {"Type":"Armor","SubType":"NULL"},
2774: {"Type":"Armor","SubType":"NULL"},
2775: {"Type":"Armor","SubType":"NULL"},
2776: {"Type":"Armor","SubType":"NULL"},
2777: {"Type":"Armor","SubType":"NULL"},
2778: {"Type":"Armor","SubType":"NULL"},
2779: {"Type":"Armor","SubType":"NULL"},
2780: {"Type":"Armor","SubType":"NULL"},
2781: {"Type":"Armor","SubType":"NULL"},
2782: {"Type":"Armor","SubType":"NULL"},
2783: {"Type":"Armor","SubType":"NULL"},
2784: {"Type":"Armor","SubType":"NULL"},
2785: {"Type":"Armor","SubType":"NULL"},
2786: {"Type":"Armor","SubType":"NULL"},
2787: {"Type":"Armor","SubType":"NULL"},
2788: {"Type":"Armor","SubType":"NULL"},
2789: {"Type":"Armor","SubType":"NULL"},
2790: {"Type":"Armor","SubType":"NULL"},
2791: {"Type":"Armor","SubType":"NULL"},
2792: {"Type":"Armor","SubType":"NULL"},
2793: {"Type":"Armor","SubType":"NULL"},
2794: {"Type":"Armor","SubType":"NULL"},
2795: {"Type":"Armor","SubType":"NULL"},
2796: {"Type":"Armor","SubType":"NULL"},
2797: {"Type":"Armor","SubType":"NULL"},
2798: {"Type":"Armor","SubType":"NULL"},
2799: {"Type":"Armor","SubType":"NULL"},
2800: {"Type":"Armor","SubType":"NULL"},
2801: {"Type":"Armor","SubType":"NULL"},
2802: {"Type":"Armor","SubType":"NULL"},
2803: {"Type":"Armor","SubType":"NULL"},
2804: {"Type":"Armor","SubType":"NULL"},
2805: {"Type":"Armor","SubType":"NULL"},
2806: {"Type":"Armor","SubType":"NULL"},
2807: {"Type":"Armor","SubType":"NULL"},
2808: {"Type":"Armor","SubType":"NULL"},
2809: {"Type":"Armor","SubType":"NULL"},
2810: {"Type":"Armor","SubType":"NULL"},
2811: {"Type":"Armor","SubType":"NULL"},
2812: {"Type":"Armor","SubType":"NULL"},
2813: {"Type":"Armor","SubType":"NULL"},
2814: {"Type":"Armor","SubType":"NULL"},
2815: {"Type":"Armor","SubType":"NULL"},
2816: {"Type":"Armor","SubType":"NULL"},
2817: {"Type":"Armor","SubType":"NULL"},
2818: {"Type":"Armor","SubType":"NULL"},
2819: {"Type":"Armor","SubType":"NULL"},
2820: {"Type":"Armor","SubType":"NULL"},
2821: {"Type":"Armor","SubType":"NULL"},
2822: {"Type":"Armor","SubType":"NULL"},
2823: {"Type":"Armor","SubType":"NULL"},
2824: {"Type":"Armor","SubType":"NULL"},
2825: {"Type":"Armor","SubType":"NULL"},
2826: {"Type":"Armor","SubType":"NULL"},
2827: {"Type":"Armor","SubType":"NULL"},
2828: {"Type":"Armor","SubType":"NULL"},
2829: {"Type":"Armor","SubType":"NULL"},
2830: {"Type":"Armor","SubType":"NULL"},
2831: {"Type":"Armor","SubType":"NULL"},
2832: {"Type":"Armor","SubType":"NULL"},
2833: {"Type":"Armor","SubType":"NULL"},
2834: {"Type":"Armor","SubType":"NULL"},
2835: {"Type":"Armor","SubType":"NULL"},
2836: {"Type":"Armor","SubType":"NULL"},
2837: {"Type":"Armor","SubType":"NULL"},
2838: {"Type":"Armor","SubType":"NULL"},
2839: {"Type":"Armor","SubType":"NULL"},
2840: {"Type":"Armor","SubType":"NULL"},
2841: {"Type":"Armor","SubType":"NULL"},
2842: {"Type":"Armor","SubType":"NULL"},
2843: {"Type":"Armor","SubType":"NULL"},
2844: {"Type":"Armor","SubType":"NULL"},
2845: {"Type":"Armor","SubType":"NULL"},
2846: {"Type":"Armor","SubType":"NULL"},
2847: {"Type":"Armor","SubType":"NULL"},
2848: {"Type":"Armor","SubType":"NULL"},
2849: {"Type":"Armor","SubType":"NULL"},
2850: {"Type":"Armor","SubType":"NULL"},
2851: {"Type":"Armor","SubType":"NULL"},
2852: {"Type":"Armor","SubType":"NULL"},
2853: {"Type":"Armor","SubType":"NULL"},
2854: {"Type":"Armor","SubType":"NULL"},
2855: {"Type":"Armor","SubType":"NULL"},
2856: {"Type":"Armor","SubType":"NULL"},
2857: {"Type":"Armor","SubType":"NULL"},
2858: {"Type":"Armor","SubType":"NULL"},
2859: {"Type":"Armor","SubType":"NULL"},
2860: {"Type":"Armor","SubType":"NULL"},
2861: {"Type":"Armor","SubType":"NULL"},
2862: {"Type":"Armor","SubType":"NULL"},
2863: {"Type":"Armor","SubType":"NULL"},
2864: {"Type":"Armor","SubType":"NULL"},
2865: {"Type":"Armor","SubType":"NULL"},
2866: {"Type":"Armor","SubType":"NULL"},
2867: {"Type":"Armor","SubType":"NULL"},
2868: {"Type":"Armor","SubType":"NULL"},
2869: {"Type":"Armor","SubType":"NULL"},
2870: {"Type":"Armor","SubType":"NULL"},
2871: {"Type":"Armor","SubType":"NULL"},
2872: {"Type":"Armor","SubType":"NULL"},
2873: {"Type":"Armor","SubType":"NULL"},
2874: {"Type":"Armor","SubType":"NULL"},
2875: {"Type":"Armor","SubType":"NULL"},
2876: {"Type":"Armor","SubType":"NULL"},
2877: {"Type":"Armor","SubType":"NULL"},
2878: {"Type":"Armor","SubType":"NULL"},
2879: {"Type":"Armor","SubType":"NULL"},
2880: {"Type":"Armor","SubType":"NULL"},
2881: {"Type":"Armor","SubType":"NULL"},
2882: {"Type":"Armor","SubType":"NULL"},
2883: {"Type":"Armor","SubType":"NULL"},
2884: {"Type":"Armor","SubType":"NULL"},
2885: {"Type":"Armor","SubType":"NULL"},
2886: {"Type":"Armor","SubType":"NULL"},
2887: {"Type":"Armor","SubType":"NULL"},
2888: {"Type":"Armor","SubType":"NULL"},
2889: {"Type":"Armor","SubType":"NULL"},
2890: {"Type":"Armor","SubType":"NULL"},
2891: {"Type":"Armor","SubType":"NULL"},
2892: {"Type":"Armor","SubType":"NULL"},
2893: {"Type":"Armor","SubType":"NULL"},
2894: {"Type":"Armor","SubType":"NULL"},
2895: {"Type":"Armor","SubType":"NULL"},
2896: {"Type":"Armor","SubType":"NULL"},
2897: {"Type":"Armor","SubType":"NULL"},
2898: {"Type":"Armor","SubType":"NULL"},
2899: {"Type":"Armor","SubType":"NULL"},
2900: {"Type":"Armor","SubType":"NULL"},
2901: {"Type":"Armor","SubType":"NULL"},
2902: {"Type":"Armor","SubType":"NULL"},
2903: {"Type":"Armor","SubType":"NULL"},
2904: {"Type":"Armor","SubType":"NULL"},
2905: {"Type":"Armor","SubType":"NULL"},
2906: {"Type":"Armor","SubType":"NULL"},
2907: {"Type":"Armor","SubType":"NULL"},
2908: {"Type":"Armor","SubType":"NULL"},
2909: {"Type":"Armor","SubType":"NULL"},
2910: {"Type":"Armor","SubType":"NULL"},
2911: {"Type":"Armor","SubType":"NULL"},
2912: {"Type":"Armor","SubType":"NULL"},
2913: {"Type":"Armor","SubType":"NULL"},
2914: {"Type":"Armor","SubType":"NULL"},
2915: {"Type":"Armor","SubType":"NULL"},
2916: {"Type":"Armor","SubType":"NULL"},
2917: {"Type":"Armor","SubType":"NULL"},
2918: {"Type":"Armor","SubType":"NULL"},
2919: {"Type":"Armor","SubType":"NULL"},
2920: {"Type":"Armor","SubType":"NULL"},
2921: {"Type":"Armor","SubType":"NULL"},
2922: {"Type":"Armor","SubType":"NULL"},
2923: {"Type":"Armor","SubType":"NULL"},
2924: {"Type":"Armor","SubType":"NULL"},
2925: {"Type":"Armor","SubType":"NULL"},
2926: {"Type":"Armor","SubType":"NULL"},
2927: {"Type":"Armor","SubType":"NULL"},
2928: {"Type":"Armor","SubType":"NULL"},
2929: {"Type":"Armor","SubType":"NULL"},
2930: {"Type":"Armor","SubType":"NULL"},
2931: {"Type":"Armor","SubType":"NULL"},
2932: {"Type":"Armor","SubType":"NULL"},
2933: {"Type":"Armor","SubType":"NULL"},
2934: {"Type":"Armor","SubType":"NULL"},
2935: {"Type":"Armor","SubType":"NULL"},
2936: {"Type":"Armor","SubType":"NULL"},
2937: {"Type":"Armor","SubType":"NULL"},
2938: {"Type":"Armor","SubType":"NULL"},
2939: {"Type":"Armor","SubType":"NULL"},
2940: {"Type":"Armor","SubType":"NULL"},
2941: {"Type":"Armor","SubType":"NULL"},
2942: {"Type":"Armor","SubType":"NULL"},
2943: {"Type":"Armor","SubType":"NULL"},
2944: {"Type":"Armor","SubType":"NULL"},
2945: {"Type":"Armor","SubType":"NULL"},
2946: {"Type":"Armor","SubType":"NULL"},
2947: {"Type":"Armor","SubType":"NULL"},
2948: {"Type":"Armor","SubType":"NULL"},
2949: {"Type":"Armor","SubType":"NULL"},
2950: {"Type":"Armor","SubType":"NULL"},
2951: {"Type":"Armor","SubType":"NULL"},
2952: {"Type":"Armor","SubType":"NULL"},
2953: {"Type":"Armor","SubType":"NULL"},
2954: {"Type":"Armor","SubType":"NULL"},
2955: {"Type":"Armor","SubType":"NULL"},
2956: {"Type":"Armor","SubType":"NULL"},
2957: {"Type":"Armor","SubType":"NULL"},
2958: {"Type":"Armor","SubType":"NULL"},
2959: {"Type":"Armor","SubType":"NULL"},
2960: {"Type":"Armor","SubType":"NULL"},
2961: {"Type":"Armor","SubType":"NULL"},
2962: {"Type":"Armor","SubType":"NULL"},
2963: {"Type":"Armor","SubType":"NULL"},
2964: {"Type":"Armor","SubType":"NULL"},
2965: {"Type":"Armor","SubType":"NULL"},
2966: {"Type":"Armor","SubType":"NULL"},
2967: {"Type":"Armor","SubType":"NULL"},
2968: {"Type":"Armor","SubType":"NULL"},
2969: {"Type":"Armor","SubType":"NULL"},
2970: {"Type":"Armor","SubType":"NULL"},
2971: {"Type":"Armor","SubType":"NULL"},
2974: {"Type":"Armor","SubType":"NULL"},
2975: {"Type":"Armor","SubType":"NULL"},
2976: {"Type":"Armor","SubType":"NULL"},
2977: {"Type":"Armor","SubType":"NULL"},
2978: {"Type":"Armor","SubType":"NULL"},
2979: {"Type":"Armor","SubType":"NULL"},
2980: {"Type":"Armor","SubType":"NULL"},
2981: {"Type":"Armor","SubType":"NULL"},
2982: {"Type":"Armor","SubType":"NULL"},
2983: {"Type":"Armor","SubType":"NULL"},
2984: {"Type":"Armor","SubType":"NULL"},
2985: {"Type":"Armor","SubType":"NULL"},
2986: {"Type":"Armor","SubType":"NULL"},
2987: {"Type":"Armor","SubType":"NULL"},
2988: {"Type":"Armor","SubType":"NULL"},
2989: {"Type":"Armor","SubType":"NULL"},
2990: {"Type":"Armor","SubType":"NULL"},
2991: {"Type":"Armor","SubType":"NULL"},
2992: {"Type":"Armor","SubType":"NULL"},
2993: {"Type":"Armor","SubType":"NULL"},
2994: {"Type":"Armor","SubType":"NULL"},
2995: {"Type":"Armor","SubType":"NULL"},
2996: {"Type":"Armor","SubType":"NULL"},
2997: {"Type":"Armor","SubType":"NULL"},
2998: {"Type":"Armor","SubType":"NULL"},
2999: {"Type":"Armor","SubType":"NULL"},
4001: {"Type":"Card","SubType":"NULL"},
4002: {"Type":"Card","SubType":"NULL"},
4003: {"Type":"Card","SubType":"NULL"},
4004: {"Type":"Card","SubType":"NULL"},
4005: {"Type":"Card","SubType":"NULL"},
4006: {"Type":"Card","SubType":"NULL"},
4007: {"Type":"Card","SubType":"NULL"},
4008: {"Type":"Card","SubType":"NULL"},
4009: {"Type":"Card","SubType":"NULL"},
4010: {"Type":"Card","SubType":"NULL"},
4011: {"Type":"Card","SubType":"NULL"},
4012: {"Type":"Card","SubType":"NULL"},
4013: {"Type":"Card","SubType":"NULL"},
4014: {"Type":"Card","SubType":"NULL"},
4015: {"Type":"Card","SubType":"NULL"},
4016: {"Type":"Card","SubType":"NULL"},
4017: {"Type":"Card","SubType":"NULL"},
4018: {"Type":"Card","SubType":"NULL"},
4019: {"Type":"Card","SubType":"NULL"},
4020: {"Type":"Card","SubType":"NULL"},
4021: {"Type":"Card","SubType":"NULL"},
4022: {"Type":"Card","SubType":"NULL"},
4023: {"Type":"Card","SubType":"NULL"},
4024: {"Type":"Card","SubType":"NULL"},
4025: {"Type":"Card","SubType":"NULL"},
4026: {"Type":"Card","SubType":"NULL"},
4027: {"Type":"Card","SubType":"NULL"},
4028: {"Type":"Card","SubType":"NULL"},
4029: {"Type":"Card","SubType":"NULL"},
4030: {"Type":"Card","SubType":"NULL"},
4031: {"Type":"Card","SubType":"NULL"},
4032: {"Type":"Card","SubType":"NULL"},
4033: {"Type":"Card","SubType":"NULL"},
4034: {"Type":"Card","SubType":"NULL"},
4035: {"Type":"Card","SubType":"NULL"},
4036: {"Type":"Card","SubType":"NULL"},
4037: {"Type":"Card","SubType":"NULL"},
4038: {"Type":"Card","SubType":"NULL"},
4039: {"Type":"Card","SubType":"NULL"},
4040: {"Type":"Card","SubType":"NULL"},
4041: {"Type":"Card","SubType":"NULL"},
4042: {"Type":"Card","SubType":"NULL"},
4043: {"Type":"Card","SubType":"NULL"},
4044: {"Type":"Card","SubType":"NULL"},
4045: {"Type":"Card","SubType":"NULL"},
4046: {"Type":"Card","SubType":"NULL"},
4047: {"Type":"Card","SubType":"NULL"},
4048: {"Type":"Card","SubType":"NULL"},
4049: {"Type":"Card","SubType":"NULL"},
4050: {"Type":"Card","SubType":"NULL"},
4051: {"Type":"Card","SubType":"NULL"},
4052: {"Type":"Card","SubType":"NULL"},
4053: {"Type":"Card","SubType":"NULL"},
4054: {"Type":"Card","SubType":"NULL"},
4055: {"Type":"Card","SubType":"NULL"},
4056: {"Type":"Card","SubType":"NULL"},
4057: {"Type":"Card","SubType":"NULL"},
4058: {"Type":"Card","SubType":"NULL"},
4059: {"Type":"Card","SubType":"NULL"},
4060: {"Type":"Card","SubType":"NULL"},
4061: {"Type":"Card","SubType":"NULL"},
4062: {"Type":"Card","SubType":"NULL"},
4063: {"Type":"Card","SubType":"NULL"},
4064: {"Type":"Card","SubType":"NULL"},
4065: {"Type":"Card","SubType":"NULL"},
4066: {"Type":"Card","SubType":"NULL"},
4067: {"Type":"Card","SubType":"NULL"},
4068: {"Type":"Card","SubType":"NULL"},
4069: {"Type":"Card","SubType":"NULL"},
4070: {"Type":"Card","SubType":"NULL"},
4071: {"Type":"Card","SubType":"NULL"},
4072: {"Type":"Card","SubType":"NULL"},
4073: {"Type":"Card","SubType":"NULL"},
4074: {"Type":"Card","SubType":"NULL"},
4075: {"Type":"Card","SubType":"NULL"},
4076: {"Type":"Card","SubType":"NULL"},
4077: {"Type":"Card","SubType":"NULL"},
4078: {"Type":"Card","SubType":"NULL"},
4079: {"Type":"Card","SubType":"NULL"},
4080: {"Type":"Card","SubType":"NULL"},
4081: {"Type":"Card","SubType":"NULL"},
4082: {"Type":"Card","SubType":"NULL"},
4083: {"Type":"Card","SubType":"NULL"},
4084: {"Type":"Card","SubType":"NULL"},
4085: {"Type":"Card","SubType":"NULL"},
4086: {"Type":"Card","SubType":"NULL"},
4087: {"Type":"Card","SubType":"NULL"},
4088: {"Type":"Card","SubType":"NULL"},
4089: {"Type":"Card","SubType":"NULL"},
4090: {"Type":"Card","SubType":"NULL"},
4091: {"Type":"Card","SubType":"NULL"},
4092: {"Type":"Card","SubType":"NULL"},
4093: {"Type":"Card","SubType":"NULL"},
4094: {"Type":"Card","SubType":"NULL"},
4095: {"Type":"Card","SubType":"NULL"},
4096: {"Type":"Card","SubType":"NULL"},
4097: {"Type":"Card","SubType":"NULL"},
4098: {"Type":"Card","SubType":"NULL"},
4099: {"Type":"Card","SubType":"NULL"},
4100: {"Type":"Card","SubType":"NULL"},
4101: {"Type":"Card","SubType":"NULL"},
4102: {"Type":"Card","SubType":"NULL"},
4103: {"Type":"Card","SubType":"NULL"},
4104: {"Type":"Card","SubType":"NULL"},
4105: {"Type":"Card","SubType":"NULL"},
4106: {"Type":"Card","SubType":"NULL"},
4107: {"Type":"Card","SubType":"NULL"},
4108: {"Type":"Card","SubType":"NULL"},
4109: {"Type":"Card","SubType":"NULL"},
4110: {"Type":"Card","SubType":"NULL"},
4111: {"Type":"Card","SubType":"NULL"},
4112: {"Type":"Card","SubType":"NULL"},
4113: {"Type":"Card","SubType":"NULL"},
4114: {"Type":"Card","SubType":"NULL"},
4115: {"Type":"Card","SubType":"NULL"},
4116: {"Type":"Card","SubType":"NULL"},
4117: {"Type":"Card","SubType":"NULL"},
4118: {"Type":"Card","SubType":"NULL"},
4119: {"Type":"Card","SubType":"NULL"},
4120: {"Type":"Card","SubType":"NULL"},
4121: {"Type":"Card","SubType":"NULL"},
4122: {"Type":"Card","SubType":"NULL"},
4123: {"Type":"Card","SubType":"NULL"},
4124: {"Type":"Card","SubType":"NULL"},
4125: {"Type":"Card","SubType":"NULL"},
4126: {"Type":"Card","SubType":"NULL"},
4127: {"Type":"Card","SubType":"NULL"},
4128: {"Type":"Card","SubType":"NULL"},
4129: {"Type":"Card","SubType":"NULL"},
4130: {"Type":"Card","SubType":"NULL"},
4131: {"Type":"Card","SubType":"NULL"},
4132: {"Type":"Card","SubType":"NULL"},
4133: {"Type":"Card","SubType":"NULL"},
4134: {"Type":"Card","SubType":"NULL"},
4135: {"Type":"Card","SubType":"NULL"},
4136: {"Type":"Card","SubType":"NULL"},
4137: {"Type":"Card","SubType":"NULL"},
4138: {"Type":"Card","SubType":"NULL"},
4139: {"Type":"Card","SubType":"NULL"},
4140: {"Type":"Card","SubType":"NULL"},
4141: {"Type":"Card","SubType":"NULL"},
4142: {"Type":"Card","SubType":"NULL"},
4143: {"Type":"Card","SubType":"NULL"},
4144: {"Type":"Card","SubType":"NULL"},
4145: {"Type":"Card","SubType":"NULL"},
4146: {"Type":"Card","SubType":"NULL"},
4147: {"Type":"Card","SubType":"NULL"},
4148: {"Type":"Card","SubType":"NULL"},
4149: {"Type":"Card","SubType":"NULL"},
4150: {"Type":"Card","SubType":"NULL"},
4151: {"Type":"Card","SubType":"NULL"},
4152: {"Type":"Card","SubType":"NULL"},
4153: {"Type":"Card","SubType":"NULL"},
4154: {"Type":"Card","SubType":"NULL"},
4155: {"Type":"Card","SubType":"NULL"},
4156: {"Type":"Card","SubType":"NULL"},
4157: {"Type":"Card","SubType":"NULL"},
4158: {"Type":"Card","SubType":"NULL"},
4159: {"Type":"Card","SubType":"NULL"},
4160: {"Type":"Card","SubType":"NULL"},
4161: {"Type":"Card","SubType":"NULL"},
4162: {"Type":"Card","SubType":"NULL"},
4163: {"Type":"Card","SubType":"NULL"},
4164: {"Type":"Card","SubType":"NULL"},
4165: {"Type":"Card","SubType":"NULL"},
4166: {"Type":"Card","SubType":"NULL"},
4167: {"Type":"Card","SubType":"NULL"},
4168: {"Type":"Card","SubType":"NULL"},
4169: {"Type":"Card","SubType":"NULL"},
4170: {"Type":"Card","SubType":"NULL"},
4171: {"Type":"Card","SubType":"NULL"},
4172: {"Type":"Card","SubType":"NULL"},
4173: {"Type":"Card","SubType":"NULL"},
4174: {"Type":"Card","SubType":"NULL"},
4175: {"Type":"Card","SubType":"NULL"},
4176: {"Type":"Card","SubType":"NULL"},
4177: {"Type":"Card","SubType":"NULL"},
4178: {"Type":"Card","SubType":"NULL"},
4179: {"Type":"Card","SubType":"NULL"},
4180: {"Type":"Card","SubType":"NULL"},
4181: {"Type":"Card","SubType":"NULL"},
4182: {"Type":"Card","SubType":"NULL"},
4183: {"Type":"Card","SubType":"NULL"},
4184: {"Type":"Card","SubType":"NULL"},
4185: {"Type":"Card","SubType":"NULL"},
4186: {"Type":"Card","SubType":"NULL"},
4187: {"Type":"Card","SubType":"NULL"},
4188: {"Type":"Card","SubType":"NULL"},
4189: {"Type":"Card","SubType":"NULL"},
4190: {"Type":"Card","SubType":"NULL"},
4191: {"Type":"Card","SubType":"NULL"},
4192: {"Type":"Card","SubType":"NULL"},
4193: {"Type":"Card","SubType":"NULL"},
4194: {"Type":"Card","SubType":"NULL"},
4195: {"Type":"Card","SubType":"NULL"},
4196: {"Type":"Card","SubType":"NULL"},
4197: {"Type":"Card","SubType":"NULL"},
4198: {"Type":"Card","SubType":"NULL"},
4199: {"Type":"Card","SubType":"NULL"},
4200: {"Type":"Card","SubType":"NULL"},
4201: {"Type":"Card","SubType":"NULL"},
4202: {"Type":"Card","SubType":"NULL"},
4203: {"Type":"Card","SubType":"NULL"},
4204: {"Type":"Card","SubType":"NULL"},
4205: {"Type":"Card","SubType":"NULL"},
4206: {"Type":"Card","SubType":"NULL"},
4207: {"Type":"Card","SubType":"NULL"},
4208: {"Type":"Card","SubType":"NULL"},
4209: {"Type":"Card","SubType":"NULL"},
4210: {"Type":"Card","SubType":"NULL"},
4211: {"Type":"Card","SubType":"NULL"},
4212: {"Type":"Card","SubType":"NULL"},
4213: {"Type":"Card","SubType":"NULL"},
4214: {"Type":"Card","SubType":"NULL"},
4215: {"Type":"Card","SubType":"NULL"},
4216: {"Type":"Card","SubType":"NULL"},
4217: {"Type":"Card","SubType":"NULL"},
4218: {"Type":"Card","SubType":"NULL"},
4219: {"Type":"Card","SubType":"NULL"},
4220: {"Type":"Card","SubType":"NULL"},
4221: {"Type":"Card","SubType":"NULL"},
4222: {"Type":"Card","SubType":"NULL"},
4223: {"Type":"Card","SubType":"NULL"},
4224: {"Type":"Card","SubType":"NULL"},
4225: {"Type":"Card","SubType":"NULL"},
4226: {"Type":"Card","SubType":"NULL"},
4227: {"Type":"Card","SubType":"NULL"},
4228: {"Type":"Card","SubType":"NULL"},
4229: {"Type":"Card","SubType":"NULL"},
4230: {"Type":"Card","SubType":"NULL"},
4231: {"Type":"Card","SubType":"NULL"},
4232: {"Type":"Card","SubType":"NULL"},
4233: {"Type":"Card","SubType":"NULL"},
4234: {"Type":"Card","SubType":"NULL"},
4235: {"Type":"Card","SubType":"NULL"},
4236: {"Type":"Card","SubType":"NULL"},
4237: {"Type":"Card","SubType":"NULL"},
4238: {"Type":"Card","SubType":"NULL"},
4239: {"Type":"Card","SubType":"NULL"},
4240: {"Type":"Card","SubType":"NULL"},
4241: {"Type":"Card","SubType":"NULL"},
4242: {"Type":"Card","SubType":"NULL"},
4243: {"Type":"Card","SubType":"NULL"},
4244: {"Type":"Card","SubType":"NULL"},
4245: {"Type":"Card","SubType":"NULL"},
4246: {"Type":"Card","SubType":"NULL"},
4247: {"Type":"Card","SubType":"NULL"},
4248: {"Type":"Card","SubType":"NULL"},
4249: {"Type":"Card","SubType":"NULL"},
4250: {"Type":"Card","SubType":"NULL"},
4251: {"Type":"Card","SubType":"NULL"},
4252: {"Type":"Card","SubType":"NULL"},
4253: {"Type":"Card","SubType":"NULL"},
4254: {"Type":"Card","SubType":"NULL"},
4255: {"Type":"Card","SubType":"NULL"},
4256: {"Type":"Card","SubType":"NULL"},
4257: {"Type":"Card","SubType":"NULL"},
4258: {"Type":"Card","SubType":"NULL"},
4259: {"Type":"Card","SubType":"NULL"},
4260: {"Type":"Card","SubType":"NULL"},
4261: {"Type":"Card","SubType":"NULL"},
4262: {"Type":"Card","SubType":"NULL"},
4263: {"Type":"Card","SubType":"NULL"},
4264: {"Type":"Card","SubType":"NULL"},
4265: {"Type":"Card","SubType":"NULL"},
4266: {"Type":"Card","SubType":"NULL"},
4267: {"Type":"Card","SubType":"NULL"},
4268: {"Type":"Card","SubType":"NULL"},
4269: {"Type":"Card","SubType":"NULL"},
4270: {"Type":"Card","SubType":"NULL"},
4271: {"Type":"Card","SubType":"NULL"},
4272: {"Type":"Card","SubType":"NULL"},
4273: {"Type":"Card","SubType":"NULL"},
4274: {"Type":"Card","SubType":"NULL"},
4275: {"Type":"Card","SubType":"NULL"},
4276: {"Type":"Card","SubType":"NULL"},
4277: {"Type":"Card","SubType":"NULL"},
4278: {"Type":"Card","SubType":"NULL"},
4279: {"Type":"Card","SubType":"NULL"},
4280: {"Type":"Card","SubType":"NULL"},
4281: {"Type":"Card","SubType":"NULL"},
4282: {"Type":"Card","SubType":"NULL"},
4283: {"Type":"Card","SubType":"NULL"},
4284: {"Type":"Card","SubType":"NULL"},
4285: {"Type":"Card","SubType":"NULL"},
4286: {"Type":"Card","SubType":"NULL"},
4287: {"Type":"Card","SubType":"NULL"},
4288: {"Type":"Card","SubType":"NULL"},
4289: {"Type":"Card","SubType":"NULL"},
4290: {"Type":"Card","SubType":"NULL"},
4291: {"Type":"Card","SubType":"NULL"},
4292: {"Type":"Card","SubType":"NULL"},
4293: {"Type":"Card","SubType":"NULL"},
4294: {"Type":"Card","SubType":"NULL"},
4295: {"Type":"Card","SubType":"NULL"},
4296: {"Type":"Card","SubType":"NULL"},
4297: {"Type":"Card","SubType":"NULL"},
4298: {"Type":"Card","SubType":"NULL"},
4299: {"Type":"Card","SubType":"NULL"},
4300: {"Type":"Card","SubType":"NULL"},
4301: {"Type":"Card","SubType":"NULL"},
4302: {"Type":"Card","SubType":"NULL"},
4303: {"Type":"Card","SubType":"NULL"},
4304: {"Type":"Card","SubType":"NULL"},
4305: {"Type":"Card","SubType":"NULL"},
4306: {"Type":"Card","SubType":"NULL"},
4307: {"Type":"Card","SubType":"NULL"},
4308: {"Type":"Card","SubType":"NULL"},
4309: {"Type":"Card","SubType":"NULL"},
4310: {"Type":"Card","SubType":"NULL"},
4311: {"Type":"Card","SubType":"NULL"},
4312: {"Type":"Card","SubType":"NULL"},
4313: {"Type":"Card","SubType":"NULL"},
4314: {"Type":"Card","SubType":"NULL"},
4315: {"Type":"Card","SubType":"NULL"},
4316: {"Type":"Card","SubType":"NULL"},
4317: {"Type":"Card","SubType":"NULL"},
4318: {"Type":"Card","SubType":"NULL"},
4319: {"Type":"Card","SubType":"NULL"},
4320: {"Type":"Card","SubType":"NULL"},
4321: {"Type":"Card","SubType":"NULL"},
4322: {"Type":"Card","SubType":"NULL"},
4323: {"Type":"Card","SubType":"NULL"},
4324: {"Type":"Card","SubType":"NULL"},
4325: {"Type":"Card","SubType":"NULL"},
4326: {"Type":"Card","SubType":"NULL"},
4327: {"Type":"Card","SubType":"NULL"},
4328: {"Type":"Card","SubType":"NULL"},
4329: {"Type":"Card","SubType":"NULL"},
4330: {"Type":"Card","SubType":"NULL"},
4331: {"Type":"Card","SubType":"NULL"},
4332: {"Type":"Card","SubType":"NULL"},
4333: {"Type":"Card","SubType":"NULL"},
4334: {"Type":"Card","SubType":"NULL"},
4335: {"Type":"Card","SubType":"NULL"},
4336: {"Type":"Card","SubType":"NULL"},
4337: {"Type":"Card","SubType":"NULL"},
4338: {"Type":"Card","SubType":"NULL"},
4339: {"Type":"Card","SubType":"NULL"},
4340: {"Type":"Card","SubType":"NULL"},
4341: {"Type":"Card","SubType":"NULL"},
4342: {"Type":"Card","SubType":"NULL"},
4343: {"Type":"Card","SubType":"NULL"},
4344: {"Type":"Card","SubType":"NULL"},
4345: {"Type":"Card","SubType":"NULL"},
4346: {"Type":"Card","SubType":"NULL"},
4347: {"Type":"Card","SubType":"NULL"},
4348: {"Type":"Card","SubType":"NULL"},
4349: {"Type":"Card","SubType":"NULL"},
4350: {"Type":"Card","SubType":"NULL"},
4351: {"Type":"Card","SubType":"NULL"},
4352: {"Type":"Card","SubType":"NULL"},
4353: {"Type":"Card","SubType":"NULL"},
4354: {"Type":"Card","SubType":"NULL"},
4355: {"Type":"Card","SubType":"NULL"},
4356: {"Type":"Card","SubType":"NULL"},
4357: {"Type":"Card","SubType":"NULL"},
4358: {"Type":"Card","SubType":"NULL"},
4359: {"Type":"Card","SubType":"NULL"},
4360: {"Type":"Card","SubType":"NULL"},
4361: {"Type":"Card","SubType":"NULL"},
4362: {"Type":"Card","SubType":"NULL"},
4363: {"Type":"Card","SubType":"NULL"},
4364: {"Type":"Card","SubType":"NULL"},
4365: {"Type":"Card","SubType":"NULL"},
4366: {"Type":"Card","SubType":"NULL"},
4367: {"Type":"Card","SubType":"NULL"},
4368: {"Type":"Card","SubType":"NULL"},
4369: {"Type":"Card","SubType":"NULL"},
4370: {"Type":"Card","SubType":"NULL"},
4371: {"Type":"Card","SubType":"NULL"},
4372: {"Type":"Card","SubType":"NULL"},
4373: {"Type":"Card","SubType":"NULL"},
4374: {"Type":"Card","SubType":"NULL"},
4375: {"Type":"Card","SubType":"NULL"},
4376: {"Type":"Card","SubType":"NULL"},
4377: {"Type":"Card","SubType":"NULL"},
4378: {"Type":"Card","SubType":"NULL"},
4379: {"Type":"Card","SubType":"NULL"},
4380: {"Type":"Card","SubType":"NULL"},
4381: {"Type":"Card","SubType":"NULL"},
4382: {"Type":"Card","SubType":"NULL"},
4383: {"Type":"Card","SubType":"NULL"},
4384: {"Type":"Card","SubType":"NULL"},
4385: {"Type":"Card","SubType":"NULL"},
4386: {"Type":"Card","SubType":"NULL"},
4387: {"Type":"Card","SubType":"NULL"},
4388: {"Type":"Card","SubType":"NULL"},
4389: {"Type":"Card","SubType":"NULL"},
4390: {"Type":"Card","SubType":"NULL"},
4391: {"Type":"Card","SubType":"NULL"},
4392: {"Type":"Card","SubType":"NULL"},
4393: {"Type":"Card","SubType":"NULL"},
4394: {"Type":"Card","SubType":"NULL"},
4395: {"Type":"Card","SubType":"NULL"},
4396: {"Type":"Card","SubType":"NULL"},
4397: {"Type":"Card","SubType":"NULL"},
4398: {"Type":"Card","SubType":"NULL"},
4399: {"Type":"Card","SubType":"NULL"},
4400: {"Type":"Card","SubType":"NULL"},
4401: {"Type":"Card","SubType":"NULL"},
4402: {"Type":"Card","SubType":"NULL"},
4403: {"Type":"Card","SubType":"NULL"},
4404: {"Type":"Card","SubType":"NULL"},
4405: {"Type":"Card","SubType":"NULL"},
4406: {"Type":"Card","SubType":"NULL"},
4407: {"Type":"Card","SubType":"NULL"},
4408: {"Type":"Card","SubType":"NULL"},
4409: {"Type":"Card","SubType":"NULL"},
4410: {"Type":"Card","SubType":"NULL"},
4411: {"Type":"Card","SubType":"NULL"},
4412: {"Type":"Card","SubType":"NULL"},
4413: {"Type":"Card","SubType":"NULL"},
4414: {"Type":"Card","SubType":"NULL"},
4415: {"Type":"Card","SubType":"NULL"},
4416: {"Type":"Card","SubType":"NULL"},
4417: {"Type":"Card","SubType":"NULL"},
4418: {"Type":"Card","SubType":"NULL"},
4419: {"Type":"Card","SubType":"NULL"},
4420: {"Type":"Card","SubType":"NULL"},
4421: {"Type":"Card","SubType":"NULL"},
4422: {"Type":"Card","SubType":"NULL"},
4423: {"Type":"Card","SubType":"NULL"},
4424: {"Type":"Card","SubType":"NULL"},
4425: {"Type":"Card","SubType":"NULL"},
4426: {"Type":"Card","SubType":"NULL"},
4427: {"Type":"Card","SubType":"NULL"},
4428: {"Type":"Card","SubType":"NULL"},
4429: {"Type":"Card","SubType":"NULL"},
4430: {"Type":"Card","SubType":"NULL"},
4431: {"Type":"Card","SubType":"NULL"},
4432: {"Type":"Card","SubType":"NULL"},
4433: {"Type":"Card","SubType":"NULL"},
4434: {"Type":"Card","SubType":"NULL"},
4435: {"Type":"Card","SubType":"NULL"},
4436: {"Type":"Card","SubType":"NULL"},
4437: {"Type":"Card","SubType":"NULL"},
4438: {"Type":"Card","SubType":"NULL"},
4439: {"Type":"Card","SubType":"NULL"},
4440: {"Type":"Card","SubType":"NULL"},
4441: {"Type":"Card","SubType":"NULL"},
4442: {"Type":"Card","SubType":"NULL"},
4443: {"Type":"Card","SubType":"NULL"},
4444: {"Type":"Card","SubType":"NULL"},
4445: {"Type":"Card","SubType":"NULL"},
4446: {"Type":"Card","SubType":"NULL"},
4447: {"Type":"Card","SubType":"NULL"},
4448: {"Type":"Card","SubType":"NULL"},
4449: {"Type":"Card","SubType":"NULL"},
4450: {"Type":"Card","SubType":"NULL"},
4451: {"Type":"Card","SubType":"NULL"},
4452: {"Type":"Card","SubType":"NULL"},
4453: {"Type":"Card","SubType":"NULL"},
4454: {"Type":"Card","SubType":"NULL"},
4455: {"Type":"Card","SubType":"NULL"},
4456: {"Type":"Card","SubType":"NULL"},
4457: {"Type":"Card","SubType":"NULL"},
4458: {"Type":"Card","SubType":"NULL"},
4459: {"Type":"Card","SubType":"NULL"},
4460: {"Type":"Card","SubType":"NULL"},
4461: {"Type":"Card","SubType":"NULL"},
4462: {"Type":"Card","SubType":"NULL"},
4463: {"Type":"Card","SubType":"NULL"},
4464: {"Type":"Card","SubType":"NULL"},
4465: {"Type":"Card","SubType":"NULL"},
4466: {"Type":"Card","SubType":"NULL"},
4467: {"Type":"Card","SubType":"NULL"},
4468: {"Type":"Card","SubType":"NULL"},
4469: {"Type":"Card","SubType":"NULL"},
4470: {"Type":"Card","SubType":"NULL"},
4471: {"Type":"Card","SubType":"NULL"},
4472: {"Type":"Card","SubType":"NULL"},
4473: {"Type":"Card","SubType":"NULL"},
4474: {"Type":"Card","SubType":"NULL"},
4475: {"Type":"Card","SubType":"NULL"},
4476: {"Type":"Card","SubType":"NULL"},
4477: {"Type":"Card","SubType":"NULL"},
4478: {"Type":"Card","SubType":"NULL"},
4479: {"Type":"Card","SubType":"NULL"},
4480: {"Type":"Card","SubType":"NULL"},
4481: {"Type":"Card","SubType":"NULL"},
4482: {"Type":"Card","SubType":"NULL"},
4483: {"Type":"Card","SubType":"NULL"},
4484: {"Type":"Card","SubType":"NULL"},
4485: {"Type":"Card","SubType":"NULL"},
4486: {"Type":"Card","SubType":"NULL"},
4487: {"Type":"Card","SubType":"NULL"},
4488: {"Type":"Card","SubType":"NULL"},
4489: {"Type":"Card","SubType":"NULL"},
4490: {"Type":"Card","SubType":"NULL"},
4491: {"Type":"Card","SubType":"NULL"},
4492: {"Type":"Card","SubType":"NULL"},
4493: {"Type":"Card","SubType":"NULL"},
4494: {"Type":"Card","SubType":"NULL"},
4495: {"Type":"Card","SubType":"NULL"},
4496: {"Type":"Card","SubType":"NULL"},
4497: {"Type":"Card","SubType":"NULL"},
4498: {"Type":"Card","SubType":"NULL"},
4499: {"Type":"Card","SubType":"NULL"},
4500: {"Type":"Card","SubType":"NULL"},
4501: {"Type":"Card","SubType":"NULL"},
4502: {"Type":"Card","SubType":"NULL"},
4503: {"Type":"Card","SubType":"NULL"},
4504: {"Type":"Card","SubType":"NULL"},
4505: {"Type":"Card","SubType":"NULL"},
4506: {"Type":"Card","SubType":"NULL"},
4507: {"Type":"Card","SubType":"NULL"},
4508: {"Type":"Card","SubType":"NULL"},
4509: {"Type":"Card","SubType":"NULL"},
4510: {"Type":"Card","SubType":"NULL"},
4511: {"Type":"Card","SubType":"NULL"},
4512: {"Type":"Card","SubType":"NULL"},
4513: {"Type":"Card","SubType":"NULL"},
4514: {"Type":"Card","SubType":"NULL"},
4515: {"Type":"Card","SubType":"NULL"},
4516: {"Type":"Card","SubType":"NULL"},
4517: {"Type":"Card","SubType":"NULL"},
4518: {"Type":"Card","SubType":"NULL"},
4519: {"Type":"Card","SubType":"NULL"},
4520: {"Type":"Card","SubType":"NULL"},
4521: {"Type":"Card","SubType":"NULL"},
4522: {"Type":"Card","SubType":"NULL"},
4523: {"Type":"Card","SubType":"NULL"},
4524: {"Type":"Card","SubType":"NULL"},
4525: {"Type":"Card","SubType":"NULL"},
4526: {"Type":"Card","SubType":"NULL"},
4527: {"Type":"Card","SubType":"NULL"},
4528: {"Type":"Card","SubType":"NULL"},
4529: {"Type":"Card","SubType":"NULL"},
4530: {"Type":"Card","SubType":"NULL"},
4531: {"Type":"Card","SubType":"NULL"},
4532: {"Type":"Card","SubType":"NULL"},
4533: {"Type":"Card","SubType":"NULL"},
4534: {"Type":"Card","SubType":"NULL"},
4535: {"Type":"Card","SubType":"NULL"},
4536: {"Type":"Card","SubType":"NULL"},
4537: {"Type":"Card","SubType":"NULL"},
4538: {"Type":"Card","SubType":"NULL"},
4539: {"Type":"Card","SubType":"NULL"},
4540: {"Type":"Card","SubType":"NULL"},
4541: {"Type":"Card","SubType":"NULL"},
4542: {"Type":"Card","SubType":"NULL"},
4543: {"Type":"Card","SubType":"NULL"},
4544: {"Type":"Card","SubType":"NULL"},
4545: {"Type":"Card","SubType":"NULL"},
4546: {"Type":"Card","SubType":"NULL"},
4547: {"Type":"Card","SubType":"NULL"},
4548: {"Type":"Card","SubType":"NULL"},
4549: {"Type":"Card","SubType":"NULL"},
4550: {"Type":"Card","SubType":"NULL"},
4551: {"Type":"Card","SubType":"NULL"},
4552: {"Type":"Card","SubType":"NULL"},
4553: {"Type":"Card","SubType":"NULL"},
4554: {"Type":"Card","SubType":"NULL"},
4555: {"Type":"Card","SubType":"NULL"},
4556: {"Type":"Card","SubType":"NULL"},
4557: {"Type":"Card","SubType":"NULL"},
4558: {"Type":"Card","SubType":"NULL"},
4559: {"Type":"Card","SubType":"NULL"},
4560: {"Type":"Card","SubType":"NULL"},
4561: {"Type":"Card","SubType":"NULL"},
4562: {"Type":"Card","SubType":"NULL"},
4563: {"Type":"Card","SubType":"NULL"},
4564: {"Type":"Card","SubType":"NULL"},
4565: {"Type":"Card","SubType":"NULL"},
4566: {"Type":"Card","SubType":"NULL"},
4567: {"Type":"Card","SubType":"NULL"},
4568: {"Type":"Card","SubType":"NULL"},
4569: {"Type":"Card","SubType":"NULL"},
4570: {"Type":"Card","SubType":"NULL"},
4571: {"Type":"Card","SubType":"NULL"},
4572: {"Type":"Card","SubType":"NULL"},
4573: {"Type":"Card","SubType":"NULL"},
4574: {"Type":"Card","SubType":"NULL"},
4575: {"Type":"Card","SubType":"NULL"},
4576: {"Type":"Card","SubType":"NULL"},
4577: {"Type":"Card","SubType":"NULL"},
4578: {"Type":"Card","SubType":"NULL"},
4579: {"Type":"Card","SubType":"NULL"},
4580: {"Type":"Card","SubType":"NULL"},
4581: {"Type":"Card","SubType":"NULL"},
4582: {"Type":"Card","SubType":"NULL"},
4583: {"Type":"Card","SubType":"NULL"},
4584: {"Type":"Card","SubType":"NULL"},
4585: {"Type":"Card","SubType":"NULL"},
4586: {"Type":"Card","SubType":"NULL"},
4587: {"Type":"Card","SubType":"NULL"},
4588: {"Type":"Card","SubType":"NULL"},
4589: {"Type":"Card","SubType":"NULL"},
4590: {"Type":"Card","SubType":"NULL"},
4591: {"Type":"Card","SubType":"NULL"},
4592: {"Type":"Card","SubType":"NULL"},
4593: {"Type":"Card","SubType":"NULL"},
4594: {"Type":"Card","SubType":"NULL"},
4595: {"Type":"Card","SubType":"NULL"},
4596: {"Type":"Card","SubType":"NULL"},
4597: {"Type":"Card","SubType":"NULL"},
4598: {"Type":"Card","SubType":"NULL"},
4599: {"Type":"Card","SubType":"NULL"},
4600: {"Type":"Card","SubType":"NULL"},
4601: {"Type":"Card","SubType":"NULL"},
4602: {"Type":"Card","SubType":"NULL"},
4603: {"Type":"Card","SubType":"NULL"},
4604: {"Type":"Card","SubType":"NULL"},
4605: {"Type":"Card","SubType":"NULL"},
4606: {"Type":"Card","SubType":"NULL"},
4607: {"Type":"Card","SubType":"NULL"},
4608: {"Type":"Card","SubType":"NULL"},
4609: {"Type":"Card","SubType":"NULL"},
4610: {"Type":"Card","SubType":"NULL"},
4623: {"Type":"Card","SubType":"NULL"},
4625: {"Type":"Card","SubType":"NULL"},
4626: {"Type":"Card","SubType":"NULL"},
4627: {"Type":"Card","SubType":"NULL"},
4628: {"Type":"Card","SubType":"NULL"},
4629: {"Type":"Card","SubType":"NULL"},
4630: {"Type":"Card","SubType":"NULL"},
4631: {"Type":"Card","SubType":"NULL"},
4632: {"Type":"Card","SubType":"NULL"},
4633: {"Type":"Card","SubType":"NULL"},
4634: {"Type":"Card","SubType":"NULL"},
4635: {"Type":"Card","SubType":"NULL"},
4636: {"Type":"Card","SubType":"NULL"},
4637: {"Type":"Card","SubType":"NULL"},
4638: {"Type":"Card","SubType":"NULL"},
4639: {"Type":"Card","SubType":"NULL"},
4640: {"Type":"Card","SubType":"NULL"},
4641: {"Type":"Card","SubType":"NULL"},
4642: {"Type":"Card","SubType":"NULL"},
4643: {"Type":"Card","SubType":"NULL"},
4644: {"Type":"Card","SubType":"NULL"},
4645: {"Type":"Card","SubType":"NULL"},
4646: {"Type":"Card","SubType":"NULL"},
4647: {"Type":"Card","SubType":"NULL"},
4648: {"Type":"Card","SubType":"NULL"},
4649: {"Type":"Card","SubType":"NULL"},
4650: {"Type":"Card","SubType":"NULL"},
4651: {"Type":"Card","SubType":"NULL"},
4652: {"Type":"Card","SubType":"NULL"},
4653: {"Type":"Card","SubType":"NULL"},
4654: {"Type":"Card","SubType":"NULL"},
4655: {"Type":"Card","SubType":"NULL"},
4656: {"Type":"Card","SubType":"NULL"},
4657: {"Type":"Card","SubType":"NULL"},
4658: {"Type":"Card","SubType":"NULL"},
4659: {"Type":"Card","SubType":"NULL"},
4660: {"Type":"Card","SubType":"NULL"},
4661: {"Type":"Card","SubType":"NULL"},
4662: {"Type":"Card","SubType":"NULL"},
4663: {"Type":"Card","SubType":"NULL"},
4664: {"Type":"Card","SubType":"NULL"},
4665: {"Type":"Card","SubType":"NULL"},
4666: {"Type":"Card","SubType":"NULL"},
4667: {"Type":"Card","SubType":"NULL"},
4668: {"Type":"Card","SubType":"NULL"},
4669: {"Type":"Card","SubType":"NULL"},
4670: {"Type":"Card","SubType":"NULL"},
4671: {"Type":"Card","SubType":"NULL"},
4672: {"Type":"Card","SubType":"NULL"},
4673: {"Type":"Card","SubType":"NULL"},
4674: {"Type":"Card","SubType":"NULL"},
4675: {"Type":"Card","SubType":"NULL"},
4676: {"Type":"Card","SubType":"NULL"},
4677: {"Type":"Card","SubType":"NULL"},
4678: {"Type":"Card","SubType":"NULL"},
4679: {"Type":"Card","SubType":"NULL"},
4680: {"Type":"Card","SubType":"NULL"},
4681: {"Type":"Card","SubType":"NULL"},
4682: {"Type":"Card","SubType":"NULL"},
4683: {"Type":"Card","SubType":"NULL"},
4684: {"Type":"Card","SubType":"NULL"},
4685: {"Type":"Card","SubType":"NULL"},
4686: {"Type":"Card","SubType":"NULL"},
4687: {"Type":"Card","SubType":"NULL"},
4688: {"Type":"Card","SubType":"NULL"},
4689: {"Type":"Card","SubType":"NULL"},
4690: {"Type":"Card","SubType":"NULL"},
4691: {"Type":"Card","SubType":"NULL"},
4692: {"Type":"Card","SubType":"NULL"},
4693: {"Type":"Card","SubType":"NULL"},
4694: {"Type":"Card","SubType":"NULL"},
4695: {"Type":"Card","SubType":"NULL"},
4696: {"Type":"Card","SubType":"NULL"},
4697: {"Type":"Card","SubType":"NULL"},
4698: {"Type":"Card","SubType":"NULL"},
4699: {"Type":"Card","SubType":"NULL"},
4700: {"Type":"Card","SubType":"Enchant"},
4701: {"Type":"Card","SubType":"Enchant"},
4702: {"Type":"Card","SubType":"Enchant"},
4703: {"Type":"Card","SubType":"Enchant"},
4704: {"Type":"Card","SubType":"Enchant"},
4705: {"Type":"Card","SubType":"Enchant"},
4706: {"Type":"Card","SubType":"Enchant"},
4707: {"Type":"Card","SubType":"Enchant"},
4708: {"Type":"Card","SubType":"Enchant"},
4709: {"Type":"Card","SubType":"Enchant"},
4710: {"Type":"Card","SubType":"Enchant"},
4711: {"Type":"Card","SubType":"Enchant"},
4712: {"Type":"Card","SubType":"Enchant"},
4713: {"Type":"Card","SubType":"Enchant"},
4714: {"Type":"Card","SubType":"Enchant"},
4715: {"Type":"Card","SubType":"Enchant"},
4716: {"Type":"Card","SubType":"Enchant"},
4717: {"Type":"Card","SubType":"Enchant"},
4718: {"Type":"Card","SubType":"Enchant"},
4719: {"Type":"Card","SubType":"Enchant"},
4720: {"Type":"Card","SubType":"Enchant"},
4721: {"Type":"Card","SubType":"Enchant"},
4722: {"Type":"Card","SubType":"Enchant"},
4723: {"Type":"Card","SubType":"Enchant"},
4724: {"Type":"Card","SubType":"Enchant"},
4725: {"Type":"Card","SubType":"Enchant"},
4726: {"Type":"Card","SubType":"Enchant"},
4727: {"Type":"Card","SubType":"Enchant"},
4728: {"Type":"Card","SubType":"Enchant"},
4729: {"Type":"Card","SubType":"Enchant"},
4730: {"Type":"Card","SubType":"Enchant"},
4731: {"Type":"Card","SubType":"Enchant"},
4732: {"Type":"Card","SubType":"Enchant"},
4733: {"Type":"Card","SubType":"Enchant"},
4734: {"Type":"Card","SubType":"Enchant"},
4735: {"Type":"Card","SubType":"Enchant"},
4736: {"Type":"Card","SubType":"Enchant"},
4737: {"Type":"Card","SubType":"Enchant"},
4738: {"Type":"Card","SubType":"Enchant"},
4739: {"Type":"Card","SubType":"Enchant"},
4740: {"Type":"Card","SubType":"Enchant"},
4741: {"Type":"Card","SubType":"Enchant"},
4742: {"Type":"Card","SubType":"Enchant"},
4743: {"Type":"Card","SubType":"Enchant"},
4744: {"Type":"Card","SubType":"Enchant"},
4745: {"Type":"Card","SubType":"Enchant"},
4746: {"Type":"Card","SubType":"Enchant"},
4747: {"Type":"Card","SubType":"Enchant"},
4748: {"Type":"Card","SubType":"Enchant"},
4749: {"Type":"Card","SubType":"Enchant"},
4750: {"Type":"Card","SubType":"Enchant"},
4751: {"Type":"Card","SubType":"Enchant"},
4752: {"Type":"Card","SubType":"Enchant"},
4753: {"Type":"Card","SubType":"Enchant"},
4754: {"Type":"Card","SubType":"Enchant"},
4755: {"Type":"Card","SubType":"Enchant"},
4756: {"Type":"Card","SubType":"Enchant"},
4757: {"Type":"Card","SubType":"Enchant"},
4758: {"Type":"Card","SubType":"Enchant"},
4759: {"Type":"Card","SubType":"Enchant"},
4760: {"Type":"Card","SubType":"Enchant"},
4761: {"Type":"Card","SubType":"Enchant"},
4762: {"Type":"Card","SubType":"Enchant"},
4763: {"Type":"Card","SubType":"Enchant"},
4764: {"Type":"Card","SubType":"Enchant"},
4765: {"Type":"Card","SubType":"Enchant"},
4766: {"Type":"Card","SubType":"Enchant"},
4767: {"Type":"Card","SubType":"Enchant"},
4768: {"Type":"Card","SubType":"Enchant"},
4769: {"Type":"Card","SubType":"Enchant"},
4770: {"Type":"Card","SubType":"Enchant"},
4771: {"Type":"Card","SubType":"Enchant"},
4772: {"Type":"Card","SubType":"Enchant"},
4773: {"Type":"Card","SubType":"Enchant"},
4774: {"Type":"Card","SubType":"Enchant"},
4775: {"Type":"Card","SubType":"Enchant"},
4776: {"Type":"Card","SubType":"Enchant"},
4777: {"Type":"Card","SubType":"Enchant"},
4778: {"Type":"Card","SubType":"Enchant"},
4779: {"Type":"Card","SubType":"Enchant"},
4780: {"Type":"Card","SubType":"Enchant"},
4781: {"Type":"Card","SubType":"Enchant"},
4782: {"Type":"Card","SubType":"Enchant"},
4783: {"Type":"Card","SubType":"Enchant"},
4784: {"Type":"Card","SubType":"Enchant"},
4785: {"Type":"Card","SubType":"Enchant"},
4786: {"Type":"Card","SubType":"Enchant"},
4787: {"Type":"Card","SubType":"Enchant"},
4788: {"Type":"Card","SubType":"Enchant"},
4789: {"Type":"Card","SubType":"Enchant"},
4790: {"Type":"Card","SubType":"Enchant"},
4791: {"Type":"Card","SubType":"Enchant"},
4792: {"Type":"Card","SubType":"Enchant"},
4793: {"Type":"Card","SubType":"Enchant"},
4794: {"Type":"Card","SubType":"Enchant"},
4795: {"Type":"Card","SubType":"Enchant"},
4796: {"Type":"Card","SubType":"Enchant"},
4797: {"Type":"Card","SubType":"Enchant"},
4798: {"Type":"Card","SubType":"Enchant"},
4799: {"Type":"Card","SubType":"Enchant"},
4800: {"Type":"Card","SubType":"Enchant"},
4801: {"Type":"Card","SubType":"Enchant"},
4802: {"Type":"Card","SubType":"Enchant"},
4803: {"Type":"Card","SubType":"Enchant"},
4804: {"Type":"Card","SubType":"Enchant"},
4805: {"Type":"Card","SubType":"Enchant"},
4806: {"Type":"Card","SubType":"Enchant"},
4807: {"Type":"Card","SubType":"Enchant"},
4808: {"Type":"Card","SubType":"Enchant"},
4809: {"Type":"Card","SubType":"Enchant"},
4810: {"Type":"Card","SubType":"Enchant"},
4811: {"Type":"Card","SubType":"Enchant"},
4812: {"Type":"Card","SubType":"Enchant"},
4813: {"Type":"Card","SubType":"Enchant"},
4814: {"Type":"Card","SubType":"Enchant"},
4815: {"Type":"Card","SubType":"Enchant"},
4816: {"Type":"Card","SubType":"Enchant"},
4817: {"Type":"Card","SubType":"Enchant"},
4818: {"Type":"Card","SubType":"Enchant"},
4819: {"Type":"Card","SubType":"Enchant"},
4820: {"Type":"Card","SubType":"Enchant"},
4821: {"Type":"Card","SubType":"Enchant"},
4822: {"Type":"Card","SubType":"Enchant"},
4823: {"Type":"Card","SubType":"Enchant"},
4824: {"Type":"Card","SubType":"Enchant"},
4825: {"Type":"Card","SubType":"Enchant"},
4826: {"Type":"Card","SubType":"Enchant"},
4827: {"Type":"Card","SubType":"Enchant"},
4828: {"Type":"Card","SubType":"Enchant"},
4829: {"Type":"Card","SubType":"Enchant"},
4830: {"Type":"Card","SubType":"Enchant"},
4831: {"Type":"Card","SubType":"Enchant"},
4832: {"Type":"Card","SubType":"Enchant"},
4833: {"Type":"Card","SubType":"Enchant"},
4834: {"Type":"Card","SubType":"Enchant"},
4835: {"Type":"Card","SubType":"Enchant"},
4836: {"Type":"Card","SubType":"Enchant"},
4837: {"Type":"Card","SubType":"Enchant"},
4838: {"Type":"Card","SubType":"Enchant"},
4839: {"Type":"Card","SubType":"Enchant"},
4840: {"Type":"Card","SubType":"Enchant"},
4841: {"Type":"Card","SubType":"Enchant"},
4842: {"Type":"Card","SubType":"Enchant"},
4843: {"Type":"Card","SubType":"Enchant"},
4844: {"Type":"Card","SubType":"Enchant"},
4845: {"Type":"Card","SubType":"Enchant"},
4846: {"Type":"Card","SubType":"Enchant"},
4847: {"Type":"Card","SubType":"Enchant"},
4848: {"Type":"Card","SubType":"Enchant"},
4849: {"Type":"Card","SubType":"Enchant"},
4850: {"Type":"Card","SubType":"Enchant"},
4851: {"Type":"Card","SubType":"Enchant"},
4852: {"Type":"Card","SubType":"Enchant"},
4853: {"Type":"Card","SubType":"Enchant"},
4854: {"Type":"Card","SubType":"Enchant"},
4855: {"Type":"Card","SubType":"Enchant"},
4856: {"Type":"Card","SubType":"Enchant"},
4857: {"Type":"Card","SubType":"Enchant"},
4858: {"Type":"Card","SubType":"Enchant"},
4859: {"Type":"Card","SubType":"Enchant"},
4860: {"Type":"Card","SubType":"Enchant"},
4861: {"Type":"Card","SubType":"Enchant"},
4862: {"Type":"Card","SubType":"Enchant"},
4863: {"Type":"Card","SubType":"Enchant"},
4864: {"Type":"Card","SubType":"Enchant"},
4865: {"Type":"Card","SubType":"Enchant"},
4866: {"Type":"Card","SubType":"Enchant"},
4867: {"Type":"Card","SubType":"Enchant"},
4868: {"Type":"Card","SubType":"Enchant"},
4869: {"Type":"Card","SubType":"Enchant"},
4870: {"Type":"Card","SubType":"Enchant"},
4871: {"Type":"Card","SubType":"Enchant"},
4872: {"Type":"Card","SubType":"Enchant"},
4873: {"Type":"Card","SubType":"Enchant"},
4874: {"Type":"Card","SubType":"Enchant"},
4875: {"Type":"Card","SubType":"Enchant"},
4876: {"Type":"Card","SubType":"Enchant"},
4877: {"Type":"Card","SubType":"Enchant"},
4878: {"Type":"Card","SubType":"Enchant"},
4879: {"Type":"Card","SubType":"Enchant"},
4880: {"Type":"Card","SubType":"Enchant"},
4881: {"Type":"Card","SubType":"Enchant"},
4882: {"Type":"Card","SubType":"Enchant"},
4883: {"Type":"Card","SubType":"Enchant"},
4884: {"Type":"Card","SubType":"Enchant"},
4885: {"Type":"Card","SubType":"Enchant"},
4886: {"Type":"Card","SubType":"Enchant"},
4887: {"Type":"Card","SubType":"Enchant"},
4888: {"Type":"Card","SubType":"Enchant"},
4889: {"Type":"Card","SubType":"Enchant"},
4890: {"Type":"Card","SubType":"Enchant"},
4891: {"Type":"Card","SubType":"Enchant"},
4892: {"Type":"Card","SubType":"Enchant"},
4893: {"Type":"Card","SubType":"Enchant"},
4894: {"Type":"Card","SubType":"Enchant"},
4895: {"Type":"Card","SubType":"Enchant"},
4896: {"Type":"Card","SubType":"Enchant"},
4897: {"Type":"Card","SubType":"Enchant"},
4898: {"Type":"Card","SubType":"Enchant"},
4899: {"Type":"Card","SubType":"Enchant"},
4900: {"Type":"Card","SubType":"Enchant"},
4902: {"Type":"Card","SubType":"Enchant"},
4903: {"Type":"Card","SubType":"Enchant"},
4904: {"Type":"Card","SubType":"Enchant"},
4905: {"Type":"Card","SubType":"Enchant"},
4906: {"Type":"Card","SubType":"Enchant"},
4907: {"Type":"Card","SubType":"Enchant"},
4908: {"Type":"Card","SubType":"Enchant"},
4909: {"Type":"Card","SubType":"Enchant"},
4910: {"Type":"Card","SubType":"Enchant"},
4911: {"Type":"Card","SubType":"Enchant"},
4912: {"Type":"Card","SubType":"Enchant"},
4913: {"Type":"Card","SubType":"Enchant"},
4914: {"Type":"Card","SubType":"Enchant"},
4915: {"Type":"Card","SubType":"Enchant"},
4916: {"Type":"Card","SubType":"Enchant"},
4917: {"Type":"Card","SubType":"Enchant"},
4918: {"Type":"Card","SubType":"Enchant"},
4919: {"Type":"Card","SubType":"Enchant"},
4920: {"Type":"Card","SubType":"Enchant"},
4921: {"Type":"Card","SubType":"Enchant"},
4922: {"Type":"Card","SubType":"Enchant"},
4923: {"Type":"Card","SubType":"Enchant"},
4924: {"Type":"Card","SubType":"Enchant"},
4925: {"Type":"Card","SubType":"Enchant"},
4926: {"Type":"Card","SubType":"Enchant"},
4927: {"Type":"Card","SubType":"Enchant"},
4928: {"Type":"Card","SubType":"Enchant"},
4929: {"Type":"Card","SubType":"Enchant"},
4930: {"Type":"Card","SubType":"Enchant"},
4931: {"Type":"Card","SubType":"Enchant"},
4932: {"Type":"Card","SubType":"Enchant"},
4933: {"Type":"Card","SubType":"Enchant"},
4934: {"Type":"Card","SubType":"Enchant"},
4935: {"Type":"Card","SubType":"Enchant"},
4936: {"Type":"Card","SubType":"Enchant"},
4937: {"Type":"Card","SubType":"Enchant"},
4938: {"Type":"Card","SubType":"Enchant"},
4939: {"Type":"Card","SubType":"Enchant"},
4940: {"Type":"Card","SubType":"Enchant"},
4941: {"Type":"Card","SubType":"Enchant"},
4942: {"Type":"Card","SubType":"Enchant"},
4943: {"Type":"Card","SubType":"Enchant"},
4944: {"Type":"Card","SubType":"Enchant"},
4945: {"Type":"Card","SubType":"Enchant"},
4946: {"Type":"Card","SubType":"Enchant"},
4947: {"Type":"Card","SubType":"Enchant"},
4948: {"Type":"Card","SubType":"Enchant"},
4949: {"Type":"Card","SubType":"Enchant"},
4950: {"Type":"Card","SubType":"Enchant"},
4951: {"Type":"Card","SubType":"Enchant"},
4952: {"Type":"Card","SubType":"Enchant"},
4953: {"Type":"Card","SubType":"Enchant"},
4954: {"Type":"Card","SubType":"Enchant"},
4955: {"Type":"Card","SubType":"Enchant"},
4956: {"Type":"Card","SubType":"Enchant"},
4957: {"Type":"Card","SubType":"Enchant"},
4958: {"Type":"Card","SubType":"Enchant"},
4959: {"Type":"Card","SubType":"Enchant"},
4960: {"Type":"Card","SubType":"Enchant"},
4961: {"Type":"Card","SubType":"Enchant"},
4962: {"Type":"Card","SubType":"Enchant"},
4963: {"Type":"Card","SubType":"Enchant"},
4964: {"Type":"Card","SubType":"Enchant"},
4965: {"Type":"Card","SubType":"Enchant"},
4966: {"Type":"Card","SubType":"Enchant"},
4967: {"Type":"Card","SubType":"Enchant"},
4968: {"Type":"Card","SubType":"Enchant"},
4969: {"Type":"Card","SubType":"Enchant"},
4970: {"Type":"Card","SubType":"Enchant"},
4971: {"Type":"Card","SubType":"Enchant"},
4972: {"Type":"Card","SubType":"Enchant"},
4973: {"Type":"Card","SubType":"Enchant"},
4974: {"Type":"Card","SubType":"Enchant"},
4975: {"Type":"Card","SubType":"Enchant"},
4976: {"Type":"Card","SubType":"Enchant"},
4977: {"Type":"Card","SubType":"Enchant"},
4978: {"Type":"Card","SubType":"Enchant"},
4979: {"Type":"Card","SubType":"Enchant"},
4980: {"Type":"Card","SubType":"Enchant"},
4981: {"Type":"Card","SubType":"Enchant"},
4982: {"Type":"Card","SubType":"Enchant"},
4983: {"Type":"Card","SubType":"Enchant"},
4984: {"Type":"Card","SubType":"Enchant"},
4985: {"Type":"Card","SubType":"Enchant"},
4986: {"Type":"Card","SubType":"Enchant"},
4987: {"Type":"Card","SubType":"Enchant"},
4988: {"Type":"Card","SubType":"Enchant"},
4989: {"Type":"Card","SubType":"Enchant"},
4990: {"Type":"Card","SubType":"Enchant"},
4991: {"Type":"Card","SubType":"Enchant"},
4992: {"Type":"Card","SubType":"Enchant"},
4993: {"Type":"Card","SubType":"Enchant"},
4994: {"Type":"Card","SubType":"Enchant"},
4995: {"Type":"Card","SubType":"Enchant"},
4996: {"Type":"Card","SubType":"Enchant"},
4997: {"Type":"Card","SubType":"Enchant"},
4998: {"Type":"Card","SubType":"Enchant"},
4999: {"Type":"Card","SubType":"Enchant"},
5001: {"Type":"Armor","SubType":"NULL"},
5002: {"Type":"Armor","SubType":"NULL"},
5003: {"Type":"Armor","SubType":"NULL"},
5004: {"Type":"Armor","SubType":"NULL"},
5005: {"Type":"Armor","SubType":"NULL"},
5006: {"Type":"Armor","SubType":"NULL"},
5007: {"Type":"Armor","SubType":"NULL"},
5008: {"Type":"Armor","SubType":"NULL"},
5009: {"Type":"Armor","SubType":"NULL"},
5010: {"Type":"Armor","SubType":"NULL"},
5011: {"Type":"Armor","SubType":"NULL"},
5012: {"Type":"Armor","SubType":"NULL"},
5013: {"Type":"Armor","SubType":"NULL"},
5014: {"Type":"Armor","SubType":"NULL"},
5015: {"Type":"Armor","SubType":"NULL"},
5016: {"Type":"Armor","SubType":"NULL"},
5017: {"Type":"Armor","SubType":"NULL"},
5018: {"Type":"Armor","SubType":"NULL"},
5019: {"Type":"Armor","SubType":"NULL"},
5020: {"Type":"Armor","SubType":"NULL"},
5021: {"Type":"Armor","SubType":"NULL"},
5022: {"Type":"Armor","SubType":"NULL"},
5023: {"Type":"Armor","SubType":"NULL"},
5024: {"Type":"Armor","SubType":"NULL"},
5025: {"Type":"Armor","SubType":"NULL"},
5026: {"Type":"Armor","SubType":"NULL"},
5027: {"Type":"Armor","SubType":"NULL"},
5028: {"Type":"Armor","SubType":"NULL"},
5029: {"Type":"Armor","SubType":"NULL"},
5030: {"Type":"Armor","SubType":"NULL"},
5031: {"Type":"Armor","SubType":"NULL"},
5032: {"Type":"Armor","SubType":"NULL"},
5033: {"Type":"Armor","SubType":"NULL"},
5034: {"Type":"Armor","SubType":"NULL"},
5035: {"Type":"Armor","SubType":"NULL"},
5036: {"Type":"Armor","SubType":"NULL"},
5037: {"Type":"Armor","SubType":"NULL"},
5038: {"Type":"Armor","SubType":"NULL"},
5039: {"Type":"Armor","SubType":"NULL"},
5040: {"Type":"Armor","SubType":"NULL"},
5041: {"Type":"Armor","SubType":"NULL"},
5042: {"Type":"Armor","SubType":"NULL"},
5043: {"Type":"Armor","SubType":"NULL"},
5044: {"Type":"Armor","SubType":"NULL"},
5045: {"Type":"Armor","SubType":"NULL"},
5046: {"Type":"Armor","SubType":"NULL"},
5047: {"Type":"Armor","SubType":"NULL"},
5048: {"Type":"Armor","SubType":"NULL"},
5049: {"Type":"Armor","SubType":"NULL"},
5050: {"Type":"Armor","SubType":"NULL"},
5051: {"Type":"Armor","SubType":"NULL"},
5052: {"Type":"Armor","SubType":"NULL"},
5053: {"Type":"Armor","SubType":"NULL"},
5054: {"Type":"Armor","SubType":"NULL"},
5055: {"Type":"Armor","SubType":"NULL"},
5056: {"Type":"Armor","SubType":"NULL"},
5057: {"Type":"Armor","SubType":"NULL"},
5058: {"Type":"Armor","SubType":"NULL"},
5059: {"Type":"Armor","SubType":"NULL"},
5060: {"Type":"Armor","SubType":"NULL"},
5061: {"Type":"Armor","SubType":"NULL"},
5062: {"Type":"Armor","SubType":"NULL"},
5063: {"Type":"Armor","SubType":"NULL"},
5064: {"Type":"Armor","SubType":"NULL"},
5065: {"Type":"Armor","SubType":"NULL"},
5066: {"Type":"Armor","SubType":"NULL"},
5067: {"Type":"Armor","SubType":"NULL"},
5068: {"Type":"Armor","SubType":"NULL"},
5069: {"Type":"Armor","SubType":"NULL"},
5070: {"Type":"Armor","SubType":"NULL"},
5071: {"Type":"Armor","SubType":"NULL"},
5072: {"Type":"Armor","SubType":"NULL"},
5073: {"Type":"Armor","SubType":"NULL"},
5074: {"Type":"Armor","SubType":"NULL"},
5075: {"Type":"Armor","SubType":"NULL"},
5076: {"Type":"Armor","SubType":"NULL"},
5077: {"Type":"Armor","SubType":"NULL"},
5078: {"Type":"Armor","SubType":"NULL"},
5079: {"Type":"Armor","SubType":"NULL"},
5080: {"Type":"Armor","SubType":"NULL"},
5081: {"Type":"Armor","SubType":"NULL"},
5082: {"Type":"Armor","SubType":"NULL"},
5083: {"Type":"Armor","SubType":"NULL"},
5084: {"Type":"Armor","SubType":"NULL"},
5085: {"Type":"Armor","SubType":"NULL"},
5086: {"Type":"Armor","SubType":"NULL"},
5087: {"Type":"Armor","SubType":"NULL"},
5088: {"Type":"Armor","SubType":"NULL"},
5089: {"Type":"Armor","SubType":"NULL"},
5090: {"Type":"Armor","SubType":"NULL"},
5091: {"Type":"Armor","SubType":"NULL"},
5092: {"Type":"Armor","SubType":"NULL"},
5093: {"Type":"Armor","SubType":"NULL"},
5094: {"Type":"Armor","SubType":"NULL"},
5095: {"Type":"Armor","SubType":"NULL"},
5096: {"Type":"Armor","SubType":"NULL"},
5097: {"Type":"Armor","SubType":"NULL"},
5098: {"Type":"Armor","SubType":"NULL"},
5099: {"Type":"Armor","SubType":"NULL"},
5100: {"Type":"Armor","SubType":"NULL"},
5101: {"Type":"Armor","SubType":"NULL"},
5102: {"Type":"Armor","SubType":"NULL"},
5103: {"Type":"Armor","SubType":"NULL"},
5104: {"Type":"Armor","SubType":"NULL"},
5105: {"Type":"Armor","SubType":"NULL"},
5106: {"Type":"Armor","SubType":"NULL"},
5107: {"Type":"Armor","SubType":"NULL"},
5108: {"Type":"Armor","SubType":"NULL"},
5109: {"Type":"Armor","SubType":"NULL"},
5110: {"Type":"Armor","SubType":"NULL"},
5111: {"Type":"Armor","SubType":"NULL"},
5112: {"Type":"Armor","SubType":"NULL"},
5113: {"Type":"Armor","SubType":"NULL"},
5114: {"Type":"Armor","SubType":"NULL"},
5115: {"Type":"Armor","SubType":"NULL"},
5116: {"Type":"Armor","SubType":"NULL"},
5117: {"Type":"Armor","SubType":"NULL"},
5118: {"Type":"Armor","SubType":"NULL"},
5119: {"Type":"Armor","SubType":"NULL"},
5120: {"Type":"Armor","SubType":"NULL"},
5121: {"Type":"Armor","SubType":"NULL"},
5122: {"Type":"Armor","SubType":"NULL"},
5123: {"Type":"Armor","SubType":"NULL"},
5124: {"Type":"Armor","SubType":"NULL"},
5125: {"Type":"Armor","SubType":"NULL"},
5126: {"Type":"Armor","SubType":"NULL"},
5127: {"Type":"Armor","SubType":"NULL"},
5128: {"Type":"Armor","SubType":"NULL"},
5129: {"Type":"Armor","SubType":"NULL"},
5130: {"Type":"Armor","SubType":"NULL"},
5131: {"Type":"Armor","SubType":"NULL"},
5132: {"Type":"Armor","SubType":"NULL"},
5133: {"Type":"Armor","SubType":"NULL"},
5134: {"Type":"Armor","SubType":"NULL"},
5135: {"Type":"Armor","SubType":"NULL"},
5136: {"Type":"Armor","SubType":"NULL"},
5137: {"Type":"Armor","SubType":"NULL"},
5138: {"Type":"Armor","SubType":"NULL"},
5139: {"Type":"Armor","SubType":"NULL"},
5140: {"Type":"Armor","SubType":"NULL"},
5141: {"Type":"Armor","SubType":"NULL"},
5142: {"Type":"Armor","SubType":"NULL"},
5143: {"Type":"Armor","SubType":"NULL"},
5144: {"Type":"Armor","SubType":"NULL"},
5145: {"Type":"Armor","SubType":"NULL"},
5146: {"Type":"Armor","SubType":"NULL"},
5147: {"Type":"Armor","SubType":"NULL"},
5148: {"Type":"Armor","SubType":"NULL"},
5149: {"Type":"Armor","SubType":"NULL"},
5150: {"Type":"Armor","SubType":"NULL"},
5151: {"Type":"Armor","SubType":"NULL"},
5152: {"Type":"Armor","SubType":"NULL"},
5153: {"Type":"Armor","SubType":"NULL"},
5154: {"Type":"Armor","SubType":"NULL"},
5155: {"Type":"Armor","SubType":"NULL"},
5156: {"Type":"Armor","SubType":"NULL"},
5157: {"Type":"Armor","SubType":"NULL"},
5158: {"Type":"Armor","SubType":"NULL"},
5159: {"Type":"Armor","SubType":"NULL"},
5160: {"Type":"Armor","SubType":"NULL"},
5161: {"Type":"Armor","SubType":"NULL"},
5162: {"Type":"Armor","SubType":"NULL"},
5163: {"Type":"Armor","SubType":"NULL"},
5164: {"Type":"Armor","SubType":"NULL"},
5165: {"Type":"Armor","SubType":"NULL"},
5166: {"Type":"Armor","SubType":"NULL"},
5167: {"Type":"Armor","SubType":"NULL"},
5168: {"Type":"Armor","SubType":"NULL"},
5169: {"Type":"Armor","SubType":"NULL"},
5170: {"Type":"Armor","SubType":"NULL"},
5171: {"Type":"Armor","SubType":"NULL"},
5172: {"Type":"Armor","SubType":"NULL"},
5173: {"Type":"Armor","SubType":"NULL"},
5174: {"Type":"Armor","SubType":"NULL"},
5175: {"Type":"Armor","SubType":"NULL"},
5176: {"Type":"Armor","SubType":"NULL"},
5177: {"Type":"Armor","SubType":"NULL"},
5178: {"Type":"Armor","SubType":"NULL"},
5179: {"Type":"Armor","SubType":"NULL"},
5180: {"Type":"Armor","SubType":"NULL"},
5181: {"Type":"Armor","SubType":"NULL"},
5182: {"Type":"Armor","SubType":"NULL"},
5183: {"Type":"Armor","SubType":"NULL"},
5184: {"Type":"Armor","SubType":"NULL"},
5185: {"Type":"Armor","SubType":"NULL"},
5186: {"Type":"Armor","SubType":"NULL"},
5187: {"Type":"Armor","SubType":"NULL"},
5188: {"Type":"Armor","SubType":"NULL"},
5189: {"Type":"Armor","SubType":"NULL"},
5190: {"Type":"Armor","SubType":"NULL"},
5191: {"Type":"Armor","SubType":"NULL"},
5192: {"Type":"Armor","SubType":"NULL"},
5193: {"Type":"Armor","SubType":"NULL"},
5194: {"Type":"Armor","SubType":"NULL"},
5195: {"Type":"Armor","SubType":"NULL"},
5196: {"Type":"Armor","SubType":"NULL"},
5197: {"Type":"Armor","SubType":"NULL"},
5198: {"Type":"Armor","SubType":"NULL"},
5199: {"Type":"Armor","SubType":"NULL"},
5200: {"Type":"Armor","SubType":"NULL"},
5201: {"Type":"Armor","SubType":"NULL"},
5202: {"Type":"Armor","SubType":"NULL"},
5203: {"Type":"Armor","SubType":"NULL"},
5204: {"Type":"Armor","SubType":"NULL"},
5205: {"Type":"Armor","SubType":"NULL"},
5206: {"Type":"Armor","SubType":"NULL"},
5207: {"Type":"Armor","SubType":"NULL"},
5208: {"Type":"Armor","SubType":"NULL"},
5209: {"Type":"Armor","SubType":"NULL"},
5210: {"Type":"Armor","SubType":"NULL"},
5211: {"Type":"Armor","SubType":"NULL"},
5212: {"Type":"Armor","SubType":"NULL"},
5213: {"Type":"Armor","SubType":"NULL"},
5214: {"Type":"Armor","SubType":"NULL"},
5215: {"Type":"Armor","SubType":"NULL"},
5216: {"Type":"Armor","SubType":"NULL"},
5217: {"Type":"Armor","SubType":"NULL"},
5218: {"Type":"Armor","SubType":"NULL"},
5219: {"Type":"Armor","SubType":"NULL"},
5220: {"Type":"Armor","SubType":"NULL"},
5221: {"Type":"Armor","SubType":"NULL"},
5222: {"Type":"Armor","SubType":"NULL"},
5223: {"Type":"Armor","SubType":"NULL"},
5224: {"Type":"Armor","SubType":"NULL"},
5225: {"Type":"Armor","SubType":"NULL"},
5226: {"Type":"Armor","SubType":"NULL"},
5227: {"Type":"Armor","SubType":"NULL"},
5228: {"Type":"Armor","SubType":"NULL"},
5229: {"Type":"Armor","SubType":"NULL"},
5230: {"Type":"Armor","SubType":"NULL"},
5231: {"Type":"Armor","SubType":"NULL"},
5232: {"Type":"Armor","SubType":"NULL"},
5233: {"Type":"Armor","SubType":"NULL"},
5234: {"Type":"Armor","SubType":"NULL"},
5235: {"Type":"Armor","SubType":"NULL"},
5236: {"Type":"Armor","SubType":"NULL"},
5237: {"Type":"Armor","SubType":"NULL"},
5238: {"Type":"Armor","SubType":"NULL"},
5239: {"Type":"Armor","SubType":"NULL"},
5240: {"Type":"Armor","SubType":"NULL"},
5241: {"Type":"Armor","SubType":"NULL"},
5242: {"Type":"Armor","SubType":"NULL"},
5243: {"Type":"Armor","SubType":"NULL"},
5244: {"Type":"Armor","SubType":"NULL"},
5245: {"Type":"Armor","SubType":"NULL"},
5246: {"Type":"Armor","SubType":"NULL"},
5247: {"Type":"Armor","SubType":"NULL"},
5248: {"Type":"Armor","SubType":"NULL"},
5249: {"Type":"Armor","SubType":"NULL"},
5250: {"Type":"Armor","SubType":"NULL"},
5251: {"Type":"Armor","SubType":"NULL"},
5252: {"Type":"Armor","SubType":"NULL"},
5253: {"Type":"Armor","SubType":"NULL"},
5254: {"Type":"Armor","SubType":"NULL"},
5255: {"Type":"Armor","SubType":"NULL"},
5256: {"Type":"Armor","SubType":"NULL"},
5257: {"Type":"Armor","SubType":"NULL"},
5258: {"Type":"Armor","SubType":"NULL"},
5259: {"Type":"Armor","SubType":"NULL"},
5260: {"Type":"Armor","SubType":"NULL"},
5261: {"Type":"Armor","SubType":"NULL"},
5262: {"Type":"Armor","SubType":"NULL"},
5263: {"Type":"Armor","SubType":"NULL"},
5264: {"Type":"Armor","SubType":"NULL"},
5265: {"Type":"Armor","SubType":"NULL"},
5266: {"Type":"Armor","SubType":"NULL"},
5267: {"Type":"Armor","SubType":"NULL"},
5268: {"Type":"Armor","SubType":"NULL"},
5269: {"Type":"Armor","SubType":"NULL"},
5270: {"Type":"Armor","SubType":"NULL"},
5271: {"Type":"Armor","SubType":"NULL"},
5272: {"Type":"Armor","SubType":"NULL"},
5273: {"Type":"Armor","SubType":"NULL"},
5274: {"Type":"Armor","SubType":"NULL"},
5275: {"Type":"Armor","SubType":"NULL"},
5276: {"Type":"Armor","SubType":"NULL"},
5277: {"Type":"Armor","SubType":"NULL"},
5278: {"Type":"Armor","SubType":"NULL"},
5279: {"Type":"Armor","SubType":"NULL"},
5280: {"Type":"Armor","SubType":"NULL"},
5281: {"Type":"Armor","SubType":"NULL"},
5282: {"Type":"Armor","SubType":"NULL"},
5283: {"Type":"Armor","SubType":"NULL"},
5284: {"Type":"Armor","SubType":"NULL"},
5285: {"Type":"Armor","SubType":"NULL"},
5286: {"Type":"Armor","SubType":"NULL"},
5287: {"Type":"Armor","SubType":"NULL"},
5288: {"Type":"Armor","SubType":"NULL"},
5289: {"Type":"Armor","SubType":"NULL"},
5290: {"Type":"Armor","SubType":"NULL"},
5291: {"Type":"Armor","SubType":"NULL"},
5292: {"Type":"Armor","SubType":"NULL"},
5293: {"Type":"Armor","SubType":"NULL"},
5294: {"Type":"Armor","SubType":"NULL"},
5295: {"Type":"Armor","SubType":"NULL"},
5296: {"Type":"Armor","SubType":"NULL"},
5297: {"Type":"Armor","SubType":"NULL"},
5298: {"Type":"Armor","SubType":"NULL"},
5299: {"Type":"Armor","SubType":"NULL"},
5300: {"Type":"Armor","SubType":"NULL"},
5301: {"Type":"Armor","SubType":"NULL"},
5302: {"Type":"Armor","SubType":"NULL"},
5303: {"Type":"Armor","SubType":"NULL"},
5304: {"Type":"Armor","SubType":"NULL"},
5305: {"Type":"Armor","SubType":"NULL"},
5306: {"Type":"Armor","SubType":"NULL"},
5307: {"Type":"Armor","SubType":"NULL"},
5308: {"Type":"Armor","SubType":"NULL"},
5309: {"Type":"Armor","SubType":"NULL"},
5310: {"Type":"Armor","SubType":"NULL"},
5311: {"Type":"Armor","SubType":"NULL"},
5312: {"Type":"Armor","SubType":"NULL"},
5313: {"Type":"Armor","SubType":"NULL"},
5314: {"Type":"Armor","SubType":"NULL"},
5315: {"Type":"Armor","SubType":"NULL"},
5316: {"Type":"Armor","SubType":"NULL"},
5317: {"Type":"Armor","SubType":"NULL"},
5318: {"Type":"Armor","SubType":"NULL"},
5319: {"Type":"Armor","SubType":"NULL"},
5320: {"Type":"Armor","SubType":"NULL"},
5321: {"Type":"Armor","SubType":"NULL"},
5322: {"Type":"Armor","SubType":"NULL"},
5323: {"Type":"Armor","SubType":"NULL"},
5324: {"Type":"Armor","SubType":"NULL"},
5325: {"Type":"Armor","SubType":"NULL"},
5326: {"Type":"Armor","SubType":"NULL"},
5327: {"Type":"Armor","SubType":"NULL"},
5328: {"Type":"Armor","SubType":"NULL"},
5329: {"Type":"Armor","SubType":"NULL"},
5330: {"Type":"Armor","SubType":"NULL"},
5331: {"Type":"Armor","SubType":"NULL"},
5332: {"Type":"Armor","SubType":"NULL"},
5333: {"Type":"Armor","SubType":"NULL"},
5334: {"Type":"Armor","SubType":"NULL"},
5335: {"Type":"Armor","SubType":"NULL"},
5336: {"Type":"Armor","SubType":"NULL"},
5337: {"Type":"Armor","SubType":"NULL"},
5338: {"Type":"Armor","SubType":"NULL"},
5339: {"Type":"Armor","SubType":"NULL"},
5340: {"Type":"Armor","SubType":"NULL"},
5341: {"Type":"Armor","SubType":"NULL"},
5342: {"Type":"Armor","SubType":"NULL"},
5343: {"Type":"Armor","SubType":"NULL"},
5344: {"Type":"Armor","SubType":"NULL"},
5345: {"Type":"Armor","SubType":"NULL"},
5346: {"Type":"Armor","SubType":"NULL"},
5347: {"Type":"Armor","SubType":"NULL"},
5348: {"Type":"Armor","SubType":"NULL"},
5349: {"Type":"Armor","SubType":"NULL"},
5350: {"Type":"Armor","SubType":"NULL"},
5351: {"Type":"Armor","SubType":"NULL"},
5352: {"Type":"Armor","SubType":"NULL"},
5353: {"Type":"Armor","SubType":"NULL"},
5354: {"Type":"Armor","SubType":"NULL"},
5355: {"Type":"Armor","SubType":"NULL"},
5356: {"Type":"Armor","SubType":"NULL"},
5357: {"Type":"Armor","SubType":"NULL"},
5358: {"Type":"Armor","SubType":"NULL"},
5359: {"Type":"Armor","SubType":"NULL"},
5360: {"Type":"Armor","SubType":"NULL"},
5361: {"Type":"Armor","SubType":"NULL"},
5362: {"Type":"Armor","SubType":"NULL"},
5363: {"Type":"Armor","SubType":"NULL"},
5364: {"Type":"Armor","SubType":"NULL"},
5365: {"Type":"Armor","SubType":"NULL"},
5366: {"Type":"Armor","SubType":"NULL"},
5367: {"Type":"Armor","SubType":"NULL"},
5368: {"Type":"Armor","SubType":"NULL"},
5369: {"Type":"Armor","SubType":"NULL"},
5370: {"Type":"Armor","SubType":"NULL"},
5371: {"Type":"Armor","SubType":"NULL"},
5372: {"Type":"Armor","SubType":"NULL"},
5373: {"Type":"Armor","SubType":"NULL"},
5374: {"Type":"Armor","SubType":"NULL"},
5375: {"Type":"Armor","SubType":"NULL"},
5376: {"Type":"Armor","SubType":"NULL"},
5377: {"Type":"Armor","SubType":"NULL"},
5378: {"Type":"Armor","SubType":"NULL"},
5379: {"Type":"Armor","SubType":"NULL"},
5380: {"Type":"Armor","SubType":"NULL"},
5381: {"Type":"Armor","SubType":"NULL"},
5382: {"Type":"Armor","SubType":"NULL"},
5383: {"Type":"Armor","SubType":"NULL"},
5384: {"Type":"Armor","SubType":"NULL"},
5385: {"Type":"Armor","SubType":"NULL"},
5386: {"Type":"Armor","SubType":"NULL"},
5387: {"Type":"Armor","SubType":"NULL"},
5388: {"Type":"Armor","SubType":"NULL"},
5389: {"Type":"Armor","SubType":"NULL"},
5390: {"Type":"Armor","SubType":"NULL"},
5391: {"Type":"Armor","SubType":"NULL"},
5392: {"Type":"Armor","SubType":"NULL"},
5393: {"Type":"Armor","SubType":"NULL"},
5394: {"Type":"Armor","SubType":"NULL"},
5395: {"Type":"Armor","SubType":"NULL"},
5396: {"Type":"Armor","SubType":"NULL"},
5397: {"Type":"Armor","SubType":"NULL"},
5398: {"Type":"Armor","SubType":"NULL"},
5399: {"Type":"Armor","SubType":"NULL"},
5400: {"Type":"Armor","SubType":"NULL"},
5401: {"Type":"Armor","SubType":"NULL"},
5402: {"Type":"Armor","SubType":"NULL"},
5403: {"Type":"Armor","SubType":"NULL"},
5404: {"Type":"Armor","SubType":"NULL"},
5405: {"Type":"Armor","SubType":"NULL"},
5406: {"Type":"Armor","SubType":"NULL"},
5407: {"Type":"Armor","SubType":"NULL"},
5408: {"Type":"Armor","SubType":"NULL"},
5409: {"Type":"Armor","SubType":"NULL"},
5410: {"Type":"Armor","SubType":"NULL"},
5411: {"Type":"Armor","SubType":"NULL"},
5412: {"Type":"Armor","SubType":"NULL"},
5413: {"Type":"Armor","SubType":"NULL"},
5414: {"Type":"Armor","SubType":"NULL"},
5415: {"Type":"Armor","SubType":"NULL"},
5416: {"Type":"Armor","SubType":"NULL"},
5417: {"Type":"Armor","SubType":"NULL"},
5418: {"Type":"Armor","SubType":"NULL"},
5419: {"Type":"Armor","SubType":"NULL"},
5420: {"Type":"Armor","SubType":"NULL"},
5421: {"Type":"Armor","SubType":"NULL"},
5422: {"Type":"Armor","SubType":"NULL"},
5423: {"Type":"Armor","SubType":"NULL"},
5424: {"Type":"Armor","SubType":"NULL"},
5425: {"Type":"Armor","SubType":"NULL"},
5426: {"Type":"Armor","SubType":"NULL"},
5427: {"Type":"Armor","SubType":"NULL"},
5428: {"Type":"Armor","SubType":"NULL"},
5429: {"Type":"Armor","SubType":"NULL"},
5430: {"Type":"Armor","SubType":"NULL"},
5431: {"Type":"Armor","SubType":"NULL"},
5432: {"Type":"Armor","SubType":"NULL"},
5433: {"Type":"Armor","SubType":"NULL"},
5434: {"Type":"Armor","SubType":"NULL"},
5435: {"Type":"Armor","SubType":"NULL"},
5436: {"Type":"Armor","SubType":"NULL"},
5437: {"Type":"Armor","SubType":"NULL"},
5438: {"Type":"Armor","SubType":"NULL"},
5439: {"Type":"Armor","SubType":"NULL"},
5440: {"Type":"Armor","SubType":"NULL"},
5441: {"Type":"Armor","SubType":"NULL"},
5442: {"Type":"Armor","SubType":"NULL"},
5443: {"Type":"Armor","SubType":"NULL"},
5444: {"Type":"Armor","SubType":"NULL"},
5445: {"Type":"Armor","SubType":"NULL"},
5446: {"Type":"Armor","SubType":"NULL"},
5447: {"Type":"Armor","SubType":"NULL"},
5448: {"Type":"Armor","SubType":"NULL"},
5449: {"Type":"Armor","SubType":"NULL"},
5450: {"Type":"Armor","SubType":"NULL"},
5451: {"Type":"Armor","SubType":"NULL"},
5452: {"Type":"Armor","SubType":"NULL"},
5453: {"Type":"Armor","SubType":"NULL"},
5454: {"Type":"Armor","SubType":"NULL"},
5455: {"Type":"Armor","SubType":"NULL"},
5456: {"Type":"Armor","SubType":"NULL"},
5457: {"Type":"Armor","SubType":"NULL"},
5458: {"Type":"Armor","SubType":"NULL"},
5459: {"Type":"Armor","SubType":"NULL"},
5460: {"Type":"Armor","SubType":"NULL"},
5461: {"Type":"Armor","SubType":"NULL"},
5462: {"Type":"Armor","SubType":"NULL"},
5463: {"Type":"Armor","SubType":"NULL"},
5464: {"Type":"Armor","SubType":"NULL"},
5465: {"Type":"Armor","SubType":"NULL"},
5466: {"Type":"Armor","SubType":"NULL"},
5467: {"Type":"Armor","SubType":"NULL"},
5468: {"Type":"Armor","SubType":"NULL"},
5469: {"Type":"Armor","SubType":"NULL"},
5470: {"Type":"Armor","SubType":"NULL"},
5471: {"Type":"Armor","SubType":"NULL"},
5472: {"Type":"Armor","SubType":"NULL"},
5473: {"Type":"Armor","SubType":"NULL"},
5474: {"Type":"Armor","SubType":"NULL"},
5475: {"Type":"Armor","SubType":"NULL"},
5476: {"Type":"Armor","SubType":"NULL"},
5477: {"Type":"Armor","SubType":"NULL"},
5478: {"Type":"Armor","SubType":"NULL"},
5479: {"Type":"Armor","SubType":"NULL"},
5480: {"Type":"Armor","SubType":"NULL"},
5481: {"Type":"Armor","SubType":"NULL"},
5482: {"Type":"Armor","SubType":"NULL"},
5483: {"Type":"Armor","SubType":"NULL"},
5484: {"Type":"Armor","SubType":"NULL"},
5485: {"Type":"Armor","SubType":"NULL"},
5486: {"Type":"Armor","SubType":"NULL"},
5487: {"Type":"Armor","SubType":"NULL"},
5488: {"Type":"Armor","SubType":"NULL"},
5489: {"Type":"Armor","SubType":"NULL"},
5490: {"Type":"Armor","SubType":"NULL"},
5491: {"Type":"Armor","SubType":"NULL"},
5492: {"Type":"Armor","SubType":"NULL"},
5493: {"Type":"Armor","SubType":"NULL"},
5494: {"Type":"Armor","SubType":"NULL"},
5495: {"Type":"Armor","SubType":"NULL"},
5496: {"Type":"Armor","SubType":"NULL"},
5497: {"Type":"Armor","SubType":"NULL"},
5498: {"Type":"Armor","SubType":"NULL"},
5499: {"Type":"Armor","SubType":"NULL"},
5500: {"Type":"Armor","SubType":"NULL"},
5501: {"Type":"Armor","SubType":"NULL"},
5502: {"Type":"Armor","SubType":"NULL"},
5503: {"Type":"Armor","SubType":"NULL"},
5504: {"Type":"Armor","SubType":"NULL"},
5505: {"Type":"Armor","SubType":"NULL"},
5506: {"Type":"Armor","SubType":"NULL"},
5507: {"Type":"Armor","SubType":"NULL"},
5508: {"Type":"Armor","SubType":"NULL"},
5509: {"Type":"Armor","SubType":"NULL"},
5510: {"Type":"Armor","SubType":"NULL"},
5511: {"Type":"Armor","SubType":"NULL"},
5512: {"Type":"Armor","SubType":"NULL"},
5513: {"Type":"Armor","SubType":"NULL"},
5514: {"Type":"Armor","SubType":"NULL"},
5515: {"Type":"Armor","SubType":"NULL"},
5516: {"Type":"Armor","SubType":"NULL"},
5517: {"Type":"Armor","SubType":"NULL"},
5518: {"Type":"Armor","SubType":"NULL"},
5519: {"Type":"Armor","SubType":"NULL"},
5520: {"Type":"Armor","SubType":"NULL"},
5521: {"Type":"Armor","SubType":"NULL"},
5522: {"Type":"Armor","SubType":"NULL"},
5523: {"Type":"Armor","SubType":"NULL"},
5524: {"Type":"Armor","SubType":"NULL"},
5525: {"Type":"Armor","SubType":"NULL"},
5526: {"Type":"Armor","SubType":"NULL"},
5527: {"Type":"Armor","SubType":"NULL"},
5528: {"Type":"Armor","SubType":"NULL"},
5529: {"Type":"Armor","SubType":"NULL"},
5530: {"Type":"Armor","SubType":"NULL"},
5531: {"Type":"Armor","SubType":"NULL"},
5532: {"Type":"Armor","SubType":"NULL"},
5533: {"Type":"Armor","SubType":"NULL"},
5534: {"Type":"Armor","SubType":"NULL"},
5535: {"Type":"Armor","SubType":"NULL"},
5536: {"Type":"Armor","SubType":"NULL"},
5537: {"Type":"Armor","SubType":"NULL"},
5538: {"Type":"Armor","SubType":"NULL"},
5539: {"Type":"Armor","SubType":"NULL"},
5540: {"Type":"Armor","SubType":"NULL"},
5541: {"Type":"Armor","SubType":"NULL"},
5542: {"Type":"Armor","SubType":"NULL"},
5543: {"Type":"Armor","SubType":"NULL"},
5544: {"Type":"Armor","SubType":"NULL"},
5545: {"Type":"Armor","SubType":"NULL"},
5546: {"Type":"Armor","SubType":"NULL"},
5547: {"Type":"Armor","SubType":"NULL"},
5548: {"Type":"Armor","SubType":"NULL"},
5549: {"Type":"Armor","SubType":"NULL"},
5550: {"Type":"Armor","SubType":"NULL"},
5551: {"Type":"Armor","SubType":"NULL"},
5552: {"Type":"Armor","SubType":"NULL"},
5553: {"Type":"Armor","SubType":"NULL"},
5554: {"Type":"Armor","SubType":"NULL"},
5555: {"Type":"Armor","SubType":"NULL"},
5556: {"Type":"Armor","SubType":"NULL"},
5557: {"Type":"Armor","SubType":"NULL"},
5558: {"Type":"Armor","SubType":"NULL"},
5559: {"Type":"Armor","SubType":"NULL"},
5560: {"Type":"Armor","SubType":"NULL"},
5561: {"Type":"Armor","SubType":"NULL"},
5562: {"Type":"Armor","SubType":"NULL"},
5563: {"Type":"Armor","SubType":"NULL"},
5564: {"Type":"Armor","SubType":"NULL"},
5565: {"Type":"Armor","SubType":"NULL"},
5566: {"Type":"Armor","SubType":"NULL"},
5567: {"Type":"Armor","SubType":"NULL"},
5568: {"Type":"Armor","SubType":"NULL"},
5569: {"Type":"Armor","SubType":"NULL"},
5570: {"Type":"Armor","SubType":"NULL"},
5571: {"Type":"Armor","SubType":"NULL"},
5572: {"Type":"Armor","SubType":"NULL"},
5573: {"Type":"Armor","SubType":"NULL"},
5574: {"Type":"Armor","SubType":"NULL"},
5575: {"Type":"Armor","SubType":"NULL"},
5576: {"Type":"Armor","SubType":"NULL"},
5577: {"Type":"Armor","SubType":"NULL"},
5578: {"Type":"Armor","SubType":"NULL"},
5579: {"Type":"Armor","SubType":"NULL"},
5580: {"Type":"Armor","SubType":"NULL"},
5581: {"Type":"Armor","SubType":"NULL"},
5582: {"Type":"Armor","SubType":"NULL"},
5583: {"Type":"Armor","SubType":"NULL"},
5584: {"Type":"Armor","SubType":"NULL"},
5585: {"Type":"Armor","SubType":"NULL"},
5586: {"Type":"Armor","SubType":"NULL"},
5587: {"Type":"Armor","SubType":"NULL"},
5588: {"Type":"Armor","SubType":"NULL"},
5589: {"Type":"Armor","SubType":"NULL"},
5590: {"Type":"Armor","SubType":"NULL"},
5591: {"Type":"Armor","SubType":"NULL"},
5592: {"Type":"Armor","SubType":"NULL"},
5593: {"Type":"Armor","SubType":"NULL"},
5594: {"Type":"Armor","SubType":"NULL"},
5595: {"Type":"Armor","SubType":"NULL"},
5596: {"Type":"Armor","SubType":"NULL"},
5597: {"Type":"Armor","SubType":"NULL"},
5598: {"Type":"Armor","SubType":"NULL"},
5599: {"Type":"Armor","SubType":"NULL"},
5600: {"Type":"Armor","SubType":"NULL"},
5601: {"Type":"Armor","SubType":"NULL"},
5602: {"Type":"Armor","SubType":"NULL"},
5603: {"Type":"Armor","SubType":"NULL"},
5604: {"Type":"Armor","SubType":"NULL"},
5605: {"Type":"Armor","SubType":"NULL"},
5606: {"Type":"Armor","SubType":"NULL"},
5607: {"Type":"Armor","SubType":"NULL"},
5608: {"Type":"Armor","SubType":"NULL"},
5609: {"Type":"Armor","SubType":"NULL"},
5610: {"Type":"Armor","SubType":"NULL"},
5611: {"Type":"Armor","SubType":"NULL"},
5612: {"Type":"Armor","SubType":"NULL"},
5613: {"Type":"Armor","SubType":"NULL"},
5614: {"Type":"Armor","SubType":"NULL"},
5615: {"Type":"Armor","SubType":"NULL"},
5616: {"Type":"Armor","SubType":"NULL"},
5617: {"Type":"Armor","SubType":"NULL"},
5618: {"Type":"Armor","SubType":"NULL"},
5619: {"Type":"Armor","SubType":"NULL"},
5620: {"Type":"Armor","SubType":"NULL"},
5621: {"Type":"Armor","SubType":"NULL"},
5622: {"Type":"Armor","SubType":"NULL"},
5623: {"Type":"Armor","SubType":"NULL"},
5624: {"Type":"Armor","SubType":"NULL"},
5625: {"Type":"Armor","SubType":"NULL"},
5626: {"Type":"Armor","SubType":"NULL"},
5627: {"Type":"Armor","SubType":"NULL"},
5628: {"Type":"Armor","SubType":"NULL"},
5629: {"Type":"Armor","SubType":"NULL"},
5630: {"Type":"Armor","SubType":"NULL"},
5631: {"Type":"Armor","SubType":"NULL"},
5632: {"Type":"Armor","SubType":"NULL"},
5633: {"Type":"Armor","SubType":"NULL"},
5634: {"Type":"Armor","SubType":"NULL"},
5635: {"Type":"Armor","SubType":"NULL"},
5636: {"Type":"Armor","SubType":"NULL"},
5637: {"Type":"Armor","SubType":"NULL"},
5638: {"Type":"Armor","SubType":"NULL"},
5639: {"Type":"Armor","SubType":"NULL"},
5640: {"Type":"Armor","SubType":"NULL"},
5641: {"Type":"Armor","SubType":"NULL"},
5642: {"Type":"Armor","SubType":"NULL"},
5643: {"Type":"Armor","SubType":"NULL"},
5644: {"Type":"Armor","SubType":"NULL"},
5645: {"Type":"Armor","SubType":"NULL"},
5646: {"Type":"Armor","SubType":"NULL"},
5647: {"Type":"Armor","SubType":"NULL"},
5648: {"Type":"Armor","SubType":"NULL"},
5649: {"Type":"Armor","SubType":"NULL"},
5650: {"Type":"Armor","SubType":"NULL"},
5651: {"Type":"Armor","SubType":"NULL"},
5652: {"Type":"Armor","SubType":"NULL"},
5653: {"Type":"Armor","SubType":"NULL"},
5654: {"Type":"Armor","SubType":"NULL"},
5655: {"Type":"Armor","SubType":"NULL"},
5656: {"Type":"Armor","SubType":"NULL"},
5657: {"Type":"Armor","SubType":"NULL"},
5658: {"Type":"Armor","SubType":"NULL"},
5659: {"Type":"Armor","SubType":"NULL"},
5660: {"Type":"Armor","SubType":"NULL"},
5661: {"Type":"Armor","SubType":"NULL"},
5662: {"Type":"Armor","SubType":"NULL"},
5663: {"Type":"Armor","SubType":"NULL"},
5664: {"Type":"Armor","SubType":"NULL"},
5665: {"Type":"Armor","SubType":"NULL"},
5666: {"Type":"Armor","SubType":"NULL"},
5667: {"Type":"Armor","SubType":"NULL"},
5668: {"Type":"Armor","SubType":"NULL"},
5669: {"Type":"Armor","SubType":"NULL"},
5670: {"Type":"Armor","SubType":"NULL"},
5671: {"Type":"Armor","SubType":"NULL"},
5672: {"Type":"Armor","SubType":"NULL"},
5673: {"Type":"Armor","SubType":"NULL"},
5674: {"Type":"Armor","SubType":"NULL"},
5675: {"Type":"Armor","SubType":"NULL"},
5676: {"Type":"Armor","SubType":"NULL"},
5677: {"Type":"Armor","SubType":"NULL"},
5678: {"Type":"Armor","SubType":"NULL"},
5679: {"Type":"Armor","SubType":"NULL"},
5680: {"Type":"Armor","SubType":"NULL"},
5681: {"Type":"Armor","SubType":"NULL"},
5682: {"Type":"Armor","SubType":"NULL"},
5683: {"Type":"Armor","SubType":"NULL"},
5684: {"Type":"Armor","SubType":"NULL"},
5685: {"Type":"Armor","SubType":"NULL"},
5686: {"Type":"Armor","SubType":"NULL"},
5687: {"Type":"Armor","SubType":"NULL"},
5688: {"Type":"Armor","SubType":"NULL"},
5689: {"Type":"Armor","SubType":"NULL"},
5690: {"Type":"Armor","SubType":"NULL"},
5691: {"Type":"Armor","SubType":"NULL"},
5692: {"Type":"Armor","SubType":"NULL"},
5693: {"Type":"Armor","SubType":"NULL"},
5694: {"Type":"Armor","SubType":"NULL"},
5695: {"Type":"Armor","SubType":"NULL"},
5696: {"Type":"Armor","SubType":"NULL"},
5697: {"Type":"Armor","SubType":"NULL"},
5698: {"Type":"Armor","SubType":"NULL"},
5699: {"Type":"Armor","SubType":"NULL"},
5700: {"Type":"Armor","SubType":"NULL"},
5701: {"Type":"Armor","SubType":"NULL"},
5702: {"Type":"Armor","SubType":"NULL"},
5703: {"Type":"Armor","SubType":"NULL"},
5704: {"Type":"Armor","SubType":"NULL"},
5705: {"Type":"Armor","SubType":"NULL"},
5706: {"Type":"Armor","SubType":"NULL"},
5707: {"Type":"Armor","SubType":"NULL"},
5708: {"Type":"Armor","SubType":"NULL"},
5709: {"Type":"Armor","SubType":"NULL"},
5710: {"Type":"Armor","SubType":"NULL"},
5711: {"Type":"Armor","SubType":"NULL"},
5712: {"Type":"Armor","SubType":"NULL"},
5713: {"Type":"Armor","SubType":"NULL"},
5714: {"Type":"Armor","SubType":"NULL"},
5715: {"Type":"Armor","SubType":"NULL"},
5716: {"Type":"Armor","SubType":"NULL"},
5717: {"Type":"Armor","SubType":"NULL"},
5718: {"Type":"Armor","SubType":"NULL"},
5719: {"Type":"Armor","SubType":"NULL"},
5720: {"Type":"Armor","SubType":"NULL"},
5721: {"Type":"Armor","SubType":"NULL"},
5722: {"Type":"Armor","SubType":"NULL"},
5723: {"Type":"Armor","SubType":"NULL"},
5724: {"Type":"Armor","SubType":"NULL"},
5725: {"Type":"Armor","SubType":"NULL"},
5726: {"Type":"Armor","SubType":"NULL"},
5727: {"Type":"Armor","SubType":"NULL"},
5728: {"Type":"Armor","SubType":"NULL"},
5729: {"Type":"Armor","SubType":"NULL"},
5730: {"Type":"Armor","SubType":"NULL"},
5731: {"Type":"Armor","SubType":"NULL"},
5732: {"Type":"Armor","SubType":"NULL"},
5733: {"Type":"Armor","SubType":"NULL"},
5734: {"Type":"Armor","SubType":"NULL"},
5735: {"Type":"Armor","SubType":"NULL"},
5736: {"Type":"Armor","SubType":"NULL"},
5737: {"Type":"Armor","SubType":"NULL"},
5738: {"Type":"Armor","SubType":"NULL"},
5739: {"Type":"Armor","SubType":"NULL"},
5740: {"Type":"Armor","SubType":"NULL"},
5741: {"Type":"Armor","SubType":"NULL"},
5742: {"Type":"Armor","SubType":"NULL"},
5743: {"Type":"Armor","SubType":"NULL"},
5744: {"Type":"Armor","SubType":"NULL"},
5745: {"Type":"Armor","SubType":"NULL"},
5746: {"Type":"Armor","SubType":"NULL"},
5747: {"Type":"Armor","SubType":"NULL"},
5748: {"Type":"Armor","SubType":"NULL"},
5749: {"Type":"Armor","SubType":"NULL"},
5750: {"Type":"Armor","SubType":"NULL"},
5751: {"Type":"Armor","SubType":"NULL"},
5752: {"Type":"Armor","SubType":"NULL"},
5753: {"Type":"Armor","SubType":"NULL"},
5754: {"Type":"Armor","SubType":"NULL"},
5755: {"Type":"Armor","SubType":"NULL"},
5756: {"Type":"Armor","SubType":"NULL"},
5757: {"Type":"Armor","SubType":"NULL"},
5758: {"Type":"Armor","SubType":"NULL"},
5759: {"Type":"Armor","SubType":"NULL"},
5760: {"Type":"Armor","SubType":"NULL"},
5761: {"Type":"Armor","SubType":"NULL"},
5762: {"Type":"Armor","SubType":"NULL"},
5763: {"Type":"Armor","SubType":"NULL"},
5764: {"Type":"Armor","SubType":"NULL"},
5765: {"Type":"Armor","SubType":"NULL"},
5766: {"Type":"Armor","SubType":"NULL"},
5767: {"Type":"Armor","SubType":"NULL"},
5768: {"Type":"Armor","SubType":"NULL"},
5769: {"Type":"Armor","SubType":"NULL"},
5770: {"Type":"Armor","SubType":"NULL"},
5771: {"Type":"Armor","SubType":"NULL"},
5772: {"Type":"Armor","SubType":"NULL"},
5773: {"Type":"Armor","SubType":"NULL"},
5774: {"Type":"Armor","SubType":"NULL"},
5775: {"Type":"Armor","SubType":"NULL"},
5776: {"Type":"Armor","SubType":"NULL"},
5777: {"Type":"Armor","SubType":"NULL"},
5778: {"Type":"Armor","SubType":"NULL"},
5779: {"Type":"Armor","SubType":"NULL"},
5780: {"Type":"Armor","SubType":"NULL"},
5781: {"Type":"Armor","SubType":"NULL"},
5782: {"Type":"Armor","SubType":"NULL"},
5783: {"Type":"Armor","SubType":"NULL"},
5784: {"Type":"Armor","SubType":"NULL"},
5785: {"Type":"Armor","SubType":"NULL"},
5786: {"Type":"Armor","SubType":"NULL"},
5787: {"Type":"Armor","SubType":"NULL"},
5788: {"Type":"Armor","SubType":"NULL"},
5789: {"Type":"Armor","SubType":"NULL"},
5790: {"Type":"Armor","SubType":"NULL"},
5791: {"Type":"Armor","SubType":"NULL"},
5792: {"Type":"Armor","SubType":"NULL"},
5793: {"Type":"Armor","SubType":"NULL"},
5794: {"Type":"Armor","SubType":"NULL"},
5795: {"Type":"Armor","SubType":"NULL"},
5796: {"Type":"Armor","SubType":"NULL"},
5797: {"Type":"Armor","SubType":"NULL"},
5798: {"Type":"Armor","SubType":"NULL"},
5799: {"Type":"Armor","SubType":"NULL"},
5800: {"Type":"Armor","SubType":"NULL"},
5801: {"Type":"Armor","SubType":"NULL"},
5802: {"Type":"Armor","SubType":"NULL"},
5803: {"Type":"Armor","SubType":"NULL"},
5804: {"Type":"Armor","SubType":"NULL"},
5805: {"Type":"Armor","SubType":"NULL"},
5806: {"Type":"Armor","SubType":"NULL"},
5807: {"Type":"Armor","SubType":"NULL"},
5808: {"Type":"Armor","SubType":"NULL"},
5809: {"Type":"Armor","SubType":"NULL"},
5810: {"Type":"Armor","SubType":"NULL"},
5811: {"Type":"Armor","SubType":"NULL"},
5812: {"Type":"Armor","SubType":"NULL"},
5813: {"Type":"Armor","SubType":"NULL"},
5814: {"Type":"Armor","SubType":"NULL"},
5815: {"Type":"Armor","SubType":"NULL"},
5816: {"Type":"Armor","SubType":"NULL"},
5817: {"Type":"Armor","SubType":"NULL"},
5818: {"Type":"Armor","SubType":"NULL"},
5819: {"Type":"Armor","SubType":"NULL"},
5820: {"Type":"Armor","SubType":"NULL"},
5821: {"Type":"Armor","SubType":"NULL"},
5822: {"Type":"Armor","SubType":"NULL"},
5823: {"Type":"Armor","SubType":"NULL"},
5824: {"Type":"Armor","SubType":"NULL"},
5825: {"Type":"Armor","SubType":"NULL"},
5826: {"Type":"Armor","SubType":"NULL"},
5827: {"Type":"Armor","SubType":"NULL"},
5828: {"Type":"Armor","SubType":"NULL"},
5829: {"Type":"Armor","SubType":"NULL"},
5830: {"Type":"Armor","SubType":"NULL"},
5831: {"Type":"Armor","SubType":"NULL"},
5832: {"Type":"Armor","SubType":"NULL"},
5833: {"Type":"Armor","SubType":"NULL"},
5834: {"Type":"Armor","SubType":"NULL"},
5835: {"Type":"Armor","SubType":"NULL"},
5836: {"Type":"Armor","SubType":"NULL"},
5837: {"Type":"Armor","SubType":"NULL"},
5838: {"Type":"Armor","SubType":"NULL"},
5839: {"Type":"Armor","SubType":"NULL"},
5840: {"Type":"Armor","SubType":"NULL"},
5841: {"Type":"Armor","SubType":"NULL"},
5842: {"Type":"Armor","SubType":"NULL"},
5843: {"Type":"Armor","SubType":"NULL"},
5844: {"Type":"Armor","SubType":"NULL"},
5845: {"Type":"Armor","SubType":"NULL"},
5846: {"Type":"Armor","SubType":"NULL"},
5847: {"Type":"Armor","SubType":"NULL"},
5848: {"Type":"Armor","SubType":"NULL"},
5849: {"Type":"Armor","SubType":"NULL"},
5850: {"Type":"Armor","SubType":"NULL"},
5851: {"Type":"Armor","SubType":"NULL"},
5852: {"Type":"Armor","SubType":"NULL"},
5853: {"Type":"Armor","SubType":"NULL"},
5855: {"Type":"Armor","SubType":"NULL"},
5856: {"Type":"Armor","SubType":"NULL"},
5857: {"Type":"Armor","SubType":"NULL"},
5858: {"Type":"Armor","SubType":"NULL"},
5859: {"Type":"Armor","SubType":"NULL"},
5864: {"Type":"Armor","SubType":"NULL"},
5865: {"Type":"Armor","SubType":"NULL"},
5866: {"Type":"Armor","SubType":"NULL"},
5867: {"Type":"Armor","SubType":"NULL"},
5868: {"Type":"Armor","SubType":"NULL"},
5869: {"Type":"Armor","SubType":"NULL"},
5870: {"Type":"Armor","SubType":"NULL"},
5871: {"Type":"Armor","SubType":"NULL"},
5873: {"Type":"Armor","SubType":"NULL"},
5874: {"Type":"Armor","SubType":"NULL"},
5875: {"Type":"Armor","SubType":"NULL"},
5878: {"Type":"Armor","SubType":"NULL"},
5879: {"Type":"Armor","SubType":"NULL"},
5880: {"Type":"Armor","SubType":"NULL"},
5881: {"Type":"Armor","SubType":"NULL"},
5882: {"Type":"Armor","SubType":"NULL"},
5883: {"Type":"Armor","SubType":"NULL"},
5884: {"Type":"Armor","SubType":"NULL"},
5885: {"Type":"Armor","SubType":"NULL"},
5886: {"Type":"Armor","SubType":"NULL"},
5887: {"Type":"Armor","SubType":"NULL"},
5888: {"Type":"Armor","SubType":"NULL"},
5889: {"Type":"Armor","SubType":"NULL"},
5890: {"Type":"Armor","SubType":"NULL"},
5891: {"Type":"Armor","SubType":"NULL"},
5892: {"Type":"Armor","SubType":"NULL"},
5893: {"Type":"Armor","SubType":"NULL"},
5894: {"Type":"Armor","SubType":"NULL"},
5895: {"Type":"Armor","SubType":"NULL"},
5896: {"Type":"Armor","SubType":"NULL"},
5897: {"Type":"Armor","SubType":"NULL"},
5898: {"Type":"Armor","SubType":"NULL"},
5899: {"Type":"Armor","SubType":"NULL"},
5900: {"Type":"Armor","SubType":"NULL"},
5901: {"Type":"Armor","SubType":"NULL"},
5902: {"Type":"Armor","SubType":"NULL"},
5903: {"Type":"Armor","SubType":"NULL"},
5904: {"Type":"Armor","SubType":"NULL"},
5905: {"Type":"Armor","SubType":"NULL"},
5906: {"Type":"Armor","SubType":"NULL"},
5907: {"Type":"Armor","SubType":"NULL"},
5908: {"Type":"Armor","SubType":"NULL"},
5909: {"Type":"Armor","SubType":"NULL"},
5911: {"Type":"Armor","SubType":"NULL"},
5912: {"Type":"Armor","SubType":"NULL"},
5913: {"Type":"Armor","SubType":"NULL"},
5914: {"Type":"Armor","SubType":"NULL"},
5915: {"Type":"Armor","SubType":"NULL"},
5916: {"Type":"Armor","SubType":"NULL"},
5917: {"Type":"Armor","SubType":"NULL"},
5918: {"Type":"Armor","SubType":"NULL"},
5919: {"Type":"Armor","SubType":"NULL"},
5920: {"Type":"Armor","SubType":"NULL"},
5921: {"Type":"Armor","SubType":"NULL"},
5924: {"Type":"Armor","SubType":"NULL"},
5930: {"Type":"Armor","SubType":"NULL"},
5931: {"Type":"Armor","SubType":"NULL"},
5932: {"Type":"Armor","SubType":"NULL"},
5933: {"Type":"Armor","SubType":"NULL"},
5934: {"Type":"Armor","SubType":"NULL"},
5936: {"Type":"Armor","SubType":"NULL"},
5937: {"Type":"Armor","SubType":"NULL"},
5938: {"Type":"Armor","SubType":"NULL"},
5940: {"Type":"Armor","SubType":"NULL"},
5943: {"Type":"Armor","SubType":"NULL"},
5944: {"Type":"Armor","SubType":"NULL"},
5945: {"Type":"Armor","SubType":"NULL"},
5946: {"Type":"Armor","SubType":"NULL"},
5953: {"Type":"Armor","SubType":"NULL"},
5963: {"Type":"Armor","SubType":"NULL"},
5965: {"Type":"Armor","SubType":"NULL"},
5966: {"Type":"Armor","SubType":"NULL"},
5967: {"Type":"Armor","SubType":"NULL"},
5968: {"Type":"Armor","SubType":"NULL"},
5969: {"Type":"Armor","SubType":"NULL"},
5970: {"Type":"Armor","SubType":"NULL"},
5971: {"Type":"Armor","SubType":"NULL"},
5972: {"Type":"Armor","SubType":"NULL"},
5973: {"Type":"Armor","SubType":"NULL"},
5975: {"Type":"Armor","SubType":"NULL"},
5977: {"Type":"Armor","SubType":"NULL"},
5978: {"Type":"Armor","SubType":"NULL"},
5979: {"Type":"Armor","SubType":"NULL"},
5980: {"Type":"Armor","SubType":"NULL"},
5981: {"Type":"Armor","SubType":"NULL"},
5985: {"Type":"Armor","SubType":"NULL"},
5986: {"Type":"Armor","SubType":"NULL"},
6000: {"Type":"Etc","SubType":"NULL"},
6001: {"Type":"Etc","SubType":"NULL"},
6002: {"Type":"Etc","SubType":"NULL"},
6003: {"Type":"Etc","SubType":"NULL"},
6004: {"Type":"Etc","SubType":"NULL"},
6005: {"Type":"Etc","SubType":"NULL"},
6006: {"Type":"Etc","SubType":"NULL"},
6007: {"Type":"Etc","SubType":"NULL"},
6008: {"Type":"Etc","SubType":"NULL"},
6009: {"Type":"Etc","SubType":"NULL"},
6010: {"Type":"Etc","SubType":"NULL"},
6011: {"Type":"Etc","SubType":"NULL"},
6012: {"Type":"Etc","SubType":"NULL"},
6013: {"Type":"Etc","SubType":"NULL"},
6015: {"Type":"Etc","SubType":"NULL"},
6016: {"Type":"Etc","SubType":"NULL"},
6017: {"Type":"Etc","SubType":"NULL"},
6018: {"Type":"Etc","SubType":"NULL"},
6019: {"Type":"Etc","SubType":"NULL"},
6020: {"Type":"Etc","SubType":"NULL"},
6021: {"Type":"Etc","SubType":"NULL"},
6022: {"Type":"Etc","SubType":"NULL"},
6023: {"Type":"Etc","SubType":"NULL"},
6024: {"Type":"Etc","SubType":"NULL"},
6025: {"Type":"Etc","SubType":"NULL"},
6026: {"Type":"Etc","SubType":"NULL"},
6027: {"Type":"Etc","SubType":"NULL"},
6028: {"Type":"Etc","SubType":"NULL"},
6029: {"Type":"Etc","SubType":"NULL"},
6030: {"Type":"Etc","SubType":"NULL"},
6031: {"Type":"Etc","SubType":"NULL"},
6032: {"Type":"Etc","SubType":"NULL"},
6033: {"Type":"Etc","SubType":"NULL"},
6034: {"Type":"Etc","SubType":"NULL"},
6035: {"Type":"Etc","SubType":"NULL"},
6036: {"Type":"Etc","SubType":"NULL"},
6037: {"Type":"Etc","SubType":"NULL"},
6038: {"Type":"Etc","SubType":"NULL"},
6039: {"Type":"Etc","SubType":"NULL"},
6040: {"Type":"Etc","SubType":"NULL"},
6041: {"Type":"Etc","SubType":"NULL"},
6042: {"Type":"Etc","SubType":"NULL"},
6043: {"Type":"Etc","SubType":"NULL"},
6044: {"Type":"Etc","SubType":"NULL"},
6045: {"Type":"Etc","SubType":"NULL"},
6046: {"Type":"Etc","SubType":"NULL"},
6047: {"Type":"Etc","SubType":"NULL"},
6048: {"Type":"Etc","SubType":"NULL"},
6049: {"Type":"Etc","SubType":"NULL"},
6050: {"Type":"Etc","SubType":"NULL"},
6051: {"Type":"Etc","SubType":"NULL"},
6052: {"Type":"Etc","SubType":"NULL"},
6053: {"Type":"Etc","SubType":"NULL"},
6054: {"Type":"Etc","SubType":"NULL"},
6055: {"Type":"Etc","SubType":"NULL"},
6056: {"Type":"Etc","SubType":"NULL"},
6057: {"Type":"Etc","SubType":"NULL"},
6058: {"Type":"Etc","SubType":"NULL"},
6059: {"Type":"Etc","SubType":"NULL"},
6060: {"Type":"Etc","SubType":"NULL"},
6061: {"Type":"Etc","SubType":"NULL"},
6062: {"Type":"Etc","SubType":"NULL"},
6063: {"Type":"Etc","SubType":"NULL"},
6064: {"Type":"Etc","SubType":"NULL"},
6065: {"Type":"Etc","SubType":"NULL"},
6066: {"Type":"Etc","SubType":"NULL"},
6067: {"Type":"Etc","SubType":"NULL"},
6068: {"Type":"Etc","SubType":"NULL"},
6069: {"Type":"Etc","SubType":"NULL"},
6070: {"Type":"Etc","SubType":"NULL"},
6071: {"Type":"Etc","SubType":"NULL"},
6072: {"Type":"Etc","SubType":"NULL"},
6073: {"Type":"Etc","SubType":"NULL"},
6074: {"Type":"Etc","SubType":"NULL"},
6075: {"Type":"Etc","SubType":"NULL"},
6076: {"Type":"Etc","SubType":"NULL"},
6077: {"Type":"Etc","SubType":"NULL"},
6078: {"Type":"Etc","SubType":"NULL"},
6079: {"Type":"Etc","SubType":"NULL"},
6080: {"Type":"Etc","SubType":"NULL"},
6081: {"Type":"Etc","SubType":"NULL"},
6082: {"Type":"Etc","SubType":"NULL"},
6083: {"Type":"Etc","SubType":"NULL"},
6084: {"Type":"Etc","SubType":"NULL"},
6085: {"Type":"Etc","SubType":"NULL"},
6086: {"Type":"Etc","SubType":"NULL"},
6087: {"Type":"Etc","SubType":"NULL"},
6088: {"Type":"Etc","SubType":"NULL"},
6089: {"Type":"Etc","SubType":"NULL"},
6090: {"Type":"Etc","SubType":"NULL"},
6091: {"Type":"Etc","SubType":"NULL"},
6092: {"Type":"Etc","SubType":"NULL"},
6093: {"Type":"Etc","SubType":"NULL"},
6094: {"Type":"Etc","SubType":"NULL"},
6095: {"Type":"Etc","SubType":"NULL"},
6096: {"Type":"Etc","SubType":"NULL"},
6097: {"Type":"Etc","SubType":"NULL"},
6098: {"Type":"Etc","SubType":"NULL"},
6099: {"Type":"Etc","SubType":"NULL"},
6100: {"Type":"Etc","SubType":"NULL"},
6101: {"Type":"Etc","SubType":"NULL"},
6102: {"Type":"Etc","SubType":"NULL"},
6103: {"Type":"Etc","SubType":"NULL"},
6104: {"Type":"Etc","SubType":"NULL"},
6105: {"Type":"Etc","SubType":"NULL"},
6106: {"Type":"Etc","SubType":"NULL"},
6107: {"Type":"Etc","SubType":"NULL"},
6108: {"Type":"Etc","SubType":"NULL"},
6109: {"Type":"Etc","SubType":"NULL"},
6110: {"Type":"Etc","SubType":"NULL"},
6111: {"Type":"Etc","SubType":"NULL"},
6112: {"Type":"Etc","SubType":"NULL"},
6113: {"Type":"Etc","SubType":"NULL"},
6114: {"Type":"Etc","SubType":"NULL"},
6115: {"Type":"Etc","SubType":"NULL"},
6116: {"Type":"Etc","SubType":"NULL"},
6117: {"Type":"Etc","SubType":"NULL"},
6118: {"Type":"Etc","SubType":"NULL"},
6119: {"Type":"Etc","SubType":"NULL"},
6120: {"Type":"Etc","SubType":"NULL"},
6121: {"Type":"Etc","SubType":"NULL"},
6122: {"Type":"Etc","SubType":"NULL"},
6123: {"Type":"Etc","SubType":"NULL"},
6124: {"Type":"Etc","SubType":"NULL"},
6125: {"Type":"Etc","SubType":"NULL"},
6126: {"Type":"Etc","SubType":"NULL"},
6127: {"Type":"Etc","SubType":"NULL"},
6128: {"Type":"Etc","SubType":"NULL"},
6129: {"Type":"Etc","SubType":"NULL"},
6130: {"Type":"Etc","SubType":"NULL"},
6131: {"Type":"Etc","SubType":"NULL"},
6132: {"Type":"Etc","SubType":"NULL"},
6133: {"Type":"Etc","SubType":"NULL"},
6134: {"Type":"Etc","SubType":"NULL"},
6135: {"Type":"Etc","SubType":"NULL"},
6136: {"Type":"Etc","SubType":"NULL"},
6137: {"Type":"Etc","SubType":"NULL"},
6138: {"Type":"Etc","SubType":"NULL"},
6139: {"Type":"Etc","SubType":"NULL"},
6140: {"Type":"Etc","SubType":"NULL"},
6141: {"Type":"Etc","SubType":"NULL"},
6142: {"Type":"Etc","SubType":"NULL"},
6143: {"Type":"Etc","SubType":"NULL"},
6144: {"Type":"Etc","SubType":"NULL"},
6145: {"Type":"Etc","SubType":"NULL"},
6146: {"Type":"Etc","SubType":"NULL"},
6147: {"Type":"Etc","SubType":"NULL"},
6148: {"Type":"Etc","SubType":"NULL"},
6149: {"Type":"Etc","SubType":"NULL"},
6150: {"Type":"Etc","SubType":"NULL"},
6151: {"Type":"Etc","SubType":"NULL"},
6152: {"Type":"Etc","SubType":"NULL"},
6153: {"Type":"Etc","SubType":"NULL"},
6154: {"Type":"Etc","SubType":"NULL"},
6155: {"Type":"Etc","SubType":"NULL"},
6156: {"Type":"Etc","SubType":"NULL"},
6157: {"Type":"Etc","SubType":"NULL"},
6158: {"Type":"Etc","SubType":"NULL"},
6159: {"Type":"Etc","SubType":"NULL"},
6160: {"Type":"Etc","SubType":"NULL"},
6161: {"Type":"Etc","SubType":"NULL"},
6162: {"Type":"Etc","SubType":"NULL"},
6163: {"Type":"Etc","SubType":"NULL"},
6164: {"Type":"Etc","SubType":"NULL"},
6165: {"Type":"Etc","SubType":"NULL"},
6166: {"Type":"Etc","SubType":"NULL"},
6167: {"Type":"Etc","SubType":"NULL"},
6168: {"Type":"Etc","SubType":"NULL"},
6169: {"Type":"Etc","SubType":"NULL"},
6170: {"Type":"Etc","SubType":"NULL"},
6171: {"Type":"Etc","SubType":"NULL"},
6172: {"Type":"Etc","SubType":"NULL"},
6173: {"Type":"Etc","SubType":"NULL"},
6174: {"Type":"Etc","SubType":"NULL"},
6175: {"Type":"Etc","SubType":"NULL"},
6176: {"Type":"Etc","SubType":"NULL"},
6177: {"Type":"Etc","SubType":"NULL"},
6178: {"Type":"Etc","SubType":"NULL"},
6179: {"Type":"Etc","SubType":"NULL"},
6180: {"Type":"Etc","SubType":"NULL"},
6181: {"Type":"Etc","SubType":"NULL"},
6182: {"Type":"Etc","SubType":"NULL"},
6183: {"Type":"Etc","SubType":"NULL"},
6184: {"Type":"Etc","SubType":"NULL"},
6185: {"Type":"Etc","SubType":"NULL"},
6186: {"Type":"Etc","SubType":"NULL"},
6187: {"Type":"Etc","SubType":"NULL"},
6188: {"Type":"Etc","SubType":"NULL"},
6189: {"Type":"Etc","SubType":"NULL"},
6190: {"Type":"Etc","SubType":"NULL"},
6191: {"Type":"Etc","SubType":"NULL"},
6192: {"Type":"Etc","SubType":"NULL"},
6193: {"Type":"Etc","SubType":"NULL"},
6194: {"Type":"Etc","SubType":"NULL"},
6195: {"Type":"Etc","SubType":"NULL"},
6196: {"Type":"Etc","SubType":"NULL"},
6197: {"Type":"Etc","SubType":"NULL"},
6198: {"Type":"Etc","SubType":"NULL"},
6199: {"Type":"Etc","SubType":"NULL"},
6200: {"Type":"Etc","SubType":"NULL"},
6201: {"Type":"Etc","SubType":"NULL"},
6202: {"Type":"Etc","SubType":"NULL"},
6203: {"Type":"Etc","SubType":"NULL"},
6204: {"Type":"Etc","SubType":"NULL"},
6205: {"Type":"Etc","SubType":"NULL"},
6206: {"Type":"Etc","SubType":"NULL"},
6207: {"Type":"Etc","SubType":"NULL"},
6208: {"Type":"Etc","SubType":"NULL"},
6209: {"Type":"Etc","SubType":"NULL"},
6210: {"Type":"Etc","SubType":"NULL"},
6211: {"Type":"Etc","SubType":"NULL"},
6212: {"Type":"Etc","SubType":"NULL"},
6213: {"Type":"Etc","SubType":"NULL"},
6214: {"Type":"Etc","SubType":"NULL"},
6215: {"Type":"Etc","SubType":"NULL"},
6216: {"Type":"Etc","SubType":"NULL"},
6217: {"Type":"Etc","SubType":"NULL"},
6218: {"Type":"Etc","SubType":"NULL"},
6219: {"Type":"Etc","SubType":"NULL"},
6220: {"Type":"Etc","SubType":"NULL"},
6221: {"Type":"Etc","SubType":"NULL"},
6222: {"Type":"Etc","SubType":"NULL"},
6223: {"Type":"Etc","SubType":"NULL"},
6224: {"Type":"Etc","SubType":"NULL"},
6225: {"Type":"Etc","SubType":"NULL"},
6226: {"Type":"Etc","SubType":"NULL"},
6228: {"Type":"Etc","SubType":"NULL"},
6229: {"Type":"Etc","SubType":"NULL"},
6230: {"Type":"Etc","SubType":"NULL"},
6231: {"Type":"Etc","SubType":"NULL"},
6232: {"Type":"Etc","SubType":"NULL"},
6233: {"Type":"Etc","SubType":"NULL"},
6234: {"Type":"Etc","SubType":"NULL"},
6235: {"Type":"Etc","SubType":"NULL"},
6236: {"Type":"Etc","SubType":"NULL"},
6237: {"Type":"Etc","SubType":"NULL"},
6238: {"Type":"Etc","SubType":"NULL"},
6239: {"Type":"Etc","SubType":"NULL"},
6240: {"Type":"Etc","SubType":"NULL"},
6241: {"Type":"Etc","SubType":"NULL"},
6242: {"Type":"Etc","SubType":"NULL"},
6243: {"Type":"Etc","SubType":"NULL"},
6244: {"Type":"Etc","SubType":"NULL"},
6245: {"Type":"Etc","SubType":"NULL"},
6246: {"Type":"Etc","SubType":"NULL"},
6247: {"Type":"Etc","SubType":"NULL"},
6248: {"Type":"Etc","SubType":"NULL"},
6249: {"Type":"Etc","SubType":"NULL"},
6250: {"Type":"Etc","SubType":"NULL"},
6251: {"Type":"Etc","SubType":"NULL"},
6252: {"Type":"Etc","SubType":"NULL"},
6253: {"Type":"Etc","SubType":"NULL"},
6254: {"Type":"Etc","SubType":"NULL"},
6255: {"Type":"Etc","SubType":"NULL"},
6256: {"Type":"Etc","SubType":"NULL"},
6257: {"Type":"Etc","SubType":"NULL"},
6258: {"Type":"Etc","SubType":"NULL"},
6259: {"Type":"Etc","SubType":"NULL"},
6260: {"Type":"Etc","SubType":"NULL"},
6261: {"Type":"Etc","SubType":"NULL"},
6262: {"Type":"Etc","SubType":"NULL"},
6263: {"Type":"Etc","SubType":"NULL"},
6264: {"Type":"Etc","SubType":"NULL"},
6265: {"Type":"Etc","SubType":"NULL"},
6266: {"Type":"Etc","SubType":"NULL"},
6267: {"Type":"Etc","SubType":"NULL"},
6268: {"Type":"Etc","SubType":"NULL"},
6269: {"Type":"Etc","SubType":"NULL"},
6270: {"Type":"Etc","SubType":"NULL"},
6271: {"Type":"Etc","SubType":"NULL"},
6272: {"Type":"Etc","SubType":"NULL"},
6273: {"Type":"Etc","SubType":"NULL"},
6274: {"Type":"Etc","SubType":"NULL"},
6275: {"Type":"Etc","SubType":"NULL"},
6276: {"Type":"Etc","SubType":"NULL"},
6277: {"Type":"Etc","SubType":"NULL"},
6278: {"Type":"Etc","SubType":"NULL"},
6279: {"Type":"Etc","SubType":"NULL"},
6280: {"Type":"Etc","SubType":"NULL"},
6281: {"Type":"Etc","SubType":"NULL"},
6282: {"Type":"Etc","SubType":"NULL"},
6283: {"Type":"Etc","SubType":"NULL"},
6284: {"Type":"Etc","SubType":"NULL"},
6285: {"Type":"Etc","SubType":"NULL"},
6286: {"Type":"Etc","SubType":"NULL"},
6287: {"Type":"Etc","SubType":"NULL"},
6288: {"Type":"Etc","SubType":"NULL"},
6289: {"Type":"Etc","SubType":"NULL"},
6290: {"Type":"Etc","SubType":"NULL"},
6291: {"Type":"Etc","SubType":"NULL"},
6292: {"Type":"Etc","SubType":"NULL"},
6293: {"Type":"Etc","SubType":"NULL"},
6294: {"Type":"Etc","SubType":"NULL"},
6295: {"Type":"Etc","SubType":"NULL"},
6296: {"Type":"Etc","SubType":"NULL"},
6297: {"Type":"Etc","SubType":"NULL"},
6298: {"Type":"Etc","SubType":"NULL"},
6299: {"Type":"Etc","SubType":"NULL"},
6300: {"Type":"Etc","SubType":"NULL"},
6301: {"Type":"Etc","SubType":"NULL"},
6302: {"Type":"Etc","SubType":"NULL"},
6303: {"Type":"Etc","SubType":"NULL"},
6304: {"Type":"Etc","SubType":"NULL"},
6305: {"Type":"Etc","SubType":"NULL"},
6306: {"Type":"Etc","SubType":"NULL"},
6307: {"Type":"Etc","SubType":"NULL"},
6308: {"Type":"Etc","SubType":"NULL"},
6309: {"Type":"Etc","SubType":"NULL"},
6310: {"Type":"Etc","SubType":"NULL"},
6311: {"Type":"Etc","SubType":"NULL"},
6312: {"Type":"Etc","SubType":"NULL"},
6313: {"Type":"Etc","SubType":"NULL"},
6314: {"Type":"Etc","SubType":"NULL"},
6315: {"Type":"Etc","SubType":"NULL"},
6316: {"Type":"Etc","SubType":"NULL"},
6317: {"Type":"Etc","SubType":"NULL"},
6318: {"Type":"Etc","SubType":"NULL"},
6319: {"Type":"Etc","SubType":"NULL"},
6320: {"Type":"Etc","SubType":"NULL"},
6321: {"Type":"Etc","SubType":"NULL"},
6322: {"Type":"Etc","SubType":"NULL"},
6323: {"Type":"Etc","SubType":"NULL"},
6324: {"Type":"Etc","SubType":"NULL"},
6325: {"Type":"Etc","SubType":"NULL"},
6326: {"Type":"Etc","SubType":"NULL"},
6327: {"Type":"Etc","SubType":"NULL"},
6328: {"Type":"Etc","SubType":"NULL"},
6329: {"Type":"Etc","SubType":"NULL"},
6330: {"Type":"Etc","SubType":"NULL"},
6331: {"Type":"Etc","SubType":"NULL"},
6332: {"Type":"Etc","SubType":"NULL"},
6333: {"Type":"Etc","SubType":"NULL"},
6334: {"Type":"Etc","SubType":"NULL"},
6335: {"Type":"Etc","SubType":"NULL"},
6336: {"Type":"Etc","SubType":"NULL"},
6337: {"Type":"Etc","SubType":"NULL"},
6338: {"Type":"Etc","SubType":"NULL"},
6339: {"Type":"Etc","SubType":"NULL"},
6340: {"Type":"Etc","SubType":"NULL"},
6341: {"Type":"Etc","SubType":"NULL"},
6342: {"Type":"Etc","SubType":"NULL"},
6343: {"Type":"Etc","SubType":"NULL"},
6344: {"Type":"Etc","SubType":"NULL"},
6345: {"Type":"Etc","SubType":"NULL"},
6346: {"Type":"Etc","SubType":"NULL"},
6347: {"Type":"Etc","SubType":"NULL"},
6348: {"Type":"Etc","SubType":"NULL"},
6349: {"Type":"Etc","SubType":"NULL"},
6350: {"Type":"Etc","SubType":"NULL"},
6351: {"Type":"Etc","SubType":"NULL"},
6352: {"Type":"Etc","SubType":"NULL"},
6353: {"Type":"Etc","SubType":"NULL"},
6354: {"Type":"Etc","SubType":"NULL"},
6355: {"Type":"Etc","SubType":"NULL"},
6356: {"Type":"Etc","SubType":"NULL"},
6357: {"Type":"Etc","SubType":"NULL"},
6358: {"Type":"Etc","SubType":"NULL"},
6359: {"Type":"Etc","SubType":"NULL"},
6360: {"Type":"Etc","SubType":"NULL"},
6361: {"Type":"Etc","SubType":"NULL"},
6362: {"Type":"Etc","SubType":"NULL"},
6363: {"Type":"Etc","SubType":"NULL"},
6364: {"Type":"Etc","SubType":"NULL"},
6365: {"Type":"Etc","SubType":"NULL"},
6366: {"Type":"Etc","SubType":"NULL"},
6367: {"Type":"Etc","SubType":"NULL"},
6368: {"Type":"Etc","SubType":"NULL"},
6369: {"Type":"Etc","SubType":"NULL"},
6370: {"Type":"Etc","SubType":"NULL"},
6371: {"Type":"Etc","SubType":"NULL"},
6372: {"Type":"Etc","SubType":"NULL"},
6373: {"Type":"Etc","SubType":"NULL"},
6374: {"Type":"Etc","SubType":"NULL"},
6375: {"Type":"Etc","SubType":"NULL"},
6376: {"Type":"Etc","SubType":"NULL"},
6377: {"Type":"Etc","SubType":"NULL"},
6378: {"Type":"Etc","SubType":"NULL"},
6379: {"Type":"Etc","SubType":"NULL"},
6380: {"Type":"Etc","SubType":"NULL"},
6381: {"Type":"Etc","SubType":"NULL"},
6382: {"Type":"Etc","SubType":"NULL"},
6383: {"Type":"Etc","SubType":"NULL"},
6384: {"Type":"Etc","SubType":"NULL"},
6385: {"Type":"Etc","SubType":"NULL"},
6386: {"Type":"Etc","SubType":"NULL"},
6387: {"Type":"Etc","SubType":"NULL"},
6388: {"Type":"Etc","SubType":"NULL"},
6389: {"Type":"Etc","SubType":"NULL"},
6390: {"Type":"Etc","SubType":"NULL"},
6391: {"Type":"Etc","SubType":"NULL"},
6392: {"Type":"Etc","SubType":"NULL"},
6393: {"Type":"Etc","SubType":"NULL"},
6394: {"Type":"Etc","SubType":"NULL"},
6395: {"Type":"Etc","SubType":"NULL"},
6396: {"Type":"Etc","SubType":"NULL"},
6397: {"Type":"Etc","SubType":"NULL"},
6398: {"Type":"Etc","SubType":"NULL"},
6399: {"Type":"Etc","SubType":"NULL"},
6400: {"Type":"Etc","SubType":"NULL"},
6401: {"Type":"Etc","SubType":"NULL"},
6402: {"Type":"Etc","SubType":"NULL"},
6403: {"Type":"Etc","SubType":"NULL"},
6404: {"Type":"Etc","SubType":"NULL"},
6405: {"Type":"Etc","SubType":"NULL"},
6406: {"Type":"Etc","SubType":"NULL"},
6407: {"Type":"Etc","SubType":"NULL"},
6408: {"Type":"Etc","SubType":"NULL"},
6409: {"Type":"Etc","SubType":"NULL"},
6410: {"Type":"Etc","SubType":"NULL"},
6411: {"Type":"Etc","SubType":"NULL"},
6412: {"Type":"Etc","SubType":"NULL"},
6413: {"Type":"Etc","SubType":"NULL"},
6414: {"Type":"Etc","SubType":"NULL"},
6415: {"Type":"Etc","SubType":"NULL"},
6416: {"Type":"Etc","SubType":"NULL"},
6417: {"Type":"Etc","SubType":"NULL"},
6418: {"Type":"Etc","SubType":"NULL"},
6419: {"Type":"Etc","SubType":"NULL"},
6420: {"Type":"Etc","SubType":"NULL"},
6421: {"Type":"Etc","SubType":"NULL"},
6422: {"Type":"Etc","SubType":"NULL"},
6423: {"Type":"Etc","SubType":"NULL"},
6424: {"Type":"Etc","SubType":"NULL"},
6425: {"Type":"Etc","SubType":"NULL"},
6426: {"Type":"Etc","SubType":"NULL"},
6427: {"Type":"Etc","SubType":"NULL"},
6428: {"Type":"Etc","SubType":"NULL"},
6429: {"Type":"Etc","SubType":"NULL"},
6430: {"Type":"Etc","SubType":"NULL"},
6431: {"Type":"Etc","SubType":"NULL"},
6432: {"Type":"Etc","SubType":"NULL"},
6433: {"Type":"Etc","SubType":"NULL"},
6434: {"Type":"Etc","SubType":"NULL"},
6435: {"Type":"Etc","SubType":"NULL"},
6436: {"Type":"Etc","SubType":"NULL"},
6437: {"Type":"Etc","SubType":"NULL"},
6438: {"Type":"Etc","SubType":"NULL"},
6439: {"Type":"Etc","SubType":"NULL"},
6440: {"Type":"Etc","SubType":"NULL"},
6441: {"Type":"Etc","SubType":"NULL"},
6442: {"Type":"Etc","SubType":"NULL"},
6443: {"Type":"Etc","SubType":"NULL"},
6444: {"Type":"Etc","SubType":"NULL"},
6445: {"Type":"Etc","SubType":"NULL"},
6446: {"Type":"Etc","SubType":"NULL"},
6447: {"Type":"Etc","SubType":"NULL"},
6448: {"Type":"Etc","SubType":"NULL"},
6449: {"Type":"Etc","SubType":"NULL"},
6450: {"Type":"Etc","SubType":"NULL"},
6451: {"Type":"Etc","SubType":"NULL"},
6452: {"Type":"Etc","SubType":"NULL"},
6453: {"Type":"Etc","SubType":"NULL"},
6454: {"Type":"Etc","SubType":"NULL"},
6455: {"Type":"Etc","SubType":"NULL"},
6456: {"Type":"Etc","SubType":"NULL"},
6457: {"Type":"Etc","SubType":"NULL"},
6459: {"Type":"Etc","SubType":"NULL"},
6460: {"Type":"Etc","SubType":"NULL"},
6461: {"Type":"Etc","SubType":"NULL"},
6462: {"Type":"Etc","SubType":"NULL"},
6463: {"Type":"Etc","SubType":"NULL"},
6464: {"Type":"Etc","SubType":"NULL"},
6465: {"Type":"Etc","SubType":"NULL"},
6466: {"Type":"Etc","SubType":"NULL"},
6467: {"Type":"Etc","SubType":"NULL"},
6468: {"Type":"Etc","SubType":"NULL"},
6469: {"Type":"Etc","SubType":"NULL"},
6470: {"Type":"Etc","SubType":"NULL"},
6471: {"Type":"Etc","SubType":"NULL"},
6472: {"Type":"Etc","SubType":"NULL"},
6473: {"Type":"Etc","SubType":"NULL"},
6474: {"Type":"Etc","SubType":"NULL"},
6475: {"Type":"Etc","SubType":"NULL"},
6476: {"Type":"Etc","SubType":"NULL"},
6477: {"Type":"Etc","SubType":"NULL"},
6478: {"Type":"Etc","SubType":"NULL"},
6479: {"Type":"Etc","SubType":"NULL"},
6480: {"Type":"Etc","SubType":"NULL"},
6481: {"Type":"Etc","SubType":"NULL"},
6482: {"Type":"Etc","SubType":"NULL"},
6483: {"Type":"Etc","SubType":"NULL"},
6484: {"Type":"Etc","SubType":"NULL"},
6485: {"Type":"Etc","SubType":"NULL"},
6486: {"Type":"Etc","SubType":"NULL"},
6487: {"Type":"Etc","SubType":"NULL"},
6488: {"Type":"Etc","SubType":"NULL"},
6489: {"Type":"Etc","SubType":"NULL"},
6490: {"Type":"Etc","SubType":"NULL"},
6491: {"Type":"Etc","SubType":"NULL"},
6492: {"Type":"Etc","SubType":"NULL"},
6493: {"Type":"Etc","SubType":"NULL"},
6494: {"Type":"Etc","SubType":"NULL"},
6495: {"Type":"Etc","SubType":"NULL"},
6496: {"Type":"Etc","SubType":"NULL"},
6497: {"Type":"Etc","SubType":"NULL"},
6498: {"Type":"Etc","SubType":"NULL"},
6499: {"Type":"Etc","SubType":"NULL"},
6500: {"Type":"Etc","SubType":"NULL"},
6501: {"Type":"Etc","SubType":"NULL"},
6502: {"Type":"Etc","SubType":"NULL"},
6503: {"Type":"Etc","SubType":"NULL"},
6504: {"Type":"Etc","SubType":"NULL"},
6505: {"Type":"Etc","SubType":"NULL"},
6506: {"Type":"Etc","SubType":"NULL"},
6507: {"Type":"Etc","SubType":"NULL"},
6508: {"Type":"Etc","SubType":"NULL"},
6509: {"Type":"Etc","SubType":"NULL"},
6510: {"Type":"Etc","SubType":"NULL"},
6511: {"Type":"Etc","SubType":"NULL"},
6512: {"Type":"Etc","SubType":"NULL"},
6513: {"Type":"Etc","SubType":"NULL"},
6514: {"Type":"Etc","SubType":"NULL"},
6515: {"Type":"Etc","SubType":"NULL"},
6516: {"Type":"Etc","SubType":"NULL"},
6517: {"Type":"Etc","SubType":"NULL"},
6518: {"Type":"Etc","SubType":"NULL"},
6519: {"Type":"Etc","SubType":"NULL"},
6520: {"Type":"Etc","SubType":"NULL"},
6521: {"Type":"Etc","SubType":"NULL"},
6522: {"Type":"Etc","SubType":"NULL"},
6523: {"Type":"Etc","SubType":"NULL"},
6524: {"Type":"Etc","SubType":"NULL"},
6525: {"Type":"Etc","SubType":"NULL"},
6526: {"Type":"Etc","SubType":"NULL"},
6527: {"Type":"Etc","SubType":"NULL"},
6528: {"Type":"Etc","SubType":"NULL"},
6529: {"Type":"Etc","SubType":"NULL"},
6530: {"Type":"Etc","SubType":"NULL"},
6531: {"Type":"Etc","SubType":"NULL"},
6532: {"Type":"Etc","SubType":"NULL"},
6533: {"Type":"Etc","SubType":"NULL"},
6534: {"Type":"Etc","SubType":"NULL"},
6535: {"Type":"Etc","SubType":"NULL"},
6536: {"Type":"Etc","SubType":"NULL"},
6537: {"Type":"Etc","SubType":"NULL"},
6538: {"Type":"Etc","SubType":"NULL"},
6539: {"Type":"Etc","SubType":"NULL"},
6540: {"Type":"Etc","SubType":"NULL"},
6541: {"Type":"Etc","SubType":"NULL"},
6542: {"Type":"Etc","SubType":"NULL"},
6543: {"Type":"Etc","SubType":"NULL"},
6544: {"Type":"Etc","SubType":"NULL"},
6545: {"Type":"Etc","SubType":"NULL"},
6546: {"Type":"Etc","SubType":"NULL"},
6547: {"Type":"Etc","SubType":"NULL"},
6548: {"Type":"Etc","SubType":"NULL"},
6549: {"Type":"Etc","SubType":"NULL"},
6550: {"Type":"Etc","SubType":"NULL"},
6551: {"Type":"Etc","SubType":"NULL"},
6552: {"Type":"Etc","SubType":"NULL"},
6553: {"Type":"Etc","SubType":"NULL"},
6554: {"Type":"Etc","SubType":"NULL"},
6555: {"Type":"Etc","SubType":"NULL"},
6556: {"Type":"Etc","SubType":"NULL"},
6557: {"Type":"Etc","SubType":"NULL"},
6558: {"Type":"Etc","SubType":"NULL"},
6559: {"Type":"Etc","SubType":"NULL"},
6560: {"Type":"Etc","SubType":"NULL"},
6561: {"Type":"Etc","SubType":"NULL"},
6562: {"Type":"Etc","SubType":"NULL"},
6563: {"Type":"Etc","SubType":"NULL"},
6564: {"Type":"Etc","SubType":"NULL"},
6565: {"Type":"Etc","SubType":"NULL"},
6566: {"Type":"Etc","SubType":"NULL"},
6567: {"Type":"Etc","SubType":"NULL"},
6581: {"Type":"Etc","SubType":"NULL"},
6583: {"Type":"Etc","SubType":"NULL"},
6584: {"Type":"Etc","SubType":"NULL"},
6585: {"Type":"Etc","SubType":"NULL"},
6586: {"Type":"Etc","SubType":"NULL"},
6592: {"Type":"Etc","SubType":"NULL"},
6593: {"Type":"Etc","SubType":"NULL"},
6594: {"Type":"Etc","SubType":"NULL"},
6595: {"Type":"Etc","SubType":"NULL"},
6596: {"Type":"Etc","SubType":"NULL"},
6597: {"Type":"Etc","SubType":"NULL"},
6598: {"Type":"Etc","SubType":"NULL"},
6599: {"Type":"Etc","SubType":"NULL"},
6600: {"Type":"Etc","SubType":"NULL"},
6601: {"Type":"Etc","SubType":"NULL"},
6602: {"Type":"Etc","SubType":"NULL"},
6603: {"Type":"Etc","SubType":"NULL"},
6604: {"Type":"Etc","SubType":"NULL"},
6605: {"Type":"Etc","SubType":"NULL"},
6606: {"Type":"Etc","SubType":"NULL"},
6607: {"Type":"Etc","SubType":"NULL"},
6608: {"Type":"Etc","SubType":"NULL"},
6609: {"Type":"Etc","SubType":"NULL"},
6610: {"Type":"Etc","SubType":"NULL"},
6611: {"Type":"Etc","SubType":"NULL"},
6612: {"Type":"Etc","SubType":"NULL"},
6613: {"Type":"Etc","SubType":"NULL"},
6615: {"Type":"Etc","SubType":"NULL"},
6616: {"Type":"Etc","SubType":"NULL"},
6617: {"Type":"Etc","SubType":"NULL"},
6618: {"Type":"Etc","SubType":"NULL"},
6619: {"Type":"Etc","SubType":"NULL"},
6623: {"Type":"Etc","SubType":"NULL"},
6624: {"Type":"Etc","SubType":"NULL"},
6625: {"Type":"Etc","SubType":"NULL"},
6635: {"Type":"Etc","SubType":"NULL"},
6636: {"Type":"Etc","SubType":"NULL"},
6637: {"Type":"Etc","SubType":"NULL"},
6638: {"Type":"Etc","SubType":"NULL"},
6639: {"Type":"Etc","SubType":"NULL"},
6640: {"Type":"Etc","SubType":"NULL"},
6641: {"Type":"Etc","SubType":"NULL"},
6642: {"Type":"Etc","SubType":"NULL"},
6643: {"Type":"Etc","SubType":"NULL"},
6644: {"Type":"Etc","SubType":"NULL"},
6645: {"Type":"Etc","SubType":"NULL"},
6646: {"Type":"Etc","SubType":"NULL"},
6648: {"Type":"Etc","SubType":"NULL"},
6649: {"Type":"Etc","SubType":"NULL"},
6650: {"Type":"Etc","SubType":"NULL"},
6651: {"Type":"Etc","SubType":"NULL"},
6652: {"Type":"Etc","SubType":"NULL"},
6653: {"Type":"Etc","SubType":"NULL"},
6654: {"Type":"Etc","SubType":"NULL"},
6655: {"Type":"Etc","SubType":"NULL"},
6656: {"Type":"Etc","SubType":"NULL"},
6657: {"Type":"Etc","SubType":"NULL"},
6658: {"Type":"Etc","SubType":"NULL"},
6665: {"Type":"Etc","SubType":"NULL"},
6669: {"Type":"Etc","SubType":"NULL"},
6671: {"Type":"Etc","SubType":"NULL"},
6672: {"Type":"Etc","SubType":"NULL"},
6673: {"Type":"Etc","SubType":"NULL"},
6674: {"Type":"Etc","SubType":"NULL"},
6681: {"Type":"Etc","SubType":"NULL"},
6682: {"Type":"Etc","SubType":"NULL"},
6683: {"Type":"Etc","SubType":"NULL"},
6684: {"Type":"Etc","SubType":"NULL"},
6685: {"Type":"Etc","SubType":"NULL"},
6686: {"Type":"Etc","SubType":"NULL"},
6687: {"Type":"Etc","SubType":"NULL"},
6688: {"Type":"Etc","SubType":"NULL"},
6689: {"Type":"Etc","SubType":"NULL"},
6690: {"Type":"Etc","SubType":"NULL"},
6691: {"Type":"Etc","SubType":"NULL"},
6692: {"Type":"Etc","SubType":"NULL"},
6693: {"Type":"Etc","SubType":"NULL"},
6694: {"Type":"Etc","SubType":"NULL"},
6695: {"Type":"Etc","SubType":"NULL"},
6696: {"Type":"Etc","SubType":"NULL"},
6697: {"Type":"Etc","SubType":"NULL"},
6698: {"Type":"Etc","SubType":"NULL"},
6699: {"Type":"Etc","SubType":"NULL"},
6700: {"Type":"Etc","SubType":"NULL"},
6701: {"Type":"Etc","SubType":"NULL"},
6702: {"Type":"Etc","SubType":"NULL"},
6703: {"Type":"Etc","SubType":"NULL"},
6704: {"Type":"Etc","SubType":"NULL"},
6705: {"Type":"Etc","SubType":"NULL"},
6706: {"Type":"Etc","SubType":"NULL"},
6707: {"Type":"Etc","SubType":"NULL"},
6708: {"Type":"Etc","SubType":"NULL"},
6709: {"Type":"Etc","SubType":"NULL"},
6710: {"Type":"Etc","SubType":"NULL"},
6712: {"Type":"Etc","SubType":"NULL"},
6713: {"Type":"Etc","SubType":"NULL"},
6714: {"Type":"Etc","SubType":"NULL"},
6715: {"Type":"Etc","SubType":"NULL"},
6716: {"Type":"Card","SubType":"NULL"},
6717: {"Type":"Card","SubType":"NULL"},
6718: {"Type":"Card","SubType":"NULL"},
6719: {"Type":"Etc","SubType":"NULL"},
6720: {"Type":"Etc","SubType":"NULL"},
6721: {"Type":"Etc","SubType":"NULL"},
6722: {"Type":"Etc","SubType":"NULL"},
6723: {"Type":"Etc","SubType":"NULL"},
6724: {"Type":"Etc","SubType":"NULL"},
6725: {"Type":"Etc","SubType":"NULL"},
6726: {"Type":"Etc","SubType":"NULL"},
6727: {"Type":"Etc","SubType":"NULL"},
6732: {"Type":"Etc","SubType":"NULL"},
6733: {"Type":"Etc","SubType":"NULL"},
6734: {"Type":"Etc","SubType":"NULL"},
6735: {"Type":"Etc","SubType":"NULL"},
6736: {"Type":"Etc","SubType":"NULL"},
6737: {"Type":"Etc","SubType":"NULL"},
6738: {"Type":"Etc","SubType":"NULL"},
6739: {"Type":"Etc","SubType":"NULL"},
6740: {"Type":"Card","SubType":"NULL"},
6741: {"Type":"Card","SubType":"NULL"},
6742: {"Type":"Card","SubType":"NULL"},
6743: {"Type":"Card","SubType":"NULL"},
6744: {"Type":"Card","SubType":"NULL"},
6745: {"Type":"Card","SubType":"NULL"},
6746: {"Type":"Etc","SubType":"NULL"},
6747: {"Type":"Etc","SubType":"NULL"},
6748: {"Type":"Etc","SubType":"NULL"},
6749: {"Type":"Etc","SubType":"NULL"},
6750: {"Type":"Etc","SubType":"NULL"},
6751: {"Type":"Etc","SubType":"NULL"},
6752: {"Type":"Etc","SubType":"NULL"},
6753: {"Type":"Etc","SubType":"NULL"},
6754: {"Type":"Etc","SubType":"NULL"},
6755: {"Type":"Etc","SubType":"NULL"},
6756: {"Type":"Etc","SubType":"NULL"},
6757: {"Type":"Etc","SubType":"NULL"},
6762: {"Type":"Etc","SubType":"NULL"},
6763: {"Type":"Etc","SubType":"NULL"},
6764: {"Type":"Etc","SubType":"NULL"},
6765: {"Type":"Etc","SubType":"NULL"},
6766: {"Type":"Etc","SubType":"NULL"},
6767: {"Type":"Etc","SubType":"NULL"},
6768: {"Type":"Etc","SubType":"NULL"},
6769: {"Type":"Etc","SubType":"NULL"},
6770: {"Type":"Etc","SubType":"NULL"},
6771: {"Type":"Etc","SubType":"NULL"},
6772: {"Type":"Etc","SubType":"NULL"},
6773: {"Type":"Etc","SubType":"NULL"},
6774: {"Type":"Etc","SubType":"NULL"},
6775: {"Type":"Etc","SubType":"NULL"},
6776: {"Type":"Etc","SubType":"NULL"},
6777: {"Type":"Etc","SubType":"NULL"},
6778: {"Type":"Etc","SubType":"NULL"},
6779: {"Type":"Etc","SubType":"NULL"},
6780: {"Type":"Etc","SubType":"NULL"},
6781: {"Type":"Etc","SubType":"NULL"},
6782: {"Type":"Etc","SubType":"NULL"},
6784: {"Type":"Etc","SubType":"NULL"},
6785: {"Type":"Etc","SubType":"NULL"},
6786: {"Type":"Etc","SubType":"NULL"},
6787: {"Type":"Etc","SubType":"NULL"},
6788: {"Type":"Etc","SubType":"NULL"},
6789: {"Type":"Etc","SubType":"NULL"},
6790: {"Type":"Card","SubType":"NULL"},
6791: {"Type":"Card","SubType":"NULL"},
6792: {"Type":"Card","SubType":"NULL"},
6795: {"Type":"Etc","SubType":"NULL"},
6796: {"Type":"Etc","SubType":"NULL"},
6797: {"Type":"Etc","SubType":"NULL"},
6803: {"Type":"Etc","SubType":"NULL"},
6804: {"Type":"Etc","SubType":"NULL"},
6805: {"Type":"Etc","SubType":"NULL"},
6813: {"Type":"Etc","SubType":"NULL"},
6814: {"Type":"Etc","SubType":"NULL"},
6815: {"Type":"Etc","SubType":"NULL"},
6816: {"Type":"Etc","SubType":"NULL"},
6817: {"Type":"Etc","SubType":"NULL"},
6818: {"Type":"Etc","SubType":"NULL"},
6819: {"Type":"Etc","SubType":"NULL"},
6820: {"Type":"Etc","SubType":"NULL"},
6821: {"Type":"Etc","SubType":"NULL"},
6824: {"Type":"Etc","SubType":"NULL"},
6825: {"Type":"Etc","SubType":"NULL"},
6826: {"Type":"Etc","SubType":"NULL"},
6827: {"Type":"Etc","SubType":"NULL"},
6828: {"Type":"Etc","SubType":"NULL"},
6832: {"Type":"Etc","SubType":"NULL"},
6833: {"Type":"Etc","SubType":"NULL"},
6834: {"Type":"Etc","SubType":"NULL"},
6835: {"Type":"Etc","SubType":"NULL"},
6836: {"Type":"Etc","SubType":"NULL"},
6837: {"Type":"Etc","SubType":"NULL"},
6838: {"Type":"Etc","SubType":"NULL"},
6839: {"Type":"Etc","SubType":"NULL"},
6840: {"Type":"Etc","SubType":"NULL"},
6841: {"Type":"Etc","SubType":"NULL"},
6842: {"Type":"Etc","SubType":"NULL"},
6843: {"Type":"Etc","SubType":"NULL"},
6844: {"Type":"Etc","SubType":"NULL"},
6845: {"Type":"Etc","SubType":"NULL"},
6846: {"Type":"Card","SubType":"NULL"},
6847: {"Type":"Etc","SubType":"NULL"},
6848: {"Type":"Etc","SubType":"NULL"},
6849: {"Type":"Etc","SubType":"NULL"},
6850: {"Type":"Etc","SubType":"NULL"},
6851: {"Type":"Etc","SubType":"NULL"},
6852: {"Type":"Etc","SubType":"NULL"},
6853: {"Type":"Etc","SubType":"NULL"},
6854: {"Type":"Etc","SubType":"NULL"},
6855: {"Type":"Etc","SubType":"NULL"},
6856: {"Type":"Etc","SubType":"NULL"},
6857: {"Type":"Etc","SubType":"NULL"},
6858: {"Type":"Etc","SubType":"NULL"},
6859: {"Type":"Etc","SubType":"NULL"},
6860: {"Type":"Etc","SubType":"NULL"},
6862: {"Type":"Etc","SubType":"NULL"},
6863: {"Type":"Etc","SubType":"NULL"},
6864: {"Type":"Etc","SubType":"NULL"},
6865: {"Type":"Etc","SubType":"NULL"},
6866: {"Type":"Etc","SubType":"NULL"},
6867: {"Type":"Etc","SubType":"NULL"},
6868: {"Type":"Etc","SubType":"NULL"},
6869: {"Type":"Etc","SubType":"NULL"},
6870: {"Type":"Etc","SubType":"NULL"},
6871: {"Type":"Etc","SubType":"NULL"},
6872: {"Type":"Etc","SubType":"NULL"},
6873: {"Type":"Etc","SubType":"NULL"},
6874: {"Type":"Etc","SubType":"NULL"},
6875: {"Type":"Etc","SubType":"NULL"},
6876: {"Type":"Etc","SubType":"NULL"},
6877: {"Type":"Etc","SubType":"NULL"},
6878: {"Type":"Etc","SubType":"NULL"},
6879: {"Type":"Etc","SubType":"NULL"},
6880: {"Type":"Etc","SubType":"NULL"},
6881: {"Type":"Etc","SubType":"NULL"},
6882: {"Type":"Etc","SubType":"NULL"},
6883: {"Type":"Etc","SubType":"NULL"},
6884: {"Type":"Etc","SubType":"NULL"},
6885: {"Type":"Etc","SubType":"NULL"},
6886: {"Type":"Etc","SubType":"NULL"},
6892: {"Type":"Etc","SubType":"NULL"},
6893: {"Type":"Etc","SubType":"NULL"},
6894: {"Type":"Etc","SubType":"NULL"},
6895: {"Type":"Etc","SubType":"NULL"},
6896: {"Type":"Etc","SubType":"NULL"},
6897: {"Type":"Etc","SubType":"NULL"},
6898: {"Type":"Etc","SubType":"NULL"},
6899: {"Type":"Etc","SubType":"NULL"},
6900: {"Type":"Etc","SubType":"NULL"},
6901: {"Type":"Etc","SubType":"NULL"},
6902: {"Type":"Etc","SubType":"NULL"},
6903: {"Type":"Etc","SubType":"NULL"},
6904: {"Type":"Etc","SubType":"NULL"},
6905: {"Type":"Etc","SubType":"NULL"},
6906: {"Type":"Etc","SubType":"NULL"},
6907: {"Type":"Etc","SubType":"NULL"},
6908: {"Type":"Card","SubType":"NULL"},
6909: {"Type":"Etc","SubType":"NULL"},
6910: {"Type":"Etc","SubType":"NULL"},
6911: {"Type":"Etc","SubType":"NULL"},
6912: {"Type":"Etc","SubType":"NULL"},
6913: {"Type":"Etc","SubType":"NULL"},
6914: {"Type":"Etc","SubType":"NULL"},
6915: {"Type":"Etc","SubType":"NULL"},
6916: {"Type":"Etc","SubType":"NULL"},
6917: {"Type":"Etc","SubType":"NULL"},
6919: {"Type":"Etc","SubType":"NULL"},
6920: {"Type":"Etc","SubType":"NULL"},
6921: {"Type":"Etc","SubType":"NULL"},
6922: {"Type":"Etc","SubType":"NULL"},
6923: {"Type":"Etc","SubType":"NULL"},
6924: {"Type":"Etc","SubType":"NULL"},
6925: {"Type":"Etc","SubType":"NULL"},
6926: {"Type":"Etc","SubType":"NULL"},
6927: {"Type":"Etc","SubType":"NULL"},
6928: {"Type":"Etc","SubType":"NULL"},
6929: {"Type":"Etc","SubType":"NULL"},
6930: {"Type":"Etc","SubType":"NULL"},
6931: {"Type":"Etc","SubType":"NULL"},
6932: {"Type":"Etc","SubType":"NULL"},
6933: {"Type":"Etc","SubType":"NULL"},
6934: {"Type":"Etc","SubType":"NULL"},
6935: {"Type":"Etc","SubType":"NULL"},
6936: {"Type":"Etc","SubType":"NULL"},
6937: {"Type":"Etc","SubType":"NULL"},
6938: {"Type":"Etc","SubType":"NULL"},
6939: {"Type":"Etc","SubType":"NULL"},
6940: {"Type":"Etc","SubType":"NULL"},
6941: {"Type":"Etc","SubType":"NULL"},
6942: {"Type":"Etc","SubType":"NULL"},
6943: {"Type":"Card","SubType":"NULL"},
6944: {"Type":"Card","SubType":"NULL"},
6945: {"Type":"Card","SubType":"NULL"},
6946: {"Type":"Card","SubType":"NULL"},
6947: {"Type":"Card","SubType":"NULL"},
6948: {"Type":"Card","SubType":"NULL"},
6949: {"Type":"Card","SubType":"NULL"},
6950: {"Type":"Card","SubType":"NULL"},
6951: {"Type":"Card","SubType":"NULL"},
6953: {"Type":"Etc","SubType":"NULL"},
6954: {"Type":"Etc","SubType":"NULL"},
6955: {"Type":"Etc","SubType":"NULL"},
6956: {"Type":"Etc","SubType":"NULL"},
6957: {"Type":"Etc","SubType":"NULL"},
6958: {"Type":"Etc","SubType":"NULL"},
6959: {"Type":"Etc","SubType":"NULL"},
6960: {"Type":"Etc","SubType":"NULL"},
6961: {"Type":"Etc","SubType":"NULL"},
6962: {"Type":"Etc","SubType":"NULL"},
6963: {"Type":"Etc","SubType":"NULL"},
6964: {"Type":"Etc","SubType":"NULL"},
6965: {"Type":"Etc","SubType":"NULL"},
6966: {"Type":"Etc","SubType":"NULL"},
6967: {"Type":"Etc","SubType":"NULL"},
6968: {"Type":"Etc","SubType":"NULL"},
6969: {"Type":"Etc","SubType":"NULL"},
6970: {"Type":"Etc","SubType":"NULL"},
6971: {"Type":"Etc","SubType":"NULL"},
6972: {"Type":"Etc","SubType":"NULL"},
6973: {"Type":"Etc","SubType":"NULL"},
6974: {"Type":"Etc","SubType":"NULL"},
6975: {"Type":"Etc","SubType":"NULL"},
6976: {"Type":"Etc","SubType":"NULL"},
6977: {"Type":"Etc","SubType":"NULL"},
6978: {"Type":"Etc","SubType":"NULL"},
6979: {"Type":"Etc","SubType":"NULL"},
6980: {"Type":"Etc","SubType":"NULL"},
6981: {"Type":"Etc","SubType":"NULL"},
6982: {"Type":"Etc","SubType":"NULL"},
6983: {"Type":"Etc","SubType":"NULL"},
6984: {"Type":"Etc","SubType":"NULL"},
6985: {"Type":"Etc","SubType":"NULL"},
6986: {"Type":"Etc","SubType":"NULL"},
6993: {"Type":"Etc","SubType":"NULL"},
6994: {"Type":"Etc","SubType":"NULL"},
6995: {"Type":"Etc","SubType":"NULL"},
6996: {"Type":"Etc","SubType":"NULL"},
6997: {"Type":"Etc","SubType":"NULL"},
6999: {"Type":"Etc","SubType":"NULL"},
7000: {"Type":"Etc","SubType":"NULL"},
7001: {"Type":"Etc","SubType":"NULL"},
7002: {"Type":"Etc","SubType":"NULL"},
7003: {"Type":"Etc","SubType":"NULL"},
7004: {"Type":"Etc","SubType":"NULL"},
7005: {"Type":"Etc","SubType":"NULL"},
7006: {"Type":"Etc","SubType":"NULL"},
7007: {"Type":"Etc","SubType":"NULL"},
7008: {"Type":"Etc","SubType":"NULL"},
7009: {"Type":"Etc","SubType":"NULL"},
7010: {"Type":"Etc","SubType":"NULL"},
7011: {"Type":"Etc","SubType":"NULL"},
7012: {"Type":"Etc","SubType":"NULL"},
7013: {"Type":"Etc","SubType":"NULL"},
7014: {"Type":"Etc","SubType":"NULL"},
7015: {"Type":"Etc","SubType":"NULL"},
7016: {"Type":"Etc","SubType":"NULL"},
7017: {"Type":"Etc","SubType":"NULL"},
7018: {"Type":"Etc","SubType":"NULL"},
7019: {"Type":"Etc","SubType":"NULL"},
7020: {"Type":"Etc","SubType":"NULL"},
7021: {"Type":"Etc","SubType":"NULL"},
7022: {"Type":"Etc","SubType":"NULL"},
7023: {"Type":"Etc","SubType":"NULL"},
7024: {"Type":"Etc","SubType":"NULL"},
7025: {"Type":"Etc","SubType":"NULL"},
7026: {"Type":"Etc","SubType":"NULL"},
7027: {"Type":"Etc","SubType":"NULL"},
7028: {"Type":"Etc","SubType":"NULL"},
7029: {"Type":"Etc","SubType":"NULL"},
7030: {"Type":"Etc","SubType":"NULL"},
7031: {"Type":"Etc","SubType":"NULL"},
7032: {"Type":"Etc","SubType":"NULL"},
7033: {"Type":"Etc","SubType":"NULL"},
7034: {"Type":"Etc","SubType":"NULL"},
7035: {"Type":"Etc","SubType":"NULL"},
7036: {"Type":"Etc","SubType":"NULL"},
7037: {"Type":"Usable","SubType":"NULL"},
7038: {"Type":"Etc","SubType":"NULL"},
7039: {"Type":"Etc","SubType":"NULL"},
7040: {"Type":"Etc","SubType":"NULL"},
7041: {"Type":"Etc","SubType":"NULL"},
7042: {"Type":"Etc","SubType":"NULL"},
7043: {"Type":"Etc","SubType":"NULL"},
7044: {"Type":"Etc","SubType":"NULL"},
7045: {"Type":"Etc","SubType":"NULL"},
7046: {"Type":"Etc","SubType":"NULL"},
7047: {"Type":"Etc","SubType":"NULL"},
7048: {"Type":"Etc","SubType":"NULL"},
7049: {"Type":"Etc","SubType":"NULL"},
7050: {"Type":"Etc","SubType":"NULL"},
7051: {"Type":"Etc","SubType":"NULL"},
7052: {"Type":"Etc","SubType":"NULL"},
7053: {"Type":"Etc","SubType":"NULL"},
7054: {"Type":"Etc","SubType":"NULL"},
7055: {"Type":"Etc","SubType":"NULL"},
7056: {"Type":"Etc","SubType":"NULL"},
7057: {"Type":"Etc","SubType":"NULL"},
7058: {"Type":"Etc","SubType":"NULL"},
7059: {"Type":"Etc","SubType":"NULL"},
7060: {"Type":"Etc","SubType":"NULL"},
7061: {"Type":"Etc","SubType":"NULL"},
7062: {"Type":"Etc","SubType":"NULL"},
7063: {"Type":"Etc","SubType":"NULL"},
7064: {"Type":"Etc","SubType":"NULL"},
7065: {"Type":"Etc","SubType":"NULL"},
7066: {"Type":"Etc","SubType":"NULL"},
7067: {"Type":"Etc","SubType":"NULL"},
7068: {"Type":"Etc","SubType":"NULL"},
7069: {"Type":"Etc","SubType":"NULL"},
7070: {"Type":"Etc","SubType":"NULL"},
7071: {"Type":"Etc","SubType":"NULL"},
7072: {"Type":"Etc","SubType":"NULL"},
7073: {"Type":"Etc","SubType":"NULL"},
7074: {"Type":"Etc","SubType":"NULL"},
7075: {"Type":"Etc","SubType":"NULL"},
7076: {"Type":"Etc","SubType":"NULL"},
7077: {"Type":"Etc","SubType":"NULL"},
7078: {"Type":"Etc","SubType":"NULL"},
7079: {"Type":"Etc","SubType":"NULL"},
7080: {"Type":"Etc","SubType":"NULL"},
7081: {"Type":"Etc","SubType":"NULL"},
7082: {"Type":"Etc","SubType":"NULL"},
7083: {"Type":"Etc","SubType":"NULL"},
7084: {"Type":"Etc","SubType":"NULL"},
7085: {"Type":"Etc","SubType":"NULL"},
7086: {"Type":"Etc","SubType":"NULL"},
7087: {"Type":"Etc","SubType":"NULL"},
7088: {"Type":"Etc","SubType":"NULL"},
7089: {"Type":"Etc","SubType":"NULL"},
7090: {"Type":"Etc","SubType":"NULL"},
7091: {"Type":"Etc","SubType":"NULL"},
7092: {"Type":"Etc","SubType":"NULL"},
7093: {"Type":"Etc","SubType":"NULL"},
7094: {"Type":"Etc","SubType":"NULL"},
7095: {"Type":"Etc","SubType":"NULL"},
7096: {"Type":"Etc","SubType":"NULL"},
7097: {"Type":"Etc","SubType":"NULL"},
7098: {"Type":"Etc","SubType":"NULL"},
7099: {"Type":"Etc","SubType":"NULL"},
7100: {"Type":"Etc","SubType":"NULL"},
7101: {"Type":"Etc","SubType":"NULL"},
7102: {"Type":"Etc","SubType":"NULL"},
7103: {"Type":"Etc","SubType":"NULL"},
7104: {"Type":"Etc","SubType":"NULL"},
7105: {"Type":"Etc","SubType":"NULL"},
7106: {"Type":"Etc","SubType":"NULL"},
7107: {"Type":"Etc","SubType":"NULL"},
7108: {"Type":"Etc","SubType":"NULL"},
7109: {"Type":"Etc","SubType":"NULL"},
7110: {"Type":"Etc","SubType":"NULL"},
7111: {"Type":"Etc","SubType":"NULL"},
7112: {"Type":"Etc","SubType":"NULL"},
7113: {"Type":"Etc","SubType":"NULL"},
7114: {"Type":"Etc","SubType":"NULL"},
7115: {"Type":"Etc","SubType":"NULL"},
7116: {"Type":"Etc","SubType":"NULL"},
7117: {"Type":"Etc","SubType":"NULL"},
7118: {"Type":"Etc","SubType":"NULL"},
7119: {"Type":"Etc","SubType":"NULL"},
7120: {"Type":"Etc","SubType":"NULL"},
7121: {"Type":"Etc","SubType":"NULL"},
7122: {"Type":"Etc","SubType":"NULL"},
7123: {"Type":"Etc","SubType":"NULL"},
7124: {"Type":"Etc","SubType":"NULL"},
7125: {"Type":"Etc","SubType":"NULL"},
7126: {"Type":"Etc","SubType":"NULL"},
7127: {"Type":"Etc","SubType":"NULL"},
7128: {"Type":"Etc","SubType":"NULL"},
7129: {"Type":"Etc","SubType":"NULL"},
7130: {"Type":"Etc","SubType":"NULL"},
7131: {"Type":"Etc","SubType":"NULL"},
7132: {"Type":"Etc","SubType":"NULL"},
7133: {"Type":"Etc","SubType":"NULL"},
7134: {"Type":"Etc","SubType":"NULL"},
7135: {"Type":"Etc","SubType":"NULL"},
7136: {"Type":"Etc","SubType":"NULL"},
7137: {"Type":"Etc","SubType":"NULL"},
7138: {"Type":"Etc","SubType":"NULL"},
7139: {"Type":"Etc","SubType":"NULL"},
7140: {"Type":"Etc","SubType":"NULL"},
7141: {"Type":"Etc","SubType":"NULL"},
7142: {"Type":"Etc","SubType":"NULL"},
7143: {"Type":"Etc","SubType":"NULL"},
7144: {"Type":"Etc","SubType":"NULL"},
7145: {"Type":"Etc","SubType":"NULL"},
7146: {"Type":"Etc","SubType":"NULL"},
7147: {"Type":"Etc","SubType":"NULL"},
7148: {"Type":"Etc","SubType":"NULL"},
7149: {"Type":"Etc","SubType":"NULL"},
7150: {"Type":"Etc","SubType":"NULL"},
7151: {"Type":"Etc","SubType":"NULL"},
7152: {"Type":"Etc","SubType":"NULL"},
7153: {"Type":"Etc","SubType":"NULL"},
7154: {"Type":"Etc","SubType":"NULL"},
7155: {"Type":"Etc","SubType":"NULL"},
7156: {"Type":"Etc","SubType":"NULL"},
7157: {"Type":"Etc","SubType":"NULL"},
7158: {"Type":"Etc","SubType":"NULL"},
7159: {"Type":"Etc","SubType":"NULL"},
7160: {"Type":"Etc","SubType":"NULL"},
7161: {"Type":"Etc","SubType":"NULL"},
7162: {"Type":"Etc","SubType":"NULL"},
7163: {"Type":"Etc","SubType":"NULL"},
7164: {"Type":"Etc","SubType":"NULL"},
7165: {"Type":"Etc","SubType":"NULL"},
7166: {"Type":"Etc","SubType":"NULL"},
7167: {"Type":"Etc","SubType":"NULL"},
7168: {"Type":"Etc","SubType":"NULL"},
7169: {"Type":"Etc","SubType":"NULL"},
7170: {"Type":"Etc","SubType":"NULL"},
7171: {"Type":"Etc","SubType":"NULL"},
7172: {"Type":"Etc","SubType":"NULL"},
7173: {"Type":"Etc","SubType":"NULL"},
7174: {"Type":"Etc","SubType":"NULL"},
7175: {"Type":"Etc","SubType":"NULL"},
7176: {"Type":"Etc","SubType":"NULL"},
7177: {"Type":"Etc","SubType":"NULL"},
7178: {"Type":"Etc","SubType":"NULL"},
7179: {"Type":"Etc","SubType":"NULL"},
7180: {"Type":"Etc","SubType":"NULL"},
7181: {"Type":"Etc","SubType":"NULL"},
7182: {"Type":"Etc","SubType":"NULL"},
7183: {"Type":"Etc","SubType":"NULL"},
7184: {"Type":"Etc","SubType":"NULL"},
7185: {"Type":"Etc","SubType":"NULL"},
7186: {"Type":"Etc","SubType":"NULL"},
7187: {"Type":"Etc","SubType":"NULL"},
7188: {"Type":"Etc","SubType":"NULL"},
7189: {"Type":"Etc","SubType":"NULL"},
7190: {"Type":"Etc","SubType":"NULL"},
7191: {"Type":"Etc","SubType":"NULL"},
7192: {"Type":"Etc","SubType":"NULL"},
7193: {"Type":"Etc","SubType":"NULL"},
7194: {"Type":"Etc","SubType":"NULL"},
7195: {"Type":"Etc","SubType":"NULL"},
7196: {"Type":"Etc","SubType":"NULL"},
7197: {"Type":"Etc","SubType":"NULL"},
7198: {"Type":"Etc","SubType":"NULL"},
7199: {"Type":"Etc","SubType":"NULL"},
7200: {"Type":"Etc","SubType":"NULL"},
7201: {"Type":"Etc","SubType":"NULL"},
7202: {"Type":"Etc","SubType":"NULL"},
7203: {"Type":"Etc","SubType":"NULL"},
7204: {"Type":"Etc","SubType":"NULL"},
7205: {"Type":"Etc","SubType":"NULL"},
7206: {"Type":"Etc","SubType":"NULL"},
7207: {"Type":"Etc","SubType":"NULL"},
7208: {"Type":"Etc","SubType":"NULL"},
7209: {"Type":"Etc","SubType":"NULL"},
7210: {"Type":"Etc","SubType":"NULL"},
7211: {"Type":"Etc","SubType":"NULL"},
7212: {"Type":"Etc","SubType":"NULL"},
7213: {"Type":"Etc","SubType":"NULL"},
7214: {"Type":"Etc","SubType":"NULL"},
7215: {"Type":"Etc","SubType":"NULL"},
7216: {"Type":"Etc","SubType":"NULL"},
7217: {"Type":"Etc","SubType":"NULL"},
7218: {"Type":"Etc","SubType":"NULL"},
7219: {"Type":"Etc","SubType":"NULL"},
7220: {"Type":"Etc","SubType":"NULL"},
7221: {"Type":"Etc","SubType":"NULL"},
7222: {"Type":"Etc","SubType":"NULL"},
7223: {"Type":"Etc","SubType":"NULL"},
7224: {"Type":"Etc","SubType":"NULL"},
7225: {"Type":"Etc","SubType":"NULL"},
7226: {"Type":"Etc","SubType":"NULL"},
7227: {"Type":"Etc","SubType":"NULL"},
7228: {"Type":"Etc","SubType":"NULL"},
7229: {"Type":"Etc","SubType":"NULL"},
7230: {"Type":"Etc","SubType":"NULL"},
7231: {"Type":"Etc","SubType":"NULL"},
7232: {"Type":"Etc","SubType":"NULL"},
7233: {"Type":"Etc","SubType":"NULL"},
7234: {"Type":"Etc","SubType":"NULL"},
7235: {"Type":"Etc","SubType":"NULL"},
7236: {"Type":"Etc","SubType":"NULL"},
7237: {"Type":"Etc","SubType":"NULL"},
7238: {"Type":"Etc","SubType":"NULL"},
7239: {"Type":"Etc","SubType":"NULL"},
7240: {"Type":"Etc","SubType":"NULL"},
7241: {"Type":"Etc","SubType":"NULL"},
7242: {"Type":"Etc","SubType":"NULL"},
7243: {"Type":"Etc","SubType":"NULL"},
7244: {"Type":"Etc","SubType":"NULL"},
7245: {"Type":"Etc","SubType":"NULL"},
7246: {"Type":"Etc","SubType":"NULL"},
7247: {"Type":"Etc","SubType":"NULL"},
7248: {"Type":"Etc","SubType":"NULL"},
7249: {"Type":"Etc","SubType":"NULL"},
7250: {"Type":"Etc","SubType":"NULL"},
7251: {"Type":"Etc","SubType":"NULL"},
7252: {"Type":"Etc","SubType":"NULL"},
7253: {"Type":"Etc","SubType":"NULL"},
7254: {"Type":"Etc","SubType":"NULL"},
7255: {"Type":"Etc","SubType":"NULL"},
7256: {"Type":"Etc","SubType":"NULL"},
7257: {"Type":"Etc","SubType":"NULL"},
7258: {"Type":"Etc","SubType":"NULL"},
7259: {"Type":"Etc","SubType":"NULL"},
7260: {"Type":"Etc","SubType":"NULL"},
7261: {"Type":"Etc","SubType":"NULL"},
7262: {"Type":"Etc","SubType":"NULL"},
7263: {"Type":"Etc","SubType":"NULL"},
7264: {"Type":"Etc","SubType":"NULL"},
7265: {"Type":"Etc","SubType":"NULL"},
7266: {"Type":"Etc","SubType":"NULL"},
7267: {"Type":"Etc","SubType":"NULL"},
7268: {"Type":"Etc","SubType":"NULL"},
7269: {"Type":"Etc","SubType":"NULL"},
7270: {"Type":"Etc","SubType":"NULL"},
7271: {"Type":"Etc","SubType":"NULL"},
7272: {"Type":"Etc","SubType":"NULL"},
7273: {"Type":"Etc","SubType":"NULL"},
7274: {"Type":"Etc","SubType":"NULL"},
7275: {"Type":"Etc","SubType":"NULL"},
7276: {"Type":"Etc","SubType":"NULL"},
7277: {"Type":"Etc","SubType":"NULL"},
7278: {"Type":"Etc","SubType":"NULL"},
7279: {"Type":"Etc","SubType":"NULL"},
7280: {"Type":"Etc","SubType":"NULL"},
7281: {"Type":"Etc","SubType":"NULL"},
7282: {"Type":"Etc","SubType":"NULL"},
7283: {"Type":"Etc","SubType":"NULL"},
7284: {"Type":"Etc","SubType":"NULL"},
7285: {"Type":"Etc","SubType":"NULL"},
7286: {"Type":"Etc","SubType":"NULL"},
7287: {"Type":"Etc","SubType":"NULL"},
7288: {"Type":"Etc","SubType":"NULL"},
7289: {"Type":"Etc","SubType":"NULL"},
7290: {"Type":"Etc","SubType":"NULL"},
7291: {"Type":"Etc","SubType":"NULL"},
7292: {"Type":"Etc","SubType":"NULL"},
7293: {"Type":"Etc","SubType":"NULL"},
7294: {"Type":"Etc","SubType":"NULL"},
7295: {"Type":"Etc","SubType":"NULL"},
7296: {"Type":"Etc","SubType":"NULL"},
7297: {"Type":"Etc","SubType":"NULL"},
7298: {"Type":"Etc","SubType":"NULL"},
7299: {"Type":"Etc","SubType":"NULL"},
7300: {"Type":"Etc","SubType":"NULL"},
7301: {"Type":"Etc","SubType":"NULL"},
7302: {"Type":"Etc","SubType":"NULL"},
7303: {"Type":"Etc","SubType":"NULL"},
7304: {"Type":"Etc","SubType":"NULL"},
7305: {"Type":"Etc","SubType":"NULL"},
7306: {"Type":"Etc","SubType":"NULL"},
7307: {"Type":"Etc","SubType":"NULL"},
7308: {"Type":"Etc","SubType":"NULL"},
7309: {"Type":"Etc","SubType":"NULL"},
7310: {"Type":"Etc","SubType":"NULL"},
7311: {"Type":"Etc","SubType":"NULL"},
7312: {"Type":"Etc","SubType":"NULL"},
7313: {"Type":"Etc","SubType":"NULL"},
7314: {"Type":"Etc","SubType":"NULL"},
7315: {"Type":"Etc","SubType":"NULL"},
7316: {"Type":"Etc","SubType":"NULL"},
7317: {"Type":"Etc","SubType":"NULL"},
7318: {"Type":"Etc","SubType":"NULL"},
7319: {"Type":"Etc","SubType":"NULL"},
7320: {"Type":"Etc","SubType":"NULL"},
7321: {"Type":"Etc","SubType":"NULL"},
7322: {"Type":"Etc","SubType":"NULL"},
7323: {"Type":"Etc","SubType":"NULL"},
7324: {"Type":"Etc","SubType":"NULL"},
7325: {"Type":"Etc","SubType":"NULL"},
7326: {"Type":"Etc","SubType":"NULL"},
7327: {"Type":"Etc","SubType":"NULL"},
7328: {"Type":"Etc","SubType":"NULL"},
7329: {"Type":"Etc","SubType":"NULL"},
7330: {"Type":"Etc","SubType":"NULL"},
7331: {"Type":"Etc","SubType":"NULL"},
7332: {"Type":"Etc","SubType":"NULL"},
7333: {"Type":"Etc","SubType":"NULL"},
7334: {"Type":"Etc","SubType":"NULL"},
7335: {"Type":"Etc","SubType":"NULL"},
7336: {"Type":"Etc","SubType":"NULL"},
7337: {"Type":"Etc","SubType":"NULL"},
7338: {"Type":"Etc","SubType":"NULL"},
7339: {"Type":"Etc","SubType":"NULL"},
7340: {"Type":"Etc","SubType":"NULL"},
7341: {"Type":"Etc","SubType":"NULL"},
7342: {"Type":"Etc","SubType":"NULL"},
7343: {"Type":"Etc","SubType":"NULL"},
7344: {"Type":"Etc","SubType":"NULL"},
7345: {"Type":"Etc","SubType":"NULL"},
7346: {"Type":"Etc","SubType":"NULL"},
7347: {"Type":"Etc","SubType":"NULL"},
7348: {"Type":"Etc","SubType":"NULL"},
7349: {"Type":"Etc","SubType":"NULL"},
7350: {"Type":"Etc","SubType":"NULL"},
7351: {"Type":"Etc","SubType":"NULL"},
7352: {"Type":"Etc","SubType":"NULL"},
7353: {"Type":"Etc","SubType":"NULL"},
7354: {"Type":"Etc","SubType":"NULL"},
7355: {"Type":"Etc","SubType":"NULL"},
7356: {"Type":"Etc","SubType":"NULL"},
7357: {"Type":"Etc","SubType":"NULL"},
7358: {"Type":"Etc","SubType":"NULL"},
7359: {"Type":"Etc","SubType":"NULL"},
7360: {"Type":"Etc","SubType":"NULL"},
7361: {"Type":"Etc","SubType":"NULL"},
7362: {"Type":"Etc","SubType":"NULL"},
7363: {"Type":"Etc","SubType":"NULL"},
7364: {"Type":"Etc","SubType":"NULL"},
7365: {"Type":"Etc","SubType":"NULL"},
7366: {"Type":"Etc","SubType":"NULL"},
7367: {"Type":"Etc","SubType":"NULL"},
7368: {"Type":"Etc","SubType":"NULL"},
7369: {"Type":"Etc","SubType":"NULL"},
7370: {"Type":"Etc","SubType":"NULL"},
7371: {"Type":"Etc","SubType":"NULL"},
7372: {"Type":"Etc","SubType":"NULL"},
7373: {"Type":"Etc","SubType":"NULL"},
7374: {"Type":"Etc","SubType":"NULL"},
7375: {"Type":"Etc","SubType":"NULL"},
7376: {"Type":"Etc","SubType":"NULL"},
7377: {"Type":"Etc","SubType":"NULL"},
7378: {"Type":"Etc","SubType":"NULL"},
7379: {"Type":"Etc","SubType":"NULL"},
7380: {"Type":"Etc","SubType":"NULL"},
7381: {"Type":"Etc","SubType":"NULL"},
7382: {"Type":"Etc","SubType":"NULL"},
7383: {"Type":"Etc","SubType":"NULL"},
7384: {"Type":"Etc","SubType":"NULL"},
7385: {"Type":"Etc","SubType":"NULL"},
7386: {"Type":"Etc","SubType":"NULL"},
7387: {"Type":"Etc","SubType":"NULL"},
7388: {"Type":"Etc","SubType":"NULL"},
7389: {"Type":"Etc","SubType":"NULL"},
7390: {"Type":"Etc","SubType":"NULL"},
7391: {"Type":"Etc","SubType":"NULL"},
7392: {"Type":"Etc","SubType":"NULL"},
7393: {"Type":"Etc","SubType":"NULL"},
7394: {"Type":"Etc","SubType":"NULL"},
7395: {"Type":"Etc","SubType":"NULL"},
7396: {"Type":"Etc","SubType":"NULL"},
7397: {"Type":"Etc","SubType":"NULL"},
7398: {"Type":"Etc","SubType":"NULL"},
7399: {"Type":"Etc","SubType":"NULL"},
7400: {"Type":"Etc","SubType":"NULL"},
7401: {"Type":"Etc","SubType":"NULL"},
7402: {"Type":"Etc","SubType":"NULL"},
7403: {"Type":"Etc","SubType":"NULL"},
7404: {"Type":"Etc","SubType":"NULL"},
7405: {"Type":"Etc","SubType":"NULL"},
7406: {"Type":"Etc","SubType":"NULL"},
7407: {"Type":"Etc","SubType":"NULL"},
7408: {"Type":"Etc","SubType":"NULL"},
7409: {"Type":"Etc","SubType":"NULL"},
7410: {"Type":"Etc","SubType":"NULL"},
7411: {"Type":"Etc","SubType":"NULL"},
7412: {"Type":"Etc","SubType":"NULL"},
7413: {"Type":"Etc","SubType":"NULL"},
7414: {"Type":"Etc","SubType":"NULL"},
7415: {"Type":"Etc","SubType":"NULL"},
7416: {"Type":"Etc","SubType":"NULL"},
7417: {"Type":"Etc","SubType":"NULL"},
7418: {"Type":"Etc","SubType":"NULL"},
7419: {"Type":"Etc","SubType":"NULL"},
7420: {"Type":"Etc","SubType":"NULL"},
7421: {"Type":"Etc","SubType":"NULL"},
7422: {"Type":"Etc","SubType":"NULL"},
7423: {"Type":"Etc","SubType":"NULL"},
7424: {"Type":"Etc","SubType":"NULL"},
7425: {"Type":"Etc","SubType":"NULL"},
7426: {"Type":"Etc","SubType":"NULL"},
7427: {"Type":"Etc","SubType":"NULL"},
7428: {"Type":"Etc","SubType":"NULL"},
7429: {"Type":"Etc","SubType":"NULL"},
7430: {"Type":"Etc","SubType":"NULL"},
7431: {"Type":"Etc","SubType":"NULL"},
7432: {"Type":"Etc","SubType":"NULL"},
7433: {"Type":"Etc","SubType":"NULL"},
7434: {"Type":"Etc","SubType":"NULL"},
7435: {"Type":"Etc","SubType":"NULL"},
7436: {"Type":"Etc","SubType":"NULL"},
7437: {"Type":"Etc","SubType":"NULL"},
7438: {"Type":"Etc","SubType":"NULL"},
7439: {"Type":"Etc","SubType":"NULL"},
7440: {"Type":"Etc","SubType":"NULL"},
7441: {"Type":"Etc","SubType":"NULL"},
7442: {"Type":"Etc","SubType":"NULL"},
7443: {"Type":"Etc","SubType":"NULL"},
7444: {"Type":"Etc","SubType":"NULL"},
7445: {"Type":"Etc","SubType":"NULL"},
7446: {"Type":"Etc","SubType":"NULL"},
7447: {"Type":"Etc","SubType":"NULL"},
7448: {"Type":"Etc","SubType":"NULL"},
7449: {"Type":"Etc","SubType":"NULL"},
7450: {"Type":"Etc","SubType":"NULL"},
7451: {"Type":"Etc","SubType":"NULL"},
7452: {"Type":"Etc","SubType":"NULL"},
7453: {"Type":"Etc","SubType":"NULL"},
7454: {"Type":"Etc","SubType":"NULL"},
7455: {"Type":"Etc","SubType":"NULL"},
7456: {"Type":"Etc","SubType":"NULL"},
7457: {"Type":"Etc","SubType":"NULL"},
7458: {"Type":"Etc","SubType":"NULL"},
7459: {"Type":"Etc","SubType":"NULL"},
7460: {"Type":"Etc","SubType":"NULL"},
7461: {"Type":"Etc","SubType":"NULL"},
7462: {"Type":"Etc","SubType":"NULL"},
7463: {"Type":"Etc","SubType":"NULL"},
7464: {"Type":"Etc","SubType":"NULL"},
7465: {"Type":"Etc","SubType":"NULL"},
7466: {"Type":"Etc","SubType":"NULL"},
7467: {"Type":"Etc","SubType":"NULL"},
7468: {"Type":"Etc","SubType":"NULL"},
7469: {"Type":"Etc","SubType":"NULL"},
7470: {"Type":"Etc","SubType":"NULL"},
7471: {"Type":"Etc","SubType":"NULL"},
7472: {"Type":"Etc","SubType":"NULL"},
7473: {"Type":"Etc","SubType":"NULL"},
7474: {"Type":"Etc","SubType":"NULL"},
7475: {"Type":"Etc","SubType":"NULL"},
7476: {"Type":"Etc","SubType":"NULL"},
7477: {"Type":"Etc","SubType":"NULL"},
7478: {"Type":"Etc","SubType":"NULL"},
7479: {"Type":"Etc","SubType":"NULL"},
7480: {"Type":"Etc","SubType":"NULL"},
7481: {"Type":"Etc","SubType":"NULL"},
7482: {"Type":"Etc","SubType":"NULL"},
7483: {"Type":"Etc","SubType":"NULL"},
7484: {"Type":"Etc","SubType":"NULL"},
7485: {"Type":"Etc","SubType":"NULL"},
7486: {"Type":"Etc","SubType":"NULL"},
7487: {"Type":"Etc","SubType":"NULL"},
7488: {"Type":"Etc","SubType":"NULL"},
7489: {"Type":"Etc","SubType":"NULL"},
7490: {"Type":"Etc","SubType":"NULL"},
7491: {"Type":"Etc","SubType":"NULL"},
7492: {"Type":"Etc","SubType":"NULL"},
7493: {"Type":"Etc","SubType":"NULL"},
7494: {"Type":"Etc","SubType":"NULL"},
7495: {"Type":"Etc","SubType":"NULL"},
7496: {"Type":"Etc","SubType":"NULL"},
7497: {"Type":"Etc","SubType":"NULL"},
7498: {"Type":"Etc","SubType":"NULL"},
7499: {"Type":"Etc","SubType":"NULL"},
7500: {"Type":"Etc","SubType":"NULL"},
7501: {"Type":"Etc","SubType":"NULL"},
7502: {"Type":"Etc","SubType":"NULL"},
7503: {"Type":"Etc","SubType":"NULL"},
7504: {"Type":"Etc","SubType":"NULL"},
7505: {"Type":"Etc","SubType":"NULL"},
7506: {"Type":"Etc","SubType":"NULL"},
7507: {"Type":"Etc","SubType":"NULL"},
7508: {"Type":"Etc","SubType":"NULL"},
7509: {"Type":"Etc","SubType":"NULL"},
7510: {"Type":"Etc","SubType":"NULL"},
7511: {"Type":"Etc","SubType":"NULL"},
7512: {"Type":"Etc","SubType":"NULL"},
7513: {"Type":"Etc","SubType":"NULL"},
7514: {"Type":"Etc","SubType":"NULL"},
7515: {"Type":"Etc","SubType":"NULL"},
7516: {"Type":"Etc","SubType":"NULL"},
7517: {"Type":"Etc","SubType":"NULL"},
7518: {"Type":"Etc","SubType":"NULL"},
7519: {"Type":"Etc","SubType":"NULL"},
7520: {"Type":"Etc","SubType":"NULL"},
7521: {"Type":"Etc","SubType":"NULL"},
7522: {"Type":"Etc","SubType":"NULL"},
7523: {"Type":"Etc","SubType":"NULL"},
7524: {"Type":"Etc","SubType":"NULL"},
7525: {"Type":"Etc","SubType":"NULL"},
7526: {"Type":"Etc","SubType":"NULL"},
7527: {"Type":"Etc","SubType":"NULL"},
7528: {"Type":"Etc","SubType":"NULL"},
7529: {"Type":"Etc","SubType":"NULL"},
7530: {"Type":"Etc","SubType":"NULL"},
7531: {"Type":"Etc","SubType":"NULL"},
7532: {"Type":"Etc","SubType":"NULL"},
7533: {"Type":"Etc","SubType":"NULL"},
7534: {"Type":"Etc","SubType":"NULL"},
7535: {"Type":"Etc","SubType":"NULL"},
7536: {"Type":"Etc","SubType":"NULL"},
7537: {"Type":"Etc","SubType":"NULL"},
7538: {"Type":"Etc","SubType":"NULL"},
7539: {"Type":"Etc","SubType":"NULL"},
7540: {"Type":"Etc","SubType":"NULL"},
7541: {"Type":"Etc","SubType":"NULL"},
7542: {"Type":"Etc","SubType":"NULL"},
7543: {"Type":"Etc","SubType":"NULL"},
7544: {"Type":"Etc","SubType":"NULL"},
7545: {"Type":"Etc","SubType":"NULL"},
7546: {"Type":"Etc","SubType":"NULL"},
7547: {"Type":"Etc","SubType":"NULL"},
7548: {"Type":"Etc","SubType":"NULL"},
7549: {"Type":"Etc","SubType":"NULL"},
7550: {"Type":"Etc","SubType":"NULL"},
7551: {"Type":"Etc","SubType":"NULL"},
7552: {"Type":"Etc","SubType":"NULL"},
7553: {"Type":"Etc","SubType":"NULL"},
7554: {"Type":"Etc","SubType":"NULL"},
7555: {"Type":"Etc","SubType":"NULL"},
7556: {"Type":"Etc","SubType":"NULL"},
7557: {"Type":"Etc","SubType":"NULL"},
7558: {"Type":"Etc","SubType":"NULL"},
7559: {"Type":"Etc","SubType":"NULL"},
7560: {"Type":"Etc","SubType":"NULL"},
7561: {"Type":"Etc","SubType":"NULL"},
7562: {"Type":"Etc","SubType":"NULL"},
7563: {"Type":"Etc","SubType":"NULL"},
7564: {"Type":"Etc","SubType":"NULL"},
7565: {"Type":"Etc","SubType":"NULL"},
7566: {"Type":"Etc","SubType":"NULL"},
7567: {"Type":"Etc","SubType":"NULL"},
7568: {"Type":"Etc","SubType":"NULL"},
7569: {"Type":"Etc","SubType":"NULL"},
7570: {"Type":"Etc","SubType":"NULL"},
7571: {"Type":"Etc","SubType":"NULL"},
7572: {"Type":"Etc","SubType":"NULL"},
7573: {"Type":"Etc","SubType":"NULL"},
7574: {"Type":"Etc","SubType":"NULL"},
7575: {"Type":"Etc","SubType":"NULL"},
7576: {"Type":"Etc","SubType":"NULL"},
7577: {"Type":"Etc","SubType":"NULL"},
7578: {"Type":"Etc","SubType":"NULL"},
7579: {"Type":"Etc","SubType":"NULL"},
7580: {"Type":"Etc","SubType":"NULL"},
7581: {"Type":"Etc","SubType":"NULL"},
7582: {"Type":"Etc","SubType":"NULL"},
7583: {"Type":"Etc","SubType":"NULL"},
7584: {"Type":"Etc","SubType":"NULL"},
7585: {"Type":"Etc","SubType":"NULL"},
7586: {"Type":"Etc","SubType":"NULL"},
7587: {"Type":"Etc","SubType":"NULL"},
7588: {"Type":"Etc","SubType":"NULL"},
7589: {"Type":"Etc","SubType":"NULL"},
7590: {"Type":"Etc","SubType":"NULL"},
7591: {"Type":"Etc","SubType":"NULL"},
7592: {"Type":"Etc","SubType":"NULL"},
7593: {"Type":"Etc","SubType":"NULL"},
7594: {"Type":"Etc","SubType":"NULL"},
7595: {"Type":"Etc","SubType":"NULL"},
7596: {"Type":"Etc","SubType":"NULL"},
7597: {"Type":"Etc","SubType":"NULL"},
7598: {"Type":"Etc","SubType":"NULL"},
7599: {"Type":"Etc","SubType":"NULL"},
7600: {"Type":"Etc","SubType":"NULL"},
7601: {"Type":"Etc","SubType":"NULL"},
7602: {"Type":"Etc","SubType":"NULL"},
7603: {"Type":"Etc","SubType":"NULL"},
7604: {"Type":"Etc","SubType":"NULL"},
7605: {"Type":"Etc","SubType":"NULL"},
7606: {"Type":"Etc","SubType":"NULL"},
7607: {"Type":"Etc","SubType":"NULL"},
7608: {"Type":"Etc","SubType":"NULL"},
7609: {"Type":"Etc","SubType":"NULL"},
7610: {"Type":"Etc","SubType":"NULL"},
7611: {"Type":"Etc","SubType":"NULL"},
7612: {"Type":"Etc","SubType":"NULL"},
7613: {"Type":"Etc","SubType":"NULL"},
7614: {"Type":"Etc","SubType":"NULL"},
7615: {"Type":"Etc","SubType":"NULL"},
7616: {"Type":"Etc","SubType":"NULL"},
7617: {"Type":"Etc","SubType":"NULL"},
7618: {"Type":"Etc","SubType":"NULL"},
7619: {"Type":"Etc","SubType":"NULL"},
7620: {"Type":"Etc","SubType":"NULL"},
7621: {"Type":"Etc","SubType":"NULL"},
7622: {"Type":"Etc","SubType":"NULL"},
7623: {"Type":"Etc","SubType":"NULL"},
7624: {"Type":"Etc","SubType":"NULL"},
7625: {"Type":"Etc","SubType":"NULL"},
7626: {"Type":"Etc","SubType":"NULL"},
7627: {"Type":"Etc","SubType":"NULL"},
7628: {"Type":"Etc","SubType":"NULL"},
7629: {"Type":"Etc","SubType":"NULL"},
7630: {"Type":"Etc","SubType":"NULL"},
7631: {"Type":"Etc","SubType":"NULL"},
7632: {"Type":"Etc","SubType":"NULL"},
7633: {"Type":"Etc","SubType":"NULL"},
7634: {"Type":"Etc","SubType":"NULL"},
7635: {"Type":"Etc","SubType":"NULL"},
7636: {"Type":"Etc","SubType":"NULL"},
7637: {"Type":"Etc","SubType":"NULL"},
7638: {"Type":"Etc","SubType":"NULL"},
7639: {"Type":"Etc","SubType":"NULL"},
7640: {"Type":"Etc","SubType":"NULL"},
7641: {"Type":"Etc","SubType":"NULL"},
7642: {"Type":"Etc","SubType":"NULL"},
7643: {"Type":"Etc","SubType":"NULL"},
7644: {"Type":"Etc","SubType":"NULL"},
7646: {"Type":"Etc","SubType":"NULL"},
7647: {"Type":"Etc","SubType":"NULL"},
7648: {"Type":"Etc","SubType":"NULL"},
7649: {"Type":"Etc","SubType":"NULL"},
7651: {"Type":"Etc","SubType":"NULL"},
7663: {"Type":"Etc","SubType":"NULL"},
7664: {"Type":"Etc","SubType":"NULL"},
7665: {"Type":"Etc","SubType":"NULL"},
7666: {"Type":"Etc","SubType":"NULL"},
7667: {"Type":"Etc","SubType":"NULL"},
7668: {"Type":"Etc","SubType":"NULL"},
7669: {"Type":"Etc","SubType":"NULL"},
7670: {"Type":"Etc","SubType":"NULL"},
7671: {"Type":"Etc","SubType":"NULL"},
7672: {"Type":"Etc","SubType":"NULL"},
7674: {"Type":"Etc","SubType":"NULL"},
7675: {"Type":"Etc","SubType":"NULL"},
7676: {"Type":"Etc","SubType":"NULL"},
7679: {"Type":"Etc","SubType":"NULL"},
7680: {"Type":"Etc","SubType":"NULL"},
7681: {"Type":"Etc","SubType":"NULL"},
7682: {"Type":"Etc","SubType":"NULL"},
7685: {"Type":"Etc","SubType":"NULL"},
7690: {"Type":"Etc","SubType":"NULL"},
7701: {"Type":"Etc","SubType":"NULL"},
7702: {"Type":"Etc","SubType":"NULL"},
7703: {"Type":"Etc","SubType":"NULL"},
7704: {"Type":"Etc","SubType":"NULL"},
7705: {"Type":"Etc","SubType":"NULL"},
7706: {"Type":"Etc","SubType":"NULL"},
7707: {"Type":"Etc","SubType":"NULL"},
7708: {"Type":"Etc","SubType":"NULL"},
7709: {"Type":"Etc","SubType":"NULL"},
7710: {"Type":"Etc","SubType":"NULL"},
7711: {"Type":"Etc","SubType":"NULL"},
7712: {"Type":"Etc","SubType":"NULL"},
7713: {"Type":"Etc","SubType":"NULL"},
7714: {"Type":"Etc","SubType":"NULL"},
7715: {"Type":"Etc","SubType":"NULL"},
7716: {"Type":"Etc","SubType":"NULL"},
7717: {"Type":"Etc","SubType":"NULL"},
7718: {"Type":"Etc","SubType":"NULL"},
7719: {"Type":"Etc","SubType":"NULL"},
7720: {"Type":"Etc","SubType":"NULL"},
7721: {"Type":"Etc","SubType":"NULL"},
7722: {"Type":"Etc","SubType":"NULL"},
7723: {"Type":"Etc","SubType":"NULL"},
7724: {"Type":"Etc","SubType":"NULL"},
7725: {"Type":"Etc","SubType":"NULL"},
7726: {"Type":"Etc","SubType":"NULL"},
7727: {"Type":"Etc","SubType":"NULL"},
7728: {"Type":"Etc","SubType":"NULL"},
7729: {"Type":"Etc","SubType":"NULL"},
7730: {"Type":"Etc","SubType":"NULL"},
7731: {"Type":"Etc","SubType":"NULL"},
7732: {"Type":"Etc","SubType":"NULL"},
7733: {"Type":"Etc","SubType":"NULL"},
7734: {"Type":"Etc","SubType":"NULL"},
7735: {"Type":"Etc","SubType":"NULL"},
7736: {"Type":"Etc","SubType":"NULL"},
7737: {"Type":"Etc","SubType":"NULL"},
7738: {"Type":"Etc","SubType":"NULL"},
7739: {"Type":"Etc","SubType":"NULL"},
7740: {"Type":"Etc","SubType":"NULL"},
7741: {"Type":"Etc","SubType":"NULL"},
7742: {"Type":"Etc","SubType":"NULL"},
7743: {"Type":"Etc","SubType":"NULL"},
7744: {"Type":"Etc","SubType":"NULL"},
7745: {"Type":"Etc","SubType":"NULL"},
7746: {"Type":"Etc","SubType":"NULL"},
7747: {"Type":"Etc","SubType":"NULL"},
7748: {"Type":"Etc","SubType":"NULL"},
7749: {"Type":"Etc","SubType":"NULL"},
7750: {"Type":"Etc","SubType":"NULL"},
7751: {"Type":"Etc","SubType":"NULL"},
7752: {"Type":"Etc","SubType":"NULL"},
7753: {"Type":"Etc","SubType":"NULL"},
7754: {"Type":"Etc","SubType":"NULL"},
7755: {"Type":"Etc","SubType":"NULL"},
7756: {"Type":"Etc","SubType":"NULL"},
7757: {"Type":"Etc","SubType":"NULL"},
7758: {"Type":"Etc","SubType":"NULL"},
7759: {"Type":"Etc","SubType":"NULL"},
7760: {"Type":"Etc","SubType":"NULL"},
7761: {"Type":"Etc","SubType":"NULL"},
7762: {"Type":"Etc","SubType":"NULL"},
7763: {"Type":"Etc","SubType":"NULL"},
7764: {"Type":"Etc","SubType":"NULL"},
7765: {"Type":"Etc","SubType":"NULL"},
7766: {"Type":"Etc","SubType":"NULL"},
7767: {"Type":"Etc","SubType":"NULL"},
7768: {"Type":"Etc","SubType":"NULL"},
7769: {"Type":"Etc","SubType":"NULL"},
7770: {"Type":"Etc","SubType":"NULL"},
7771: {"Type":"Etc","SubType":"NULL"},
7772: {"Type":"Etc","SubType":"NULL"},
7773: {"Type":"Etc","SubType":"NULL"},
7774: {"Type":"Etc","SubType":"NULL"},
7775: {"Type":"Etc","SubType":"NULL"},
7776: {"Type":"Etc","SubType":"NULL"},
7777: {"Type":"Etc","SubType":"NULL"},
7778: {"Type":"Etc","SubType":"NULL"},
7779: {"Type":"Etc","SubType":"NULL"},
7780: {"Type":"Etc","SubType":"NULL"},
7781: {"Type":"Etc","SubType":"NULL"},
7782: {"Type":"Etc","SubType":"NULL"},
7783: {"Type":"Etc","SubType":"NULL"},
7784: {"Type":"Etc","SubType":"NULL"},
7785: {"Type":"Etc","SubType":"NULL"},
7786: {"Type":"Etc","SubType":"NULL"},
7787: {"Type":"Etc","SubType":"NULL"},
7788: {"Type":"Etc","SubType":"NULL"},
7789: {"Type":"Etc","SubType":"NULL"},
7790: {"Type":"Etc","SubType":"NULL"},
7791: {"Type":"Etc","SubType":"NULL"},
7792: {"Type":"Etc","SubType":"NULL"},
7793: {"Type":"Etc","SubType":"NULL"},
7794: {"Type":"Etc","SubType":"NULL"},
7795: {"Type":"Etc","SubType":"NULL"},
7796: {"Type":"Etc","SubType":"NULL"},
7797: {"Type":"Etc","SubType":"NULL"},
7798: {"Type":"Etc","SubType":"NULL"},
7799: {"Type":"Etc","SubType":"NULL"},
7800: {"Type":"Etc","SubType":"NULL"},
7801: {"Type":"Etc","SubType":"NULL"},
7802: {"Type":"Etc","SubType":"NULL"},
7803: {"Type":"Etc","SubType":"NULL"},
7804: {"Type":"Etc","SubType":"NULL"},
7805: {"Type":"Etc","SubType":"NULL"},
7806: {"Type":"Etc","SubType":"NULL"},
7807: {"Type":"Etc","SubType":"NULL"},
7808: {"Type":"Etc","SubType":"NULL"},
7809: {"Type":"Etc","SubType":"NULL"},
7810: {"Type":"Etc","SubType":"NULL"},
7811: {"Type":"Etc","SubType":"NULL"},
7812: {"Type":"Etc","SubType":"NULL"},
7813: {"Type":"Etc","SubType":"NULL"},
7814: {"Type":"Etc","SubType":"NULL"},
7815: {"Type":"Etc","SubType":"NULL"},
7816: {"Type":"Etc","SubType":"NULL"},
7817: {"Type":"Etc","SubType":"NULL"},
7818: {"Type":"Etc","SubType":"NULL"},
7819: {"Type":"Etc","SubType":"NULL"},
7820: {"Type":"Etc","SubType":"NULL"},
7821: {"Type":"Etc","SubType":"NULL"},
7822: {"Type":"Etc","SubType":"NULL"},
7823: {"Type":"Etc","SubType":"NULL"},
7824: {"Type":"Etc","SubType":"NULL"},
7825: {"Type":"Etc","SubType":"NULL"},
7826: {"Type":"Etc","SubType":"NULL"},
7827: {"Type":"Etc","SubType":"NULL"},
7828: {"Type":"Etc","SubType":"NULL"},
7829: {"Type":"Etc","SubType":"NULL"},
7830: {"Type":"Etc","SubType":"NULL"},
7831: {"Type":"Etc","SubType":"NULL"},
7832: {"Type":"Etc","SubType":"NULL"},
7833: {"Type":"Etc","SubType":"NULL"},
7834: {"Type":"Etc","SubType":"NULL"},
7835: {"Type":"Etc","SubType":"NULL"},
7836: {"Type":"Etc","SubType":"NULL"},
7837: {"Type":"Etc","SubType":"NULL"},
7838: {"Type":"Etc","SubType":"NULL"},
7839: {"Type":"Etc","SubType":"NULL"},
7840: {"Type":"Etc","SubType":"NULL"},
7841: {"Type":"Etc","SubType":"NULL"},
7842: {"Type":"Etc","SubType":"NULL"},
7843: {"Type":"Etc","SubType":"NULL"},
7844: {"Type":"Etc","SubType":"NULL"},
7845: {"Type":"Etc","SubType":"NULL"},
7846: {"Type":"Etc","SubType":"NULL"},
7847: {"Type":"Etc","SubType":"NULL"},
7848: {"Type":"Etc","SubType":"NULL"},
7849: {"Type":"Etc","SubType":"NULL"},
7850: {"Type":"Etc","SubType":"NULL"},
7851: {"Type":"Etc","SubType":"NULL"},
7852: {"Type":"Etc","SubType":"NULL"},
7853: {"Type":"Etc","SubType":"NULL"},
7854: {"Type":"Etc","SubType":"NULL"},
7855: {"Type":"Etc","SubType":"NULL"},
7856: {"Type":"Etc","SubType":"NULL"},
7857: {"Type":"Etc","SubType":"NULL"},
7858: {"Type":"Etc","SubType":"NULL"},
7859: {"Type":"Etc","SubType":"NULL"},
7860: {"Type":"Etc","SubType":"NULL"},
7861: {"Type":"Etc","SubType":"NULL"},
7862: {"Type":"Etc","SubType":"NULL"},
7863: {"Type":"Etc","SubType":"NULL"},
7864: {"Type":"Etc","SubType":"NULL"},
7865: {"Type":"Etc","SubType":"NULL"},
7866: {"Type":"Etc","SubType":"NULL"},
7867: {"Type":"Etc","SubType":"NULL"},
7868: {"Type":"Etc","SubType":"NULL"},
7869: {"Type":"Etc","SubType":"NULL"},
7870: {"Type":"Etc","SubType":"NULL"},
7871: {"Type":"Etc","SubType":"NULL"},
7872: {"Type":"Etc","SubType":"NULL"},
7873: {"Type":"Etc","SubType":"NULL"},
7874: {"Type":"Etc","SubType":"NULL"},
7875: {"Type":"Etc","SubType":"NULL"},
7876: {"Type":"Etc","SubType":"NULL"},
7877: {"Type":"Etc","SubType":"NULL"},
7878: {"Type":"Etc","SubType":"NULL"},
7879: {"Type":"Etc","SubType":"NULL"},
7880: {"Type":"Etc","SubType":"NULL"},
7881: {"Type":"Etc","SubType":"NULL"},
7882: {"Type":"Etc","SubType":"NULL"},
7883: {"Type":"Etc","SubType":"NULL"},
7884: {"Type":"Etc","SubType":"NULL"},
7885: {"Type":"Etc","SubType":"NULL"},
7886: {"Type":"Etc","SubType":"NULL"},
7887: {"Type":"Etc","SubType":"NULL"},
7888: {"Type":"Etc","SubType":"NULL"},
7889: {"Type":"Etc","SubType":"NULL"},
7891: {"Type":"Etc","SubType":"NULL"},
7892: {"Type":"Etc","SubType":"NULL"},
7893: {"Type":"Etc","SubType":"NULL"},
7894: {"Type":"Etc","SubType":"NULL"},
7895: {"Type":"Etc","SubType":"NULL"},
7896: {"Type":"Etc","SubType":"NULL"},
7897: {"Type":"Etc","SubType":"NULL"},
7898: {"Type":"Etc","SubType":"NULL"},
7899: {"Type":"Etc","SubType":"NULL"},
7900: {"Type":"Etc","SubType":"NULL"},
7901: {"Type":"Etc","SubType":"NULL"},
7902: {"Type":"Etc","SubType":"NULL"},
7903: {"Type":"Etc","SubType":"NULL"},
7904: {"Type":"Etc","SubType":"NULL"},
7905: {"Type":"Etc","SubType":"NULL"},
7906: {"Type":"Etc","SubType":"NULL"},
7907: {"Type":"Etc","SubType":"NULL"},
7908: {"Type":"Etc","SubType":"NULL"},
7909: {"Type":"Etc","SubType":"NULL"},
7910: {"Type":"Etc","SubType":"NULL"},
7911: {"Type":"Etc","SubType":"NULL"},
7912: {"Type":"Etc","SubType":"NULL"},
7913: {"Type":"Etc","SubType":"NULL"},
7914: {"Type":"Etc","SubType":"NULL"},
7915: {"Type":"Etc","SubType":"NULL"},
7916: {"Type":"Etc","SubType":"NULL"},
7917: {"Type":"Etc","SubType":"NULL"},
7918: {"Type":"Etc","SubType":"NULL"},
7919: {"Type":"Etc","SubType":"NULL"},
7920: {"Type":"Etc","SubType":"NULL"},
7921: {"Type":"Etc","SubType":"NULL"},
7922: {"Type":"Etc","SubType":"NULL"},
7923: {"Type":"Etc","SubType":"NULL"},
7924: {"Type":"Etc","SubType":"NULL"},
7925: {"Type":"Etc","SubType":"NULL"},
7926: {"Type":"Etc","SubType":"NULL"},
7927: {"Type":"Etc","SubType":"NULL"},
7928: {"Type":"Etc","SubType":"NULL"},
7929: {"Type":"Etc","SubType":"NULL"},
7930: {"Type":"Etc","SubType":"NULL"},
7931: {"Type":"Etc","SubType":"NULL"},
7932: {"Type":"Etc","SubType":"NULL"},
7933: {"Type":"Etc","SubType":"NULL"},
7934: {"Type":"Etc","SubType":"NULL"},
7935: {"Type":"Etc","SubType":"NULL"},
7936: {"Type":"Etc","SubType":"NULL"},
7937: {"Type":"Etc","SubType":"NULL"},
7938: {"Type":"Etc","SubType":"NULL"},
7939: {"Type":"Etc","SubType":"NULL"},
7940: {"Type":"Etc","SubType":"NULL"},
7941: {"Type":"Etc","SubType":"NULL"},
7942: {"Type":"Etc","SubType":"NULL"},
7943: {"Type":"Etc","SubType":"NULL"},
7944: {"Type":"Etc","SubType":"NULL"},
7945: {"Type":"Etc","SubType":"NULL"},
7946: {"Type":"Etc","SubType":"NULL"},
7947: {"Type":"Etc","SubType":"NULL"},
7948: {"Type":"Etc","SubType":"NULL"},
7949: {"Type":"Etc","SubType":"NULL"},
7950: {"Type":"Etc","SubType":"NULL"},
7951: {"Type":"Etc","SubType":"NULL"},
7952: {"Type":"Etc","SubType":"NULL"},
7953: {"Type":"Etc","SubType":"NULL"},
7954: {"Type":"Etc","SubType":"NULL"},
7955: {"Type":"Etc","SubType":"NULL"},
7956: {"Type":"Etc","SubType":"NULL"},
7957: {"Type":"Etc","SubType":"NULL"},
7958: {"Type":"Etc","SubType":"NULL"},
7959: {"Type":"Etc","SubType":"NULL"},
7960: {"Type":"Etc","SubType":"NULL"},
7961: {"Type":"Etc","SubType":"NULL"},
7962: {"Type":"Etc","SubType":"NULL"},
7963: {"Type":"Etc","SubType":"NULL"},
7964: {"Type":"Etc","SubType":"NULL"},
7965: {"Type":"Etc","SubType":"NULL"},
7966: {"Type":"Etc","SubType":"NULL"},
7967: {"Type":"Etc","SubType":"NULL"},
7968: {"Type":"Etc","SubType":"NULL"},
7969: {"Type":"Etc","SubType":"NULL"},
7970: {"Type":"Etc","SubType":"NULL"},
7971: {"Type":"Etc","SubType":"NULL"},
7972: {"Type":"Etc","SubType":"NULL"},
7973: {"Type":"Etc","SubType":"NULL"},
7974: {"Type":"Etc","SubType":"NULL"},
7975: {"Type":"Etc","SubType":"NULL"},
7976: {"Type":"Etc","SubType":"NULL"},
7977: {"Type":"Etc","SubType":"NULL"},
7978: {"Type":"Etc","SubType":"NULL"},
7979: {"Type":"Etc","SubType":"NULL"},
7980: {"Type":"Etc","SubType":"NULL"},
7981: {"Type":"Etc","SubType":"NULL"},
7982: {"Type":"Etc","SubType":"NULL"},
7983: {"Type":"Etc","SubType":"NULL"},
7984: {"Type":"Etc","SubType":"NULL"},
7985: {"Type":"Etc","SubType":"NULL"},
7986: {"Type":"Etc","SubType":"NULL"},
7987: {"Type":"Etc","SubType":"NULL"},
7988: {"Type":"Etc","SubType":"NULL"},
7989: {"Type":"Etc","SubType":"NULL"},
7990: {"Type":"Etc","SubType":"NULL"},
7991: {"Type":"Etc","SubType":"NULL"},
7992: {"Type":"Etc","SubType":"NULL"},
7993: {"Type":"Etc","SubType":"NULL"},
7994: {"Type":"Etc","SubType":"NULL"},
7995: {"Type":"Etc","SubType":"NULL"},
7996: {"Type":"Etc","SubType":"NULL"},
7997: {"Type":"Etc","SubType":"NULL"},
7998: {"Type":"Etc","SubType":"NULL"},
7999: {"Type":"Etc","SubType":"NULL"},
9001: {"Type":"Petegg","SubType":"NULL"},
9002: {"Type":"Petegg","SubType":"NULL"},
9003: {"Type":"Petegg","SubType":"NULL"},
9004: {"Type":"Petegg","SubType":"NULL"},
9005: {"Type":"Petegg","SubType":"NULL"},
9006: {"Type":"Petegg","SubType":"NULL"},
9007: {"Type":"Petegg","SubType":"NULL"},
9008: {"Type":"Petegg","SubType":"NULL"},
9009: {"Type":"Petegg","SubType":"NULL"},
9010: {"Type":"Petegg","SubType":"NULL"},
9011: {"Type":"Petegg","SubType":"NULL"},
9012: {"Type":"Petegg","SubType":"NULL"},
9013: {"Type":"Petegg","SubType":"NULL"},
9014: {"Type":"Petegg","SubType":"NULL"},
9015: {"Type":"Petegg","SubType":"NULL"},
9016: {"Type":"Petegg","SubType":"NULL"},
9017: {"Type":"Petegg","SubType":"NULL"},
9018: {"Type":"Petegg","SubType":"NULL"},
9019: {"Type":"Petegg","SubType":"NULL"},
9020: {"Type":"Petegg","SubType":"NULL"},
9021: {"Type":"Petegg","SubType":"NULL"},
9022: {"Type":"Petegg","SubType":"NULL"},
9023: {"Type":"Petegg","SubType":"NULL"},
9024: {"Type":"Petegg","SubType":"NULL"},
9025: {"Type":"Petegg","SubType":"NULL"},
9026: {"Type":"Petegg","SubType":"NULL"},
9027: {"Type":"Petegg","SubType":"NULL"},
9028: {"Type":"Petegg","SubType":"NULL"},
9029: {"Type":"Petegg","SubType":"NULL"},
9030: {"Type":"Petegg","SubType":"NULL"},
9031: {"Type":"Petegg","SubType":"NULL"},
9032: {"Type":"Petegg","SubType":"NULL"},
9033: {"Type":"Petegg","SubType":"NULL"},
9034: {"Type":"Petegg","SubType":"NULL"},
9035: {"Type":"Petegg","SubType":"NULL"},
9036: {"Type":"Petegg","SubType":"NULL"},
9037: {"Type":"Petegg","SubType":"NULL"},
9038: {"Type":"Petegg","SubType":"NULL"},
9039: {"Type":"Petegg","SubType":"NULL"},
9040: {"Type":"Petegg","SubType":"NULL"},
9041: {"Type":"Petegg","SubType":"NULL"},
9042: {"Type":"Petegg","SubType":"NULL"},
9043: {"Type":"Petegg","SubType":"NULL"},
9044: {"Type":"Petegg","SubType":"NULL"},
9045: {"Type":"Petegg","SubType":"NULL"},
9046: {"Type":"Petegg","SubType":"NULL"},
9047: {"Type":"Petegg","SubType":"NULL"},
9048: {"Type":"Petegg","SubType":"NULL"},
9049: {"Type":"Petegg","SubType":"NULL"},
9050: {"Type":"Petegg","SubType":"NULL"},
9051: {"Type":"Petegg","SubType":"NULL"},
9052: {"Type":"Petegg","SubType":"NULL"},
9053: {"Type":"Petegg","SubType":"NULL"},
9054: {"Type":"Petegg","SubType":"NULL"},
9055: {"Type":"Petegg","SubType":"NULL"},
9056: {"Type":"Petegg","SubType":"NULL"},
9057: {"Type":"Petegg","SubType":"NULL"},
9058: {"Type":"Petegg","SubType":"NULL"},
9059: {"Type":"Petegg","SubType":"NULL"},
9060: {"Type":"Petegg","SubType":"NULL"},
9061: {"Type":"Petegg","SubType":"NULL"},
9062: {"Type":"Petegg","SubType":"NULL"},
9063: {"Type":"Petegg","SubType":"NULL"},
9064: {"Type":"Petegg","SubType":"NULL"},
9065: {"Type":"Petegg","SubType":"NULL"},
9066: {"Type":"Petegg","SubType":"NULL"},
9067: {"Type":"Petegg","SubType":"NULL"},
9068: {"Type":"Petegg","SubType":"NULL"},
9069: {"Type":"Petegg","SubType":"NULL"},
9070: {"Type":"Petegg","SubType":"NULL"},
9071: {"Type":"Petegg","SubType":"NULL"},
9072: {"Type":"Petegg","SubType":"NULL"},
9073: {"Type":"Petegg","SubType":"NULL"},
9074: {"Type":"Petegg","SubType":"NULL"},
9075: {"Type":"Petegg","SubType":"NULL"},
9076: {"Type":"Petegg","SubType":"NULL"},
9077: {"Type":"Petegg","SubType":"NULL"},
9078: {"Type":"Petegg","SubType":"NULL"},
9079: {"Type":"Petegg","SubType":"NULL"},
9080: {"Type":"Petegg","SubType":"NULL"},
9087: {"Type":"Petegg","SubType":"NULL"},
9088: {"Type":"Petegg","SubType":"NULL"},
9089: {"Type":"Petegg","SubType":"NULL"},
9090: {"Type":"Petegg","SubType":"NULL"},
9091: {"Type":"Petegg","SubType":"NULL"},
9092: {"Type":"Petegg","SubType":"NULL"},
9093: {"Type":"Petegg","SubType":"NULL"},
9094: {"Type":"Petegg","SubType":"NULL"},
9095: {"Type":"Petegg","SubType":"NULL"},
9096: {"Type":"Petegg","SubType":"NULL"},
9097: {"Type":"Petegg","SubType":"NULL"},
9098: {"Type":"Petegg","SubType":"NULL"},
9099: {"Type":"Petegg","SubType":"NULL"},
9100: {"Type":"Petegg","SubType":"NULL"},
9101: {"Type":"Petegg","SubType":"NULL"},
9102: {"Type":"Petegg","SubType":"NULL"},
9103: {"Type":"Petegg","SubType":"NULL"},
9104: {"Type":"Petegg","SubType":"NULL"},
9105: {"Type":"Petegg","SubType":"NULL"},
9106: {"Type":"Petegg","SubType":"NULL"},
9107: {"Type":"Petegg","SubType":"NULL"},
9108: {"Type":"Petegg","SubType":"NULL"},
9109: {"Type":"Petegg","SubType":"NULL"},
9111: {"Type":"Petegg","SubType":"NULL"},
9112: {"Type":"Petegg","SubType":"NULL"},
9113: {"Type":"Petegg","SubType":"NULL"},
9114: {"Type":"Petegg","SubType":"NULL"},
9115: {"Type":"Petegg","SubType":"NULL"},
9116: {"Type":"Petegg","SubType":"NULL"},
9117: {"Type":"Petegg","SubType":"NULL"},
9118: {"Type":"Petegg","SubType":"NULL"},
9119: {"Type":"Petegg","SubType":"NULL"},
9120: {"Type":"Petegg","SubType":"NULL"},
9121: {"Type":"Petegg","SubType":"NULL"},
9122: {"Type":"Petegg","SubType":"NULL"},
9123: {"Type":"Petegg","SubType":"NULL"},
9124: {"Type":"Petegg","SubType":"NULL"},
9125: {"Type":"PetEgg","SubType":"NULL"},
9126: {"Type":"PetEgg","SubType":"NULL"},
9128: {"Type":"Petegg","SubType":"NULL"},
9129: {"Type":"PetEgg","SubType":"NULL"},
9130: {"Type":"PetEgg","SubType":"NULL"},
9131: {"Type":"PetEgg","SubType":"NULL"},
9132: {"Type":"PetEgg","SubType":"NULL"},
9133: {"Type":"PetEgg","SubType":"NULL"},
9134: {"Type":"PetEgg","SubType":"NULL"},
9137: {"Type":"PetEgg","SubType":"NULL"},
9138: {"Type":"PetEgg","SubType":"NULL"},
9139: {"Type":"PetEgg","SubType":"NULL"},
9140: {"Type":"PetEgg","SubType":"NULL"},
9141: {"Type":"PetEgg","SubType":"NULL"},
9142: {"Type":"PetEgg","SubType":"NULL"},
9144: {"Type":"PetEgg","SubType":"NULL"},
9145: {"Type":"PetEgg","SubType":"NULL"},
9146: {"Type":"PetEgg","SubType":"NULL"},
9147: {"Type":"PetEgg","SubType":"NULL"},
9148: {"Type":"PetEgg","SubType":"NULL"},
9155: {"Type":"PetEgg","SubType":"NULL"},
9156: {"Type":"PetEgg","SubType":"NULL"},
9157: {"Type":"PetEgg","SubType":"NULL"},
9183: {"Type":"PetEgg","SubType":"NULL"},
9184: {"Type":"PetEgg","SubType":"NULL"},
9192: {"Type":"PetEgg","SubType":"NULL"},
9193: {"Type":"PetEgg","SubType":"NULL"},
9510: {"Type":"Usable","SubType":"NULL"},
9514: {"Type":"DelayConsume","SubType":"NULL"},
9515: {"Type":"Usable","SubType":"NULL"},
9517: {"Type":"Usable","SubType":"NULL"},
9523: {"Type":"DelayConsume","SubType":"NULL"},
9529: {"Type":"DelayConsume","SubType":"NULL"},
9530: {"Type":"Usable","SubType":"NULL"},
9539: {"Type":"Healing","SubType":"NULL"},
9550: {"Type":"DelayConsume","SubType":"NULL"},
9551: {"Type":"DelayConsume","SubType":"NULL"},
9553: {"Type":"Cash","SubType":"NULL"},
9569: {"Type":"Healing","SubType":"NULL"},
9581: {"Type":"Usable","SubType":"NULL"},
9582: {"Type":"Healing","SubType":"NULL"},
9585: {"Type":"Usable","SubType":"NULL"},
9586: {"Type":"Usable","SubType":"NULL"},
9587: {"Type":"Usable","SubType":"NULL"},
9588: {"Type":"Usable","SubType":"NULL"},
9589: {"Type":"Usable","SubType":"NULL"},
9590: {"Type":"Usable","SubType":"NULL"},
9610: {"Type":"Healing","SubType":"NULL"},
9785: {"Type":"DelayConsume","SubType":"NULL"},
9862: {"Type":"Usable","SubType":"NULL"},
9894: {"Type":"DelayConsume","SubType":"NULL"},
9895: {"Type":"Usable","SubType":"NULL"},
9896: {"Type":"Usable","SubType":"NULL"},
9897: {"Type":"Usable","SubType":"NULL"},
9908: {"Type":"Usable","SubType":"NULL"},
9909: {"Type":"Usable","SubType":"NULL"},
9932: {"Type":"Usable","SubType":"NULL"},
9933: {"Type":"DelayConsume","SubType":"NULL"},
9934: {"Type":"DelayConsume","SubType":"NULL"},
9935: {"Type":"DelayConsume","SubType":"NULL"},
9969: {"Type":"Usable","SubType":"NULL"},
9970: {"Type":"Usable","SubType":"NULL"},
9971: {"Type":"Usable","SubType":"NULL"},
9972: {"Type":"Usable","SubType":"NULL"},
9973: {"Type":"Usable","SubType":"NULL"},
9974: {"Type":"Usable","SubType":"NULL"},
9975: {"Type":"Usable","SubType":"NULL"},
9976: {"Type":"Usable","SubType":"NULL"},
9977: {"Type":"Usable","SubType":"NULL"},
9978: {"Type":"Usable","SubType":"NULL"},
9979: {"Type":"Usable","SubType":"NULL"},
9980: {"Type":"Usable","SubType":"NULL"},
9981: {"Type":"Usable","SubType":"NULL"},
9982: {"Type":"Usable","SubType":"NULL"},
9983: {"Type":"Usable","SubType":"NULL"},
9984: {"Type":"Usable","SubType":"NULL"},
9985: {"Type":"Usable","SubType":"NULL"},
9986: {"Type":"Usable","SubType":"NULL"},
9987: {"Type":"Usable","SubType":"NULL"},
9988: {"Type":"Usable","SubType":"NULL"},
9991: {"Type":"Cash","SubType":"NULL"},
9999: {"Type":"Usable","SubType":"NULL"},
10001: {"Type":"Petarmor","SubType":"NULL"},
10002: {"Type":"Petarmor","SubType":"NULL"},
10003: {"Type":"Petarmor","SubType":"NULL"},
10004: {"Type":"Petarmor","SubType":"NULL"},
10005: {"Type":"Petarmor","SubType":"NULL"},
10006: {"Type":"Petarmor","SubType":"NULL"},
10007: {"Type":"Petarmor","SubType":"NULL"},
10008: {"Type":"Petarmor","SubType":"NULL"},
10009: {"Type":"Petarmor","SubType":"NULL"},
10010: {"Type":"Petarmor","SubType":"NULL"},
10011: {"Type":"Petarmor","SubType":"NULL"},
10012: {"Type":"Petarmor","SubType":"NULL"},
10013: {"Type":"Petarmor","SubType":"NULL"},
10014: {"Type":"Petarmor","SubType":"NULL"},
10015: {"Type":"Petarmor","SubType":"NULL"},
10016: {"Type":"Petarmor","SubType":"NULL"},
10017: {"Type":"Petarmor","SubType":"NULL"},
10018: {"Type":"Petarmor","SubType":"NULL"},
10019: {"Type":"Petarmor","SubType":"NULL"},
10020: {"Type":"Petarmor","SubType":"NULL"},
10021: {"Type":"Petarmor","SubType":"NULL"},
10022: {"Type":"Petarmor","SubType":"NULL"},
10023: {"Type":"Petarmor","SubType":"NULL"},
10024: {"Type":"Petarmor","SubType":"NULL"},
10025: {"Type":"Petarmor","SubType":"NULL"},
10026: {"Type":"Petarmor","SubType":"NULL"},
10027: {"Type":"Petarmor","SubType":"NULL"},
10028: {"Type":"Petarmor","SubType":"NULL"},
10029: {"Type":"Petarmor","SubType":"NULL"},
10030: {"Type":"Petarmor","SubType":"NULL"},
10031: {"Type":"Petarmor","SubType":"NULL"},
10032: {"Type":"Petarmor","SubType":"NULL"},
10033: {"Type":"Petarmor","SubType":"NULL"},
10034: {"Type":"Petarmor","SubType":"NULL"},
10035: {"Type":"Petarmor","SubType":"NULL"},
10036: {"Type":"Petarmor","SubType":"NULL"},
10037: {"Type":"Petarmor","SubType":"NULL"},
10038: {"Type":"Petarmor","SubType":"NULL"},
10039: {"Type":"Petarmor","SubType":"NULL"},
10040: {"Type":"Petarmor","SubType":"NULL"},
10041: {"Type":"Petarmor","SubType":"NULL"},
10042: {"Type":"Petarmor","SubType":"NULL"},
10043: {"Type":"PetArmor","SubType":"NULL"},
10044: {"Type":"PetArmor","SubType":"NULL"},
10045: {"Type":"PetArmor","SubType":"NULL"},
10625: {"Type":"Usable","SubType":"NULL"},
11000: {"Type":"Etc","SubType":"NULL"},
11001: {"Type":"Etc","SubType":"NULL"},
11002: {"Type":"Etc","SubType":"NULL"},
11003: {"Type":"Etc","SubType":"NULL"},
11004: {"Type":"Etc","SubType":"NULL"},
11005: {"Type":"Etc","SubType":"NULL"},
11006: {"Type":"Etc","SubType":"NULL"},
11007: {"Type":"Etc","SubType":"NULL"},
11008: {"Type":"Etc","SubType":"NULL"},
11009: {"Type":"Etc","SubType":"NULL"},
11010: {"Type":"Etc","SubType":"NULL"},
11011: {"Type":"Etc","SubType":"NULL"},
11012: {"Type":"Etc","SubType":"NULL"},
11013: {"Type":"Etc","SubType":"NULL"},
11014: {"Type":"Etc","SubType":"NULL"},
11015: {"Type":"Etc","SubType":"NULL"},
11016: {"Type":"Etc","SubType":"NULL"},
11017: {"Type":"Etc","SubType":"NULL"},
11018: {"Type":"Etc","SubType":"NULL"},
11019: {"Type":"Etc","SubType":"NULL"},
11020: {"Type":"Etc","SubType":"NULL"},
11021: {"Type":"Etc","SubType":"NULL"},
11022: {"Type":"Etc","SubType":"NULL"},
11023: {"Type":"Etc","SubType":"NULL"},
11024: {"Type":"Etc","SubType":"NULL"},
11025: {"Type":"Etc","SubType":"NULL"},
11026: {"Type":"Etc","SubType":"NULL"},
11027: {"Type":"Etc","SubType":"NULL"},
11028: {"Type":"Etc","SubType":"NULL"},
11029: {"Type":"Etc","SubType":"NULL"},
11030: {"Type":"Etc","SubType":"NULL"},
11031: {"Type":"Etc","SubType":"NULL"},
11032: {"Type":"Etc","SubType":"NULL"},
11033: {"Type":"Etc","SubType":"NULL"},
11034: {"Type":"Etc","SubType":"NULL"},
11035: {"Type":"Etc","SubType":"NULL"},
11036: {"Type":"Etc","SubType":"NULL"},
11037: {"Type":"Etc","SubType":"NULL"},
11038: {"Type":"Etc","SubType":"NULL"},
11039: {"Type":"Etc","SubType":"NULL"},
11040: {"Type":"Etc","SubType":"NULL"},
11041: {"Type":"Etc","SubType":"NULL"},
11042: {"Type":"Etc","SubType":"NULL"},
11043: {"Type":"Etc","SubType":"NULL"},
11044: {"Type":"Etc","SubType":"NULL"},
11045: {"Type":"Etc","SubType":"NULL"},
11046: {"Type":"Etc","SubType":"NULL"},
11047: {"Type":"Etc","SubType":"NULL"},
11048: {"Type":"Etc","SubType":"NULL"},
11049: {"Type":"Etc","SubType":"NULL"},
11050: {"Type":"Etc","SubType":"NULL"},
11051: {"Type":"Etc","SubType":"NULL"},
11052: {"Type":"Etc","SubType":"NULL"},
11053: {"Type":"Etc","SubType":"NULL"},
11054: {"Type":"Etc","SubType":"NULL"},
11055: {"Type":"Etc","SubType":"NULL"},
11056: {"Type":"Etc","SubType":"NULL"},
11057: {"Type":"Etc","SubType":"NULL"},
11058: {"Type":"Etc","SubType":"NULL"},
11059: {"Type":"Etc","SubType":"NULL"},
11060: {"Type":"Etc","SubType":"NULL"},
11061: {"Type":"Etc","SubType":"NULL"},
11064: {"Type":"Etc","SubType":"NULL"},
11500: {"Type":"Healing","SubType":"NULL"},
11501: {"Type":"Healing","SubType":"NULL"},
11502: {"Type":"Healing","SubType":"NULL"},
11503: {"Type":"Healing","SubType":"NULL"},
11504: {"Type":"Healing","SubType":"NULL"},
11505: {"Type":"Healing","SubType":"NULL"},
11506: {"Type":"Healing","SubType":"NULL"},
11507: {"Type":"Healing","SubType":"NULL"},
11508: {"Type":"Healing","SubType":"NULL"},
11509: {"Type":"Healing","SubType":"NULL"},
11510: {"Type":"Healing","SubType":"NULL"},
11511: {"Type":"Healing","SubType":"NULL"},
11512: {"Type":"Healing","SubType":"NULL"},
11513: {"Type":"Healing","SubType":"NULL"},
11514: {"Type":"Healing","SubType":"NULL"},
11515: {"Type":"Healing","SubType":"NULL"},
11516: {"Type":"Healing","SubType":"NULL"},
11517: {"Type":"Healing","SubType":"NULL"},
11518: {"Type":"Healing","SubType":"NULL"},
11519: {"Type":"Healing","SubType":"NULL"},
11520: {"Type":"Healing","SubType":"NULL"},
11521: {"Type":"Healing","SubType":"NULL"},
11522: {"Type":"Healing","SubType":"NULL"},
11523: {"Type":"Healing","SubType":"NULL"},
11524: {"Type":"Healing","SubType":"NULL"},
11525: {"Type":"Healing","SubType":"NULL"},
11526: {"Type":"Healing","SubType":"NULL"},
11527: {"Type":"Healing","SubType":"NULL"},
11528: {"Type":"Healing","SubType":"NULL"},
11529: {"Type":"Healing","SubType":"NULL"},
11530: {"Type":"Healing","SubType":"NULL"},
11531: {"Type":"Healing","SubType":"NULL"},
11532: {"Type":"Healing","SubType":"NULL"},
11533: {"Type":"Healing","SubType":"NULL"},
11534: {"Type":"Healing","SubType":"NULL"},
11535: {"Type":"Healing","SubType":"NULL"},
11536: {"Type":"Healing","SubType":"NULL"},
11537: {"Type":"Healing","SubType":"NULL"},
11538: {"Type":"Healing","SubType":"NULL"},
11539: {"Type":"Healing","SubType":"NULL"},
11540: {"Type":"Healing","SubType":"NULL"},
11541: {"Type":"Healing","SubType":"NULL"},
11542: {"Type":"Healing","SubType":"NULL"},
11543: {"Type":"Healing","SubType":"NULL"},
11544: {"Type":"Healing","SubType":"NULL"},
11545: {"Type":"Healing","SubType":"NULL"},
11546: {"Type":"Healing","SubType":"NULL"},
11547: {"Type":"Healing","SubType":"NULL"},
11548: {"Type":"Healing","SubType":"NULL"},
11549: {"Type":"Healing","SubType":"NULL"},
11550: {"Type":"Healing","SubType":"NULL"},
11551: {"Type":"Healing","SubType":"NULL"},
11552: {"Type":"Healing","SubType":"NULL"},
11553: {"Type":"Healing","SubType":"NULL"},
11554: {"Type":"Healing","SubType":"NULL"},
11555: {"Type":"Healing","SubType":"NULL"},
11556: {"Type":"Healing","SubType":"NULL"},
11557: {"Type":"Healing","SubType":"NULL"},
11558: {"Type":"Healing","SubType":"NULL"},
11562: {"Type":"Healing","SubType":"NULL"},
11563: {"Type":"Usable","SubType":"NULL"},
11564: {"Type":"Usable","SubType":"NULL"},
11565: {"Type":"Healing","SubType":"NULL"},
11566: {"Type":"Healing","SubType":"NULL"},
11567: {"Type":"Healing","SubType":"NULL"},
11568: {"Type":"Healing","SubType":"NULL"},
11569: {"Type":"Healing","SubType":"NULL"},
11570: {"Type":"Healing","SubType":"NULL"},
11571: {"Type":"Healing","SubType":"NULL"},
11572: {"Type":"Healing","SubType":"NULL"},
11573: {"Type":"Healing","SubType":"NULL"},
11574: {"Type":"Healing","SubType":"NULL"},
11575: {"Type":"Etc","SubType":"NULL"},
11576: {"Type":"Etc","SubType":"NULL"},
11577: {"Type":"Healing","SubType":"NULL"},
11578: {"Type":"Healing","SubType":"NULL"},
11579: {"Type":"Etc","SubType":"NULL"},
11580: {"Type":"Healing","SubType":"NULL"},
11581: {"Type":"Healing","SubType":"NULL"},
11582: {"Type":"Healing","SubType":"NULL"},
11583: {"Type":"Healing","SubType":"NULL"},
11584: {"Type":"Healing","SubType":"NULL"},
11585: {"Type":"Healing","SubType":"NULL"},
11586: {"Type":"Healing","SubType":"NULL"},
11587: {"Type":"Healing","SubType":"NULL"},
11588: {"Type":"Healing","SubType":"NULL"},
11589: {"Type":"Healing","SubType":"NULL"},
11590: {"Type":"Healing","SubType":"NULL"},
11592: {"Type":"Healing","SubType":"NULL"},
11593: {"Type":"Healing","SubType":"NULL"},
11594: {"Type":"Healing","SubType":"NULL"},
11595: {"Type":"Healing","SubType":"NULL"},
11596: {"Type":"Healing","SubType":"NULL"},
11597: {"Type":"Healing","SubType":"NULL"},
11598: {"Type":"Healing","SubType":"NULL"},
11599: {"Type":"Healing","SubType":"NULL"},
11600: {"Type":"Healing","SubType":"NULL"},
11601: {"Type":"Healing","SubType":"NULL"},
11602: {"Type":"Healing","SubType":"NULL"},
11603: {"Type":"Healing","SubType":"NULL"},
11604: {"Type":"Healing","SubType":"NULL"},
11605: {"Type":"Healing","SubType":"NULL"},
11606: {"Type":"Healing","SubType":"NULL"},
11607: {"Type":"Healing","SubType":"NULL"},
11608: {"Type":"Healing","SubType":"NULL"},
11609: {"Type":"Healing","SubType":"NULL"},
11610: {"Type":"Healing","SubType":"NULL"},
11611: {"Type":"Healing","SubType":"NULL"},
11612: {"Type":"Healing","SubType":"NULL"},
11613: {"Type":"Healing","SubType":"NULL"},
11614: {"Type":"Healing","SubType":"NULL"},
11615: {"Type":"Healing","SubType":"NULL"},
11616: {"Type":"Healing","SubType":"NULL"},
11617: {"Type":"Healing","SubType":"NULL"},
11620: {"Type":"Healing","SubType":"NULL"},
11621: {"Type":"Healing","SubType":"NULL"},
11622: {"Type":"Healing","SubType":"NULL"},
11623: {"Type":"Healing","SubType":"NULL"},
11624: {"Type":"Healing","SubType":"NULL"},
11625: {"Type":"Healing","SubType":"NULL"},
11626: {"Type":"Healing","SubType":"NULL"},
11627: {"Type":"Healing","SubType":"NULL"},
11628: {"Type":"Healing","SubType":"NULL"},
11629: {"Type":"Healing","SubType":"NULL"},
11630: {"Type":"Healing","SubType":"NULL"},
11631: {"Type":"Healing","SubType":"NULL"},
11632: {"Type":"Healing","SubType":"NULL"},
11633: {"Type":"Healing","SubType":"NULL"},
11634: {"Type":"Healing","SubType":"NULL"},
11635: {"Type":"Healing","SubType":"NULL"},
11636: {"Type":"Healing","SubType":"NULL"},
11637: {"Type":"Healing","SubType":"NULL"},
11638: {"Type":"Healing","SubType":"NULL"},
11639: {"Type":"Healing","SubType":"NULL"},
11640: {"Type":"Healing","SubType":"NULL"},
11641: {"Type":"Healing","SubType":"NULL"},
11701: {"Type":"Healing","SubType":"NULL"},
11702: {"Type":"Healing","SubType":"NULL"},
11703: {"Type":"Healing","SubType":"NULL"},
11704: {"Type":"Healing","SubType":"NULL"},
11705: {"Type":"Healing","SubType":"NULL"},
11706: {"Type":"Healing","SubType":"NULL"},
11707: {"Type":"Healing","SubType":"NULL"},
11708: {"Type":"Healing","SubType":"NULL"},
11709: {"Type":"Healing","SubType":"NULL"},
11710: {"Type":"Healing","SubType":"NULL"},
11711: {"Type":"Healing","SubType":"NULL"},
11712: {"Type":"Healing","SubType":"NULL"},
11713: {"Type":"Healing","SubType":"NULL"},
12000: {"Type":"DelayConsume","SubType":"NULL"},
12001: {"Type":"DelayConsume","SubType":"NULL"},
12002: {"Type":"DelayConsume","SubType":"NULL"},
12003: {"Type":"DelayConsume","SubType":"NULL"},
12004: {"Type":"Usable","SubType":"NULL"},
12005: {"Type":"Usable","SubType":"NULL"},
12006: {"Type":"Usable","SubType":"NULL"},
12007: {"Type":"Usable","SubType":"NULL"},
12008: {"Type":"Usable","SubType":"NULL"},
12009: {"Type":"Usable","SubType":"NULL"},
12010: {"Type":"Usable","SubType":"NULL"},
12011: {"Type":"Usable","SubType":"NULL"},
12012: {"Type":"Usable","SubType":"NULL"},
12013: {"Type":"Usable","SubType":"NULL"},
12014: {"Type":"Usable","SubType":"NULL"},
12015: {"Type":"Usable","SubType":"NULL"},
12016: {"Type":"Usable","SubType":"NULL"},
12017: {"Type":"Usable","SubType":"NULL"},
12018: {"Type":"Usable","SubType":"NULL"},
12019: {"Type":"DelayConsume","SubType":"NULL"},
12020: {"Type":"DelayConsume","SubType":"NULL"},
12021: {"Type":"Healing","SubType":"NULL"},
12022: {"Type":"Healing","SubType":"NULL"},
12023: {"Type":"Usable","SubType":"NULL"},
12024: {"Type":"Usable","SubType":"NULL"},
12025: {"Type":"Usable","SubType":"NULL"},
12026: {"Type":"Usable","SubType":"NULL"},
12027: {"Type":"Usable","SubType":"NULL"},
12028: {"Type":"Usable","SubType":"NULL"},
12029: {"Type":"DelayConsume","SubType":"NULL"},
12030: {"Type":"Usable","SubType":"NULL"},
12031: {"Type":"Usable","SubType":"NULL"},
12032: {"Type":"DelayConsume","SubType":"NULL"},
12033: {"Type":"Usable","SubType":"NULL"},
12034: {"Type":"Usable","SubType":"NULL"},
12035: {"Type":"Usable","SubType":"NULL"},
12036: {"Type":"Usable","SubType":"NULL"},
12037: {"Type":"Usable","SubType":"NULL"},
12038: {"Type":"Usable","SubType":"NULL"},
12039: {"Type":"Usable","SubType":"NULL"},
12040: {"Type":"Usable","SubType":"NULL"},
12041: {"Type":"Healing","SubType":"NULL"},
12042: {"Type":"Healing","SubType":"NULL"},
12043: {"Type":"Healing","SubType":"NULL"},
12044: {"Type":"Healing","SubType":"NULL"},
12045: {"Type":"Healing","SubType":"NULL"},
12046: {"Type":"Healing","SubType":"NULL"},
12047: {"Type":"Healing","SubType":"NULL"},
12048: {"Type":"Healing","SubType":"NULL"},
12049: {"Type":"Healing","SubType":"NULL"},
12050: {"Type":"Healing","SubType":"NULL"},
12051: {"Type":"Healing","SubType":"NULL"},
12052: {"Type":"Healing","SubType":"NULL"},
12053: {"Type":"Healing","SubType":"NULL"},
12054: {"Type":"Healing","SubType":"NULL"},
12055: {"Type":"Healing","SubType":"NULL"},
12056: {"Type":"Healing","SubType":"NULL"},
12057: {"Type":"Healing","SubType":"NULL"},
12058: {"Type":"Healing","SubType":"NULL"},
12059: {"Type":"Healing","SubType":"NULL"},
12060: {"Type":"Healing","SubType":"NULL"},
12061: {"Type":"Healing","SubType":"NULL"},
12062: {"Type":"Healing","SubType":"NULL"},
12063: {"Type":"Healing","SubType":"NULL"},
12064: {"Type":"Healing","SubType":"NULL"},
12065: {"Type":"Healing","SubType":"NULL"},
12066: {"Type":"Healing","SubType":"NULL"},
12067: {"Type":"Healing","SubType":"NULL"},
12068: {"Type":"Healing","SubType":"NULL"},
12069: {"Type":"Healing","SubType":"NULL"},
12070: {"Type":"Healing","SubType":"NULL"},
12071: {"Type":"Healing","SubType":"NULL"},
12072: {"Type":"Healing","SubType":"NULL"},
12073: {"Type":"Healing","SubType":"NULL"},
12074: {"Type":"Healing","SubType":"NULL"},
12075: {"Type":"Healing","SubType":"NULL"},
12076: {"Type":"Healing","SubType":"NULL"},
12077: {"Type":"Healing","SubType":"NULL"},
12078: {"Type":"Healing","SubType":"NULL"},
12079: {"Type":"Healing","SubType":"NULL"},
12080: {"Type":"Healing","SubType":"NULL"},
12081: {"Type":"Healing","SubType":"NULL"},
12082: {"Type":"Healing","SubType":"NULL"},
12083: {"Type":"Healing","SubType":"NULL"},
12084: {"Type":"Healing","SubType":"NULL"},
12085: {"Type":"Healing","SubType":"NULL"},
12086: {"Type":"Healing","SubType":"NULL"},
12087: {"Type":"Healing","SubType":"NULL"},
12088: {"Type":"Healing","SubType":"NULL"},
12089: {"Type":"Healing","SubType":"NULL"},
12090: {"Type":"Healing","SubType":"NULL"},
12091: {"Type":"Healing","SubType":"NULL"},
12092: {"Type":"Healing","SubType":"NULL"},
12093: {"Type":"Healing","SubType":"NULL"},
12094: {"Type":"Healing","SubType":"NULL"},
12095: {"Type":"Healing","SubType":"NULL"},
12096: {"Type":"Healing","SubType":"NULL"},
12097: {"Type":"Healing","SubType":"NULL"},
12098: {"Type":"Healing","SubType":"NULL"},
12099: {"Type":"Healing","SubType":"NULL"},
12100: {"Type":"Healing","SubType":"NULL"},
12101: {"Type":"Healing","SubType":"NULL"},
12102: {"Type":"Healing","SubType":"NULL"},
12103: {"Type":"Usable","SubType":"NULL"},
12104: {"Type":"Usable","SubType":"NULL"},
12105: {"Type":"Usable","SubType":"NULL"},
12106: {"Type":"Usable","SubType":"NULL"},
12107: {"Type":"Usable","SubType":"NULL"},
12108: {"Type":"Usable","SubType":"NULL"},
12109: {"Type":"Usable","SubType":"NULL"},
12110: {"Type":"Usable","SubType":"NULL"},
12111: {"Type":"Usable","SubType":"NULL"},
12112: {"Type":"Usable","SubType":"NULL"},
12113: {"Type":"Usable","SubType":"NULL"},
12114: {"Type":"DelayConsume","SubType":"NULL"},
12115: {"Type":"DelayConsume","SubType":"NULL"},
12116: {"Type":"DelayConsume","SubType":"NULL"},
12117: {"Type":"DelayConsume","SubType":"NULL"},
12118: {"Type":"Usable","SubType":"NULL"},
12119: {"Type":"Usable","SubType":"NULL"},
12120: {"Type":"Usable","SubType":"NULL"},
12121: {"Type":"Usable","SubType":"NULL"},
12122: {"Type":"Usable","SubType":"NULL"},
12123: {"Type":"Usable","SubType":"NULL"},
12124: {"Type":"Usable","SubType":"NULL"},
12125: {"Type":"Usable","SubType":"NULL"},
12126: {"Type":"Usable","SubType":"NULL"},
12127: {"Type":"Usable","SubType":"NULL"},
12128: {"Type":"Usable","SubType":"NULL"},
12129: {"Type":"Usable","SubType":"NULL"},
12130: {"Type":"Usable","SubType":"NULL"},
12131: {"Type":"Healing","SubType":"NULL"},
12132: {"Type":"Usable","SubType":"NULL"},
12133: {"Type":"Healing","SubType":"NULL"},
12134: {"Type":"Usable","SubType":"NULL"},
12135: {"Type":"Usable","SubType":"NULL"},
12136: {"Type":"Usable","SubType":"NULL"},
12137: {"Type":"Usable","SubType":"NULL"},
12138: {"Type":"Usable","SubType":"NULL"},
12139: {"Type":"Usable","SubType":"NULL"},
12140: {"Type":"Usable","SubType":"NULL"},
12141: {"Type":"Usable","SubType":"NULL"},
12142: {"Type":"Usable","SubType":"NULL"},
12143: {"Type":"Usable","SubType":"NULL"},
12144: {"Type":"Usable","SubType":"NULL"},
12145: {"Type":"Usable","SubType":"NULL"},
12146: {"Type":"Usable","SubType":"NULL"},
12147: {"Type":"Usable","SubType":"NULL"},
12148: {"Type":"Usable","SubType":"NULL"},
12149: {"Type":"Usable","SubType":"NULL"},
12150: {"Type":"Usable","SubType":"NULL"},
12151: {"Type":"Usable","SubType":"NULL"},
12152: {"Type":"Usable","SubType":"NULL"},
12153: {"Type":"Usable","SubType":"NULL"},
12154: {"Type":"Usable","SubType":"NULL"},
12155: {"Type":"Usable","SubType":"NULL"},
12156: {"Type":"Usable","SubType":"NULL"},
12157: {"Type":"Usable","SubType":"NULL"},
12158: {"Type":"Usable","SubType":"NULL"},
12159: {"Type":"Usable","SubType":"NULL"},
12160: {"Type":"Usable","SubType":"NULL"},
12161: {"Type":"Usable","SubType":"NULL"},
12162: {"Type":"Usable","SubType":"NULL"},
12163: {"Type":"Usable","SubType":"NULL"},
12164: {"Type":"Usable","SubType":"NULL"},
12165: {"Type":"Usable","SubType":"NULL"},
12166: {"Type":"Usable","SubType":"NULL"},
12167: {"Type":"Usable","SubType":"NULL"},
12168: {"Type":"Usable","SubType":"NULL"},
12169: {"Type":"Usable","SubType":"NULL"},
12170: {"Type":"Usable","SubType":"NULL"},
12171: {"Type":"Usable","SubType":"NULL"},
12172: {"Type":"Usable","SubType":"NULL"},
12173: {"Type":"Usable","SubType":"NULL"},
12174: {"Type":"Usable","SubType":"NULL"},
12175: {"Type":"Usable","SubType":"NULL"},
12176: {"Type":"Usable","SubType":"NULL"},
12177: {"Type":"Usable","SubType":"NULL"},
12178: {"Type":"Usable","SubType":"NULL"},
12179: {"Type":"Usable","SubType":"NULL"},
12180: {"Type":"Usable","SubType":"NULL"},
12181: {"Type":"Usable","SubType":"NULL"},
12182: {"Type":"Usable","SubType":"NULL"},
12183: {"Type":"Usable","SubType":"NULL"},
12184: {"Type":"Usable","SubType":"NULL"},
12185: {"Type":"Usable","SubType":"NULL"},
12186: {"Type":"Usable","SubType":"NULL"},
12187: {"Type":"Usable","SubType":"NULL"},
12188: {"Type":"Healing","SubType":"NULL"},
12189: {"Type":"Usable","SubType":"NULL"},
12190: {"Type":"Usable","SubType":"NULL"},
12191: {"Type":"Usable","SubType":"NULL"},
12192: {"Type":"Healing","SubType":"NULL"},
12193: {"Type":"Usable","SubType":"NULL"},
12194: {"Type":"Usable","SubType":"NULL"},
12195: {"Type":"Healing","SubType":"NULL"},
12196: {"Type":"Healing","SubType":"NULL"},
12197: {"Type":"Healing","SubType":"NULL"},
12198: {"Type":"Usable","SubType":"NULL"},
12199: {"Type":"Usable","SubType":"NULL"},
12200: {"Type":"DelayConsume","SubType":"NULL"},
12201: {"Type":"Usable","SubType":"NULL"},
12202: {"Type":"Healing","SubType":"NULL"},
12203: {"Type":"Healing","SubType":"NULL"},
12204: {"Type":"Healing","SubType":"NULL"},
12205: {"Type":"Healing","SubType":"NULL"},
12206: {"Type":"Healing","SubType":"NULL"},
12207: {"Type":"Healing","SubType":"NULL"},
12208: {"Type":"Usable","SubType":"NULL"},
12209: {"Type":"Usable","SubType":"NULL"},
12210: {"Type":"Usable","SubType":"NULL"},
12211: {"Type":"Usable","SubType":"NULL"},
12212: {"Type":"Usable","SubType":"NULL"},
12213: {"Type":"DelayConsume","SubType":"NULL"},
12214: {"Type":"Usable","SubType":"NULL"},
12215: {"Type":"Usable","SubType":"NULL"},
12216: {"Type":"Usable","SubType":"NULL"},
12217: {"Type":"Usable","SubType":"NULL"},
12218: {"Type":"Usable","SubType":"NULL"},
12219: {"Type":"Usable","SubType":"NULL"},
12220: {"Type":"Usable","SubType":"NULL"},
12221: {"Type":"Usable","SubType":"NULL"},
12223: {"Type":"Usable","SubType":"NULL"},
12224: {"Type":"Usable","SubType":"NULL"},
12225: {"Type":"Usable","SubType":"NULL"},
12226: {"Type":"Healing","SubType":"NULL"},
12227: {"Type":"Healing","SubType":"NULL"},
12228: {"Type":"Healing","SubType":"NULL"},
12229: {"Type":"Healing","SubType":"NULL"},
12230: {"Type":"Healing","SubType":"NULL"},
12231: {"Type":"Healing","SubType":"NULL"},
12232: {"Type":"Usable","SubType":"NULL"},
12233: {"Type":"Healing","SubType":"NULL"},
12234: {"Type":"Healing","SubType":"NULL"},
12235: {"Type":"Usable","SubType":"NULL"},
12236: {"Type":"DelayConsume","SubType":"NULL"},
12237: {"Type":"Usable","SubType":"NULL"},
12238: {"Type":"Usable","SubType":"NULL"},
12239: {"Type":"Usable","SubType":"NULL"},
12240: {"Type":"Usable","SubType":"NULL"},
12241: {"Type":"Usable","SubType":"NULL"},
12242: {"Type":"Usable","SubType":"NULL"},
12243: {"Type":"Usable","SubType":"NULL"},
12244: {"Type":"Usable","SubType":"NULL"},
12245: {"Type":"Healing","SubType":"NULL"},
12246: {"Type":"Usable","SubType":"NULL"},
12247: {"Type":"Usable","SubType":"NULL"},
12248: {"Type":"Usable","SubType":"NULL"},
12249: {"Type":"Usable","SubType":"NULL"},
12250: {"Type":"Usable","SubType":"NULL"},
12251: {"Type":"Usable","SubType":"NULL"},
12252: {"Type":"Usable","SubType":"NULL"},
12253: {"Type":"Usable","SubType":"NULL"},
12254: {"Type":"Usable","SubType":"NULL"},
12255: {"Type":"Usable","SubType":"NULL"},
12256: {"Type":"Usable","SubType":"NULL"},
12257: {"Type":"Healing","SubType":"NULL"},
12258: {"Type":"Usable","SubType":"NULL"},
12259: {"Type":"Usable","SubType":"NULL"},
12260: {"Type":"Usable","SubType":"NULL"},
12261: {"Type":"Usable","SubType":"NULL"},
12262: {"Type":"Usable","SubType":"NULL"},
12263: {"Type":"Usable","SubType":"NULL"},
12264: {"Type":"Usable","SubType":"NULL"},
12265: {"Type":"Usable","SubType":"NULL"},
12266: {"Type":"Usable","SubType":"NULL"},
12267: {"Type":"Usable","SubType":"NULL"},
12268: {"Type":"Usable","SubType":"NULL"},
12269: {"Type":"Usable","SubType":"NULL"},
12270: {"Type":"Usable","SubType":"NULL"},
12271: {"Type":"Healing","SubType":"NULL"},
12272: {"Type":"Usable","SubType":"NULL"},
12273: {"Type":"Usable","SubType":"NULL"},
12274: {"Type":"Healing","SubType":"NULL"},
12275: {"Type":"Healing","SubType":"NULL"},
12276: {"Type":"Usable","SubType":"NULL"},
12277: {"Type":"Usable","SubType":"NULL"},
12278: {"Type":"Usable","SubType":"NULL"},
12279: {"Type":"Usable","SubType":"NULL"},
12280: {"Type":"Usable","SubType":"NULL"},
12281: {"Type":"Usable","SubType":"NULL"},
12282: {"Type":"Usable","SubType":"NULL"},
12283: {"Type":"Usable","SubType":"NULL"},
12284: {"Type":"Usable","SubType":"NULL"},
12285: {"Type":"Usable","SubType":"NULL"},
12286: {"Type":"Usable","SubType":"NULL"},
12287: {"Type":"Usable","SubType":"NULL"},
12288: {"Type":"Usable","SubType":"NULL"},
12289: {"Type":"Usable","SubType":"NULL"},
12290: {"Type":"Usable","SubType":"NULL"},
12291: {"Type":"Usable","SubType":"NULL"},
12292: {"Type":"Healing","SubType":"NULL"},
12293: {"Type":"Healing","SubType":"NULL"},
12294: {"Type":"Usable","SubType":"NULL"},
12295: {"Type":"Usable","SubType":"NULL"},
12296: {"Type":"Usable","SubType":"NULL"},
12297: {"Type":"Usable","SubType":"NULL"},
12298: {"Type":"Usable","SubType":"NULL"},
12299: {"Type":"Usable","SubType":"NULL"},
12300: {"Type":"Usable","SubType":"NULL"},
12301: {"Type":"Usable","SubType":"NULL"},
12302: {"Type":"Usable","SubType":"NULL"},
12303: {"Type":"Usable","SubType":"NULL"},
12304: {"Type":"Usable","SubType":"NULL"},
12305: {"Type":"Usable","SubType":"NULL"},
12306: {"Type":"Usable","SubType":"NULL"},
12307: {"Type":"Usable","SubType":"NULL"},
12308: {"Type":"Usable","SubType":"NULL"},
12309: {"Type":"Usable","SubType":"NULL"},
12310: {"Type":"Usable","SubType":"NULL"},
12311: {"Type":"DelayConsume","SubType":"NULL"},
12312: {"Type":"Usable","SubType":"NULL"},
12313: {"Type":"Usable","SubType":"NULL"},
12314: {"Type":"Usable","SubType":"NULL"},
12315: {"Type":"Usable","SubType":"NULL"},
12316: {"Type":"Usable","SubType":"NULL"},
12317: {"Type":"Usable","SubType":"NULL"},
12318: {"Type":"Usable","SubType":"NULL"},
12319: {"Type":"Usable","SubType":"NULL"},
12320: {"Type":"Usable","SubType":"NULL"},
12321: {"Type":"Usable","SubType":"NULL"},
12322: {"Type":"Healing","SubType":"NULL"},
12323: {"Type":"DelayConsume","SubType":"NULL"},
12324: {"Type":"DelayConsume","SubType":"NULL"},
12325: {"Type":"DelayConsume","SubType":"NULL"},
12326: {"Type":"Usable","SubType":"NULL"},
12327: {"Type":"Usable","SubType":"NULL"},
12328: {"Type":"Usable","SubType":"NULL"},
12329: {"Type":"Usable","SubType":"NULL"},
12330: {"Type":"Usable","SubType":"NULL"},
12331: {"Type":"Healing","SubType":"NULL"},
12332: {"Type":"Healing","SubType":"NULL"},
12333: {"Type":"Usable","SubType":"NULL"},
12334: {"Type":"Usable","SubType":"NULL"},
12335: {"Type":"Healing","SubType":"NULL"},
12336: {"Type":"Healing","SubType":"NULL"},
12337: {"Type":"Healing","SubType":"NULL"},
12338: {"Type":"Usable","SubType":"NULL"},
12339: {"Type":"Usable","SubType":"NULL"},
12340: {"Type":"Usable","SubType":"NULL"},
12341: {"Type":"Usable","SubType":"NULL"},
12342: {"Type":"Usable","SubType":"NULL"},
12343: {"Type":"Usable","SubType":"NULL"},
12344: {"Type":"Usable","SubType":"NULL"},
12345: {"Type":"Usable","SubType":"NULL"},
12346: {"Type":"Usable","SubType":"NULL"},
12347: {"Type":"DelayConsume","SubType":"NULL"},
12348: {"Type":"Usable","SubType":"NULL"},
12349: {"Type":"Usable","SubType":"NULL"},
12350: {"Type":"DelayConsume","SubType":"NULL"},
12351: {"Type":"DelayConsume","SubType":"NULL"},
12352: {"Type":"Usable","SubType":"NULL"},
12353: {"Type":"Usable","SubType":"NULL"},
12354: {"Type":"Usable","SubType":"NULL"},
12355: {"Type":"Usable","SubType":"NULL"},
12356: {"Type":"Usable","SubType":"NULL"},
12357: {"Type":"Usable","SubType":"NULL"},
12358: {"Type":"Usable","SubType":"NULL"},
12359: {"Type":"Usable","SubType":"NULL"},
12360: {"Type":"Usable","SubType":"NULL"},
12361: {"Type":"Usable","SubType":"NULL"},
12362: {"Type":"Usable","SubType":"NULL"},
12363: {"Type":"Usable","SubType":"NULL"},
12364: {"Type":"Usable","SubType":"NULL"},
12365: {"Type":"Usable","SubType":"NULL"},
12366: {"Type":"Usable","SubType":"NULL"},
12367: {"Type":"Usable","SubType":"NULL"},
12368: {"Type":"Usable","SubType":"NULL"},
12369: {"Type":"Usable","SubType":"NULL"},
12370: {"Type":"Usable","SubType":"NULL"},
12371: {"Type":"Usable","SubType":"NULL"},
12372: {"Type":"Usable","SubType":"NULL"},
12373: {"Type":"Usable","SubType":"NULL"},
12374: {"Type":"Usable","SubType":"NULL"},
12375: {"Type":"Usable","SubType":"NULL"},
12376: {"Type":"DelayConsume","SubType":"NULL"},
12377: {"Type":"DelayConsume","SubType":"NULL"},
12378: {"Type":"Usable","SubType":"NULL"},
12379: {"Type":"Usable","SubType":"NULL"},
12380: {"Type":"Usable","SubType":"NULL"},
12381: {"Type":"Usable","SubType":"NULL"},
12382: {"Type":"Usable","SubType":"NULL"},
12383: {"Type":"Usable","SubType":"NULL"},
12384: {"Type":"DelayConsume","SubType":"NULL"},
12385: {"Type":"DelayConsume","SubType":"NULL"},
12386: {"Type":"DelayConsume","SubType":"NULL"},
12387: {"Type":"DelayConsume","SubType":"NULL"},
12388: {"Type":"DelayConsume","SubType":"NULL"},
12389: {"Type":"DelayConsume","SubType":"NULL"},
12390: {"Type":"DelayConsume","SubType":"NULL"},
12391: {"Type":"Usable","SubType":"NULL"},
12392: {"Type":"Usable","SubType":"NULL"},
12393: {"Type":"Usable","SubType":"NULL"},
12394: {"Type":"Usable","SubType":"NULL"},
12395: {"Type":"Usable","SubType":"NULL"},
12396: {"Type":"DelayConsume","SubType":"NULL"},
12397: {"Type":"DelayConsume","SubType":"NULL"},
12398: {"Type":"Usable","SubType":"NULL"},
12399: {"Type":"Usable","SubType":"NULL"},
12400: {"Type":"Usable","SubType":"NULL"},
12401: {"Type":"Usable","SubType":"NULL"},
12402: {"Type":"Usable","SubType":"NULL"},
12403: {"Type":"Usable","SubType":"NULL"},
12404: {"Type":"Usable","SubType":"NULL"},
12405: {"Type":"Usable","SubType":"NULL"},
12406: {"Type":"Usable","SubType":"NULL"},
12407: {"Type":"Usable","SubType":"NULL"},
12408: {"Type":"Usable","SubType":"NULL"},
12409: {"Type":"Usable","SubType":"NULL"},
12410: {"Type":"Usable","SubType":"NULL"},
12411: {"Type":"Usable","SubType":"NULL"},
12412: {"Type":"Usable","SubType":"NULL"},
12413: {"Type":"Usable","SubType":"NULL"},
12414: {"Type":"Usable","SubType":"NULL"},
12415: {"Type":"Usable","SubType":"NULL"},
12416: {"Type":"Usable","SubType":"NULL"},
12417: {"Type":"Usable","SubType":"NULL"},
12418: {"Type":"Usable","SubType":"NULL"},
12419: {"Type":"Usable","SubType":"NULL"},
12420: {"Type":"Usable","SubType":"NULL"},
12421: {"Type":"Usable","SubType":"NULL"},
12422: {"Type":"Usable","SubType":"NULL"},
12423: {"Type":"Usable","SubType":"NULL"},
12424: {"Type":"Usable","SubType":"NULL"},
12425: {"Type":"Usable","SubType":"NULL"},
12426: {"Type":"Usable","SubType":"NULL"},
12427: {"Type":"Usable","SubType":"NULL"},
12428: {"Type":"Healing","SubType":"NULL"},
12429: {"Type":"Usable","SubType":"NULL"},
12430: {"Type":"Usable","SubType":"NULL"},
12431: {"Type":"Usable","SubType":"NULL"},
12432: {"Type":"Usable","SubType":"NULL"},
12433: {"Type":"Usable","SubType":"NULL"},
12434: {"Type":"Usable","SubType":"NULL"},
12435: {"Type":"Usable","SubType":"NULL"},
12436: {"Type":"Healing","SubType":"NULL"},
12437: {"Type":"Usable","SubType":"NULL"},
12438: {"Type":"Usable","SubType":"NULL"},
12439: {"Type":"Usable","SubType":"NULL"},
12440: {"Type":"Usable","SubType":"NULL"},
12441: {"Type":"Usable","SubType":"NULL"},
12442: {"Type":"Usable","SubType":"NULL"},
12443: {"Type":"Usable","SubType":"NULL"},
12444: {"Type":"Usable","SubType":"NULL"},
12445: {"Type":"Usable","SubType":"NULL"},
12446: {"Type":"Usable","SubType":"NULL"},
12447: {"Type":"Usable","SubType":"NULL"},
12448: {"Type":"Usable","SubType":"NULL"},
12449: {"Type":"Usable","SubType":"NULL"},
12450: {"Type":"Usable","SubType":"NULL"},
12451: {"Type":"Usable","SubType":"NULL"},
12452: {"Type":"Usable","SubType":"NULL"},
12453: {"Type":"Usable","SubType":"NULL"},
12454: {"Type":"Usable","SubType":"NULL"},
12456: {"Type":"DelayConsume","SubType":"NULL"},
12457: {"Type":"Usable","SubType":"NULL"},
12458: {"Type":"Usable","SubType":"NULL"},
12459: {"Type":"Usable","SubType":"NULL"},
12460: {"Type":"Usable","SubType":"NULL"},
12461: {"Type":"Usable","SubType":"NULL"},
12462: {"Type":"Usable","SubType":"NULL"},
12463: {"Type":"Usable","SubType":"NULL"},
12464: {"Type":"Usable","SubType":"NULL"},
12465: {"Type":"Usable","SubType":"NULL"},
12466: {"Type":"DelayConsume","SubType":"NULL"},
12467: {"Type":"DelayConsume","SubType":"NULL"},
12468: {"Type":"DelayConsume","SubType":"NULL"},
12470: {"Type":"DelayConsume","SubType":"NULL"},
12471: {"Type":"DelayConsume","SubType":"NULL"},
12472: {"Type":"Usable","SubType":"NULL"},
12473: {"Type":"Usable","SubType":"NULL"},
12474: {"Type":"Usable","SubType":"NULL"},
12475: {"Type":"Usable","SubType":"NULL"},
12476: {"Type":"Usable","SubType":"NULL"},
12477: {"Type":"Usable","SubType":"NULL"},
12478: {"Type":"Usable","SubType":"NULL"},
12479: {"Type":"Usable","SubType":"NULL"},
12480: {"Type":"Usable","SubType":"NULL"},
12481: {"Type":"Usable","SubType":"NULL"},
12482: {"Type":"Usable","SubType":"NULL"},
12483: {"Type":"Usable","SubType":"NULL"},
12484: {"Type":"Usable","SubType":"NULL"},
12485: {"Type":"Usable","SubType":"NULL"},
12486: {"Type":"Usable","SubType":"NULL"},
12487: {"Type":"Usable","SubType":"NULL"},
12488: {"Type":"Usable","SubType":"NULL"},
12489: {"Type":"Usable","SubType":"NULL"},
12490: {"Type":"Usable","SubType":"NULL"},
12491: {"Type":"Usable","SubType":"NULL"},
12492: {"Type":"Usable","SubType":"NULL"},
12493: {"Type":"Usable","SubType":"NULL"},
12494: {"Type":"Usable","SubType":"NULL"},
12495: {"Type":"Usable","SubType":"NULL"},
12496: {"Type":"Usable","SubType":"NULL"},
12497: {"Type":"Usable","SubType":"NULL"},
12498: {"Type":"Usable","SubType":"NULL"},
12499: {"Type":"Usable","SubType":"NULL"},
12500: {"Type":"Usable","SubType":"NULL"},
12501: {"Type":"Usable","SubType":"NULL"},
12502: {"Type":"Usable","SubType":"NULL"},
12503: {"Type":"Usable","SubType":"NULL"},
12504: {"Type":"Usable","SubType":"NULL"},
12505: {"Type":"Usable","SubType":"NULL"},
12506: {"Type":"Usable","SubType":"NULL"},
12507: {"Type":"Usable","SubType":"NULL"},
12508: {"Type":"Usable","SubType":"NULL"},
12509: {"Type":"Usable","SubType":"NULL"},
12510: {"Type":"Usable","SubType":"NULL"},
12511: {"Type":"Usable","SubType":"NULL"},
12512: {"Type":"DelayConsume","SubType":"NULL"},
12513: {"Type":"Usable","SubType":"NULL"},
12514: {"Type":"Usable","SubType":"NULL"},
12515: {"Type":"Usable","SubType":"NULL"},
12516: {"Type":"Usable","SubType":"NULL"},
12517: {"Type":"Usable","SubType":"NULL"},
12518: {"Type":"Usable","SubType":"NULL"},
12519: {"Type":"Usable","SubType":"NULL"},
12520: {"Type":"Usable","SubType":"NULL"},
12521: {"Type":"Usable","SubType":"NULL"},
12522: {"Type":"DelayConsume","SubType":"NULL"},
12523: {"Type":"DelayConsume","SubType":"NULL"},
12524: {"Type":"DelayConsume","SubType":"NULL"},
12525: {"Type":"DelayConsume","SubType":"NULL"},
12526: {"Type":"DelayConsume","SubType":"NULL"},
12527: {"Type":"DelayConsume","SubType":"NULL"},
12528: {"Type":"Usable","SubType":"NULL"},
12529: {"Type":"Usable","SubType":"NULL"},
12530: {"Type":"Usable","SubType":"NULL"},
12531: {"Type":"Usable","SubType":"NULL"},
12532: {"Type":"Usable","SubType":"NULL"},
12533: {"Type":"Usable","SubType":"NULL"},
12534: {"Type":"Usable","SubType":"NULL"},
12535: {"Type":"Usable","SubType":"NULL"},
12536: {"Type":"Usable","SubType":"NULL"},
12537: {"Type":"Usable","SubType":"NULL"},
12538: {"Type":"Usable","SubType":"NULL"},
12539: {"Type":"Usable","SubType":"NULL"},
12540: {"Type":"Usable","SubType":"NULL"},
12541: {"Type":"Usable","SubType":"NULL"},
12542: {"Type":"Usable","SubType":"NULL"},
12543: {"Type":"Usable","SubType":"NULL"},
12544: {"Type":"Usable","SubType":"NULL"},
12545: {"Type":"Usable","SubType":"NULL"},
12546: {"Type":"Usable","SubType":"NULL"},
12547: {"Type":"Usable","SubType":"NULL"},
12548: {"Type":"Usable","SubType":"NULL"},
12549: {"Type":"Usable","SubType":"NULL"},
12550: {"Type":"Usable","SubType":"NULL"},
12551: {"Type":"Usable","SubType":"NULL"},
12552: {"Type":"Usable","SubType":"NULL"},
12553: {"Type":"Usable","SubType":"NULL"},
12554: {"Type":"Usable","SubType":"NULL"},
12555: {"Type":"Usable","SubType":"NULL"},
12556: {"Type":"Usable","SubType":"NULL"},
12557: {"Type":"Usable","SubType":"NULL"},
12558: {"Type":"Usable","SubType":"NULL"},
12559: {"Type":"Usable","SubType":"NULL"},
12560: {"Type":"Usable","SubType":"NULL"},
12561: {"Type":"Usable","SubType":"NULL"},
12562: {"Type":"Usable","SubType":"NULL"},
12563: {"Type":"Usable","SubType":"NULL"},
12564: {"Type":"Cash","SubType":"NULL"},
12565: {"Type":"Usable","SubType":"NULL"},
12566: {"Type":"Cash","SubType":"NULL"},
12567: {"Type":"Cash","SubType":"NULL"},
12568: {"Type":"Cash","SubType":"NULL"},
12569: {"Type":"Cash","SubType":"NULL"},
12570: {"Type":"Cash","SubType":"NULL"},
12571: {"Type":"Cash","SubType":"NULL"},
12572: {"Type":"Cash","SubType":"NULL"},
12573: {"Type":"Usable","SubType":"NULL"},
12574: {"Type":"Usable","SubType":"NULL"},
12575: {"Type":"Usable","SubType":"NULL"},
12576: {"Type":"Usable","SubType":"NULL"},
12577: {"Type":"Usable","SubType":"NULL"},
12578: {"Type":"Usable","SubType":"NULL"},
12579: {"Type":"Cash","SubType":"NULL"},
12580: {"Type":"Usable","SubType":"NULL"},
12581: {"Type":"Usable","SubType":"NULL"},
12582: {"Type":"Usable","SubType":"NULL"},
12583: {"Type":"Cash","SubType":"NULL"},
12584: {"Type":"Cash","SubType":"NULL"},
12585: {"Type":"Cash","SubType":"NULL"},
12586: {"Type":"Cash","SubType":"NULL"},
12587: {"Type":"Cash","SubType":"NULL"},
12588: {"Type":"Cash","SubType":"NULL"},
12589: {"Type":"Cash","SubType":"NULL"},
12591: {"Type":"Usable","SubType":"NULL"},
12592: {"Type":"DelayConsume","SubType":"NULL"},
12593: {"Type":"DelayConsume","SubType":"NULL"},
12594: {"Type":"DelayConsume","SubType":"NULL"},
12595: {"Type":"Usable","SubType":"NULL"},
12596: {"Type":"Usable","SubType":"NULL"},
12597: {"Type":"DelayConsume","SubType":"NULL"},
12598: {"Type":"DelayConsume","SubType":"NULL"},
12599: {"Type":"DelayConsume","SubType":"NULL"},
12600: {"Type":"DelayConsume","SubType":"NULL"},
12601: {"Type":"Healing","SubType":"NULL"},
12602: {"Type":"Usable","SubType":"NULL"},
12603: {"Type":"Usable","SubType":"NULL"},
12604: {"Type":"Usable","SubType":"NULL"},
12605: {"Type":"Usable","SubType":"NULL"},
12606: {"Type":"Usable","SubType":"NULL"},
12607: {"Type":"Usable","SubType":"NULL"},
12608: {"Type":"Usable","SubType":"NULL"},
12609: {"Type":"Usable","SubType":"NULL"},
12610: {"Type":"Usable","SubType":"NULL"},
12612: {"Type":"Usable","SubType":"NULL"},
12613: {"Type":"Usable","SubType":"NULL"},
12614: {"Type":"Usable","SubType":"NULL"},
12615: {"Type":"Usable","SubType":"NULL"},
12616: {"Type":"Usable","SubType":"NULL"},
12617: {"Type":"Usable","SubType":"NULL"},
12618: {"Type":"Usable","SubType":"NULL"},
12619: {"Type":"Usable","SubType":"NULL"},
12620: {"Type":"Usable","SubType":"NULL"},
12621: {"Type":"Usable","SubType":"NULL"},
12622: {"Type":"Usable","SubType":"NULL"},
12623: {"Type":"Usable","SubType":"NULL"},
12624: {"Type":"Healing","SubType":"NULL"},
12625: {"Type":"Usable","SubType":"NULL"},
12626: {"Type":"Usable","SubType":"NULL"},
12627: {"Type":"Usable","SubType":"NULL"},
12628: {"Type":"Usable","SubType":"NULL"},
12629: {"Type":"Usable","SubType":"NULL"},
12630: {"Type":"Usable","SubType":"NULL"},
12631: {"Type":"Usable","SubType":"NULL"},
12632: {"Type":"Usable","SubType":"NULL"},
12633: {"Type":"Usable","SubType":"NULL"},
12634: {"Type":"Usable","SubType":"NULL"},
12635: {"Type":"Usable","SubType":"NULL"},
12636: {"Type":"Usable","SubType":"NULL"},
12637: {"Type":"Usable","SubType":"NULL"},
12638: {"Type":"Usable","SubType":"NULL"},
12639: {"Type":"Usable","SubType":"NULL"},
12640: {"Type":"Usable","SubType":"NULL"},
12641: {"Type":"Usable","SubType":"NULL"},
12642: {"Type":"Usable","SubType":"NULL"},
12643: {"Type":"Usable","SubType":"NULL"},
12644: {"Type":"Usable","SubType":"NULL"},
12645: {"Type":"Usable","SubType":"NULL"},
12646: {"Type":"Usable","SubType":"NULL"},
12647: {"Type":"Usable","SubType":"NULL"},
12648: {"Type":"Usable","SubType":"NULL"},
12649: {"Type":"Usable","SubType":"NULL"},
12650: {"Type":"Usable","SubType":"NULL"},
12651: {"Type":"Usable","SubType":"NULL"},
12652: {"Type":"Usable","SubType":"NULL"},
12653: {"Type":"Usable","SubType":"NULL"},
12654: {"Type":"Usable","SubType":"NULL"},
12655: {"Type":"Usable","SubType":"NULL"},
12656: {"Type":"Usable","SubType":"NULL"},
12657: {"Type":"Usable","SubType":"NULL"},
12658: {"Type":"Usable","SubType":"NULL"},
12659: {"Type":"Usable","SubType":"NULL"},
12660: {"Type":"Usable","SubType":"NULL"},
12661: {"Type":"Usable","SubType":"NULL"},
12662: {"Type":"Usable","SubType":"NULL"},
12663: {"Type":"Usable","SubType":"NULL"},
12664: {"Type":"Usable","SubType":"NULL"},
12665: {"Type":"Usable","SubType":"NULL"},
12666: {"Type":"Usable","SubType":"NULL"},
12667: {"Type":"Usable","SubType":"NULL"},
12668: {"Type":"Usable","SubType":"NULL"},
12669: {"Type":"Usable","SubType":"NULL"},
12670: {"Type":"Usable","SubType":"NULL"},
12671: {"Type":"Usable","SubType":"NULL"},
12672: {"Type":"Usable","SubType":"NULL"},
12673: {"Type":"Usable","SubType":"NULL"},
12674: {"Type":"Usable","SubType":"NULL"},
12675: {"Type":"Usable","SubType":"NULL"},
12676: {"Type":"Usable","SubType":"NULL"},
12677: {"Type":"Usable","SubType":"NULL"},
12678: {"Type":"Usable","SubType":"NULL"},
12679: {"Type":"Usable","SubType":"NULL"},
12680: {"Type":"Usable","SubType":"NULL"},
12681: {"Type":"Usable","SubType":"NULL"},
12682: {"Type":"Usable","SubType":"NULL"},
12683: {"Type":"Usable","SubType":"NULL"},
12684: {"Type":"Usable","SubType":"NULL"},
12685: {"Type":"Usable","SubType":"NULL"},
12686: {"Type":"Usable","SubType":"NULL"},
12687: {"Type":"Usable","SubType":"NULL"},
12688: {"Type":"Usable","SubType":"NULL"},
12689: {"Type":"Usable","SubType":"NULL"},
12690: {"Type":"Usable","SubType":"NULL"},
12691: {"Type":"Usable","SubType":"NULL"},
12692: {"Type":"Usable","SubType":"NULL"},
12693: {"Type":"Usable","SubType":"NULL"},
12694: {"Type":"Usable","SubType":"NULL"},
12695: {"Type":"Usable","SubType":"NULL"},
12696: {"Type":"Usable","SubType":"NULL"},
12697: {"Type":"Usable","SubType":"NULL"},
12698: {"Type":"Usable","SubType":"NULL"},
12699: {"Type":"Usable","SubType":"NULL"},
12700: {"Type":"Usable","SubType":"NULL"},
12701: {"Type":"Usable","SubType":"NULL"},
12702: {"Type":"Usable","SubType":"NULL"},
12703: {"Type":"Usable","SubType":"NULL"},
12704: {"Type":"Healing","SubType":"NULL"},
12705: {"Type":"Usable","SubType":"NULL"},
12706: {"Type":"DelayConsume","SubType":"NULL"},
12707: {"Type":"DelayConsume","SubType":"NULL"},
12708: {"Type":"DelayConsume","SubType":"NULL"},
12709: {"Type":"Healing","SubType":"NULL"},
12710: {"Type":"Usable","SubType":"NULL"},
12711: {"Type":"Healing","SubType":"NULL"},
12712: {"Type":"Usable","SubType":"NULL"},
12713: {"Type":"Usable","SubType":"NULL"},
12714: {"Type":"Usable","SubType":"NULL"},
12715: {"Type":"Usable","SubType":"NULL"},
12716: {"Type":"Usable","SubType":"NULL"},
12717: {"Type":"Usable","SubType":"NULL"},
12718: {"Type":"Usable","SubType":"NULL"},
12719: {"Type":"Usable","SubType":"NULL"},
12720: {"Type":"Usable","SubType":"NULL"},
12721: {"Type":"Usable","SubType":"NULL"},
12722: {"Type":"Usable","SubType":"NULL"},
12723: {"Type":"Usable","SubType":"NULL"},
12724: {"Type":"Usable","SubType":"NULL"},
12725: {"Type":"Usable","SubType":"NULL"},
12726: {"Type":"Usable","SubType":"NULL"},
12727: {"Type":"Usable","SubType":"NULL"},
12728: {"Type":"Usable","SubType":"NULL"},
12729: {"Type":"Usable","SubType":"NULL"},
12730: {"Type":"Usable","SubType":"NULL"},
12731: {"Type":"Usable","SubType":"NULL"},
12732: {"Type":"Usable","SubType":"NULL"},
12733: {"Type":"Usable","SubType":"NULL"},
12734: {"Type":"Healing","SubType":"NULL"},
12735: {"Type":"Healing","SubType":"NULL"},
12736: {"Type":"Healing","SubType":"NULL"},
12737: {"Type":"Healing","SubType":"NULL"},
12738: {"Type":"Healing","SubType":"NULL"},
12739: {"Type":"Usable","SubType":"NULL"},
12740: {"Type":"Usable","SubType":"NULL"},
12741: {"Type":"Usable","SubType":"NULL"},
12742: {"Type":"Usable","SubType":"NULL"},
12743: {"Type":"Usable","SubType":"NULL"},
12744: {"Type":"Usable","SubType":"NULL"},
12745: {"Type":"Usable","SubType":"NULL"},
12746: {"Type":"Usable","SubType":"NULL"},
12747: {"Type":"Usable","SubType":"NULL"},
12748: {"Type":"Usable","SubType":"NULL"},
12749: {"Type":"Usable","SubType":"NULL"},
12750: {"Type":"Usable","SubType":"NULL"},
12751: {"Type":"Usable","SubType":"NULL"},
12752: {"Type":"Usable","SubType":"NULL"},
12753: {"Type":"Usable","SubType":"NULL"},
12754: {"Type":"Usable","SubType":"NULL"},
12755: {"Type":"Usable","SubType":"NULL"},
12756: {"Type":"Usable","SubType":"NULL"},
12757: {"Type":"Usable","SubType":"NULL"},
12758: {"Type":"Usable","SubType":"NULL"},
12759: {"Type":"Usable","SubType":"NULL"},
12760: {"Type":"Usable","SubType":"NULL"},
12761: {"Type":"Usable","SubType":"NULL"},
12762: {"Type":"Usable","SubType":"NULL"},
12763: {"Type":"Usable","SubType":"NULL"},
12764: {"Type":"Usable","SubType":"NULL"},
12765: {"Type":"Usable","SubType":"NULL"},
12766: {"Type":"Usable","SubType":"NULL"},
12767: {"Type":"Usable","SubType":"NULL"},
12768: {"Type":"Usable","SubType":"NULL"},
12769: {"Type":"Usable","SubType":"NULL"},
12770: {"Type":"Usable","SubType":"NULL"},
12771: {"Type":"Usable","SubType":"NULL"},
12772: {"Type":"Usable","SubType":"NULL"},
12773: {"Type":"Usable","SubType":"NULL"},
12774: {"Type":"Usable","SubType":"NULL"},
12775: {"Type":"Usable","SubType":"NULL"},
12776: {"Type":"Usable","SubType":"NULL"},
12777: {"Type":"Usable","SubType":"NULL"},
12778: {"Type":"Usable","SubType":"NULL"},
12779: {"Type":"Usable","SubType":"NULL"},
12780: {"Type":"Usable","SubType":"NULL"},
12781: {"Type":"Usable","SubType":"NULL"},
12782: {"Type":"Usable","SubType":"NULL"},
12783: {"Type":"Usable","SubType":"NULL"},
12784: {"Type":"Usable","SubType":"NULL"},
12785: {"Type":"Usable","SubType":"NULL"},
12786: {"Type":"Usable","SubType":"NULL"},
12787: {"Type":"Usable","SubType":"NULL"},
12788: {"Type":"Usable","SubType":"NULL"},
12789: {"Type":"Usable","SubType":"NULL"},
12790: {"Type":"Usable","SubType":"NULL"},
12791: {"Type":"Usable","SubType":"NULL"},
12792: {"Type":"Usable","SubType":"NULL"},
12793: {"Type":"Usable","SubType":"NULL"},
12794: {"Type":"Usable","SubType":"NULL"},
12795: {"Type":"Usable","SubType":"NULL"},
12796: {"Type":"Usable","SubType":"NULL"},
12797: {"Type":"Usable","SubType":"NULL"},
12798: {"Type":"Usable","SubType":"NULL"},
12799: {"Type":"Usable","SubType":"NULL"},
12800: {"Type":"Usable","SubType":"NULL"},
12801: {"Type":"Usable","SubType":"NULL"},
12802: {"Type":"Usable","SubType":"NULL"},
12803: {"Type":"Usable","SubType":"NULL"},
12804: {"Type":"Usable","SubType":"NULL"},
12805: {"Type":"Usable","SubType":"NULL"},
12806: {"Type":"Usable","SubType":"NULL"},
12807: {"Type":"Usable","SubType":"NULL"},
12808: {"Type":"Usable","SubType":"NULL"},
12809: {"Type":"Usable","SubType":"NULL"},
12810: {"Type":"Cash","SubType":"NULL"},
12811: {"Type":"Cash","SubType":"NULL"},
12812: {"Type":"DelayConsume","SubType":"NULL"},
12813: {"Type":"DelayConsume","SubType":"NULL"},
12814: {"Type":"DelayConsume","SubType":"NULL"},
12815: {"Type":"DelayConsume","SubType":"NULL"},
12816: {"Type":"Usable","SubType":"NULL"},
12817: {"Type":"Usable","SubType":"NULL"},
12818: {"Type":"Usable","SubType":"NULL"},
12819: {"Type":"Usable","SubType":"NULL"},
12820: {"Type":"Usable","SubType":"NULL"},
12821: {"Type":"Usable","SubType":"NULL"},
12822: {"Type":"Usable","SubType":"NULL"},
12823: {"Type":"Usable","SubType":"NULL"},
12824: {"Type":"Usable","SubType":"NULL"},
12825: {"Type":"Usable","SubType":"NULL"},
12826: {"Type":"Usable","SubType":"NULL"},
12827: {"Type":"Usable","SubType":"NULL"},
12828: {"Type":"Usable","SubType":"NULL"},
12829: {"Type":"Usable","SubType":"NULL"},
12830: {"Type":"Usable","SubType":"NULL"},
12831: {"Type":"Usable","SubType":"NULL"},
12832: {"Type":"Usable","SubType":"NULL"},
12833: {"Type":"Usable","SubType":"NULL"},
12834: {"Type":"Usable","SubType":"NULL"},
12835: {"Type":"Usable","SubType":"NULL"},
12837: {"Type":"Usable","SubType":"NULL"},
12838: {"Type":"Usable","SubType":"NULL"},
12839: {"Type":"Usable","SubType":"NULL"},
12840: {"Type":"Usable","SubType":"NULL"},
12841: {"Type":"Usable","SubType":"NULL"},
12842: {"Type":"Usable","SubType":"NULL"},
12843: {"Type":"Usable","SubType":"NULL"},
12844: {"Type":"Usable","SubType":"NULL"},
12845: {"Type":"Usable","SubType":"NULL"},
12846: {"Type":"Usable","SubType":"NULL"},
12847: {"Type":"Usable","SubType":"NULL"},
12848: {"Type":"DelayConsume","SubType":"NULL"},
12849: {"Type":"Usable","SubType":"NULL"},
12850: {"Type":"Usable","SubType":"NULL"},
12851: {"Type":"Usable","SubType":"NULL"},
12852: {"Type":"Usable","SubType":"NULL"},
12853: {"Type":"Usable","SubType":"NULL"},
12854: {"Type":"Usable","SubType":"NULL"},
12855: {"Type":"Usable","SubType":"NULL"},
12856: {"Type":"Usable","SubType":"NULL"},
12857: {"Type":"Usable","SubType":"NULL"},
12858: {"Type":"Usable","SubType":"NULL"},
12860: {"Type":"Usable","SubType":"NULL"},
12863: {"Type":"Usable","SubType":"NULL"},
12871: {"Type":"Usable","SubType":"NULL"},
12872: {"Type":"Usable","SubType":"NULL"},
12873: {"Type":"Cash","SubType":"NULL"},
12874: {"Type":"Usable","SubType":"NULL"},
12875: {"Type":"Usable","SubType":"NULL"},
12876: {"Type":"Usable","SubType":"NULL"},
12877: {"Type":"Usable","SubType":"NULL"},
12878: {"Type":"Usable","SubType":"NULL"},
12879: {"Type":"Usable","SubType":"NULL"},
12880: {"Type":"Usable","SubType":"NULL"},
12881: {"Type":"Usable","SubType":"NULL"},
12882: {"Type":"Usable","SubType":"NULL"},
12883: {"Type":"Usable","SubType":"NULL"},
12884: {"Type":"DelayConsume","SubType":"NULL"},
12885: {"Type":"DelayConsume","SubType":"NULL"},
12886: {"Type":"DelayConsume","SubType":"NULL"},
12887: {"Type":"Usable","SubType":"NULL"},
12888: {"Type":"Cash","SubType":"NULL"},
12889: {"Type":"Usable","SubType":"NULL"},
12890: {"Type":"Usable","SubType":"NULL"},
12891: {"Type":"Usable","SubType":"NULL"},
12892: {"Type":"Usable","SubType":"NULL"},
12893: {"Type":"Usable","SubType":"NULL"},
12894: {"Type":"Usable","SubType":"NULL"},
12895: {"Type":"Usable","SubType":"NULL"},
12896: {"Type":"Usable","SubType":"NULL"},
12897: {"Type":"Usable","SubType":"NULL"},
12898: {"Type":"Usable","SubType":"NULL"},
12899: {"Type":"Usable","SubType":"NULL"},
12900: {"Type":"Cash","SubType":"NULL"},
12901: {"Type":"Cash","SubType":"NULL"},
12902: {"Type":"Cash","SubType":"NULL"},
12903: {"Type":"Cash","SubType":"NULL"},
12904: {"Type":"Cash","SubType":"NULL"},
12905: {"Type":"Cash","SubType":"NULL"},
12906: {"Type":"Cash","SubType":"NULL"},
12907: {"Type":"Cash","SubType":"NULL"},
12908: {"Type":"Cash","SubType":"NULL"},
12909: {"Type":"Cash","SubType":"NULL"},
12910: {"Type":"Cash","SubType":"NULL"},
12911: {"Type":"Cash","SubType":"NULL"},
12912: {"Type":"Cash","SubType":"NULL"},
12913: {"Type":"Cash","SubType":"NULL"},
12914: {"Type":"Cash","SubType":"NULL"},
12915: {"Type":"Cash","SubType":"NULL"},
12916: {"Type":"Cash","SubType":"NULL"},
12917: {"Type":"Cash","SubType":"NULL"},
12918: {"Type":"Cash","SubType":"NULL"},
12919: {"Type":"Cash","SubType":"NULL"},
12920: {"Type":"Cash","SubType":"NULL"},
12921: {"Type":"Cash","SubType":"NULL"},
12922: {"Type":"Cash","SubType":"NULL"},
12923: {"Type":"Cash","SubType":"NULL"},
12924: {"Type":"Cash","SubType":"NULL"},
12925: {"Type":"Cash","SubType":"NULL"},
12926: {"Type":"Cash","SubType":"NULL"},
12927: {"Type":"Cash","SubType":"NULL"},
12928: {"Type":"DelayConsume","SubType":"NULL"},
12929: {"Type":"Cash","SubType":"NULL"},
12930: {"Type":"Cash","SubType":"NULL"},
12931: {"Type":"Cash","SubType":"NULL"},
12932: {"Type":"Cash","SubType":"NULL"},
12933: {"Type":"Cash","SubType":"NULL"},
12934: {"Type":"Cash","SubType":"NULL"},
12935: {"Type":"Cash","SubType":"NULL"},
12936: {"Type":"Cash","SubType":"NULL"},
12937: {"Type":"Cash","SubType":"NULL"},
12938: {"Type":"Cash","SubType":"NULL"},
12939: {"Type":"Cash","SubType":"NULL"},
12940: {"Type":"Cash","SubType":"NULL"},
12941: {"Type":"Cash","SubType":"NULL"},
12942: {"Type":"Cash","SubType":"NULL"},
12943: {"Type":"Cash","SubType":"NULL"},
12944: {"Type":"Cash","SubType":"NULL"},
12945: {"Type":"Cash","SubType":"NULL"},
12946: {"Type":"Cash","SubType":"NULL"},
12947: {"Type":"Cash","SubType":"NULL"},
12948: {"Type":"Cash","SubType":"NULL"},
12949: {"Type":"Cash","SubType":"NULL"},
12950: {"Type":"Cash","SubType":"NULL"},
12951: {"Type":"Cash","SubType":"NULL"},
12952: {"Type":"Cash","SubType":"NULL"},
12953: {"Type":"Cash","SubType":"NULL"},
12954: {"Type":"Cash","SubType":"NULL"},
12955: {"Type":"Cash","SubType":"NULL"},
12956: {"Type":"Cash","SubType":"NULL"},
12957: {"Type":"Cash","SubType":"NULL"},
12958: {"Type":"Cash","SubType":"NULL"},
12959: {"Type":"Cash","SubType":"NULL"},
12960: {"Type":"Cash","SubType":"NULL"},
12961: {"Type":"Cash","SubType":"NULL"},
12962: {"Type":"Cash","SubType":"NULL"},
12963: {"Type":"Cash","SubType":"NULL"},
12964: {"Type":"Cash","SubType":"NULL"},
12965: {"Type":"Cash","SubType":"NULL"},
12966: {"Type":"Cash","SubType":"NULL"},
12967: {"Type":"Cash","SubType":"NULL"},
12968: {"Type":"Usable","SubType":"NULL"},
12969: {"Type":"Usable","SubType":"NULL"},
12970: {"Type":"Usable","SubType":"NULL"},
12971: {"Type":"Cash","SubType":"NULL"},
12972: {"Type":"Cash","SubType":"NULL"},
12973: {"Type":"Cash","SubType":"NULL"},
12974: {"Type":"Cash","SubType":"NULL"},
12975: {"Type":"Cash","SubType":"NULL"},
12976: {"Type":"Cash","SubType":"NULL"},
12977: {"Type":"Usable","SubType":"NULL"},
12978: {"Type":"Usable","SubType":"NULL"},
12979: {"Type":"Usable","SubType":"NULL"},
12980: {"Type":"Usable","SubType":"NULL"},
12981: {"Type":"Usable","SubType":"NULL"},
12982: {"Type":"Usable","SubType":"NULL"},
12983: {"Type":"Cash","SubType":"NULL"},
12984: {"Type":"Cash","SubType":"NULL"},
12985: {"Type":"Cash","SubType":"NULL"},
12986: {"Type":"Cash","SubType":"NULL"},
12987: {"Type":"Cash","SubType":"NULL"},
12988: {"Type":"Cash","SubType":"NULL"},
12989: {"Type":"Cash","SubType":"NULL"},
12990: {"Type":"Cash","SubType":"NULL"},
12991: {"Type":"Cash","SubType":"NULL"},
12992: {"Type":"Cash","SubType":"NULL"},
12993: {"Type":"Cash","SubType":"NULL"},
12994: {"Type":"Cash","SubType":"NULL"},
12995: {"Type":"Cash","SubType":"NULL"},
12996: {"Type":"Cash","SubType":"NULL"},
12997: {"Type":"Cash","SubType":"NULL"},
12998: {"Type":"Cash","SubType":"NULL"},
12999: {"Type":"Cash","SubType":"NULL"},
13000: {"Type":"Weapon","SubType":"Dagger"},
13001: {"Type":"Weapon","SubType":"Dagger"},
13002: {"Type":"Weapon","SubType":"Dagger"},
13003: {"Type":"Weapon","SubType":"Dagger"},
13004: {"Type":"Weapon","SubType":"Dagger"},
13005: {"Type":"Weapon","SubType":"Dagger"},
13006: {"Type":"Weapon","SubType":"Dagger"},
13007: {"Type":"Weapon","SubType":"Dagger"},
13008: {"Type":"Weapon","SubType":"Dagger"},
13009: {"Type":"Weapon","SubType":"Dagger"},
13010: {"Type":"Weapon","SubType":"Dagger"},
13011: {"Type":"Weapon","SubType":"Dagger"},
13012: {"Type":"Weapon","SubType":"Dagger"},
13013: {"Type":"Weapon","SubType":"Dagger"},
13014: {"Type":"Weapon","SubType":"Dagger"},
13015: {"Type":"Weapon","SubType":"Dagger"},
13016: {"Type":"Weapon","SubType":"Dagger"},
13017: {"Type":"Weapon","SubType":"Dagger"},
13018: {"Type":"Weapon","SubType":"Dagger"},
13019: {"Type":"Weapon","SubType":"Dagger"},
13020: {"Type":"Weapon","SubType":"Dagger"},
13021: {"Type":"Weapon","SubType":"Dagger"},
13022: {"Type":"Weapon","SubType":"Dagger"},
13023: {"Type":"Weapon","SubType":"Dagger"},
13024: {"Type":"Weapon","SubType":"Dagger"},
13025: {"Type":"Weapon","SubType":"Dagger"},
13026: {"Type":"Weapon","SubType":"Dagger"},
13027: {"Type":"Weapon","SubType":"Dagger"},
13028: {"Type":"Weapon","SubType":"Dagger"},
13029: {"Type":"Weapon","SubType":"Dagger"},
13030: {"Type":"Weapon","SubType":"Dagger"},
13031: {"Type":"Weapon","SubType":"Dagger"},
13032: {"Type":"Weapon","SubType":"Dagger"},
13033: {"Type":"Weapon","SubType":"Dagger"},
13034: {"Type":"Weapon","SubType":"Dagger"},
13035: {"Type":"Weapon","SubType":"Dagger"},
13036: {"Type":"Weapon","SubType":"Dagger"},
13037: {"Type":"Weapon","SubType":"Dagger"},
13038: {"Type":"Weapon","SubType":"Dagger"},
13039: {"Type":"Weapon","SubType":"Dagger"},
13040: {"Type":"Weapon","SubType":"Dagger"},
13041: {"Type":"Weapon","SubType":"Dagger"},
13042: {"Type":"Weapon","SubType":"Dagger"},
13043: {"Type":"Weapon","SubType":"Dagger"},
13044: {"Type":"Weapon","SubType":"Dagger"},
13045: {"Type":"Weapon","SubType":"Dagger"},
13046: {"Type":"Weapon","SubType":"Dagger"},
13047: {"Type":"Weapon","SubType":"Dagger"},
13048: {"Type":"Weapon","SubType":"Dagger"},
13049: {"Type":"Weapon","SubType":"Dagger"},
13050: {"Type":"Weapon","SubType":"Dagger"},
13051: {"Type":"Weapon","SubType":"Dagger"},
13052: {"Type":"Weapon","SubType":"Dagger"},
13053: {"Type":"Weapon","SubType":"Dagger"},
13054: {"Type":"Weapon","SubType":"Dagger"},
13055: {"Type":"Weapon","SubType":"Dagger"},
13056: {"Type":"Weapon","SubType":"Dagger"},
13057: {"Type":"Weapon","SubType":"Dagger"},
13058: {"Type":"Weapon","SubType":"Dagger"},
13059: {"Type":"Weapon","SubType":"Dagger"},
13060: {"Type":"Weapon","SubType":"Dagger"},
13061: {"Type":"Weapon","SubType":"Dagger"},
13062: {"Type":"Weapon","SubType":"Dagger"},
13063: {"Type":"Weapon","SubType":"Dagger"},
13064: {"Type":"Weapon","SubType":"Dagger"},
13065: {"Type":"Weapon","SubType":"Dagger"},
13066: {"Type":"Weapon","SubType":"Dagger"},
13067: {"Type":"Weapon","SubType":"Dagger"},
13068: {"Type":"Weapon","SubType":"Dagger"},
13069: {"Type":"Weapon","SubType":"Dagger"},
13070: {"Type":"Weapon","SubType":"Dagger"},
13071: {"Type":"Weapon","SubType":"Dagger"},
13072: {"Type":"Weapon","SubType":"Dagger"},
13073: {"Type":"Weapon","SubType":"Dagger"},
13074: {"Type":"Weapon","SubType":"Dagger"},
13075: {"Type":"Weapon","SubType":"Dagger"},
13076: {"Type":"Weapon","SubType":"Dagger"},
13077: {"Type":"Weapon","SubType":"Dagger"},
13078: {"Type":"Weapon","SubType":"Dagger"},
13079: {"Type":"Weapon","SubType":"Dagger"},
13080: {"Type":"Weapon","SubType":"Dagger"},
13081: {"Type":"Weapon","SubType":"Dagger"},
13082: {"Type":"Weapon","SubType":"Dagger"},
13083: {"Type":"Weapon","SubType":"Dagger"},
13084: {"Type":"Weapon","SubType":"Dagger"},
13085: {"Type":"Weapon","SubType":"Dagger"},
13086: {"Type":"Weapon","SubType":"Dagger"},
13087: {"Type":"Weapon","SubType":"Dagger"},
13088: {"Type":"Weapon","SubType":"Dagger"},
13089: {"Type":"Weapon","SubType":"Dagger"},
13090: {"Type":"Weapon","SubType":"Dagger"},
13091: {"Type":"Weapon","SubType":"Dagger"},
13092: {"Type":"Weapon","SubType":"Dagger"},
13093: {"Type":"Weapon","SubType":"Dagger"},
13094: {"Type":"Weapon","SubType":"Dagger"},
13096: {"Type":"Weapon","SubType":"Dagger"},
13097: {"Type":"Weapon","SubType":"Dagger"},
13098: {"Type":"Weapon","SubType":"Dagger"},
13099: {"Type":"Weapon","SubType":"Dagger"},
13100: {"Type":"Weapon","SubType":"Revolve"},
13101: {"Type":"Weapon","SubType":"Revolve"},
13102: {"Type":"Weapon","SubType":"Revolve"},
13103: {"Type":"Weapon","SubType":"Revolve"},
13104: {"Type":"Weapon","SubType":"Revolve"},
13105: {"Type":"Weapon","SubType":"Revolve"},
13106: {"Type":"Weapon","SubType":"Revolve"},
13107: {"Type":"Weapon","SubType":"Revolve"},
13108: {"Type":"Weapon","SubType":"Revolve"},
13109: {"Type":"Weapon","SubType":"Revolve"},
13110: {"Type":"Weapon","SubType":"Revolve"},
13111: {"Type":"Weapon","SubType":"Revolve"},
13112: {"Type":"Weapon","SubType":"Revolve"},
13113: {"Type":"Weapon","SubType":"Revolve"},
13114: {"Type":"Weapon","SubType":"Revolve"},
13115: {"Type":"Weapon","SubType":"Revolve"},
13116: {"Type":"Weapon","SubType":"Revolve"},
13117: {"Type":"Weapon","SubType":"Revolve"},
13118: {"Type":"Weapon","SubType":"Revolve"},
13119: {"Type":"Weapon","SubType":"Revolve"},
13120: {"Type":"Weapon","SubType":"Revolve"},
13122: {"Type":"Weapon","SubType":"Revolve"},
13124: {"Type":"Weapon","SubType":"Revolve"},
13125: {"Type":"Weapon","SubType":"Revolve"},
13126: {"Type":"Weapon","SubType":"Revolve"},
13127: {"Type":"Weapon","SubType":"Revolve"},
13128: {"Type":"Weapon","SubType":"Revolve"},
13129: {"Type":"Weapon","SubType":"Revolve"},
13130: {"Type":"Weapon","SubType":"Revolve"},
13131: {"Type":"Weapon","SubType":"Revolve"},
13132: {"Type":"Weapon","SubType":"Revolve"},
13133: {"Type":"Weapon","SubType":"Revolve"},
13134: {"Type":"Weapon","SubType":"Revolve"},
13135: {"Type":"Weapon","SubType":"Revolve"},
13136: {"Type":"Weapon","SubType":"Revolve"},
13137: {"Type":"Weapon","SubType":"Revolve"},
13138: {"Type":"Weapon","SubType":"Revolve"},
13139: {"Type":"Weapon","SubType":"Revolve"},
13140: {"Type":"Weapon","SubType":"Revolve"},
13141: {"Type":"Weapon","SubType":"Revolve"},
13142: {"Type":"Weapon","SubType":"Revolve"},
13144: {"Type":"Weapon","SubType":"Revolve"},
13145: {"Type":"Weapon","SubType":"Revolve"},
13146: {"Type":"Weapon","SubType":"Revolve"},
13150: {"Type":"Weapon","SubType":"Rifle"},
13151: {"Type":"Weapon","SubType":"Rifle"},
13152: {"Type":"Weapon","SubType":"Rifle"},
13153: {"Type":"Weapon","SubType":"Rifle"},
13154: {"Type":"Weapon","SubType":"Shotgun"},
13155: {"Type":"Weapon","SubType":"Shotgun"},
13156: {"Type":"Weapon","SubType":"Shotgun"},
13157: {"Type":"Weapon","SubType":"Gatling"},
13158: {"Type":"Weapon","SubType":"Gatling"},
13159: {"Type":"Weapon","SubType":"Gatling"},
13160: {"Type":"Weapon","SubType":"Grenade"},
13161: {"Type":"Weapon","SubType":"Grenade"},
13162: {"Type":"Weapon","SubType":"Grenade"},
13163: {"Type":"Weapon","SubType":"Rifle"},
13164: {"Type":"Weapon","SubType":"Rifle"},
13165: {"Type":"Weapon","SubType":"Rifle"},
13166: {"Type":"Weapon","SubType":"Rifle"},
13167: {"Type":"Weapon","SubType":"Shotgun"},
13168: {"Type":"Weapon","SubType":"Shotgun"},
13169: {"Type":"Weapon","SubType":"Shotgun"},
13170: {"Type":"Weapon","SubType":"Rifle"},
13171: {"Type":"Weapon","SubType":"Rifle"},
13172: {"Type":"Weapon","SubType":"Gatling"},
13173: {"Type":"Weapon","SubType":"Shotgun"},
13174: {"Type":"Weapon","SubType":"Grenade"},
13175: {"Type":"Weapon","SubType":"Rifle"},
13176: {"Type":"Weapon","SubType":"Rifle"},
13177: {"Type":"Weapon","SubType":"Gatling"},
13178: {"Type":"Weapon","SubType":"Shotgun"},
13179: {"Type":"Weapon","SubType":"Grenade"},
13180: {"Type":"Weapon","SubType":"Rifle"},
13181: {"Type":"Weapon","SubType":"Shotgun"},
13182: {"Type":"Weapon","SubType":"Gatling"},
13183: {"Type":"Weapon","SubType":"Grenade"},
13184: {"Type":"Weapon","SubType":"Rifle"},
13185: {"Type":"Weapon","SubType":"Gatling"},
13186: {"Type":"Weapon","SubType":"Shotgun"},
13187: {"Type":"Weapon","SubType":"Grenade"},
13189: {"Type":"Weapon","SubType":"Rifle"},
13190: {"Type":"Weapon","SubType":"Rifle"},
13192: {"Type":"Weapon","SubType":"Shotgun"},
13193: {"Type":"Weapon","SubType":"Shotgun"},
13194: {"Type":"Weapon","SubType":"Shotgun"},
13195: {"Type":"Weapon","SubType":"Rifle"},
13196: {"Type":"Weapon","SubType":"Shotgun"},
13197: {"Type":"Weapon","SubType":"Gatling"},
13198: {"Type":"Weapon","SubType":"Gatling"},
13199: {"Type":"Weapon","SubType":"Gatling"},
13200: {"Type":"Ammo","SubType":"Bullet"},
13201: {"Type":"Ammo","SubType":"Bullet"},
13202: {"Type":"Ammo","SubType":"Bullet"},
13203: {"Type":"Ammo","SubType":"Grenade"},
13204: {"Type":"Ammo","SubType":"Grenade"},
13205: {"Type":"Ammo","SubType":"Grenade"},
13206: {"Type":"Ammo","SubType":"Grenade"},
13207: {"Type":"Ammo","SubType":"Grenade"},
13208: {"Type":"Ammo","SubType":"Bullet"},
13210: {"Type":"Ammo","SubType":"Bullet"},
13211: {"Type":"Ammo","SubType":"Bullet"},
13212: {"Type":"Ammo","SubType":"Bullet"},
13213: {"Type":"Ammo","SubType":"Bullet"},
13214: {"Type":"Ammo","SubType":"Bullet"},
13215: {"Type":"Ammo","SubType":"Bullet"},
13216: {"Type":"Ammo","SubType":"Bullet"},
13217: {"Type":"Ammo","SubType":"Bullet"},
13218: {"Type":"Ammo","SubType":"Bullet"},
13219: {"Type":"Ammo","SubType":"Bullet"},
13220: {"Type":"Ammo","SubType":"Bullet"},
13221: {"Type":"Ammo","SubType":"Bullet"},
13222: {"Type":"Ammo","SubType":"Bullet"},
13223: {"Type":"Ammo","SubType":"Grenade"},
13224: {"Type":"Ammo","SubType":"Grenade"},
13225: {"Type":"Ammo","SubType":"Grenade"},
13226: {"Type":"Ammo","SubType":"Grenade"},
13227: {"Type":"Ammo","SubType":"Grenade"},
13228: {"Type":"Ammo","SubType":"Bullet"},
13229: {"Type":"Ammo","SubType":"Bullet"},
13230: {"Type":"Ammo","SubType":"Bullet"},
13231: {"Type":"Ammo","SubType":"Bullet"},
13232: {"Type":"Ammo","SubType":"Bullet"},
13250: {"Type":"Ammo","SubType":"Shurike"},
13251: {"Type":"Ammo","SubType":"Shurike"},
13252: {"Type":"Ammo","SubType":"Shurike"},
13253: {"Type":"Ammo","SubType":"Shurike"},
13254: {"Type":"Ammo","SubType":"Shurike"},
13255: {"Type":"Ammo","SubType":"Kunai"},
13256: {"Type":"Ammo","SubType":"Kunai"},
13257: {"Type":"Ammo","SubType":"Kunai"},
13258: {"Type":"Ammo","SubType":"Kunai"},
13259: {"Type":"Ammo","SubType":"Kunai"},
13260: {"Type":"Ammo","SubType":"Throwwe"},
13261: {"Type":"Ammo","SubType":"Throwwe"},
13262: {"Type":"Ammo","SubType":"Throwwe"},
13263: {"Type":"Ammo","SubType":"Throwwe"},
13264: {"Type":"Ammo","SubType":"Throwwe"},
13265: {"Type":"Ammo","SubType":"Throwwe"},
13266: {"Type":"Ammo","SubType":"Throwwe"},
13267: {"Type":"Ammo","SubType":"Throwwe"},
13268: {"Type":"Ammo","SubType":"Throwwe"},
13269: {"Type":"Ammo","SubType":"Throwwe"},
13270: {"Type":"Ammo","SubType":"Throwwe"},
13271: {"Type":"Ammo","SubType":"Throwwe"},
13272: {"Type":"Ammo","SubType":"Throwwe"},
13273: {"Type":"Ammo","SubType":"Throwwe"},
13274: {"Type":"Ammo","SubType":"Throwwe"},
13275: {"Type":"Ammo","SubType":"Throwwe"},
13276: {"Type":"Ammo","SubType":"Throwwe"},
13277: {"Type":"Ammo","SubType":"Throwwe"},
13278: {"Type":"Ammo","SubType":"Throwwe"},
13279: {"Type":"Ammo","SubType":"Throwwe"},
13280: {"Type":"Ammo","SubType":"Throwwe"},
13281: {"Type":"Ammo","SubType":"Throwwe"},
13282: {"Type":"Ammo","SubType":"Throwwe"},
13283: {"Type":"Ammo","SubType":"Throwwe"},
13284: {"Type":"Ammo","SubType":"Throwwe"},
13285: {"Type":"Ammo","SubType":"Throwwe"},
13286: {"Type":"Ammo","SubType":"Throwwe"},
13287: {"Type":"Ammo","SubType":"Throwwe"},
13288: {"Type":"Ammo","SubType":"Throwwe"},
13289: {"Type":"Ammo","SubType":"Throwwe"},
13290: {"Type":"Ammo","SubType":"Throwwe"},
13291: {"Type":"Ammo","SubType":"Shurike"},
13292: {"Type":"Ammo","SubType":"Kunai"},
13293: {"Type":"Ammo","SubType":"Kunai"},
13294: {"Type":"Ammo","SubType":"Kunai"},
13295: {"Type":"Ammo","SubType":"Shurike"},
13300: {"Type":"Weapon","SubType":"Huuma"},
13301: {"Type":"Weapon","SubType":"Huuma"},
13302: {"Type":"Weapon","SubType":"Huuma"},
13303: {"Type":"Weapon","SubType":"Huuma"},
13304: {"Type":"Weapon","SubType":"Huuma"},
13305: {"Type":"Weapon","SubType":"Huuma"},
13306: {"Type":"Weapon","SubType":"Huuma"},
13307: {"Type":"Weapon","SubType":"Huuma"},
13308: {"Type":"Weapon","SubType":"Huuma"},
13309: {"Type":"Weapon","SubType":"Huuma"},
13310: {"Type":"Weapon","SubType":"Huuma"},
13311: {"Type":"Weapon","SubType":"Huuma"},
13312: {"Type":"Weapon","SubType":"Huuma"},
13313: {"Type":"Weapon","SubType":"Huuma"},
13314: {"Type":"Weapon","SubType":"Huuma"},
13315: {"Type":"Weapon","SubType":"Huuma"},
13316: {"Type":"Weapon","SubType":"Huuma"},
13317: {"Type":"Weapon","SubType":"Huuma"},
13321: {"Type":"Weapon","SubType":"Huuma"},
13322: {"Type":"Weapon","SubType":"Huuma"},
13323: {"Type":"Weapon","SubType":"Huuma"},
13327: {"Type":"Weapon","SubType":"Huuma"},
13328: {"Type":"Weapon","SubType":"Huuma"},
13329: {"Type":"Weapon","SubType":"Huuma"},
13330: {"Type":"Weapon","SubType":"Huuma"},
13332: {"Type":"Weapon","SubType":"Huuma"},
13333: {"Type":"Weapon","SubType":"Huuma"},
13334: {"Type":"Weapon","SubType":"Huuma"},
13335: {"Type":"Weapon","SubType":"Huuma"},
13336: {"Type":"Weapon","SubType":"Huuma"},
13337: {"Type":"Weapon","SubType":"Huuma"},
13338: {"Type":"Weapon","SubType":"Huuma"},
13339: {"Type":"Weapon","SubType":"Huuma"},
13340: {"Type":"Weapon","SubType":"Huuma"},
13341: {"Type":"Weapon","SubType":"Huuma"},
13343: {"Type":"Weapon","SubType":"Huuma"},
13345: {"Type":"Weapon","SubType":"Huuma"},
13346: {"Type":"Weapon","SubType":"Huuma"},
13347: {"Type":"Weapon","SubType":"Huuma"},
13400: {"Type":"Weapon","SubType":"1hSword"},
13401: {"Type":"Weapon","SubType":"1hSword"},
13402: {"Type":"Weapon","SubType":"1hSword"},
13403: {"Type":"Weapon","SubType":"1hSword"},
13404: {"Type":"Weapon","SubType":"1hSword"},
13405: {"Type":"Weapon","SubType":"1hSword"},
13406: {"Type":"Weapon","SubType":"1hSword"},
13407: {"Type":"Weapon","SubType":"1hSword"},
13408: {"Type":"Weapon","SubType":"1hSword"},
13409: {"Type":"Weapon","SubType":"1hSword"},
13410: {"Type":"Weapon","SubType":"1hSword"},
13411: {"Type":"Weapon","SubType":"1hSword"},
13412: {"Type":"Weapon","SubType":"1hSword"},
13413: {"Type":"Weapon","SubType":"1hSword"},
13414: {"Type":"Weapon","SubType":"1hSword"},
13415: {"Type":"Weapon","SubType":"1hSword"},
13416: {"Type":"Weapon","SubType":"1hSword"},
13417: {"Type":"Weapon","SubType":"1hSword"},
13418: {"Type":"Weapon","SubType":"1hSword"},
13419: {"Type":"Weapon","SubType":"1hSword"},
13420: {"Type":"Weapon","SubType":"1hSword"},
13421: {"Type":"Weapon","SubType":"1hSword"},
13422: {"Type":"Weapon","SubType":"1hSword"},
13423: {"Type":"Weapon","SubType":"1hSword"},
13424: {"Type":"Weapon","SubType":"1hSword"},
13425: {"Type":"Weapon","SubType":"1hSword"},
13426: {"Type":"Weapon","SubType":"1hSword"},
13427: {"Type":"Weapon","SubType":"1hSword"},
13428: {"Type":"Weapon","SubType":"1hSword"},
13429: {"Type":"Weapon","SubType":"1hSword"},
13430: {"Type":"Weapon","SubType":"1hSword"},
13431: {"Type":"Weapon","SubType":"1hSword"},
13432: {"Type":"Weapon","SubType":"1hSword"},
13433: {"Type":"Weapon","SubType":"1hSword"},
13434: {"Type":"Weapon","SubType":"1hSword"},
13435: {"Type":"Weapon","SubType":"1hSword"},
13436: {"Type":"Weapon","SubType":"1hSword"},
13437: {"Type":"Weapon","SubType":"1hSword"},
13438: {"Type":"Weapon","SubType":"1hSword"},
13439: {"Type":"Weapon","SubType":"1hSword"},
13440: {"Type":"Weapon","SubType":"1hSword"},
13441: {"Type":"Weapon","SubType":"1hSword"},
13442: {"Type":"Weapon","SubType":"1hSword"},
13444: {"Type":"Weapon","SubType":"1hSword"},
13445: {"Type":"Weapon","SubType":"1hSword"},
13446: {"Type":"Weapon","SubType":"1hSword"},
13447: {"Type":"Weapon","SubType":"1hSword"},
13448: {"Type":"Weapon","SubType":"1hSword"},
13449: {"Type":"Weapon","SubType":"1hSword"},
13450: {"Type":"Weapon","SubType":"1hSword"},
13451: {"Type":"Weapon","SubType":"1hSword"},
13452: {"Type":"Weapon","SubType":"1hSword"},
13453: {"Type":"Weapon","SubType":"1hSword"},
13454: {"Type":"Weapon","SubType":"1hSword"},
13455: {"Type":"Weapon","SubType":"1hSword"},
13456: {"Type":"Weapon","SubType":"1hSword"},
13457: {"Type":"Weapon","SubType":"Dagger"},
13460: {"Type":"Weapon","SubType":"1hSword"},
13461: {"Type":"Weapon","SubType":"1hSword"},
13462: {"Type":"Weapon","SubType":"1hSword"},
13465: {"Type":"Weapon","SubType":"1hSword"},
13466: {"Type":"Weapon","SubType":"1hSword"},
13467: {"Type":"Weapon","SubType":"1hSword"},
13468: {"Type":"Weapon","SubType":"1hSword"},
13469: {"Type":"Weapon","SubType":"1hSword"},
13470: {"Type":"Weapon","SubType":"1hSword"},
13471: {"Type":"Weapon","SubType":"1hSword"},
13472: {"Type":"Weapon","SubType":"1hSword"},
13473: {"Type":"Weapon","SubType":"1hSword"},
13474: {"Type":"Weapon","SubType":"1hSword"},
13475: {"Type":"Weapon","SubType":"1hSword"},
13476: {"Type":"Weapon","SubType":"1hSword"},
13477: {"Type":"Weapon","SubType":"1hSword"},
13478: {"Type":"Weapon","SubType":"1hSword"},
13479: {"Type":"Weapon","SubType":"1hSword"},
13480: {"Type":"Weapon","SubType":"1hSword"},
13481: {"Type":"Weapon","SubType":"1hSword"},
13482: {"Type":"Weapon","SubType":"1hSword"},
13483: {"Type":"Weapon","SubType":"1hSword"},
13485: {"Type":"Weapon","SubType":"1hSword"},
13488: {"Type":"Weapon","SubType":"1hSword"},
13489: {"Type":"Weapon","SubType":"1hSword"},
13490: {"Type":"Weapon","SubType":"1hSword"},
13492: {"Type":"Weapon","SubType":"1hSword"},
13493: {"Type":"Weapon","SubType":"1hSword"},
13495: {"Type":"Weapon","SubType":"1hSword"},
13497: {"Type":"Weapon","SubType":"1hSword"},
13498: {"Type":"Weapon","SubType":"1hSword"},
13499: {"Type":"Weapon","SubType":"1hSword"},
13500: {"Type":"Cash","SubType":"NULL"},
13501: {"Type":"Cash","SubType":"NULL"},
13502: {"Type":"Cash","SubType":"NULL"},
13503: {"Type":"Cash","SubType":"NULL"},
13504: {"Type":"Cash","SubType":"NULL"},
13505: {"Type":"Cash","SubType":"NULL"},
13506: {"Type":"Cash","SubType":"NULL"},
13507: {"Type":"Cash","SubType":"NULL"},
13508: {"Type":"Cash","SubType":"NULL"},
13509: {"Type":"Cash","SubType":"NULL"},
13510: {"Type":"Cash","SubType":"NULL"},
13511: {"Type":"Cash","SubType":"NULL"},
13512: {"Type":"Cash","SubType":"NULL"},
13513: {"Type":"Cash","SubType":"NULL"},
13514: {"Type":"Cash","SubType":"NULL"},
13515: {"Type":"Cash","SubType":"NULL"},
13516: {"Type":"Cash","SubType":"NULL"},
13517: {"Type":"Cash","SubType":"NULL"},
13518: {"Type":"Cash","SubType":"NULL"},
13519: {"Type":"Cash","SubType":"NULL"},
13520: {"Type":"Cash","SubType":"NULL"},
13521: {"Type":"Cash","SubType":"NULL"},
13522: {"Type":"Cash","SubType":"NULL"},
13523: {"Type":"Cash","SubType":"NULL"},
13524: {"Type":"Cash","SubType":"NULL"},
13525: {"Type":"Cash","SubType":"NULL"},
13526: {"Type":"Cash","SubType":"NULL"},
13527: {"Type":"Cash","SubType":"NULL"},
13528: {"Type":"Cash","SubType":"NULL"},
13529: {"Type":"Cash","SubType":"NULL"},
13530: {"Type":"Cash","SubType":"NULL"},
13531: {"Type":"Cash","SubType":"NULL"},
13532: {"Type":"Cash","SubType":"NULL"},
13533: {"Type":"Cash","SubType":"NULL"},
13534: {"Type":"Cash","SubType":"NULL"},
13535: {"Type":"Cash","SubType":"NULL"},
13536: {"Type":"Cash","SubType":"NULL"},
13537: {"Type":"Cash","SubType":"NULL"},
13538: {"Type":"Cash","SubType":"NULL"},
13539: {"Type":"Cash","SubType":"NULL"},
13540: {"Type":"Cash","SubType":"NULL"},
13541: {"Type":"Cash","SubType":"NULL"},
13542: {"Type":"Cash","SubType":"NULL"},
13543: {"Type":"Cash","SubType":"NULL"},
13544: {"Type":"Cash","SubType":"NULL"},
13545: {"Type":"Cash","SubType":"NULL"},
13546: {"Type":"Cash","SubType":"NULL"},
13547: {"Type":"Cash","SubType":"NULL"},
13548: {"Type":"Cash","SubType":"NULL"},
13549: {"Type":"Cash","SubType":"NULL"},
13550: {"Type":"Cash","SubType":"NULL"},
13551: {"Type":"Cash","SubType":"NULL"},
13552: {"Type":"Cash","SubType":"NULL"},
13553: {"Type":"Cash","SubType":"NULL"},
13554: {"Type":"Cash","SubType":"NULL"},
13555: {"Type":"Cash","SubType":"NULL"},
13556: {"Type":"Cash","SubType":"NULL"},
13557: {"Type":"Cash","SubType":"NULL"},
13558: {"Type":"Cash","SubType":"NULL"},
13559: {"Type":"Cash","SubType":"NULL"},
13560: {"Type":"Cash","SubType":"NULL"},
13561: {"Type":"Cash","SubType":"NULL"},
13562: {"Type":"Cash","SubType":"NULL"},
13563: {"Type":"Cash","SubType":"NULL"},
13564: {"Type":"Cash","SubType":"NULL"},
13565: {"Type":"Cash","SubType":"NULL"},
13566: {"Type":"Cash","SubType":"NULL"},
13567: {"Type":"Cash","SubType":"NULL"},
13568: {"Type":"Cash","SubType":"NULL"},
13569: {"Type":"Cash","SubType":"NULL"},
13570: {"Type":"Cash","SubType":"NULL"},
13571: {"Type":"Cash","SubType":"NULL"},
13572: {"Type":"Cash","SubType":"NULL"},
13573: {"Type":"Cash","SubType":"NULL"},
13574: {"Type":"Cash","SubType":"NULL"},
13575: {"Type":"Cash","SubType":"NULL"},
13576: {"Type":"Cash","SubType":"NULL"},
13577: {"Type":"Cash","SubType":"NULL"},
13578: {"Type":"Cash","SubType":"NULL"},
13579: {"Type":"Cash","SubType":"NULL"},
13580: {"Type":"Cash","SubType":"NULL"},
13581: {"Type":"Cash","SubType":"NULL"},
13582: {"Type":"Cash","SubType":"NULL"},
13583: {"Type":"Cash","SubType":"NULL"},
13584: {"Type":"Cash","SubType":"NULL"},
13585: {"Type":"Cash","SubType":"NULL"},
13586: {"Type":"Cash","SubType":"NULL"},
13587: {"Type":"Cash","SubType":"NULL"},
13588: {"Type":"Cash","SubType":"NULL"},
13589: {"Type":"Cash","SubType":"NULL"},
13590: {"Type":"Cash","SubType":"NULL"},
13591: {"Type":"Cash","SubType":"NULL"},
13592: {"Type":"Cash","SubType":"NULL"},
13593: {"Type":"Cash","SubType":"NULL"},
13594: {"Type":"Cash","SubType":"NULL"},
13595: {"Type":"Cash","SubType":"NULL"},
13596: {"Type":"Cash","SubType":"NULL"},
13597: {"Type":"Cash","SubType":"NULL"},
13598: {"Type":"Cash","SubType":"NULL"},
13599: {"Type":"Cash","SubType":"NULL"},
13600: {"Type":"Cash","SubType":"NULL"},
13601: {"Type":"Cash","SubType":"NULL"},
13602: {"Type":"Cash","SubType":"NULL"},
13603: {"Type":"Cash","SubType":"NULL"},
13604: {"Type":"Cash","SubType":"NULL"},
13605: {"Type":"Cash","SubType":"NULL"},
13606: {"Type":"Cash","SubType":"NULL"},
13607: {"Type":"Cash","SubType":"NULL"},
13608: {"Type":"Cash","SubType":"NULL"},
13609: {"Type":"Cash","SubType":"NULL"},
13610: {"Type":"Cash","SubType":"NULL"},
13611: {"Type":"Cash","SubType":"NULL"},
13612: {"Type":"Cash","SubType":"NULL"},
13613: {"Type":"Cash","SubType":"NULL"},
13614: {"Type":"Cash","SubType":"NULL"},
13615: {"Type":"Cash","SubType":"NULL"},
13616: {"Type":"Cash","SubType":"NULL"},
13617: {"Type":"Usable","SubType":"NULL"},
13618: {"Type":"Usable","SubType":"NULL"},
13619: {"Type":"Usable","SubType":"NULL"},
13620: {"Type":"Usable","SubType":"NULL"},
13621: {"Type":"Cash","SubType":"NULL"},
13622: {"Type":"Cash","SubType":"NULL"},
13623: {"Type":"Cash","SubType":"NULL"},
13624: {"Type":"Cash","SubType":"NULL"},
13625: {"Type":"Cash","SubType":"NULL"},
13626: {"Type":"Cash","SubType":"NULL"},
13627: {"Type":"Cash","SubType":"NULL"},
13628: {"Type":"Cash","SubType":"NULL"},
13629: {"Type":"Cash","SubType":"NULL"},
13630: {"Type":"Usable","SubType":"NULL"},
13631: {"Type":"Usable","SubType":"NULL"},
13632: {"Type":"Usable","SubType":"NULL"},
13633: {"Type":"Usable","SubType":"NULL"},
13634: {"Type":"Cash","SubType":"NULL"},
13635: {"Type":"Cash","SubType":"NULL"},
13636: {"Type":"Cash","SubType":"NULL"},
13637: {"Type":"Cash","SubType":"NULL"},
13638: {"Type":"Cash","SubType":"NULL"},
13639: {"Type":"Cash","SubType":"NULL"},
13640: {"Type":"Cash","SubType":"NULL"},
13641: {"Type":"Cash","SubType":"NULL"},
13642: {"Type":"Cash","SubType":"NULL"},
13643: {"Type":"Cash","SubType":"NULL"},
13644: {"Type":"Cash","SubType":"NULL"},
13645: {"Type":"Cash","SubType":"NULL"},
13646: {"Type":"Cash","SubType":"NULL"},
13647: {"Type":"Cash","SubType":"NULL"},
13648: {"Type":"Cash","SubType":"NULL"},
13649: {"Type":"Cash","SubType":"NULL"},
13650: {"Type":"Cash","SubType":"NULL"},
13651: {"Type":"Cash","SubType":"NULL"},
13652: {"Type":"Cash","SubType":"NULL"},
13653: {"Type":"Cash","SubType":"NULL"},
13654: {"Type":"Cash","SubType":"NULL"},
13655: {"Type":"Cash","SubType":"NULL"},
13656: {"Type":"Cash","SubType":"NULL"},
13657: {"Type":"Cash","SubType":"NULL"},
13658: {"Type":"Cash","SubType":"NULL"},
13659: {"Type":"Cash","SubType":"NULL"},
13660: {"Type":"Cash","SubType":"NULL"},
13661: {"Type":"Cash","SubType":"NULL"},
13662: {"Type":"Cash","SubType":"NULL"},
13663: {"Type":"Cash","SubType":"NULL"},
13664: {"Type":"Cash","SubType":"NULL"},
13665: {"Type":"Cash","SubType":"NULL"},
13666: {"Type":"Cash","SubType":"NULL"},
13667: {"Type":"Cash","SubType":"NULL"},
13668: {"Type":"Cash","SubType":"NULL"},
13669: {"Type":"Cash","SubType":"NULL"},
13670: {"Type":"Cash","SubType":"NULL"},
13671: {"Type":"Cash","SubType":"NULL"},
13672: {"Type":"Cash","SubType":"NULL"},
13673: {"Type":"Cash","SubType":"NULL"},
13674: {"Type":"Cash","SubType":"NULL"},
13675: {"Type":"Cash","SubType":"NULL"},
13676: {"Type":"Cash","SubType":"NULL"},
13677: {"Type":"Cash","SubType":"NULL"},
13678: {"Type":"Cash","SubType":"NULL"},
13679: {"Type":"Cash","SubType":"NULL"},
13680: {"Type":"Cash","SubType":"NULL"},
13681: {"Type":"Cash","SubType":"NULL"},
13682: {"Type":"Cash","SubType":"NULL"},
13683: {"Type":"Cash","SubType":"NULL"},
13684: {"Type":"Cash","SubType":"NULL"},
13685: {"Type":"Cash","SubType":"NULL"},
13686: {"Type":"Cash","SubType":"NULL"},
13687: {"Type":"Cash","SubType":"NULL"},
13688: {"Type":"Cash","SubType":"NULL"},
13689: {"Type":"Cash","SubType":"NULL"},
13690: {"Type":"Cash","SubType":"NULL"},
13691: {"Type":"Cash","SubType":"NULL"},
13692: {"Type":"Cash","SubType":"NULL"},
13693: {"Type":"Cash","SubType":"NULL"},
13694: {"Type":"Cash","SubType":"NULL"},
13695: {"Type":"Cash","SubType":"NULL"},
13696: {"Type":"Cash","SubType":"NULL"},
13697: {"Type":"Cash","SubType":"NULL"},
13698: {"Type":"Cash","SubType":"NULL"},
13699: {"Type":"Cash","SubType":"NULL"},
13700: {"Type":"Cash","SubType":"NULL"},
13701: {"Type":"Usable","SubType":"NULL"},
13702: {"Type":"Usable","SubType":"NULL"},
13703: {"Type":"Usable","SubType":"NULL"},
13704: {"Type":"Usable","SubType":"NULL"},
13705: {"Type":"Usable","SubType":"NULL"},
13706: {"Type":"Usable","SubType":"NULL"},
13707: {"Type":"Usable","SubType":"NULL"},
13708: {"Type":"Usable","SubType":"NULL"},
13709: {"Type":"Cash","SubType":"NULL"},
13710: {"Type":"Cash","SubType":"NULL"},
13711: {"Type":"Cash","SubType":"NULL"},
13712: {"Type":"Cash","SubType":"NULL"},
13713: {"Type":"Cash","SubType":"NULL"},
13714: {"Type":"Cash","SubType":"NULL"},
13715: {"Type":"Cash","SubType":"NULL"},
13716: {"Type":"Cash","SubType":"NULL"},
13717: {"Type":"Cash","SubType":"NULL"},
13718: {"Type":"Cash","SubType":"NULL"},
13719: {"Type":"Cash","SubType":"NULL"},
13720: {"Type":"Cash","SubType":"NULL"},
13721: {"Type":"Cash","SubType":"NULL"},
13722: {"Type":"Cash","SubType":"NULL"},
13723: {"Type":"Cash","SubType":"NULL"},
13724: {"Type":"Cash","SubType":"NULL"},
13725: {"Type":"Cash","SubType":"NULL"},
13726: {"Type":"Cash","SubType":"NULL"},
13727: {"Type":"Cash","SubType":"NULL"},
13728: {"Type":"Cash","SubType":"NULL"},
13729: {"Type":"Cash","SubType":"NULL"},
13730: {"Type":"Cash","SubType":"NULL"},
13731: {"Type":"Cash","SubType":"NULL"},
13734: {"Type":"Cash","SubType":"NULL"},
13735: {"Type":"Cash","SubType":"NULL"},
13736: {"Type":"Cash","SubType":"NULL"},
13737: {"Type":"Cash","SubType":"NULL"},
13738: {"Type":"Cash","SubType":"NULL"},
13739: {"Type":"Cash","SubType":"NULL"},
13740: {"Type":"Cash","SubType":"NULL"},
13741: {"Type":"Cash","SubType":"NULL"},
13742: {"Type":"Cash","SubType":"NULL"},
13743: {"Type":"Cash","SubType":"NULL"},
13744: {"Type":"Cash","SubType":"NULL"},
13745: {"Type":"Cash","SubType":"NULL"},
13746: {"Type":"Cash","SubType":"NULL"},
13747: {"Type":"Cash","SubType":"NULL"},
13748: {"Type":"Cash","SubType":"NULL"},
13749: {"Type":"Cash","SubType":"NULL"},
13750: {"Type":"Cash","SubType":"NULL"},
13751: {"Type":"Cash","SubType":"NULL"},
13752: {"Type":"Cash","SubType":"NULL"},
13753: {"Type":"Cash","SubType":"NULL"},
13754: {"Type":"Cash","SubType":"NULL"},
13755: {"Type":"Cash","SubType":"NULL"},
13756: {"Type":"Cash","SubType":"NULL"},
13757: {"Type":"Cash","SubType":"NULL"},
13758: {"Type":"Cash","SubType":"NULL"},
13759: {"Type":"Cash","SubType":"NULL"},
13760: {"Type":"Cash","SubType":"NULL"},
13761: {"Type":"Cash","SubType":"NULL"},
13762: {"Type":"Cash","SubType":"NULL"},
13763: {"Type":"Cash","SubType":"NULL"},
13764: {"Type":"Cash","SubType":"NULL"},
13765: {"Type":"Cash","SubType":"NULL"},
13766: {"Type":"Cash","SubType":"NULL"},
13767: {"Type":"Cash","SubType":"NULL"},
13768: {"Type":"Cash","SubType":"NULL"},
13769: {"Type":"Cash","SubType":"NULL"},
13770: {"Type":"Cash","SubType":"NULL"},
13771: {"Type":"Cash","SubType":"NULL"},
13772: {"Type":"Cash","SubType":"NULL"},
13773: {"Type":"Cash","SubType":"NULL"},
13774: {"Type":"Cash","SubType":"NULL"},
13775: {"Type":"Cash","SubType":"NULL"},
13776: {"Type":"Cash","SubType":"NULL"},
13777: {"Type":"Cash","SubType":"NULL"},
13778: {"Type":"Cash","SubType":"NULL"},
13779: {"Type":"Cash","SubType":"NULL"},
13780: {"Type":"Cash","SubType":"NULL"},
13781: {"Type":"Cash","SubType":"NULL"},
13782: {"Type":"Cash","SubType":"NULL"},
13783: {"Type":"Cash","SubType":"NULL"},
13784: {"Type":"Cash","SubType":"NULL"},
13785: {"Type":"Cash","SubType":"NULL"},
13786: {"Type":"Cash","SubType":"NULL"},
13787: {"Type":"Cash","SubType":"NULL"},
13788: {"Type":"Cash","SubType":"NULL"},
13789: {"Type":"Cash","SubType":"NULL"},
13790: {"Type":"Cash","SubType":"NULL"},
13791: {"Type":"Cash","SubType":"NULL"},
13792: {"Type":"Cash","SubType":"NULL"},
13793: {"Type":"Cash","SubType":"NULL"},
13794: {"Type":"Cash","SubType":"NULL"},
13795: {"Type":"Cash","SubType":"NULL"},
13796: {"Type":"Cash","SubType":"NULL"},
13797: {"Type":"Cash","SubType":"NULL"},
13798: {"Type":"Cash","SubType":"NULL"},
13799: {"Type":"Cash","SubType":"NULL"},
13800: {"Type":"Cash","SubType":"NULL"},
13801: {"Type":"Cash","SubType":"NULL"},
13802: {"Type":"Cash","SubType":"NULL"},
13803: {"Type":"Cash","SubType":"NULL"},
13804: {"Type":"Cash","SubType":"NULL"},
13805: {"Type":"Cash","SubType":"NULL"},
13806: {"Type":"Cash","SubType":"NULL"},
13807: {"Type":"Cash","SubType":"NULL"},
13808: {"Type":"Cash","SubType":"NULL"},
13809: {"Type":"Cash","SubType":"NULL"},
13810: {"Type":"Cash","SubType":"NULL"},
13811: {"Type":"Cash","SubType":"NULL"},
13812: {"Type":"Cash","SubType":"NULL"},
13813: {"Type":"Cash","SubType":"NULL"},
13814: {"Type":"Cash","SubType":"NULL"},
13815: {"Type":"Cash","SubType":"NULL"},
13816: {"Type":"Cash","SubType":"NULL"},
13817: {"Type":"Cash","SubType":"NULL"},
13818: {"Type":"Cash","SubType":"NULL"},
13819: {"Type":"Cash","SubType":"NULL"},
13820: {"Type":"Cash","SubType":"NULL"},
13821: {"Type":"Cash","SubType":"NULL"},
13822: {"Type":"Cash","SubType":"NULL"},
13823: {"Type":"Cash","SubType":"NULL"},
13824: {"Type":"Cash","SubType":"NULL"},
13825: {"Type":"Cash","SubType":"NULL"},
13826: {"Type":"Usable","SubType":"NULL"},
13827: {"Type":"Usable","SubType":"NULL"},
13828: {"Type":"Cash","SubType":"NULL"},
13829: {"Type":"Cash","SubType":"NULL"},
13830: {"Type":"Cash","SubType":"NULL"},
13831: {"Type":"Cash","SubType":"NULL"},
13832: {"Type":"Cash","SubType":"NULL"},
13833: {"Type":"Cash","SubType":"NULL"},
13834: {"Type":"Cash","SubType":"NULL"},
13835: {"Type":"Cash","SubType":"NULL"},
13836: {"Type":"Cash","SubType":"NULL"},
13837: {"Type":"Cash","SubType":"NULL"},
13838: {"Type":"Cash","SubType":"NULL"},
13839: {"Type":"Cash","SubType":"NULL"},
13840: {"Type":"Cash","SubType":"NULL"},
13841: {"Type":"Cash","SubType":"NULL"},
13842: {"Type":"Cash","SubType":"NULL"},
13843: {"Type":"Cash","SubType":"NULL"},
13844: {"Type":"Cash","SubType":"NULL"},
13845: {"Type":"Cash","SubType":"NULL"},
13846: {"Type":"Cash","SubType":"NULL"},
13847: {"Type":"Cash","SubType":"NULL"},
13848: {"Type":"Cash","SubType":"NULL"},
13849: {"Type":"Cash","SubType":"NULL"},
13850: {"Type":"Cash","SubType":"NULL"},
13851: {"Type":"Cash","SubType":"NULL"},
13852: {"Type":"Cash","SubType":"NULL"},
13853: {"Type":"Cash","SubType":"NULL"},
13854: {"Type":"Cash","SubType":"NULL"},
13855: {"Type":"Cash","SubType":"NULL"},
13856: {"Type":"Cash","SubType":"NULL"},
13857: {"Type":"Cash","SubType":"NULL"},
13858: {"Type":"Cash","SubType":"NULL"},
13859: {"Type":"Cash","SubType":"NULL"},
13860: {"Type":"Cash","SubType":"NULL"},
13861: {"Type":"Cash","SubType":"NULL"},
13862: {"Type":"Cash","SubType":"NULL"},
13863: {"Type":"Cash","SubType":"NULL"},
13864: {"Type":"Cash","SubType":"NULL"},
13865: {"Type":"Cash","SubType":"NULL"},
13866: {"Type":"Cash","SubType":"NULL"},
13867: {"Type":"Cash","SubType":"NULL"},
13868: {"Type":"Cash","SubType":"NULL"},
13869: {"Type":"Cash","SubType":"NULL"},
13870: {"Type":"Cash","SubType":"NULL"},
13871: {"Type":"Cash","SubType":"NULL"},
13872: {"Type":"Cash","SubType":"NULL"},
13873: {"Type":"Cash","SubType":"NULL"},
13874: {"Type":"Cash","SubType":"NULL"},
13875: {"Type":"Cash","SubType":"NULL"},
13876: {"Type":"Cash","SubType":"NULL"},
13877: {"Type":"Cash","SubType":"NULL"},
13878: {"Type":"Cash","SubType":"NULL"},
13879: {"Type":"Cash","SubType":"NULL"},
13880: {"Type":"Cash","SubType":"NULL"},
13881: {"Type":"Cash","SubType":"NULL"},
13882: {"Type":"Cash","SubType":"NULL"},
13883: {"Type":"Cash","SubType":"NULL"},
13884: {"Type":"Cash","SubType":"NULL"},
13885: {"Type":"Cash","SubType":"NULL"},
13886: {"Type":"Cash","SubType":"NULL"},
13887: {"Type":"Cash","SubType":"NULL"},
13888: {"Type":"Cash","SubType":"NULL"},
13889: {"Type":"Cash","SubType":"NULL"},
13890: {"Type":"Cash","SubType":"NULL"},
13891: {"Type":"Cash","SubType":"NULL"},
13892: {"Type":"Cash","SubType":"NULL"},
13893: {"Type":"Cash","SubType":"NULL"},
13894: {"Type":"Cash","SubType":"NULL"},
13895: {"Type":"Cash","SubType":"NULL"},
13896: {"Type":"Cash","SubType":"NULL"},
13897: {"Type":"Cash","SubType":"NULL"},
13898: {"Type":"Cash","SubType":"NULL"},
13899: {"Type":"Cash","SubType":"NULL"},
13900: {"Type":"Cash","SubType":"NULL"},
13901: {"Type":"Cash","SubType":"NULL"},
13902: {"Type":"Cash","SubType":"NULL"},
13903: {"Type":"Cash","SubType":"NULL"},
13904: {"Type":"Cash","SubType":"NULL"},
13905: {"Type":"Cash","SubType":"NULL"},
13906: {"Type":"Cash","SubType":"NULL"},
13907: {"Type":"Cash","SubType":"NULL"},
13908: {"Type":"Cash","SubType":"NULL"},
13909: {"Type":"Cash","SubType":"NULL"},
13910: {"Type":"Cash","SubType":"NULL"},
13911: {"Type":"Usable","SubType":"NULL"},
13912: {"Type":"Cash","SubType":"NULL"},
13913: {"Type":"Cash","SubType":"NULL"},
13914: {"Type":"Cash","SubType":"NULL"},
13915: {"Type":"Cash","SubType":"NULL"},
13916: {"Type":"Cash","SubType":"NULL"},
13917: {"Type":"Cash","SubType":"NULL"},
13918: {"Type":"Cash","SubType":"NULL"},
13919: {"Type":"Cash","SubType":"NULL"},
13920: {"Type":"Cash","SubType":"NULL"},
13921: {"Type":"Cash","SubType":"NULL"},
13922: {"Type":"Cash","SubType":"NULL"},
13923: {"Type":"Cash","SubType":"NULL"},
13924: {"Type":"Cash","SubType":"NULL"},
13925: {"Type":"Cash","SubType":"NULL"},
13926: {"Type":"Cash","SubType":"NULL"},
13927: {"Type":"Cash","SubType":"NULL"},
13928: {"Type":"Cash","SubType":"NULL"},
13929: {"Type":"Cash","SubType":"NULL"},
13930: {"Type":"Cash","SubType":"NULL"},
13931: {"Type":"Cash","SubType":"NULL"},
13932: {"Type":"Cash","SubType":"NULL"},
13933: {"Type":"Cash","SubType":"NULL"},
13934: {"Type":"Cash","SubType":"NULL"},
13935: {"Type":"Cash","SubType":"NULL"},
13936: {"Type":"Cash","SubType":"NULL"},
13937: {"Type":"Cash","SubType":"NULL"},
13938: {"Type":"Cash","SubType":"NULL"},
13939: {"Type":"Cash","SubType":"NULL"},
13940: {"Type":"Cash","SubType":"NULL"},
13941: {"Type":"Cash","SubType":"NULL"},
13942: {"Type":"Cash","SubType":"NULL"},
13943: {"Type":"Cash","SubType":"NULL"},
13944: {"Type":"Cash","SubType":"NULL"},
13945: {"Type":"Cash","SubType":"NULL"},
13946: {"Type":"Cash","SubType":"NULL"},
13947: {"Type":"Cash","SubType":"NULL"},
13948: {"Type":"Cash","SubType":"NULL"},
13949: {"Type":"Cash","SubType":"NULL"},
13950: {"Type":"Cash","SubType":"NULL"},
13951: {"Type":"Cash","SubType":"NULL"},
13952: {"Type":"Cash","SubType":"NULL"},
13953: {"Type":"Cash","SubType":"NULL"},
13954: {"Type":"Cash","SubType":"NULL"},
13955: {"Type":"Cash","SubType":"NULL"},
13956: {"Type":"Cash","SubType":"NULL"},
13957: {"Type":"Cash","SubType":"NULL"},
13958: {"Type":"Cash","SubType":"NULL"},
13959: {"Type":"Cash","SubType":"NULL"},
13960: {"Type":"Cash","SubType":"NULL"},
13961: {"Type":"Cash","SubType":"NULL"},
13962: {"Type":"Cash","SubType":"NULL"},
13963: {"Type":"Cash","SubType":"NULL"},
13964: {"Type":"Cash","SubType":"NULL"},
13965: {"Type":"Cash","SubType":"NULL"},
13966: {"Type":"Cash","SubType":"NULL"},
13967: {"Type":"Cash","SubType":"NULL"},
13968: {"Type":"Cash","SubType":"NULL"},
13969: {"Type":"Cash","SubType":"NULL"},
13970: {"Type":"Cash","SubType":"NULL"},
13971: {"Type":"Cash","SubType":"NULL"},
13972: {"Type":"Cash","SubType":"NULL"},
13973: {"Type":"Cash","SubType":"NULL"},
13974: {"Type":"Cash","SubType":"NULL"},
13975: {"Type":"Cash","SubType":"NULL"},
13976: {"Type":"Cash","SubType":"NULL"},
13977: {"Type":"Cash","SubType":"NULL"},
13978: {"Type":"Cash","SubType":"NULL"},
13979: {"Type":"Cash","SubType":"NULL"},
13980: {"Type":"Cash","SubType":"NULL"},
13981: {"Type":"Cash","SubType":"NULL"},
13982: {"Type":"Cash","SubType":"NULL"},
13983: {"Type":"Cash","SubType":"NULL"},
13984: {"Type":"Cash","SubType":"NULL"},
13985: {"Type":"Cash","SubType":"NULL"},
13986: {"Type":"Cash","SubType":"NULL"},
13987: {"Type":"Cash","SubType":"NULL"},
13988: {"Type":"Cash","SubType":"NULL"},
13989: {"Type":"Cash","SubType":"NULL"},
13990: {"Type":"Cash","SubType":"NULL"},
13991: {"Type":"Cash","SubType":"NULL"},
13992: {"Type":"Cash","SubType":"NULL"},
13993: {"Type":"Cash","SubType":"NULL"},
13994: {"Type":"Cash","SubType":"NULL"},
13995: {"Type":"Cash","SubType":"NULL"},
13996: {"Type":"Cash","SubType":"NULL"},
13997: {"Type":"Cash","SubType":"NULL"},
13998: {"Type":"Cash","SubType":"NULL"},
13999: {"Type":"Cash","SubType":"NULL"},
14000: {"Type":"Cash","SubType":"NULL"},
14001: {"Type":"Cash","SubType":"NULL"},
14002: {"Type":"Cash","SubType":"NULL"},
14003: {"Type":"Cash","SubType":"NULL"},
14004: {"Type":"Cash","SubType":"NULL"},
14005: {"Type":"Cash","SubType":"NULL"},
14006: {"Type":"Cash","SubType":"NULL"},
14007: {"Type":"Cash","SubType":"NULL"},
14008: {"Type":"Cash","SubType":"NULL"},
14009: {"Type":"Cash","SubType":"NULL"},
14010: {"Type":"Cash","SubType":"NULL"},
14011: {"Type":"Cash","SubType":"NULL"},
14012: {"Type":"Cash","SubType":"NULL"},
14013: {"Type":"Cash","SubType":"NULL"},
14014: {"Type":"Cash","SubType":"NULL"},
14015: {"Type":"Cash","SubType":"NULL"},
14016: {"Type":"Cash","SubType":"NULL"},
14017: {"Type":"Cash","SubType":"NULL"},
14018: {"Type":"Cash","SubType":"NULL"},
14019: {"Type":"Cash","SubType":"NULL"},
14020: {"Type":"Cash","SubType":"NULL"},
14021: {"Type":"Cash","SubType":"NULL"},
14022: {"Type":"Cash","SubType":"NULL"},
14023: {"Type":"Cash","SubType":"NULL"},
14024: {"Type":"Cash","SubType":"NULL"},
14025: {"Type":"Cash","SubType":"NULL"},
14026: {"Type":"Cash","SubType":"NULL"},
14027: {"Type":"Cash","SubType":"NULL"},
14028: {"Type":"Cash","SubType":"NULL"},
14029: {"Type":"Cash","SubType":"NULL"},
14030: {"Type":"Cash","SubType":"NULL"},
14031: {"Type":"Cash","SubType":"NULL"},
14032: {"Type":"Cash","SubType":"NULL"},
14033: {"Type":"Cash","SubType":"NULL"},
14034: {"Type":"Cash","SubType":"NULL"},
14035: {"Type":"Cash","SubType":"NULL"},
14036: {"Type":"Cash","SubType":"NULL"},
14037: {"Type":"Cash","SubType":"NULL"},
14038: {"Type":"Cash","SubType":"NULL"},
14039: {"Type":"Cash","SubType":"NULL"},
14040: {"Type":"Cash","SubType":"NULL"},
14041: {"Type":"Cash","SubType":"NULL"},
14042: {"Type":"Cash","SubType":"NULL"},
14043: {"Type":"Cash","SubType":"NULL"},
14044: {"Type":"Cash","SubType":"NULL"},
14045: {"Type":"Cash","SubType":"NULL"},
14046: {"Type":"Cash","SubType":"NULL"},
14047: {"Type":"Cash","SubType":"NULL"},
14048: {"Type":"Cash","SubType":"NULL"},
14049: {"Type":"Cash","SubType":"NULL"},
14050: {"Type":"Cash","SubType":"NULL"},
14051: {"Type":"Cash","SubType":"NULL"},
14052: {"Type":"Cash","SubType":"NULL"},
14053: {"Type":"Cash","SubType":"NULL"},
14054: {"Type":"Cash","SubType":"NULL"},
14055: {"Type":"Cash","SubType":"NULL"},
14056: {"Type":"Cash","SubType":"NULL"},
14057: {"Type":"Cash","SubType":"NULL"},
14058: {"Type":"Cash","SubType":"NULL"},
14059: {"Type":"Cash","SubType":"NULL"},
14060: {"Type":"Cash","SubType":"NULL"},
14061: {"Type":"Cash","SubType":"NULL"},
14062: {"Type":"Cash","SubType":"NULL"},
14063: {"Type":"Cash","SubType":"NULL"},
14064: {"Type":"Cash","SubType":"NULL"},
14065: {"Type":"Cash","SubType":"NULL"},
14066: {"Type":"Cash","SubType":"NULL"},
14067: {"Type":"Cash","SubType":"NULL"},
14068: {"Type":"Cash","SubType":"NULL"},
14069: {"Type":"Cash","SubType":"NULL"},
14070: {"Type":"Cash","SubType":"NULL"},
14071: {"Type":"Cash","SubType":"NULL"},
14072: {"Type":"Cash","SubType":"NULL"},
14073: {"Type":"Cash","SubType":"NULL"},
14074: {"Type":"Cash","SubType":"NULL"},
14075: {"Type":"Cash","SubType":"NULL"},
14076: {"Type":"Cash","SubType":"NULL"},
14077: {"Type":"Cash","SubType":"NULL"},
14078: {"Type":"Cash","SubType":"NULL"},
14079: {"Type":"Cash","SubType":"NULL"},
14080: {"Type":"Cash","SubType":"NULL"},
14081: {"Type":"Cash","SubType":"NULL"},
14082: {"Type":"Cash","SubType":"NULL"},
14083: {"Type":"Cash","SubType":"NULL"},
14084: {"Type":"Cash","SubType":"NULL"},
14085: {"Type":"Cash","SubType":"NULL"},
14086: {"Type":"Cash","SubType":"NULL"},
14087: {"Type":"Cash","SubType":"NULL"},
14088: {"Type":"Cash","SubType":"NULL"},
14089: {"Type":"Cash","SubType":"NULL"},
14090: {"Type":"Cash","SubType":"NULL"},
14091: {"Type":"Cash","SubType":"NULL"},
14092: {"Type":"Cash","SubType":"NULL"},
14093: {"Type":"Cash","SubType":"NULL"},
14094: {"Type":"Cash","SubType":"NULL"},
14095: {"Type":"Cash","SubType":"NULL"},
14096: {"Type":"Cash","SubType":"NULL"},
14097: {"Type":"Cash","SubType":"NULL"},
14098: {"Type":"Cash","SubType":"NULL"},
14099: {"Type":"Cash","SubType":"NULL"},
14100: {"Type":"Cash","SubType":"NULL"},
14101: {"Type":"Cash","SubType":"NULL"},
14102: {"Type":"Cash","SubType":"NULL"},
14103: {"Type":"Cash","SubType":"NULL"},
14104: {"Type":"Cash","SubType":"NULL"},
14105: {"Type":"Cash","SubType":"NULL"},
14106: {"Type":"Cash","SubType":"NULL"},
14107: {"Type":"Cash","SubType":"NULL"},
14108: {"Type":"Cash","SubType":"NULL"},
14109: {"Type":"Cash","SubType":"NULL"},
14110: {"Type":"Cash","SubType":"NULL"},
14111: {"Type":"Cash","SubType":"NULL"},
14112: {"Type":"Cash","SubType":"NULL"},
14113: {"Type":"Cash","SubType":"NULL"},
14114: {"Type":"Cash","SubType":"NULL"},
14115: {"Type":"Cash","SubType":"NULL"},
14116: {"Type":"Cash","SubType":"NULL"},
14117: {"Type":"Cash","SubType":"NULL"},
14118: {"Type":"Cash","SubType":"NULL"},
14119: {"Type":"Cash","SubType":"NULL"},
14120: {"Type":"Cash","SubType":"NULL"},
14121: {"Type":"Cash","SubType":"NULL"},
14122: {"Type":"Cash","SubType":"NULL"},
14123: {"Type":"Cash","SubType":"NULL"},
14124: {"Type":"Cash","SubType":"NULL"},
14125: {"Type":"Cash","SubType":"NULL"},
14126: {"Type":"Cash","SubType":"NULL"},
14127: {"Type":"Cash","SubType":"NULL"},
14128: {"Type":"Cash","SubType":"NULL"},
14129: {"Type":"Cash","SubType":"NULL"},
14130: {"Type":"Cash","SubType":"NULL"},
14131: {"Type":"Cash","SubType":"NULL"},
14132: {"Type":"Cash","SubType":"NULL"},
14133: {"Type":"Cash","SubType":"NULL"},
14134: {"Type":"Cash","SubType":"NULL"},
14135: {"Type":"Cash","SubType":"NULL"},
14136: {"Type":"Cash","SubType":"NULL"},
14137: {"Type":"Cash","SubType":"NULL"},
14138: {"Type":"Cash","SubType":"NULL"},
14139: {"Type":"Cash","SubType":"NULL"},
14140: {"Type":"Cash","SubType":"NULL"},
14141: {"Type":"Cash","SubType":"NULL"},
14142: {"Type":"Cash","SubType":"NULL"},
14143: {"Type":"Cash","SubType":"NULL"},
14144: {"Type":"Cash","SubType":"NULL"},
14145: {"Type":"Cash","SubType":"NULL"},
14146: {"Type":"Cash","SubType":"NULL"},
14147: {"Type":"Cash","SubType":"NULL"},
14148: {"Type":"Cash","SubType":"NULL"},
14149: {"Type":"Cash","SubType":"NULL"},
14150: {"Type":"Cash","SubType":"NULL"},
14151: {"Type":"Cash","SubType":"NULL"},
14152: {"Type":"Cash","SubType":"NULL"},
14153: {"Type":"Cash","SubType":"NULL"},
14154: {"Type":"Cash","SubType":"NULL"},
14155: {"Type":"Cash","SubType":"NULL"},
14156: {"Type":"Cash","SubType":"NULL"},
14157: {"Type":"Cash","SubType":"NULL"},
14158: {"Type":"Cash","SubType":"NULL"},
14159: {"Type":"Cash","SubType":"NULL"},
14160: {"Type":"Cash","SubType":"NULL"},
14161: {"Type":"Cash","SubType":"NULL"},
14162: {"Type":"Cash","SubType":"NULL"},
14163: {"Type":"Cash","SubType":"NULL"},
14164: {"Type":"Cash","SubType":"NULL"},
14165: {"Type":"Cash","SubType":"NULL"},
14166: {"Type":"Cash","SubType":"NULL"},
14167: {"Type":"Cash","SubType":"NULL"},
14168: {"Type":"Cash","SubType":"NULL"},
14169: {"Type":"Cash","SubType":"NULL"},
14170: {"Type":"Cash","SubType":"NULL"},
14171: {"Type":"Cash","SubType":"NULL"},
14172: {"Type":"Cash","SubType":"NULL"},
14173: {"Type":"Cash","SubType":"NULL"},
14174: {"Type":"Cash","SubType":"NULL"},
14175: {"Type":"Cash","SubType":"NULL"},
14176: {"Type":"Cash","SubType":"NULL"},
14177: {"Type":"Cash","SubType":"NULL"},
14178: {"Type":"Cash","SubType":"NULL"},
14179: {"Type":"Cash","SubType":"NULL"},
14180: {"Type":"Cash","SubType":"NULL"},
14181: {"Type":"Cash","SubType":"NULL"},
14182: {"Type":"Cash","SubType":"NULL"},
14183: {"Type":"Cash","SubType":"NULL"},
14184: {"Type":"Cash","SubType":"NULL"},
14185: {"Type":"Cash","SubType":"NULL"},
14186: {"Type":"Cash","SubType":"NULL"},
14187: {"Type":"Cash","SubType":"NULL"},
14188: {"Type":"Cash","SubType":"NULL"},
14189: {"Type":"Cash","SubType":"NULL"},
14190: {"Type":"Cash","SubType":"NULL"},
14191: {"Type":"Cash","SubType":"NULL"},
14192: {"Type":"Cash","SubType":"NULL"},
14193: {"Type":"Cash","SubType":"NULL"},
14194: {"Type":"Cash","SubType":"NULL"},
14195: {"Type":"Cash","SubType":"NULL"},
14196: {"Type":"Cash","SubType":"NULL"},
14197: {"Type":"Cash","SubType":"NULL"},
14198: {"Type":"Cash","SubType":"NULL"},
14199: {"Type":"Cash","SubType":"NULL"},
14200: {"Type":"Cash","SubType":"NULL"},
14201: {"Type":"Cash","SubType":"NULL"},
14202: {"Type":"Cash","SubType":"NULL"},
14203: {"Type":"Cash","SubType":"NULL"},
14204: {"Type":"Cash","SubType":"NULL"},
14205: {"Type":"Cash","SubType":"NULL"},
14206: {"Type":"Cash","SubType":"NULL"},
14207: {"Type":"Cash","SubType":"NULL"},
14208: {"Type":"Cash","SubType":"NULL"},
14209: {"Type":"Cash","SubType":"NULL"},
14210: {"Type":"Cash","SubType":"NULL"},
14211: {"Type":"Cash","SubType":"NULL"},
14212: {"Type":"Cash","SubType":"NULL"},
14213: {"Type":"Cash","SubType":"NULL"},
14214: {"Type":"Cash","SubType":"NULL"},
14215: {"Type":"Cash","SubType":"NULL"},
14216: {"Type":"Cash","SubType":"NULL"},
14217: {"Type":"Cash","SubType":"NULL"},
14218: {"Type":"Cash","SubType":"NULL"},
14219: {"Type":"Cash","SubType":"NULL"},
14220: {"Type":"Cash","SubType":"NULL"},
14221: {"Type":"Cash","SubType":"NULL"},
14222: {"Type":"Cash","SubType":"NULL"},
14223: {"Type":"Cash","SubType":"NULL"},
14224: {"Type":"Cash","SubType":"NULL"},
14225: {"Type":"Cash","SubType":"NULL"},
14226: {"Type":"Cash","SubType":"NULL"},
14227: {"Type":"Cash","SubType":"NULL"},
14228: {"Type":"Cash","SubType":"NULL"},
14229: {"Type":"Cash","SubType":"NULL"},
14230: {"Type":"Cash","SubType":"NULL"},
14231: {"Type":"Cash","SubType":"NULL"},
14232: {"Type":"Cash","SubType":"NULL"},
14233: {"Type":"Cash","SubType":"NULL"},
14234: {"Type":"Cash","SubType":"NULL"},
14235: {"Type":"Cash","SubType":"NULL"},
14236: {"Type":"Cash","SubType":"NULL"},
14237: {"Type":"Cash","SubType":"NULL"},
14238: {"Type":"Cash","SubType":"NULL"},
14239: {"Type":"Cash","SubType":"NULL"},
14240: {"Type":"Cash","SubType":"NULL"},
14241: {"Type":"Cash","SubType":"NULL"},
14242: {"Type":"Cash","SubType":"NULL"},
14243: {"Type":"Cash","SubType":"NULL"},
14244: {"Type":"Cash","SubType":"NULL"},
14245: {"Type":"Cash","SubType":"NULL"},
14246: {"Type":"Cash","SubType":"NULL"},
14247: {"Type":"Cash","SubType":"NULL"},
14248: {"Type":"Cash","SubType":"NULL"},
14249: {"Type":"Cash","SubType":"NULL"},
14250: {"Type":"Cash","SubType":"NULL"},
14251: {"Type":"Cash","SubType":"NULL"},
14252: {"Type":"Cash","SubType":"NULL"},
14253: {"Type":"Cash","SubType":"NULL"},
14254: {"Type":"Cash","SubType":"NULL"},
14255: {"Type":"Cash","SubType":"NULL"},
14256: {"Type":"Cash","SubType":"NULL"},
14257: {"Type":"Cash","SubType":"NULL"},
14258: {"Type":"Cash","SubType":"NULL"},
14259: {"Type":"Cash","SubType":"NULL"},
14260: {"Type":"Cash","SubType":"NULL"},
14261: {"Type":"Cash","SubType":"NULL"},
14262: {"Type":"Cash","SubType":"NULL"},
14263: {"Type":"Cash","SubType":"NULL"},
14264: {"Type":"Cash","SubType":"NULL"},
14265: {"Type":"Cash","SubType":"NULL"},
14266: {"Type":"Cash","SubType":"NULL"},
14267: {"Type":"Cash","SubType":"NULL"},
14268: {"Type":"Cash","SubType":"NULL"},
14269: {"Type":"Cash","SubType":"NULL"},
14270: {"Type":"Cash","SubType":"NULL"},
14271: {"Type":"Cash","SubType":"NULL"},
14272: {"Type":"Cash","SubType":"NULL"},
14273: {"Type":"Cash","SubType":"NULL"},
14274: {"Type":"Cash","SubType":"NULL"},
14275: {"Type":"Cash","SubType":"NULL"},
14276: {"Type":"Cash","SubType":"NULL"},
14277: {"Type":"Cash","SubType":"NULL"},
14278: {"Type":"Cash","SubType":"NULL"},
14279: {"Type":"Cash","SubType":"NULL"},
14280: {"Type":"Cash","SubType":"NULL"},
14281: {"Type":"Cash","SubType":"NULL"},
14282: {"Type":"Cash","SubType":"NULL"},
14283: {"Type":"Cash","SubType":"NULL"},
14284: {"Type":"Cash","SubType":"NULL"},
14285: {"Type":"Cash","SubType":"NULL"},
14286: {"Type":"Cash","SubType":"NULL"},
14287: {"Type":"Cash","SubType":"NULL"},
14288: {"Type":"Cash","SubType":"NULL"},
14289: {"Type":"Cash","SubType":"NULL"},
14290: {"Type":"Cash","SubType":"NULL"},
14291: {"Type":"Usable","SubType":"NULL"},
14292: {"Type":"Usable","SubType":"NULL"},
14293: {"Type":"Usable","SubType":"NULL"},
14294: {"Type":"Usable","SubType":"NULL"},
14295: {"Type":"Usable","SubType":"NULL"},
14296: {"Type":"Usable","SubType":"NULL"},
14297: {"Type":"Usable","SubType":"NULL"},
14298: {"Type":"Usable","SubType":"NULL"},
14299: {"Type":"Cash","SubType":"NULL"},
14300: {"Type":"Cash","SubType":"NULL"},
14301: {"Type":"Cash","SubType":"NULL"},
14302: {"Type":"Cash","SubType":"NULL"},
14303: {"Type":"Cash","SubType":"NULL"},
14304: {"Type":"Cash","SubType":"NULL"},
14305: {"Type":"Cash","SubType":"NULL"},
14306: {"Type":"Usable","SubType":"NULL"},
14307: {"Type":"Usable","SubType":"NULL"},
14308: {"Type":"Cash","SubType":"NULL"},
14309: {"Type":"Cash","SubType":"NULL"},
14310: {"Type":"Cash","SubType":"NULL"},
14311: {"Type":"Cash","SubType":"NULL"},
14312: {"Type":"Cash","SubType":"NULL"},
14313: {"Type":"Cash","SubType":"NULL"},
14314: {"Type":"Cash","SubType":"NULL"},
14315: {"Type":"Cash","SubType":"NULL"},
14316: {"Type":"Usable","SubType":"NULL"},
14317: {"Type":"Usable","SubType":"NULL"},
14318: {"Type":"Cash","SubType":"NULL"},
14319: {"Type":"Cash","SubType":"NULL"},
14320: {"Type":"Cash","SubType":"NULL"},
14321: {"Type":"Cash","SubType":"NULL"},
14322: {"Type":"Cash","SubType":"NULL"},
14323: {"Type":"Cash","SubType":"NULL"},
14324: {"Type":"Cash","SubType":"NULL"},
14325: {"Type":"Cash","SubType":"NULL"},
14326: {"Type":"Cash","SubType":"NULL"},
14327: {"Type":"Cash","SubType":"NULL"},
14328: {"Type":"Cash","SubType":"NULL"},
14329: {"Type":"Cash","SubType":"NULL"},
14330: {"Type":"Cash","SubType":"NULL"},
14331: {"Type":"Cash","SubType":"NULL"},
14332: {"Type":"Cash","SubType":"NULL"},
14333: {"Type":"Cash","SubType":"NULL"},
14334: {"Type":"Cash","SubType":"NULL"},
14335: {"Type":"Cash","SubType":"NULL"},
14336: {"Type":"Cash","SubType":"NULL"},
14337: {"Type":"Cash","SubType":"NULL"},
14338: {"Type":"Cash","SubType":"NULL"},
14339: {"Type":"Cash","SubType":"NULL"},
14340: {"Type":"Cash","SubType":"NULL"},
14341: {"Type":"Cash","SubType":"NULL"},
14342: {"Type":"Cash","SubType":"NULL"},
14343: {"Type":"Cash","SubType":"NULL"},
14344: {"Type":"Cash","SubType":"NULL"},
14345: {"Type":"Usable","SubType":"NULL"},
14346: {"Type":"Cash","SubType":"NULL"},
14347: {"Type":"Cash","SubType":"NULL"},
14348: {"Type":"Cash","SubType":"NULL"},
14349: {"Type":"Cash","SubType":"NULL"},
14350: {"Type":"Cash","SubType":"NULL"},
14351: {"Type":"Cash","SubType":"NULL"},
14352: {"Type":"Cash","SubType":"NULL"},
14353: {"Type":"Cash","SubType":"NULL"},
14354: {"Type":"Cash","SubType":"NULL"},
14355: {"Type":"Cash","SubType":"NULL"},
14356: {"Type":"Cash","SubType":"NULL"},
14357: {"Type":"Cash","SubType":"NULL"},
14358: {"Type":"Cash","SubType":"NULL"},
14359: {"Type":"Cash","SubType":"NULL"},
14360: {"Type":"Cash","SubType":"NULL"},
14361: {"Type":"Cash","SubType":"NULL"},
14362: {"Type":"Cash","SubType":"NULL"},
14363: {"Type":"Usable","SubType":"NULL"},
14364: {"Type":"Cash","SubType":"NULL"},
14365: {"Type":"Cash","SubType":"NULL"},
14366: {"Type":"Cash","SubType":"NULL"},
14367: {"Type":"Cash","SubType":"NULL"},
14368: {"Type":"Cash","SubType":"NULL"},
14369: {"Type":"Cash","SubType":"NULL"},
14370: {"Type":"Cash","SubType":"NULL"},
14371: {"Type":"Cash","SubType":"NULL"},
14372: {"Type":"Cash","SubType":"NULL"},
14373: {"Type":"Cash","SubType":"NULL"},
14374: {"Type":"Cash","SubType":"NULL"},
14375: {"Type":"Cash","SubType":"NULL"},
14376: {"Type":"Cash","SubType":"NULL"},
14377: {"Type":"Cash","SubType":"NULL"},
14378: {"Type":"Cash","SubType":"NULL"},
14379: {"Type":"Cash","SubType":"NULL"},
14380: {"Type":"Cash","SubType":"NULL"},
14381: {"Type":"Cash","SubType":"NULL"},
14382: {"Type":"Cash","SubType":"NULL"},
14383: {"Type":"Cash","SubType":"NULL"},
14384: {"Type":"Cash","SubType":"NULL"},
14385: {"Type":"Cash","SubType":"NULL"},
14386: {"Type":"Cash","SubType":"NULL"},
14387: {"Type":"Cash","SubType":"NULL"},
14388: {"Type":"Cash","SubType":"NULL"},
14389: {"Type":"Cash","SubType":"NULL"},
14390: {"Type":"Cash","SubType":"NULL"},
14391: {"Type":"Cash","SubType":"NULL"},
14392: {"Type":"Cash","SubType":"NULL"},
14393: {"Type":"Cash","SubType":"NULL"},
14394: {"Type":"Cash","SubType":"NULL"},
14395: {"Type":"Cash","SubType":"NULL"},
14396: {"Type":"Cash","SubType":"NULL"},
14397: {"Type":"Cash","SubType":"NULL"},
14398: {"Type":"Cash","SubType":"NULL"},
14399: {"Type":"Cash","SubType":"NULL"},
14400: {"Type":"Cash","SubType":"NULL"},
14401: {"Type":"Cash","SubType":"NULL"},
14402: {"Type":"Cash","SubType":"NULL"},
14403: {"Type":"Cash","SubType":"NULL"},
14404: {"Type":"Cash","SubType":"NULL"},
14405: {"Type":"Cash","SubType":"NULL"},
14406: {"Type":"Cash","SubType":"NULL"},
14407: {"Type":"Cash","SubType":"NULL"},
14408: {"Type":"Usable","SubType":"NULL"},
14409: {"Type":"Cash","SubType":"NULL"},
14410: {"Type":"Cash","SubType":"NULL"},
14411: {"Type":"Cash","SubType":"NULL"},
14412: {"Type":"Cash","SubType":"NULL"},
14413: {"Type":"Cash","SubType":"NULL"},
14414: {"Type":"Cash","SubType":"NULL"},
14415: {"Type":"Cash","SubType":"NULL"},
14416: {"Type":"Cash","SubType":"NULL"},
14417: {"Type":"Cash","SubType":"NULL"},
14418: {"Type":"Cash","SubType":"NULL"},
14419: {"Type":"Cash","SubType":"NULL"},
14420: {"Type":"Cash","SubType":"NULL"},
14421: {"Type":"Cash","SubType":"NULL"},
14422: {"Type":"Cash","SubType":"NULL"},
14423: {"Type":"Cash","SubType":"NULL"},
14424: {"Type":"Cash","SubType":"NULL"},
14426: {"Type":"Cash","SubType":"NULL"},
14427: {"Type":"Cash","SubType":"NULL"},
14428: {"Type":"Cash","SubType":"NULL"},
14429: {"Type":"Cash","SubType":"NULL"},
14430: {"Type":"Cash","SubType":"NULL"},
14431: {"Type":"Cash","SubType":"NULL"},
14432: {"Type":"Cash","SubType":"NULL"},
14433: {"Type":"Cash","SubType":"NULL"},
14434: {"Type":"Cash","SubType":"NULL"},
14435: {"Type":"Cash","SubType":"NULL"},
14436: {"Type":"Cash","SubType":"NULL"},
14437: {"Type":"Cash","SubType":"NULL"},
14438: {"Type":"Cash","SubType":"NULL"},
14439: {"Type":"Cash","SubType":"NULL"},
14440: {"Type":"Cash","SubType":"NULL"},
14441: {"Type":"Cash","SubType":"NULL"},
14442: {"Type":"Cash","SubType":"NULL"},
14443: {"Type":"Cash","SubType":"NULL"},
14444: {"Type":"Cash","SubType":"NULL"},
14447: {"Type":"Cash","SubType":"NULL"},
14448: {"Type":"Cash","SubType":"NULL"},
14449: {"Type":"Cash","SubType":"NULL"},
14450: {"Type":"Cash","SubType":"NULL"},
14451: {"Type":"Cash","SubType":"NULL"},
14452: {"Type":"Cash","SubType":"NULL"},
14453: {"Type":"Cash","SubType":"NULL"},
14454: {"Type":"Cash","SubType":"NULL"},
14455: {"Type":"Cash","SubType":"NULL"},
14456: {"Type":"Cash","SubType":"NULL"},
14457: {"Type":"Cash","SubType":"NULL"},
14458: {"Type":"Cash","SubType":"NULL"},
14459: {"Type":"Cash","SubType":"NULL"},
14460: {"Type":"Cash","SubType":"NULL"},
14461: {"Type":"Cash","SubType":"NULL"},
14462: {"Type":"Cash","SubType":"NULL"},
14463: {"Type":"Cash","SubType":"NULL"},
14464: {"Type":"Cash","SubType":"NULL"},
14465: {"Type":"Cash","SubType":"NULL"},
14466: {"Type":"Usable","SubType":"NULL"},
14467: {"Type":"Cash","SubType":"NULL"},
14468: {"Type":"Cash","SubType":"NULL"},
14469: {"Type":"Usable","SubType":"NULL"},
14470: {"Type":"Cash","SubType":"NULL"},
14471: {"Type":"Cash","SubType":"NULL"},
14472: {"Type":"Cash","SubType":"NULL"},
14473: {"Type":"Cash","SubType":"NULL"},
14474: {"Type":"Cash","SubType":"NULL"},
14475: {"Type":"Cash","SubType":"NULL"},
14476: {"Type":"Cash","SubType":"NULL"},
14477: {"Type":"Cash","SubType":"NULL"},
14478: {"Type":"Cash","SubType":"NULL"},
14479: {"Type":"Cash","SubType":"NULL"},
14480: {"Type":"Cash","SubType":"NULL"},
14481: {"Type":"Cash","SubType":"NULL"},
14482: {"Type":"Cash","SubType":"NULL"},
14483: {"Type":"Cash","SubType":"NULL"},
14484: {"Type":"Cash","SubType":"NULL"},
14485: {"Type":"Cash","SubType":"NULL"},
14486: {"Type":"Cash","SubType":"NULL"},
14487: {"Type":"Cash","SubType":"NULL"},
14488: {"Type":"Cash","SubType":"NULL"},
14489: {"Type":"Cash","SubType":"NULL"},
14490: {"Type":"Cash","SubType":"NULL"},
14491: {"Type":"Cash","SubType":"NULL"},
14492: {"Type":"Cash","SubType":"NULL"},
14493: {"Type":"Cash","SubType":"NULL"},
14494: {"Type":"Cash","SubType":"NULL"},
14495: {"Type":"Cash","SubType":"NULL"},
14496: {"Type":"Cash","SubType":"NULL"},
14497: {"Type":"Cash","SubType":"NULL"},
14498: {"Type":"Cash","SubType":"NULL"},
14499: {"Type":"Cash","SubType":"NULL"},
14500: {"Type":"Usable","SubType":"NULL"},
14505: {"Type":"Usable","SubType":"NULL"},
14506: {"Type":"Usable","SubType":"NULL"},
14508: {"Type":"Usable","SubType":"NULL"},
14509: {"Type":"Usable","SubType":"NULL"},
14510: {"Type":"Usable","SubType":"NULL"},
14511: {"Type":"Usable","SubType":"NULL"},
14512: {"Type":"DelayConsume","SubType":"NULL"},
14513: {"Type":"DelayConsume","SubType":"NULL"},
14514: {"Type":"DelayConsume","SubType":"NULL"},
14515: {"Type":"DelayConsume","SubType":"NULL"},
14516: {"Type":"DelayConsume","SubType":"NULL"},
14517: {"Type":"Usable","SubType":"NULL"},
14518: {"Type":"Usable","SubType":"NULL"},
14519: {"Type":"Usable","SubType":"NULL"},
14520: {"Type":"Usable","SubType":"NULL"},
14521: {"Type":"Usable","SubType":"NULL"},
14522: {"Type":"Healing","SubType":"NULL"},
14523: {"Type":"Healing","SubType":"NULL"},
14524: {"Type":"Healing","SubType":"NULL"},
14525: {"Type":"Usable","SubType":"NULL"},
14526: {"Type":"Usable","SubType":"NULL"},
14527: {"Type":"Usable","SubType":"NULL"},
14528: {"Type":"Usable","SubType":"NULL"},
14529: {"Type":"DelayConsume","SubType":"NULL"},
14530: {"Type":"Usable","SubType":"NULL"},
14531: {"Type":"Usable","SubType":"NULL"},
14532: {"Type":"Usable","SubType":"NULL"},
14533: {"Type":"Usable","SubType":"NULL"},
14534: {"Type":"Usable","SubType":"NULL"},
14535: {"Type":"Usable","SubType":"NULL"},
14536: {"Type":"Usable","SubType":"NULL"},
14537: {"Type":"Usable","SubType":"NULL"},
14538: {"Type":"Usable","SubType":"NULL"},
14539: {"Type":"Usable","SubType":"NULL"},
14540: {"Type":"Usable","SubType":"NULL"},
14541: {"Type":"Usable","SubType":"NULL"},
14542: {"Type":"Usable","SubType":"NULL"},
14543: {"Type":"Usable","SubType":"NULL"},
14544: {"Type":"Usable","SubType":"NULL"},
14545: {"Type":"Usable","SubType":"NULL"},
14546: {"Type":"Usable","SubType":"NULL"},
14547: {"Type":"Usable","SubType":"NULL"},
14548: {"Type":"Usable","SubType":"NULL"},
14549: {"Type":"Usable","SubType":"NULL"},
14550: {"Type":"Usable","SubType":"NULL"},
14551: {"Type":"Healing","SubType":"NULL"},
14552: {"Type":"Healing","SubType":"NULL"},
14553: {"Type":"Healing","SubType":"NULL"},
14554: {"Type":"Healing","SubType":"NULL"},
14555: {"Type":"Healing","SubType":"NULL"},
14556: {"Type":"Healing","SubType":"NULL"},
14557: {"Type":"Healing","SubType":"NULL"},
14558: {"Type":"Healing","SubType":"NULL"},
14559: {"Type":"Healing","SubType":"NULL"},
14560: {"Type":"Healing","SubType":"NULL"},
14561: {"Type":"Healing","SubType":"NULL"},
14562: {"Type":"Healing","SubType":"NULL"},
14563: {"Type":"Healing","SubType":"NULL"},
14564: {"Type":"Healing","SubType":"NULL"},
14565: {"Type":"Healing","SubType":"NULL"},
14566: {"Type":"Healing","SubType":"NULL"},
14567: {"Type":"Healing","SubType":"NULL"},
14568: {"Type":"Healing","SubType":"NULL"},
14569: {"Type":"Usable","SubType":"NULL"},
14570: {"Type":"Usable","SubType":"NULL"},
14571: {"Type":"Usable","SubType":"NULL"},
14572: {"Type":"Usable","SubType":"NULL"},
14573: {"Type":"Usable","SubType":"NULL"},
14574: {"Type":"Usable","SubType":"NULL"},
14575: {"Type":"Healing","SubType":"NULL"},
14576: {"Type":"Healing","SubType":"NULL"},
14577: {"Type":"Healing","SubType":"NULL"},
14578: {"Type":"Healing","SubType":"NULL"},
14579: {"Type":"Healing","SubType":"NULL"},
14580: {"Type":"Healing","SubType":"NULL"},
14581: {"Type":"Usable","SubType":"NULL"},
14582: {"Type":"Usable","SubType":"NULL"},
14583: {"Type":"Usable","SubType":"NULL"},
14584: {"Type":"Usable","SubType":"NULL"},
14585: {"Type":"Usable","SubType":"NULL"},
14586: {"Type":"Usable","SubType":"NULL"},
14587: {"Type":"DelayConsume","SubType":"NULL"},
14588: {"Type":"DelayConsume","SubType":"NULL"},
14589: {"Type":"DelayConsume","SubType":"NULL"},
14590: {"Type":"DelayConsume","SubType":"NULL"},
14591: {"Type":"Usable","SubType":"NULL"},
14592: {"Type":"Usable","SubType":"NULL"},
14593: {"Type":"DelayConsume","SubType":"NULL"},
14594: {"Type":"DelayConsume","SubType":"NULL"},
14595: {"Type":"Usable","SubType":"NULL"},
14596: {"Type":"Usable","SubType":"NULL"},
14597: {"Type":"Usable","SubType":"NULL"},
14598: {"Type":"Usable","SubType":"NULL"},
14599: {"Type":"DelayConsume","SubType":"NULL"},
14600: {"Type":"Usable","SubType":"NULL"},
14601: {"Type":"Usable","SubType":"NULL"},
14602: {"Type":"Usable","SubType":"NULL"},
14603: {"Type":"Usable","SubType":"NULL"},
14604: {"Type":"Usable","SubType":"NULL"},
14605: {"Type":"Usable","SubType":"NULL"},
14606: {"Type":"Usable","SubType":"NULL"},
14607: {"Type":"Usable","SubType":"NULL"},
14608: {"Type":"Usable","SubType":"NULL"},
14609: {"Type":"Usable","SubType":"NULL"},
14611: {"Type":"DelayConsume","SubType":"NULL"},
14612: {"Type":"DelayConsume","SubType":"NULL"},
14613: {"Type":"Usable","SubType":"NULL"},
14614: {"Type":"Usable","SubType":"NULL"},
14616: {"Type":"Usable","SubType":"NULL"},
14617: {"Type":"Usable","SubType":"NULL"},
14618: {"Type":"Usable","SubType":"NULL"},
14619: {"Type":"Usable","SubType":"NULL"},
14620: {"Type":"Usable","SubType":"NULL"},
14621: {"Type":"Usable","SubType":"NULL"},
14623: {"Type":"Cash","SubType":"NULL"},
14624: {"Type":"Usable","SubType":"NULL"},
14626: {"Type":"Usable","SubType":"NULL"},
14627: {"Type":"Cash","SubType":"NULL"},
14628: {"Type":"Cash","SubType":"NULL"},
14629: {"Type":"Usable","SubType":"NULL"},
14643: {"Type":"Cash","SubType":"NULL"},
14645: {"Type":"DelayConsume","SubType":"NULL"},
14646: {"Type":"Usable","SubType":"NULL"},
14663: {"Type":"Cash","SubType":"NULL"},
14664: {"Type":"Cash","SubType":"NULL"},
14665: {"Type":"Cash","SubType":"NULL"},
14666: {"Type":"Cash","SubType":"NULL"},
14667: {"Type":"Cash","SubType":"NULL"},
14672: {"Type":"Cash","SubType":"NULL"},
14673: {"Type":"Cash","SubType":"NULL"},
14674: {"Type":"Usable","SubType":"NULL"},
14675: {"Type":"Cash","SubType":"NULL"},
14679: {"Type":"Cash","SubType":"NULL"},
14681: {"Type":"Usable","SubType":"NULL"},
14682: {"Type":"Cash","SubType":"NULL"},
14689: {"Type":"Cash","SubType":"NULL"},
14695: {"Type":"Usable","SubType":"NULL"},
14696: {"Type":"Cash","SubType":"NULL"},
14699: {"Type":"Cash","SubType":"NULL"},
14701: {"Type":"Cash","SubType":"NULL"},
14704: {"Type":"Cash","SubType":"NULL"},
14705: {"Type":"Cash","SubType":"NULL"},
14713: {"Type":"Cash","SubType":"NULL"},
14717: {"Type":"Usable","SubType":"NULL"},
14718: {"Type":"Cash","SubType":"NULL"},
14723: {"Type":"DelayConsume","SubType":"NULL"},
14724: {"Type":"DelayConsume","SubType":"NULL"},
14725: {"Type":"Cash","SubType":"NULL"},
14726: {"Type":"Cash","SubType":"NULL"},
14727: {"Type":"Cash","SubType":"NULL"},
14728: {"Type":"Cash","SubType":"NULL"},
14729: {"Type":"Cash","SubType":"NULL"},
14730: {"Type":"Cash","SubType":"NULL"},
14731: {"Type":"Cash","SubType":"NULL"},
14732: {"Type":"Cash","SubType":"NULL"},
14733: {"Type":"Cash","SubType":"NULL"},
14735: {"Type":"Cash","SubType":"NULL"},
14739: {"Type":"Cash","SubType":"NULL"},
14740: {"Type":"Cash","SubType":"NULL"},
14741: {"Type":"Cash","SubType":"NULL"},
14753: {"Type":"Cash","SubType":"NULL"},
14758: {"Type":"Cash","SubType":"NULL"},
14765: {"Type":"Cash","SubType":"NULL"},
14766: {"Type":"Usable","SubType":"NULL"},
14780: {"Type":"Cash","SubType":"NULL"},
14781: {"Type":"Cash","SubType":"NULL"},
14799: {"Type":"Cash","SubType":"NULL"},
14805: {"Type":"Cash","SubType":"NULL"},
14826: {"Type":"Healing","SubType":"NULL"},
14840: {"Type":"Usable","SubType":"NULL"},
14841: {"Type":"Healing","SubType":"NULL"},
14843: {"Type":"Usable","SubType":"NULL"},
14844: {"Type":"Usable","SubType":"NULL"},
14845: {"Type":"DelayConsume","SubType":"NULL"},
14846: {"Type":"DelayConsume","SubType":"NULL"},
14847: {"Type":"Usable","SubType":"NULL"},
14849: {"Type":"Usable","SubType":"NULL"},
14850: {"Type":"Usable","SubType":"NULL"},
14851: {"Type":"Usable","SubType":"NULL"},
14852: {"Type":"Usable","SubType":"NULL"},
14853: {"Type":"Usable","SubType":"NULL"},
14854: {"Type":"Usable","SubType":"NULL"},
14861: {"Type":"Usable","SubType":"NULL"},
14862: {"Type":"Usable","SubType":"NULL"},
14866: {"Type":"Usable","SubType":"NULL"},
14869: {"Type":"Usable","SubType":"NULL"},
14875: {"Type":"Usable","SubType":"NULL"},
14886: {"Type":"Usable","SubType":"NULL"},
14887: {"Type":"Usable","SubType":"NULL"},
14908: {"Type":"Healing","SubType":"NULL"},
15000: {"Type":"Armor","SubType":"NULL"},
15001: {"Type":"Armor","SubType":"NULL"},
15002: {"Type":"Armor","SubType":"NULL"},
15003: {"Type":"Armor","SubType":"NULL"},
15004: {"Type":"Armor","SubType":"NULL"},
15005: {"Type":"Armor","SubType":"NULL"},
15006: {"Type":"Armor","SubType":"NULL"},
15007: {"Type":"Armor","SubType":"NULL"},
15008: {"Type":"Armor","SubType":"NULL"},
15009: {"Type":"Armor","SubType":"NULL"},
15010: {"Type":"Armor","SubType":"NULL"},
15011: {"Type":"Armor","SubType":"NULL"},
15012: {"Type":"Armor","SubType":"NULL"},
15013: {"Type":"Armor","SubType":"NULL"},
15014: {"Type":"Armor","SubType":"NULL"},
15015: {"Type":"Armor","SubType":"NULL"},
15016: {"Type":"Armor","SubType":"NULL"},
15017: {"Type":"Armor","SubType":"NULL"},
15018: {"Type":"Armor","SubType":"NULL"},
15019: {"Type":"Armor","SubType":"NULL"},
15020: {"Type":"Armor","SubType":"NULL"},
15021: {"Type":"Armor","SubType":"NULL"},
15022: {"Type":"Armor","SubType":"NULL"},
15023: {"Type":"Armor","SubType":"NULL"},
15024: {"Type":"Armor","SubType":"NULL"},
15025: {"Type":"Armor","SubType":"NULL"},
15026: {"Type":"Armor","SubType":"NULL"},
15027: {"Type":"Armor","SubType":"NULL"},
15028: {"Type":"Armor","SubType":"NULL"},
15029: {"Type":"Armor","SubType":"NULL"},
15030: {"Type":"Armor","SubType":"NULL"},
15031: {"Type":"Armor","SubType":"NULL"},
15032: {"Type":"Armor","SubType":"NULL"},
15033: {"Type":"Armor","SubType":"NULL"},
15034: {"Type":"Armor","SubType":"NULL"},
15035: {"Type":"Armor","SubType":"NULL"},
15036: {"Type":"Armor","SubType":"NULL"},
15037: {"Type":"Armor","SubType":"NULL"},
15038: {"Type":"Armor","SubType":"NULL"},
15039: {"Type":"Armor","SubType":"NULL"},
15040: {"Type":"Armor","SubType":"NULL"},
15041: {"Type":"Armor","SubType":"NULL"},
15042: {"Type":"Armor","SubType":"NULL"},
15043: {"Type":"Armor","SubType":"NULL"},
15044: {"Type":"Armor","SubType":"NULL"},
15045: {"Type":"Armor","SubType":"NULL"},
15046: {"Type":"Armor","SubType":"NULL"},
15047: {"Type":"Armor","SubType":"NULL"},
15048: {"Type":"Armor","SubType":"NULL"},
15049: {"Type":"Armor","SubType":"NULL"},
15050: {"Type":"Armor","SubType":"NULL"},
15051: {"Type":"Armor","SubType":"NULL"},
15052: {"Type":"Armor","SubType":"NULL"},
15053: {"Type":"Armor","SubType":"NULL"},
15054: {"Type":"Armor","SubType":"NULL"},
15055: {"Type":"Armor","SubType":"NULL"},
15056: {"Type":"Armor","SubType":"NULL"},
15057: {"Type":"Armor","SubType":"NULL"},
15058: {"Type":"Armor","SubType":"NULL"},
15059: {"Type":"Armor","SubType":"NULL"},
15060: {"Type":"Armor","SubType":"NULL"},
15061: {"Type":"Armor","SubType":"NULL"},
15062: {"Type":"Armor","SubType":"NULL"},
15063: {"Type":"Armor","SubType":"NULL"},
15064: {"Type":"Armor","SubType":"NULL"},
15065: {"Type":"Armor","SubType":"NULL"},
15066: {"Type":"Armor","SubType":"NULL"},
15067: {"Type":"Armor","SubType":"NULL"},
15068: {"Type":"Armor","SubType":"NULL"},
15069: {"Type":"Armor","SubType":"NULL"},
15070: {"Type":"Armor","SubType":"NULL"},
15071: {"Type":"Armor","SubType":"NULL"},
15072: {"Type":"Armor","SubType":"NULL"},
15073: {"Type":"Armor","SubType":"NULL"},
15074: {"Type":"Armor","SubType":"NULL"},
15075: {"Type":"Armor","SubType":"NULL"},
15076: {"Type":"Armor","SubType":"NULL"},
15077: {"Type":"Armor","SubType":"NULL"},
15078: {"Type":"Armor","SubType":"NULL"},
15079: {"Type":"Armor","SubType":"NULL"},
15080: {"Type":"Armor","SubType":"NULL"},
15081: {"Type":"Armor","SubType":"NULL"},
15082: {"Type":"Armor","SubType":"NULL"},
15083: {"Type":"Armor","SubType":"NULL"},
15084: {"Type":"Armor","SubType":"NULL"},
15085: {"Type":"Armor","SubType":"NULL"},
15086: {"Type":"Armor","SubType":"NULL"},
15087: {"Type":"Armor","SubType":"NULL"},
15088: {"Type":"Armor","SubType":"NULL"},
15089: {"Type":"Armor","SubType":"NULL"},
15090: {"Type":"Armor","SubType":"NULL"},
15091: {"Type":"Armor","SubType":"NULL"},
15092: {"Type":"Armor","SubType":"NULL"},
15093: {"Type":"Armor","SubType":"NULL"},
15094: {"Type":"Armor","SubType":"NULL"},
15095: {"Type":"Armor","SubType":"NULL"},
15096: {"Type":"Armor","SubType":"NULL"},
15097: {"Type":"Armor","SubType":"NULL"},
15098: {"Type":"Armor","SubType":"NULL"},
15099: {"Type":"Armor","SubType":"NULL"},
15100: {"Type":"Armor","SubType":"NULL"},
15101: {"Type":"Armor","SubType":"NULL"},
15102: {"Type":"Armor","SubType":"NULL"},
15103: {"Type":"Armor","SubType":"NULL"},
15104: {"Type":"Armor","SubType":"NULL"},
15105: {"Type":"Armor","SubType":"NULL"},
15106: {"Type":"Armor","SubType":"NULL"},
15107: {"Type":"Armor","SubType":"NULL"},
15108: {"Type":"Armor","SubType":"NULL"},
15109: {"Type":"Armor","SubType":"NULL"},
15110: {"Type":"Armor","SubType":"NULL"},
15111: {"Type":"Armor","SubType":"NULL"},
15112: {"Type":"Armor","SubType":"NULL"},
15113: {"Type":"Armor","SubType":"NULL"},
15114: {"Type":"Armor","SubType":"NULL"},
15115: {"Type":"Armor","SubType":"NULL"},
15116: {"Type":"Armor","SubType":"NULL"},
15117: {"Type":"Armor","SubType":"NULL"},
15121: {"Type":"Armor","SubType":"NULL"},
15122: {"Type":"Armor","SubType":"NULL"},
15123: {"Type":"Armor","SubType":"NULL"},
15124: {"Type":"Armor","SubType":"NULL"},
15125: {"Type":"Armor","SubType":"NULL"},
15126: {"Type":"Armor","SubType":"NULL"},
15127: {"Type":"Armor","SubType":"NULL"},
15128: {"Type":"Armor","SubType":"NULL"},
15129: {"Type":"Armor","SubType":"NULL"},
15130: {"Type":"Armor","SubType":"NULL"},
15134: {"Type":"Armor","SubType":"NULL"},
15135: {"Type":"Armor","SubType":"NULL"},
15136: {"Type":"Armor","SubType":"NULL"},
15137: {"Type":"Armor","SubType":"NULL"},
15138: {"Type":"Armor","SubType":"NULL"},
15139: {"Type":"Armor","SubType":"NULL"},
15140: {"Type":"Armor","SubType":"NULL"},
15141: {"Type":"Armor","SubType":"NULL"},
15142: {"Type":"Armor","SubType":"NULL"},
15143: {"Type":"Armor","SubType":"NULL"},
15144: {"Type":"Armor","SubType":"NULL"},
15145: {"Type":"Armor","SubType":"NULL"},
15146: {"Type":"Armor","SubType":"NULL"},
15147: {"Type":"Armor","SubType":"NULL"},
15148: {"Type":"Armor","SubType":"NULL"},
15149: {"Type":"Armor","SubType":"NULL"},
15150: {"Type":"Armor","SubType":"NULL"},
15151: {"Type":"Armor","SubType":"NULL"},
15152: {"Type":"Armor","SubType":"NULL"},
15153: {"Type":"Armor","SubType":"NULL"},
15154: {"Type":"Armor","SubType":"NULL"},
15155: {"Type":"Armor","SubType":"NULL"},
15156: {"Type":"Armor","SubType":"NULL"},
15162: {"Type":"Armor","SubType":"NULL"},
15163: {"Type":"Armor","SubType":"NULL"},
15164: {"Type":"Armor","SubType":"NULL"},
15165: {"Type":"Armor","SubType":"NULL"},
15166: {"Type":"Armor","SubType":"NULL"},
15167: {"Type":"Armor","SubType":"NULL"},
15169: {"Type":"Armor","SubType":"NULL"},
15170: {"Type":"Armor","SubType":"NULL"},
15171: {"Type":"Armor","SubType":"NULL"},
15173: {"Type":"Armor","SubType":"NULL"},
15174: {"Type":"Armor","SubType":"NULL"},
15175: {"Type":"Armor","SubType":"NULL"},
15176: {"Type":"Armor","SubType":"NULL"},
15177: {"Type":"Armor","SubType":"NULL"},
15178: {"Type":"Armor","SubType":"NULL"},
15179: {"Type":"Armor","SubType":"NULL"},
15180: {"Type":"Armor","SubType":"NULL"},
15181: {"Type":"Armor","SubType":"NULL"},
15182: {"Type":"Armor","SubType":"NULL"},
15183: {"Type":"Armor","SubType":"NULL"},
15184: {"Type":"Armor","SubType":"NULL"},
15185: {"Type":"Armor","SubType":"NULL"},
15186: {"Type":"Armor","SubType":"NULL"},
15187: {"Type":"Armor","SubType":"NULL"},
15188: {"Type":"Armor","SubType":"NULL"},
15189: {"Type":"Armor","SubType":"NULL"},
15191: {"Type":"Armor","SubType":"NULL"},
15195: {"Type":"Armor","SubType":"NULL"},
15196: {"Type":"Armor","SubType":"NULL"},
15204: {"Type":"Armor","SubType":"NULL"},
15205: {"Type":"Armor","SubType":"NULL"},
15207: {"Type":"Armor","SubType":"NULL"},
15208: {"Type":"Armor","SubType":"NULL"},
15209: {"Type":"Armor","SubType":"NULL"},
15210: {"Type":"Armor","SubType":"NULL"},
15211: {"Type":"Armor","SubType":"NULL"},
15212: {"Type":"Armor","SubType":"NULL"},
15213: {"Type":"Armor","SubType":"NULL"},
15214: {"Type":"Armor","SubType":"NULL"},
15215: {"Type":"Armor","SubType":"NULL"},
15216: {"Type":"Armor","SubType":"NULL"},
15217: {"Type":"Armor","SubType":"NULL"},
15218: {"Type":"Armor","SubType":"NULL"},
15219: {"Type":"Armor","SubType":"NULL"},
15220: {"Type":"Armor","SubType":"NULL"},
15221: {"Type":"Armor","SubType":"NULL"},
15222: {"Type":"Armor","SubType":"NULL"},
15223: {"Type":"Armor","SubType":"NULL"},
15224: {"Type":"Armor","SubType":"NULL"},
15225: {"Type":"Armor","SubType":"NULL"},
15226: {"Type":"Armor","SubType":"NULL"},
15227: {"Type":"Armor","SubType":"NULL"},
15228: {"Type":"Armor","SubType":"NULL"},
15229: {"Type":"Armor","SubType":"NULL"},
15230: {"Type":"Armor","SubType":"NULL"},
15231: {"Type":"Armor","SubType":"NULL"},
15232: {"Type":"Armor","SubType":"NULL"},
15233: {"Type":"Armor","SubType":"NULL"},
15234: {"Type":"Armor","SubType":"NULL"},
15235: {"Type":"Armor","SubType":"NULL"},
15236: {"Type":"Armor","SubType":"NULL"},
15237: {"Type":"Armor","SubType":"NULL"},
15238: {"Type":"Armor","SubType":"NULL"},
15239: {"Type":"Armor","SubType":"NULL"},
15240: {"Type":"Armor","SubType":"NULL"},
15241: {"Type":"Armor","SubType":"NULL"},
15242: {"Type":"Armor","SubType":"NULL"},
15243: {"Type":"Armor","SubType":"NULL"},
15244: {"Type":"Armor","SubType":"NULL"},
15245: {"Type":"Armor","SubType":"NULL"},
15246: {"Type":"Armor","SubType":"NULL"},
15247: {"Type":"Armor","SubType":"NULL"},
15248: {"Type":"Armor","SubType":"NULL"},
15249: {"Type":"Armor","SubType":"NULL"},
15250: {"Type":"Armor","SubType":"NULL"},
15251: {"Type":"Armor","SubType":"NULL"},
15252: {"Type":"Armor","SubType":"NULL"},
15253: {"Type":"Armor","SubType":"NULL"},
15254: {"Type":"Armor","SubType":"NULL"},
15255: {"Type":"Armor","SubType":"NULL"},
15256: {"Type":"Armor","SubType":"NULL"},
15257: {"Type":"Armor","SubType":"NULL"},
15258: {"Type":"Armor","SubType":"NULL"},
15259: {"Type":"Armor","SubType":"NULL"},
15260: {"Type":"Armor","SubType":"NULL"},
15261: {"Type":"Armor","SubType":"NULL"},
15262: {"Type":"Armor","SubType":"NULL"},
15263: {"Type":"Armor","SubType":"NULL"},
15264: {"Type":"Armor","SubType":"NULL"},
15265: {"Type":"Armor","SubType":"NULL"},
15266: {"Type":"Armor","SubType":"NULL"},
15267: {"Type":"Armor","SubType":"NULL"},
15268: {"Type":"Armor","SubType":"NULL"},
15269: {"Type":"Armor","SubType":"NULL"},
15270: {"Type":"Armor","SubType":"NULL"},
15271: {"Type":"Armor","SubType":"NULL"},
15272: {"Type":"Armor","SubType":"NULL"},
15273: {"Type":"Armor","SubType":"NULL"},
15274: {"Type":"Armor","SubType":"NULL"},
15275: {"Type":"Armor","SubType":"NULL"},
15276: {"Type":"Armor","SubType":"NULL"},
15277: {"Type":"Armor","SubType":"NULL"},
15278: {"Type":"Armor","SubType":"NULL"},
15279: {"Type":"Armor","SubType":"NULL"},
15280: {"Type":"Shadowgear","SubType":"NULL"},
15281: {"Type":"Armor","SubType":"NULL"},
15282: {"Type":"Armor","SubType":"NULL"},
15283: {"Type":"Armor","SubType":"NULL"},
15343: {"Type":"Armor","SubType":"NULL"},
15344: {"Type":"Armor","SubType":"NULL"},
15345: {"Type":"Armor","SubType":"NULL"},
15346: {"Type":"Armor","SubType":"NULL"},
15347: {"Type":"Armor","SubType":"NULL"},
15348: {"Type":"Armor","SubType":"NULL"},
15349: {"Type":"Armor","SubType":"NULL"},
15352: {"Type":"Armor","SubType":"NULL"},
15353: {"Type":"Armor","SubType":"NULL"},
15354: {"Type":"Armor","SubType":"NULL"},
15362: {"Type":"Armor","SubType":"NULL"},
15363: {"Type":"Armor","SubType":"NULL"},
15365: {"Type":"Armor","SubType":"NULL"},
15367: {"Type":"Armor","SubType":"NULL"},
15369: {"Type":"Armor","SubType":"NULL"},
15372: {"Type":"Armor","SubType":"NULL"},
15374: {"Type":"Armor","SubType":"NULL"},
15375: {"Type":"Armor","SubType":"NULL"},
15376: {"Type":"Armor","SubType":"NULL"},
15377: {"Type":"Armor","SubType":"NULL"},
15378: {"Type":"Armor","SubType":"NULL"},
15379: {"Type":"Armor","SubType":"NULL"},
15380: {"Type":"Armor","SubType":"NULL"},
15383: {"Type":"Armor","SubType":"NULL"},
15384: {"Type":"Armor","SubType":"NULL"},
15385: {"Type":"Armor","SubType":"NULL"},
15386: {"Type":"Armor","SubType":"NULL"},
15387: {"Type":"Armor","SubType":"NULL"},
15388: {"Type":"Armor","SubType":"NULL"},
15389: {"Type":"Armor","SubType":"NULL"},
15390: {"Type":"Armor","SubType":"NULL"},
15391: {"Type":"Armor","SubType":"NULL"},
15392: {"Type":"Armor","SubType":"NULL"},
15393: {"Type":"Armor","SubType":"NULL"},
15394: {"Type":"Armor","SubType":"NULL"},
15395: {"Type":"Armor","SubType":"NULL"},
15396: {"Type":"Armor","SubType":"NULL"},
15397: {"Type":"Armor","SubType":"NULL"},
15398: {"Type":"Armor","SubType":"NULL"},
15399: {"Type":"Armor","SubType":"NULL"},
15400: {"Type":"Armor","SubType":"NULL"},
15401: {"Type":"Armor","SubType":"NULL"},
15402: {"Type":"Armor","SubType":"NULL"},
15405: {"Type":"Armor","SubType":"NULL"},
15407: {"Type":"Armor","SubType":"NULL"},
15408: {"Type":"Armor","SubType":"NULL"},
15409: {"Type":"Armor","SubType":"NULL"},
15410: {"Type":"Armor","SubType":"NULL"},
15412: {"Type":"Armor","SubType":"NULL"},
15417: {"Type":"Armor","SubType":"NULL"},
15418: {"Type":"Armor","SubType":"NULL"},
15419: {"Type":"Armor","SubType":"NULL"},
15420: {"Type":"Armor","SubType":"NULL"},
15421: {"Type":"Armor","SubType":"NULL"},
15424: {"Type":"Armor","SubType":"NULL"},
15425: {"Type":"Armor","SubType":"NULL"},
15426: {"Type":"Armor","SubType":"NULL"},
15430: {"Type":"Armor","SubType":"NULL"},
15431: {"Type":"Armor","SubType":"NULL"},
15432: {"Type":"Armor","SubType":"NULL"},
15433: {"Type":"Armor","SubType":"NULL"},
15434: {"Type":"Armor","SubType":"NULL"},
15440: {"Type":"Armor","SubType":"NULL"},
15441: {"Type":"Armor","SubType":"NULL"},
15442: {"Type":"Armor","SubType":"NULL"},
15443: {"Type":"Armor","SubType":"NULL"},
15444: {"Type":"Armor","SubType":"NULL"},
15446: {"Type":"Armor","SubType":"NULL"},
15447: {"Type":"Armor","SubType":"NULL"},
15448: {"Type":"Armor","SubType":"NULL"},
15449: {"Type":"Armor","SubType":"NULL"},
15450: {"Type":"Armor","SubType":"NULL"},
15451: {"Type":"Armor","SubType":"NULL"},
15460: {"Type":"Armor","SubType":"NULL"},
15461: {"Type":"Armor","SubType":"NULL"},
15462: {"Type":"Armor","SubType":"NULL"},
15463: {"Type":"Armor","SubType":"NULL"},
15464: {"Type":"Armor","SubType":"NULL"},
15465: {"Type":"Armor","SubType":"NULL"},
15466: {"Type":"Armor","SubType":"NULL"},
15467: {"Type":"Armor","SubType":"NULL"},
15468: {"Type":"Armor","SubType":"NULL"},
15469: {"Type":"Armor","SubType":"NULL"},
15470: {"Type":"Armor","SubType":"NULL"},
15471: {"Type":"Armor","SubType":"NULL"},
15472: {"Type":"Armor","SubType":"NULL"},
15473: {"Type":"Armor","SubType":"NULL"},
15474: {"Type":"Armor","SubType":"NULL"},
15475: {"Type":"Armor","SubType":"NULL"},
15476: {"Type":"Armor","SubType":"NULL"},
15477: {"Type":"Armor","SubType":"NULL"},
15478: {"Type":"Armor","SubType":"NULL"},
15479: {"Type":"Armor","SubType":"NULL"},
15480: {"Type":"Armor","SubType":"NULL"},
15481: {"Type":"Armor","SubType":"NULL"},
15482: {"Type":"Armor","SubType":"NULL"},
15483: {"Type":"Armor","SubType":"NULL"},
15484: {"Type":"Armor","SubType":"NULL"},
15822: {"Type":"Armor","SubType":"NULL"},
15823: {"Type":"Armor","SubType":"NULL"},
15824: {"Type":"Armor","SubType":"NULL"},
15825: {"Type":"Armor","SubType":"NULL"},
15826: {"Type":"Armor","SubType":"NULL"},
15827: {"Type":"Armor","SubType":"NULL"},
15828: {"Type":"Armor","SubType":"NULL"},
15829: {"Type":"Armor","SubType":"NULL"},
15830: {"Type":"Armor","SubType":"NULL"},
15831: {"Type":"Armor","SubType":"NULL"},
15832: {"Type":"Armor","SubType":"NULL"},
15833: {"Type":"Armor","SubType":"NULL"},
15834: {"Type":"Armor","SubType":"NULL"},
15835: {"Type":"Armor","SubType":"NULL"},
15836: {"Type":"Armor","SubType":"NULL"},
15838: {"Type":"Armor","SubType":"NULL"},
15839: {"Type":"Armor","SubType":"NULL"},
15840: {"Type":"Armor","SubType":"NULL"},
15841: {"Type":"Armor","SubType":"NULL"},
15842: {"Type":"Armor","SubType":"NULL"},
15843: {"Type":"Armor","SubType":"NULL"},
15844: {"Type":"Armor","SubType":"NULL"},
15845: {"Type":"Armor","SubType":"NULL"},
15846: {"Type":"Armor","SubType":"NULL"},
15847: {"Type":"Armor","SubType":"NULL"},
15848: {"Type":"Armor","SubType":"NULL"},
15849: {"Type":"Armor","SubType":"NULL"},
15850: {"Type":"Armor","SubType":"NULL"},
15851: {"Type":"Armor","SubType":"NULL"},
15853: {"Type":"Armor","SubType":"NULL"},
15855: {"Type":"Armor","SubType":"NULL"},
15856: {"Type":"Armor","SubType":"NULL"},
15857: {"Type":"Armor","SubType":"NULL"},
15858: {"Type":"Armor","SubType":"NULL"},
15875: {"Type":"Armor","SubType":"NULL"},
15876: {"Type":"Armor","SubType":"NULL"},
15877: {"Type":"Armor","SubType":"NULL"},
15878: {"Type":"Armor","SubType":"NULL"},
15879: {"Type":"Armor","SubType":"NULL"},
15880: {"Type":"Armor","SubType":"NULL"},
15881: {"Type":"Armor","SubType":"NULL"},
15882: {"Type":"Armor","SubType":"NULL"},
15883: {"Type":"Armor","SubType":"NULL"},
15884: {"Type":"Armor","SubType":"NULL"},
15885: {"Type":"Armor","SubType":"NULL"},
15887: {"Type":"Armor","SubType":"NULL"},
15888: {"Type":"Armor","SubType":"NULL"},
15889: {"Type":"Armor","SubType":"NULL"},
15890: {"Type":"Armor","SubType":"NULL"},
15891: {"Type":"Armor","SubType":"NULL"},
15892: {"Type":"Armor","SubType":"NULL"},
15893: {"Type":"Armor","SubType":"NULL"},
15894: {"Type":"Armor","SubType":"NULL"},
15897: {"Type":"Armor","SubType":"NULL"},
15898: {"Type":"Armor","SubType":"NULL"},
15899: {"Type":"Armor","SubType":"NULL"},
15904: {"Type":"Armor","SubType":"NULL"},
15905: {"Type":"Armor","SubType":"NULL"},
15906: {"Type":"Armor","SubType":"NULL"},
15920: {"Type":"Armor","SubType":"NULL"},
15921: {"Type":"Armor","SubType":"NULL"},
15922: {"Type":"Armor","SubType":"NULL"},
15923: {"Type":"Armor","SubType":"NULL"},
15924: {"Type":"Armor","SubType":"NULL"},
15925: {"Type":"Armor","SubType":"NULL"},
15926: {"Type":"Armor","SubType":"NULL"},
15927: {"Type":"Armor","SubType":"NULL"},
15928: {"Type":"Armor","SubType":"NULL"},
15932: {"Type":"Armor","SubType":"NULL"},
15945: {"Type":"Armor","SubType":"NULL"},
15947: {"Type":"Armor","SubType":"NULL"},
15948: {"Type":"Armor","SubType":"NULL"},
15949: {"Type":"Armor","SubType":"NULL"},
15950: {"Type":"Armor","SubType":"NULL"},
15951: {"Type":"Armor","SubType":"NULL"},
15952: {"Type":"Armor","SubType":"NULL"},
15953: {"Type":"Armor","SubType":"NULL"},
15954: {"Type":"Armor","SubType":"NULL"},
15955: {"Type":"Armor","SubType":"NULL"},
15956: {"Type":"Armor","SubType":"NULL"},
15957: {"Type":"Armor","SubType":"NULL"},
15958: {"Type":"Armor","SubType":"NULL"},
15959: {"Type":"Armor","SubType":"NULL"},
15960: {"Type":"Armor","SubType":"NULL"},
15961: {"Type":"Armor","SubType":"NULL"},
15962: {"Type":"Armor","SubType":"NULL"},
15963: {"Type":"Armor","SubType":"NULL"},
15964: {"Type":"Armor","SubType":"NULL"},
15965: {"Type":"Armor","SubType":"NULL"},
15966: {"Type":"Armor","SubType":"NULL"},
15967: {"Type":"Armor","SubType":"NULL"},
15968: {"Type":"Armor","SubType":"NULL"},
15969: {"Type":"Armor","SubType":"NULL"},
15970: {"Type":"Armor","SubType":"NULL"},
15976: {"Type":"Armor","SubType":"NULL"},
15977: {"Type":"Armor","SubType":"NULL"},
15978: {"Type":"Armor","SubType":"NULL"},
15980: {"Type":"Armor","SubType":"NULL"},
15981: {"Type":"Armor","SubType":"NULL"},
15982: {"Type":"Armor","SubType":"NULL"},
15983: {"Type":"Armor","SubType":"NULL"},
15984: {"Type":"Armor","SubType":"NULL"},
15985: {"Type":"Armor","SubType":"NULL"},
16000: {"Type":"Weapon","SubType":"Mace"},
16001: {"Type":"Weapon","SubType":"Mace"},
16002: {"Type":"Weapon","SubType":"Mace"},
16003: {"Type":"Weapon","SubType":"Mace"},
16004: {"Type":"Weapon","SubType":"Mace"},
16005: {"Type":"Weapon","SubType":"Mace"},
16006: {"Type":"Weapon","SubType":"Mace"},
16007: {"Type":"Weapon","SubType":"Mace"},
16008: {"Type":"Weapon","SubType":"Mace"},
16009: {"Type":"Weapon","SubType":"Mace"},
16010: {"Type":"Weapon","SubType":"Mace"},
16011: {"Type":"Weapon","SubType":"Mace"},
16012: {"Type":"Weapon","SubType":"Mace"},
16013: {"Type":"Weapon","SubType":"Mace"},
16014: {"Type":"Weapon","SubType":"Mace"},
16015: {"Type":"Weapon","SubType":"Mace"},
16016: {"Type":"Weapon","SubType":"Mace"},
16017: {"Type":"Weapon","SubType":"Mace"},
16018: {"Type":"Weapon","SubType":"Mace"},
16019: {"Type":"Weapon","SubType":"Mace"},
16020: {"Type":"Weapon","SubType":"Mace"},
16021: {"Type":"Weapon","SubType":"Mace"},
16022: {"Type":"Weapon","SubType":"Mace"},
16023: {"Type":"Weapon","SubType":"Mace"},
16024: {"Type":"Weapon","SubType":"Mace"},
16025: {"Type":"Weapon","SubType":"Mace"},
16026: {"Type":"Weapon","SubType":"Mace"},
16027: {"Type":"Weapon","SubType":"Mace"},
16028: {"Type":"Weapon","SubType":"Mace"},
16029: {"Type":"Weapon","SubType":"Mace"},
16030: {"Type":"Weapon","SubType":"Mace"},
16031: {"Type":"Weapon","SubType":"Mace"},
16032: {"Type":"Weapon","SubType":"Mace"},
16033: {"Type":"Weapon","SubType":"Mace"},
16034: {"Type":"Weapon","SubType":"Mace"},
16035: {"Type":"Weapon","SubType":"Mace"},
16036: {"Type":"Weapon","SubType":"Mace"},
16037: {"Type":"Weapon","SubType":"Mace"},
16038: {"Type":"Weapon","SubType":"Mace"},
16039: {"Type":"Weapon","SubType":"Mace"},
16040: {"Type":"Weapon","SubType":"Mace"},
16041: {"Type":"Weapon","SubType":"Mace"},
16043: {"Type":"Weapon","SubType":"Mace"},
16048: {"Type":"Weapon","SubType":"Mace"},
16049: {"Type":"Weapon","SubType":"Mace"},
16050: {"Type":"Weapon","SubType":"Mace"},
16051: {"Type":"Weapon","SubType":"Mace"},
16052: {"Type":"Weapon","SubType":"Mace"},
16053: {"Type":"Weapon","SubType":"Mace"},
16054: {"Type":"Weapon","SubType":"Mace"},
16055: {"Type":"Weapon","SubType":"Mace"},
16056: {"Type":"Weapon","SubType":"Mace"},
16057: {"Type":"Weapon","SubType":"Mace"},
16058: {"Type":"Weapon","SubType":"Mace"},
16059: {"Type":"Weapon","SubType":"Mace"},
16060: {"Type":"Weapon","SubType":"Mace"},
16061: {"Type":"Weapon","SubType":"Mace"},
16063: {"Type":"Weapon","SubType":"Mace"},
16064: {"Type":"Weapon","SubType":"Mace"},
16065: {"Type":"Weapon","SubType":"Mace"},
16075: {"Type":"Weapon","SubType":"Mace"},
16076: {"Type":"Weapon","SubType":"Mace"},
16083: {"Type":"Weapon","SubType":"Mace"},
16084: {"Type":"Weapon","SubType":"Mace"},
16085: {"Type":"Weapon","SubType":"Mace"},
16087: {"Type":"Weapon","SubType":"Mace"},
16088: {"Type":"Weapon","SubType":"Mace"},
16089: {"Type":"Weapon","SubType":"Mace"},
16092: {"Type":"Weapon","SubType":"Mace"},
16093: {"Type":"Weapon","SubType":"Mace"},
16094: {"Type":"Weapon","SubType":"Mace"},
16095: {"Type":"Weapon","SubType":"Mace"},
16096: {"Type":"Weapon","SubType":"Mace"},
16098: {"Type":"Weapon","SubType":"Mace"},
16099: {"Type":"Weapon","SubType":"Mace"},
16100: {"Type":"Cash","SubType":"NULL"},
16101: {"Type":"Cash","SubType":"NULL"},
16102: {"Type":"Cash","SubType":"NULL"},
16103: {"Type":"Cash","SubType":"NULL"},
16104: {"Type":"Cash","SubType":"NULL"},
16105: {"Type":"Cash","SubType":"NULL"},
16106: {"Type":"Cash","SubType":"NULL"},
16107: {"Type":"Cash","SubType":"NULL"},
16108: {"Type":"Cash","SubType":"NULL"},
16109: {"Type":"Cash","SubType":"NULL"},
16110: {"Type":"Cash","SubType":"NULL"},
16111: {"Type":"Cash","SubType":"NULL"},
16112: {"Type":"Cash","SubType":"NULL"},
16113: {"Type":"Cash","SubType":"NULL"},
16114: {"Type":"Cash","SubType":"NULL"},
16115: {"Type":"Cash","SubType":"NULL"},
16116: {"Type":"Cash","SubType":"NULL"},
16117: {"Type":"Cash","SubType":"NULL"},
16118: {"Type":"Cash","SubType":"NULL"},
16119: {"Type":"Cash","SubType":"NULL"},
16120: {"Type":"Cash","SubType":"NULL"},
16121: {"Type":"Cash","SubType":"NULL"},
16122: {"Type":"Cash","SubType":"NULL"},
16123: {"Type":"Cash","SubType":"NULL"},
16124: {"Type":"Cash","SubType":"NULL"},
16125: {"Type":"Cash","SubType":"NULL"},
16126: {"Type":"Cash","SubType":"NULL"},
16127: {"Type":"Cash","SubType":"NULL"},
16128: {"Type":"Cash","SubType":"NULL"},
16129: {"Type":"Cash","SubType":"NULL"},
16130: {"Type":"Cash","SubType":"NULL"},
16131: {"Type":"Cash","SubType":"NULL"},
16132: {"Type":"Cash","SubType":"NULL"},
16133: {"Type":"Cash","SubType":"NULL"},
16134: {"Type":"Cash","SubType":"NULL"},
16135: {"Type":"Cash","SubType":"NULL"},
16136: {"Type":"Cash","SubType":"NULL"},
16137: {"Type":"Cash","SubType":"NULL"},
16138: {"Type":"Cash","SubType":"NULL"},
16139: {"Type":"Cash","SubType":"NULL"},
16140: {"Type":"Cash","SubType":"NULL"},
16141: {"Type":"Cash","SubType":"NULL"},
16142: {"Type":"Cash","SubType":"NULL"},
16143: {"Type":"Cash","SubType":"NULL"},
16144: {"Type":"Cash","SubType":"NULL"},
16145: {"Type":"Cash","SubType":"NULL"},
16146: {"Type":"Cash","SubType":"NULL"},
16147: {"Type":"Cash","SubType":"NULL"},
16148: {"Type":"Cash","SubType":"NULL"},
16149: {"Type":"Cash","SubType":"NULL"},
16150: {"Type":"Cash","SubType":"NULL"},
16151: {"Type":"Cash","SubType":"NULL"},
16152: {"Type":"Cash","SubType":"NULL"},
16153: {"Type":"Cash","SubType":"NULL"},
16154: {"Type":"Cash","SubType":"NULL"},
16155: {"Type":"Cash","SubType":"NULL"},
16156: {"Type":"Cash","SubType":"NULL"},
16157: {"Type":"Cash","SubType":"NULL"},
16158: {"Type":"Cash","SubType":"NULL"},
16159: {"Type":"Cash","SubType":"NULL"},
16160: {"Type":"Cash","SubType":"NULL"},
16161: {"Type":"Cash","SubType":"NULL"},
16162: {"Type":"Cash","SubType":"NULL"},
16163: {"Type":"Cash","SubType":"NULL"},
16164: {"Type":"Cash","SubType":"NULL"},
16165: {"Type":"Cash","SubType":"NULL"},
16166: {"Type":"Cash","SubType":"NULL"},
16167: {"Type":"Cash","SubType":"NULL"},
16168: {"Type":"Cash","SubType":"NULL"},
16169: {"Type":"Cash","SubType":"NULL"},
16170: {"Type":"Cash","SubType":"NULL"},
16171: {"Type":"Cash","SubType":"NULL"},
16172: {"Type":"Cash","SubType":"NULL"},
16173: {"Type":"Cash","SubType":"NULL"},
16174: {"Type":"Cash","SubType":"NULL"},
16175: {"Type":"Cash","SubType":"NULL"},
16176: {"Type":"Cash","SubType":"NULL"},
16177: {"Type":"Cash","SubType":"NULL"},
16178: {"Type":"Cash","SubType":"NULL"},
16179: {"Type":"Cash","SubType":"NULL"},
16180: {"Type":"Cash","SubType":"NULL"},
16181: {"Type":"Cash","SubType":"NULL"},
16182: {"Type":"Cash","SubType":"NULL"},
16183: {"Type":"Cash","SubType":"NULL"},
16184: {"Type":"Cash","SubType":"NULL"},
16185: {"Type":"Cash","SubType":"NULL"},
16186: {"Type":"Cash","SubType":"NULL"},
16187: {"Type":"Cash","SubType":"NULL"},
16188: {"Type":"Cash","SubType":"NULL"},
16189: {"Type":"Cash","SubType":"NULL"},
16190: {"Type":"Cash","SubType":"NULL"},
16191: {"Type":"Cash","SubType":"NULL"},
16192: {"Type":"Cash","SubType":"NULL"},
16193: {"Type":"Cash","SubType":"NULL"},
16194: {"Type":"Cash","SubType":"NULL"},
16195: {"Type":"Cash","SubType":"NULL"},
16196: {"Type":"Cash","SubType":"NULL"},
16197: {"Type":"Cash","SubType":"NULL"},
16198: {"Type":"Cash","SubType":"NULL"},
16199: {"Type":"Cash","SubType":"NULL"},
16200: {"Type":"Cash","SubType":"NULL"},
16201: {"Type":"Cash","SubType":"NULL"},
16202: {"Type":"Cash","SubType":"NULL"},
16203: {"Type":"Cash","SubType":"NULL"},
16204: {"Type":"Cash","SubType":"NULL"},
16205: {"Type":"Cash","SubType":"NULL"},
16206: {"Type":"Cash","SubType":"NULL"},
16207: {"Type":"Cash","SubType":"NULL"},
16208: {"Type":"Cash","SubType":"NULL"},
16209: {"Type":"Cash","SubType":"NULL"},
16210: {"Type":"Cash","SubType":"NULL"},
16211: {"Type":"Cash","SubType":"NULL"},
16212: {"Type":"Cash","SubType":"NULL"},
16213: {"Type":"Cash","SubType":"NULL"},
16214: {"Type":"Cash","SubType":"NULL"},
16215: {"Type":"Cash","SubType":"NULL"},
16216: {"Type":"Cash","SubType":"NULL"},
16217: {"Type":"Cash","SubType":"NULL"},
16218: {"Type":"Cash","SubType":"NULL"},
16219: {"Type":"Cash","SubType":"NULL"},
16220: {"Type":"Cash","SubType":"NULL"},
16221: {"Type":"Cash","SubType":"NULL"},
16222: {"Type":"Cash","SubType":"NULL"},
16223: {"Type":"Cash","SubType":"NULL"},
16224: {"Type":"Cash","SubType":"NULL"},
16225: {"Type":"Cash","SubType":"NULL"},
16226: {"Type":"Cash","SubType":"NULL"},
16227: {"Type":"Cash","SubType":"NULL"},
16228: {"Type":"Cash","SubType":"NULL"},
16229: {"Type":"Cash","SubType":"NULL"},
16230: {"Type":"Cash","SubType":"NULL"},
16231: {"Type":"Cash","SubType":"NULL"},
16232: {"Type":"Cash","SubType":"NULL"},
16233: {"Type":"Cash","SubType":"NULL"},
16234: {"Type":"Cash","SubType":"NULL"},
16235: {"Type":"Cash","SubType":"NULL"},
16236: {"Type":"Cash","SubType":"NULL"},
16237: {"Type":"Cash","SubType":"NULL"},
16238: {"Type":"Cash","SubType":"NULL"},
16239: {"Type":"Cash","SubType":"NULL"},
16240: {"Type":"Cash","SubType":"NULL"},
16241: {"Type":"Cash","SubType":"NULL"},
16242: {"Type":"Cash","SubType":"NULL"},
16243: {"Type":"Cash","SubType":"NULL"},
16244: {"Type":"Cash","SubType":"NULL"},
16245: {"Type":"Usable","SubType":"NULL"},
16246: {"Type":"Cash","SubType":"NULL"},
16247: {"Type":"Cash","SubType":"NULL"},
16248: {"Type":"Cash","SubType":"NULL"},
16249: {"Type":"Usable","SubType":"NULL"},
16250: {"Type":"Cash","SubType":"NULL"},
16251: {"Type":"Cash","SubType":"NULL"},
16252: {"Type":"Cash","SubType":"NULL"},
16253: {"Type":"Usable","SubType":"NULL"},
16254: {"Type":"Cash","SubType":"NULL"},
16255: {"Type":"Cash","SubType":"NULL"},
16256: {"Type":"Cash","SubType":"NULL"},
16257: {"Type":"Usable","SubType":"NULL"},
16258: {"Type":"Usable","SubType":"NULL"},
16259: {"Type":"Usable","SubType":"NULL"},
16260: {"Type":"Usable","SubType":"NULL"},
16261: {"Type":"Usable","SubType":"NULL"},
16262: {"Type":"Usable","SubType":"NULL"},
16263: {"Type":"Usable","SubType":"NULL"},
16264: {"Type":"Usable","SubType":"NULL"},
16265: {"Type":"Usable","SubType":"NULL"},
16266: {"Type":"Cash","SubType":"NULL"},
16267: {"Type":"Usable","SubType":"NULL"},
16268: {"Type":"Usable","SubType":"NULL"},
16269: {"Type":"Cash","SubType":"NULL"},
16270: {"Type":"Cash","SubType":"NULL"},
16271: {"Type":"Cash","SubType":"NULL"},
16272: {"Type":"Cash","SubType":"NULL"},
16273: {"Type":"Cash","SubType":"NULL"},
16274: {"Type":"Cash","SubType":"NULL"},
16275: {"Type":"Cash","SubType":"NULL"},
16276: {"Type":"Cash","SubType":"NULL"},
16277: {"Type":"Cash","SubType":"NULL"},
16278: {"Type":"Cash","SubType":"NULL"},
16279: {"Type":"Cash","SubType":"NULL"},
16280: {"Type":"Cash","SubType":"NULL"},
16281: {"Type":"Cash","SubType":"NULL"},
16282: {"Type":"Cash","SubType":"NULL"},
16283: {"Type":"Cash","SubType":"NULL"},
16284: {"Type":"Cash","SubType":"NULL"},
16285: {"Type":"Cash","SubType":"NULL"},
16286: {"Type":"Cash","SubType":"NULL"},
16287: {"Type":"Cash","SubType":"NULL"},
16288: {"Type":"Cash","SubType":"NULL"},
16289: {"Type":"Cash","SubType":"NULL"},
16290: {"Type":"Cash","SubType":"NULL"},
16291: {"Type":"Cash","SubType":"NULL"},
16292: {"Type":"Cash","SubType":"NULL"},
16293: {"Type":"Cash","SubType":"NULL"},
16294: {"Type":"Cash","SubType":"NULL"},
16295: {"Type":"Cash","SubType":"NULL"},
16296: {"Type":"Cash","SubType":"NULL"},
16297: {"Type":"Cash","SubType":"NULL"},
16298: {"Type":"Cash","SubType":"NULL"},
16299: {"Type":"Cash","SubType":"NULL"},
16300: {"Type":"Cash","SubType":"NULL"},
16301: {"Type":"Cash","SubType":"NULL"},
16302: {"Type":"Cash","SubType":"NULL"},
16303: {"Type":"Cash","SubType":"NULL"},
16304: {"Type":"Usable","SubType":"NULL"},
16305: {"Type":"Cash","SubType":"NULL"},
16306: {"Type":"Cash","SubType":"NULL"},
16307: {"Type":"Cash","SubType":"NULL"},
16308: {"Type":"Cash","SubType":"NULL"},
16309: {"Type":"Cash","SubType":"NULL"},
16310: {"Type":"Cash","SubType":"NULL"},
16311: {"Type":"Cash","SubType":"NULL"},
16312: {"Type":"Cash","SubType":"NULL"},
16313: {"Type":"Cash","SubType":"NULL"},
16314: {"Type":"Cash","SubType":"NULL"},
16315: {"Type":"Cash","SubType":"NULL"},
16316: {"Type":"Cash","SubType":"NULL"},
16317: {"Type":"Cash","SubType":"NULL"},
16318: {"Type":"Cash","SubType":"NULL"},
16319: {"Type":"Cash","SubType":"NULL"},
16320: {"Type":"Cash","SubType":"NULL"},
16321: {"Type":"Cash","SubType":"NULL"},
16322: {"Type":"Cash","SubType":"NULL"},
16323: {"Type":"Cash","SubType":"NULL"},
16324: {"Type":"Cash","SubType":"NULL"},
16325: {"Type":"Cash","SubType":"NULL"},
16326: {"Type":"Cash","SubType":"NULL"},
16327: {"Type":"Cash","SubType":"NULL"},
16328: {"Type":"Cash","SubType":"NULL"},
16329: {"Type":"Cash","SubType":"NULL"},
16330: {"Type":"Cash","SubType":"NULL"},
16331: {"Type":"Cash","SubType":"NULL"},
16332: {"Type":"Cash","SubType":"NULL"},
16333: {"Type":"Cash","SubType":"NULL"},
16334: {"Type":"Cash","SubType":"NULL"},
16335: {"Type":"Cash","SubType":"NULL"},
16336: {"Type":"Cash","SubType":"NULL"},
16337: {"Type":"Cash","SubType":"NULL"},
16338: {"Type":"Cash","SubType":"NULL"},
16339: {"Type":"Cash","SubType":"NULL"},
16340: {"Type":"Cash","SubType":"NULL"},
16341: {"Type":"Cash","SubType":"NULL"},
16342: {"Type":"Cash","SubType":"NULL"},
16343: {"Type":"Cash","SubType":"NULL"},
16344: {"Type":"Cash","SubType":"NULL"},
16345: {"Type":"Cash","SubType":"NULL"},
16346: {"Type":"Cash","SubType":"NULL"},
16347: {"Type":"Cash","SubType":"NULL"},
16348: {"Type":"Cash","SubType":"NULL"},
16349: {"Type":"Cash","SubType":"NULL"},
16350: {"Type":"Cash","SubType":"NULL"},
16351: {"Type":"Cash","SubType":"NULL"},
16352: {"Type":"Cash","SubType":"NULL"},
16353: {"Type":"Cash","SubType":"NULL"},
16354: {"Type":"Cash","SubType":"NULL"},
16355: {"Type":"Cash","SubType":"NULL"},
16356: {"Type":"Cash","SubType":"NULL"},
16357: {"Type":"Cash","SubType":"NULL"},
16358: {"Type":"Cash","SubType":"NULL"},
16359: {"Type":"Cash","SubType":"NULL"},
16360: {"Type":"Cash","SubType":"NULL"},
16361: {"Type":"Cash","SubType":"NULL"},
16362: {"Type":"Cash","SubType":"NULL"},
16363: {"Type":"Cash","SubType":"NULL"},
16364: {"Type":"Cash","SubType":"NULL"},
16365: {"Type":"Cash","SubType":"NULL"},
16366: {"Type":"Cash","SubType":"NULL"},
16367: {"Type":"Cash","SubType":"NULL"},
16368: {"Type":"Cash","SubType":"NULL"},
16369: {"Type":"Cash","SubType":"NULL"},
16370: {"Type":"Cash","SubType":"NULL"},
16371: {"Type":"Usable","SubType":"NULL"},
16372: {"Type":"Usable","SubType":"NULL"},
16373: {"Type":"Cash","SubType":"NULL"},
16374: {"Type":"Usable","SubType":"NULL"},
16375: {"Type":"Cash","SubType":"NULL"},
16376: {"Type":"Cash","SubType":"NULL"},
16377: {"Type":"Cash","SubType":"NULL"},
16378: {"Type":"Cash","SubType":"NULL"},
16379: {"Type":"Cash","SubType":"NULL"},
16380: {"Type":"Cash","SubType":"NULL"},
16381: {"Type":"Usable","SubType":"NULL"},
16382: {"Type":"Usable","SubType":"NULL"},
16383: {"Type":"Cash","SubType":"NULL"},
16384: {"Type":"Cash","SubType":"NULL"},
16385: {"Type":"Usable","SubType":"NULL"},
16386: {"Type":"Usable","SubType":"NULL"},
16387: {"Type":"Cash","SubType":"NULL"},
16388: {"Type":"Cash","SubType":"NULL"},
16389: {"Type":"Usable","SubType":"NULL"},
16390: {"Type":"Usable","SubType":"NULL"},
16391: {"Type":"Cash","SubType":"NULL"},
16392: {"Type":"Cash","SubType":"NULL"},
16393: {"Type":"Usable","SubType":"NULL"},
16394: {"Type":"Usable","SubType":"NULL"},
16395: {"Type":"Usable","SubType":"NULL"},
16396: {"Type":"Usable","SubType":"NULL"},
16397: {"Type":"Cash","SubType":"NULL"},
16398: {"Type":"Cash","SubType":"NULL"},
16399: {"Type":"Cash","SubType":"NULL"},
16400: {"Type":"Cash","SubType":"NULL"},
16401: {"Type":"Cash","SubType":"NULL"},
16402: {"Type":"Cash","SubType":"NULL"},
16403: {"Type":"Cash","SubType":"NULL"},
16405: {"Type":"Cash","SubType":"NULL"},
16406: {"Type":"Cash","SubType":"NULL"},
16407: {"Type":"Cash","SubType":"NULL"},
16408: {"Type":"Cash","SubType":"NULL"},
16409: {"Type":"Usable","SubType":"NULL"},
16410: {"Type":"Cash","SubType":"NULL"},
16411: {"Type":"Cash","SubType":"NULL"},
16412: {"Type":"Cash","SubType":"NULL"},
16413: {"Type":"Cash","SubType":"NULL"},
16414: {"Type":"Cash","SubType":"NULL"},
16415: {"Type":"Cash","SubType":"NULL"},
16418: {"Type":"Usable","SubType":"NULL"},
16419: {"Type":"Usable","SubType":"NULL"},
16420: {"Type":"Usable","SubType":"NULL"},
16421: {"Type":"Usable","SubType":"NULL"},
16422: {"Type":"Usable","SubType":"NULL"},
16423: {"Type":"Usable","SubType":"NULL"},
16424: {"Type":"Usable","SubType":"NULL"},
16425: {"Type":"Usable","SubType":"NULL"},
16426: {"Type":"Usable","SubType":"NULL"},
16427: {"Type":"Usable","SubType":"NULL"},
16428: {"Type":"Usable","SubType":"NULL"},
16429: {"Type":"Usable","SubType":"NULL"},
16430: {"Type":"Usable","SubType":"NULL"},
16431: {"Type":"Usable","SubType":"NULL"},
16432: {"Type":"Cash","SubType":"NULL"},
16433: {"Type":"Cash","SubType":"NULL"},
16434: {"Type":"Cash","SubType":"NULL"},
16435: {"Type":"Cash","SubType":"NULL"},
16436: {"Type":"Cash","SubType":"NULL"},
16437: {"Type":"Cash","SubType":"NULL"},
16438: {"Type":"Cash","SubType":"NULL"},
16439: {"Type":"Cash","SubType":"NULL"},
16440: {"Type":"Cash","SubType":"NULL"},
16441: {"Type":"Cash","SubType":"NULL"},
16442: {"Type":"Cash","SubType":"NULL"},
16443: {"Type":"Cash","SubType":"NULL"},
16444: {"Type":"Cash","SubType":"NULL"},
16445: {"Type":"Cash","SubType":"NULL"},
16446: {"Type":"Usable","SubType":"NULL"},
16447: {"Type":"Cash","SubType":"NULL"},
16448: {"Type":"Cash","SubType":"NULL"},
16449: {"Type":"Cash","SubType":"NULL"},
16450: {"Type":"Cash","SubType":"NULL"},
16451: {"Type":"Cash","SubType":"NULL"},
16452: {"Type":"Cash","SubType":"NULL"},
16453: {"Type":"Cash","SubType":"NULL"},
16454: {"Type":"Cash","SubType":"NULL"},
16455: {"Type":"Cash","SubType":"NULL"},
16456: {"Type":"Usable","SubType":"NULL"},
16457: {"Type":"Usable","SubType":"NULL"},
16458: {"Type":"Cash","SubType":"NULL"},
16459: {"Type":"Cash","SubType":"NULL"},
16460: {"Type":"Cash","SubType":"NULL"},
16461: {"Type":"Cash","SubType":"NULL"},
16462: {"Type":"Cash","SubType":"NULL"},
16466: {"Type":"Usable","SubType":"NULL"},
16467: {"Type":"Cash","SubType":"NULL"},
16468: {"Type":"Cash","SubType":"NULL"},
16469: {"Type":"Cash","SubType":"NULL"},
16470: {"Type":"Cash","SubType":"NULL"},
16481: {"Type":"Usable","SubType":"NULL"},
16483: {"Type":"Usable","SubType":"NULL"},
16492: {"Type":"Cash","SubType":"NULL"},
16503: {"Type":"Cash","SubType":"NULL"},
16504: {"Type":"Cash","SubType":"NULL"},
16505: {"Type":"Cash","SubType":"NULL"},
16506: {"Type":"Cash","SubType":"NULL"},
16507: {"Type":"Cash","SubType":"NULL"},
16508: {"Type":"Cash","SubType":"NULL"},
16509: {"Type":"Cash","SubType":"NULL"},
16510: {"Type":"Cash","SubType":"NULL"},
16514: {"Type":"Cash","SubType":"NULL"},
16515: {"Type":"Cash","SubType":"NULL"},
16542: {"Type":"Usable","SubType":"NULL"},
16543: {"Type":"Cash","SubType":"NULL"},
16544: {"Type":"Cash","SubType":"NULL"},
16548: {"Type":"Cash","SubType":"NULL"},
16549: {"Type":"Cash","SubType":"NULL"},
16550: {"Type":"Cash","SubType":"NULL"},
16551: {"Type":"Cash","SubType":"NULL"},
16554: {"Type":"Usable","SubType":"NULL"},
16555: {"Type":"Usable","SubType":"NULL"},
16556: {"Type":"Usable","SubType":"NULL"},
16557: {"Type":"Cash","SubType":"NULL"},
16558: {"Type":"Cash","SubType":"NULL"},
16559: {"Type":"Cash","SubType":"NULL"},
16560: {"Type":"Cash","SubType":"NULL"},
16561: {"Type":"Usable","SubType":"NULL"},
16562: {"Type":"Usable","SubType":"NULL"},
16563: {"Type":"Cash","SubType":"NULL"},
16565: {"Type":"Cash","SubType":"NULL"},
16566: {"Type":"Cash","SubType":"NULL"},
16567: {"Type":"Cash","SubType":"NULL"},
16568: {"Type":"Cash","SubType":"NULL"},
16569: {"Type":"Usable","SubType":"NULL"},
16570: {"Type":"Etc","SubType":"NULL"},
16571: {"Type":"Cash","SubType":"NULL"},
16573: {"Type":"Cash","SubType":"NULL"},
16574: {"Type":"Cash","SubType":"NULL"},
16576: {"Type":"Usable","SubType":"NULL"},
16577: {"Type":"Usable","SubType":"NULL"},
16580: {"Type":"Cash","SubType":"NULL"},
16581: {"Type":"Cash","SubType":"NULL"},
16582: {"Type":"Cash","SubType":"NULL"},
16584: {"Type":"Cash","SubType":"NULL"},
16585: {"Type":"Cash","SubType":"NULL"},
16586: {"Type":"Cash","SubType":"NULL"},
16587: {"Type":"Cash","SubType":"NULL"},
16588: {"Type":"Usable","SubType":"NULL"},
16589: {"Type":"Usable","SubType":"NULL"},
16590: {"Type":"Usable","SubType":"NULL"},
16591: {"Type":"Cash","SubType":"NULL"},
16592: {"Type":"Cash","SubType":"NULL"},
16593: {"Type":"Cash","SubType":"NULL"},
16596: {"Type":"Cash","SubType":"NULL"},
16597: {"Type":"Cash","SubType":"NULL"},
16598: {"Type":"Cash","SubType":"NULL"},
16599: {"Type":"Cash","SubType":"NULL"},
16600: {"Type":"Usable","SubType":"NULL"},
16601: {"Type":"Cash","SubType":"NULL"},
16602: {"Type":"Cash","SubType":"NULL"},
16603: {"Type":"Cash","SubType":"NULL"},
16604: {"Type":"Cash","SubType":"NULL"},
16605: {"Type":"Cash","SubType":"NULL"},
16606: {"Type":"Cash","SubType":"NULL"},
16619: {"Type":"Cash","SubType":"NULL"},
16620: {"Type":"Cash","SubType":"NULL"},
16621: {"Type":"Cash","SubType":"NULL"},
16622: {"Type":"Cash","SubType":"NULL"},
16623: {"Type":"Cash","SubType":"NULL"},
16624: {"Type":"Cash","SubType":"NULL"},
16625: {"Type":"Usable","SubType":"NULL"},
16626: {"Type":"Cash","SubType":"NULL"},
16627: {"Type":"Cash","SubType":"NULL"},
16628: {"Type":"Cash","SubType":"NULL"},
16629: {"Type":"Cash","SubType":"NULL"},
16630: {"Type":"Cash","SubType":"NULL"},
16631: {"Type":"Usable","SubType":"NULL"},
16632: {"Type":"Usable","SubType":"NULL"},
16633: {"Type":"Cash","SubType":"NULL"},
16634: {"Type":"Cash","SubType":"NULL"},
16635: {"Type":"Cash","SubType":"NULL"},
16636: {"Type":"Cash","SubType":"NULL"},
16637: {"Type":"Cash","SubType":"NULL"},
16638: {"Type":"Usable","SubType":"NULL"},
16639: {"Type":"Usable","SubType":"NULL"},
16640: {"Type":"Usable","SubType":"NULL"},
16641: {"Type":"Cash","SubType":"NULL"},
16642: {"Type":"Cash","SubType":"NULL"},
16643: {"Type":"Cash","SubType":"NULL"},
16644: {"Type":"Cash","SubType":"NULL"},
16645: {"Type":"Cash","SubType":"NULL"},
16646: {"Type":"Cash","SubType":"NULL"},
16647: {"Type":"Cash","SubType":"NULL"},
16648: {"Type":"Cash","SubType":"NULL"},
16649: {"Type":"Cash","SubType":"NULL"},
16650: {"Type":"Cash","SubType":"NULL"},
16651: {"Type":"Cash","SubType":"NULL"},
16652: {"Type":"Usable","SubType":"NULL"},
16653: {"Type":"Cash","SubType":"NULL"},
16654: {"Type":"Usable","SubType":"NULL"},
16655: {"Type":"Usable","SubType":"NULL"},
16656: {"Type":"Usable","SubType":"NULL"},
16657: {"Type":"Usable","SubType":"NULL"},
16658: {"Type":"Cash","SubType":"NULL"},
16659: {"Type":"Usable","SubType":"NULL"},
16660: {"Type":"Cash","SubType":"NULL"},
16661: {"Type":"Cash","SubType":"NULL"},
16662: {"Type":"Cash","SubType":"NULL"},
16663: {"Type":"Cash","SubType":"NULL"},
16664: {"Type":"Usable","SubType":"NULL"},
16665: {"Type":"Usable","SubType":"NULL"},
16666: {"Type":"Usable","SubType":"NULL"},
16667: {"Type":"Usable","SubType":"NULL"},
16668: {"Type":"Cash","SubType":"NULL"},
16670: {"Type":"Usable","SubType":"NULL"},
16671: {"Type":"Usable","SubType":"NULL"},
16672: {"Type":"Usable","SubType":"NULL"},
16673: {"Type":"Usable","SubType":"NULL"},
16674: {"Type":"Usable","SubType":"NULL"},
16675: {"Type":"Usable","SubType":"NULL"},
16676: {"Type":"Usable","SubType":"NULL"},
16677: {"Type":"Usable","SubType":"NULL"},
16678: {"Type":"Usable","SubType":"NULL"},
16679: {"Type":"Usable","SubType":"NULL"},
16680: {"Type":"Usable","SubType":"NULL"},
16681: {"Type":"Usable","SubType":"NULL"},
16682: {"Type":"Cash","SubType":"NULL"},
16683: {"Type":"Cash","SubType":"NULL"},
16684: {"Type":"Usable","SubType":"NULL"},
16685: {"Type":"Usable","SubType":"NULL"},
16686: {"Type":"Usable","SubType":"NULL"},
16687: {"Type":"Usable","SubType":"NULL"},
16688: {"Type":"Usable","SubType":"NULL"},
16689: {"Type":"Cash","SubType":"NULL"},
16690: {"Type":"Cash","SubType":"NULL"},
16691: {"Type":"Usable","SubType":"NULL"},
16692: {"Type":"Usable","SubType":"NULL"},
16693: {"Type":"Usable","SubType":"NULL"},
16694: {"Type":"Usable","SubType":"NULL"},
16695: {"Type":"Usable","SubType":"NULL"},
16696: {"Type":"Usable","SubType":"NULL"},
16697: {"Type":"Usable","SubType":"NULL"},
16698: {"Type":"Usable","SubType":"NULL"},
16699: {"Type":"Usable","SubType":"NULL"},
16701: {"Type":"Usable","SubType":"NULL"},
16702: {"Type":"Usable","SubType":"NULL"},
16703: {"Type":"Usable","SubType":"NULL"},
16704: {"Type":"Usable","SubType":"NULL"},
16705: {"Type":"Usable","SubType":"NULL"},
16706: {"Type":"Usable","SubType":"NULL"},
16707: {"Type":"Usable","SubType":"NULL"},
16708: {"Type":"Usable","SubType":"NULL"},
16709: {"Type":"Usable","SubType":"NULL"},
16710: {"Type":"Usable","SubType":"NULL"},
16711: {"Type":"Usable","SubType":"NULL"},
16712: {"Type":"Usable","SubType":"NULL"},
16713: {"Type":"Usable","SubType":"NULL"},
16714: {"Type":"Usable","SubType":"NULL"},
16715: {"Type":"Usable","SubType":"NULL"},
16716: {"Type":"Usable","SubType":"NULL"},
16717: {"Type":"Usable","SubType":"NULL"},
16718: {"Type":"Usable","SubType":"NULL"},
16719: {"Type":"Usable","SubType":"NULL"},
16720: {"Type":"Usable","SubType":"NULL"},
16721: {"Type":"Usable","SubType":"NULL"},
16722: {"Type":"Usable","SubType":"NULL"},
16723: {"Type":"Usable","SubType":"NULL"},
16724: {"Type":"Usable","SubType":"NULL"},
16725: {"Type":"Usable","SubType":"NULL"},
16726: {"Type":"Usable","SubType":"NULL"},
16727: {"Type":"Usable","SubType":"NULL"},
16728: {"Type":"Usable","SubType":"NULL"},
16729: {"Type":"Usable","SubType":"NULL"},
16730: {"Type":"Usable","SubType":"NULL"},
16731: {"Type":"Usable","SubType":"NULL"},
16732: {"Type":"Usable","SubType":"NULL"},
16733: {"Type":"Usable","SubType":"NULL"},
16734: {"Type":"Usable","SubType":"NULL"},
16735: {"Type":"Usable","SubType":"NULL"},
16736: {"Type":"Usable","SubType":"NULL"},
16737: {"Type":"Usable","SubType":"NULL"},
16738: {"Type":"Usable","SubType":"NULL"},
16739: {"Type":"Usable","SubType":"NULL"},
16740: {"Type":"Cash","SubType":"NULL"},
16741: {"Type":"Usable","SubType":"NULL"},
16742: {"Type":"Usable","SubType":"NULL"},
16743: {"Type":"Usable","SubType":"NULL"},
16744: {"Type":"Usable","SubType":"NULL"},
16745: {"Type":"Usable","SubType":"NULL"},
16746: {"Type":"Usable","SubType":"NULL"},
16747: {"Type":"Usable","SubType":"NULL"},
16748: {"Type":"Usable","SubType":"NULL"},
16749: {"Type":"Usable","SubType":"NULL"},
16750: {"Type":"Usable","SubType":"NULL"},
16751: {"Type":"Usable","SubType":"NULL"},
16752: {"Type":"Usable","SubType":"NULL"},
16753: {"Type":"Usable","SubType":"NULL"},
16754: {"Type":"Usable","SubType":"NULL"},
16755: {"Type":"Usable","SubType":"NULL"},
16756: {"Type":"Usable","SubType":"NULL"},
16757: {"Type":"Usable","SubType":"NULL"},
16758: {"Type":"Usable","SubType":"NULL"},
16759: {"Type":"Usable","SubType":"NULL"},
16760: {"Type":"Usable","SubType":"NULL"},
16761: {"Type":"Usable","SubType":"NULL"},
16762: {"Type":"Cash","SubType":"NULL"},
16763: {"Type":"Cash","SubType":"NULL"},
16764: {"Type":"Cash","SubType":"NULL"},
16765: {"Type":"Cash","SubType":"NULL"},
16766: {"Type":"Cash","SubType":"NULL"},
16767: {"Type":"Cash","SubType":"NULL"},
16770: {"Type":"Cash","SubType":"NULL"},
16771: {"Type":"Cash","SubType":"NULL"},
16774: {"Type":"Usable","SubType":"NULL"},
16775: {"Type":"Usable","SubType":"NULL"},
16776: {"Type":"Usable","SubType":"NULL"},
16777: {"Type":"Usable","SubType":"NULL"},
16778: {"Type":"Cash","SubType":"NULL"},
16779: {"Type":"Cash","SubType":"NULL"},
16780: {"Type":"Cash","SubType":"NULL"},
16781: {"Type":"Cash","SubType":"NULL"},
16782: {"Type":"Cash","SubType":"NULL"},
16783: {"Type":"Cash","SubType":"NULL"},
16784: {"Type":"Cash","SubType":"NULL"},
16785: {"Type":"Cash","SubType":"NULL"},
16786: {"Type":"Cash","SubType":"NULL"},
16787: {"Type":"Cash","SubType":"NULL"},
16788: {"Type":"Cash","SubType":"NULL"},
16789: {"Type":"Cash","SubType":"NULL"},
16790: {"Type":"Usable","SubType":"NULL"},
16791: {"Type":"Usable","SubType":"NULL"},
16792: {"Type":"Usable","SubType":"NULL"},
16793: {"Type":"Usable","SubType":"NULL"},
16794: {"Type":"Cash","SubType":"NULL"},
16795: {"Type":"Usable","SubType":"NULL"},
16796: {"Type":"Cash","SubType":"NULL"},
16797: {"Type":"Cash","SubType":"NULL"},
16798: {"Type":"Cash","SubType":"NULL"},
16799: {"Type":"Cash","SubType":"NULL"},
16800: {"Type":"Usable","SubType":"NULL"},
16801: {"Type":"Usable","SubType":"NULL"},
16802: {"Type":"Usable","SubType":"NULL"},
16803: {"Type":"Usable","SubType":"NULL"},
16804: {"Type":"Usable","SubType":"NULL"},
16805: {"Type":"Usable","SubType":"NULL"},
16806: {"Type":"Usable","SubType":"NULL"},
16807: {"Type":"Usable","SubType":"NULL"},
16808: {"Type":"Usable","SubType":"NULL"},
16809: {"Type":"Usable","SubType":"NULL"},
16810: {"Type":"Usable","SubType":"NULL"},
16811: {"Type":"Usable","SubType":"NULL"},
16812: {"Type":"Cash","SubType":"NULL"},
16813: {"Type":"Cash","SubType":"NULL"},
16814: {"Type":"Cash","SubType":"NULL"},
16815: {"Type":"Cash","SubType":"NULL"},
16816: {"Type":"Cash","SubType":"NULL"},
16817: {"Type":"Cash","SubType":"NULL"},
16818: {"Type":"Cash","SubType":"NULL"},
16819: {"Type":"Cash","SubType":"NULL"},
16820: {"Type":"Cash","SubType":"NULL"},
16821: {"Type":"Usable","SubType":"NULL"},
16822: {"Type":"Usable","SubType":"NULL"},
16823: {"Type":"Cash","SubType":"NULL"},
16824: {"Type":"Cash","SubType":"NULL"},
16825: {"Type":"Cash","SubType":"NULL"},
16826: {"Type":"Usable","SubType":"NULL"},
16827: {"Type":"Cash","SubType":"NULL"},
16828: {"Type":"Cash","SubType":"NULL"},
16829: {"Type":"Cash","SubType":"NULL"},
16830: {"Type":"Cash","SubType":"NULL"},
16831: {"Type":"Cash","SubType":"NULL"},
16832: {"Type":"Cash","SubType":"NULL"},
16833: {"Type":"Cash","SubType":"NULL"},
16834: {"Type":"Cash","SubType":"NULL"},
16835: {"Type":"Cash","SubType":"NULL"},
16836: {"Type":"Cash","SubType":"NULL"},
16837: {"Type":"Usable","SubType":"NULL"},
16838: {"Type":"Usable","SubType":"NULL"},
16839: {"Type":"Cash","SubType":"NULL"},
16840: {"Type":"Cash","SubType":"NULL"},
16841: {"Type":"Cash","SubType":"NULL"},
16842: {"Type":"Cash","SubType":"NULL"},
16843: {"Type":"Cash","SubType":"NULL"},
16844: {"Type":"Cash","SubType":"NULL"},
16845: {"Type":"Cash","SubType":"NULL"},
16846: {"Type":"Cash","SubType":"NULL"},
16847: {"Type":"Cash","SubType":"NULL"},
16848: {"Type":"Cash","SubType":"NULL"},
16849: {"Type":"Cash","SubType":"NULL"},
16850: {"Type":"Cash","SubType":"NULL"},
16851: {"Type":"Cash","SubType":"NULL"},
16852: {"Type":"Cash","SubType":"NULL"},
16853: {"Type":"Cash","SubType":"NULL"},
16854: {"Type":"Usable","SubType":"NULL"},
16855: {"Type":"Usable","SubType":"NULL"},
16856: {"Type":"Cash","SubType":"NULL"},
16857: {"Type":"Cash","SubType":"NULL"},
16858: {"Type":"Cash","SubType":"NULL"},
16859: {"Type":"Cash","SubType":"NULL"},
16860: {"Type":"Cash","SubType":"NULL"},
16861: {"Type":"Cash","SubType":"NULL"},
16862: {"Type":"Cash","SubType":"NULL"},
16863: {"Type":"Cash","SubType":"NULL"},
16864: {"Type":"Cash","SubType":"NULL"},
16865: {"Type":"Cash","SubType":"NULL"},
16866: {"Type":"Cash","SubType":"NULL"},
16867: {"Type":"Cash","SubType":"NULL"},
16868: {"Type":"Cash","SubType":"NULL"},
16869: {"Type":"Cash","SubType":"NULL"},
16870: {"Type":"Cash","SubType":"NULL"},
16871: {"Type":"Cash","SubType":"NULL"},
16872: {"Type":"Cash","SubType":"NULL"},
16873: {"Type":"Cash","SubType":"NULL"},
16874: {"Type":"Cash","SubType":"NULL"},
16875: {"Type":"Cash","SubType":"NULL"},
16876: {"Type":"Usable","SubType":"NULL"},
16877: {"Type":"Usable","SubType":"NULL"},
16878: {"Type":"Usable","SubType":"NULL"},
16879: {"Type":"Cash","SubType":"NULL"},
16880: {"Type":"Cash","SubType":"NULL"},
16881: {"Type":"Cash","SubType":"NULL"},
16882: {"Type":"Cash","SubType":"NULL"},
16883: {"Type":"Cash","SubType":"NULL"},
16884: {"Type":"Cash","SubType":"NULL"},
16885: {"Type":"Cash","SubType":"NULL"},
16886: {"Type":"Cash","SubType":"NULL"},
16887: {"Type":"Cash","SubType":"NULL"},
16888: {"Type":"Cash","SubType":"NULL"},
16889: {"Type":"Cash","SubType":"NULL"},
16890: {"Type":"Cash","SubType":"NULL"},
16891: {"Type":"Cash","SubType":"NULL"},
16892: {"Type":"Cash","SubType":"NULL"},
16893: {"Type":"Cash","SubType":"NULL"},
16894: {"Type":"Usable","SubType":"NULL"},
16895: {"Type":"Cash","SubType":"NULL"},
16896: {"Type":"Cash","SubType":"NULL"},
16897: {"Type":"Cash","SubType":"NULL"},
16898: {"Type":"Cash","SubType":"NULL"},
16899: {"Type":"Cash","SubType":"NULL"},
16900: {"Type":"Cash","SubType":"NULL"},
16901: {"Type":"Cash","SubType":"NULL"},
16902: {"Type":"Cash","SubType":"NULL"},
16903: {"Type":"Cash","SubType":"NULL"},
16904: {"Type":"Cash","SubType":"NULL"},
16905: {"Type":"Cash","SubType":"NULL"},
16906: {"Type":"Cash","SubType":"NULL"},
16907: {"Type":"Cash","SubType":"NULL"},
16908: {"Type":"Cash","SubType":"NULL"},
16909: {"Type":"Cash","SubType":"NULL"},
16910: {"Type":"Cash","SubType":"NULL"},
16911: {"Type":"Cash","SubType":"NULL"},
16912: {"Type":"Cash","SubType":"NULL"},
16913: {"Type":"Cash","SubType":"NULL"},
16914: {"Type":"Cash","SubType":"NULL"},
16915: {"Type":"Cash","SubType":"NULL"},
16916: {"Type":"Cash","SubType":"NULL"},
16917: {"Type":"Cash","SubType":"NULL"},
16918: {"Type":"Cash","SubType":"NULL"},
16919: {"Type":"Cash","SubType":"NULL"},
16920: {"Type":"Usable","SubType":"NULL"},
16921: {"Type":"Cash","SubType":"NULL"},
16922: {"Type":"Cash","SubType":"NULL"},
16923: {"Type":"Cash","SubType":"NULL"},
16924: {"Type":"Cash","SubType":"NULL"},
16925: {"Type":"Cash","SubType":"NULL"},
16926: {"Type":"Cash","SubType":"NULL"},
16927: {"Type":"Cash","SubType":"NULL"},
16928: {"Type":"Cash","SubType":"NULL"},
16929: {"Type":"Cash","SubType":"NULL"},
16930: {"Type":"Cash","SubType":"NULL"},
16931: {"Type":"Cash","SubType":"NULL"},
16932: {"Type":"Cash","SubType":"NULL"},
16933: {"Type":"Cash","SubType":"NULL"},
16934: {"Type":"Cash","SubType":"NULL"},
16935: {"Type":"Cash","SubType":"NULL"},
16936: {"Type":"Cash","SubType":"NULL"},
16937: {"Type":"Cash","SubType":"NULL"},
16938: {"Type":"Cash","SubType":"NULL"},
16939: {"Type":"Cash","SubType":"NULL"},
16940: {"Type":"Cash","SubType":"NULL"},
16941: {"Type":"Cash","SubType":"NULL"},
16942: {"Type":"Cash","SubType":"NULL"},
16943: {"Type":"Cash","SubType":"NULL"},
16944: {"Type":"Cash","SubType":"NULL"},
16945: {"Type":"Cash","SubType":"NULL"},
16946: {"Type":"Cash","SubType":"NULL"},
16947: {"Type":"Cash","SubType":"NULL"},
16948: {"Type":"Cash","SubType":"NULL"},
16949: {"Type":"Cash","SubType":"NULL"},
16950: {"Type":"Cash","SubType":"NULL"},
16951: {"Type":"Cash","SubType":"NULL"},
16952: {"Type":"Cash","SubType":"NULL"},
16953: {"Type":"Cash","SubType":"NULL"},
16954: {"Type":"Cash","SubType":"NULL"},
16955: {"Type":"Cash","SubType":"NULL"},
16956: {"Type":"Cash","SubType":"NULL"},
16957: {"Type":"Cash","SubType":"NULL"},
16958: {"Type":"Cash","SubType":"NULL"},
16959: {"Type":"Cash","SubType":"NULL"},
16960: {"Type":"Cash","SubType":"NULL"},
16961: {"Type":"Cash","SubType":"NULL"},
16962: {"Type":"Cash","SubType":"NULL"},
16963: {"Type":"Cash","SubType":"NULL"},
16964: {"Type":"Cash","SubType":"NULL"},
16965: {"Type":"Cash","SubType":"NULL"},
16966: {"Type":"Cash","SubType":"NULL"},
16967: {"Type":"Cash","SubType":"NULL"},
16968: {"Type":"Cash","SubType":"NULL"},
16969: {"Type":"Cash","SubType":"NULL"},
16970: {"Type":"Cash","SubType":"NULL"},
16971: {"Type":"Cash","SubType":"NULL"},
16972: {"Type":"Usable","SubType":"NULL"},
16973: {"Type":"Cash","SubType":"NULL"},
16974: {"Type":"Usable","SubType":"NULL"},
16975: {"Type":"Cash","SubType":"NULL"},
16976: {"Type":"Usable","SubType":"NULL"},
16977: {"Type":"Cash","SubType":"NULL"},
16978: {"Type":"Cash","SubType":"NULL"},
16979: {"Type":"Cash","SubType":"NULL"},
16990: {"Type":"Usable","SubType":"NULL"},
16991: {"Type":"Usable","SubType":"NULL"},
16992: {"Type":"Cash","SubType":"NULL"},
16993: {"Type":"Cash","SubType":"NULL"},
16995: {"Type":"Usable","SubType":"NULL"},
16996: {"Type":"Usable","SubType":"NULL"},
16997: {"Type":"Usable","SubType":"NULL"},
16998: {"Type":"Cash","SubType":"NULL"},
16999: {"Type":"Cash","SubType":"NULL"},
17000: {"Type":"Cash","SubType":"NULL"},
17001: {"Type":"Cash","SubType":"NULL"},
17002: {"Type":"Cash","SubType":"NULL"},
17003: {"Type":"Cash","SubType":"NULL"},
17004: {"Type":"Cash","SubType":"NULL"},
17005: {"Type":"Cash","SubType":"NULL"},
17006: {"Type":"Cash","SubType":"NULL"},
17007: {"Type":"Cash","SubType":"NULL"},
17008: {"Type":"Cash","SubType":"NULL"},
17009: {"Type":"Cash","SubType":"NULL"},
17011: {"Type":"Usable","SubType":"NULL"},
17012: {"Type":"Usable","SubType":"NULL"},
17013: {"Type":"Usable","SubType":"NULL"},
17014: {"Type":"Cash","SubType":"NULL"},
17015: {"Type":"Cash","SubType":"NULL"},
17016: {"Type":"Usable","SubType":"NULL"},
17017: {"Type":"Usable","SubType":"NULL"},
17018: {"Type":"Usable","SubType":"NULL"},
17019: {"Type":"Usable","SubType":"NULL"},
17020: {"Type":"Usable","SubType":"NULL"},
17021: {"Type":"Usable","SubType":"NULL"},
17022: {"Type":"Usable","SubType":"NULL"},
17023: {"Type":"Usable","SubType":"NULL"},
17024: {"Type":"Usable","SubType":"NULL"},
17025: {"Type":"Usable","SubType":"NULL"},
17026: {"Type":"Usable","SubType":"NULL"},
17027: {"Type":"Usable","SubType":"NULL"},
17028: {"Type":"Usable","SubType":"NULL"},
17029: {"Type":"Usable","SubType":"NULL"},
17030: {"Type":"Cash","SubType":"NULL"},
17035: {"Type":"Usable","SubType":"NULL"},
17036: {"Type":"Usable","SubType":"NULL"},
17037: {"Type":"Cash","SubType":"NULL"},
17038: {"Type":"Cash","SubType":"NULL"},
17039: {"Type":"Cash","SubType":"NULL"},
17040: {"Type":"Cash","SubType":"NULL"},
17041: {"Type":"Cash","SubType":"NULL"},
17042: {"Type":"Cash","SubType":"NULL"},
17043: {"Type":"Cash","SubType":"NULL"},
17044: {"Type":"Cash","SubType":"NULL"},
17045: {"Type":"Cash","SubType":"NULL"},
17046: {"Type":"Usable","SubType":"NULL"},
17050: {"Type":"Usable","SubType":"NULL"},
17051: {"Type":"Usable","SubType":"NULL"},
17052: {"Type":"Cash","SubType":"NULL"},
17056: {"Type":"Usable","SubType":"NULL"},
17057: {"Type":"Usable","SubType":"NULL"},
17058: {"Type":"Usable","SubType":"NULL"},
17059: {"Type":"Usable","SubType":"NULL"},
17060: {"Type":"Usable","SubType":"NULL"},
17061: {"Type":"Usable","SubType":"NULL"},
17062: {"Type":"Usable","SubType":"NULL"},
17063: {"Type":"Usable","SubType":"NULL"},
17064: {"Type":"Usable","SubType":"NULL"},
17065: {"Type":"Cash","SubType":"NULL"},
17066: {"Type":"Cash","SubType":"NULL"},
17067: {"Type":"Cash","SubType":"NULL"},
17068: {"Type":"Usable","SubType":"NULL"},
17069: {"Type":"Usable","SubType":"NULL"},
17070: {"Type":"Usable","SubType":"NULL"},
17071: {"Type":"Cash","SubType":"NULL"},
17072: {"Type":"Cash","SubType":"NULL"},
17073: {"Type":"Cash","SubType":"NULL"},
17074: {"Type":"Cash","SubType":"NULL"},
17075: {"Type":"Cash","SubType":"NULL"},
17076: {"Type":"Cash","SubType":"NULL"},
17077: {"Type":"Usable","SubType":"NULL"},
17078: {"Type":"Usable","SubType":"NULL"},
17079: {"Type":"Cash","SubType":"NULL"},
17080: {"Type":"Usable","SubType":"NULL"},
17081: {"Type":"Cash","SubType":"NULL"},
17082: {"Type":"Usable","SubType":"NULL"},
17083: {"Type":"Usable","SubType":"NULL"},
17084: {"Type":"Cash","SubType":"NULL"},
17085: {"Type":"Cash","SubType":"NULL"},
17086: {"Type":"Cash","SubType":"NULL"},
17087: {"Type":"Cash","SubType":"NULL"},
17088: {"Type":"Cash","SubType":"NULL"},
17089: {"Type":"Cash","SubType":"NULL"},
17090: {"Type":"Cash","SubType":"NULL"},
17091: {"Type":"Cash","SubType":"NULL"},
17092: {"Type":"Cash","SubType":"NULL"},
17093: {"Type":"Cash","SubType":"NULL"},
17094: {"Type":"Usable","SubType":"NULL"},
17095: {"Type":"Usable","SubType":"NULL"},
17096: {"Type":"Usable","SubType":"NULL"},
17097: {"Type":"Usable","SubType":"NULL"},
17098: {"Type":"Usable","SubType":"NULL"},
17099: {"Type":"Usable","SubType":"NULL"},
17100: {"Type":"Usable","SubType":"NULL"},
17101: {"Type":"Usable","SubType":"NULL"},
17102: {"Type":"Usable","SubType":"NULL"},
17103: {"Type":"Usable","SubType":"NULL"},
17104: {"Type":"Cash","SubType":"NULL"},
17105: {"Type":"Cash","SubType":"NULL"},
17106: {"Type":"Cash","SubType":"NULL"},
17107: {"Type":"Cash","SubType":"NULL"},
17108: {"Type":"Cash","SubType":"NULL"},
17109: {"Type":"Usable","SubType":"NULL"},
17110: {"Type":"Usable","SubType":"NULL"},
17113: {"Type":"Usable","SubType":"NULL"},
17114: {"Type":"Cash","SubType":"NULL"},
17115: {"Type":"Cash","SubType":"NULL"},
17116: {"Type":"Cash","SubType":"NULL"},
17117: {"Type":"Usable","SubType":"NULL"},
17118: {"Type":"Usable","SubType":"NULL"},
17120: {"Type":"Usable","SubType":"NULL"},
17121: {"Type":"Usable","SubType":"NULL"},
17122: {"Type":"Cash","SubType":"NULL"},
17123: {"Type":"Cash","SubType":"NULL"},
17124: {"Type":"Cash","SubType":"NULL"},
17125: {"Type":"Cash","SubType":"NULL"},
17126: {"Type":"Cash","SubType":"NULL"},
17127: {"Type":"Usable","SubType":"NULL"},
17134: {"Type":"Usable","SubType":"NULL"},
17135: {"Type":"Usable","SubType":"NULL"},
17136: {"Type":"Usable","SubType":"NULL"},
17137: {"Type":"Usable","SubType":"NULL"},
17138: {"Type":"Usable","SubType":"NULL"},
17139: {"Type":"Usable","SubType":"NULL"},
17140: {"Type":"Usable","SubType":"NULL"},
17141: {"Type":"Usable","SubType":"NULL"},
17143: {"Type":"Usable","SubType":"NULL"},
17144: {"Type":"Cash","SubType":"NULL"},
17145: {"Type":"Cash","SubType":"NULL"},
17146: {"Type":"Cash","SubType":"NULL"},
17147: {"Type":"Cash","SubType":"NULL"},
17152: {"Type":"Cash","SubType":"NULL"},
17153: {"Type":"Cash","SubType":"NULL"},
17154: {"Type":"Cash","SubType":"NULL"},
17155: {"Type":"Usable","SubType":"NULL"},
17156: {"Type":"Usable","SubType":"NULL"},
17157: {"Type":"Cash","SubType":"NULL"},
17158: {"Type":"Cash","SubType":"NULL"},
17159: {"Type":"Cash","SubType":"NULL"},
17160: {"Type":"Cash","SubType":"NULL"},
17162: {"Type":"Cash","SubType":"NULL"},
17163: {"Type":"Cash","SubType":"NULL"},
17164: {"Type":"Cash","SubType":"NULL"},
17165: {"Type":"Usable","SubType":"NULL"},
17166: {"Type":"Cash","SubType":"NULL"},
17171: {"Type":"Cash","SubType":"NULL"},
17172: {"Type":"Cash","SubType":"NULL"},
17173: {"Type":"Cash","SubType":"NULL"},
17174: {"Type":"Cash","SubType":"NULL"},
17175: {"Type":"Cash","SubType":"NULL"},
17176: {"Type":"Cash","SubType":"NULL"},
17177: {"Type":"Cash","SubType":"NULL"},
17178: {"Type":"Cash","SubType":"NULL"},
17179: {"Type":"Cash","SubType":"NULL"},
17180: {"Type":"Cash","SubType":"NULL"},
17181: {"Type":"Usable","SubType":"NULL"},
17182: {"Type":"Cash","SubType":"NULL"},
17184: {"Type":"Cash","SubType":"NULL"},
17193: {"Type":"Cash","SubType":"NULL"},
17194: {"Type":"Cash","SubType":"NULL"},
17195: {"Type":"Cash","SubType":"NULL"},
17196: {"Type":"Cash","SubType":"NULL"},
17197: {"Type":"Cash","SubType":"NULL"},
17198: {"Type":"Cash","SubType":"NULL"},
17200: {"Type":"Cash","SubType":"NULL"},
17201: {"Type":"Cash","SubType":"NULL"},
17202: {"Type":"Cash","SubType":"NULL"},
17203: {"Type":"Usable","SubType":"NULL"},
17204: {"Type":"Cash","SubType":"NULL"},
17205: {"Type":"Cash","SubType":"NULL"},
17206: {"Type":"Cash","SubType":"NULL"},
17207: {"Type":"Usable","SubType":"NULL"},
17209: {"Type":"Usable","SubType":"NULL"},
17210: {"Type":"Usable","SubType":"NULL"},
17211: {"Type":"Usable","SubType":"NULL"},
17212: {"Type":"Usable","SubType":"NULL"},
17224: {"Type":"Cash","SubType":"NULL"},
17226: {"Type":"Cash","SubType":"NULL"},
17227: {"Type":"Cash","SubType":"NULL"},
17228: {"Type":"Cash","SubType":"NULL"},
17229: {"Type":"Cash","SubType":"NULL"},
17230: {"Type":"Cash","SubType":"NULL"},
17231: {"Type":"Cash","SubType":"NULL"},
17232: {"Type":"Cash","SubType":"NULL"},
17233: {"Type":"Usable","SubType":"NULL"},
17234: {"Type":"Usable","SubType":"NULL"},
17235: {"Type":"Usable","SubType":"NULL"},
17236: {"Type":"Usable","SubType":"NULL"},
17237: {"Type":"Usable","SubType":"NULL"},
17238: {"Type":"Usable","SubType":"NULL"},
17239: {"Type":"Usable","SubType":"NULL"},
17240: {"Type":"Usable","SubType":"NULL"},
17241: {"Type":"Usable","SubType":"NULL"},
17242: {"Type":"Cash","SubType":"NULL"},
17244: {"Type":"Cash","SubType":"NULL"},
17245: {"Type":"Cash","SubType":"NULL"},
17246: {"Type":"Cash","SubType":"NULL"},
17247: {"Type":"Cash","SubType":"NULL"},
17251: {"Type":"Usable","SubType":"NULL"},
17252: {"Type":"Usable","SubType":"NULL"},
17253: {"Type":"Cash","SubType":"NULL"},
17254: {"Type":"Cash","SubType":"NULL"},
17255: {"Type":"Cash","SubType":"NULL"},
17256: {"Type":"Cash","SubType":"NULL"},
17257: {"Type":"Cash","SubType":"NULL"},
17262: {"Type":"Cash","SubType":"NULL"},
17263: {"Type":"Cash","SubType":"NULL"},
17264: {"Type":"Cash","SubType":"NULL"},
17265: {"Type":"Cash","SubType":"NULL"},
17266: {"Type":"Cash","SubType":"NULL"},
17270: {"Type":"Cash","SubType":"NULL"},
17271: {"Type":"Cash","SubType":"NULL"},
17272: {"Type":"Cash","SubType":"NULL"},
17273: {"Type":"Cash","SubType":"NULL"},
17274: {"Type":"Cash","SubType":"NULL"},
17275: {"Type":"Cash","SubType":"NULL"},
17277: {"Type":"Cash","SubType":"NULL"},
17278: {"Type":"Cash","SubType":"NULL"},
17279: {"Type":"Cash","SubType":"NULL"},
17281: {"Type":"Cash","SubType":"NULL"},
17282: {"Type":"Cash","SubType":"NULL"},
17283: {"Type":"Cash","SubType":"NULL"},
17284: {"Type":"Cash","SubType":"NULL"},
17285: {"Type":"Cash","SubType":"NULL"},
17286: {"Type":"Cash","SubType":"NULL"},
17287: {"Type":"Cash","SubType":"NULL"},
17288: {"Type":"Cash","SubType":"NULL"},
17289: {"Type":"Usable","SubType":"NULL"},
17290: {"Type":"Cash","SubType":"NULL"},
17292: {"Type":"Cash","SubType":"NULL"},
17293: {"Type":"Cash","SubType":"NULL"},
17294: {"Type":"Cash","SubType":"NULL"},
17298: {"Type":"Cash","SubType":"NULL"},
17299: {"Type":"Cash","SubType":"NULL"},
17302: {"Type":"Cash","SubType":"NULL"},
17303: {"Type":"Cash","SubType":"NULL"},
17304: {"Type":"Cash","SubType":"NULL"},
17306: {"Type":"Cash","SubType":"NULL"},
17307: {"Type":"Cash","SubType":"NULL"},
17308: {"Type":"Usable","SubType":"NULL"},
17311: {"Type":"Usable","SubType":"NULL"},
17314: {"Type":"Cash","SubType":"NULL"},
17315: {"Type":"Cash","SubType":"NULL"},
17316: {"Type":"Cash","SubType":"NULL"},
17317: {"Type":"Cash","SubType":"NULL"},
17320: {"Type":"Cash","SubType":"NULL"},
17321: {"Type":"Cash","SubType":"NULL"},
17322: {"Type":"Cash","SubType":"NULL"},
17326: {"Type":"Cash","SubType":"NULL"},
17331: {"Type":"Cash","SubType":"NULL"},
17332: {"Type":"Cash","SubType":"NULL"},
17336: {"Type":"Cash","SubType":"NULL"},
17337: {"Type":"Cash","SubType":"NULL"},
17338: {"Type":"Cash","SubType":"NULL"},
17339: {"Type":"Cash","SubType":"NULL"},
17394: {"Type":"Usable","SubType":"NULL"},
17396: {"Type":"Usable","SubType":"NULL"},
17397: {"Type":"Usable","SubType":"NULL"},
17398: {"Type":"Usable","SubType":"NULL"},
17399: {"Type":"Usable","SubType":"NULL"},
17400: {"Type":"Usable","SubType":"NULL"},
17401: {"Type":"Usable","SubType":"NULL"},
17402: {"Type":"Usable","SubType":"NULL"},
17403: {"Type":"Usable","SubType":"NULL"},
17404: {"Type":"Usable","SubType":"NULL"},
17405: {"Type":"Usable","SubType":"NULL"},
17406: {"Type":"Usable","SubType":"NULL"},
17407: {"Type":"Usable","SubType":"NULL"},
17408: {"Type":"Usable","SubType":"NULL"},
17409: {"Type":"Usable","SubType":"NULL"},
17410: {"Type":"Usable","SubType":"NULL"},
17411: {"Type":"Usable","SubType":"NULL"},
17412: {"Type":"Usable","SubType":"NULL"},
17413: {"Type":"Usable","SubType":"NULL"},
17414: {"Type":"Usable","SubType":"NULL"},
17415: {"Type":"Usable","SubType":"NULL"},
17416: {"Type":"Usable","SubType":"NULL"},
17417: {"Type":"Usable","SubType":"NULL"},
17418: {"Type":"Usable","SubType":"NULL"},
17419: {"Type":"Usable","SubType":"NULL"},
17420: {"Type":"Usable","SubType":"NULL"},
17421: {"Type":"Usable","SubType":"NULL"},
17422: {"Type":"Usable","SubType":"NULL"},
17423: {"Type":"Usable","SubType":"NULL"},
17424: {"Type":"Usable","SubType":"NULL"},
17425: {"Type":"Usable","SubType":"NULL"},
17426: {"Type":"Usable","SubType":"NULL"},
17427: {"Type":"Usable","SubType":"NULL"},
17429: {"Type":"Cash","SubType":"NULL"},
17430: {"Type":"Cash","SubType":"NULL"},
17431: {"Type":"Cash","SubType":"NULL"},
17432: {"Type":"Cash","SubType":"NULL"},
17433: {"Type":"Cash","SubType":"NULL"},
17435: {"Type":"Cash","SubType":"NULL"},
17438: {"Type":"Cash","SubType":"NULL"},
17439: {"Type":"Cash","SubType":"NULL"},
17440: {"Type":"Cash","SubType":"NULL"},
17441: {"Type":"Cash","SubType":"NULL"},
17442: {"Type":"Cash","SubType":"NULL"},
17443: {"Type":"Cash","SubType":"NULL"},
17447: {"Type":"Cash","SubType":"NULL"},
17449: {"Type":"Cash","SubType":"NULL"},
17455: {"Type":"Cash","SubType":"NULL"},
17456: {"Type":"Cash","SubType":"NULL"},
17457: {"Type":"Cash","SubType":"NULL"},
17461: {"Type":"Cash","SubType":"NULL"},
17464: {"Type":"Cash","SubType":"NULL"},
17465: {"Type":"Cash","SubType":"NULL"},
17466: {"Type":"Cash","SubType":"NULL"},
17467: {"Type":"Cash","SubType":"NULL"},
17468: {"Type":"Usable","SubType":"NULL"},
17469: {"Type":"Usable","SubType":"NULL"},
17470: {"Type":"Cash","SubType":"NULL"},
17471: {"Type":"Cash","SubType":"NULL"},
17472: {"Type":"Cash","SubType":"NULL"},
17473: {"Type":"Cash","SubType":"NULL"},
17474: {"Type":"Cash","SubType":"NULL"},
17475: {"Type":"Cash","SubType":"NULL"},
17477: {"Type":"Cash","SubType":"NULL"},
17478: {"Type":"Cash","SubType":"NULL"},
17479: {"Type":"Usable","SubType":"NULL"},
17481: {"Type":"Cash","SubType":"NULL"},
17482: {"Type":"Usable","SubType":"NULL"},
17483: {"Type":"Cash","SubType":"NULL"},
17484: {"Type":"Cash","SubType":"NULL"},
17490: {"Type":"Usable","SubType":"NULL"},
17491: {"Type":"Cash","SubType":"NULL"},
17492: {"Type":"Cash","SubType":"NULL"},
17493: {"Type":"Cash","SubType":"NULL"},
17494: {"Type":"Cash","SubType":"NULL"},
17495: {"Type":"Cash","SubType":"NULL"},
17496: {"Type":"Cash","SubType":"NULL"},
17497: {"Type":"Cash","SubType":"NULL"},
17498: {"Type":"Cash","SubType":"NULL"},
17499: {"Type":"Cash","SubType":"NULL"},
17501: {"Type":"Cash","SubType":"NULL"},
17502: {"Type":"Cash","SubType":"NULL"},
17507: {"Type":"Cash","SubType":"NULL"},
17508: {"Type":"Cash","SubType":"NULL"},
17509: {"Type":"Cash","SubType":"NULL"},
17510: {"Type":"Cash","SubType":"NULL"},
17511: {"Type":"Cash","SubType":"NULL"},
17512: {"Type":"Cash","SubType":"NULL"},
17513: {"Type":"Cash","SubType":"NULL"},
17515: {"Type":"Cash","SubType":"NULL"},
17516: {"Type":"Cash","SubType":"NULL"},
17517: {"Type":"Cash","SubType":"NULL"},
17519: {"Type":"Cash","SubType":"NULL"},
17520: {"Type":"Cash","SubType":"NULL"},
17521: {"Type":"Cash","SubType":"NULL"},
17522: {"Type":"Cash","SubType":"NULL"},
17523: {"Type":"Cash","SubType":"NULL"},
17524: {"Type":"Cash","SubType":"NULL"},
17525: {"Type":"Cash","SubType":"NULL"},
17526: {"Type":"Cash","SubType":"NULL"},
17527: {"Type":"Cash","SubType":"NULL"},
17532: {"Type":"Cash","SubType":"NULL"},
17544: {"Type":"Cash","SubType":"NULL"},
17545: {"Type":"Cash","SubType":"NULL"},
17547: {"Type":"Usable","SubType":"NULL"},
17548: {"Type":"Usable","SubType":"NULL"},
17549: {"Type":"Usable","SubType":"NULL"},
17550: {"Type":"Usable","SubType":"NULL"},
17552: {"Type":"Cash","SubType":"NULL"},
17567: {"Type":"Cash","SubType":"NULL"},
17568: {"Type":"Cash","SubType":"NULL"},
17569: {"Type":"Usable","SubType":"NULL"},
17570: {"Type":"Usable","SubType":"NULL"},
17572: {"Type":"Cash","SubType":"NULL"},
17573: {"Type":"Cash","SubType":"NULL"},
17574: {"Type":"Cash","SubType":"NULL"},
17575: {"Type":"Cash","SubType":"NULL"},
17576: {"Type":"Cash","SubType":"NULL"},
17582: {"Type":"Cash","SubType":"NULL"},
17583: {"Type":"Cash","SubType":"NULL"},
17584: {"Type":"Cash","SubType":"NULL"},
17586: {"Type":"Cash","SubType":"NULL"},
17587: {"Type":"Cash","SubType":"NULL"},
17588: {"Type":"Cash","SubType":"NULL"},
17590: {"Type":"Cash","SubType":"NULL"},
17591: {"Type":"Cash","SubType":"NULL"},
17592: {"Type":"Cash","SubType":"NULL"},
17593: {"Type":"Cash","SubType":"NULL"},
17598: {"Type":"Cash","SubType":"NULL"},
17599: {"Type":"Cash","SubType":"NULL"},
17600: {"Type":"Cash","SubType":"NULL"},
17601: {"Type":"Cash","SubType":"NULL"},
17602: {"Type":"Cash","SubType":"NULL"},
17607: {"Type":"Cash","SubType":"NULL"},
17608: {"Type":"Cash","SubType":"NULL"},
17609: {"Type":"Cash","SubType":"NULL"},
17610: {"Type":"Cash","SubType":"NULL"},
17613: {"Type":"Cash","SubType":"NULL"},
17616: {"Type":"Cash","SubType":"NULL"},
17617: {"Type":"Cash","SubType":"NULL"},
17628: {"Type":"Cash","SubType":"NULL"},
17631: {"Type":"Cash","SubType":"NULL"},
17632: {"Type":"Cash","SubType":"NULL"},
17633: {"Type":"Cash","SubType":"NULL"},
17639: {"Type":"Cash","SubType":"NULL"},
17640: {"Type":"Cash","SubType":"NULL"},
17646: {"Type":"Cash","SubType":"NULL"},
17648: {"Type":"Cash","SubType":"NULL"},
17650: {"Type":"Cash","SubType":"NULL"},
17651: {"Type":"Cash","SubType":"NULL"},
17659: {"Type":"Cash","SubType":"NULL"},
17662: {"Type":"Cash","SubType":"NULL"},
17663: {"Type":"Cash","SubType":"NULL"},
17665: {"Type":"Cash","SubType":"NULL"},
17668: {"Type":"Cash","SubType":"NULL"},
17669: {"Type":"Cash","SubType":"NULL"},
17671: {"Type":"Cash","SubType":"NULL"},
17672: {"Type":"Cash","SubType":"NULL"},
17673: {"Type":"Cash","SubType":"NULL"},
17674: {"Type":"Cash","SubType":"NULL"},
17675: {"Type":"Cash","SubType":"NULL"},
17676: {"Type":"Cash","SubType":"NULL"},
17677: {"Type":"Cash","SubType":"NULL"},
17681: {"Type":"Cash","SubType":"NULL"},
17683: {"Type":"Cash","SubType":"NULL"},
17684: {"Type":"Cash","SubType":"NULL"},
17689: {"Type":"Cash","SubType":"NULL"},
17690: {"Type":"Cash","SubType":"NULL"},
17691: {"Type":"Cash","SubType":"NULL"},
17692: {"Type":"Cash","SubType":"NULL"},
17712: {"Type":"Cash","SubType":"NULL"},
17713: {"Type":"Cash","SubType":"NULL"},
17716: {"Type":"Cash","SubType":"NULL"},
17717: {"Type":"Cash","SubType":"NULL"},
17718: {"Type":"Cash","SubType":"NULL"},
17726: {"Type":"Cash","SubType":"NULL"},
17727: {"Type":"Cash","SubType":"NULL"},
17742: {"Type":"Cash","SubType":"NULL"},
17743: {"Type":"Cash","SubType":"NULL"},
17748: {"Type":"Cash","SubType":"NULL"},
17749: {"Type":"Cash","SubType":"NULL"},
17756: {"Type":"Cash","SubType":"NULL"},
17759: {"Type":"Cash","SubType":"NULL"},
17760: {"Type":"Cash","SubType":"NULL"},
17761: {"Type":"Cash","SubType":"NULL"},
17764: {"Type":"Cash","SubType":"NULL"},
17765: {"Type":"Cash","SubType":"NULL"},
17766: {"Type":"Cash","SubType":"NULL"},
17774: {"Type":"Cash","SubType":"NULL"},
17775: {"Type":"Cash","SubType":"NULL"},
17776: {"Type":"Cash","SubType":"NULL"},
17777: {"Type":"Cash","SubType":"NULL"},
17780: {"Type":"Cash","SubType":"NULL"},
17783: {"Type":"Cash","SubType":"NULL"},
17784: {"Type":"Cash","SubType":"NULL"},
17792: {"Type":"Cash","SubType":"NULL"},
17793: {"Type":"Cash","SubType":"NULL"},
17794: {"Type":"Cash","SubType":"NULL"},
17795: {"Type":"Cash","SubType":"NULL"},
17799: {"Type":"Cash","SubType":"NULL"},
17800: {"Type":"Cash","SubType":"NULL"},
17832: {"Type":"Cash","SubType":"NULL"},
17833: {"Type":"Cash","SubType":"NULL"},
17881: {"Type":"Cash","SubType":"NULL"},
17882: {"Type":"Cash","SubType":"NULL"},
17883: {"Type":"Cash","SubType":"NULL"},
17884: {"Type":"Cash","SubType":"NULL"},
17885: {"Type":"Cash","SubType":"NULL"},
17886: {"Type":"Cash","SubType":"NULL"},
17887: {"Type":"Cash","SubType":"NULL"},
17888: {"Type":"Cash","SubType":"NULL"},
17894: {"Type":"Cash","SubType":"NULL"},
17895: {"Type":"Cash","SubType":"NULL"},
17901: {"Type":"Cash","SubType":"NULL"},
17902: {"Type":"Cash","SubType":"NULL"},
17914: {"Type":"Cash","SubType":"NULL"},
17920: {"Type":"Cash","SubType":"NULL"},
17921: {"Type":"Cash","SubType":"NULL"},
17923: {"Type":"Cash","SubType":"NULL"},
17924: {"Type":"Cash","SubType":"NULL"},
17925: {"Type":"Cash","SubType":"NULL"},
17926: {"Type":"Cash","SubType":"NULL"},
17935: {"Type":"Cash","SubType":"NULL"},
17936: {"Type":"Cash","SubType":"NULL"},
17940: {"Type":"Cash","SubType":"NULL"},
17941: {"Type":"Cash","SubType":"NULL"},
17944: {"Type":"Cash","SubType":"NULL"},
17945: {"Type":"Cash","SubType":"NULL"},
17948: {"Type":"Cash","SubType":"NULL"},
17949: {"Type":"Cash","SubType":"NULL"},
17950: {"Type":"Cash","SubType":"NULL"},
17951: {"Type":"Cash","SubType":"NULL"},
17959: {"Type":"Cash","SubType":"NULL"},
17960: {"Type":"Cash","SubType":"NULL"},
17961: {"Type":"Cash","SubType":"NULL"},
17962: {"Type":"Cash","SubType":"NULL"},
17967: {"Type":"Cash","SubType":"NULL"},
17968: {"Type":"Cash","SubType":"NULL"},
17969: {"Type":"Cash","SubType":"NULL"},
17970: {"Type":"Cash","SubType":"NULL"},
17971: {"Type":"Cash","SubType":"NULL"},
17972: {"Type":"Cash","SubType":"NULL"},
17973: {"Type":"Cash","SubType":"NULL"},
17974: {"Type":"Cash","SubType":"NULL"},
17975: {"Type":"Cash","SubType":"NULL"},
17976: {"Type":"Cash","SubType":"NULL"},
17977: {"Type":"Cash","SubType":"NULL"},
17978: {"Type":"Cash","SubType":"NULL"},
17979: {"Type":"Cash","SubType":"NULL"},
17980: {"Type":"Cash","SubType":"NULL"},
17981: {"Type":"Cash","SubType":"NULL"},
17982: {"Type":"Cash","SubType":"NULL"},
17983: {"Type":"Cash","SubType":"NULL"},
17984: {"Type":"Cash","SubType":"NULL"},
17985: {"Type":"Cash","SubType":"NULL"},
17986: {"Type":"Cash","SubType":"NULL"},
17999: {"Type":"Cash","SubType":"NULL"},
18000: {"Type":"Ammo","SubType":"Cannonb"},
18001: {"Type":"Ammo","SubType":"Cannonb"},
18002: {"Type":"Ammo","SubType":"Cannonb"},
18003: {"Type":"Ammo","SubType":"Cannonb"},
18004: {"Type":"Ammo","SubType":"Cannonb"},
18005: {"Type":"Ammo","SubType":"Cannonb"},
18006: {"Type":"Ammo","SubType":"Cannonb"},
18007: {"Type":"Ammo","SubType":"Cannonb"},
18008: {"Type":"Ammo","SubType":"Cannonb"},
18009: {"Type":"Ammo","SubType":"Cannonb"},
18100: {"Type":"Weapon","SubType":"Bow"},
18101: {"Type":"Weapon","SubType":"Bow"},
18102: {"Type":"Weapon","SubType":"Bow"},
18103: {"Type":"Weapon","SubType":"Bow"},
18104: {"Type":"Weapon","SubType":"Bow"},
18105: {"Type":"Weapon","SubType":"Bow"},
18106: {"Type":"Weapon","SubType":"Bow"},
18107: {"Type":"Weapon","SubType":"Bow"},
18108: {"Type":"Weapon","SubType":"Bow"},
18109: {"Type":"Weapon","SubType":"Bow"},
18110: {"Type":"Weapon","SubType":"Bow"},
18111: {"Type":"Weapon","SubType":"Bow"},
18112: {"Type":"Weapon","SubType":"Bow"},
18113: {"Type":"Weapon","SubType":"Bow"},
18114: {"Type":"Weapon","SubType":"Bow"},
18115: {"Type":"Weapon","SubType":"Bow"},
18116: {"Type":"Weapon","SubType":"Bow"},
18117: {"Type":"Weapon","SubType":"Bow"},
18118: {"Type":"Weapon","SubType":"Bow"},
18119: {"Type":"Weapon","SubType":"Bow"},
18120: {"Type":"Weapon","SubType":"Bow"},
18121: {"Type":"Weapon","SubType":"Bow"},
18122: {"Type":"Weapon","SubType":"Bow"},
18123: {"Type":"Weapon","SubType":"Bow"},
18124: {"Type":"Weapon","SubType":"Bow"},
18125: {"Type":"Weapon","SubType":"Bow"},
18126: {"Type":"Weapon","SubType":"Bow"},
18127: {"Type":"Weapon","SubType":"Bow"},
18128: {"Type":"Weapon","SubType":"Bow"},
18129: {"Type":"Weapon","SubType":"Bow"},
18130: {"Type":"Weapon","SubType":"Bow"},
18132: {"Type":"Weapon","SubType":"Bow"},
18133: {"Type":"Weapon","SubType":"Bow"},
18137: {"Type":"Weapon","SubType":"Bow"},
18138: {"Type":"Weapon","SubType":"Bow"},
18139: {"Type":"Weapon","SubType":"Bow"},
18140: {"Type":"Weapon","SubType":"Bow"},
18141: {"Type":"Weapon","SubType":"Bow"},
18142: {"Type":"Weapon","SubType":"Bow"},
18143: {"Type":"Weapon","SubType":"Bow"},
18144: {"Type":"Weapon","SubType":"Bow"},
18145: {"Type":"Weapon","SubType":"Bow"},
18146: {"Type":"Weapon","SubType":"Bow"},
18147: {"Type":"Weapon","SubType":"Bow"},
18148: {"Type":"Weapon","SubType":"Bow"},
18149: {"Type":"Weapon","SubType":"Bow"},
18150: {"Type":"Weapon","SubType":"Bow"},
18151: {"Type":"Weapon","SubType":"Bow"},
18153: {"Type":"Weapon","SubType":"Bow"},
18154: {"Type":"Weapon","SubType":"Bow"},
18155: {"Type":"Weapon","SubType":"Bow"},
18163: {"Type":"Weapon","SubType":"Bow"},
18164: {"Type":"Weapon","SubType":"Bow"},
18165: {"Type":"Weapon","SubType":"Bow"},
18166: {"Type":"Weapon","SubType":"Bow"},
18170: {"Type":"Weapon","SubType":"Bow"},
18172: {"Type":"Weapon","SubType":"Bow"},
18173: {"Type":"Weapon","SubType":"Bow"},
18174: {"Type":"Weapon","SubType":"Bow"},
18175: {"Type":"Weapon","SubType":"Bow"},
18176: {"Type":"Weapon","SubType":"Bow"},
18177: {"Type":"Weapon","SubType":"Bow"},
18178: {"Type":"Weapon","SubType":"Bow"},
18179: {"Type":"Weapon","SubType":"Bow"},
18180: {"Type":"Weapon","SubType":"Bow"},
18182: {"Type":"Weapon","SubType":"Bow"},
18183: {"Type":"Weapon","SubType":"Bow"},
18184: {"Type":"Weapon","SubType":"Bow"},
18185: {"Type":"Weapon","SubType":"Bow"},
18186: {"Type":"Weapon","SubType":"Bow"},
18187: {"Type":"Weapon","SubType":"Bow"},
18188: {"Type":"Weapon","SubType":"Bow"},
18190: {"Type":"Weapon","SubType":"Bow"},
18191: {"Type":"Weapon","SubType":"Bow"},
18193: {"Type":"Weapon","SubType":"Bow"},
18194: {"Type":"Weapon","SubType":"Bow"},
18195: {"Type":"Weapon","SubType":"Bow"},
18196: {"Type":"Weapon","SubType":"Bow"},
18197: {"Type":"Weapon","SubType":"Bow"},
18198: {"Type":"Weapon","SubType":"Bow"},
18200: {"Type":"Weapon","SubType":"Bow"},
18201: {"Type":"Weapon","SubType":"Bow"},
18202: {"Type":"Weapon","SubType":"Bow"},
18500: {"Type":"Armor","SubType":"NULL"},
18501: {"Type":"Armor","SubType":"NULL"},
18502: {"Type":"Armor","SubType":"NULL"},
18503: {"Type":"Armor","SubType":"NULL"},
18504: {"Type":"Armor","SubType":"NULL"},
18505: {"Type":"Armor","SubType":"NULL"},
18506: {"Type":"Armor","SubType":"NULL"},
18507: {"Type":"Armor","SubType":"NULL"},
18508: {"Type":"Armor","SubType":"NULL"},
18509: {"Type":"Armor","SubType":"NULL"},
18510: {"Type":"Armor","SubType":"NULL"},
18511: {"Type":"Armor","SubType":"NULL"},
18512: {"Type":"Armor","SubType":"NULL"},
18513: {"Type":"Armor","SubType":"NULL"},
18514: {"Type":"Armor","SubType":"NULL"},
18515: {"Type":"Armor","SubType":"NULL"},
18516: {"Type":"Armor","SubType":"NULL"},
18517: {"Type":"Armor","SubType":"NULL"},
18518: {"Type":"Armor","SubType":"NULL"},
18519: {"Type":"Armor","SubType":"NULL"},
18520: {"Type":"Armor","SubType":"NULL"},
18521: {"Type":"Armor","SubType":"NULL"},
18522: {"Type":"Armor","SubType":"NULL"},
18523: {"Type":"Armor","SubType":"NULL"},
18524: {"Type":"Armor","SubType":"NULL"},
18525: {"Type":"Armor","SubType":"NULL"},
18526: {"Type":"Armor","SubType":"NULL"},
18527: {"Type":"Armor","SubType":"NULL"},
18528: {"Type":"Armor","SubType":"NULL"},
18529: {"Type":"Armor","SubType":"NULL"},
18530: {"Type":"Armor","SubType":"NULL"},
18531: {"Type":"Armor","SubType":"NULL"},
18532: {"Type":"Armor","SubType":"NULL"},
18533: {"Type":"Armor","SubType":"NULL"},
18534: {"Type":"Armor","SubType":"NULL"},
18535: {"Type":"Armor","SubType":"NULL"},
18536: {"Type":"Armor","SubType":"NULL"},
18537: {"Type":"Armor","SubType":"NULL"},
18538: {"Type":"Armor","SubType":"NULL"},
18539: {"Type":"Armor","SubType":"NULL"},
18540: {"Type":"Armor","SubType":"NULL"},
18541: {"Type":"Armor","SubType":"NULL"},
18542: {"Type":"Armor","SubType":"NULL"},
18543: {"Type":"Armor","SubType":"NULL"},
18544: {"Type":"Armor","SubType":"NULL"},
18545: {"Type":"Armor","SubType":"NULL"},
18546: {"Type":"Armor","SubType":"NULL"},
18547: {"Type":"Armor","SubType":"NULL"},
18548: {"Type":"Armor","SubType":"NULL"},
18549: {"Type":"Armor","SubType":"NULL"},
18550: {"Type":"Armor","SubType":"NULL"},
18551: {"Type":"Armor","SubType":"NULL"},
18552: {"Type":"Armor","SubType":"NULL"},
18553: {"Type":"Armor","SubType":"NULL"},
18554: {"Type":"Armor","SubType":"NULL"},
18555: {"Type":"Armor","SubType":"NULL"},
18556: {"Type":"Armor","SubType":"NULL"},
18557: {"Type":"Armor","SubType":"NULL"},
18558: {"Type":"Armor","SubType":"NULL"},
18559: {"Type":"Armor","SubType":"NULL"},
18560: {"Type":"Armor","SubType":"NULL"},
18561: {"Type":"Armor","SubType":"NULL"},
18562: {"Type":"Armor","SubType":"NULL"},
18563: {"Type":"Armor","SubType":"NULL"},
18564: {"Type":"Armor","SubType":"NULL"},
18565: {"Type":"Armor","SubType":"NULL"},
18566: {"Type":"Armor","SubType":"NULL"},
18567: {"Type":"Armor","SubType":"NULL"},
18568: {"Type":"Armor","SubType":"NULL"},
18569: {"Type":"Armor","SubType":"NULL"},
18570: {"Type":"Armor","SubType":"NULL"},
18571: {"Type":"Armor","SubType":"NULL"},
18572: {"Type":"Armor","SubType":"NULL"},
18573: {"Type":"Armor","SubType":"NULL"},
18574: {"Type":"Armor","SubType":"NULL"},
18575: {"Type":"Armor","SubType":"NULL"},
18576: {"Type":"Armor","SubType":"NULL"},
18577: {"Type":"Armor","SubType":"NULL"},
18578: {"Type":"Armor","SubType":"NULL"},
18579: {"Type":"Armor","SubType":"NULL"},
18580: {"Type":"Armor","SubType":"NULL"},
18581: {"Type":"Armor","SubType":"NULL"},
18582: {"Type":"Armor","SubType":"NULL"},
18583: {"Type":"Armor","SubType":"NULL"},
18584: {"Type":"Armor","SubType":"NULL"},
18585: {"Type":"Armor","SubType":"NULL"},
18586: {"Type":"Armor","SubType":"NULL"},
18587: {"Type":"Armor","SubType":"NULL"},
18588: {"Type":"Armor","SubType":"NULL"},
18589: {"Type":"Armor","SubType":"NULL"},
18590: {"Type":"Armor","SubType":"NULL"},
18591: {"Type":"Armor","SubType":"NULL"},
18592: {"Type":"Armor","SubType":"NULL"},
18593: {"Type":"Armor","SubType":"NULL"},
18594: {"Type":"Armor","SubType":"NULL"},
18595: {"Type":"Armor","SubType":"NULL"},
18596: {"Type":"Armor","SubType":"NULL"},
18597: {"Type":"Armor","SubType":"NULL"},
18598: {"Type":"Armor","SubType":"NULL"},
18599: {"Type":"Armor","SubType":"NULL"},
18600: {"Type":"Armor","SubType":"NULL"},
18601: {"Type":"Armor","SubType":"NULL"},
18602: {"Type":"Armor","SubType":"NULL"},
18603: {"Type":"Armor","SubType":"NULL"},
18604: {"Type":"Armor","SubType":"NULL"},
18605: {"Type":"Armor","SubType":"NULL"},
18606: {"Type":"Armor","SubType":"NULL"},
18607: {"Type":"Armor","SubType":"NULL"},
18608: {"Type":"Armor","SubType":"NULL"},
18609: {"Type":"Armor","SubType":"NULL"},
18610: {"Type":"Armor","SubType":"NULL"},
18611: {"Type":"Armor","SubType":"NULL"},
18612: {"Type":"Armor","SubType":"NULL"},
18613: {"Type":"Armor","SubType":"NULL"},
18614: {"Type":"Armor","SubType":"NULL"},
18615: {"Type":"Armor","SubType":"NULL"},
18616: {"Type":"Armor","SubType":"NULL"},
18617: {"Type":"Armor","SubType":"NULL"},
18618: {"Type":"Armor","SubType":"NULL"},
18619: {"Type":"Armor","SubType":"NULL"},
18620: {"Type":"Armor","SubType":"NULL"},
18621: {"Type":"Armor","SubType":"NULL"},
18622: {"Type":"Armor","SubType":"NULL"},
18623: {"Type":"Armor","SubType":"NULL"},
18624: {"Type":"Armor","SubType":"NULL"},
18625: {"Type":"Armor","SubType":"NULL"},
18626: {"Type":"Armor","SubType":"NULL"},
18627: {"Type":"Armor","SubType":"NULL"},
18628: {"Type":"Armor","SubType":"NULL"},
18629: {"Type":"Armor","SubType":"NULL"},
18630: {"Type":"Armor","SubType":"NULL"},
18631: {"Type":"Armor","SubType":"NULL"},
18632: {"Type":"Armor","SubType":"NULL"},
18633: {"Type":"Armor","SubType":"NULL"},
18634: {"Type":"Armor","SubType":"NULL"},
18635: {"Type":"Armor","SubType":"NULL"},
18636: {"Type":"Armor","SubType":"NULL"},
18637: {"Type":"Armor","SubType":"NULL"},
18638: {"Type":"Armor","SubType":"NULL"},
18639: {"Type":"Armor","SubType":"NULL"},
18640: {"Type":"Armor","SubType":"NULL"},
18641: {"Type":"Armor","SubType":"NULL"},
18642: {"Type":"Armor","SubType":"NULL"},
18643: {"Type":"Armor","SubType":"NULL"},
18644: {"Type":"Armor","SubType":"NULL"},
18645: {"Type":"Armor","SubType":"NULL"},
18646: {"Type":"Armor","SubType":"NULL"},
18647: {"Type":"Armor","SubType":"NULL"},
18648: {"Type":"Armor","SubType":"NULL"},
18649: {"Type":"Armor","SubType":"NULL"},
18650: {"Type":"Armor","SubType":"NULL"},
18651: {"Type":"Armor","SubType":"NULL"},
18652: {"Type":"Armor","SubType":"NULL"},
18653: {"Type":"Armor","SubType":"NULL"},
18655: {"Type":"Armor","SubType":"NULL"},
18656: {"Type":"Armor","SubType":"NULL"},
18657: {"Type":"Armor","SubType":"NULL"},
18658: {"Type":"Armor","SubType":"NULL"},
18659: {"Type":"Armor","SubType":"NULL"},
18660: {"Type":"Armor","SubType":"NULL"},
18661: {"Type":"Armor","SubType":"NULL"},
18662: {"Type":"Armor","SubType":"NULL"},
18663: {"Type":"Armor","SubType":"NULL"},
18664: {"Type":"Armor","SubType":"NULL"},
18665: {"Type":"Armor","SubType":"NULL"},
18666: {"Type":"Armor","SubType":"NULL"},
18667: {"Type":"Armor","SubType":"NULL"},
18668: {"Type":"Armor","SubType":"NULL"},
18669: {"Type":"Armor","SubType":"NULL"},
18670: {"Type":"Armor","SubType":"NULL"},
18671: {"Type":"Armor","SubType":"NULL"},
18672: {"Type":"Armor","SubType":"NULL"},
18673: {"Type":"Armor","SubType":"NULL"},
18674: {"Type":"Armor","SubType":"NULL"},
18675: {"Type":"Armor","SubType":"NULL"},
18676: {"Type":"Armor","SubType":"NULL"},
18677: {"Type":"Armor","SubType":"NULL"},
18678: {"Type":"Armor","SubType":"NULL"},
18679: {"Type":"Armor","SubType":"NULL"},
18680: {"Type":"Armor","SubType":"NULL"},
18681: {"Type":"Armor","SubType":"NULL"},
18682: {"Type":"Armor","SubType":"NULL"},
18683: {"Type":"Armor","SubType":"NULL"},
18684: {"Type":"Armor","SubType":"NULL"},
18685: {"Type":"Armor","SubType":"NULL"},
18686: {"Type":"Armor","SubType":"NULL"},
18687: {"Type":"Armor","SubType":"NULL"},
18688: {"Type":"Armor","SubType":"NULL"},
18689: {"Type":"Armor","SubType":"NULL"},
18690: {"Type":"Armor","SubType":"NULL"},
18691: {"Type":"Armor","SubType":"NULL"},
18692: {"Type":"Armor","SubType":"NULL"},
18693: {"Type":"Armor","SubType":"NULL"},
18694: {"Type":"Armor","SubType":"NULL"},
18695: {"Type":"Armor","SubType":"NULL"},
18696: {"Type":"Armor","SubType":"NULL"},
18697: {"Type":"Armor","SubType":"NULL"},
18698: {"Type":"Armor","SubType":"NULL"},
18699: {"Type":"Armor","SubType":"NULL"},
18700: {"Type":"Armor","SubType":"NULL"},
18701: {"Type":"Armor","SubType":"NULL"},
18702: {"Type":"Armor","SubType":"NULL"},
18703: {"Type":"Armor","SubType":"NULL"},
18704: {"Type":"Armor","SubType":"NULL"},
18705: {"Type":"Armor","SubType":"NULL"},
18706: {"Type":"Armor","SubType":"NULL"},
18707: {"Type":"Armor","SubType":"NULL"},
18708: {"Type":"Armor","SubType":"NULL"},
18709: {"Type":"Armor","SubType":"NULL"},
18710: {"Type":"Armor","SubType":"NULL"},
18711: {"Type":"Armor","SubType":"NULL"},
18712: {"Type":"Armor","SubType":"NULL"},
18713: {"Type":"Armor","SubType":"NULL"},
18714: {"Type":"Armor","SubType":"NULL"},
18715: {"Type":"Armor","SubType":"NULL"},
18716: {"Type":"Armor","SubType":"NULL"},
18718: {"Type":"Armor","SubType":"NULL"},
18720: {"Type":"Armor","SubType":"NULL"},
18724: {"Type":"Armor","SubType":"NULL"},
18725: {"Type":"Armor","SubType":"NULL"},
18726: {"Type":"Armor","SubType":"NULL"},
18727: {"Type":"Armor","SubType":"NULL"},
18728: {"Type":"Armor","SubType":"NULL"},
18729: {"Type":"Armor","SubType":"NULL"},
18730: {"Type":"Armor","SubType":"NULL"},
18731: {"Type":"Armor","SubType":"NULL"},
18732: {"Type":"Armor","SubType":"NULL"},
18733: {"Type":"Armor","SubType":"NULL"},
18734: {"Type":"Armor","SubType":"NULL"},
18735: {"Type":"Armor","SubType":"NULL"},
18736: {"Type":"Armor","SubType":"NULL"},
18737: {"Type":"Armor","SubType":"NULL"},
18738: {"Type":"Armor","SubType":"NULL"},
18739: {"Type":"Armor","SubType":"NULL"},
18740: {"Type":"Armor","SubType":"NULL"},
18741: {"Type":"Armor","SubType":"NULL"},
18742: {"Type":"Armor","SubType":"NULL"},
18743: {"Type":"Armor","SubType":"NULL"},
18744: {"Type":"Armor","SubType":"NULL"},
18745: {"Type":"Armor","SubType":"NULL"},
18746: {"Type":"Armor","SubType":"NULL"},
18747: {"Type":"Armor","SubType":"NULL"},
18748: {"Type":"Armor","SubType":"NULL"},
18749: {"Type":"Armor","SubType":"NULL"},
18750: {"Type":"Armor","SubType":"NULL"},
18751: {"Type":"Armor","SubType":"NULL"},
18752: {"Type":"Armor","SubType":"NULL"},
18753: {"Type":"Armor","SubType":"NULL"},
18754: {"Type":"Armor","SubType":"NULL"},
18755: {"Type":"Armor","SubType":"NULL"},
18756: {"Type":"Armor","SubType":"NULL"},
18758: {"Type":"Armor","SubType":"NULL"},
18759: {"Type":"Armor","SubType":"NULL"},
18760: {"Type":"Armor","SubType":"NULL"},
18761: {"Type":"Armor","SubType":"NULL"},
18762: {"Type":"Armor","SubType":"NULL"},
18763: {"Type":"Armor","SubType":"NULL"},
18764: {"Type":"Armor","SubType":"NULL"},
18765: {"Type":"Armor","SubType":"NULL"},
18766: {"Type":"Armor","SubType":"NULL"},
18767: {"Type":"Armor","SubType":"NULL"},
18768: {"Type":"Armor","SubType":"NULL"},
18769: {"Type":"Armor","SubType":"NULL"},
18770: {"Type":"Armor","SubType":"NULL"},
18771: {"Type":"Armor","SubType":"NULL"},
18772: {"Type":"Armor","SubType":"NULL"},
18773: {"Type":"Armor","SubType":"NULL"},
18774: {"Type":"Armor","SubType":"NULL"},
18775: {"Type":"Armor","SubType":"NULL"},
18776: {"Type":"Armor","SubType":"NULL"},
18777: {"Type":"Armor","SubType":"NULL"},
18778: {"Type":"Armor","SubType":"NULL"},
18779: {"Type":"Armor","SubType":"NULL"},
18780: {"Type":"Armor","SubType":"NULL"},
18781: {"Type":"Armor","SubType":"NULL"},
18782: {"Type":"Armor","SubType":"NULL"},
18783: {"Type":"Armor","SubType":"NULL"},
18784: {"Type":"Armor","SubType":"NULL"},
18785: {"Type":"Armor","SubType":"NULL"},
18786: {"Type":"Armor","SubType":"NULL"},
18787: {"Type":"Armor","SubType":"NULL"},
18788: {"Type":"Armor","SubType":"NULL"},
18789: {"Type":"Armor","SubType":"NULL"},
18790: {"Type":"Armor","SubType":"NULL"},
18791: {"Type":"Armor","SubType":"NULL"},
18792: {"Type":"Armor","SubType":"NULL"},
18793: {"Type":"Armor","SubType":"NULL"},
18796: {"Type":"Armor","SubType":"NULL"},
18797: {"Type":"Armor","SubType":"NULL"},
18798: {"Type":"Armor","SubType":"NULL"},
18799: {"Type":"Armor","SubType":"NULL"},
18801: {"Type":"Armor","SubType":"NULL"},
18802: {"Type":"Armor","SubType":"NULL"},
18803: {"Type":"Armor","SubType":"NULL"},
18804: {"Type":"Armor","SubType":"NULL"},
18805: {"Type":"Armor","SubType":"NULL"},
18806: {"Type":"Armor","SubType":"NULL"},
18807: {"Type":"Armor","SubType":"NULL"},
18808: {"Type":"Armor","SubType":"NULL"},
18809: {"Type":"Armor","SubType":"NULL"},
18810: {"Type":"Armor","SubType":"NULL"},
18811: {"Type":"Armor","SubType":"NULL"},
18812: {"Type":"Armor","SubType":"NULL"},
18813: {"Type":"Armor","SubType":"NULL"},
18814: {"Type":"Armor","SubType":"NULL"},
18815: {"Type":"Armor","SubType":"NULL"},
18816: {"Type":"Armor","SubType":"NULL"},
18817: {"Type":"Armor","SubType":"NULL"},
18818: {"Type":"Armor","SubType":"NULL"},
18819: {"Type":"Armor","SubType":"NULL"},
18820: {"Type":"Armor","SubType":"NULL"},
18821: {"Type":"Armor","SubType":"NULL"},
18822: {"Type":"Armor","SubType":"NULL"},
18823: {"Type":"Armor","SubType":"NULL"},
18824: {"Type":"Armor","SubType":"NULL"},
18825: {"Type":"Armor","SubType":"NULL"},
18827: {"Type":"Armor","SubType":"NULL"},
18828: {"Type":"Armor","SubType":"NULL"},
18829: {"Type":"Armor","SubType":"NULL"},
18830: {"Type":"Armor","SubType":"NULL"},
18831: {"Type":"Armor","SubType":"NULL"},
18832: {"Type":"Armor","SubType":"NULL"},
18833: {"Type":"Armor","SubType":"NULL"},
18834: {"Type":"Armor","SubType":"NULL"},
18838: {"Type":"Armor","SubType":"NULL"},
18839: {"Type":"Armor","SubType":"NULL"},
18841: {"Type":"Armor","SubType":"NULL"},
18842: {"Type":"Armor","SubType":"NULL"},
18843: {"Type":"Armor","SubType":"NULL"},
18844: {"Type":"Armor","SubType":"NULL"},
18845: {"Type":"Armor","SubType":"NULL"},
18846: {"Type":"Armor","SubType":"NULL"},
18847: {"Type":"Armor","SubType":"NULL"},
18848: {"Type":"Armor","SubType":"NULL"},
18849: {"Type":"Armor","SubType":"NULL"},
18850: {"Type":"Armor","SubType":"NULL"},
18851: {"Type":"Armor","SubType":"NULL"},
18852: {"Type":"Armor","SubType":"NULL"},
18853: {"Type":"Armor","SubType":"NULL"},
18854: {"Type":"Armor","SubType":"NULL"},
18855: {"Type":"Armor","SubType":"NULL"},
18856: {"Type":"Armor","SubType":"NULL"},
18857: {"Type":"Armor","SubType":"NULL"},
18858: {"Type":"Armor","SubType":"NULL"},
18859: {"Type":"Armor","SubType":"NULL"},
18860: {"Type":"Armor","SubType":"NULL"},
18861: {"Type":"Armor","SubType":"NULL"},
18862: {"Type":"Armor","SubType":"NULL"},
18863: {"Type":"Armor","SubType":"NULL"},
18864: {"Type":"Armor","SubType":"NULL"},
18865: {"Type":"Armor","SubType":"NULL"},
18866: {"Type":"Armor","SubType":"NULL"},
18867: {"Type":"Armor","SubType":"NULL"},
18868: {"Type":"Armor","SubType":"NULL"},
18869: {"Type":"Armor","SubType":"NULL"},
18870: {"Type":"Armor","SubType":"NULL"},
18871: {"Type":"Armor","SubType":"NULL"},
18872: {"Type":"Armor","SubType":"NULL"},
18873: {"Type":"Armor","SubType":"NULL"},
18874: {"Type":"Armor","SubType":"NULL"},
18877: {"Type":"Armor","SubType":"NULL"},
18878: {"Type":"Armor","SubType":"NULL"},
18879: {"Type":"Armor","SubType":"NULL"},
18880: {"Type":"Armor","SubType":"NULL"},
18881: {"Type":"Armor","SubType":"NULL"},
18882: {"Type":"Armor","SubType":"NULL"},
18883: {"Type":"Armor","SubType":"NULL"},
18884: {"Type":"Armor","SubType":"NULL"},
18885: {"Type":"Armor","SubType":"NULL"},
18887: {"Type":"Armor","SubType":"NULL"},
18888: {"Type":"Armor","SubType":"NULL"},
18889: {"Type":"Armor","SubType":"NULL"},
18890: {"Type":"Armor","SubType":"NULL"},
18891: {"Type":"Armor","SubType":"NULL"},
18892: {"Type":"Armor","SubType":"NULL"},
18893: {"Type":"Armor","SubType":"NULL"},
18894: {"Type":"Armor","SubType":"NULL"},
18895: {"Type":"Armor","SubType":"NULL"},
18896: {"Type":"Armor","SubType":"NULL"},
18897: {"Type":"Armor","SubType":"NULL"},
18898: {"Type":"Armor","SubType":"NULL"},
18900: {"Type":"Armor","SubType":"NULL"},
18901: {"Type":"Armor","SubType":"NULL"},
18902: {"Type":"Armor","SubType":"NULL"},
18903: {"Type":"Armor","SubType":"NULL"},
18904: {"Type":"Armor","SubType":"NULL"},
18905: {"Type":"Armor","SubType":"NULL"},
18906: {"Type":"Armor","SubType":"NULL"},
18908: {"Type":"Armor","SubType":"NULL"},
18909: {"Type":"Armor","SubType":"NULL"},
18910: {"Type":"Armor","SubType":"NULL"},
18912: {"Type":"Armor","SubType":"NULL"},
18913: {"Type":"Armor","SubType":"NULL"},
18914: {"Type":"Armor","SubType":"NULL"},
18915: {"Type":"Armor","SubType":"NULL"},
18916: {"Type":"Armor","SubType":"NULL"},
18917: {"Type":"Armor","SubType":"NULL"},
18918: {"Type":"Armor","SubType":"NULL"},
18919: {"Type":"Armor","SubType":"NULL"},
18920: {"Type":"Armor","SubType":"NULL"},
18921: {"Type":"Armor","SubType":"NULL"},
18922: {"Type":"Armor","SubType":"NULL"},
18923: {"Type":"Armor","SubType":"NULL"},
18924: {"Type":"Armor","SubType":"NULL"},
18925: {"Type":"Armor","SubType":"NULL"},
18926: {"Type":"Armor","SubType":"NULL"},
18929: {"Type":"Armor","SubType":"NULL"},
18930: {"Type":"Armor","SubType":"NULL"},
18931: {"Type":"Armor","SubType":"NULL"},
18932: {"Type":"Armor","SubType":"NULL"},
18933: {"Type":"Armor","SubType":"NULL"},
18934: {"Type":"Armor","SubType":"NULL"},
18935: {"Type":"Armor","SubType":"NULL"},
18936: {"Type":"Armor","SubType":"NULL"},
18937: {"Type":"Armor","SubType":"NULL"},
18938: {"Type":"Armor","SubType":"NULL"},
18939: {"Type":"Armor","SubType":"NULL"},
18940: {"Type":"Armor","SubType":"NULL"},
18941: {"Type":"Armor","SubType":"NULL"},
18942: {"Type":"Armor","SubType":"NULL"},
18943: {"Type":"Armor","SubType":"NULL"},
18947: {"Type":"Armor","SubType":"NULL"},
18948: {"Type":"Armor","SubType":"NULL"},
18949: {"Type":"Armor","SubType":"NULL"},
18950: {"Type":"Armor","SubType":"NULL"},
18954: {"Type":"Armor","SubType":"NULL"},
18955: {"Type":"Armor","SubType":"NULL"},
18956: {"Type":"Armor","SubType":"NULL"},
18959: {"Type":"Armor","SubType":"NULL"},
18960: {"Type":"Armor","SubType":"NULL"},
18962: {"Type":"Armor","SubType":"NULL"},
18965: {"Type":"Armor","SubType":"NULL"},
18968: {"Type":"Armor","SubType":"NULL"},
18969: {"Type":"Armor","SubType":"NULL"},
18970: {"Type":"Armor","SubType":"NULL"},
18971: {"Type":"Armor","SubType":"NULL"},
18972: {"Type":"Armor","SubType":"NULL"},
18973: {"Type":"Armor","SubType":"NULL"},
18974: {"Type":"Armor","SubType":"NULL"},
18975: {"Type":"Armor","SubType":"NULL"},
18976: {"Type":"Armor","SubType":"NULL"},
18977: {"Type":"Armor","SubType":"NULL"},
18978: {"Type":"Armor","SubType":"NULL"},
18979: {"Type":"Armor","SubType":"NULL"},
18980: {"Type":"Armor","SubType":"NULL"},
18981: {"Type":"Armor","SubType":"NULL"},
18982: {"Type":"Armor","SubType":"NULL"},
18983: {"Type":"Armor","SubType":"NULL"},
18984: {"Type":"Armor","SubType":"NULL"},
18985: {"Type":"Armor","SubType":"NULL"},
18987: {"Type":"Armor","SubType":"NULL"},
18992: {"Type":"Armor","SubType":"NULL"},
18993: {"Type":"Armor","SubType":"NULL"},
18997: {"Type":"Armor","SubType":"NULL"},
19004: {"Type":"Armor","SubType":"NULL"},
19006: {"Type":"Armor","SubType":"NULL"},
19010: {"Type":"Armor","SubType":"NULL"},
19011: {"Type":"Armor","SubType":"NULL"},
19014: {"Type":"Armor","SubType":"NULL"},
19015: {"Type":"Armor","SubType":"NULL"},
19018: {"Type":"Armor","SubType":"NULL"},
19019: {"Type":"Armor","SubType":"NULL"},
19020: {"Type":"Armor","SubType":"NULL"},
19021: {"Type":"Armor","SubType":"NULL"},
19022: {"Type":"Armor","SubType":"NULL"},
19023: {"Type":"Armor","SubType":"NULL"},
19024: {"Type":"Armor","SubType":"NULL"},
19025: {"Type":"Armor","SubType":"NULL"},
19026: {"Type":"Armor","SubType":"NULL"},
19027: {"Type":"Armor","SubType":"NULL"},
19028: {"Type":"Armor","SubType":"NULL"},
19030: {"Type":"Armor","SubType":"NULL"},
19031: {"Type":"Armor","SubType":"NULL"},
19033: {"Type":"Armor","SubType":"NULL"},
19034: {"Type":"Armor","SubType":"NULL"},
19035: {"Type":"Armor","SubType":"NULL"},
19036: {"Type":"Armor","SubType":"NULL"},
19037: {"Type":"Armor","SubType":"NULL"},
19038: {"Type":"Armor","SubType":"NULL"},
19039: {"Type":"Armor","SubType":"NULL"},
19041: {"Type":"Armor","SubType":"NULL"},
19042: {"Type":"Armor","SubType":"NULL"},
19043: {"Type":"Armor","SubType":"NULL"},
19044: {"Type":"Armor","SubType":"NULL"},
19045: {"Type":"Armor","SubType":"NULL"},
19046: {"Type":"Armor","SubType":"NULL"},
19047: {"Type":"Armor","SubType":"NULL"},
19048: {"Type":"Armor","SubType":"NULL"},
19050: {"Type":"Armor","SubType":"NULL"},
19051: {"Type":"Armor","SubType":"NULL"},
19052: {"Type":"Armor","SubType":"NULL"},
19053: {"Type":"Armor","SubType":"NULL"},
19079: {"Type":"Armor","SubType":"NULL"},
19080: {"Type":"Armor","SubType":"NULL"},
19081: {"Type":"Armor","SubType":"NULL"},
19082: {"Type":"Armor","SubType":"NULL"},
19083: {"Type":"Armor","SubType":"NULL"},
19084: {"Type":"Armor","SubType":"NULL"},
19085: {"Type":"Armor","SubType":"NULL"},
19086: {"Type":"Armor","SubType":"NULL"},
19087: {"Type":"Armor","SubType":"NULL"},
19088: {"Type":"Armor","SubType":"NULL"},
19089: {"Type":"Armor","SubType":"NULL"},
19090: {"Type":"Armor","SubType":"NULL"},
19091: {"Type":"Armor","SubType":"NULL"},
19092: {"Type":"Armor","SubType":"NULL"},
19093: {"Type":"Armor","SubType":"NULL"},
19094: {"Type":"Armor","SubType":"NULL"},
19095: {"Type":"Armor","SubType":"NULL"},
19096: {"Type":"Armor","SubType":"NULL"},
19097: {"Type":"Armor","SubType":"NULL"},
19098: {"Type":"Armor","SubType":"NULL"},
19101: {"Type":"Armor","SubType":"NULL"},
19102: {"Type":"Armor","SubType":"NULL"},
19103: {"Type":"Armor","SubType":"NULL"},
19104: {"Type":"Armor","SubType":"NULL"},
19105: {"Type":"Armor","SubType":"NULL"},
19106: {"Type":"Armor","SubType":"NULL"},
19107: {"Type":"Armor","SubType":"NULL"},
19108: {"Type":"Armor","SubType":"NULL"},
19109: {"Type":"Armor","SubType":"NULL"},
19110: {"Type":"Armor","SubType":"NULL"},
19111: {"Type":"Armor","SubType":"NULL"},
19112: {"Type":"Armor","SubType":"NULL"},
19113: {"Type":"Armor","SubType":"NULL"},
19114: {"Type":"Armor","SubType":"NULL"},
19115: {"Type":"Armor","SubType":"NULL"},
19116: {"Type":"Armor","SubType":"NULL"},
19117: {"Type":"Armor","SubType":"NULL"},
19118: {"Type":"Armor","SubType":"NULL"},
19119: {"Type":"Armor","SubType":"NULL"},
19125: {"Type":"Armor","SubType":"NULL"},
19126: {"Type":"Armor","SubType":"NULL"},
19127: {"Type":"Armor","SubType":"NULL"},
19128: {"Type":"Armor","SubType":"NULL"},
19129: {"Type":"Armor","SubType":"NULL"},
19130: {"Type":"Armor","SubType":"NULL"},
19131: {"Type":"Armor","SubType":"NULL"},
19132: {"Type":"Armor","SubType":"NULL"},
19133: {"Type":"Armor","SubType":"NULL"},
19134: {"Type":"Armor","SubType":"NULL"},
19135: {"Type":"Armor","SubType":"NULL"},
19136: {"Type":"Armor","SubType":"NULL"},
19137: {"Type":"Armor","SubType":"NULL"},
19138: {"Type":"Armor","SubType":"NULL"},
19139: {"Type":"Armor","SubType":"NULL"},
19140: {"Type":"Armor","SubType":"NULL"},
19141: {"Type":"Armor","SubType":"NULL"},
19142: {"Type":"Armor","SubType":"NULL"},
19143: {"Type":"Armor","SubType":"NULL"},
19144: {"Type":"Armor","SubType":"NULL"},
19145: {"Type":"Armor","SubType":"NULL"},
19146: {"Type":"Armor","SubType":"NULL"},
19147: {"Type":"Armor","SubType":"NULL"},
19148: {"Type":"Armor","SubType":"NULL"},
19149: {"Type":"Armor","SubType":"NULL"},
19150: {"Type":"Armor","SubType":"NULL"},
19151: {"Type":"Armor","SubType":"NULL"},
19152: {"Type":"Armor","SubType":"NULL"},
19153: {"Type":"Armor","SubType":"NULL"},
19154: {"Type":"Armor","SubType":"NULL"},
19155: {"Type":"Armor","SubType":"NULL"},
19156: {"Type":"Armor","SubType":"NULL"},
19157: {"Type":"Armor","SubType":"NULL"},
19158: {"Type":"Armor","SubType":"NULL"},
19159: {"Type":"Armor","SubType":"NULL"},
19162: {"Type":"Armor","SubType":"NULL"},
19163: {"Type":"Armor","SubType":"NULL"},
19164: {"Type":"Armor","SubType":"NULL"},
19165: {"Type":"Armor","SubType":"NULL"},
19166: {"Type":"Armor","SubType":"NULL"},
19168: {"Type":"Armor","SubType":"NULL"},
19169: {"Type":"Armor","SubType":"NULL"},
19170: {"Type":"Armor","SubType":"NULL"},
19171: {"Type":"Armor","SubType":"NULL"},
19172: {"Type":"Armor","SubType":"NULL"},
19173: {"Type":"Armor","SubType":"NULL"},
19174: {"Type":"Armor","SubType":"NULL"},
19175: {"Type":"Armor","SubType":"NULL"},
19176: {"Type":"Armor","SubType":"NULL"},
19177: {"Type":"Armor","SubType":"NULL"},
19178: {"Type":"Armor","SubType":"NULL"},
19179: {"Type":"Armor","SubType":"NULL"},
19180: {"Type":"Armor","SubType":"NULL"},
19181: {"Type":"Armor","SubType":"NULL"},
19185: {"Type":"Armor","SubType":"NULL"},
19189: {"Type":"Armor","SubType":"NULL"},
19190: {"Type":"Armor","SubType":"NULL"},
19191: {"Type":"Armor","SubType":"NULL"},
19192: {"Type":"Armor","SubType":"NULL"},
19193: {"Type":"Armor","SubType":"NULL"},
19194: {"Type":"Armor","SubType":"NULL"},
19195: {"Type":"Armor","SubType":"NULL"},
19196: {"Type":"Armor","SubType":"NULL"},
19197: {"Type":"Armor","SubType":"NULL"},
19198: {"Type":"Armor","SubType":"NULL"},
19199: {"Type":"Armor","SubType":"NULL"},
19200: {"Type":"Armor","SubType":"NULL"},
19201: {"Type":"Armor","SubType":"NULL"},
19202: {"Type":"Armor","SubType":"NULL"},
19203: {"Type":"Armor","SubType":"NULL"},
19204: {"Type":"Armor","SubType":"NULL"},
19205: {"Type":"Armor","SubType":"NULL"},
19209: {"Type":"Armor","SubType":"NULL"},
19210: {"Type":"Armor","SubType":"NULL"},
19211: {"Type":"Armor","SubType":"NULL"},
19212: {"Type":"Armor","SubType":"NULL"},
19217: {"Type":"Armor","SubType":"NULL"},
19218: {"Type":"Armor","SubType":"NULL"},
19219: {"Type":"Armor","SubType":"NULL"},
19221: {"Type":"Armor","SubType":"NULL"},
19223: {"Type":"Armor","SubType":"NULL"},
19238: {"Type":"Armor","SubType":"NULL"},
19239: {"Type":"Armor","SubType":"NULL"},
19240: {"Type":"Armor","SubType":"NULL"},
19241: {"Type":"Armor","SubType":"NULL"},
19242: {"Type":"Armor","SubType":"NULL"},
19243: {"Type":"Armor","SubType":"NULL"},
19244: {"Type":"Armor","SubType":"NULL"},
19245: {"Type":"Armor","SubType":"NULL"},
19246: {"Type":"Armor","SubType":"NULL"},
19247: {"Type":"Armor","SubType":"NULL"},
19249: {"Type":"Armor","SubType":"NULL"},
19252: {"Type":"Armor","SubType":"NULL"},
19256: {"Type":"Armor","SubType":"NULL"},
19261: {"Type":"Armor","SubType":"NULL"},
19262: {"Type":"Armor","SubType":"NULL"},
19263: {"Type":"Armor","SubType":"NULL"},
19264: {"Type":"Armor","SubType":"NULL"},
19265: {"Type":"Armor","SubType":"NULL"},
19266: {"Type":"Armor","SubType":"NULL"},
19267: {"Type":"Armor","SubType":"NULL"},
19268: {"Type":"Armor","SubType":"NULL"},
19269: {"Type":"Armor","SubType":"NULL"},
19272: {"Type":"Armor","SubType":"NULL"},
19273: {"Type":"Armor","SubType":"NULL"},
19274: {"Type":"Armor","SubType":"NULL"},
19275: {"Type":"Armor","SubType":"NULL"},
19276: {"Type":"Armor","SubType":"NULL"},
19277: {"Type":"Armor","SubType":"NULL"},
19281: {"Type":"Armor","SubType":"NULL"},
19282: {"Type":"Armor","SubType":"NULL"},
19283: {"Type":"Armor","SubType":"NULL"},
19284: {"Type":"Armor","SubType":"NULL"},
19285: {"Type":"Armor","SubType":"NULL"},
19286: {"Type":"Armor","SubType":"NULL"},
19287: {"Type":"Armor","SubType":"NULL"},
19288: {"Type":"Armor","SubType":"NULL"},
19289: {"Type":"Armor","SubType":"NULL"},
19290: {"Type":"Armor","SubType":"NULL"},
19291: {"Type":"Armor","SubType":"NULL"},
19292: {"Type":"Armor","SubType":"NULL"},
19293: {"Type":"Armor","SubType":"NULL"},
19294: {"Type":"Armor","SubType":"NULL"},
19295: {"Type":"Armor","SubType":"NULL"},
19296: {"Type":"Armor","SubType":"NULL"},
19298: {"Type":"Armor","SubType":"NULL"},
19299: {"Type":"Armor","SubType":"NULL"},
19300: {"Type":"Armor","SubType":"NULL"},
19306: {"Type":"Armor","SubType":"NULL"},
19307: {"Type":"Armor","SubType":"NULL"},
19308: {"Type":"Armor","SubType":"NULL"},
19310: {"Type":"Armor","SubType":"NULL"},
19311: {"Type":"Armor","SubType":"NULL"},
19312: {"Type":"Armor","SubType":"NULL"},
19313: {"Type":"Armor","SubType":"NULL"},
19314: {"Type":"Armor","SubType":"NULL"},
19316: {"Type":"Armor","SubType":"NULL"},
19318: {"Type":"Armor","SubType":"NULL"},
19319: {"Type":"Armor","SubType":"NULL"},
19320: {"Type":"Armor","SubType":"NULL"},
19321: {"Type":"Armor","SubType":"NULL"},
19326: {"Type":"Armor","SubType":"NULL"},
19327: {"Type":"Armor","SubType":"NULL"},
19328: {"Type":"Armor","SubType":"NULL"},
19329: {"Type":"Armor","SubType":"NULL"},
19337: {"Type":"Armor","SubType":"NULL"},
19338: {"Type":"Armor","SubType":"NULL"},
19339: {"Type":"Armor","SubType":"NULL"},
19340: {"Type":"Armor","SubType":"NULL"},
19341: {"Type":"Armor","SubType":"NULL"},
19342: {"Type":"Armor","SubType":"NULL"},
19343: {"Type":"Armor","SubType":"NULL"},
19344: {"Type":"Armor","SubType":"NULL"},
19347: {"Type":"Armor","SubType":"NULL"},
19349: {"Type":"Armor","SubType":"NULL"},
19350: {"Type":"Armor","SubType":"NULL"},
19353: {"Type":"Armor","SubType":"NULL"},
19364: {"Type":"Armor","SubType":"NULL"},
19366: {"Type":"Armor","SubType":"NULL"},
19367: {"Type":"Armor","SubType":"NULL"},
19371: {"Type":"Armor","SubType":"NULL"},
19373: {"Type":"Armor","SubType":"NULL"},
19379: {"Type":"Armor","SubType":"NULL"},
19380: {"Type":"Armor","SubType":"NULL"},
19381: {"Type":"Armor","SubType":"NULL"},
19382: {"Type":"Armor","SubType":"NULL"},
19387: {"Type":"Armor","SubType":"NULL"},
19388: {"Type":"Armor","SubType":"NULL"},
19389: {"Type":"Armor","SubType":"NULL"},
19390: {"Type":"Armor","SubType":"NULL"},
19391: {"Type":"Armor","SubType":"NULL"},
19393: {"Type":"Armor","SubType":"NULL"},
19396: {"Type":"Armor","SubType":"NULL"},
19397: {"Type":"Armor","SubType":"NULL"},
19398: {"Type":"Armor","SubType":"NULL"},
19399: {"Type":"Armor","SubType":"NULL"},
19400: {"Type":"Armor","SubType":"NULL"},
19401: {"Type":"Armor","SubType":"NULL"},
19402: {"Type":"Armor","SubType":"NULL"},
19403: {"Type":"Armor","SubType":"NULL"},
19404: {"Type":"Armor","SubType":"NULL"},
19405: {"Type":"Armor","SubType":"NULL"},
19406: {"Type":"Armor","SubType":"NULL"},
19407: {"Type":"Armor","SubType":"NULL"},
19408: {"Type":"Armor","SubType":"NULL"},
19409: {"Type":"Armor","SubType":"NULL"},
19410: {"Type":"Armor","SubType":"NULL"},
19411: {"Type":"Armor","SubType":"NULL"},
19412: {"Type":"Armor","SubType":"NULL"},
19415: {"Type":"Armor","SubType":"NULL"},
19424: {"Type":"Armor","SubType":"NULL"},
19425: {"Type":"Armor","SubType":"NULL"},
19426: {"Type":"Armor","SubType":"NULL"},
19427: {"Type":"Armor","SubType":"NULL"},
19428: {"Type":"Armor","SubType":"NULL"},
19429: {"Type":"Armor","SubType":"NULL"},
19433: {"Type":"Armor","SubType":"NULL"},
19435: {"Type":"Armor","SubType":"NULL"},
19436: {"Type":"Armor","SubType":"NULL"},
19437: {"Type":"Armor","SubType":"NULL"},
19438: {"Type":"Armor","SubType":"NULL"},
19439: {"Type":"Armor","SubType":"NULL"},
19443: {"Type":"Armor","SubType":"NULL"},
19444: {"Type":"Armor","SubType":"NULL"},
19445: {"Type":"Armor","SubType":"NULL"},
19446: {"Type":"Armor","SubType":"NULL"},
19447: {"Type":"Armor","SubType":"NULL"},
19449: {"Type":"Armor","SubType":"NULL"},
19451: {"Type":"Armor","SubType":"NULL"},
19452: {"Type":"Armor","SubType":"NULL"},
19453: {"Type":"Armor","SubType":"NULL"},
19459: {"Type":"Armor","SubType":"NULL"},
19460: {"Type":"Armor","SubType":"NULL"},
19462: {"Type":"Armor","SubType":"NULL"},
19463: {"Type":"Armor","SubType":"NULL"},
19464: {"Type":"Armor","SubType":"NULL"},
19465: {"Type":"Armor","SubType":"NULL"},
19466: {"Type":"Armor","SubType":"NULL"},
19468: {"Type":"Armor","SubType":"NULL"},
19469: {"Type":"Armor","SubType":"NULL"},
19471: {"Type":"Armor","SubType":"NULL"},
19472: {"Type":"Armor","SubType":"NULL"},
19473: {"Type":"Armor","SubType":"NULL"},
19474: {"Type":"Armor","SubType":"NULL"},
19475: {"Type":"Armor","SubType":"NULL"},
19476: {"Type":"Armor","SubType":"NULL"},
19477: {"Type":"Armor","SubType":"NULL"},
19478: {"Type":"Armor","SubType":"NULL"},
19479: {"Type":"Armor","SubType":"NULL"},
19480: {"Type":"Armor","SubType":"NULL"},
19481: {"Type":"Armor","SubType":"NULL"},
19482: {"Type":"Armor","SubType":"NULL"},
19483: {"Type":"Armor","SubType":"NULL"},
19484: {"Type":"Armor","SubType":"NULL"},
19485: {"Type":"Armor","SubType":"NULL"},
19486: {"Type":"Armor","SubType":"NULL"},
19487: {"Type":"Armor","SubType":"NULL"},
19488: {"Type":"Armor","SubType":"NULL"},
19489: {"Type":"Armor","SubType":"NULL"},
19490: {"Type":"Armor","SubType":"NULL"},
19491: {"Type":"Armor","SubType":"NULL"},
19492: {"Type":"Armor","SubType":"NULL"},
19495: {"Type":"Armor","SubType":"NULL"},
19496: {"Type":"Armor","SubType":"NULL"},
19497: {"Type":"Armor","SubType":"NULL"},
19498: {"Type":"Armor","SubType":"NULL"},
19499: {"Type":"Armor","SubType":"NULL"},
19500: {"Type":"Armor","SubType":"NULL"},
19501: {"Type":"Armor","SubType":"NULL"},
19502: {"Type":"Armor","SubType":"NULL"},
19503: {"Type":"Armor","SubType":"NULL"},
19504: {"Type":"Armor","SubType":"NULL"},
19505: {"Type":"Armor","SubType":"NULL"},
19506: {"Type":"Armor","SubType":"NULL"},
19507: {"Type":"Armor","SubType":"NULL"},
19508: {"Type":"Armor","SubType":"NULL"},
19509: {"Type":"Armor","SubType":"NULL"},
19510: {"Type":"Armor","SubType":"NULL"},
19511: {"Type":"Armor","SubType":"NULL"},
19512: {"Type":"Armor","SubType":"NULL"},
19513: {"Type":"Armor","SubType":"NULL"},
19514: {"Type":"Armor","SubType":"NULL"},
19515: {"Type":"Armor","SubType":"NULL"},
19516: {"Type":"Armor","SubType":"NULL"},
19517: {"Type":"Armor","SubType":"NULL"},
19518: {"Type":"Armor","SubType":"NULL"},
19519: {"Type":"Armor","SubType":"NULL"},
19520: {"Type":"Armor","SubType":"NULL"},
19521: {"Type":"Armor","SubType":"NULL"},
19522: {"Type":"Armor","SubType":"NULL"},
19523: {"Type":"Armor","SubType":"NULL"},
19524: {"Type":"Armor","SubType":"NULL"},
19525: {"Type":"Armor","SubType":"NULL"},
19526: {"Type":"Armor","SubType":"NULL"},
19527: {"Type":"Armor","SubType":"NULL"},
19528: {"Type":"Armor","SubType":"NULL"},
19529: {"Type":"Armor","SubType":"NULL"},
19530: {"Type":"Armor","SubType":"NULL"},
19531: {"Type":"Armor","SubType":"NULL"},
19532: {"Type":"Armor","SubType":"NULL"},
19533: {"Type":"Armor","SubType":"NULL"},
19534: {"Type":"Armor","SubType":"NULL"},
19535: {"Type":"Armor","SubType":"NULL"},
19536: {"Type":"Armor","SubType":"NULL"},
19537: {"Type":"Armor","SubType":"NULL"},
19538: {"Type":"Armor","SubType":"NULL"},
19539: {"Type":"Armor","SubType":"NULL"},
19540: {"Type":"Armor","SubType":"NULL"},
19541: {"Type":"Armor","SubType":"NULL"},
19542: {"Type":"Armor","SubType":"NULL"},
19543: {"Type":"Armor","SubType":"NULL"},
19544: {"Type":"Armor","SubType":"NULL"},
19545: {"Type":"Armor","SubType":"NULL"},
19546: {"Type":"Armor","SubType":"NULL"},
19547: {"Type":"Armor","SubType":"NULL"},
19548: {"Type":"Armor","SubType":"NULL"},
19549: {"Type":"Armor","SubType":"NULL"},
19550: {"Type":"Armor","SubType":"NULL"},
19551: {"Type":"Armor","SubType":"NULL"},
19552: {"Type":"Armor","SubType":"NULL"},
19553: {"Type":"Armor","SubType":"NULL"},
19554: {"Type":"Armor","SubType":"NULL"},
19555: {"Type":"Armor","SubType":"NULL"},
19556: {"Type":"Armor","SubType":"NULL"},
19557: {"Type":"Armor","SubType":"NULL"},
19558: {"Type":"Armor","SubType":"NULL"},
19559: {"Type":"Armor","SubType":"NULL"},
19560: {"Type":"Armor","SubType":"NULL"},
19561: {"Type":"Armor","SubType":"NULL"},
19562: {"Type":"Armor","SubType":"NULL"},
19563: {"Type":"Armor","SubType":"NULL"},
19564: {"Type":"Armor","SubType":"NULL"},
19565: {"Type":"Armor","SubType":"NULL"},
19566: {"Type":"Armor","SubType":"NULL"},
19567: {"Type":"Armor","SubType":"NULL"},
19568: {"Type":"Armor","SubType":"NULL"},
19569: {"Type":"Armor","SubType":"NULL"},
19570: {"Type":"Armor","SubType":"NULL"},
19571: {"Type":"Armor","SubType":"NULL"},
19572: {"Type":"Armor","SubType":"NULL"},
19573: {"Type":"Armor","SubType":"NULL"},
19574: {"Type":"Armor","SubType":"NULL"},
19575: {"Type":"Armor","SubType":"NULL"},
19576: {"Type":"Armor","SubType":"NULL"},
19577: {"Type":"Armor","SubType":"NULL"},
19578: {"Type":"Armor","SubType":"NULL"},
19579: {"Type":"Armor","SubType":"NULL"},
19580: {"Type":"Armor","SubType":"NULL"},
19581: {"Type":"Armor","SubType":"NULL"},
19582: {"Type":"Armor","SubType":"NULL"},
19583: {"Type":"Armor","SubType":"NULL"},
19584: {"Type":"Armor","SubType":"NULL"},
19585: {"Type":"Armor","SubType":"NULL"},
19586: {"Type":"Armor","SubType":"NULL"},
19587: {"Type":"Armor","SubType":"NULL"},
19588: {"Type":"Armor","SubType":"NULL"},
19589: {"Type":"Armor","SubType":"NULL"},
19590: {"Type":"Armor","SubType":"NULL"},
19591: {"Type":"Armor","SubType":"NULL"},
19592: {"Type":"Armor","SubType":"NULL"},
19593: {"Type":"Armor","SubType":"NULL"},
19594: {"Type":"Armor","SubType":"NULL"},
19595: {"Type":"Armor","SubType":"NULL"},
19596: {"Type":"Armor","SubType":"NULL"},
19597: {"Type":"Armor","SubType":"NULL"},
19598: {"Type":"Armor","SubType":"NULL"},
19599: {"Type":"Armor","SubType":"NULL"},
19600: {"Type":"Armor","SubType":"NULL"},
19601: {"Type":"Armor","SubType":"NULL"},
19602: {"Type":"Armor","SubType":"NULL"},
19603: {"Type":"Armor","SubType":"NULL"},
19604: {"Type":"Armor","SubType":"NULL"},
19605: {"Type":"Armor","SubType":"NULL"},
19606: {"Type":"Armor","SubType":"NULL"},
19607: {"Type":"Armor","SubType":"NULL"},
19608: {"Type":"Armor","SubType":"NULL"},
19609: {"Type":"Armor","SubType":"NULL"},
19610: {"Type":"Armor","SubType":"NULL"},
19611: {"Type":"Armor","SubType":"NULL"},
19612: {"Type":"Armor","SubType":"NULL"},
19613: {"Type":"Armor","SubType":"NULL"},
19614: {"Type":"Armor","SubType":"NULL"},
19615: {"Type":"Armor","SubType":"NULL"},
19616: {"Type":"Armor","SubType":"NULL"},
19617: {"Type":"Armor","SubType":"NULL"},
19618: {"Type":"Armor","SubType":"NULL"},
19619: {"Type":"Armor","SubType":"NULL"},
19620: {"Type":"Armor","SubType":"NULL"},
19621: {"Type":"Armor","SubType":"NULL"},
19622: {"Type":"Armor","SubType":"NULL"},
19623: {"Type":"Armor","SubType":"NULL"},
19624: {"Type":"Armor","SubType":"NULL"},
19625: {"Type":"Armor","SubType":"NULL"},
19626: {"Type":"Armor","SubType":"NULL"},
19627: {"Type":"Armor","SubType":"NULL"},
19628: {"Type":"Armor","SubType":"NULL"},
19629: {"Type":"Armor","SubType":"NULL"},
19630: {"Type":"Armor","SubType":"NULL"},
19631: {"Type":"Armor","SubType":"NULL"},
19632: {"Type":"Armor","SubType":"NULL"},
19633: {"Type":"Armor","SubType":"NULL"},
19634: {"Type":"Armor","SubType":"NULL"},
19635: {"Type":"Armor","SubType":"NULL"},
19636: {"Type":"Armor","SubType":"NULL"},
19637: {"Type":"Armor","SubType":"NULL"},
19638: {"Type":"Armor","SubType":"NULL"},
19639: {"Type":"Armor","SubType":"NULL"},
19640: {"Type":"Armor","SubType":"NULL"},
19641: {"Type":"Armor","SubType":"NULL"},
19642: {"Type":"Armor","SubType":"NULL"},
19643: {"Type":"Armor","SubType":"NULL"},
19644: {"Type":"Armor","SubType":"NULL"},
19645: {"Type":"Armor","SubType":"NULL"},
19646: {"Type":"Armor","SubType":"NULL"},
19647: {"Type":"Armor","SubType":"NULL"},
19648: {"Type":"Armor","SubType":"NULL"},
19649: {"Type":"Armor","SubType":"NULL"},
19650: {"Type":"Armor","SubType":"NULL"},
19651: {"Type":"Armor","SubType":"NULL"},
19652: {"Type":"Armor","SubType":"NULL"},
19653: {"Type":"Armor","SubType":"NULL"},
19654: {"Type":"Armor","SubType":"NULL"},
19655: {"Type":"Armor","SubType":"NULL"},
19656: {"Type":"Armor","SubType":"NULL"},
19657: {"Type":"Armor","SubType":"NULL"},
19658: {"Type":"Armor","SubType":"NULL"},
19659: {"Type":"Armor","SubType":"NULL"},
19660: {"Type":"Armor","SubType":"NULL"},
19661: {"Type":"Armor","SubType":"NULL"},
19662: {"Type":"Armor","SubType":"NULL"},
19663: {"Type":"Armor","SubType":"NULL"},
19664: {"Type":"Armor","SubType":"NULL"},
19665: {"Type":"Armor","SubType":"NULL"},
19666: {"Type":"Armor","SubType":"NULL"},
19667: {"Type":"Armor","SubType":"NULL"},
19668: {"Type":"Armor","SubType":"NULL"},
19669: {"Type":"Armor","SubType":"NULL"},
19670: {"Type":"Armor","SubType":"NULL"},
19671: {"Type":"Armor","SubType":"NULL"},
19672: {"Type":"Armor","SubType":"NULL"},
19673: {"Type":"Armor","SubType":"NULL"},
19674: {"Type":"Armor","SubType":"NULL"},
19675: {"Type":"Armor","SubType":"NULL"},
19676: {"Type":"Armor","SubType":"NULL"},
19677: {"Type":"Armor","SubType":"NULL"},
19678: {"Type":"Armor","SubType":"NULL"},
19679: {"Type":"Armor","SubType":"NULL"},
19680: {"Type":"Armor","SubType":"NULL"},
19681: {"Type":"Armor","SubType":"NULL"},
19682: {"Type":"Armor","SubType":"NULL"},
19683: {"Type":"Armor","SubType":"NULL"},
19684: {"Type":"Armor","SubType":"NULL"},
19685: {"Type":"Armor","SubType":"NULL"},
19686: {"Type":"Armor","SubType":"NULL"},
19687: {"Type":"Armor","SubType":"NULL"},
19688: {"Type":"Armor","SubType":"NULL"},
19689: {"Type":"Armor","SubType":"NULL"},
19690: {"Type":"Armor","SubType":"NULL"},
19691: {"Type":"Armor","SubType":"NULL"},
19692: {"Type":"Armor","SubType":"NULL"},
19693: {"Type":"Armor","SubType":"NULL"},
19694: {"Type":"Armor","SubType":"NULL"},
19695: {"Type":"Armor","SubType":"NULL"},
19696: {"Type":"Armor","SubType":"NULL"},
19697: {"Type":"Armor","SubType":"NULL"},
19698: {"Type":"Armor","SubType":"NULL"},
19699: {"Type":"Armor","SubType":"NULL"},
19700: {"Type":"Armor","SubType":"NULL"},
19701: {"Type":"Armor","SubType":"NULL"},
19702: {"Type":"Armor","SubType":"NULL"},
19703: {"Type":"Armor","SubType":"NULL"},
19704: {"Type":"Armor","SubType":"NULL"},
19705: {"Type":"Armor","SubType":"NULL"},
19706: {"Type":"Armor","SubType":"NULL"},
19707: {"Type":"Armor","SubType":"NULL"},
19708: {"Type":"Armor","SubType":"NULL"},
19709: {"Type":"Armor","SubType":"NULL"},
19710: {"Type":"Armor","SubType":"NULL"},
19711: {"Type":"Armor","SubType":"NULL"},
19712: {"Type":"Armor","SubType":"NULL"},
19713: {"Type":"Armor","SubType":"NULL"},
19714: {"Type":"Armor","SubType":"NULL"},
19715: {"Type":"Armor","SubType":"NULL"},
19716: {"Type":"Armor","SubType":"NULL"},
19717: {"Type":"Armor","SubType":"NULL"},
19718: {"Type":"Armor","SubType":"NULL"},
19719: {"Type":"Armor","SubType":"NULL"},
19720: {"Type":"Armor","SubType":"NULL"},
19721: {"Type":"Armor","SubType":"NULL"},
19722: {"Type":"Armor","SubType":"NULL"},
19723: {"Type":"Armor","SubType":"NULL"},
19724: {"Type":"Armor","SubType":"NULL"},
19725: {"Type":"Armor","SubType":"NULL"},
19726: {"Type":"Armor","SubType":"NULL"},
19727: {"Type":"Armor","SubType":"NULL"},
19728: {"Type":"Armor","SubType":"NULL"},
19729: {"Type":"Armor","SubType":"NULL"},
19730: {"Type":"Armor","SubType":"NULL"},
19731: {"Type":"Armor","SubType":"NULL"},
19732: {"Type":"Armor","SubType":"NULL"},
19733: {"Type":"Armor","SubType":"NULL"},
19734: {"Type":"Armor","SubType":"NULL"},
19735: {"Type":"Armor","SubType":"NULL"},
19736: {"Type":"Armor","SubType":"NULL"},
19737: {"Type":"Armor","SubType":"NULL"},
19738: {"Type":"Armor","SubType":"NULL"},
19739: {"Type":"Armor","SubType":"NULL"},
19740: {"Type":"Armor","SubType":"NULL"},
19741: {"Type":"Armor","SubType":"NULL"},
19742: {"Type":"Armor","SubType":"NULL"},
19743: {"Type":"Armor","SubType":"NULL"},
19744: {"Type":"Armor","SubType":"NULL"},
19745: {"Type":"Armor","SubType":"NULL"},
19746: {"Type":"Armor","SubType":"NULL"},
19747: {"Type":"Armor","SubType":"NULL"},
19748: {"Type":"Armor","SubType":"NULL"},
19749: {"Type":"Armor","SubType":"NULL"},
19750: {"Type":"Armor","SubType":"NULL"},
19751: {"Type":"Armor","SubType":"NULL"},
19752: {"Type":"Armor","SubType":"NULL"},
19753: {"Type":"Armor","SubType":"NULL"},
19754: {"Type":"Armor","SubType":"NULL"},
19755: {"Type":"Armor","SubType":"NULL"},
19756: {"Type":"Armor","SubType":"NULL"},
19757: {"Type":"Armor","SubType":"NULL"},
19758: {"Type":"Armor","SubType":"NULL"},
19759: {"Type":"Armor","SubType":"NULL"},
19760: {"Type":"Armor","SubType":"NULL"},
19761: {"Type":"Armor","SubType":"NULL"},
19762: {"Type":"Armor","SubType":"NULL"},
19763: {"Type":"Armor","SubType":"NULL"},
19764: {"Type":"Armor","SubType":"NULL"},
19765: {"Type":"Armor","SubType":"NULL"},
19766: {"Type":"Armor","SubType":"NULL"},
19767: {"Type":"Armor","SubType":"NULL"},
19768: {"Type":"Armor","SubType":"NULL"},
19769: {"Type":"Armor","SubType":"NULL"},
19770: {"Type":"Armor","SubType":"NULL"},
19771: {"Type":"Armor","SubType":"NULL"},
19772: {"Type":"Armor","SubType":"NULL"},
19773: {"Type":"Armor","SubType":"NULL"},
19774: {"Type":"Armor","SubType":"NULL"},
19775: {"Type":"Armor","SubType":"NULL"},
19776: {"Type":"Armor","SubType":"NULL"},
19777: {"Type":"Armor","SubType":"NULL"},
19778: {"Type":"Armor","SubType":"NULL"},
19779: {"Type":"Armor","SubType":"NULL"},
19780: {"Type":"Armor","SubType":"NULL"},
19781: {"Type":"Armor","SubType":"NULL"},
19782: {"Type":"Armor","SubType":"NULL"},
19783: {"Type":"Armor","SubType":"NULL"},
19784: {"Type":"Armor","SubType":"NULL"},
19785: {"Type":"Armor","SubType":"NULL"},
19786: {"Type":"Armor","SubType":"NULL"},
19787: {"Type":"Armor","SubType":"NULL"},
19788: {"Type":"Armor","SubType":"NULL"},
19789: {"Type":"Armor","SubType":"NULL"},
19790: {"Type":"Armor","SubType":"NULL"},
19791: {"Type":"Armor","SubType":"NULL"},
19792: {"Type":"Armor","SubType":"NULL"},
19793: {"Type":"Armor","SubType":"NULL"},
19794: {"Type":"Armor","SubType":"NULL"},
19795: {"Type":"Armor","SubType":"NULL"},
19796: {"Type":"Armor","SubType":"NULL"},
19797: {"Type":"Armor","SubType":"NULL"},
19798: {"Type":"Armor","SubType":"NULL"},
19799: {"Type":"Armor","SubType":"NULL"},
19800: {"Type":"Armor","SubType":"NULL"},
19801: {"Type":"Armor","SubType":"NULL"},
19802: {"Type":"Armor","SubType":"NULL"},
19803: {"Type":"Armor","SubType":"NULL"},
19804: {"Type":"Armor","SubType":"NULL"},
19805: {"Type":"Armor","SubType":"NULL"},
19806: {"Type":"Armor","SubType":"NULL"},
19807: {"Type":"Armor","SubType":"NULL"},
19808: {"Type":"Armor","SubType":"NULL"},
19809: {"Type":"Armor","SubType":"NULL"},
19810: {"Type":"Armor","SubType":"NULL"},
19811: {"Type":"Armor","SubType":"NULL"},
19812: {"Type":"Armor","SubType":"NULL"},
19813: {"Type":"Armor","SubType":"NULL"},
19814: {"Type":"Armor","SubType":"NULL"},
19815: {"Type":"Armor","SubType":"NULL"},
19816: {"Type":"Armor","SubType":"NULL"},
19817: {"Type":"Armor","SubType":"NULL"},
19818: {"Type":"Armor","SubType":"NULL"},
19819: {"Type":"Armor","SubType":"NULL"},
19820: {"Type":"Armor","SubType":"NULL"},
19821: {"Type":"Armor","SubType":"NULL"},
19822: {"Type":"Armor","SubType":"NULL"},
19823: {"Type":"Armor","SubType":"NULL"},
19824: {"Type":"Armor","SubType":"NULL"},
19825: {"Type":"Armor","SubType":"NULL"},
19826: {"Type":"Armor","SubType":"NULL"},
19827: {"Type":"Armor","SubType":"NULL"},
19828: {"Type":"Armor","SubType":"NULL"},
19829: {"Type":"Armor","SubType":"NULL"},
19830: {"Type":"Armor","SubType":"NULL"},
19831: {"Type":"Armor","SubType":"NULL"},
19832: {"Type":"Armor","SubType":"NULL"},
19833: {"Type":"Armor","SubType":"NULL"},
19834: {"Type":"Armor","SubType":"NULL"},
19835: {"Type":"Armor","SubType":"NULL"},
19836: {"Type":"Armor","SubType":"NULL"},
19837: {"Type":"Armor","SubType":"NULL"},
19838: {"Type":"Armor","SubType":"NULL"},
19839: {"Type":"Armor","SubType":"NULL"},
19840: {"Type":"Armor","SubType":"NULL"},
19841: {"Type":"Armor","SubType":"NULL"},
19842: {"Type":"Armor","SubType":"NULL"},
19843: {"Type":"Armor","SubType":"NULL"},
19844: {"Type":"Armor","SubType":"NULL"},
19845: {"Type":"Armor","SubType":"NULL"},
19846: {"Type":"Armor","SubType":"NULL"},
19847: {"Type":"Armor","SubType":"NULL"},
19848: {"Type":"Armor","SubType":"NULL"},
19849: {"Type":"Armor","SubType":"NULL"},
19850: {"Type":"Armor","SubType":"NULL"},
19851: {"Type":"Armor","SubType":"NULL"},
19852: {"Type":"Armor","SubType":"NULL"},
19853: {"Type":"Armor","SubType":"NULL"},
19854: {"Type":"Armor","SubType":"NULL"},
19855: {"Type":"Armor","SubType":"NULL"},
19856: {"Type":"Armor","SubType":"NULL"},
19857: {"Type":"Armor","SubType":"NULL"},
19858: {"Type":"Armor","SubType":"NULL"},
19859: {"Type":"Armor","SubType":"NULL"},
19860: {"Type":"Armor","SubType":"NULL"},
19861: {"Type":"Armor","SubType":"NULL"},
19862: {"Type":"Armor","SubType":"NULL"},
19863: {"Type":"Armor","SubType":"NULL"},
19864: {"Type":"Armor","SubType":"NULL"},
19865: {"Type":"Armor","SubType":"NULL"},
19866: {"Type":"Armor","SubType":"NULL"},
19867: {"Type":"Armor","SubType":"NULL"},
19868: {"Type":"Armor","SubType":"NULL"},
19869: {"Type":"Armor","SubType":"NULL"},
19870: {"Type":"Armor","SubType":"NULL"},
19871: {"Type":"Armor","SubType":"NULL"},
19872: {"Type":"Armor","SubType":"NULL"},
19873: {"Type":"Armor","SubType":"NULL"},
19874: {"Type":"Armor","SubType":"NULL"},
19875: {"Type":"Armor","SubType":"NULL"},
19876: {"Type":"Armor","SubType":"NULL"},
19877: {"Type":"Armor","SubType":"NULL"},
19878: {"Type":"Armor","SubType":"NULL"},
19879: {"Type":"Armor","SubType":"NULL"},
19880: {"Type":"Armor","SubType":"NULL"},
19881: {"Type":"Armor","SubType":"NULL"},
19882: {"Type":"Armor","SubType":"NULL"},
19883: {"Type":"Armor","SubType":"NULL"},
19884: {"Type":"Armor","SubType":"NULL"},
19885: {"Type":"Armor","SubType":"NULL"},
19886: {"Type":"Armor","SubType":"NULL"},
19887: {"Type":"Armor","SubType":"NULL"},
19888: {"Type":"Armor","SubType":"NULL"},
19889: {"Type":"Armor","SubType":"NULL"},
19890: {"Type":"Armor","SubType":"NULL"},
19891: {"Type":"Armor","SubType":"NULL"},
19892: {"Type":"Armor","SubType":"NULL"},
19893: {"Type":"Armor","SubType":"NULL"},
19894: {"Type":"Armor","SubType":"NULL"},
19895: {"Type":"Armor","SubType":"NULL"},
19896: {"Type":"Armor","SubType":"NULL"},
19897: {"Type":"Armor","SubType":"NULL"},
19898: {"Type":"Armor","SubType":"NULL"},
19899: {"Type":"Armor","SubType":"NULL"},
19900: {"Type":"Armor","SubType":"NULL"},
19901: {"Type":"Armor","SubType":"NULL"},
19902: {"Type":"Armor","SubType":"NULL"},
19903: {"Type":"Armor","SubType":"NULL"},
19904: {"Type":"Armor","SubType":"NULL"},
19905: {"Type":"Armor","SubType":"NULL"},
19906: {"Type":"Armor","SubType":"NULL"},
19907: {"Type":"Armor","SubType":"NULL"},
19908: {"Type":"Armor","SubType":"NULL"},
19909: {"Type":"Armor","SubType":"NULL"},
19910: {"Type":"Armor","SubType":"NULL"},
19911: {"Type":"Armor","SubType":"NULL"},
19912: {"Type":"Armor","SubType":"NULL"},
19913: {"Type":"Armor","SubType":"NULL"},
19914: {"Type":"Armor","SubType":"NULL"},
19915: {"Type":"Armor","SubType":"NULL"},
19916: {"Type":"Armor","SubType":"NULL"},
19917: {"Type":"Armor","SubType":"NULL"},
19918: {"Type":"Armor","SubType":"NULL"},
19919: {"Type":"Armor","SubType":"NULL"},
19920: {"Type":"Armor","SubType":"NULL"},
19921: {"Type":"Armor","SubType":"NULL"},
19922: {"Type":"Armor","SubType":"NULL"},
19923: {"Type":"Armor","SubType":"NULL"},
19924: {"Type":"Armor","SubType":"NULL"},
19925: {"Type":"Armor","SubType":"NULL"},
19926: {"Type":"Armor","SubType":"NULL"},
19927: {"Type":"Armor","SubType":"NULL"},
19928: {"Type":"Armor","SubType":"NULL"},
19929: {"Type":"Armor","SubType":"NULL"},
19930: {"Type":"Armor","SubType":"NULL"},
19931: {"Type":"Armor","SubType":"NULL"},
19932: {"Type":"Armor","SubType":"NULL"},
19933: {"Type":"Armor","SubType":"NULL"},
19934: {"Type":"Armor","SubType":"NULL"},
19935: {"Type":"Armor","SubType":"NULL"},
19936: {"Type":"Armor","SubType":"NULL"},
19937: {"Type":"Armor","SubType":"NULL"},
19938: {"Type":"Armor","SubType":"NULL"},
19939: {"Type":"Armor","SubType":"NULL"},
19940: {"Type":"Armor","SubType":"NULL"},
19941: {"Type":"Armor","SubType":"NULL"},
19942: {"Type":"Armor","SubType":"NULL"},
19943: {"Type":"Armor","SubType":"NULL"},
19944: {"Type":"Armor","SubType":"NULL"},
19945: {"Type":"Armor","SubType":"NULL"},
19946: {"Type":"Armor","SubType":"NULL"},
19947: {"Type":"Armor","SubType":"NULL"},
19948: {"Type":"Armor","SubType":"NULL"},
19949: {"Type":"Armor","SubType":"NULL"},
19950: {"Type":"Armor","SubType":"NULL"},
19951: {"Type":"Armor","SubType":"NULL"},
19952: {"Type":"Armor","SubType":"NULL"},
19953: {"Type":"Armor","SubType":"NULL"},
19954: {"Type":"Armor","SubType":"NULL"},
19955: {"Type":"Armor","SubType":"NULL"},
19956: {"Type":"Armor","SubType":"NULL"},
19957: {"Type":"Armor","SubType":"NULL"},
19958: {"Type":"Armor","SubType":"NULL"},
19959: {"Type":"Armor","SubType":"NULL"},
19960: {"Type":"Armor","SubType":"NULL"},
19961: {"Type":"Armor","SubType":"NULL"},
19962: {"Type":"Armor","SubType":"NULL"},
19963: {"Type":"Armor","SubType":"NULL"},
19964: {"Type":"Armor","SubType":"NULL"},
19965: {"Type":"Armor","SubType":"NULL"},
19966: {"Type":"Armor","SubType":"NULL"},
19967: {"Type":"Armor","SubType":"NULL"},
19968: {"Type":"Armor","SubType":"NULL"},
19969: {"Type":"Armor","SubType":"NULL"},
19970: {"Type":"Armor","SubType":"NULL"},
19971: {"Type":"Armor","SubType":"NULL"},
19972: {"Type":"Armor","SubType":"NULL"},
19973: {"Type":"Armor","SubType":"NULL"},
19974: {"Type":"Armor","SubType":"NULL"},
19975: {"Type":"Armor","SubType":"NULL"},
19976: {"Type":"Armor","SubType":"NULL"},
19977: {"Type":"Armor","SubType":"NULL"},
19978: {"Type":"Armor","SubType":"NULL"},
19979: {"Type":"Armor","SubType":"NULL"},
19980: {"Type":"Armor","SubType":"NULL"},
19981: {"Type":"Armor","SubType":"NULL"},
19982: {"Type":"Armor","SubType":"NULL"},
19983: {"Type":"Armor","SubType":"NULL"},
19984: {"Type":"Armor","SubType":"NULL"},
19985: {"Type":"Armor","SubType":"NULL"},
19986: {"Type":"Armor","SubType":"NULL"},
19987: {"Type":"Armor","SubType":"NULL"},
19988: {"Type":"Armor","SubType":"NULL"},
19989: {"Type":"Armor","SubType":"NULL"},
19990: {"Type":"Armor","SubType":"NULL"},
19991: {"Type":"Armor","SubType":"NULL"},
19992: {"Type":"Armor","SubType":"NULL"},
19993: {"Type":"Armor","SubType":"NULL"},
19994: {"Type":"Armor","SubType":"NULL"},
19995: {"Type":"Armor","SubType":"NULL"},
19996: {"Type":"Armor","SubType":"NULL"},
19997: {"Type":"Armor","SubType":"NULL"},
19998: {"Type":"Armor","SubType":"NULL"},
19999: {"Type":"Armor","SubType":"NULL"},
20000: {"Type":"Armor","SubType":"NULL"},
20001: {"Type":"Armor","SubType":"NULL"},
20002: {"Type":"Armor","SubType":"NULL"},
20003: {"Type":"Armor","SubType":"NULL"},
20004: {"Type":"Armor","SubType":"NULL"},
20005: {"Type":"Armor","SubType":"NULL"},
20006: {"Type":"Armor","SubType":"NULL"},
20007: {"Type":"Armor","SubType":"NULL"},
20008: {"Type":"Armor","SubType":"NULL"},
20009: {"Type":"Armor","SubType":"NULL"},
20010: {"Type":"Armor","SubType":"NULL"},
20011: {"Type":"Armor","SubType":"NULL"},
20012: {"Type":"Armor","SubType":"NULL"},
20013: {"Type":"Armor","SubType":"NULL"},
20014: {"Type":"Armor","SubType":"NULL"},
20015: {"Type":"Armor","SubType":"NULL"},
20016: {"Type":"Armor","SubType":"NULL"},
20017: {"Type":"Armor","SubType":"NULL"},
20018: {"Type":"Armor","SubType":"NULL"},
20019: {"Type":"Armor","SubType":"NULL"},
20020: {"Type":"Armor","SubType":"NULL"},
20021: {"Type":"Armor","SubType":"NULL"},
20022: {"Type":"Armor","SubType":"NULL"},
20023: {"Type":"Armor","SubType":"NULL"},
20024: {"Type":"Armor","SubType":"NULL"},
20025: {"Type":"Armor","SubType":"NULL"},
20026: {"Type":"Armor","SubType":"NULL"},
20027: {"Type":"Armor","SubType":"NULL"},
20028: {"Type":"Armor","SubType":"NULL"},
20029: {"Type":"Armor","SubType":"NULL"},
20030: {"Type":"Armor","SubType":"NULL"},
20031: {"Type":"Armor","SubType":"NULL"},
20032: {"Type":"Armor","SubType":"NULL"},
20033: {"Type":"Armor","SubType":"NULL"},
20034: {"Type":"Armor","SubType":"NULL"},
20035: {"Type":"Armor","SubType":"NULL"},
20036: {"Type":"Armor","SubType":"NULL"},
20037: {"Type":"Armor","SubType":"NULL"},
20038: {"Type":"Armor","SubType":"NULL"},
20039: {"Type":"Armor","SubType":"NULL"},
20040: {"Type":"Armor","SubType":"NULL"},
20041: {"Type":"Armor","SubType":"NULL"},
20042: {"Type":"Armor","SubType":"NULL"},
20043: {"Type":"Armor","SubType":"NULL"},
20044: {"Type":"Armor","SubType":"NULL"},
20045: {"Type":"Armor","SubType":"NULL"},
20046: {"Type":"Armor","SubType":"NULL"},
20047: {"Type":"Armor","SubType":"NULL"},
20048: {"Type":"Armor","SubType":"NULL"},
20049: {"Type":"Armor","SubType":"NULL"},
20050: {"Type":"Armor","SubType":"NULL"},
20051: {"Type":"Armor","SubType":"NULL"},
20052: {"Type":"Armor","SubType":"NULL"},
20053: {"Type":"Armor","SubType":"NULL"},
20054: {"Type":"Armor","SubType":"NULL"},
20055: {"Type":"Armor","SubType":"NULL"},
20056: {"Type":"Armor","SubType":"NULL"},
20057: {"Type":"Armor","SubType":"NULL"},
20058: {"Type":"Armor","SubType":"NULL"},
20059: {"Type":"Armor","SubType":"NULL"},
20060: {"Type":"Armor","SubType":"NULL"},
20061: {"Type":"Armor","SubType":"NULL"},
20062: {"Type":"Armor","SubType":"NULL"},
20063: {"Type":"Armor","SubType":"NULL"},
20064: {"Type":"Armor","SubType":"NULL"},
20065: {"Type":"Armor","SubType":"NULL"},
20066: {"Type":"Armor","SubType":"NULL"},
20067: {"Type":"Armor","SubType":"NULL"},
20068: {"Type":"Armor","SubType":"NULL"},
20069: {"Type":"Armor","SubType":"NULL"},
20070: {"Type":"Armor","SubType":"NULL"},
20071: {"Type":"Armor","SubType":"NULL"},
20072: {"Type":"Armor","SubType":"NULL"},
20073: {"Type":"Armor","SubType":"NULL"},
20074: {"Type":"Armor","SubType":"NULL"},
20075: {"Type":"Armor","SubType":"NULL"},
20076: {"Type":"Armor","SubType":"NULL"},
20077: {"Type":"Armor","SubType":"NULL"},
20078: {"Type":"Armor","SubType":"NULL"},
20079: {"Type":"Armor","SubType":"NULL"},
20080: {"Type":"Armor","SubType":"NULL"},
20081: {"Type":"Armor","SubType":"NULL"},
20082: {"Type":"Armor","SubType":"NULL"},
20083: {"Type":"Armor","SubType":"NULL"},
20084: {"Type":"Armor","SubType":"NULL"},
20085: {"Type":"Armor","SubType":"NULL"},
20086: {"Type":"Armor","SubType":"NULL"},
20087: {"Type":"Armor","SubType":"NULL"},
20088: {"Type":"Armor","SubType":"NULL"},
20089: {"Type":"Armor","SubType":"NULL"},
20090: {"Type":"Armor","SubType":"NULL"},
20091: {"Type":"Armor","SubType":"NULL"},
20092: {"Type":"Armor","SubType":"NULL"},
20093: {"Type":"Armor","SubType":"NULL"},
20094: {"Type":"Armor","SubType":"NULL"},
20095: {"Type":"Armor","SubType":"NULL"},
20096: {"Type":"Armor","SubType":"NULL"},
20097: {"Type":"Armor","SubType":"NULL"},
20098: {"Type":"Armor","SubType":"NULL"},
20099: {"Type":"Armor","SubType":"NULL"},
20100: {"Type":"Armor","SubType":"NULL"},
20101: {"Type":"Armor","SubType":"NULL"},
20102: {"Type":"Armor","SubType":"NULL"},
20103: {"Type":"Armor","SubType":"NULL"},
20104: {"Type":"Armor","SubType":"NULL"},
20105: {"Type":"Armor","SubType":"NULL"},
20106: {"Type":"Armor","SubType":"NULL"},
20107: {"Type":"Armor","SubType":"NULL"},
20108: {"Type":"Armor","SubType":"NULL"},
20109: {"Type":"Armor","SubType":"NULL"},
20110: {"Type":"Armor","SubType":"NULL"},
20111: {"Type":"Armor","SubType":"NULL"},
20112: {"Type":"Armor","SubType":"NULL"},
20113: {"Type":"Armor","SubType":"NULL"},
20114: {"Type":"Armor","SubType":"NULL"},
20115: {"Type":"Armor","SubType":"NULL"},
20116: {"Type":"Armor","SubType":"NULL"},
20117: {"Type":"Armor","SubType":"NULL"},
20118: {"Type":"Armor","SubType":"NULL"},
20119: {"Type":"Armor","SubType":"NULL"},
20120: {"Type":"Armor","SubType":"NULL"},
20121: {"Type":"Armor","SubType":"NULL"},
20122: {"Type":"Armor","SubType":"NULL"},
20123: {"Type":"Armor","SubType":"NULL"},
20124: {"Type":"Armor","SubType":"NULL"},
20125: {"Type":"Armor","SubType":"NULL"},
20126: {"Type":"Armor","SubType":"NULL"},
20127: {"Type":"Armor","SubType":"NULL"},
20128: {"Type":"Armor","SubType":"NULL"},
20129: {"Type":"Armor","SubType":"NULL"},
20130: {"Type":"Armor","SubType":"NULL"},
20131: {"Type":"Armor","SubType":"NULL"},
20132: {"Type":"Armor","SubType":"NULL"},
20133: {"Type":"Armor","SubType":"NULL"},
20134: {"Type":"Armor","SubType":"NULL"},
20135: {"Type":"Armor","SubType":"NULL"},
20136: {"Type":"Armor","SubType":"NULL"},
20137: {"Type":"Armor","SubType":"NULL"},
20138: {"Type":"Armor","SubType":"NULL"},
20139: {"Type":"Armor","SubType":"NULL"},
20140: {"Type":"Armor","SubType":"NULL"},
20141: {"Type":"Armor","SubType":"NULL"},
20142: {"Type":"Armor","SubType":"NULL"},
20143: {"Type":"Armor","SubType":"NULL"},
20144: {"Type":"Armor","SubType":"NULL"},
20145: {"Type":"Armor","SubType":"NULL"},
20146: {"Type":"Armor","SubType":"NULL"},
20147: {"Type":"Armor","SubType":"NULL"},
20148: {"Type":"Armor","SubType":"NULL"},
20149: {"Type":"Armor","SubType":"NULL"},
20150: {"Type":"Armor","SubType":"NULL"},
20151: {"Type":"Armor","SubType":"NULL"},
20152: {"Type":"Armor","SubType":"NULL"},
20153: {"Type":"Armor","SubType":"NULL"},
20154: {"Type":"Armor","SubType":"NULL"},
20155: {"Type":"Armor","SubType":"NULL"},
20156: {"Type":"Armor","SubType":"NULL"},
20157: {"Type":"Armor","SubType":"NULL"},
20158: {"Type":"Armor","SubType":"NULL"},
20159: {"Type":"Armor","SubType":"NULL"},
20160: {"Type":"Armor","SubType":"NULL"},
20161: {"Type":"Armor","SubType":"NULL"},
20162: {"Type":"Armor","SubType":"NULL"},
20163: {"Type":"Armor","SubType":"NULL"},
20164: {"Type":"Armor","SubType":"NULL"},
20165: {"Type":"Armor","SubType":"NULL"},
20166: {"Type":"Armor","SubType":"NULL"},
20167: {"Type":"Armor","SubType":"NULL"},
20168: {"Type":"Armor","SubType":"NULL"},
20169: {"Type":"Armor","SubType":"NULL"},
20170: {"Type":"Armor","SubType":"NULL"},
20171: {"Type":"Armor","SubType":"NULL"},
20172: {"Type":"Armor","SubType":"NULL"},
20173: {"Type":"Armor","SubType":"NULL"},
20174: {"Type":"Armor","SubType":"NULL"},
20175: {"Type":"Armor","SubType":"NULL"},
20176: {"Type":"Armor","SubType":"NULL"},
20177: {"Type":"Armor","SubType":"NULL"},
20178: {"Type":"Armor","SubType":"NULL"},
20179: {"Type":"Armor","SubType":"NULL"},
20180: {"Type":"Armor","SubType":"NULL"},
20181: {"Type":"Armor","SubType":"NULL"},
20182: {"Type":"Armor","SubType":"NULL"},
20183: {"Type":"Armor","SubType":"NULL"},
20184: {"Type":"Armor","SubType":"NULL"},
20185: {"Type":"Armor","SubType":"NULL"},
20186: {"Type":"Armor","SubType":"NULL"},
20187: {"Type":"Armor","SubType":"NULL"},
20188: {"Type":"Armor","SubType":"NULL"},
20189: {"Type":"Armor","SubType":"NULL"},
20190: {"Type":"Armor","SubType":"NULL"},
20191: {"Type":"Armor","SubType":"NULL"},
20192: {"Type":"Armor","SubType":"NULL"},
20193: {"Type":"Armor","SubType":"NULL"},
20194: {"Type":"Armor","SubType":"NULL"},
20195: {"Type":"Armor","SubType":"NULL"},
20196: {"Type":"Armor","SubType":"NULL"},
20197: {"Type":"Armor","SubType":"NULL"},
20198: {"Type":"Armor","SubType":"NULL"},
20199: {"Type":"Armor","SubType":"NULL"},
20200: {"Type":"Armor","SubType":"NULL"},
20201: {"Type":"Armor","SubType":"NULL"},
20202: {"Type":"Armor","SubType":"NULL"},
20203: {"Type":"Armor","SubType":"NULL"},
20204: {"Type":"Armor","SubType":"NULL"},
20205: {"Type":"Armor","SubType":"NULL"},
20206: {"Type":"Armor","SubType":"NULL"},
20207: {"Type":"Armor","SubType":"NULL"},
20208: {"Type":"Armor","SubType":"NULL"},
20209: {"Type":"Armor","SubType":"NULL"},
20210: {"Type":"Armor","SubType":"NULL"},
20211: {"Type":"Armor","SubType":"NULL"},
20212: {"Type":"Armor","SubType":"NULL"},
20213: {"Type":"Armor","SubType":"NULL"},
20214: {"Type":"Armor","SubType":"NULL"},
20215: {"Type":"Armor","SubType":"NULL"},
20216: {"Type":"Armor","SubType":"NULL"},
20217: {"Type":"Armor","SubType":"NULL"},
20218: {"Type":"Armor","SubType":"NULL"},
20219: {"Type":"Armor","SubType":"NULL"},
20220: {"Type":"Armor","SubType":"NULL"},
20221: {"Type":"Armor","SubType":"NULL"},
20222: {"Type":"Armor","SubType":"NULL"},
20223: {"Type":"Armor","SubType":"NULL"},
20224: {"Type":"Armor","SubType":"NULL"},
20225: {"Type":"Armor","SubType":"NULL"},
20226: {"Type":"Armor","SubType":"NULL"},
20227: {"Type":"Armor","SubType":"NULL"},
20228: {"Type":"Armor","SubType":"NULL"},
20229: {"Type":"Armor","SubType":"NULL"},
20230: {"Type":"Armor","SubType":"NULL"},
20231: {"Type":"Armor","SubType":"NULL"},
20232: {"Type":"Armor","SubType":"NULL"},
20233: {"Type":"Armor","SubType":"NULL"},
20234: {"Type":"Armor","SubType":"NULL"},
20235: {"Type":"Armor","SubType":"NULL"},
20236: {"Type":"Armor","SubType":"NULL"},
20237: {"Type":"Armor","SubType":"NULL"},
20238: {"Type":"Armor","SubType":"NULL"},
20239: {"Type":"Armor","SubType":"NULL"},
20240: {"Type":"Armor","SubType":"NULL"},
20241: {"Type":"Armor","SubType":"NULL"},
20242: {"Type":"Armor","SubType":"NULL"},
20243: {"Type":"Armor","SubType":"NULL"},
20244: {"Type":"Armor","SubType":"NULL"},
20245: {"Type":"Armor","SubType":"NULL"},
20246: {"Type":"Armor","SubType":"NULL"},
20247: {"Type":"Armor","SubType":"NULL"},
20248: {"Type":"Armor","SubType":"NULL"},
20249: {"Type":"Armor","SubType":"NULL"},
20250: {"Type":"Armor","SubType":"NULL"},
20251: {"Type":"Armor","SubType":"NULL"},
20252: {"Type":"Armor","SubType":"NULL"},
20253: {"Type":"Armor","SubType":"NULL"},
20254: {"Type":"Armor","SubType":"NULL"},
20255: {"Type":"Armor","SubType":"NULL"},
20256: {"Type":"Armor","SubType":"NULL"},
20257: {"Type":"Armor","SubType":"NULL"},
20258: {"Type":"Armor","SubType":"NULL"},
20259: {"Type":"Armor","SubType":"NULL"},
20260: {"Type":"Armor","SubType":"NULL"},
20261: {"Type":"Armor","SubType":"NULL"},
20262: {"Type":"Armor","SubType":"NULL"},
20263: {"Type":"Armor","SubType":"NULL"},
20264: {"Type":"Armor","SubType":"NULL"},
20265: {"Type":"Armor","SubType":"NULL"},
20266: {"Type":"Armor","SubType":"NULL"},
20267: {"Type":"Armor","SubType":"NULL"},
20268: {"Type":"Armor","SubType":"NULL"},
20269: {"Type":"Armor","SubType":"NULL"},
20270: {"Type":"Armor","SubType":"NULL"},
20271: {"Type":"Armor","SubType":"NULL"},
20272: {"Type":"Armor","SubType":"NULL"},
20273: {"Type":"Armor","SubType":"NULL"},
20274: {"Type":"Armor","SubType":"NULL"},
20275: {"Type":"Armor","SubType":"NULL"},
20276: {"Type":"Armor","SubType":"NULL"},
20277: {"Type":"Armor","SubType":"NULL"},
20278: {"Type":"Armor","SubType":"NULL"},
20279: {"Type":"Armor","SubType":"NULL"},
20280: {"Type":"Armor","SubType":"NULL"},
20281: {"Type":"Armor","SubType":"NULL"},
20282: {"Type":"Armor","SubType":"NULL"},
20283: {"Type":"Armor","SubType":"NULL"},
20284: {"Type":"Armor","SubType":"NULL"},
20285: {"Type":"Armor","SubType":"NULL"},
20286: {"Type":"Armor","SubType":"NULL"},
20287: {"Type":"Armor","SubType":"NULL"},
20288: {"Type":"Armor","SubType":"NULL"},
20289: {"Type":"Armor","SubType":"NULL"},
20290: {"Type":"Armor","SubType":"NULL"},
20291: {"Type":"Armor","SubType":"NULL"},
20292: {"Type":"Armor","SubType":"NULL"},
20293: {"Type":"Armor","SubType":"NULL"},
20294: {"Type":"Armor","SubType":"NULL"},
20295: {"Type":"Armor","SubType":"NULL"},
20296: {"Type":"Armor","SubType":"NULL"},
20297: {"Type":"Armor","SubType":"NULL"},
20298: {"Type":"Armor","SubType":"NULL"},
20299: {"Type":"Armor","SubType":"NULL"},
20300: {"Type":"Armor","SubType":"NULL"},
20301: {"Type":"Armor","SubType":"NULL"},
20302: {"Type":"Armor","SubType":"NULL"},
20303: {"Type":"Armor","SubType":"NULL"},
20304: {"Type":"Armor","SubType":"NULL"},
20305: {"Type":"Armor","SubType":"NULL"},
20306: {"Type":"Armor","SubType":"NULL"},
20307: {"Type":"Armor","SubType":"NULL"},
20308: {"Type":"Armor","SubType":"NULL"},
20309: {"Type":"Armor","SubType":"NULL"},
20310: {"Type":"Armor","SubType":"NULL"},
20311: {"Type":"Armor","SubType":"NULL"},
20312: {"Type":"Armor","SubType":"NULL"},
20313: {"Type":"Armor","SubType":"NULL"},
20314: {"Type":"Armor","SubType":"NULL"},
20315: {"Type":"Armor","SubType":"NULL"},
20316: {"Type":"Armor","SubType":"NULL"},
20317: {"Type":"Armor","SubType":"NULL"},
20318: {"Type":"Armor","SubType":"NULL"},
20319: {"Type":"Armor","SubType":"NULL"},
20320: {"Type":"Armor","SubType":"NULL"},
20321: {"Type":"Armor","SubType":"NULL"},
20322: {"Type":"Armor","SubType":"NULL"},
20323: {"Type":"Armor","SubType":"NULL"},
20324: {"Type":"Armor","SubType":"NULL"},
20325: {"Type":"Armor","SubType":"NULL"},
20326: {"Type":"Armor","SubType":"NULL"},
20327: {"Type":"Armor","SubType":"NULL"},
20328: {"Type":"Armor","SubType":"NULL"},
20329: {"Type":"Armor","SubType":"NULL"},
20330: {"Type":"Armor","SubType":"NULL"},
20331: {"Type":"Armor","SubType":"NULL"},
20332: {"Type":"Armor","SubType":"NULL"},
20333: {"Type":"Armor","SubType":"NULL"},
20334: {"Type":"Armor","SubType":"NULL"},
20335: {"Type":"Armor","SubType":"NULL"},
20336: {"Type":"Armor","SubType":"NULL"},
20337: {"Type":"Armor","SubType":"NULL"},
20338: {"Type":"Armor","SubType":"NULL"},
20339: {"Type":"Armor","SubType":"NULL"},
20340: {"Type":"Armor","SubType":"NULL"},
20341: {"Type":"Armor","SubType":"NULL"},
20342: {"Type":"Armor","SubType":"NULL"},
20343: {"Type":"Armor","SubType":"NULL"},
20344: {"Type":"Armor","SubType":"NULL"},
20345: {"Type":"Armor","SubType":"NULL"},
20346: {"Type":"Armor","SubType":"NULL"},
20347: {"Type":"Armor","SubType":"NULL"},
20348: {"Type":"Armor","SubType":"NULL"},
20349: {"Type":"Armor","SubType":"NULL"},
20350: {"Type":"Armor","SubType":"NULL"},
20351: {"Type":"Armor","SubType":"NULL"},
20352: {"Type":"Armor","SubType":"NULL"},
20353: {"Type":"Armor","SubType":"NULL"},
20354: {"Type":"Armor","SubType":"NULL"},
20355: {"Type":"Armor","SubType":"NULL"},
20356: {"Type":"Armor","SubType":"NULL"},
20357: {"Type":"Armor","SubType":"NULL"},
20358: {"Type":"Armor","SubType":"NULL"},
20359: {"Type":"Armor","SubType":"NULL"},
20360: {"Type":"Armor","SubType":"NULL"},
20361: {"Type":"Armor","SubType":"NULL"},
20362: {"Type":"Armor","SubType":"NULL"},
20363: {"Type":"Armor","SubType":"NULL"},
20364: {"Type":"Armor","SubType":"NULL"},
20365: {"Type":"Armor","SubType":"NULL"},
20366: {"Type":"Armor","SubType":"NULL"},
20367: {"Type":"Armor","SubType":"NULL"},
20368: {"Type":"Armor","SubType":"NULL"},
20369: {"Type":"Armor","SubType":"NULL"},
20370: {"Type":"Armor","SubType":"NULL"},
20371: {"Type":"Armor","SubType":"NULL"},
20372: {"Type":"Armor","SubType":"NULL"},
20373: {"Type":"Armor","SubType":"NULL"},
20374: {"Type":"Armor","SubType":"NULL"},
20375: {"Type":"Armor","SubType":"NULL"},
20376: {"Type":"Armor","SubType":"NULL"},
20377: {"Type":"Armor","SubType":"NULL"},
20378: {"Type":"Armor","SubType":"NULL"},
20379: {"Type":"Armor","SubType":"NULL"},
20380: {"Type":"Armor","SubType":"NULL"},
20381: {"Type":"Armor","SubType":"NULL"},
20382: {"Type":"Armor","SubType":"NULL"},
20383: {"Type":"Armor","SubType":"NULL"},
20384: {"Type":"Armor","SubType":"NULL"},
20385: {"Type":"Armor","SubType":"NULL"},
20386: {"Type":"Armor","SubType":"NULL"},
20387: {"Type":"Armor","SubType":"NULL"},
20388: {"Type":"Armor","SubType":"NULL"},
20389: {"Type":"Armor","SubType":"NULL"},
20390: {"Type":"Armor","SubType":"NULL"},
20391: {"Type":"Armor","SubType":"NULL"},
20392: {"Type":"Armor","SubType":"NULL"},
20393: {"Type":"Armor","SubType":"NULL"},
20394: {"Type":"Armor","SubType":"NULL"},
20395: {"Type":"Armor","SubType":"NULL"},
20396: {"Type":"Armor","SubType":"NULL"},
20397: {"Type":"Armor","SubType":"NULL"},
20398: {"Type":"Armor","SubType":"NULL"},
20399: {"Type":"Armor","SubType":"NULL"},
20400: {"Type":"Armor","SubType":"NULL"},
20401: {"Type":"Armor","SubType":"NULL"},
20402: {"Type":"Armor","SubType":"NULL"},
20403: {"Type":"Armor","SubType":"NULL"},
20404: {"Type":"Armor","SubType":"NULL"},
20405: {"Type":"Armor","SubType":"NULL"},
20406: {"Type":"Armor","SubType":"NULL"},
20407: {"Type":"Armor","SubType":"NULL"},
20408: {"Type":"Armor","SubType":"NULL"},
20409: {"Type":"Armor","SubType":"NULL"},
20410: {"Type":"Armor","SubType":"NULL"},
20411: {"Type":"Armor","SubType":"NULL"},
20412: {"Type":"Armor","SubType":"NULL"},
20413: {"Type":"Armor","SubType":"NULL"},
20414: {"Type":"Armor","SubType":"NULL"},
20415: {"Type":"Armor","SubType":"NULL"},
20416: {"Type":"Armor","SubType":"NULL"},
20417: {"Type":"Armor","SubType":"NULL"},
20418: {"Type":"Armor","SubType":"NULL"},
20419: {"Type":"Armor","SubType":"NULL"},
20420: {"Type":"Armor","SubType":"NULL"},
20421: {"Type":"Armor","SubType":"NULL"},
20422: {"Type":"Armor","SubType":"NULL"},
20423: {"Type":"Armor","SubType":"NULL"},
20424: {"Type":"Armor","SubType":"NULL"},
20425: {"Type":"Armor","SubType":"NULL"},
20426: {"Type":"Armor","SubType":"NULL"},
20427: {"Type":"Armor","SubType":"NULL"},
20428: {"Type":"Armor","SubType":"NULL"},
20429: {"Type":"Armor","SubType":"NULL"},
20430: {"Type":"Armor","SubType":"NULL"},
20431: {"Type":"Armor","SubType":"NULL"},
20432: {"Type":"Armor","SubType":"NULL"},
20433: {"Type":"Armor","SubType":"NULL"},
20434: {"Type":"Armor","SubType":"NULL"},
20435: {"Type":"Armor","SubType":"NULL"},
20436: {"Type":"Armor","SubType":"NULL"},
20437: {"Type":"Armor","SubType":"NULL"},
20438: {"Type":"Armor","SubType":"NULL"},
20439: {"Type":"Armor","SubType":"NULL"},
20440: {"Type":"Armor","SubType":"NULL"},
20441: {"Type":"Armor","SubType":"NULL"},
20442: {"Type":"Armor","SubType":"NULL"},
20443: {"Type":"Armor","SubType":"NULL"},
20444: {"Type":"Armor","SubType":"NULL"},
20445: {"Type":"Armor","SubType":"NULL"},
20446: {"Type":"Armor","SubType":"NULL"},
20447: {"Type":"Armor","SubType":"NULL"},
20448: {"Type":"Armor","SubType":"NULL"},
20449: {"Type":"Armor","SubType":"NULL"},
20450: {"Type":"Armor","SubType":"NULL"},
20451: {"Type":"Armor","SubType":"NULL"},
20452: {"Type":"Armor","SubType":"NULL"},
20453: {"Type":"Armor","SubType":"NULL"},
20454: {"Type":"Armor","SubType":"NULL"},
20455: {"Type":"Armor","SubType":"NULL"},
20456: {"Type":"Armor","SubType":"NULL"},
20457: {"Type":"Armor","SubType":"NULL"},
20458: {"Type":"Armor","SubType":"NULL"},
20459: {"Type":"Armor","SubType":"NULL"},
20460: {"Type":"Armor","SubType":"NULL"},
20461: {"Type":"Armor","SubType":"NULL"},
20462: {"Type":"Armor","SubType":"NULL"},
20463: {"Type":"Armor","SubType":"NULL"},
20464: {"Type":"Armor","SubType":"NULL"},
20465: {"Type":"Armor","SubType":"NULL"},
20466: {"Type":"Armor","SubType":"NULL"},
20467: {"Type":"Armor","SubType":"NULL"},
20468: {"Type":"Armor","SubType":"NULL"},
20469: {"Type":"Armor","SubType":"NULL"},
20470: {"Type":"Armor","SubType":"NULL"},
20471: {"Type":"Armor","SubType":"NULL"},
20472: {"Type":"Armor","SubType":"NULL"},
20473: {"Type":"Armor","SubType":"NULL"},
20474: {"Type":"Armor","SubType":"NULL"},
20475: {"Type":"Armor","SubType":"NULL"},
20476: {"Type":"Armor","SubType":"NULL"},
20477: {"Type":"Armor","SubType":"NULL"},
20478: {"Type":"Armor","SubType":"NULL"},
20479: {"Type":"Armor","SubType":"NULL"},
20480: {"Type":"Armor","SubType":"NULL"},
20481: {"Type":"Armor","SubType":"NULL"},
20482: {"Type":"Armor","SubType":"NULL"},
20483: {"Type":"Armor","SubType":"NULL"},
20484: {"Type":"Armor","SubType":"NULL"},
20485: {"Type":"Armor","SubType":"NULL"},
20486: {"Type":"Armor","SubType":"NULL"},
20487: {"Type":"Armor","SubType":"NULL"},
20488: {"Type":"Armor","SubType":"NULL"},
20489: {"Type":"Armor","SubType":"NULL"},
20490: {"Type":"Armor","SubType":"NULL"},
20491: {"Type":"Armor","SubType":"NULL"},
20492: {"Type":"Armor","SubType":"NULL"},
20493: {"Type":"Armor","SubType":"NULL"},
20494: {"Type":"Armor","SubType":"NULL"},
20495: {"Type":"Armor","SubType":"NULL"},
20496: {"Type":"Armor","SubType":"NULL"},
20497: {"Type":"Armor","SubType":"NULL"},
20498: {"Type":"Armor","SubType":"NULL"},
20499: {"Type":"Armor","SubType":"NULL"},
20500: {"Type":"Armor","SubType":"NULL"},
20501: {"Type":"Armor","SubType":"NULL"},
20502: {"Type":"Armor","SubType":"NULL"},
20503: {"Type":"Armor","SubType":"NULL"},
20504: {"Type":"Armor","SubType":"NULL"},
20505: {"Type":"Armor","SubType":"NULL"},
20506: {"Type":"Armor","SubType":"NULL"},
20507: {"Type":"Armor","SubType":"NULL"},
20508: {"Type":"Armor","SubType":"NULL"},
20509: {"Type":"Armor","SubType":"NULL"},
20510: {"Type":"Armor","SubType":"NULL"},
20511: {"Type":"Armor","SubType":"NULL"},
20512: {"Type":"Armor","SubType":"NULL"},
20513: {"Type":"Armor","SubType":"NULL"},
20514: {"Type":"Armor","SubType":"NULL"},
20515: {"Type":"Armor","SubType":"NULL"},
20516: {"Type":"Armor","SubType":"NULL"},
20517: {"Type":"Armor","SubType":"NULL"},
20518: {"Type":"Armor","SubType":"NULL"},
20519: {"Type":"Armor","SubType":"NULL"},
20520: {"Type":"Armor","SubType":"NULL"},
20521: {"Type":"Armor","SubType":"NULL"},
20522: {"Type":"Armor","SubType":"NULL"},
20523: {"Type":"Armor","SubType":"NULL"},
20524: {"Type":"Armor","SubType":"NULL"},
20525: {"Type":"Armor","SubType":"NULL"},
20526: {"Type":"Armor","SubType":"NULL"},
20527: {"Type":"Armor","SubType":"NULL"},
20528: {"Type":"Armor","SubType":"NULL"},
20529: {"Type":"Armor","SubType":"NULL"},
20530: {"Type":"Armor","SubType":"NULL"},
20531: {"Type":"Armor","SubType":"NULL"},
20532: {"Type":"Armor","SubType":"NULL"},
20533: {"Type":"Armor","SubType":"NULL"},
20534: {"Type":"Armor","SubType":"NULL"},
20535: {"Type":"Armor","SubType":"NULL"},
20536: {"Type":"Armor","SubType":"NULL"},
20537: {"Type":"Armor","SubType":"NULL"},
20538: {"Type":"Armor","SubType":"NULL"},
20539: {"Type":"Armor","SubType":"NULL"},
20540: {"Type":"Armor","SubType":"NULL"},
20541: {"Type":"Armor","SubType":"NULL"},
20542: {"Type":"Armor","SubType":"NULL"},
20543: {"Type":"Armor","SubType":"NULL"},
20544: {"Type":"Armor","SubType":"NULL"},
20545: {"Type":"Armor","SubType":"NULL"},
20546: {"Type":"Armor","SubType":"NULL"},
20547: {"Type":"Armor","SubType":"NULL"},
20548: {"Type":"Armor","SubType":"NULL"},
20549: {"Type":"Armor","SubType":"NULL"},
20550: {"Type":"Armor","SubType":"NULL"},
20551: {"Type":"Armor","SubType":"NULL"},
20552: {"Type":"Armor","SubType":"NULL"},
20553: {"Type":"Armor","SubType":"NULL"},
20554: {"Type":"Armor","SubType":"NULL"},
20555: {"Type":"Armor","SubType":"NULL"},
20556: {"Type":"Armor","SubType":"NULL"},
20557: {"Type":"Armor","SubType":"NULL"},
20558: {"Type":"Armor","SubType":"NULL"},
20559: {"Type":"Armor","SubType":"NULL"},
20560: {"Type":"Armor","SubType":"NULL"},
20561: {"Type":"Armor","SubType":"NULL"},
20562: {"Type":"Armor","SubType":"NULL"},
20563: {"Type":"Armor","SubType":"NULL"},
20564: {"Type":"Armor","SubType":"NULL"},
20565: {"Type":"Armor","SubType":"NULL"},
20566: {"Type":"Armor","SubType":"NULL"},
20567: {"Type":"Armor","SubType":"NULL"},
20568: {"Type":"Armor","SubType":"NULL"},
20569: {"Type":"Armor","SubType":"NULL"},
20570: {"Type":"Armor","SubType":"NULL"},
20571: {"Type":"Armor","SubType":"NULL"},
20572: {"Type":"Armor","SubType":"NULL"},
20573: {"Type":"Armor","SubType":"NULL"},
20574: {"Type":"Armor","SubType":"NULL"},
20575: {"Type":"Armor","SubType":"NULL"},
20576: {"Type":"Armor","SubType":"NULL"},
20577: {"Type":"Armor","SubType":"NULL"},
20578: {"Type":"Armor","SubType":"NULL"},
20579: {"Type":"Armor","SubType":"NULL"},
20580: {"Type":"Armor","SubType":"NULL"},
20581: {"Type":"Armor","SubType":"NULL"},
20582: {"Type":"Armor","SubType":"NULL"},
20583: {"Type":"Armor","SubType":"NULL"},
20584: {"Type":"Armor","SubType":"NULL"},
20585: {"Type":"Armor","SubType":"NULL"},
20586: {"Type":"Armor","SubType":"NULL"},
20587: {"Type":"Armor","SubType":"NULL"},
20588: {"Type":"Armor","SubType":"NULL"},
20589: {"Type":"Armor","SubType":"NULL"},
20590: {"Type":"Armor","SubType":"NULL"},
20591: {"Type":"Armor","SubType":"NULL"},
20592: {"Type":"Armor","SubType":"NULL"},
20593: {"Type":"Armor","SubType":"NULL"},
20594: {"Type":"Armor","SubType":"NULL"},
20595: {"Type":"Armor","SubType":"NULL"},
20596: {"Type":"Armor","SubType":"NULL"},
20597: {"Type":"Armor","SubType":"NULL"},
20598: {"Type":"Armor","SubType":"NULL"},
20599: {"Type":"Armor","SubType":"NULL"},
20600: {"Type":"Armor","SubType":"NULL"},
20601: {"Type":"Armor","SubType":"NULL"},
20602: {"Type":"Armor","SubType":"NULL"},
20603: {"Type":"Armor","SubType":"NULL"},
20604: {"Type":"Armor","SubType":"NULL"},
20605: {"Type":"Armor","SubType":"NULL"},
20606: {"Type":"Armor","SubType":"NULL"},
20607: {"Type":"Armor","SubType":"NULL"},
20608: {"Type":"Armor","SubType":"NULL"},
20609: {"Type":"Armor","SubType":"NULL"},
20610: {"Type":"Armor","SubType":"NULL"},
20611: {"Type":"Armor","SubType":"NULL"},
20612: {"Type":"Armor","SubType":"NULL"},
20613: {"Type":"Armor","SubType":"NULL"},
20614: {"Type":"Armor","SubType":"NULL"},
20615: {"Type":"Armor","SubType":"NULL"},
20616: {"Type":"Armor","SubType":"NULL"},
20617: {"Type":"Armor","SubType":"NULL"},
20618: {"Type":"Armor","SubType":"NULL"},
20619: {"Type":"Armor","SubType":"NULL"},
20620: {"Type":"Armor","SubType":"NULL"},
20621: {"Type":"Armor","SubType":"NULL"},
20622: {"Type":"Armor","SubType":"NULL"},
20623: {"Type":"Armor","SubType":"NULL"},
20624: {"Type":"Armor","SubType":"NULL"},
20625: {"Type":"Armor","SubType":"NULL"},
20626: {"Type":"Armor","SubType":"NULL"},
20627: {"Type":"Armor","SubType":"NULL"},
20628: {"Type":"Armor","SubType":"NULL"},
20629: {"Type":"Armor","SubType":"NULL"},
20700: {"Type":"Armor","SubType":"NULL"},
20701: {"Type":"Armor","SubType":"NULL"},
20702: {"Type":"Armor","SubType":"NULL"},
20703: {"Type":"Armor","SubType":"NULL"},
20704: {"Type":"Armor","SubType":"NULL"},
20705: {"Type":"Armor","SubType":"NULL"},
20706: {"Type":"Armor","SubType":"NULL"},
20707: {"Type":"Armor","SubType":"NULL"},
20708: {"Type":"Armor","SubType":"NULL"},
20709: {"Type":"Armor","SubType":"NULL"},
20710: {"Type":"Armor","SubType":"NULL"},
20711: {"Type":"Armor","SubType":"NULL"},
20712: {"Type":"Armor","SubType":"NULL"},
20713: {"Type":"Armor","SubType":"NULL"},
20714: {"Type":"Armor","SubType":"NULL"},
20715: {"Type":"Armor","SubType":"NULL"},
20716: {"Type":"Armor","SubType":"NULL"},
20717: {"Type":"Armor","SubType":"NULL"},
20718: {"Type":"Armor","SubType":"NULL"},
20719: {"Type":"Armor","SubType":"NULL"},
20720: {"Type":"Armor","SubType":"NULL"},
20721: {"Type":"Armor","SubType":"NULL"},
20722: {"Type":"Armor","SubType":"NULL"},
20723: {"Type":"Armor","SubType":"NULL"},
20724: {"Type":"Armor","SubType":"NULL"},
20725: {"Type":"Armor","SubType":"NULL"},
20726: {"Type":"Armor","SubType":"NULL"},
20727: {"Type":"Armor","SubType":"NULL"},
20728: {"Type":"Armor","SubType":"NULL"},
20729: {"Type":"Armor","SubType":"NULL"},
20730: {"Type":"Armor","SubType":"NULL"},
20731: {"Type":"Armor","SubType":"NULL"},
20732: {"Type":"Armor","SubType":"NULL"},
20733: {"Type":"Armor","SubType":"NULL"},
20734: {"Type":"Armor","SubType":"NULL"},
20735: {"Type":"Armor","SubType":"NULL"},
20737: {"Type":"Armor","SubType":"NULL"},
20743: {"Type":"Armor","SubType":"NULL"},
20744: {"Type":"Armor","SubType":"NULL"},
20745: {"Type":"Armor","SubType":"NULL"},
20746: {"Type":"Armor","SubType":"NULL"},
20747: {"Type":"Armor","SubType":"NULL"},
20748: {"Type":"Armor","SubType":"NULL"},
20749: {"Type":"Armor","SubType":"NULL"},
20750: {"Type":"Armor","SubType":"NULL"},
20753: {"Type":"Armor","SubType":"NULL"},
20756: {"Type":"Armor","SubType":"NULL"},
20761: {"Type":"Armor","SubType":"NULL"},
20762: {"Type":"Armor","SubType":"NULL"},
20763: {"Type":"Armor","SubType":"NULL"},
20764: {"Type":"Armor","SubType":"NULL"},
20765: {"Type":"Armor","SubType":"NULL"},
20766: {"Type":"Armor","SubType":"NULL"},
20767: {"Type":"Armor","SubType":"NULL"},
20768: {"Type":"Armor","SubType":"NULL"},
20769: {"Type":"Armor","SubType":"NULL"},
20770: {"Type":"Armor","SubType":"NULL"},
20771: {"Type":"Armor","SubType":"NULL"},
20772: {"Type":"Armor","SubType":"NULL"},
20773: {"Type":"Armor","SubType":"NULL"},
20774: {"Type":"Armor","SubType":"NULL"},
20776: {"Type":"Armor","SubType":"NULL"},
20777: {"Type":"Armor","SubType":"NULL"},
20778: {"Type":"Armor","SubType":"NULL"},
20779: {"Type":"Armor","SubType":"NULL"},
20780: {"Type":"Armor","SubType":"NULL"},
20781: {"Type":"Armor","SubType":"NULL"},
20782: {"Type":"Armor","SubType":"NULL"},
20783: {"Type":"Armor","SubType":"NULL"},
20784: {"Type":"Armor","SubType":"NULL"},
20787: {"Type":"Armor","SubType":"NULL"},
20788: {"Type":"Armor","SubType":"NULL"},
20789: {"Type":"Armor","SubType":"NULL"},
20790: {"Type":"Armor","SubType":"NULL"},
20796: {"Type":"Armor","SubType":"NULL"},
20797: {"Type":"Armor","SubType":"NULL"},
20798: {"Type":"Armor","SubType":"NULL"},
20799: {"Type":"Armor","SubType":"NULL"},
20800: {"Type":"Armor","SubType":"NULL"},
20801: {"Type":"Armor","SubType":"NULL"},
20802: {"Type":"Armor","SubType":"NULL"},
20803: {"Type":"Armor","SubType":"NULL"},
20804: {"Type":"Armor","SubType":"NULL"},
20805: {"Type":"Armor","SubType":"NULL"},
20806: {"Type":"Armor","SubType":"NULL"},
20807: {"Type":"Armor","SubType":"NULL"},
20808: {"Type":"Armor","SubType":"NULL"},
20809: {"Type":"Armor","SubType":"NULL"},
20811: {"Type":"Armor","SubType":"NULL"},
20812: {"Type":"Armor","SubType":"NULL"},
20813: {"Type":"Armor","SubType":"NULL"},
20814: {"Type":"Armor","SubType":"NULL"},
20815: {"Type":"Armor","SubType":"NULL"},
20816: {"Type":"Armor","SubType":"NULL"},
20817: {"Type":"Armor","SubType":"NULL"},
20818: {"Type":"Armor","SubType":"NULL"},
20819: {"Type":"Armor","SubType":"NULL"},
20820: {"Type":"Armor","SubType":"NULL"},
20821: {"Type":"Armor","SubType":"NULL"},
20822: {"Type":"Armor","SubType":"NULL"},
20823: {"Type":"Armor","SubType":"NULL"},
20824: {"Type":"Armor","SubType":"NULL"},
20825: {"Type":"Armor","SubType":"NULL"},
20826: {"Type":"Armor","SubType":"NULL"},
20827: {"Type":"Armor","SubType":"NULL"},
20828: {"Type":"Armor","SubType":"NULL"},
20830: {"Type":"Armor","SubType":"NULL"},
20831: {"Type":"Armor","SubType":"NULL"},
20833: {"Type":"Armor","SubType":"NULL"},
20834: {"Type":"Armor","SubType":"NULL"},
20835: {"Type":"Armor","SubType":"NULL"},
20836: {"Type":"Armor","SubType":"NULL"},
20837: {"Type":"Armor","SubType":"NULL"},
20838: {"Type":"Armor","SubType":"NULL"},
20840: {"Type":"Armor","SubType":"NULL"},
20841: {"Type":"Armor","SubType":"NULL"},
20842: {"Type":"Armor","SubType":"NULL"},
20843: {"Type":"Armor","SubType":"NULL"},
20844: {"Type":"Armor","SubType":"NULL"},
20845: {"Type":"Armor","SubType":"NULL"},
20846: {"Type":"Armor","SubType":"NULL"},
20847: {"Type":"Armor","SubType":"NULL"},
20852: {"Type":"Armor","SubType":"NULL"},
20853: {"Type":"Armor","SubType":"NULL"},
20854: {"Type":"Armor","SubType":"NULL"},
20855: {"Type":"Armor","SubType":"NULL"},
20856: {"Type":"Armor","SubType":"NULL"},
20857: {"Type":"Armor","SubType":"NULL"},
20858: {"Type":"Armor","SubType":"NULL"},
20859: {"Type":"Armor","SubType":"NULL"},
20860: {"Type":"Armor","SubType":"NULL"},
20861: {"Type":"Armor","SubType":"NULL"},
20862: {"Type":"Armor","SubType":"NULL"},
20863: {"Type":"Armor","SubType":"NULL"},
20864: {"Type":"Armor","SubType":"NULL"},
20865: {"Type":"Armor","SubType":"NULL"},
20866: {"Type":"Armor","SubType":"NULL"},
20867: {"Type":"Armor","SubType":"NULL"},
20868: {"Type":"Armor","SubType":"NULL"},
20869: {"Type":"Armor","SubType":"NULL"},
20870: {"Type":"Armor","SubType":"NULL"},
20871: {"Type":"Armor","SubType":"NULL"},
20872: {"Type":"Armor","SubType":"NULL"},
20873: {"Type":"Armor","SubType":"NULL"},
20874: {"Type":"Armor","SubType":"NULL"},
20875: {"Type":"Armor","SubType":"NULL"},
20876: {"Type":"Armor","SubType":"NULL"},
20877: {"Type":"Armor","SubType":"NULL"},
20900: {"Type":"Armor","SubType":"NULL"},
20902: {"Type":"Armor","SubType":"NULL"},
20903: {"Type":"Armor","SubType":"NULL"},
20904: {"Type":"Armor","SubType":"NULL"},
20905: {"Type":"Armor","SubType":"NULL"},
20906: {"Type":"Armor","SubType":"NULL"},
20907: {"Type":"Armor","SubType":"NULL"},
20908: {"Type":"Armor","SubType":"NULL"},
20909: {"Type":"Armor","SubType":"NULL"},
20910: {"Type":"Armor","SubType":"NULL"},
20915: {"Type":"Armor","SubType":"NULL"},
20916: {"Type":"Armor","SubType":"NULL"},
20917: {"Type":"Armor","SubType":"NULL"},
20918: {"Type":"Armor","SubType":"NULL"},
20922: {"Type":"Armor","SubType":"NULL"},
20923: {"Type":"Armor","SubType":"NULL"},
20924: {"Type":"Armor","SubType":"NULL"},
20925: {"Type":"Armor","SubType":"NULL"},
20926: {"Type":"Armor","SubType":"NULL"},
20927: {"Type":"Armor","SubType":"NULL"},
20928: {"Type":"Armor","SubType":"NULL"},
20929: {"Type":"Armor","SubType":"NULL"},
20931: {"Type":"Armor","SubType":"NULL"},
20932: {"Type":"Armor","SubType":"NULL"},
20933: {"Type":"Armor","SubType":"NULL"},
20934: {"Type":"Armor","SubType":"NULL"},
20935: {"Type":"Armor","SubType":"NULL"},
20936: {"Type":"Armor","SubType":"NULL"},
20937: {"Type":"Armor","SubType":"NULL"},
20938: {"Type":"Armor","SubType":"NULL"},
20939: {"Type":"Armor","SubType":"NULL"},
20940: {"Type":"Armor","SubType":"NULL"},
20941: {"Type":"Armor","SubType":"NULL"},
20942: {"Type":"Armor","SubType":"NULL"},
20943: {"Type":"Armor","SubType":"NULL"},
20944: {"Type":"Armor","SubType":"NULL"},
20945: {"Type":"Armor","SubType":"NULL"},
20946: {"Type":"Armor","SubType":"NULL"},
20947: {"Type":"Armor","SubType":"NULL"},
20948: {"Type":"Armor","SubType":"NULL"},
20949: {"Type":"Armor","SubType":"NULL"},
20951: {"Type":"Armor","SubType":"NULL"},
20952: {"Type":"Armor","SubType":"NULL"},
20953: {"Type":"Armor","SubType":"NULL"},
20954: {"Type":"Armor","SubType":"NULL"},
20955: {"Type":"Armor","SubType":"NULL"},
20962: {"Type":"Armor","SubType":"NULL"},
20963: {"Type":"Armor","SubType":"NULL"},
20964: {"Type":"Armor","SubType":"NULL"},
20965: {"Type":"Armor","SubType":"NULL"},
20966: {"Type":"Armor","SubType":"NULL"},
20967: {"Type":"Armor","SubType":"NULL"},
20968: {"Type":"Armor","SubType":"NULL"},
20969: {"Type":"Armor","SubType":"NULL"},
20970: {"Type":"Armor","SubType":"NULL"},
20971: {"Type":"Armor","SubType":"NULL"},
20972: {"Type":"Armor","SubType":"NULL"},
20973: {"Type":"Armor","SubType":"NULL"},
20976: {"Type":"Armor","SubType":"NULL"},
20983: {"Type":"Armor","SubType":"NULL"},
20984: {"Type":"Armor","SubType":"NULL"},
20985: {"Type":"Armor","SubType":"NULL"},
20986: {"Type":"Armor","SubType":"NULL"},
20987: {"Type":"Armor","SubType":"NULL"},
20988: {"Type":"Armor","SubType":"NULL"},
20989: {"Type":"Armor","SubType":"NULL"},
20990: {"Type":"Armor","SubType":"NULL"},
20991: {"Type":"Armor","SubType":"NULL"},
20992: {"Type":"Armor","SubType":"NULL"},
20993: {"Type":"Armor","SubType":"NULL"},
20994: {"Type":"Armor","SubType":"NULL"},
21000: {"Type":"Weapon","SubType":"2hSword"},
21001: {"Type":"Weapon","SubType":"2hSword"},
21002: {"Type":"Weapon","SubType":"2hSword"},
21003: {"Type":"Weapon","SubType":"2hSword"},
21004: {"Type":"Weapon","SubType":"2hSword"},
21005: {"Type":"Weapon","SubType":"2hSword"},
21006: {"Type":"Weapon","SubType":"2hSword"},
21007: {"Type":"Weapon","SubType":"2hSword"},
21008: {"Type":"Weapon","SubType":"2hSword"},
21009: {"Type":"Weapon","SubType":"2hSword"},
21010: {"Type":"Weapon","SubType":"2hSword"},
21011: {"Type":"Weapon","SubType":"2hSword"},
21012: {"Type":"Weapon","SubType":"2hSword"},
21013: {"Type":"Weapon","SubType":"2hSword"},
21014: {"Type":"Weapon","SubType":"2hSword"},
21015: {"Type":"Weapon","SubType":"2hSword"},
21016: {"Type":"Weapon","SubType":"2hSword"},
21018: {"Type":"Weapon","SubType":"2hSword"},
21019: {"Type":"Weapon","SubType":"2hSword"},
21023: {"Type":"Weapon","SubType":"2hSword"},
21024: {"Type":"Weapon","SubType":"2hSword"},
21026: {"Type":"Weapon","SubType":"2hSword"},
21027: {"Type":"Weapon","SubType":"2hSword"},
21028: {"Type":"Weapon","SubType":"2hSword"},
21030: {"Type":"Weapon","SubType":"2hSword"},
21031: {"Type":"Weapon","SubType":"2hSword"},
21037: {"Type":"Weapon","SubType":"2hSword"},
21038: {"Type":"Weapon","SubType":"2hSword"},
21039: {"Type":"Weapon","SubType":"2hSword"},
21041: {"Type":"Weapon","SubType":"2hSword"},
21042: {"Type":"Weapon","SubType":"2hSword"},
21043: {"Type":"Weapon","SubType":"2hSword"},
21044: {"Type":"Weapon","SubType":"2hSword"},
21046: {"Type":"Weapon","SubType":"2hSword"},
21047: {"Type":"Weapon","SubType":"2hSword"},
21049: {"Type":"Weapon","SubType":"2hSword"},
21050: {"Type":"Weapon","SubType":"2hSword"},
21051: {"Type":"Weapon","SubType":"2hSword"},
21052: {"Type":"Weapon","SubType":"2hSword"},
21053: {"Type":"Weapon","SubType":"2hSword"},
21054: {"Type":"Weapon","SubType":"2hSword"},
21055: {"Type":"Weapon","SubType":"2hSword"},
21056: {"Type":"Weapon","SubType":"2hSword"},
21057: {"Type":"Weapon","SubType":"2hSword"},
21058: {"Type":"Weapon","SubType":"2hSword"},
21063: {"Type":"Weapon","SubType":"2hSword"},
21064: {"Type":"Weapon","SubType":"2hSword"},
21065: {"Type":"Weapon","SubType":"2hSword"},
21066: {"Type":"Weapon","SubType":"2hSword"},
21200: {"Type":"Armor","SubType":"NULL"},
21201: {"Type":"Armor","SubType":"NULL"},
21202: {"Type":"Armor","SubType":"NULL"},
21205: {"Type":"Armor","SubType":"NULL"},
21206: {"Type":"Armor","SubType":"NULL"},
21207: {"Type":"Armor","SubType":"NULL"},
21300: {"Type":"Armor","SubType":"NULL"},
21400: {"Type":"Armor","SubType":"NULL"},
22000: {"Type":"Armor","SubType":"NULL"},
22001: {"Type":"Armor","SubType":"NULL"},
22002: {"Type":"Armor","SubType":"NULL"},
22003: {"Type":"Armor","SubType":"NULL"},
22004: {"Type":"Armor","SubType":"NULL"},
22005: {"Type":"Armor","SubType":"NULL"},
22006: {"Type":"Armor","SubType":"NULL"},
22007: {"Type":"Armor","SubType":"NULL"},
22008: {"Type":"Armor","SubType":"NULL"},
22009: {"Type":"Armor","SubType":"NULL"},
22010: {"Type":"Armor","SubType":"NULL"},
22011: {"Type":"Armor","SubType":"NULL"},
22012: {"Type":"Armor","SubType":"NULL"},
22013: {"Type":"Armor","SubType":"NULL"},
22014: {"Type":"Armor","SubType":"NULL"},
22015: {"Type":"Armor","SubType":"NULL"},
22016: {"Type":"Armor","SubType":"NULL"},
22017: {"Type":"Armor","SubType":"NULL"},
22018: {"Type":"Armor","SubType":"NULL"},
22019: {"Type":"Armor","SubType":"NULL"},
22020: {"Type":"Armor","SubType":"NULL"},
22021: {"Type":"Armor","SubType":"NULL"},
22022: {"Type":"Armor","SubType":"NULL"},
22023: {"Type":"Armor","SubType":"NULL"},
22024: {"Type":"Armor","SubType":"NULL"},
22025: {"Type":"Armor","SubType":"NULL"},
22026: {"Type":"Armor","SubType":"NULL"},
22027: {"Type":"Armor","SubType":"NULL"},
22028: {"Type":"Armor","SubType":"NULL"},
22029: {"Type":"Armor","SubType":"NULL"},
22030: {"Type":"Armor","SubType":"NULL"},
22031: {"Type":"Armor","SubType":"NULL"},
22032: {"Type":"Armor","SubType":"NULL"},
22033: {"Type":"Armor","SubType":"NULL"},
22034: {"Type":"Armor","SubType":"NULL"},
22035: {"Type":"Armor","SubType":"NULL"},
22036: {"Type":"Armor","SubType":"NULL"},
22037: {"Type":"Armor","SubType":"NULL"},
22038: {"Type":"Armor","SubType":"NULL"},
22042: {"Type":"Armor","SubType":"NULL"},
22043: {"Type":"Armor","SubType":"NULL"},
22044: {"Type":"Armor","SubType":"NULL"},
22045: {"Type":"Armor","SubType":"NULL"},
22046: {"Type":"Armor","SubType":"NULL"},
22047: {"Type":"Armor","SubType":"NULL"},
22048: {"Type":"Armor","SubType":"NULL"},
22049: {"Type":"Armor","SubType":"NULL"},
22050: {"Type":"Armor","SubType":"NULL"},
22051: {"Type":"Armor","SubType":"NULL"},
22052: {"Type":"Armor","SubType":"NULL"},
22055: {"Type":"Armor","SubType":"NULL"},
22056: {"Type":"Armor","SubType":"NULL"},
22057: {"Type":"Armor","SubType":"NULL"},
22058: {"Type":"Armor","SubType":"NULL"},
22059: {"Type":"Armor","SubType":"NULL"},
22060: {"Type":"Armor","SubType":"NULL"},
22061: {"Type":"Armor","SubType":"NULL"},
22062: {"Type":"Armor","SubType":"NULL"},
22063: {"Type":"Armor","SubType":"NULL"},
22064: {"Type":"Armor","SubType":"NULL"},
22065: {"Type":"Armor","SubType":"NULL"},
22066: {"Type":"Armor","SubType":"NULL"},
22067: {"Type":"Armor","SubType":"NULL"},
22068: {"Type":"Armor","SubType":"NULL"},
22069: {"Type":"Armor","SubType":"NULL"},
22070: {"Type":"Armor","SubType":"NULL"},
22071: {"Type":"Armor","SubType":"NULL"},
22072: {"Type":"Armor","SubType":"NULL"},
22073: {"Type":"Armor","SubType":"NULL"},
22074: {"Type":"Armor","SubType":"NULL"},
22075: {"Type":"Armor","SubType":"NULL"},
22076: {"Type":"Armor","SubType":"NULL"},
22077: {"Type":"Armor","SubType":"NULL"},
22078: {"Type":"Armor","SubType":"NULL"},
22079: {"Type":"Armor","SubType":"NULL"},
22080: {"Type":"Armor","SubType":"NULL"},
22081: {"Type":"Armor","SubType":"NULL"},
22082: {"Type":"Armor","SubType":"NULL"},
22083: {"Type":"Armor","SubType":"NULL"},
22084: {"Type":"Armor","SubType":"NULL"},
22085: {"Type":"Armor","SubType":"NULL"},
22089: {"Type":"Armor","SubType":"NULL"},
22091: {"Type":"Armor","SubType":"NULL"},
22092: {"Type":"Armor","SubType":"NULL"},
22093: {"Type":"Armor","SubType":"NULL"},
22094: {"Type":"Armor","SubType":"NULL"},
22095: {"Type":"Armor","SubType":"NULL"},
22096: {"Type":"Armor","SubType":"NULL"},
22097: {"Type":"Armor","SubType":"NULL"},
22098: {"Type":"Armor","SubType":"NULL"},
22099: {"Type":"Armor","SubType":"NULL"},
22100: {"Type":"Armor","SubType":"NULL"},
22101: {"Type":"Armor","SubType":"NULL"},
22102: {"Type":"Armor","SubType":"NULL"},
22103: {"Type":"Armor","SubType":"NULL"},
22104: {"Type":"Armor","SubType":"NULL"},
22105: {"Type":"Armor","SubType":"NULL"},
22106: {"Type":"Armor","SubType":"NULL"},
22107: {"Type":"Armor","SubType":"NULL"},
22108: {"Type":"Armor","SubType":"NULL"},
22109: {"Type":"Armor","SubType":"NULL"},
22110: {"Type":"Armor","SubType":"NULL"},
22111: {"Type":"Armor","SubType":"NULL"},
22112: {"Type":"Armor","SubType":"NULL"},
22113: {"Type":"Armor","SubType":"NULL"},
22114: {"Type":"Armor","SubType":"NULL"},
22115: {"Type":"Armor","SubType":"NULL"},
22116: {"Type":"Armor","SubType":"NULL"},
22117: {"Type":"Armor","SubType":"NULL"},
22118: {"Type":"Armor","SubType":"NULL"},
22119: {"Type":"Armor","SubType":"NULL"},
22120: {"Type":"Armor","SubType":"NULL"},
22122: {"Type":"Armor","SubType":"NULL"},
22123: {"Type":"Armor","SubType":"NULL"},
22124: {"Type":"Armor","SubType":"NULL"},
22125: {"Type":"Armor","SubType":"NULL"},
22126: {"Type":"Armor","SubType":"NULL"},
22127: {"Type":"Armor","SubType":"NULL"},
22128: {"Type":"Armor","SubType":"NULL"},
22129: {"Type":"Armor","SubType":"NULL"},
22131: {"Type":"Armor","SubType":"NULL"},
22132: {"Type":"Armor","SubType":"NULL"},
22133: {"Type":"Armor","SubType":"NULL"},
22134: {"Type":"Armor","SubType":"NULL"},
22138: {"Type":"Armor","SubType":"NULL"},
22139: {"Type":"Armor","SubType":"NULL"},
22140: {"Type":"Armor","SubType":"NULL"},
22141: {"Type":"Armor","SubType":"NULL"},
22142: {"Type":"Armor","SubType":"NULL"},
22143: {"Type":"Armor","SubType":"NULL"},
22144: {"Type":"Armor","SubType":"NULL"},
22145: {"Type":"Armor","SubType":"NULL"},
22146: {"Type":"Armor","SubType":"NULL"},
22147: {"Type":"Armor","SubType":"NULL"},
22148: {"Type":"Armor","SubType":"NULL"},
22149: {"Type":"Armor","SubType":"NULL"},
22150: {"Type":"Armor","SubType":"NULL"},
22151: {"Type":"Armor","SubType":"NULL"},
22152: {"Type":"Armor","SubType":"NULL"},
22153: {"Type":"Armor","SubType":"NULL"},
22154: {"Type":"Armor","SubType":"NULL"},
22155: {"Type":"Armor","SubType":"NULL"},
22156: {"Type":"Armor","SubType":"NULL"},
22157: {"Type":"Armor","SubType":"NULL"},
22158: {"Type":"Armor","SubType":"NULL"},
22159: {"Type":"Armor","SubType":"NULL"},
22160: {"Type":"Armor","SubType":"NULL"},
22167: {"Type":"Armor","SubType":"NULL"},
22168: {"Type":"Armor","SubType":"NULL"},
22169: {"Type":"Armor","SubType":"NULL"},
22170: {"Type":"Armor","SubType":"NULL"},
22171: {"Type":"Armor","SubType":"NULL"},
22172: {"Type":"Armor","SubType":"NULL"},
22173: {"Type":"Armor","SubType":"NULL"},
22174: {"Type":"Armor","SubType":"NULL"},
22178: {"Type":"Armor","SubType":"NULL"},
22182: {"Type":"Armor","SubType":"NULL"},
22185: {"Type":"Armor","SubType":"NULL"},
22186: {"Type":"Armor","SubType":"NULL"},
22187: {"Type":"Armor","SubType":"NULL"},
22189: {"Type":"Armor","SubType":"NULL"},
22190: {"Type":"Armor","SubType":"NULL"},
22191: {"Type":"Armor","SubType":"NULL"},
22192: {"Type":"Armor","SubType":"NULL"},
22193: {"Type":"Armor","SubType":"NULL"},
22194: {"Type":"Armor","SubType":"NULL"},
22195: {"Type":"Armor","SubType":"NULL"},
22196: {"Type":"Armor","SubType":"NULL"},
22197: {"Type":"Armor","SubType":"NULL"},
22198: {"Type":"Armor","SubType":"NULL"},
22199: {"Type":"Armor","SubType":"NULL"},
22200: {"Type":"Armor","SubType":"NULL"},
22201: {"Type":"Armor","SubType":"NULL"},
22202: {"Type":"Armor","SubType":"NULL"},
22203: {"Type":"Armor","SubType":"NULL"},
22204: {"Type":"Armor","SubType":"NULL"},
22206: {"Type":"Armor","SubType":"NULL"},
22207: {"Type":"Armor","SubType":"NULL"},
22208: {"Type":"Armor","SubType":"NULL"},
22209: {"Type":"Armor","SubType":"NULL"},
22210: {"Type":"Armor","SubType":"NULL"},
22211: {"Type":"Armor","SubType":"NULL"},
22212: {"Type":"Armor","SubType":"NULL"},
22213: {"Type":"Armor","SubType":"NULL"},
22214: {"Type":"Armor","SubType":"NULL"},
22215: {"Type":"Armor","SubType":"NULL"},
22216: {"Type":"Armor","SubType":"NULL"},
22221: {"Type":"Armor","SubType":"NULL"},
22222: {"Type":"Armor","SubType":"NULL"},
22225: {"Type":"Armor","SubType":"NULL"},
22227: {"Type":"Armor","SubType":"NULL"},
22228: {"Type":"Armor","SubType":"NULL"},
22230: {"Type":"Armor","SubType":"NULL"},
22231: {"Type":"Armor","SubType":"NULL"},
22233: {"Type":"Armor","SubType":"NULL"},
22234: {"Type":"Armor","SubType":"NULL"},
22238: {"Type":"Armor","SubType":"NULL"},
22240: {"Type":"Armor","SubType":"NULL"},
22241: {"Type":"Armor","SubType":"NULL"},
22242: {"Type":"Armor","SubType":"NULL"},
22243: {"Type":"Armor","SubType":"NULL"},
22244: {"Type":"Armor","SubType":"NULL"},
22245: {"Type":"Armor","SubType":"NULL"},
22249: {"Type":"Armor","SubType":"NULL"},
22257: {"Type":"Armor","SubType":"NULL"},
22258: {"Type":"Armor","SubType":"NULL"},
22259: {"Type":"Armor","SubType":"NULL"},
22507: {"Type":"Usable","SubType":"NULL"},
22508: {"Type":"Usable","SubType":"NULL"},
22510: {"Type":"Usable","SubType":"NULL"},
22511: {"Type":"Usable","SubType":"NULL"},
22513: {"Type":"Usable","SubType":"NULL"},
22514: {"Type":"Usable","SubType":"NULL"},
22515: {"Type":"DelayConsume","SubType":"NULL"},
22516: {"Type":"Usable","SubType":"NULL"},
22517: {"Type":"Usable","SubType":"NULL"},
22518: {"Type":"Cash","SubType":"NULL"},
22519: {"Type":"Etc","SubType":"NULL"},
22520: {"Type":"Etc","SubType":"NULL"},
22521: {"Type":"Usable","SubType":"NULL"},
22522: {"Type":"Cash","SubType":"NULL"},
22523: {"Type":"Cash","SubType":"NULL"},
22524: {"Type":"Cash","SubType":"NULL"},
22525: {"Type":"Cash","SubType":"NULL"},
22526: {"Type":"Cash","SubType":"NULL"},
22527: {"Type":"Cash","SubType":"NULL"},
22528: {"Type":"Cash","SubType":"NULL"},
22529: {"Type":"DelayConsume","SubType":"NULL"},
22530: {"Type":"Cash","SubType":"NULL"},
22531: {"Type":"Cash","SubType":"NULL"},
22532: {"Type":"Cash","SubType":"NULL"},
22533: {"Type":"Usable","SubType":"NULL"},
22534: {"Type":"Cash","SubType":"NULL"},
22535: {"Type":"Usable","SubType":"NULL"},
22536: {"Type":"Usable","SubType":"NULL"},
22537: {"Type":"Usable","SubType":"NULL"},
22538: {"Type":"Usable","SubType":"NULL"},
22539: {"Type":"Usable","SubType":"NULL"},
22540: {"Type":"DelayConsume","SubType":"NULL"},
22541: {"Type":"Usable","SubType":"NULL"},
22542: {"Type":"Usable","SubType":"NULL"},
22543: {"Type":"Usable","SubType":"NULL"},
22544: {"Type":"Usable","SubType":"NULL"},
22545: {"Type":"Usable","SubType":"NULL"},
22546: {"Type":"Usable","SubType":"NULL"},
22547: {"Type":"Usable","SubType":"NULL"},
22548: {"Type":"Usable","SubType":"NULL"},
22549: {"Type":"Usable","SubType":"NULL"},
22550: {"Type":"Usable","SubType":"NULL"},
22551: {"Type":"Usable","SubType":"NULL"},
22552: {"Type":"Usable","SubType":"NULL"},
22553: {"Type":"Usable","SubType":"NULL"},
22554: {"Type":"Usable","SubType":"NULL"},
22555: {"Type":"Healing","SubType":"NULL"},
22556: {"Type":"Healing","SubType":"NULL"},
22557: {"Type":"Healing","SubType":"NULL"},
22558: {"Type":"Usable","SubType":"NULL"},
22559: {"Type":"DelayConsume","SubType":"NULL"},
22563: {"Type":"Usable","SubType":"NULL"},
22566: {"Type":"Usable","SubType":"NULL"},
22567: {"Type":"Usable","SubType":"NULL"},
22568: {"Type":"Usable","SubType":"NULL"},
22569: {"Type":"Usable","SubType":"NULL"},
22571: {"Type":"DelayConsume","SubType":"NULL"},
22589: {"Type":"Etc","SubType":"NULL"},
22590: {"Type":"Etc","SubType":"NULL"},
22591: {"Type":"Etc","SubType":"NULL"},
22592: {"Type":"Usable","SubType":"NULL"},
22605: {"Type":"Usable","SubType":"NULL"},
22610: {"Type":"Usable","SubType":"NULL"},
22611: {"Type":"Usable","SubType":"NULL"},
22612: {"Type":"DelayConsume","SubType":"NULL"},
22613: {"Type":"DelayConsume","SubType":"NULL"},
22614: {"Type":"Usable","SubType":"NULL"},
22617: {"Type":"Usable","SubType":"NULL"},
22618: {"Type":"Cash","SubType":"NULL"},
22619: {"Type":"Usable","SubType":"NULL"},
22620: {"Type":"Usable","SubType":"NULL"},
22621: {"Type":"Usable","SubType":"NULL"},
22623: {"Type":"Cash","SubType":"NULL"},
22624: {"Type":"Healing","SubType":"NULL"},
22625: {"Type":"Usable","SubType":"NULL"},
22626: {"Type":"Usable","SubType":"NULL"},
22627: {"Type":"Usable","SubType":"NULL"},
22628: {"Type":"Cash","SubType":"NULL"},
22629: {"Type":"Cash","SubType":"NULL"},
22630: {"Type":"Cash","SubType":"NULL"},
22631: {"Type":"Cash","SubType":"NULL"},
22640: {"Type":"Cash","SubType":"NULL"},
22641: {"Type":"Cash","SubType":"NULL"},
22642: {"Type":"Cash","SubType":"NULL"},
22643: {"Type":"Cash","SubType":"NULL"},
22644: {"Type":"Cash","SubType":"NULL"},
22645: {"Type":"Cash","SubType":"NULL"},
22646: {"Type":"Cash","SubType":"NULL"},
22647: {"Type":"Cash","SubType":"NULL"},
22648: {"Type":"Usable","SubType":"NULL"},
22649: {"Type":"Usable","SubType":"NULL"},
22652: {"Type":"Usable","SubType":"NULL"},
22653: {"Type":"Usable","SubType":"NULL"},
22654: {"Type":"Usable","SubType":"NULL"},
22657: {"Type":"Healing","SubType":"NULL"},
22658: {"Type":"Healing","SubType":"NULL"},
22659: {"Type":"Healing","SubType":"NULL"},
22660: {"Type":"Usable","SubType":"NULL"},
22668: {"Type":"Usable","SubType":"NULL"},
22669: {"Type":"Usable","SubType":"NULL"},
22670: {"Type":"Usable","SubType":"NULL"},
22671: {"Type":"Usable","SubType":"NULL"},
22672: {"Type":"Usable","SubType":"NULL"},
22673: {"Type":"Usable","SubType":"NULL"},
22674: {"Type":"Usable","SubType":"NULL"},
22675: {"Type":"Usable","SubType":"NULL"},
22676: {"Type":"Usable","SubType":"NULL"},
22679: {"Type":"Usable","SubType":"NULL"},
22685: {"Type":"Usable","SubType":"NULL"},
22686: {"Type":"Healing","SubType":"NULL"},
22687: {"Type":"DelayConsume","SubType":"NULL"},
22691: {"Type":"Healing","SubType":"NULL"},
22692: {"Type":"Healing","SubType":"NULL"},
22693: {"Type":"Healing","SubType":"NULL"},
22694: {"Type":"Healing","SubType":"NULL"},
22695: {"Type":"Healing","SubType":"NULL"},
22699: {"Type":"Usable","SubType":"NULL"},
22700: {"Type":"Usable","SubType":"NULL"},
22701: {"Type":"Usable","SubType":"NULL"},
22702: {"Type":"DelayConsume","SubType":"NULL"},
22703: {"Type":"DelayConsume","SubType":"NULL"},
22704: {"Type":"DelayConsume","SubType":"NULL"},
22705: {"Type":"DelayConsume","SubType":"NULL"},
22706: {"Type":"DelayConsume","SubType":"NULL"},
22707: {"Type":"DelayConsume","SubType":"NULL"},
22708: {"Type":"Usable","SubType":"NULL"},
22717: {"Type":"Etc","SubType":"NULL"},
22718: {"Type":"Etc","SubType":"NULL"},
22719: {"Type":"Etc","SubType":"NULL"},
22720: {"Type":"Etc","SubType":"NULL"},
22721: {"Type":"Usable","SubType":"NULL"},
22734: {"Type":"Cash","SubType":"NULL"},
22735: {"Type":"Usable","SubType":"NULL"},
22736: {"Type":"Usable","SubType":"NULL"},
22737: {"Type":"Usable","SubType":"NULL"},
22738: {"Type":"Usable","SubType":"NULL"},
22739: {"Type":"Usable","SubType":"NULL"},
22740: {"Type":"Usable","SubType":"NULL"},
22741: {"Type":"Usable","SubType":"NULL"},
22742: {"Type":"Usable","SubType":"NULL"},
22743: {"Type":"Usable","SubType":"NULL"},
22744: {"Type":"Usable","SubType":"NULL"},
22745: {"Type":"Usable","SubType":"NULL"},
22746: {"Type":"Usable","SubType":"NULL"},
22747: {"Type":"Usable","SubType":"NULL"},
22748: {"Type":"Usable","SubType":"NULL"},
22749: {"Type":"Usable","SubType":"NULL"},
22750: {"Type":"Usable","SubType":"NULL"},
22751: {"Type":"Usable","SubType":"NULL"},
22752: {"Type":"Usable","SubType":"NULL"},
22753: {"Type":"Usable","SubType":"NULL"},
22754: {"Type":"Usable","SubType":"NULL"},
22755: {"Type":"Usable","SubType":"NULL"},
22756: {"Type":"Usable","SubType":"NULL"},
22757: {"Type":"Cash","SubType":"NULL"},
22758: {"Type":"Cash","SubType":"NULL"},
22759: {"Type":"Cash","SubType":"NULL"},
22760: {"Type":"Usable","SubType":"NULL"},
22761: {"Type":"Usable","SubType":"NULL"},
22762: {"Type":"Usable","SubType":"NULL"},
22764: {"Type":"Usable","SubType":"NULL"},
22770: {"Type":"Healing","SubType":"NULL"},
22771: {"Type":"Healing","SubType":"NULL"},
22772: {"Type":"Healing","SubType":"NULL"},
22773: {"Type":"Healing","SubType":"NULL"},
22774: {"Type":"Healing","SubType":"NULL"},
22775: {"Type":"Healing","SubType":"NULL"},
22776: {"Type":"Healing","SubType":"NULL"},
22777: {"Type":"Usable","SubType":"NULL"},
22781: {"Type":"Usable","SubType":"NULL"},
22782: {"Type":"Usable","SubType":"NULL"},
22783: {"Type":"Usable","SubType":"NULL"},
22784: {"Type":"Usable","SubType":"NULL"},
22802: {"Type":"Etc","SubType":"NULL"},
22808: {"Type":"Usable","SubType":"NULL"},
22812: {"Type":"Usable","SubType":"NULL"},
22813: {"Type":"Usable","SubType":"NULL"},
22814: {"Type":"Usable","SubType":"NULL"},
22816: {"Type":"Usable","SubType":"NULL"},
22817: {"Type":"Usable","SubType":"NULL"},
22818: {"Type":"Usable","SubType":"NULL"},
22819: {"Type":"Usable","SubType":"NULL"},
22820: {"Type":"Usable","SubType":"NULL"},
22821: {"Type":"Usable","SubType":"NULL"},
22822: {"Type":"Usable","SubType":"NULL"},
22823: {"Type":"Usable","SubType":"NULL"},
22825: {"Type":"Usable","SubType":"NULL"},
22826: {"Type":"Usable","SubType":"NULL"},
22827: {"Type":"Usable","SubType":"NULL"},
22828: {"Type":"Usable","SubType":"NULL"},
22829: {"Type":"Usable","SubType":"NULL"},
22837: {"Type":"Usable","SubType":"NULL"},
22838: {"Type":"Usable","SubType":"NULL"},
22839: {"Type":"Usable","SubType":"NULL"},
22841: {"Type":"Usable","SubType":"NULL"},
22842: {"Type":"Usable","SubType":"NULL"},
22843: {"Type":"Usable","SubType":"NULL"},
22844: {"Type":"Usable","SubType":"NULL"},
22845: {"Type":"Usable","SubType":"NULL"},
22846: {"Type":"Usable","SubType":"NULL"},
22847: {"Type":"Usable","SubType":"NULL"},
22848: {"Type":"Usable","SubType":"NULL"},
22849: {"Type":"Usable","SubType":"NULL"},
22850: {"Type":"Usable","SubType":"NULL"},
22851: {"Type":"Usable","SubType":"NULL"},
22852: {"Type":"Usable","SubType":"NULL"},
22853: {"Type":"Usable","SubType":"NULL"},
22854: {"Type":"Usable","SubType":"NULL"},
22855: {"Type":"Usable","SubType":"NULL"},
22856: {"Type":"Usable","SubType":"NULL"},
22857: {"Type":"Usable","SubType":"NULL"},
22858: {"Type":"Cash","SubType":"NULL"},
22859: {"Type":"Usable","SubType":"NULL"},
22860: {"Type":"Usable","SubType":"NULL"},
22861: {"Type":"Usable","SubType":"NULL"},
22868: {"Type":"Usable","SubType":"NULL"},
22869: {"Type":"Usable","SubType":"NULL"},
22870: {"Type":"Usable","SubType":"NULL"},
22873: {"Type":"Usable","SubType":"NULL"},
22874: {"Type":"Usable","SubType":"NULL"},
22875: {"Type":"Card","SubType":"NULL"},
22876: {"Type":"Usable","SubType":"NULL"},
22881: {"Type":"Usable","SubType":"NULL"},
22882: {"Type":"Usable","SubType":"NULL"},
22883: {"Type":"Usable","SubType":"NULL"},
22884: {"Type":"Usable","SubType":"NULL"},
22885: {"Type":"Usable","SubType":"NULL"},
22886: {"Type":"Usable","SubType":"NULL"},
22887: {"Type":"Usable","SubType":"NULL"},
22888: {"Type":"Usable","SubType":"NULL"},
22893: {"Type":"Usable","SubType":"NULL"},
22894: {"Type":"Usable","SubType":"NULL"},
22895: {"Type":"Usable","SubType":"NULL"},
22896: {"Type":"Usable","SubType":"NULL"},
22899: {"Type":"DelayConsume","SubType":"NULL"},
22901: {"Type":"Usable","SubType":"NULL"},
22902: {"Type":"Usable","SubType":"NULL"},
22905: {"Type":"Usable","SubType":"NULL"},
22906: {"Type":"Usable","SubType":"NULL"},
22907: {"Type":"Usable","SubType":"NULL"},
22908: {"Type":"Usable","SubType":"NULL"},
22909: {"Type":"Usable","SubType":"NULL"},
22910: {"Type":"Usable","SubType":"NULL"},
22911: {"Type":"Usable","SubType":"NULL"},
22912: {"Type":"Usable","SubType":"NULL"},
22913: {"Type":"Usable","SubType":"NULL"},
22914: {"Type":"Usable","SubType":"NULL"},
22915: {"Type":"Usable","SubType":"NULL"},
22916: {"Type":"Usable","SubType":"NULL"},
22917: {"Type":"Usable","SubType":"NULL"},
22918: {"Type":"Usable","SubType":"NULL"},
22919: {"Type":"Usable","SubType":"NULL"},
22920: {"Type":"Usable","SubType":"NULL"},
22921: {"Type":"Usable","SubType":"NULL"},
22922: {"Type":"Usable","SubType":"NULL"},
22923: {"Type":"Usable","SubType":"NULL"},
22924: {"Type":"Usable","SubType":"NULL"},
22925: {"Type":"Usable","SubType":"NULL"},
22926: {"Type":"Usable","SubType":"NULL"},
22927: {"Type":"Usable","SubType":"NULL"},
22928: {"Type":"Usable","SubType":"NULL"},
22929: {"Type":"Usable","SubType":"NULL"},
22930: {"Type":"Usable","SubType":"NULL"},
22931: {"Type":"Usable","SubType":"NULL"},
22932: {"Type":"Usable","SubType":"NULL"},
22933: {"Type":"Usable","SubType":"NULL"},
22934: {"Type":"Usable","SubType":"NULL"},
22935: {"Type":"Usable","SubType":"NULL"},
22936: {"Type":"Usable","SubType":"NULL"},
22937: {"Type":"Usable","SubType":"NULL"},
22938: {"Type":"Usable","SubType":"NULL"},
22943: {"Type":"Usable","SubType":"NULL"},
22944: {"Type":"Usable","SubType":"NULL"},
22945: {"Type":"Usable","SubType":"NULL"},
22946: {"Type":"Usable","SubType":"NULL"},
22947: {"Type":"Cash","SubType":"NULL"},
22948: {"Type":"Cash","SubType":"NULL"},
22949: {"Type":"Cash","SubType":"NULL"},
22950: {"Type":"Cash","SubType":"NULL"},
22951: {"Type":"Cash","SubType":"NULL"},
22952: {"Type":"Cash","SubType":"NULL"},
22953: {"Type":"Usable","SubType":"NULL"},
22971: {"Type":"Usable","SubType":"NULL"},
22972: {"Type":"Usable","SubType":"NULL"},
22973: {"Type":"Usable","SubType":"NULL"},
22974: {"Type":"Usable","SubType":"NULL"},
22975: {"Type":"Usable","SubType":"NULL"},
22976: {"Type":"Usable","SubType":"NULL"},
22977: {"Type":"Usable","SubType":"NULL"},
22978: {"Type":"Usable","SubType":"NULL"},
22979: {"Type":"Usable","SubType":"NULL"},
22980: {"Type":"Usable","SubType":"NULL"},
22982: {"Type":"Usable","SubType":"NULL"},
22983: {"Type":"Usable","SubType":"NULL"},
22984: {"Type":"Healing","SubType":"NULL"},
22985: {"Type":"Healing","SubType":"NULL"},
22988: {"Type":"Usable","SubType":"NULL"},
22989: {"Type":"Usable","SubType":"NULL"},
22991: {"Type":"Usable","SubType":"NULL"},
22996: {"Type":"Usable","SubType":"NULL"},
22997: {"Type":"DelayConsume","SubType":"NULL"},
22998: {"Type":"DelayConsume","SubType":"NULL"},
22999: {"Type":"Usable","SubType":"NULL"},
23001: {"Type":"Usable","SubType":"NULL"},
23007: {"Type":"Usable","SubType":"NULL"},
23008: {"Type":"Usable","SubType":"NULL"},
23010: {"Type":"Usable","SubType":"NULL"},
23011: {"Type":"Usable","SubType":"NULL"},
23012: {"Type":"Usable","SubType":"NULL"},
23013: {"Type":"Usable","SubType":"NULL"},
23014: {"Type":"Usable","SubType":"NULL"},
23015: {"Type":"Usable","SubType":"NULL"},
23016: {"Type":"Usable","SubType":"NULL"},
23021: {"Type":"Usable","SubType":"NULL"},
23022: {"Type":"Usable","SubType":"NULL"},
23023: {"Type":"DelayConsume","SubType":"NULL"},
23024: {"Type":"Usable","SubType":"NULL"},
23025: {"Type":"Usable","SubType":"NULL"},
23026: {"Type":"Usable","SubType":"NULL"},
23027: {"Type":"Usable","SubType":"NULL"},
23028: {"Type":"Usable","SubType":"NULL"},
23029: {"Type":"Usable","SubType":"NULL"},
23030: {"Type":"Usable","SubType":"NULL"},
23031: {"Type":"Usable","SubType":"NULL"},
23032: {"Type":"Usable","SubType":"NULL"},
23033: {"Type":"Usable","SubType":"NULL"},
23034: {"Type":"Usable","SubType":"NULL"},
23036: {"Type":"Usable","SubType":"NULL"},
23037: {"Type":"Usable","SubType":"NULL"},
23038: {"Type":"Usable","SubType":"NULL"},
23039: {"Type":"Usable","SubType":"NULL"},
23040: {"Type":"Usable","SubType":"NULL"},
23041: {"Type":"Usable","SubType":"NULL"},
23042: {"Type":"Healing","SubType":"NULL"},
23043: {"Type":"Usable","SubType":"NULL"},
23044: {"Type":"Usable","SubType":"NULL"},
23045: {"Type":"DelayConsume","SubType":"NULL"},
23046: {"Type":"Usable","SubType":"NULL"},
23047: {"Type":"Usable","SubType":"NULL"},
23048: {"Type":"Usable","SubType":"NULL"},
23049: {"Type":"Usable","SubType":"NULL"},
23050: {"Type":"Usable","SubType":"NULL"},
23051: {"Type":"Usable","SubType":"NULL"},
23052: {"Type":"Usable","SubType":"NULL"},
23058: {"Type":"Usable","SubType":"NULL"},
23059: {"Type":"Usable","SubType":"NULL"},
23060: {"Type":"Usable","SubType":"NULL"},
23061: {"Type":"Usable","SubType":"NULL"},
23062: {"Type":"Usable","SubType":"NULL"},
23063: {"Type":"Usable","SubType":"NULL"},
23069: {"Type":"Usable","SubType":"NULL"},
23070: {"Type":"Usable","SubType":"NULL"},
23072: {"Type":"Usable","SubType":"NULL"},
23073: {"Type":"Usable","SubType":"NULL"},
23074: {"Type":"Usable","SubType":"NULL"},
23075: {"Type":"Usable","SubType":"NULL"},
23076: {"Type":"Usable","SubType":"NULL"},
23077: {"Type":"Usable","SubType":"NULL"},
23078: {"Type":"Usable","SubType":"NULL"},
23079: {"Type":"DelayConsume","SubType":"NULL"},
23080: {"Type":"Usable","SubType":"NULL"},
23081: {"Type":"Usable","SubType":"NULL"},
23082: {"Type":"Usable","SubType":"NULL"},
23083: {"Type":"Usable","SubType":"NULL"},
23084: {"Type":"Usable","SubType":"NULL"},
23085: {"Type":"Usable","SubType":"NULL"},
23086: {"Type":"Usable","SubType":"NULL"},
23087: {"Type":"Usable","SubType":"NULL"},
23094: {"Type":"Usable","SubType":"NULL"},
23095: {"Type":"Usable","SubType":"NULL"},
23096: {"Type":"Usable","SubType":"NULL"},
23097: {"Type":"Usable","SubType":"NULL"},
23098: {"Type":"Usable","SubType":"NULL"},
23100: {"Type":"DelayConsume","SubType":"NULL"},
23106: {"Type":"Usable","SubType":"NULL"},
23107: {"Type":"Usable","SubType":"NULL"},
23115: {"Type":"Usable","SubType":"NULL"},
23116: {"Type":"Usable","SubType":"NULL"},
23119: {"Type":"Usable","SubType":"NULL"},
23120: {"Type":"Usable","SubType":"NULL"},
23123: {"Type":"Usable","SubType":"NULL"},
23124: {"Type":"Usable","SubType":"NULL"},
23125: {"Type":"Usable","SubType":"NULL"},
23126: {"Type":"Usable","SubType":"NULL"},
23127: {"Type":"Usable","SubType":"NULL"},
23128: {"Type":"Usable","SubType":"NULL"},
23129: {"Type":"Usable","SubType":"NULL"},
23130: {"Type":"Usable","SubType":"NULL"},
23131: {"Type":"Usable","SubType":"NULL"},
23132: {"Type":"Usable","SubType":"NULL"},
23133: {"Type":"Usable","SubType":"NULL"},
23134: {"Type":"Usable","SubType":"NULL"},
23135: {"Type":"Usable","SubType":"NULL"},
23136: {"Type":"Usable","SubType":"NULL"},
23137: {"Type":"Usable","SubType":"NULL"},
23142: {"Type":"Usable","SubType":"NULL"},
23143: {"Type":"Usable","SubType":"NULL"},
23144: {"Type":"Usable","SubType":"NULL"},
23145: {"Type":"Usable","SubType":"NULL"},
23148: {"Type":"Usable","SubType":"NULL"},
23149: {"Type":"Usable","SubType":"NULL"},
23150: {"Type":"Usable","SubType":"NULL"},
23151: {"Type":"DelayConsume","SubType":"NULL"},
23152: {"Type":"DelayConsume","SubType":"NULL"},
23153: {"Type":"DelayConsume","SubType":"NULL"},
23154: {"Type":"DelayConsume","SubType":"NULL"},
23159: {"Type":"Usable","SubType":"NULL"},
23160: {"Type":"Usable","SubType":"NULL"},
23161: {"Type":"Usable","SubType":"NULL"},
23162: {"Type":"Usable","SubType":"NULL"},
23165: {"Type":"Usable","SubType":"NULL"},
23167: {"Type":"Usable","SubType":"NULL"},
23168: {"Type":"Usable","SubType":"NULL"},
23169: {"Type":"Usable","SubType":"NULL"},
23170: {"Type":"DelayConsume","SubType":"NULL"},
23171: {"Type":"Usable","SubType":"NULL"},
23172: {"Type":"Usable","SubType":"NULL"},
23173: {"Type":"Usable","SubType":"NULL"},
23174: {"Type":"Usable","SubType":"NULL"},
23175: {"Type":"DelayConsume","SubType":"NULL"},
23176: {"Type":"Usable","SubType":"NULL"},
23177: {"Type":"Usable","SubType":"NULL"},
23178: {"Type":"Usable","SubType":"NULL"},
23187: {"Type":"Usable","SubType":"NULL"},
23188: {"Type":"Usable","SubType":"NULL"},
23189: {"Type":"Usable","SubType":"NULL"},
23191: {"Type":"DelayConsume","SubType":"NULL"},
23192: {"Type":"DelayConsume","SubType":"NULL"},
23193: {"Type":"DelayConsume","SubType":"NULL"},
23194: {"Type":"DelayConsume","SubType":"NULL"},
23195: {"Type":"Usable","SubType":"NULL"},
23196: {"Type":"Cash","SubType":"NULL"},
23198: {"Type":"Usable","SubType":"NULL"},
23199: {"Type":"Usable","SubType":"NULL"},
23200: {"Type":"Usable","SubType":"NULL"},
23201: {"Type":"Usable","SubType":"NULL"},
23202: {"Type":"Usable","SubType":"NULL"},
23203: {"Type":"Usable","SubType":"NULL"},
23204: {"Type":"Usable","SubType":"NULL"},
23205: {"Type":"Usable","SubType":"NULL"},
23206: {"Type":"Usable","SubType":"NULL"},
23207: {"Type":"Usable","SubType":"NULL"},
23209: {"Type":"Usable","SubType":"NULL"},
23210: {"Type":"Usable","SubType":"NULL"},
23211: {"Type":"Usable","SubType":"NULL"},
23212: {"Type":"Usable","SubType":"NULL"},
23213: {"Type":"Usable","SubType":"NULL"},
23214: {"Type":"Usable","SubType":"NULL"},
23215: {"Type":"Usable","SubType":"NULL"},
23216: {"Type":"Usable","SubType":"NULL"},
23217: {"Type":"Usable","SubType":"NULL"},
23218: {"Type":"Usable","SubType":"NULL"},
23221: {"Type":"Usable","SubType":"NULL"},
23222: {"Type":"Usable","SubType":"NULL"},
23223: {"Type":"Usable","SubType":"NULL"},
23224: {"Type":"Usable","SubType":"NULL"},
23225: {"Type":"Usable","SubType":"NULL"},
23226: {"Type":"Usable","SubType":"NULL"},
23227: {"Type":"Usable","SubType":"NULL"},
23228: {"Type":"Healing","SubType":"NULL"},
23229: {"Type":"DelayConsume","SubType":"NULL"},
23234: {"Type":"Usable","SubType":"NULL"},
23235: {"Type":"Usable","SubType":"NULL"},
23236: {"Type":"DelayConsume","SubType":"NULL"},
23237: {"Type":"DelayConsume","SubType":"NULL"},
23238: {"Type":"DelayConsume","SubType":"NULL"},
23239: {"Type":"DelayConsume","SubType":"NULL"},
23240: {"Type":"DelayConsume","SubType":"NULL"},
23241: {"Type":"DelayConsume","SubType":"NULL"},
23242: {"Type":"Usable","SubType":"NULL"},
23243: {"Type":"Usable","SubType":"NULL"},
23245: {"Type":"Usable","SubType":"NULL"},
23246: {"Type":"Usable","SubType":"NULL"},
23247: {"Type":"DelayConsume","SubType":"NULL"},
23248: {"Type":"DelayConsume","SubType":"NULL"},
23249: {"Type":"DelayConsume","SubType":"NULL"},
23250: {"Type":"DelayConsume","SubType":"NULL"},
23251: {"Type":"Usable","SubType":"NULL"},
23252: {"Type":"Usable","SubType":"NULL"},
23253: {"Type":"Usable","SubType":"NULL"},
23254: {"Type":"Usable","SubType":"NULL"},
23255: {"Type":"Usable","SubType":"NULL"},
23256: {"Type":"Usable","SubType":"NULL"},
23257: {"Type":"Usable","SubType":"NULL"},
23258: {"Type":"Usable","SubType":"NULL"},
23259: {"Type":"Usable","SubType":"NULL"},
23260: {"Type":"Usable","SubType":"NULL"},
23261: {"Type":"Usable","SubType":"NULL"},
23262: {"Type":"Usable","SubType":"NULL"},
23263: {"Type":"Usable","SubType":"NULL"},
23264: {"Type":"Usable","SubType":"NULL"},
23265: {"Type":"Usable","SubType":"NULL"},
23266: {"Type":"Usable","SubType":"NULL"},
23267: {"Type":"Usable","SubType":"NULL"},
23268: {"Type":"Usable","SubType":"NULL"},
23269: {"Type":"Usable","SubType":"NULL"},
23270: {"Type":"Usable","SubType":"NULL"},
23271: {"Type":"Usable","SubType":"NULL"},
23272: {"Type":"Usable","SubType":"NULL"},
23273: {"Type":"Usable","SubType":"NULL"},
23274: {"Type":"Usable","SubType":"NULL"},
23275: {"Type":"Usable","SubType":"NULL"},
23276: {"Type":"Usable","SubType":"NULL"},
23277: {"Type":"Usable","SubType":"NULL"},
23278: {"Type":"DelayConsume","SubType":"NULL"},
23280: {"Type":"DelayConsume","SubType":"NULL"},
23281: {"Type":"DelayConsume","SubType":"NULL"},
23282: {"Type":"Usable","SubType":"NULL"},
23283: {"Type":"Usable","SubType":"NULL"},
23284: {"Type":"Usable","SubType":"NULL"},
23285: {"Type":"Usable","SubType":"NULL"},
23286: {"Type":"Usable","SubType":"NULL"},
23287: {"Type":"Usable","SubType":"NULL"},
23288: {"Type":"DelayConsume","SubType":"NULL"},
23289: {"Type":"DelayConsume","SubType":"NULL"},
23290: {"Type":"DelayConsume","SubType":"NULL"},
23291: {"Type":"DelayConsume","SubType":"NULL"},
23294: {"Type":"Usable","SubType":"NULL"},
23295: {"Type":"Usable","SubType":"NULL"},
23296: {"Type":"Usable","SubType":"NULL"},
23297: {"Type":"Usable","SubType":"NULL"},
23299: {"Type":"Usable","SubType":"NULL"},
23302: {"Type":"Usable","SubType":"NULL"},
23303: {"Type":"Cash","SubType":"NULL"},
23304: {"Type":"Cash","SubType":"NULL"},
23305: {"Type":"Usable","SubType":"NULL"},
23307: {"Type":"Usable","SubType":"NULL"},
23308: {"Type":"DelayConsume","SubType":"NULL"},
23309: {"Type":"Usable","SubType":"NULL"},
23310: {"Type":"Usable","SubType":"NULL"},
23311: {"Type":"DelayConsume","SubType":"NULL"},
23312: {"Type":"Usable","SubType":"NULL"},
23317: {"Type":"Usable","SubType":"NULL"},
23318: {"Type":"Usable","SubType":"NULL"},
23320: {"Type":"Usable","SubType":"NULL"},
23321: {"Type":"Usable","SubType":"NULL"},
23322: {"Type":"Usable","SubType":"NULL"},
23323: {"Type":"Cash","SubType":"NULL"},
23324: {"Type":"DelayConsume","SubType":"NULL"},
23325: {"Type":"Usable","SubType":"NULL"},
23328: {"Type":"Usable","SubType":"NULL"},
23329: {"Type":"Cash","SubType":"NULL"},
23330: {"Type":"Cash","SubType":"NULL"},
23331: {"Type":"Cash","SubType":"NULL"},
23332: {"Type":"Usable","SubType":"NULL"},
23333: {"Type":"Usable","SubType":"NULL"},
23334: {"Type":"Usable","SubType":"NULL"},
23335: {"Type":"Usable","SubType":"NULL"},
23336: {"Type":"Usable","SubType":"NULL"},
23338: {"Type":"DelayConsume","SubType":"NULL"},
23340: {"Type":"Usable","SubType":"NULL"},
23342: {"Type":"Usable","SubType":"NULL"},
23343: {"Type":"Usable","SubType":"NULL"},
23344: {"Type":"Usable","SubType":"NULL"},
23345: {"Type":"Usable","SubType":"NULL"},
23346: {"Type":"Usable","SubType":"NULL"},
23347: {"Type":"Usable","SubType":"NULL"},
23348: {"Type":"Usable","SubType":"NULL"},
23349: {"Type":"Usable","SubType":"NULL"},
23350: {"Type":"Usable","SubType":"NULL"},
23351: {"Type":"Usable","SubType":"NULL"},
23352: {"Type":"Usable","SubType":"NULL"},
23353: {"Type":"Usable","SubType":"NULL"},
23354: {"Type":"Usable","SubType":"NULL"},
23355: {"Type":"Usable","SubType":"NULL"},
23356: {"Type":"Usable","SubType":"NULL"},
23357: {"Type":"Usable","SubType":"NULL"},
23358: {"Type":"Usable","SubType":"NULL"},
23359: {"Type":"Usable","SubType":"NULL"},
23360: {"Type":"DelayConsume","SubType":"NULL"},
23361: {"Type":"Healing","SubType":"NULL"},
23362: {"Type":"Usable","SubType":"NULL"},
23363: {"Type":"Usable","SubType":"NULL"},
23364: {"Type":"Usable","SubType":"NULL"},
23365: {"Type":"Usable","SubType":"NULL"},
23367: {"Type":"Usable","SubType":"NULL"},
23368: {"Type":"Usable","SubType":"NULL"},
23374: {"Type":"Usable","SubType":"NULL"},
23375: {"Type":"Usable","SubType":"NULL"},
23376: {"Type":"Usable","SubType":"NULL"},
23377: {"Type":"Usable","SubType":"NULL"},
23383: {"Type":"Usable","SubType":"NULL"},
23388: {"Type":"Usable","SubType":"NULL"},
23405: {"Type":"Usable","SubType":"NULL"},
23436: {"Type":"DelayConsume","SubType":"NULL"},
23438: {"Type":"Usable","SubType":"NULL"},
23440: {"Type":"Usable","SubType":"NULL"},
23444: {"Type":"Usable","SubType":"NULL"},
23445: {"Type":"Usable","SubType":"NULL"},
23446: {"Type":"Usable","SubType":"NULL"},
23473: {"Type":"Usable","SubType":"NULL"},
23474: {"Type":"DelayConsume","SubType":"NULL"},
23475: {"Type":"Usable","SubType":"NULL"},
23484: {"Type":"Usable","SubType":"NULL"},
23485: {"Type":"Usable","SubType":"NULL"},
23486: {"Type":"Usable","SubType":"NULL"},
23487: {"Type":"Usable","SubType":"NULL"},
23488: {"Type":"Usable","SubType":"NULL"},
23489: {"Type":"Usable","SubType":"NULL"},
23490: {"Type":"Usable","SubType":"NULL"},
23491: {"Type":"Usable","SubType":"NULL"},
23492: {"Type":"Usable","SubType":"NULL"},
23493: {"Type":"Usable","SubType":"NULL"},
23494: {"Type":"Usable","SubType":"NULL"},
23495: {"Type":"Usable","SubType":"NULL"},
23496: {"Type":"Usable","SubType":"NULL"},
23497: {"Type":"Usable","SubType":"NULL"},
23498: {"Type":"Usable","SubType":"NULL"},
23499: {"Type":"Usable","SubType":"NULL"},
23500: {"Type":"Usable","SubType":"NULL"},
23501: {"Type":"Usable","SubType":"NULL"},
23502: {"Type":"Usable","SubType":"NULL"},
23503: {"Type":"Usable","SubType":"NULL"},
23504: {"Type":"Usable","SubType":"NULL"},
23505: {"Type":"Usable","SubType":"NULL"},
23506: {"Type":"Usable","SubType":"NULL"},
23524: {"Type":"Usable","SubType":"NULL"},
23533: {"Type":"Usable","SubType":"NULL"},
23537: {"Type":"Usable","SubType":"NULL"},
23538: {"Type":"Usable","SubType":"NULL"},
23545: {"Type":"DelayConsume","SubType":"NULL"},
23546: {"Type":"DelayConsume","SubType":"NULL"},
23547: {"Type":"DelayConsume","SubType":"NULL"},
23548: {"Type":"Usable","SubType":"NULL"},
23549: {"Type":"Usable","SubType":"NULL"},
23550: {"Type":"Usable","SubType":"NULL"},
23551: {"Type":"Usable","SubType":"NULL"},
23552: {"Type":"Usable","SubType":"NULL"},
23553: {"Type":"Usable","SubType":"NULL"},
23554: {"Type":"Usable","SubType":"NULL"},
23556: {"Type":"Usable","SubType":"NULL"},
23575: {"Type":"Usable","SubType":"NULL"},
23576: {"Type":"Usable","SubType":"NULL"},
23577: {"Type":"Usable","SubType":"NULL"},
23578: {"Type":"Usable","SubType":"NULL"},
23579: {"Type":"Usable","SubType":"NULL"},
23580: {"Type":"Usable","SubType":"NULL"},
23581: {"Type":"Usable","SubType":"NULL"},
23582: {"Type":"Cash","SubType":"NULL"},
23583: {"Type":"Usable","SubType":"NULL"},
23584: {"Type":"Usable","SubType":"NULL"},
23585: {"Type":"Usable","SubType":"NULL"},
23586: {"Type":"Usable","SubType":"NULL"},
23587: {"Type":"Usable","SubType":"NULL"},
23604: {"Type":"Usable","SubType":"NULL"},
23605: {"Type":"Usable","SubType":"NULL"},
23606: {"Type":"Usable","SubType":"NULL"},
23607: {"Type":"Usable","SubType":"NULL"},
23611: {"Type":"Usable","SubType":"NULL"},
23612: {"Type":"Usable","SubType":"NULL"},
23618: {"Type":"Usable","SubType":"NULL"},
23619: {"Type":"Usable","SubType":"NULL"},
23629: {"Type":"Usable","SubType":"NULL"},
23647: {"Type":"Usable","SubType":"NULL"},
23648: {"Type":"Usable","SubType":"NULL"},
23650: {"Type":"Usable","SubType":"NULL"},
23660: {"Type":"Healing","SubType":"NULL"},
23661: {"Type":"Usable","SubType":"NULL"},
23662: {"Type":"Usable","SubType":"NULL"},
23663: {"Type":"Usable","SubType":"NULL"},
23664: {"Type":"Usable","SubType":"NULL"},
23665: {"Type":"DelayConsume","SubType":"NULL"},
23666: {"Type":"DelayConsume","SubType":"NULL"},
23667: {"Type":"DelayConsume","SubType":"NULL"},
23668: {"Type":"DelayConsume","SubType":"NULL"},
23669: {"Type":"DelayConsume","SubType":"NULL"},
23674: {"Type":"Usable","SubType":"NULL"},
23675: {"Type":"DelayConsume","SubType":"NULL"},
23676: {"Type":"DelayConsume","SubType":"NULL"},
23677: {"Type":"DelayConsume","SubType":"NULL"},
23678: {"Type":"DelayConsume","SubType":"NULL"},
23679: {"Type":"DelayConsume","SubType":"NULL"},
23682: {"Type":"Usable","SubType":"NULL"},
23683: {"Type":"Usable","SubType":"NULL"},
23684: {"Type":"Usable","SubType":"NULL"},
23700: {"Type":"Usable","SubType":"NULL"},
23706: {"Type":"DelayConsume","SubType":"NULL"},
23707: {"Type":"DelayConsume","SubType":"NULL"},
23708: {"Type":"Usable","SubType":"NULL"},
23710: {"Type":"Usable","SubType":"NULL"},
23711: {"Type":"Usable","SubType":"NULL"},
23718: {"Type":"Usable","SubType":"NULL"},
23719: {"Type":"Usable","SubType":"NULL"},
23720: {"Type":"DelayConsume","SubType":"NULL"},
23723: {"Type":"Usable","SubType":"NULL"},
23724: {"Type":"Usable","SubType":"NULL"},
23725: {"Type":"Usable","SubType":"NULL"},
23726: {"Type":"Usable","SubType":"NULL"},
23727: {"Type":"Usable","SubType":"NULL"},
23728: {"Type":"Usable","SubType":"NULL"},
23732: {"Type":"Usable","SubType":"NULL"},
23733: {"Type":"Usable","SubType":"NULL"},
23743: {"Type":"Usable","SubType":"NULL"},
23744: {"Type":"Usable","SubType":"NULL"},
23751: {"Type":"Usable","SubType":"NULL"},
23752: {"Type":"Usable","SubType":"NULL"},
23754: {"Type":"Usable","SubType":"NULL"},
23761: {"Type":"Usable","SubType":"NULL"},
23763: {"Type":"Usable","SubType":"NULL"},
23764: {"Type":"Usable","SubType":"NULL"},
23765: {"Type":"Usable","SubType":"NULL"},
23766: {"Type":"Usable","SubType":"NULL"},
23767: {"Type":"Usable","SubType":"NULL"},
23770: {"Type":"Usable","SubType":"NULL"},
23771: {"Type":"Usable","SubType":"NULL"},
23772: {"Type":"Usable","SubType":"NULL"},
23773: {"Type":"Usable","SubType":"NULL"},
23774: {"Type":"Usable","SubType":"NULL"},
23775: {"Type":"Usable","SubType":"NULL"},
23776: {"Type":"DelayConsume","SubType":"NULL"},
23777: {"Type":"DelayConsume","SubType":"NULL"},
23778: {"Type":"DelayConsume","SubType":"NULL"},
23779: {"Type":"DelayConsume","SubType":"NULL"},
23780: {"Type":"DelayConsume","SubType":"NULL"},
23781: {"Type":"DelayConsume","SubType":"NULL"},
23784: {"Type":"Usable","SubType":"NULL"},
23804: {"Type":"Usable","SubType":"NULL"},
23805: {"Type":"Usable","SubType":"NULL"},
23806: {"Type":"Usable","SubType":"NULL"},
23815: {"Type":"DelayConsume","SubType":"NULL"},
23817: {"Type":"Usable","SubType":"NULL"},
23818: {"Type":"DelayConsume","SubType":"NULL"},
23819: {"Type":"DelayConsume","SubType":"NULL"},
23820: {"Type":"DelayConsume","SubType":"NULL"},
23821: {"Type":"DelayConsume","SubType":"NULL"},
23822: {"Type":"DelayConsume","SubType":"NULL"},
23823: {"Type":"DelayConsume","SubType":"NULL"},
23824: {"Type":"DelayConsume","SubType":"NULL"},
23825: {"Type":"DelayConsume","SubType":"NULL"},
23826: {"Type":"DelayConsume","SubType":"NULL"},
23827: {"Type":"DelayConsume","SubType":"NULL"},
23828: {"Type":"DelayConsume","SubType":"NULL"},
23829: {"Type":"DelayConsume","SubType":"NULL"},
23830: {"Type":"DelayConsume","SubType":"NULL"},
23831: {"Type":"DelayConsume","SubType":"NULL"},
23832: {"Type":"DelayConsume","SubType":"NULL"},
23833: {"Type":"DelayConsume","SubType":"NULL"},
23834: {"Type":"DelayConsume","SubType":"NULL"},
23835: {"Type":"DelayConsume","SubType":"NULL"},
23836: {"Type":"DelayConsume","SubType":"NULL"},
23837: {"Type":"DelayConsume","SubType":"NULL"},
23838: {"Type":"DelayConsume","SubType":"NULL"},
23839: {"Type":"DelayConsume","SubType":"NULL"},
23840: {"Type":"DelayConsume","SubType":"NULL"},
23841: {"Type":"DelayConsume","SubType":"NULL"},
23842: {"Type":"DelayConsume","SubType":"NULL"},
23843: {"Type":"DelayConsume","SubType":"NULL"},
23844: {"Type":"DelayConsume","SubType":"NULL"},
23845: {"Type":"DelayConsume","SubType":"NULL"},
23846: {"Type":"DelayConsume","SubType":"NULL"},
23847: {"Type":"DelayConsume","SubType":"NULL"},
23848: {"Type":"DelayConsume","SubType":"NULL"},
23849: {"Type":"DelayConsume","SubType":"NULL"},
23850: {"Type":"DelayConsume","SubType":"NULL"},
23851: {"Type":"DelayConsume","SubType":"NULL"},
23852: {"Type":"DelayConsume","SubType":"NULL"},
23853: {"Type":"DelayConsume","SubType":"NULL"},
23854: {"Type":"DelayConsume","SubType":"NULL"},
23855: {"Type":"DelayConsume","SubType":"NULL"},
23856: {"Type":"DelayConsume","SubType":"NULL"},
23857: {"Type":"DelayConsume","SubType":"NULL"},
23858: {"Type":"DelayConsume","SubType":"NULL"},
23859: {"Type":"DelayConsume","SubType":"NULL"},
23860: {"Type":"DelayConsume","SubType":"NULL"},
23861: {"Type":"DelayConsume","SubType":"NULL"},
23862: {"Type":"DelayConsume","SubType":"NULL"},
23863: {"Type":"DelayConsume","SubType":"NULL"},
23864: {"Type":"DelayConsume","SubType":"NULL"},
23865: {"Type":"DelayConsume","SubType":"NULL"},
23866: {"Type":"DelayConsume","SubType":"NULL"},
23867: {"Type":"DelayConsume","SubType":"NULL"},
23868: {"Type":"DelayConsume","SubType":"NULL"},
23869: {"Type":"DelayConsume","SubType":"NULL"},
23870: {"Type":"DelayConsume","SubType":"NULL"},
23871: {"Type":"DelayConsume","SubType":"NULL"},
23872: {"Type":"DelayConsume","SubType":"NULL"},
23873: {"Type":"DelayConsume","SubType":"NULL"},
23874: {"Type":"DelayConsume","SubType":"NULL"},
23875: {"Type":"DelayConsume","SubType":"NULL"},
23876: {"Type":"DelayConsume","SubType":"NULL"},
23877: {"Type":"DelayConsume","SubType":"NULL"},
23878: {"Type":"Usable","SubType":"NULL"},
23879: {"Type":"DelayConsume","SubType":"NULL"},
23880: {"Type":"DelayConsume","SubType":"NULL"},
23881: {"Type":"DelayConsume","SubType":"NULL"},
23882: {"Type":"DelayConsume","SubType":"NULL"},
23883: {"Type":"DelayConsume","SubType":"NULL"},
23884: {"Type":"DelayConsume","SubType":"NULL"},
23885: {"Type":"DelayConsume","SubType":"NULL"},
23886: {"Type":"DelayConsume","SubType":"NULL"},
23887: {"Type":"DelayConsume","SubType":"NULL"},
23888: {"Type":"DelayConsume","SubType":"NULL"},
23889: {"Type":"DelayConsume","SubType":"NULL"},
23890: {"Type":"DelayConsume","SubType":"NULL"},
23891: {"Type":"DelayConsume","SubType":"NULL"},
23892: {"Type":"DelayConsume","SubType":"NULL"},
23893: {"Type":"DelayConsume","SubType":"NULL"},
23894: {"Type":"DelayConsume","SubType":"NULL"},
23896: {"Type":"Usable","SubType":"NULL"},
23897: {"Type":"Usable","SubType":"NULL"},
23898: {"Type":"Usable","SubType":"NULL"},
23899: {"Type":"Usable","SubType":"NULL"},
23900: {"Type":"Usable","SubType":"NULL"},
23901: {"Type":"Usable","SubType":"NULL"},
23905: {"Type":"Usable","SubType":"NULL"},
23906: {"Type":"Usable","SubType":"NULL"},
23907: {"Type":"Usable","SubType":"NULL"},
23913: {"Type":"Usable","SubType":"NULL"},
23914: {"Type":"Usable","SubType":"NULL"},
23919: {"Type":"Delayconsume","SubType":"NULL"},
23921: {"Type":"Usable","SubType":"NULL"},
23922: {"Type":"Usable","SubType":"NULL"},
23923: {"Type":"Usable","SubType":"NULL"},
23924: {"Type":"Usable","SubType":"NULL"},
23925: {"Type":"Usable","SubType":"NULL"},
23926: {"Type":"DelayConsume","SubType":"NULL"},
23949: {"Type":"Usable","SubType":"NULL"},
23952: {"Type":"Cash","SubType":"NULL"},
23962: {"Type":"Usable","SubType":"NULL"},
23967: {"Type":"DelayConsume","SubType":"NULL"},
23981: {"Type":"DelayConsume","SubType":"NULL"},
23985: {"Type":"Usable","SubType":"NULL"},
23986: {"Type":"Usable","SubType":"NULL"},
23992: {"Type":"Usable","SubType":"NULL"},
23993: {"Type":"Usable","SubType":"NULL"},
23994: {"Type":"Usable","SubType":"NULL"},
24000: {"Type":"Shadowgear","SubType":"NULL"},
24001: {"Type":"Shadowgear","SubType":"NULL"},
24002: {"Type":"Shadowgear","SubType":"NULL"},
24003: {"Type":"Shadowgear","SubType":"NULL"},
24004: {"Type":"Shadowgear","SubType":"NULL"},
24005: {"Type":"Shadowgear","SubType":"NULL"},
24006: {"Type":"Shadowgear","SubType":"NULL"},
24007: {"Type":"Shadowgear","SubType":"NULL"},
24008: {"Type":"Shadowgear","SubType":"NULL"},
24009: {"Type":"Shadowgear","SubType":"NULL"},
24010: {"Type":"Shadowgear","SubType":"NULL"},
24011: {"Type":"Shadowgear","SubType":"NULL"},
24012: {"Type":"Shadowgear","SubType":"NULL"},
24013: {"Type":"Shadowgear","SubType":"NULL"},
24014: {"Type":"Shadowgear","SubType":"NULL"},
24015: {"Type":"Shadowgear","SubType":"NULL"},
24016: {"Type":"Shadowgear","SubType":"NULL"},
24017: {"Type":"Shadowgear","SubType":"NULL"},
24018: {"Type":"Shadowgear","SubType":"NULL"},
24019: {"Type":"Shadowgear","SubType":"NULL"},
24020: {"Type":"Shadowgear","SubType":"NULL"},
24021: {"Type":"Shadowgear","SubType":"NULL"},
24022: {"Type":"Shadowgear","SubType":"NULL"},
24023: {"Type":"Shadowgear","SubType":"NULL"},
24024: {"Type":"Shadowgear","SubType":"NULL"},
24025: {"Type":"Shadowgear","SubType":"NULL"},
24026: {"Type":"Shadowgear","SubType":"NULL"},
24027: {"Type":"Shadowgear","SubType":"NULL"},
24028: {"Type":"Shadowgear","SubType":"NULL"},
24029: {"Type":"Shadowgear","SubType":"NULL"},
24030: {"Type":"Shadowgear","SubType":"NULL"},
24031: {"Type":"Shadowgear","SubType":"NULL"},
24032: {"Type":"Shadowgear","SubType":"NULL"},
24033: {"Type":"Shadowgear","SubType":"NULL"},
24034: {"Type":"Shadowgear","SubType":"NULL"},
24035: {"Type":"Shadowgear","SubType":"NULL"},
24036: {"Type":"Shadowgear","SubType":"NULL"},
24037: {"Type":"Shadowgear","SubType":"NULL"},
24038: {"Type":"Shadowgear","SubType":"NULL"},
24039: {"Type":"Shadowgear","SubType":"NULL"},
24040: {"Type":"Shadowgear","SubType":"NULL"},
24041: {"Type":"Shadowgear","SubType":"NULL"},
24042: {"Type":"Shadowgear","SubType":"NULL"},
24043: {"Type":"Shadowgear","SubType":"NULL"},
24044: {"Type":"Shadowgear","SubType":"NULL"},
24045: {"Type":"Shadowgear","SubType":"NULL"},
24046: {"Type":"Shadowgear","SubType":"NULL"},
24047: {"Type":"Shadowgear","SubType":"NULL"},
24048: {"Type":"Shadowgear","SubType":"NULL"},
24049: {"Type":"Shadowgear","SubType":"NULL"},
24050: {"Type":"Shadowgear","SubType":"NULL"},
24051: {"Type":"Shadowgear","SubType":"NULL"},
24052: {"Type":"Shadowgear","SubType":"NULL"},
24053: {"Type":"Shadowgear","SubType":"NULL"},
24054: {"Type":"Shadowgear","SubType":"NULL"},
24055: {"Type":"Shadowgear","SubType":"NULL"},
24056: {"Type":"Shadowgear","SubType":"NULL"},
24057: {"Type":"Shadowgear","SubType":"NULL"},
24058: {"Type":"Shadowgear","SubType":"NULL"},
24059: {"Type":"Shadowgear","SubType":"NULL"},
24060: {"Type":"Shadowgear","SubType":"NULL"},
24061: {"Type":"Shadowgear","SubType":"NULL"},
24062: {"Type":"Shadowgear","SubType":"NULL"},
24063: {"Type":"Shadowgear","SubType":"NULL"},
24064: {"Type":"Shadowgear","SubType":"NULL"},
24065: {"Type":"Shadowgear","SubType":"NULL"},
24066: {"Type":"Shadowgear","SubType":"NULL"},
24067: {"Type":"Shadowgear","SubType":"NULL"},
24068: {"Type":"Shadowgear","SubType":"NULL"},
24069: {"Type":"Shadowgear","SubType":"NULL"},
24070: {"Type":"Shadowgear","SubType":"NULL"},
24071: {"Type":"Shadowgear","SubType":"NULL"},
24072: {"Type":"Shadowgear","SubType":"NULL"},
24073: {"Type":"Shadowgear","SubType":"NULL"},
24074: {"Type":"Shadowgear","SubType":"NULL"},
24075: {"Type":"Shadowgear","SubType":"NULL"},
24076: {"Type":"Shadowgear","SubType":"NULL"},
24077: {"Type":"Shadowgear","SubType":"NULL"},
24078: {"Type":"Shadowgear","SubType":"NULL"},
24079: {"Type":"Shadowgear","SubType":"NULL"},
24080: {"Type":"Shadowgear","SubType":"NULL"},
24081: {"Type":"Shadowgear","SubType":"NULL"},
24082: {"Type":"Shadowgear","SubType":"NULL"},
24083: {"Type":"Shadowgear","SubType":"NULL"},
24084: {"Type":"Shadowgear","SubType":"NULL"},
24085: {"Type":"Shadowgear","SubType":"NULL"},
24086: {"Type":"Shadowgear","SubType":"NULL"},
24087: {"Type":"Shadowgear","SubType":"NULL"},
24088: {"Type":"Shadowgear","SubType":"NULL"},
24089: {"Type":"Shadowgear","SubType":"NULL"},
24090: {"Type":"Shadowgear","SubType":"NULL"},
24091: {"Type":"Shadowgear","SubType":"NULL"},
24092: {"Type":"Shadowgear","SubType":"NULL"},
24093: {"Type":"Shadowgear","SubType":"NULL"},
24094: {"Type":"Shadowgear","SubType":"NULL"},
24095: {"Type":"Shadowgear","SubType":"NULL"},
24096: {"Type":"Shadowgear","SubType":"NULL"},
24097: {"Type":"Shadowgear","SubType":"NULL"},
24098: {"Type":"Shadowgear","SubType":"NULL"},
24099: {"Type":"Shadowgear","SubType":"NULL"},
24100: {"Type":"Shadowgear","SubType":"NULL"},
24101: {"Type":"Shadowgear","SubType":"NULL"},
24102: {"Type":"Shadowgear","SubType":"NULL"},
24103: {"Type":"Shadowgear","SubType":"NULL"},
24104: {"Type":"Shadowgear","SubType":"NULL"},
24105: {"Type":"Shadowgear","SubType":"NULL"},
24106: {"Type":"Shadowgear","SubType":"NULL"},
24107: {"Type":"Shadowgear","SubType":"NULL"},
24108: {"Type":"Shadowgear","SubType":"NULL"},
24109: {"Type":"Shadowgear","SubType":"NULL"},
24110: {"Type":"Shadowgear","SubType":"NULL"},
24111: {"Type":"Shadowgear","SubType":"NULL"},
24112: {"Type":"Shadowgear","SubType":"NULL"},
24113: {"Type":"Shadowgear","SubType":"NULL"},
24114: {"Type":"Shadowgear","SubType":"NULL"},
24115: {"Type":"Shadowgear","SubType":"NULL"},
24116: {"Type":"Shadowgear","SubType":"NULL"},
24117: {"Type":"Shadowgear","SubType":"NULL"},
24118: {"Type":"Shadowgear","SubType":"NULL"},
24119: {"Type":"Shadowgear","SubType":"NULL"},
24120: {"Type":"Shadowgear","SubType":"NULL"},
24121: {"Type":"Shadowgear","SubType":"NULL"},
24122: {"Type":"Shadowgear","SubType":"NULL"},
24123: {"Type":"Shadowgear","SubType":"NULL"},
24124: {"Type":"Shadowgear","SubType":"NULL"},
24125: {"Type":"Shadowgear","SubType":"NULL"},
24126: {"Type":"Shadowgear","SubType":"NULL"},
24127: {"Type":"Shadowgear","SubType":"NULL"},
24128: {"Type":"Shadowgear","SubType":"NULL"},
24129: {"Type":"Shadowgear","SubType":"NULL"},
24130: {"Type":"Shadowgear","SubType":"NULL"},
24131: {"Type":"Shadowgear","SubType":"NULL"},
24132: {"Type":"Shadowgear","SubType":"NULL"},
24133: {"Type":"Shadowgear","SubType":"NULL"},
24134: {"Type":"Shadowgear","SubType":"NULL"},
24135: {"Type":"Shadowgear","SubType":"NULL"},
24136: {"Type":"Shadowgear","SubType":"NULL"},
24137: {"Type":"Shadowgear","SubType":"NULL"},
24138: {"Type":"Shadowgear","SubType":"NULL"},
24139: {"Type":"Shadowgear","SubType":"NULL"},
24140: {"Type":"Shadowgear","SubType":"NULL"},
24141: {"Type":"Shadowgear","SubType":"NULL"},
24142: {"Type":"Shadowgear","SubType":"NULL"},
24143: {"Type":"Shadowgear","SubType":"NULL"},
24144: {"Type":"Shadowgear","SubType":"NULL"},
24145: {"Type":"Shadowgear","SubType":"NULL"},
24146: {"Type":"Shadowgear","SubType":"NULL"},
24147: {"Type":"Shadowgear","SubType":"NULL"},
24148: {"Type":"Shadowgear","SubType":"NULL"},
24149: {"Type":"Shadowgear","SubType":"NULL"},
24150: {"Type":"Shadowgear","SubType":"NULL"},
24151: {"Type":"Shadowgear","SubType":"NULL"},
24152: {"Type":"Shadowgear","SubType":"NULL"},
24153: {"Type":"Shadowgear","SubType":"NULL"},
24154: {"Type":"Shadowgear","SubType":"NULL"},
24155: {"Type":"Shadowgear","SubType":"NULL"},
24156: {"Type":"Shadowgear","SubType":"NULL"},
24157: {"Type":"Shadowgear","SubType":"NULL"},
24158: {"Type":"Shadowgear","SubType":"NULL"},
24159: {"Type":"Shadowgear","SubType":"NULL"},
24160: {"Type":"Shadowgear","SubType":"NULL"},
24161: {"Type":"Shadowgear","SubType":"NULL"},
24162: {"Type":"Shadowgear","SubType":"NULL"},
24163: {"Type":"Shadowgear","SubType":"NULL"},
24164: {"Type":"Shadowgear","SubType":"NULL"},
24165: {"Type":"Shadowgear","SubType":"NULL"},
24166: {"Type":"Shadowgear","SubType":"NULL"},
24167: {"Type":"Shadowgear","SubType":"NULL"},
24168: {"Type":"Shadowgear","SubType":"NULL"},
24169: {"Type":"Shadowgear","SubType":"NULL"},
24170: {"Type":"Shadowgear","SubType":"NULL"},
24171: {"Type":"Shadowgear","SubType":"NULL"},
24172: {"Type":"Shadowgear","SubType":"NULL"},
24173: {"Type":"Shadowgear","SubType":"NULL"},
24174: {"Type":"Shadowgear","SubType":"NULL"},
24175: {"Type":"Shadowgear","SubType":"NULL"},
24176: {"Type":"Shadowgear","SubType":"NULL"},
24177: {"Type":"Shadowgear","SubType":"NULL"},
24178: {"Type":"Shadowgear","SubType":"NULL"},
24179: {"Type":"Shadowgear","SubType":"NULL"},
24180: {"Type":"Shadowgear","SubType":"NULL"},
24181: {"Type":"Shadowgear","SubType":"NULL"},
24182: {"Type":"Shadowgear","SubType":"NULL"},
24183: {"Type":"Shadowgear","SubType":"NULL"},
24184: {"Type":"Shadowgear","SubType":"NULL"},
24185: {"Type":"Shadowgear","SubType":"NULL"},
24186: {"Type":"Shadowgear","SubType":"NULL"},
24187: {"Type":"Shadowgear","SubType":"NULL"},
24188: {"Type":"Shadowgear","SubType":"NULL"},
24189: {"Type":"Shadowgear","SubType":"NULL"},
24190: {"Type":"Shadowgear","SubType":"NULL"},
24191: {"Type":"Shadowgear","SubType":"NULL"},
24192: {"Type":"Shadowgear","SubType":"NULL"},
24193: {"Type":"Shadowgear","SubType":"NULL"},
24194: {"Type":"Shadowgear","SubType":"NULL"},
24195: {"Type":"Shadowgear","SubType":"NULL"},
24196: {"Type":"Shadowgear","SubType":"NULL"},
24197: {"Type":"Shadowgear","SubType":"NULL"},
24198: {"Type":"Shadowgear","SubType":"NULL"},
24199: {"Type":"Shadowgear","SubType":"NULL"},
24200: {"Type":"Shadowgear","SubType":"NULL"},
24201: {"Type":"Shadowgear","SubType":"NULL"},
24202: {"Type":"Shadowgear","SubType":"NULL"},
24203: {"Type":"Shadowgear","SubType":"NULL"},
24204: {"Type":"Shadowgear","SubType":"NULL"},
24205: {"Type":"Shadowgear","SubType":"NULL"},
24206: {"Type":"Shadowgear","SubType":"NULL"},
24207: {"Type":"Shadowgear","SubType":"NULL"},
24208: {"Type":"Shadowgear","SubType":"NULL"},
24209: {"Type":"Shadowgear","SubType":"NULL"},
24210: {"Type":"Shadowgear","SubType":"NULL"},
24211: {"Type":"Shadowgear","SubType":"NULL"},
24212: {"Type":"Shadowgear","SubType":"NULL"},
24213: {"Type":"Shadowgear","SubType":"NULL"},
24214: {"Type":"Shadowgear","SubType":"NULL"},
24215: {"Type":"Shadowgear","SubType":"NULL"},
24216: {"Type":"Shadowgear","SubType":"NULL"},
24217: {"Type":"Shadowgear","SubType":"NULL"},
24218: {"Type":"Shadowgear","SubType":"NULL"},
24219: {"Type":"Shadowgear","SubType":"NULL"},
24220: {"Type":"Shadowgear","SubType":"NULL"},
24221: {"Type":"Shadowgear","SubType":"NULL"},
24222: {"Type":"Shadowgear","SubType":"NULL"},
24223: {"Type":"Shadowgear","SubType":"NULL"},
24224: {"Type":"Shadowgear","SubType":"NULL"},
24225: {"Type":"Shadowgear","SubType":"NULL"},
24226: {"Type":"Shadowgear","SubType":"NULL"},
24227: {"Type":"Shadowgear","SubType":"NULL"},
24228: {"Type":"Shadowgear","SubType":"NULL"},
24229: {"Type":"Shadowgear","SubType":"NULL"},
24230: {"Type":"Shadowgear","SubType":"NULL"},
24231: {"Type":"Shadowgear","SubType":"NULL"},
24232: {"Type":"Shadowgear","SubType":"NULL"},
24233: {"Type":"Shadowgear","SubType":"NULL"},
24234: {"Type":"Shadowgear","SubType":"NULL"},
24235: {"Type":"Shadowgear","SubType":"NULL"},
24236: {"Type":"Shadowgear","SubType":"NULL"},
24237: {"Type":"Shadowgear","SubType":"NULL"},
24238: {"Type":"Shadowgear","SubType":"NULL"},
24239: {"Type":"Shadowgear","SubType":"NULL"},
24240: {"Type":"Shadowgear","SubType":"NULL"},
24241: {"Type":"Shadowgear","SubType":"NULL"},
24242: {"Type":"Shadowgear","SubType":"NULL"},
24243: {"Type":"Shadowgear","SubType":"NULL"},
24244: {"Type":"Shadowgear","SubType":"NULL"},
24245: {"Type":"Shadowgear","SubType":"NULL"},
24246: {"Type":"Shadowgear","SubType":"NULL"},
24247: {"Type":"Shadowgear","SubType":"NULL"},
24248: {"Type":"Shadowgear","SubType":"NULL"},
24249: {"Type":"Shadowgear","SubType":"NULL"},
24250: {"Type":"Shadowgear","SubType":"NULL"},
24251: {"Type":"Shadowgear","SubType":"NULL"},
24252: {"Type":"Shadowgear","SubType":"NULL"},
24253: {"Type":"Shadowgear","SubType":"NULL"},
24254: {"Type":"Shadowgear","SubType":"NULL"},
24255: {"Type":"Shadowgear","SubType":"NULL"},
24256: {"Type":"Shadowgear","SubType":"NULL"},
24257: {"Type":"Shadowgear","SubType":"NULL"},
24258: {"Type":"Shadowgear","SubType":"NULL"},
24259: {"Type":"Shadowgear","SubType":"NULL"},
24260: {"Type":"Shadowgear","SubType":"NULL"},
24261: {"Type":"Shadowgear","SubType":"NULL"},
24262: {"Type":"Shadowgear","SubType":"NULL"},
24263: {"Type":"Shadowgear","SubType":"NULL"},
24264: {"Type":"Shadowgear","SubType":"NULL"},
24265: {"Type":"Shadowgear","SubType":"NULL"},
24266: {"Type":"Shadowgear","SubType":"NULL"},
24267: {"Type":"Shadowgear","SubType":"NULL"},
24268: {"Type":"Shadowgear","SubType":"NULL"},
24269: {"Type":"Shadowgear","SubType":"NULL"},
24270: {"Type":"Shadowgear","SubType":"NULL"},
24271: {"Type":"Shadowgear","SubType":"NULL"},
24272: {"Type":"Shadowgear","SubType":"NULL"},
24273: {"Type":"Shadowgear","SubType":"NULL"},
24274: {"Type":"Shadowgear","SubType":"NULL"},
24275: {"Type":"Shadowgear","SubType":"NULL"},
24276: {"Type":"Shadowgear","SubType":"NULL"},
24277: {"Type":"Shadowgear","SubType":"NULL"},
24278: {"Type":"Shadowgear","SubType":"NULL"},
24279: {"Type":"Shadowgear","SubType":"NULL"},
24280: {"Type":"Shadowgear","SubType":"NULL"},
24281: {"Type":"Shadowgear","SubType":"NULL"},
24282: {"Type":"Shadowgear","SubType":"NULL"},
24283: {"Type":"Shadowgear","SubType":"NULL"},
24284: {"Type":"Shadowgear","SubType":"NULL"},
24285: {"Type":"Shadowgear","SubType":"NULL"},
24286: {"Type":"Shadowgear","SubType":"NULL"},
24287: {"Type":"Shadowgear","SubType":"NULL"},
24288: {"Type":"Shadowgear","SubType":"NULL"},
24289: {"Type":"Shadowgear","SubType":"NULL"},
24290: {"Type":"Shadowgear","SubType":"NULL"},
24291: {"Type":"Shadowgear","SubType":"NULL"},
24292: {"Type":"Shadowgear","SubType":"NULL"},
24293: {"Type":"Shadowgear","SubType":"NULL"},
24294: {"Type":"Shadowgear","SubType":"NULL"},
24295: {"Type":"Shadowgear","SubType":"NULL"},
24296: {"Type":"Shadowgear","SubType":"NULL"},
24297: {"Type":"Shadowgear","SubType":"NULL"},
24298: {"Type":"Shadowgear","SubType":"NULL"},
24299: {"Type":"Shadowgear","SubType":"NULL"},
24300: {"Type":"Shadowgear","SubType":"NULL"},
24301: {"Type":"Shadowgear","SubType":"NULL"},
24302: {"Type":"Shadowgear","SubType":"NULL"},
24303: {"Type":"Shadowgear","SubType":"NULL"},
24304: {"Type":"Shadowgear","SubType":"NULL"},
24305: {"Type":"Shadowgear","SubType":"NULL"},
24306: {"Type":"Shadowgear","SubType":"NULL"},
24307: {"Type":"Shadowgear","SubType":"NULL"},
24308: {"Type":"Shadowgear","SubType":"NULL"},
24309: {"Type":"Shadowgear","SubType":"NULL"},
24310: {"Type":"Shadowgear","SubType":"NULL"},
24311: {"Type":"Shadowgear","SubType":"NULL"},
24312: {"Type":"Shadowgear","SubType":"NULL"},
24313: {"Type":"Shadowgear","SubType":"NULL"},
24314: {"Type":"Shadowgear","SubType":"NULL"},
24315: {"Type":"Shadowgear","SubType":"NULL"},
24316: {"Type":"Shadowgear","SubType":"NULL"},
24317: {"Type":"Shadowgear","SubType":"NULL"},
24318: {"Type":"Shadowgear","SubType":"NULL"},
24319: {"Type":"Shadowgear","SubType":"NULL"},
24320: {"Type":"Shadowgear","SubType":"NULL"},
24321: {"Type":"Shadowgear","SubType":"NULL"},
24322: {"Type":"Shadowgear","SubType":"NULL"},
24323: {"Type":"Shadowgear","SubType":"NULL"},
24324: {"Type":"Shadowgear","SubType":"NULL"},
24325: {"Type":"Shadowgear","SubType":"NULL"},
24326: {"Type":"Shadowgear","SubType":"NULL"},
24327: {"Type":"Shadowgear","SubType":"NULL"},
24328: {"Type":"Shadowgear","SubType":"NULL"},
24329: {"Type":"Shadowgear","SubType":"NULL"},
24330: {"Type":"Shadowgear","SubType":"NULL"},
24331: {"Type":"Shadowgear","SubType":"NULL"},
24332: {"Type":"Shadowgear","SubType":"NULL"},
24333: {"Type":"Shadowgear","SubType":"NULL"},
24334: {"Type":"Shadowgear","SubType":"NULL"},
24335: {"Type":"Shadowgear","SubType":"NULL"},
24336: {"Type":"Shadowgear","SubType":"NULL"},
24337: {"Type":"Shadowgear","SubType":"NULL"},
24338: {"Type":"Shadowgear","SubType":"NULL"},
24339: {"Type":"Shadowgear","SubType":"NULL"},
24340: {"Type":"Shadowgear","SubType":"NULL"},
24341: {"Type":"Shadowgear","SubType":"NULL"},
24342: {"Type":"Shadowgear","SubType":"NULL"},
24343: {"Type":"Shadowgear","SubType":"NULL"},
24344: {"Type":"Shadowgear","SubType":"NULL"},
24345: {"Type":"Shadowgear","SubType":"NULL"},
24346: {"Type":"Shadowgear","SubType":"NULL"},
24347: {"Type":"Shadowgear","SubType":"NULL"},
24348: {"Type":"Shadowgear","SubType":"NULL"},
24349: {"Type":"Shadowgear","SubType":"NULL"},
24350: {"Type":"Shadowgear","SubType":"NULL"},
24351: {"Type":"Shadowgear","SubType":"NULL"},
24352: {"Type":"Shadowgear","SubType":"NULL"},
24353: {"Type":"Shadowgear","SubType":"NULL"},
24354: {"Type":"Shadowgear","SubType":"NULL"},
24355: {"Type":"Shadowgear","SubType":"NULL"},
24356: {"Type":"Shadowgear","SubType":"NULL"},
24357: {"Type":"Shadowgear","SubType":"NULL"},
24358: {"Type":"Shadowgear","SubType":"NULL"},
24359: {"Type":"Shadowgear","SubType":"NULL"},
24360: {"Type":"Shadowgear","SubType":"NULL"},
24361: {"Type":"Shadowgear","SubType":"NULL"},
24362: {"Type":"Shadowgear","SubType":"NULL"},
24363: {"Type":"Shadowgear","SubType":"NULL"},
24364: {"Type":"Shadowgear","SubType":"NULL"},
24365: {"Type":"Shadowgear","SubType":"NULL"},
24366: {"Type":"Shadowgear","SubType":"NULL"},
24367: {"Type":"Shadowgear","SubType":"NULL"},
24368: {"Type":"Shadowgear","SubType":"NULL"},
24369: {"Type":"Shadowgear","SubType":"NULL"},
24370: {"Type":"Shadowgear","SubType":"NULL"},
24371: {"Type":"Shadowgear","SubType":"NULL"},
24372: {"Type":"Shadowgear","SubType":"NULL"},
24373: {"Type":"Shadowgear","SubType":"NULL"},
24374: {"Type":"Shadowgear","SubType":"NULL"},
24375: {"Type":"Shadowgear","SubType":"NULL"},
24376: {"Type":"Shadowgear","SubType":"NULL"},
24377: {"Type":"Shadowgear","SubType":"NULL"},
24378: {"Type":"Shadowgear","SubType":"NULL"},
24379: {"Type":"Shadowgear","SubType":"NULL"},
24380: {"Type":"Shadowgear","SubType":"NULL"},
24381: {"Type":"Shadowgear","SubType":"NULL"},
24382: {"Type":"Shadowgear","SubType":"NULL"},
24383: {"Type":"Shadowgear","SubType":"NULL"},
24384: {"Type":"Shadowgear","SubType":"NULL"},
24385: {"Type":"Shadowgear","SubType":"NULL"},
24386: {"Type":"Shadowgear","SubType":"NULL"},
24387: {"Type":"Shadowgear","SubType":"NULL"},
24388: {"Type":"Shadowgear","SubType":"NULL"},
24389: {"Type":"Shadowgear","SubType":"NULL"},
24390: {"Type":"Shadowgear","SubType":"NULL"},
24391: {"Type":"Shadowgear","SubType":"NULL"},
24392: {"Type":"Shadowgear","SubType":"NULL"},
24393: {"Type":"Shadowgear","SubType":"NULL"},
24394: {"Type":"Shadowgear","SubType":"NULL"},
24395: {"Type":"Shadowgear","SubType":"NULL"},
24396: {"Type":"Shadowgear","SubType":"NULL"},
24397: {"Type":"Shadowgear","SubType":"NULL"},
24398: {"Type":"Shadowgear","SubType":"NULL"},
24399: {"Type":"Shadowgear","SubType":"NULL"},
24400: {"Type":"Shadowgear","SubType":"NULL"},
24401: {"Type":"Shadowgear","SubType":"NULL"},
24402: {"Type":"Shadowgear","SubType":"NULL"},
24403: {"Type":"Shadowgear","SubType":"NULL"},
24404: {"Type":"Shadowgear","SubType":"NULL"},
24405: {"Type":"Shadowgear","SubType":"NULL"},
24406: {"Type":"Shadowgear","SubType":"NULL"},
24407: {"Type":"Shadowgear","SubType":"NULL"},
24408: {"Type":"Shadowgear","SubType":"NULL"},
24409: {"Type":"Shadowgear","SubType":"NULL"},
24410: {"Type":"Shadowgear","SubType":"NULL"},
24411: {"Type":"Shadowgear","SubType":"NULL"},
24412: {"Type":"Shadowgear","SubType":"NULL"},
24413: {"Type":"Shadowgear","SubType":"NULL"},
24414: {"Type":"Shadowgear","SubType":"NULL"},
24415: {"Type":"Shadowgear","SubType":"NULL"},
24416: {"Type":"Shadowgear","SubType":"NULL"},
24417: {"Type":"Shadowgear","SubType":"NULL"},
24418: {"Type":"Shadowgear","SubType":"NULL"},
24419: {"Type":"Shadowgear","SubType":"NULL"},
24420: {"Type":"Shadowgear","SubType":"NULL"},
24421: {"Type":"Shadowgear","SubType":"NULL"},
24423: {"Type":"Shadowgear","SubType":"NULL"},
24424: {"Type":"Shadowgear","SubType":"NULL"},
24425: {"Type":"Shadowgear","SubType":"NULL"},
24426: {"Type":"Shadowgear","SubType":"NULL"},
24427: {"Type":"Shadowgear","SubType":"NULL"},
24428: {"Type":"Shadowgear","SubType":"NULL"},
24429: {"Type":"Shadowgear","SubType":"NULL"},
24430: {"Type":"Shadowgear","SubType":"NULL"},
24431: {"Type":"Shadowgear","SubType":"NULL"},
24432: {"Type":"Shadowgear","SubType":"NULL"},
24433: {"Type":"Shadowgear","SubType":"NULL"},
24434: {"Type":"Shadowgear","SubType":"NULL"},
24435: {"Type":"Shadowgear","SubType":"NULL"},
24436: {"Type":"Shadowgear","SubType":"NULL"},
24437: {"Type":"Shadowgear","SubType":"NULL"},
24438: {"Type":"Shadowgear","SubType":"NULL"},
24439: {"Type":"Shadowgear","SubType":"NULL"},
24440: {"Type":"Shadowgear","SubType":"NULL"},
24441: {"Type":"Shadowgear","SubType":"NULL"},
24442: {"Type":"Shadowgear","SubType":"NULL"},
24443: {"Type":"Shadowgear","SubType":"NULL"},
24444: {"Type":"Shadowgear","SubType":"NULL"},
24445: {"Type":"Shadowgear","SubType":"NULL"},
24446: {"Type":"Shadowgear","SubType":"NULL"},
24447: {"Type":"Shadowgear","SubType":"NULL"},
24448: {"Type":"Shadowgear","SubType":"NULL"},
24449: {"Type":"Shadowgear","SubType":"NULL"},
24450: {"Type":"Shadowgear","SubType":"NULL"},
24451: {"Type":"Shadowgear","SubType":"NULL"},
24452: {"Type":"Shadowgear","SubType":"NULL"},
24453: {"Type":"Shadowgear","SubType":"NULL"},
24454: {"Type":"Shadowgear","SubType":"NULL"},
24455: {"Type":"Shadowgear","SubType":"NULL"},
24456: {"Type":"Shadowgear","SubType":"NULL"},
24457: {"Type":"Shadowgear","SubType":"NULL"},
24458: {"Type":"Shadowgear","SubType":"NULL"},
24459: {"Type":"Shadowgear","SubType":"NULL"},
24460: {"Type":"Shadowgear","SubType":"NULL"},
24461: {"Type":"Shadowgear","SubType":"NULL"},
24462: {"Type":"Shadowgear","SubType":"NULL"},
24463: {"Type":"Shadowgear","SubType":"NULL"},
24464: {"Type":"Shadowgear","SubType":"NULL"},
24465: {"Type":"Shadowgear","SubType":"NULL"},
24466: {"Type":"Shadowgear","SubType":"NULL"},
24467: {"Type":"Shadowgear","SubType":"NULL"},
24468: {"Type":"Shadowgear","SubType":"NULL"},
24469: {"Type":"Shadowgear","SubType":"NULL"},
24470: {"Type":"Shadowgear","SubType":"NULL"},
24471: {"Type":"Shadowgear","SubType":"NULL"},
24472: {"Type":"Shadowgear","SubType":"NULL"},
24473: {"Type":"Shadowgear","SubType":"NULL"},
24474: {"Type":"Shadowgear","SubType":"NULL"},
24475: {"Type":"Shadowgear","SubType":"NULL"},
24476: {"Type":"ShadowGear","SubType":"NULL"},
24477: {"Type":"ShadowGear","SubType":"NULL"},
24478: {"Type":"ShadowGear","SubType":"NULL"},
24479: {"Type":"ShadowGear","SubType":"NULL"},
24480: {"Type":"ShadowGear","SubType":"NULL"},
24481: {"Type":"ShadowGear","SubType":"NULL"},
24482: {"Type":"ShadowGear","SubType":"NULL"},
24483: {"Type":"ShadowGear","SubType":"NULL"},
24484: {"Type":"ShadowGear","SubType":"NULL"},
24485: {"Type":"ShadowGear","SubType":"NULL"},
24486: {"Type":"ShadowGear","SubType":"NULL"},
24487: {"Type":"ShadowGear","SubType":"NULL"},
24488: {"Type":"ShadowGear","SubType":"NULL"},
24489: {"Type":"ShadowGear","SubType":"NULL"},
24490: {"Type":"ShadowGear","SubType":"NULL"},
24491: {"Type":"ShadowGear","SubType":"NULL"},
24492: {"Type":"ShadowGear","SubType":"NULL"},
24493: {"Type":"ShadowGear","SubType":"NULL"},
24494: {"Type":"ShadowGear","SubType":"NULL"},
24495: {"Type":"ShadowGear","SubType":"NULL"},
24496: {"Type":"ShadowGear","SubType":"NULL"},
24497: {"Type":"ShadowGear","SubType":"NULL"},
24498: {"Type":"ShadowGear","SubType":"NULL"},
24499: {"Type":"ShadowGear","SubType":"NULL"},
24500: {"Type":"ShadowGear","SubType":"NULL"},
24501: {"Type":"ShadowGear","SubType":"NULL"},
24502: {"Type":"ShadowGear","SubType":"NULL"},
24503: {"Type":"ShadowGear","SubType":"NULL"},
24504: {"Type":"ShadowGear","SubType":"NULL"},
24505: {"Type":"ShadowGear","SubType":"NULL"},
24506: {"Type":"ShadowGear","SubType":"NULL"},
24507: {"Type":"ShadowGear","SubType":"NULL"},
24508: {"Type":"ShadowGear","SubType":"NULL"},
24509: {"Type":"ShadowGear","SubType":"NULL"},
24510: {"Type":"ShadowGear","SubType":"NULL"},
24511: {"Type":"ShadowGear","SubType":"NULL"},
24512: {"Type":"ShadowGear","SubType":"NULL"},
24513: {"Type":"ShadowGear","SubType":"NULL"},
24514: {"Type":"ShadowGear","SubType":"NULL"},
24515: {"Type":"ShadowGear","SubType":"NULL"},
24516: {"Type":"ShadowGear","SubType":"NULL"},
24517: {"Type":"ShadowGear","SubType":"NULL"},
24518: {"Type":"ShadowGear","SubType":"NULL"},
24519: {"Type":"ShadowGear","SubType":"NULL"},
24520: {"Type":"ShadowGear","SubType":"NULL"},
24521: {"Type":"ShadowGear","SubType":"NULL"},
24522: {"Type":"ShadowGear","SubType":"NULL"},
24523: {"Type":"ShadowGear","SubType":"NULL"},
24524: {"Type":"ShadowGear","SubType":"NULL"},
24525: {"Type":"ShadowGear","SubType":"NULL"},
24526: {"Type":"ShadowGear","SubType":"NULL"},
24527: {"Type":"ShadowGear","SubType":"NULL"},
24528: {"Type":"ShadowGear","SubType":"NULL"},
24529: {"Type":"ShadowGear","SubType":"NULL"},
24530: {"Type":"ShadowGear","SubType":"NULL"},
24531: {"Type":"ShadowGear","SubType":"NULL"},
24532: {"Type":"ShadowGear","SubType":"NULL"},
24533: {"Type":"ShadowGear","SubType":"NULL"},
24534: {"Type":"ShadowGear","SubType":"NULL"},
24535: {"Type":"ShadowGear","SubType":"NULL"},
24536: {"Type":"ShadowGear","SubType":"NULL"},
24537: {"Type":"ShadowGear","SubType":"NULL"},
24538: {"Type":"ShadowGear","SubType":"NULL"},
24539: {"Type":"ShadowGear","SubType":"NULL"},
24540: {"Type":"ShadowGear","SubType":"NULL"},
24541: {"Type":"ShadowGear","SubType":"NULL"},
24542: {"Type":"ShadowGear","SubType":"NULL"},
24543: {"Type":"ShadowGear","SubType":"NULL"},
24544: {"Type":"ShadowGear","SubType":"NULL"},
24545: {"Type":"ShadowGear","SubType":"NULL"},
24546: {"Type":"ShadowGear","SubType":"NULL"},
24547: {"Type":"ShadowGear","SubType":"NULL"},
24548: {"Type":"ShadowGear","SubType":"NULL"},
24549: {"Type":"ShadowGear","SubType":"NULL"},
24550: {"Type":"ShadowGear","SubType":"NULL"},
24551: {"Type":"ShadowGear","SubType":"NULL"},
24552: {"Type":"ShadowGear","SubType":"NULL"},
24553: {"Type":"ShadowGear","SubType":"NULL"},
24554: {"Type":"ShadowGear","SubType":"NULL"},
24555: {"Type":"ShadowGear","SubType":"NULL"},
24556: {"Type":"ShadowGear","SubType":"NULL"},
24557: {"Type":"ShadowGear","SubType":"NULL"},
24558: {"Type":"ShadowGear","SubType":"NULL"},
24559: {"Type":"ShadowGear","SubType":"NULL"},
24560: {"Type":"ShadowGear","SubType":"NULL"},
24561: {"Type":"ShadowGear","SubType":"NULL"},
24562: {"Type":"ShadowGear","SubType":"NULL"},
24563: {"Type":"ShadowGear","SubType":"NULL"},
24564: {"Type":"ShadowGear","SubType":"NULL"},
24565: {"Type":"ShadowGear","SubType":"NULL"},
24566: {"Type":"ShadowGear","SubType":"NULL"},
24567: {"Type":"ShadowGear","SubType":"NULL"},
24568: {"Type":"ShadowGear","SubType":"NULL"},
24569: {"Type":"ShadowGear","SubType":"NULL"},
24570: {"Type":"ShadowGear","SubType":"NULL"},
24571: {"Type":"ShadowGear","SubType":"NULL"},
24572: {"Type":"ShadowGear","SubType":"NULL"},
24573: {"Type":"ShadowGear","SubType":"NULL"},
24574: {"Type":"ShadowGear","SubType":"NULL"},
24575: {"Type":"ShadowGear","SubType":"NULL"},
24576: {"Type":"ShadowGear","SubType":"NULL"},
24577: {"Type":"ShadowGear","SubType":"NULL"},
24578: {"Type":"ShadowGear","SubType":"NULL"},
24579: {"Type":"ShadowGear","SubType":"NULL"},
24580: {"Type":"ShadowGear","SubType":"NULL"},
24581: {"Type":"ShadowGear","SubType":"NULL"},
24582: {"Type":"ShadowGear","SubType":"NULL"},
24583: {"Type":"ShadowGear","SubType":"NULL"},
24584: {"Type":"ShadowGear","SubType":"NULL"},
24585: {"Type":"ShadowGear","SubType":"NULL"},
24586: {"Type":"ShadowGear","SubType":"NULL"},
24587: {"Type":"ShadowGear","SubType":"NULL"},
24588: {"Type":"ShadowGear","SubType":"NULL"},
24589: {"Type":"ShadowGear","SubType":"NULL"},
24590: {"Type":"ShadowGear","SubType":"NULL"},
24591: {"Type":"ShadowGear","SubType":"NULL"},
24592: {"Type":"ShadowGear","SubType":"NULL"},
24593: {"Type":"ShadowGear","SubType":"NULL"},
24594: {"Type":"ShadowGear","SubType":"NULL"},
24595: {"Type":"ShadowGear","SubType":"NULL"},
24596: {"Type":"ShadowGear","SubType":"NULL"},
24597: {"Type":"ShadowGear","SubType":"NULL"},
24598: {"Type":"ShadowGear","SubType":"NULL"},
24599: {"Type":"ShadowGear","SubType":"NULL"},
24600: {"Type":"ShadowGear","SubType":"NULL"},
24601: {"Type":"ShadowGear","SubType":"NULL"},
24602: {"Type":"ShadowGear","SubType":"NULL"},
24603: {"Type":"ShadowGear","SubType":"NULL"},
24604: {"Type":"ShadowGear","SubType":"NULL"},
24605: {"Type":"ShadowGear","SubType":"NULL"},
24606: {"Type":"ShadowGear","SubType":"NULL"},
24607: {"Type":"ShadowGear","SubType":"NULL"},
24608: {"Type":"ShadowGear","SubType":"NULL"},
24609: {"Type":"ShadowGear","SubType":"NULL"},
24610: {"Type":"ShadowGear","SubType":"NULL"},
24611: {"Type":"ShadowGear","SubType":"NULL"},
24612: {"Type":"ShadowGear","SubType":"NULL"},
24613: {"Type":"ShadowGear","SubType":"NULL"},
24614: {"Type":"ShadowGear","SubType":"NULL"},
24615: {"Type":"ShadowGear","SubType":"NULL"},
24616: {"Type":"ShadowGear","SubType":"NULL"},
24617: {"Type":"ShadowGear","SubType":"NULL"},
24618: {"Type":"ShadowGear","SubType":"NULL"},
24619: {"Type":"ShadowGear","SubType":"NULL"},
24620: {"Type":"ShadowGear","SubType":"NULL"},
24621: {"Type":"ShadowGear","SubType":"NULL"},
24622: {"Type":"ShadowGear","SubType":"NULL"},
24623: {"Type":"ShadowGear","SubType":"NULL"},
24624: {"Type":"ShadowGear","SubType":"NULL"},
24625: {"Type":"ShadowGear","SubType":"NULL"},
24626: {"Type":"ShadowGear","SubType":"NULL"},
24627: {"Type":"ShadowGear","SubType":"NULL"},
24628: {"Type":"ShadowGear","SubType":"NULL"},
24629: {"Type":"ShadowGear","SubType":"NULL"},
24630: {"Type":"ShadowGear","SubType":"NULL"},
24631: {"Type":"ShadowGear","SubType":"NULL"},
24632: {"Type":"ShadowGear","SubType":"NULL"},
24633: {"Type":"ShadowGear","SubType":"NULL"},
24634: {"Type":"ShadowGear","SubType":"NULL"},
24635: {"Type":"ShadowGear","SubType":"NULL"},
24636: {"Type":"ShadowGear","SubType":"NULL"},
24637: {"Type":"ShadowGear","SubType":"NULL"},
24638: {"Type":"ShadowGear","SubType":"NULL"},
24639: {"Type":"ShadowGear","SubType":"NULL"},
24640: {"Type":"ShadowGear","SubType":"NULL"},
24641: {"Type":"ShadowGear","SubType":"NULL"},
24642: {"Type":"ShadowGear","SubType":"NULL"},
24643: {"Type":"ShadowGear","SubType":"NULL"},
24644: {"Type":"ShadowGear","SubType":"NULL"},
24645: {"Type":"ShadowGear","SubType":"NULL"},
24646: {"Type":"ShadowGear","SubType":"NULL"},
24647: {"Type":"ShadowGear","SubType":"NULL"},
24648: {"Type":"ShadowGear","SubType":"NULL"},
24649: {"Type":"ShadowGear","SubType":"NULL"},
24650: {"Type":"ShadowGear","SubType":"NULL"},
24651: {"Type":"ShadowGear","SubType":"NULL"},
24652: {"Type":"ShadowGear","SubType":"NULL"},
24653: {"Type":"ShadowGear","SubType":"NULL"},
24654: {"Type":"ShadowGear","SubType":"NULL"},
24655: {"Type":"ShadowGear","SubType":"NULL"},
24656: {"Type":"ShadowGear","SubType":"NULL"},
24657: {"Type":"ShadowGear","SubType":"NULL"},
24658: {"Type":"ShadowGear","SubType":"NULL"},
24659: {"Type":"ShadowGear","SubType":"NULL"},
24660: {"Type":"ShadowGear","SubType":"NULL"},
24661: {"Type":"ShadowGear","SubType":"NULL"},
24662: {"Type":"ShadowGear","SubType":"NULL"},
24663: {"Type":"ShadowGear","SubType":"NULL"},
24664: {"Type":"ShadowGear","SubType":"NULL"},
24665: {"Type":"ShadowGear","SubType":"NULL"},
24666: {"Type":"ShadowGear","SubType":"NULL"},
24667: {"Type":"ShadowGear","SubType":"NULL"},
24668: {"Type":"ShadowGear","SubType":"NULL"},
24669: {"Type":"ShadowGear","SubType":"NULL"},
24670: {"Type":"ShadowGear","SubType":"NULL"},
24671: {"Type":"ShadowGear","SubType":"NULL"},
24672: {"Type":"ShadowGear","SubType":"NULL"},
24673: {"Type":"ShadowGear","SubType":"NULL"},
24674: {"Type":"ShadowGear","SubType":"NULL"},
24675: {"Type":"ShadowGear","SubType":"NULL"},
24676: {"Type":"ShadowGear","SubType":"NULL"},
24677: {"Type":"ShadowGear","SubType":"NULL"},
24678: {"Type":"ShadowGear","SubType":"NULL"},
24679: {"Type":"ShadowGear","SubType":"NULL"},
24680: {"Type":"ShadowGear","SubType":"NULL"},
24681: {"Type":"ShadowGear","SubType":"NULL"},
24682: {"Type":"ShadowGear","SubType":"NULL"},
24683: {"Type":"ShadowGear","SubType":"NULL"},
24684: {"Type":"ShadowGear","SubType":"NULL"},
24685: {"Type":"ShadowGear","SubType":"NULL"},
24686: {"Type":"ShadowGear","SubType":"NULL"},
24687: {"Type":"Shadowgear","SubType":"NULL"},
24688: {"Type":"Shadowgear","SubType":"NULL"},
24689: {"Type":"Shadowgear","SubType":"NULL"},
24690: {"Type":"Shadowgear","SubType":"NULL"},
24691: {"Type":"Shadowgear","SubType":"NULL"},
24692: {"Type":"Shadowgear","SubType":"NULL"},
24693: {"Type":"Shadowgear","SubType":"NULL"},
24694: {"Type":"Shadowgear","SubType":"NULL"},
24695: {"Type":"Shadowgear","SubType":"NULL"},
24696: {"Type":"Shadowgear","SubType":"NULL"},
24697: {"Type":"Shadowgear","SubType":"NULL"},
24698: {"Type":"Shadowgear","SubType":"NULL"},
24699: {"Type":"Shadowgear","SubType":"NULL"},
24700: {"Type":"Shadowgear","SubType":"NULL"},
24701: {"Type":"Shadowgear","SubType":"NULL"},
24702: {"Type":"Shadowgear","SubType":"NULL"},
24703: {"Type":"Shadowgear","SubType":"NULL"},
24704: {"Type":"Shadowgear","SubType":"NULL"},
24705: {"Type":"Shadowgear","SubType":"NULL"},
24706: {"Type":"Shadowgear","SubType":"NULL"},
24707: {"Type":"Shadowgear","SubType":"NULL"},
24708: {"Type":"Shadowgear","SubType":"NULL"},
24709: {"Type":"Shadowgear","SubType":"NULL"},
24710: {"Type":"Shadowgear","SubType":"NULL"},
24711: {"Type":"Shadowgear","SubType":"NULL"},
24712: {"Type":"Shadowgear","SubType":"NULL"},
24713: {"Type":"Shadowgear","SubType":"NULL"},
24714: {"Type":"Shadowgear","SubType":"NULL"},
24715: {"Type":"Shadowgear","SubType":"NULL"},
24722: {"Type":"ShadowGear","SubType":"NULL"},
24723: {"Type":"ShadowGear","SubType":"NULL"},
24724: {"Type":"ShadowGear","SubType":"NULL"},
24725: {"Type":"ShadowGear","SubType":"NULL"},
24726: {"Type":"ShadowGear","SubType":"NULL"},
24727: {"Type":"ShadowGear","SubType":"NULL"},
24728: {"Type":"ShadowGear","SubType":"NULL"},
24729: {"Type":"ShadowGear","SubType":"NULL"},
24730: {"Type":"ShadowGear","SubType":"NULL"},
24731: {"Type":"ShadowGear","SubType":"NULL"},
24732: {"Type":"ShadowGear","SubType":"NULL"},
24733: {"Type":"ShadowGear","SubType":"NULL"},
24734: {"Type":"ShadowGear","SubType":"NULL"},
24735: {"Type":"ShadowGear","SubType":"NULL"},
24736: {"Type":"ShadowGear","SubType":"NULL"},
24737: {"Type":"ShadowGear","SubType":"NULL"},
24738: {"Type":"ShadowGear","SubType":"NULL"},
24739: {"Type":"ShadowGear","SubType":"NULL"},
24740: {"Type":"ShadowGear","SubType":"NULL"},
24741: {"Type":"ShadowGear","SubType":"NULL"},
24742: {"Type":"ShadowGear","SubType":"NULL"},
24743: {"Type":"ShadowGear","SubType":"NULL"},
24744: {"Type":"ShadowGear","SubType":"NULL"},
24745: {"Type":"ShadowGear","SubType":"NULL"},
24746: {"Type":"ShadowGear","SubType":"NULL"},
24747: {"Type":"ShadowGear","SubType":"NULL"},
24748: {"Type":"ShadowGear","SubType":"NULL"},
24749: {"Type":"ShadowGear","SubType":"NULL"},
24750: {"Type":"ShadowGear","SubType":"NULL"},
24751: {"Type":"ShadowGear","SubType":"NULL"},
24752: {"Type":"ShadowGear","SubType":"NULL"},
24753: {"Type":"ShadowGear","SubType":"NULL"},
24754: {"Type":"ShadowGear","SubType":"NULL"},
24755: {"Type":"ShadowGear","SubType":"NULL"},
24756: {"Type":"ShadowGear","SubType":"NULL"},
24757: {"Type":"ShadowGear","SubType":"NULL"},
24758: {"Type":"ShadowGear","SubType":"NULL"},
24759: {"Type":"ShadowGear","SubType":"NULL"},
24760: {"Type":"ShadowGear","SubType":"NULL"},
24761: {"Type":"ShadowGear","SubType":"NULL"},
24762: {"Type":"ShadowGear","SubType":"NULL"},
24763: {"Type":"ShadowGear","SubType":"NULL"},
24764: {"Type":"ShadowGear","SubType":"NULL"},
24765: {"Type":"ShadowGear","SubType":"NULL"},
24766: {"Type":"ShadowGear","SubType":"NULL"},
24767: {"Type":"ShadowGear","SubType":"NULL"},
24768: {"Type":"ShadowGear","SubType":"NULL"},
24770: {"Type":"ShadowGear","SubType":"NULL"},
24778: {"Type":"ShadowGear","SubType":"NULL"},
24779: {"Type":"ShadowGear","SubType":"NULL"},
24780: {"Type":"ShadowGear","SubType":"NULL"},
24781: {"Type":"ShadowGear","SubType":"NULL"},
24782: {"Type":"ShadowGear","SubType":"NULL"},
24783: {"Type":"ShadowGear","SubType":"NULL"},
24792: {"Type":"ShadowGear","SubType":"NULL"},
24793: {"Type":"ShadowGear","SubType":"NULL"},
24800: {"Type":"ShadowGear","SubType":"NULL"},
24801: {"Type":"ShadowGear","SubType":"NULL"},
24802: {"Type":"ShadowGear","SubType":"NULL"},
24803: {"Type":"ShadowGear","SubType":"NULL"},
24804: {"Type":"ShadowGear","SubType":"NULL"},
24805: {"Type":"ShadowGear","SubType":"NULL"},
24806: {"Type":"ShadowGear","SubType":"NULL"},
24807: {"Type":"ShadowGear","SubType":"NULL"},
24808: {"Type":"ShadowGear","SubType":"NULL"},
24809: {"Type":"ShadowGear","SubType":"NULL"},
24810: {"Type":"ShadowGear","SubType":"NULL"},
24811: {"Type":"ShadowGear","SubType":"NULL"},
24812: {"Type":"ShadowGear","SubType":"NULL"},
24813: {"Type":"ShadowGear","SubType":"NULL"},
24814: {"Type":"ShadowGear","SubType":"NULL"},
24815: {"Type":"ShadowGear","SubType":"NULL"},
24816: {"Type":"ShadowGear","SubType":"NULL"},
24817: {"Type":"ShadowGear","SubType":"NULL"},
24818: {"Type":"ShadowGear","SubType":"NULL"},
24819: {"Type":"ShadowGear","SubType":"NULL"},
24820: {"Type":"ShadowGear","SubType":"NULL"},
24821: {"Type":"ShadowGear","SubType":"NULL"},
24822: {"Type":"ShadowGear","SubType":"NULL"},
24823: {"Type":"ShadowGear","SubType":"NULL"},
24824: {"Type":"ShadowGear","SubType":"NULL"},
24825: {"Type":"ShadowGear","SubType":"NULL"},
24826: {"Type":"ShadowGear","SubType":"NULL"},
24827: {"Type":"ShadowGear","SubType":"NULL"},
24828: {"Type":"ShadowGear","SubType":"NULL"},
24829: {"Type":"ShadowGear","SubType":"NULL"},
24830: {"Type":"ShadowGear","SubType":"NULL"},
24831: {"Type":"ShadowGear","SubType":"NULL"},
24832: {"Type":"ShadowGear","SubType":"NULL"},
24833: {"Type":"ShadowGear","SubType":"NULL"},
24834: {"Type":"ShadowGear","SubType":"NULL"},
24835: {"Type":"ShadowGear","SubType":"NULL"},
24836: {"Type":"ShadowGear","SubType":"NULL"},
24837: {"Type":"ShadowGear","SubType":"NULL"},
24838: {"Type":"ShadowGear","SubType":"NULL"},
24839: {"Type":"ShadowGear","SubType":"NULL"},
24840: {"Type":"ShadowGear","SubType":"NULL"},
24841: {"Type":"ShadowGear","SubType":"NULL"},
24842: {"Type":"ShadowGear","SubType":"NULL"},
24843: {"Type":"ShadowGear","SubType":"NULL"},
24844: {"Type":"ShadowGear","SubType":"NULL"},
24845: {"Type":"ShadowGear","SubType":"NULL"},
24846: {"Type":"ShadowGear","SubType":"NULL"},
24847: {"Type":"ShadowGear","SubType":"NULL"},
24848: {"Type":"ShadowGear","SubType":"NULL"},
24849: {"Type":"ShadowGear","SubType":"NULL"},
24850: {"Type":"ShadowGear","SubType":"NULL"},
24851: {"Type":"ShadowGear","SubType":"NULL"},
24852: {"Type":"ShadowGear","SubType":"NULL"},
24853: {"Type":"ShadowGear","SubType":"NULL"},
24854: {"Type":"ShadowGear","SubType":"NULL"},
24855: {"Type":"ShadowGear","SubType":"NULL"},
24856: {"Type":"ShadowGear","SubType":"NULL"},
24857: {"Type":"ShadowGear","SubType":"NULL"},
24858: {"Type":"ShadowGear","SubType":"NULL"},
24859: {"Type":"ShadowGear","SubType":"NULL"},
24860: {"Type":"ShadowGear","SubType":"NULL"},
24861: {"Type":"ShadowGear","SubType":"NULL"},
24862: {"Type":"ShadowGear","SubType":"NULL"},
24863: {"Type":"ShadowGear","SubType":"NULL"},
24864: {"Type":"ShadowGear","SubType":"NULL"},
24865: {"Type":"ShadowGear","SubType":"NULL"},
24866: {"Type":"ShadowGear","SubType":"NULL"},
24867: {"Type":"ShadowGear","SubType":"NULL"},
24868: {"Type":"ShadowGear","SubType":"NULL"},
24869: {"Type":"ShadowGear","SubType":"NULL"},
24870: {"Type":"ShadowGear","SubType":"NULL"},
24871: {"Type":"ShadowGear","SubType":"NULL"},
24872: {"Type":"ShadowGear","SubType":"NULL"},
24873: {"Type":"ShadowGear","SubType":"NULL"},
24874: {"Type":"ShadowGear","SubType":"NULL"},
24875: {"Type":"ShadowGear","SubType":"NULL"},
24876: {"Type":"ShadowGear","SubType":"NULL"},
24877: {"Type":"ShadowGear","SubType":"NULL"},
24878: {"Type":"ShadowGear","SubType":"NULL"},
24879: {"Type":"ShadowGear","SubType":"NULL"},
24883: {"Type":"ShadowGear","SubType":"NULL"},
24884: {"Type":"ShadowGear","SubType":"NULL"},
24885: {"Type":"ShadowGear","SubType":"NULL"},
24886: {"Type":"ShadowGear","SubType":"NULL"},
24887: {"Type":"ShadowGear","SubType":"NULL"},
24888: {"Type":"ShadowGear","SubType":"NULL"},
24906: {"Type":"ShadowGear","SubType":"NULL"},
24907: {"Type":"ShadowGear","SubType":"NULL"},
24908: {"Type":"ShadowGear","SubType":"NULL"},
24909: {"Type":"ShadowGear","SubType":"NULL"},
24910: {"Type":"ShadowGear","SubType":"NULL"},
24911: {"Type":"ShadowGear","SubType":"NULL"},
24912: {"Type":"ShadowGear","SubType":"NULL"},
24913: {"Type":"ShadowGear","SubType":"NULL"},
24914: {"Type":"ShadowGear","SubType":"NULL"},
24915: {"Type":"ShadowGear","SubType":"NULL"},
24916: {"Type":"ShadowGear","SubType":"NULL"},
24917: {"Type":"ShadowGear","SubType":"NULL"},
24918: {"Type":"ShadowGear","SubType":"NULL"},
24919: {"Type":"ShadowGear","SubType":"NULL"},
24920: {"Type":"ShadowGear","SubType":"NULL"},
24921: {"Type":"ShadowGear","SubType":"NULL"},
24922: {"Type":"ShadowGear","SubType":"NULL"},
24923: {"Type":"ShadowGear","SubType":"NULL"},
24924: {"Type":"ShadowGear","SubType":"NULL"},
24925: {"Type":"ShadowGear","SubType":"NULL"},
24926: {"Type":"ShadowGear","SubType":"NULL"},
24927: {"Type":"ShadowGear","SubType":"NULL"},
24928: {"Type":"ShadowGear","SubType":"NULL"},
24929: {"Type":"ShadowGear","SubType":"NULL"},
24936: {"Type":"ShadowGear","SubType":"NULL"},
24937: {"Type":"ShadowGear","SubType":"NULL"},
24938: {"Type":"ShadowGear","SubType":"NULL"},
24939: {"Type":"ShadowGear","SubType":"NULL"},
24940: {"Type":"ShadowGear","SubType":"NULL"},
24941: {"Type":"ShadowGear","SubType":"NULL"},
24942: {"Type":"ShadowGear","SubType":"NULL"},
24943: {"Type":"ShadowGear","SubType":"NULL"},
24944: {"Type":"ShadowGear","SubType":"NULL"},
24945: {"Type":"ShadowGear","SubType":"NULL"},
24946: {"Type":"ShadowGear","SubType":"NULL"},
24947: {"Type":"ShadowGear","SubType":"NULL"},
24948: {"Type":"ShadowGear","SubType":"NULL"},
24949: {"Type":"ShadowGear","SubType":"NULL"},
24950: {"Type":"ShadowGear","SubType":"NULL"},
24951: {"Type":"ShadowGear","SubType":"NULL"},
24952: {"Type":"ShadowGear","SubType":"NULL"},
24953: {"Type":"ShadowGear","SubType":"NULL"},
24954: {"Type":"ShadowGear","SubType":"NULL"},
24955: {"Type":"ShadowGear","SubType":"NULL"},
24956: {"Type":"ShadowGear","SubType":"NULL"},
24957: {"Type":"ShadowGear","SubType":"NULL"},
24958: {"Type":"ShadowGear","SubType":"NULL"},
24959: {"Type":"ShadowGear","SubType":"NULL"},
24967: {"Type":"ShadowGear","SubType":"NULL"},
24968: {"Type":"ShadowGear","SubType":"NULL"},
24969: {"Type":"ShadowGear","SubType":"NULL"},
24970: {"Type":"ShadowGear","SubType":"NULL"},
24971: {"Type":"ShadowGear","SubType":"NULL"},
24972: {"Type":"ShadowGear","SubType":"NULL"},
24973: {"Type":"ShadowGear","SubType":"NULL"},
24974: {"Type":"ShadowGear","SubType":"NULL"},
24975: {"Type":"ShadowGear","SubType":"NULL"},
24976: {"Type":"ShadowGear","SubType":"NULL"},
24977: {"Type":"ShadowGear","SubType":"NULL"},
24978: {"Type":"ShadowGear","SubType":"NULL"},
24979: {"Type":"ShadowGear","SubType":"NULL"},
24980: {"Type":"ShadowGear","SubType":"NULL"},
24981: {"Type":"ShadowGear","SubType":"NULL"},
24982: {"Type":"ShadowGear","SubType":"NULL"},
24983: {"Type":"ShadowGear","SubType":"NULL"},
24984: {"Type":"ShadowGear","SubType":"NULL"},
24985: {"Type":"ShadowGear","SubType":"NULL"},
24986: {"Type":"ShadowGear","SubType":"NULL"},
24987: {"Type":"ShadowGear","SubType":"NULL"},
24988: {"Type":"ShadowGear","SubType":"NULL"},
24989: {"Type":"ShadowGear","SubType":"NULL"},
24990: {"Type":"ShadowGear","SubType":"NULL"},
24993: {"Type":"ShadowGear","SubType":"NULL"},
24994: {"Type":"ShadowGear","SubType":"NULL"},
24995: {"Type":"ShadowGear","SubType":"NULL"},
24996: {"Type":"ShadowGear","SubType":"NULL"},
24997: {"Type":"ShadowGear","SubType":"NULL"},
24998: {"Type":"ShadowGear","SubType":"NULL"},
24999: {"Type":"ShadowGear","SubType":"NULL"},
25000: {"Type":"Etc","SubType":"NULL"},
25001: {"Type":"Etc","SubType":"NULL"},
25002: {"Type":"Etc","SubType":"NULL"},
25003: {"Type":"Etc","SubType":"NULL"},
25004: {"Type":"Etc","SubType":"NULL"},
25005: {"Type":"Etc","SubType":"NULL"},
25006: {"Type":"Etc","SubType":"NULL"},
25007: {"Type":"Etc","SubType":"NULL"},
25008: {"Type":"Etc","SubType":"NULL"},
25009: {"Type":"Etc","SubType":"NULL"},
25010: {"Type":"Etc","SubType":"NULL"},
25011: {"Type":"Etc","SubType":"NULL"},
25012: {"Type":"Etc","SubType":"NULL"},
25013: {"Type":"Etc","SubType":"NULL"},
25014: {"Type":"Etc","SubType":"NULL"},
25015: {"Type":"Etc","SubType":"NULL"},
25016: {"Type":"Etc","SubType":"NULL"},
25017: {"Type":"Etc","SubType":"NULL"},
25038: {"Type":"Etc","SubType":"NULL"},
25039: {"Type":"Etc","SubType":"NULL"},
25041: {"Type":"Etc","SubType":"NULL"},
25042: {"Type":"Etc","SubType":"NULL"},
25043: {"Type":"Etc","SubType":"NULL"},
25044: {"Type":"Etc","SubType":"NULL"},
25045: {"Type":"Etc","SubType":"NULL"},
25046: {"Type":"Etc","SubType":"NULL"},
25047: {"Type":"Etc","SubType":"NULL"},
25048: {"Type":"Etc","SubType":"NULL"},
25049: {"Type":"Etc","SubType":"NULL"},
25051: {"Type":"Etc","SubType":"NULL"},
25058: {"Type":"Etc","SubType":"NULL"},
25059: {"Type":"Etc","SubType":"NULL"},
25060: {"Type":"Etc","SubType":"NULL"},
25061: {"Type":"Etc","SubType":"NULL"},
25062: {"Type":"Etc","SubType":"NULL"},
25063: {"Type":"Etc","SubType":"NULL"},
25064: {"Type":"Etc","SubType":"NULL"},
25065: {"Type":"Etc","SubType":"NULL"},
25066: {"Type":"Card","SubType":"NULL"},
25067: {"Type":"Etc","SubType":"NULL"},
25068: {"Type":"Etc","SubType":"NULL"},
25069: {"Type":"Etc","SubType":"NULL"},
25070: {"Type":"Etc","SubType":"NULL"},
25071: {"Type":"Etc","SubType":"NULL"},
25072: {"Type":"Etc","SubType":"NULL"},
25073: {"Type":"Etc","SubType":"NULL"},
25074: {"Type":"Etc","SubType":"NULL"},
25075: {"Type":"Etc","SubType":"NULL"},
25076: {"Type":"Etc","SubType":"NULL"},
25077: {"Type":"Etc","SubType":"NULL"},
25078: {"Type":"Etc","SubType":"NULL"},
25079: {"Type":"Etc","SubType":"NULL"},
25080: {"Type":"Etc","SubType":"NULL"},
25083: {"Type":"Etc","SubType":"NULL"},
25084: {"Type":"Etc","SubType":"NULL"},
25085: {"Type":"Etc","SubType":"NULL"},
25086: {"Type":"Etc","SubType":"NULL"},
25087: {"Type":"Etc","SubType":"NULL"},
25088: {"Type":"Etc","SubType":"NULL"},
25089: {"Type":"Etc","SubType":"NULL"},
25098: {"Type":"Etc","SubType":"NULL"},
25099: {"Type":"Etc","SubType":"NULL"},
25100: {"Type":"Etc","SubType":"NULL"},
25101: {"Type":"Etc","SubType":"NULL"},
25102: {"Type":"Etc","SubType":"NULL"},
25103: {"Type":"Etc","SubType":"NULL"},
25104: {"Type":"Etc","SubType":"NULL"},
25105: {"Type":"Etc","SubType":"NULL"},
25106: {"Type":"Etc","SubType":"NULL"},
25107: {"Type":"Etc","SubType":"NULL"},
25108: {"Type":"Etc","SubType":"NULL"},
25109: {"Type":"Etc","SubType":"NULL"},
25110: {"Type":"Etc","SubType":"NULL"},
25111: {"Type":"Etc","SubType":"NULL"},
25112: {"Type":"Etc","SubType":"NULL"},
25113: {"Type":"Etc","SubType":"NULL"},
25114: {"Type":"Etc","SubType":"NULL"},
25115: {"Type":"Etc","SubType":"NULL"},
25116: {"Type":"Etc","SubType":"NULL"},
25117: {"Type":"Etc","SubType":"NULL"},
25118: {"Type":"Etc","SubType":"NULL"},
25119: {"Type":"Etc","SubType":"NULL"},
25120: {"Type":"Etc","SubType":"NULL"},
25121: {"Type":"Etc","SubType":"NULL"},
25122: {"Type":"Etc","SubType":"NULL"},
25123: {"Type":"Etc","SubType":"NULL"},
25127: {"Type":"Etc","SubType":"NULL"},
25128: {"Type":"Etc","SubType":"NULL"},
25129: {"Type":"Etc","SubType":"NULL"},
25130: {"Type":"Etc","SubType":"NULL"},
25131: {"Type":"Etc","SubType":"NULL"},
25132: {"Type":"Etc","SubType":"NULL"},
25133: {"Type":"Etc","SubType":"NULL"},
25135: {"Type":"Etc","SubType":"NULL"},
25136: {"Type":"Etc","SubType":"NULL"},
25137: {"Type":"Etc","SubType":"NULL"},
25138: {"Type":"Etc","SubType":"NULL"},
25139: {"Type":"Etc","SubType":"NULL"},
25140: {"Type":"Etc","SubType":"NULL"},
25141: {"Type":"Etc","SubType":"NULL"},
25142: {"Type":"Etc","SubType":"NULL"},
25143: {"Type":"Etc","SubType":"NULL"},
25144: {"Type":"Etc","SubType":"NULL"},
25145: {"Type":"Etc","SubType":"NULL"},
25146: {"Type":"Etc","SubType":"NULL"},
25147: {"Type":"Etc","SubType":"NULL"},
25148: {"Type":"Etc","SubType":"NULL"},
25149: {"Type":"Etc","SubType":"NULL"},
25150: {"Type":"Etc","SubType":"NULL"},
25151: {"Type":"Etc","SubType":"NULL"},
25152: {"Type":"Etc","SubType":"NULL"},
25153: {"Type":"Etc","SubType":"NULL"},
25154: {"Type":"Etc","SubType":"NULL"},
25155: {"Type":"Etc","SubType":"NULL"},
25156: {"Type":"Etc","SubType":"NULL"},
25157: {"Type":"Etc","SubType":"NULL"},
25158: {"Type":"Etc","SubType":"NULL"},
25159: {"Type":"Etc","SubType":"NULL"},
25160: {"Type":"Etc","SubType":"NULL"},
25161: {"Type":"Etc","SubType":"NULL"},
25162: {"Type":"Etc","SubType":"NULL"},
25163: {"Type":"Etc","SubType":"NULL"},
25164: {"Type":"Etc","SubType":"NULL"},
25165: {"Type":"Etc","SubType":"NULL"},
25166: {"Type":"Etc","SubType":"NULL"},
25167: {"Type":"Etc","SubType":"NULL"},
25169: {"Type":"Etc","SubType":"NULL"},
25170: {"Type":"Etc","SubType":"NULL"},
25171: {"Type":"Etc","SubType":"NULL"},
25172: {"Type":"Etc","SubType":"NULL"},
25173: {"Type":"Etc","SubType":"NULL"},
25174: {"Type":"Etc","SubType":"NULL"},
25175: {"Type":"Etc","SubType":"NULL"},
25176: {"Type":"Etc","SubType":"NULL"},
25177: {"Type":"Etc","SubType":"NULL"},
25178: {"Type":"Etc","SubType":"NULL"},
25179: {"Type":"Etc","SubType":"NULL"},
25180: {"Type":"Etc","SubType":"NULL"},
25181: {"Type":"Etc","SubType":"NULL"},
25182: {"Type":"Etc","SubType":"NULL"},
25183: {"Type":"Etc","SubType":"NULL"},
25184: {"Type":"Etc","SubType":"NULL"},
25185: {"Type":"Etc","SubType":"NULL"},
25187: {"Type":"Etc","SubType":"NULL"},
25188: {"Type":"Etc","SubType":"NULL"},
25200: {"Type":"Etc","SubType":"NULL"},
25201: {"Type":"Etc","SubType":"NULL"},
25205: {"Type":"Etc","SubType":"NULL"},
25206: {"Type":"Etc","SubType":"NULL"},
25207: {"Type":"Etc","SubType":"NULL"},
25208: {"Type":"Etc","SubType":"NULL"},
25209: {"Type":"Etc","SubType":"NULL"},
25210: {"Type":"Etc","SubType":"NULL"},
25212: {"Type":"Etc","SubType":"NULL"},
25218: {"Type":"Etc","SubType":"NULL"},
25219: {"Type":"Etc","SubType":"NULL"},
25220: {"Type":"Etc","SubType":"NULL"},
25221: {"Type":"Etc","SubType":"NULL"},
25222: {"Type":"Etc","SubType":"NULL"},
25223: {"Type":"Etc","SubType":"NULL"},
25224: {"Type":"Etc","SubType":"NULL"},
25225: {"Type":"Etc","SubType":"NULL"},
25226: {"Type":"Etc","SubType":"NULL"},
25227: {"Type":"Etc","SubType":"NULL"},
25228: {"Type":"Etc","SubType":"NULL"},
25229: {"Type":"Etc","SubType":"NULL"},
25231: {"Type":"Etc","SubType":"NULL"},
25232: {"Type":"Etc","SubType":"NULL"},
25233: {"Type":"Etc","SubType":"NULL"},
25235: {"Type":"Etc","SubType":"NULL"},
25238: {"Type":"Etc","SubType":"NULL"},
25239: {"Type":"Etc","SubType":"NULL"},
25240: {"Type":"Etc","SubType":"NULL"},
25245: {"Type":"Etc","SubType":"NULL"},
25246: {"Type":"Etc","SubType":"NULL"},
25247: {"Type":"Etc","SubType":"NULL"},
25248: {"Type":"Etc","SubType":"NULL"},
25249: {"Type":"Etc","SubType":"NULL"},
25250: {"Type":"Etc","SubType":"NULL"},
25251: {"Type":"Etc","SubType":"NULL"},
25252: {"Type":"Etc","SubType":"NULL"},
25253: {"Type":"Etc","SubType":"NULL"},
25254: {"Type":"Etc","SubType":"NULL"},
25256: {"Type":"Etc","SubType":"NULL"},
25257: {"Type":"Etc","SubType":"NULL"},
25258: {"Type":"Etc","SubType":"NULL"},
25259: {"Type":"Etc","SubType":"NULL"},
25260: {"Type":"Etc","SubType":"NULL"},
25261: {"Type":"Etc","SubType":"NULL"},
25262: {"Type":"Etc","SubType":"NULL"},
25263: {"Type":"Etc","SubType":"NULL"},
25264: {"Type":"Etc","SubType":"NULL"},
25265: {"Type":"Etc","SubType":"NULL"},
25266: {"Type":"Etc","SubType":"NULL"},
25267: {"Type":"Etc","SubType":"NULL"},
25268: {"Type":"Etc","SubType":"NULL"},
25269: {"Type":"Etc","SubType":"NULL"},
25270: {"Type":"Etc","SubType":"NULL"},
25271: {"Type":"Etc","SubType":"NULL"},
25272: {"Type":"Etc","SubType":"NULL"},
25273: {"Type":"Etc","SubType":"NULL"},
25274: {"Type":"Etc","SubType":"NULL"},
25276: {"Type":"Etc","SubType":"NULL"},
25277: {"Type":"Etc","SubType":"NULL"},
25278: {"Type":"Etc","SubType":"NULL"},
25279: {"Type":"Etc","SubType":"NULL"},
25280: {"Type":"Etc","SubType":"NULL"},
25281: {"Type":"Etc","SubType":"NULL"},
25282: {"Type":"Etc","SubType":"NULL"},
25283: {"Type":"Etc","SubType":"NULL"},
25284: {"Type":"Etc","SubType":"NULL"},
25285: {"Type":"Etc","SubType":"NULL"},
25286: {"Type":"Etc","SubType":"NULL"},
25287: {"Type":"Etc","SubType":"NULL"},
25290: {"Type":"Etc","SubType":"NULL"},
25291: {"Type":"Etc","SubType":"NULL"},
25292: {"Type":"Etc","SubType":"NULL"},
25294: {"Type":"Etc","SubType":"NULL"},
25295: {"Type":"Etc","SubType":"NULL"},
25296: {"Type":"Etc","SubType":"NULL"},
25297: {"Type":"Etc","SubType":"NULL"},
25298: {"Type":"Etc","SubType":"NULL"},
25299: {"Type":"Etc","SubType":"NULL"},
25300: {"Type":"Etc","SubType":"NULL"},
25302: {"Type":"Etc","SubType":"NULL"},
25303: {"Type":"Etc","SubType":"NULL"},
25304: {"Type":"Etc","SubType":"NULL"},
25305: {"Type":"Etc","SubType":"NULL"},
25306: {"Type":"Etc","SubType":"NULL"},
25307: {"Type":"Etc","SubType":"NULL"},
25308: {"Type":"Etc","SubType":"NULL"},
25309: {"Type":"Etc","SubType":"NULL"},
25310: {"Type":"Etc","SubType":"NULL"},
25311: {"Type":"Etc","SubType":"NULL"},
25312: {"Type":"Etc","SubType":"NULL"},
25313: {"Type":"Etc","SubType":"NULL"},
25314: {"Type":"Etc","SubType":"NULL"},
25315: {"Type":"Etc","SubType":"NULL"},
25316: {"Type":"Etc","SubType":"NULL"},
25318: {"Type":"Etc","SubType":"NULL"},
25319: {"Type":"Etc","SubType":"NULL"},
25320: {"Type":"Etc","SubType":"NULL"},
25340: {"Type":"Etc","SubType":"NULL"},
25341: {"Type":"Etc","SubType":"NULL"},
25342: {"Type":"Etc","SubType":"NULL"},
25344: {"Type":"Etc","SubType":"NULL"},
25358: {"Type":"Etc","SubType":"NULL"},
25359: {"Type":"Etc","SubType":"NULL"},
25360: {"Type":"Etc","SubType":"NULL"},
25365: {"Type":"Etc","SubType":"NULL"},
25366: {"Type":"Etc","SubType":"NULL"},
25367: {"Type":"Etc","SubType":"NULL"},
25375: {"Type":"Etc","SubType":"NULL"},
25376: {"Type":"Etc","SubType":"NULL"},
25377: {"Type":"Etc","SubType":"NULL"},
25378: {"Type":"Etc","SubType":"NULL"},
25379: {"Type":"Etc","SubType":"NULL"},
25380: {"Type":"Etc","SubType":"NULL"},
25381: {"Type":"Etc","SubType":"NULL"},
25382: {"Type":"Etc","SubType":"NULL"},
25383: {"Type":"Etc","SubType":"NULL"},
25390: {"Type":"Etc","SubType":"NULL"},
25391: {"Type":"Etc","SubType":"NULL"},
25392: {"Type":"Etc","SubType":"NULL"},
25393: {"Type":"Etc","SubType":"NULL"},
25394: {"Type":"Etc","SubType":"NULL"},
25395: {"Type":"Etc","SubType":"NULL"},
25401: {"Type":"Etc","SubType":"NULL"},
25408: {"Type":"Etc","SubType":"NULL"},
25409: {"Type":"Etc","SubType":"NULL"},
25410: {"Type":"Etc","SubType":"NULL"},
25411: {"Type":"Etc","SubType":"NULL"},
25412: {"Type":"Etc","SubType":"NULL"},
25413: {"Type":"Etc","SubType":"NULL"},
25414: {"Type":"Etc","SubType":"NULL"},
25415: {"Type":"Etc","SubType":"NULL"},
25416: {"Type":"Etc","SubType":"NULL"},
25417: {"Type":"Etc","SubType":"NULL"},
25418: {"Type":"Etc","SubType":"NULL"},
25419: {"Type":"Etc","SubType":"NULL"},
25420: {"Type":"Etc","SubType":"NULL"},
25421: {"Type":"Etc","SubType":"NULL"},
25422: {"Type":"Etc","SubType":"NULL"},
25425: {"Type":"Etc","SubType":"NULL"},
25426: {"Type":"Etc","SubType":"NULL"},
25427: {"Type":"Etc","SubType":"NULL"},
25428: {"Type":"Etc","SubType":"NULL"},
25445: {"Type":"Etc","SubType":"NULL"},
25446: {"Type":"Etc","SubType":"NULL"},
25447: {"Type":"Etc","SubType":"NULL"},
25448: {"Type":"Etc","SubType":"NULL"},
25449: {"Type":"Etc","SubType":"NULL"},
25450: {"Type":"Etc","SubType":"NULL"},
25451: {"Type":"Etc","SubType":"NULL"},
25452: {"Type":"Etc","SubType":"NULL"},
25453: {"Type":"Etc","SubType":"NULL"},
25454: {"Type":"Etc","SubType":"NULL"},
25455: {"Type":"Etc","SubType":"NULL"},
25456: {"Type":"Etc","SubType":"NULL"},
25461: {"Type":"Etc","SubType":"NULL"},
25464: {"Type":"Etc","SubType":"NULL"},
25479: {"Type":"Etc","SubType":"NULL"},
25482: {"Type":"Etc","SubType":"NULL"},
25483: {"Type":"Etc","SubType":"NULL"},
25484: {"Type":"Etc","SubType":"NULL"},
25485: {"Type":"Etc","SubType":"NULL"},
25486: {"Type":"Etc","SubType":"NULL"},
25487: {"Type":"Etc","SubType":"NULL"},
25488: {"Type":"Etc","SubType":"NULL"},
25489: {"Type":"Etc","SubType":"NULL"},
25490: {"Type":"Etc","SubType":"NULL"},
25491: {"Type":"Etc","SubType":"NULL"},
25492: {"Type":"Etc","SubType":"NULL"},
25493: {"Type":"Etc","SubType":"NULL"},
25494: {"Type":"Etc","SubType":"NULL"},
25495: {"Type":"Etc","SubType":"NULL"},
25496: {"Type":"Etc","SubType":"NULL"},
25497: {"Type":"Etc","SubType":"NULL"},
25498: {"Type":"Etc","SubType":"NULL"},
25499: {"Type":"Etc","SubType":"NULL"},
25500: {"Type":"Etc","SubType":"NULL"},
25501: {"Type":"Etc","SubType":"NULL"},
25502: {"Type":"Etc","SubType":"NULL"},
25503: {"Type":"Etc","SubType":"NULL"},
25504: {"Type":"Etc","SubType":"NULL"},
25505: {"Type":"Etc","SubType":"NULL"},
25506: {"Type":"Etc","SubType":"NULL"},
25507: {"Type":"Etc","SubType":"NULL"},
25508: {"Type":"Etc","SubType":"NULL"},
25509: {"Type":"Etc","SubType":"NULL"},
25511: {"Type":"Etc","SubType":"NULL"},
25512: {"Type":"Etc","SubType":"NULL"},
25615: {"Type":"Etc","SubType":"NULL"},
25616: {"Type":"Etc","SubType":"NULL"},
25617: {"Type":"Etc","SubType":"NULL"},
25618: {"Type":"Etc","SubType":"NULL"},
25619: {"Type":"Etc","SubType":"NULL"},
25622: {"Type":"Etc","SubType":"NULL"},
25627: {"Type":"Etc","SubType":"NULL"},
25629: {"Type":"Etc","SubType":"NULL"},
25633: {"Type":"Etc","SubType":"NULL"},
25634: {"Type":"Etc","SubType":"NULL"},
25635: {"Type":"Etc","SubType":"NULL"},
25636: {"Type":"Etc","SubType":"NULL"},
25637: {"Type":"Etc","SubType":"NULL"},
25638: {"Type":"Etc","SubType":"NULL"},
25639: {"Type":"Etc","SubType":"NULL"},
25640: {"Type":"Etc","SubType":"NULL"},
25641: {"Type":"Etc","SubType":"NULL"},
25642: {"Type":"Etc","SubType":"NULL"},
25643: {"Type":"Etc","SubType":"NULL"},
25655: {"Type":"Etc","SubType":"NULL"},
25656: {"Type":"Etc","SubType":"NULL"},
25657: {"Type":"Etc","SubType":"NULL"},
25658: {"Type":"Etc","SubType":"NULL"},
25659: {"Type":"Etc","SubType":"NULL"},
25664: {"Type":"Etc","SubType":"NULL"},
25665: {"Type":"Etc","SubType":"NULL"},
25666: {"Type":"Etc","SubType":"NULL"},
25668: {"Type":"Etc","SubType":"NULL"},
25669: {"Type":"Etc","SubType":"NULL"},
25670: {"Type":"Etc","SubType":"NULL"},
25671: {"Type":"Etc","SubType":"NULL"},
25672: {"Type":"Etc","SubType":"NULL"},
25673: {"Type":"Etc","SubType":"NULL"},
25674: {"Type":"Etc","SubType":"NULL"},
25675: {"Type":"Etc","SubType":"NULL"},
25676: {"Type":"Etc","SubType":"NULL"},
25677: {"Type":"Etc","SubType":"NULL"},
25678: {"Type":"Etc","SubType":"NULL"},
25679: {"Type":"Etc","SubType":"NULL"},
25680: {"Type":"Etc","SubType":"NULL"},
25681: {"Type":"Etc","SubType":"NULL"},
25682: {"Type":"Etc","SubType":"NULL"},
25683: {"Type":"Etc","SubType":"NULL"},
25684: {"Type":"Etc","SubType":"NULL"},
25685: {"Type":"Etc","SubType":"NULL"},
25686: {"Type":"Etc","SubType":"NULL"},
25687: {"Type":"Etc","SubType":"NULL"},
25688: {"Type":"Etc","SubType":"NULL"},
25689: {"Type":"Etc","SubType":"NULL"},
25690: {"Type":"Etc","SubType":"NULL"},
25691: {"Type":"Etc","SubType":"NULL"},
25692: {"Type":"Etc","SubType":"NULL"},
25693: {"Type":"Etc","SubType":"NULL"},
25694: {"Type":"Etc","SubType":"NULL"},
25695: {"Type":"Etc","SubType":"NULL"},
25696: {"Type":"Etc","SubType":"NULL"},
25697: {"Type":"Etc","SubType":"NULL"},
25698: {"Type":"Etc","SubType":"NULL"},
25699: {"Type":"Etc","SubType":"NULL"},
25700: {"Type":"Etc","SubType":"NULL"},
25701: {"Type":"Etc","SubType":"NULL"},
25702: {"Type":"Etc","SubType":"NULL"},
25703: {"Type":"Etc","SubType":"NULL"},
25704: {"Type":"Etc","SubType":"NULL"},
25705: {"Type":"Etc","SubType":"NULL"},
25706: {"Type":"Etc","SubType":"NULL"},
25707: {"Type":"Etc","SubType":"NULL"},
25708: {"Type":"Etc","SubType":"NULL"},
25709: {"Type":"Etc","SubType":"NULL"},
25710: {"Type":"Etc","SubType":"NULL"},
25711: {"Type":"Etc","SubType":"NULL"},
25712: {"Type":"Etc","SubType":"NULL"},
25713: {"Type":"Etc","SubType":"NULL"},
25714: {"Type":"Etc","SubType":"NULL"},
25715: {"Type":"Etc","SubType":"NULL"},
25716: {"Type":"Etc","SubType":"NULL"},
25717: {"Type":"Etc","SubType":"NULL"},
25723: {"Type":"Etc","SubType":"NULL"},
25728: {"Type":"Etc","SubType":"NULL"},
25729: {"Type":"Etc","SubType":"NULL"},
25730: {"Type":"Etc","SubType":"NULL"},
25731: {"Type":"Etc","SubType":"NULL"},
25733: {"Type":"Etc","SubType":"NULL"},
25734: {"Type":"Etc","SubType":"NULL"},
25735: {"Type":"Etc","SubType":"NULL"},
25736: {"Type":"Etc","SubType":"NULL"},
25739: {"Type":"Etc","SubType":"NULL"},
25740: {"Type":"Etc","SubType":"NULL"},
25759: {"Type":"Etc","SubType":"NULL"},
25760: {"Type":"Etc","SubType":"NULL"},
25761: {"Type":"Etc","SubType":"NULL"},
25762: {"Type":"Etc","SubType":"NULL"},
25763: {"Type":"Etc","SubType":"NULL"},
25764: {"Type":"Etc","SubType":"NULL"},
25765: {"Type":"Etc","SubType":"NULL"},
25766: {"Type":"Etc","SubType":"NULL"},
25767: {"Type":"Etc","SubType":"NULL"},
25768: {"Type":"Etc","SubType":"NULL"},
25769: {"Type":"Etc","SubType":"NULL"},
25770: {"Type":"Etc","SubType":"NULL"},
25771: {"Type":"Etc","SubType":"NULL"},
25772: {"Type":"Etc","SubType":"NULL"},
25773: {"Type":"Etc","SubType":"NULL"},
25774: {"Type":"Etc","SubType":"NULL"},
25775: {"Type":"Etc","SubType":"NULL"},
25776: {"Type":"Etc","SubType":"NULL"},
25777: {"Type":"Etc","SubType":"NULL"},
25778: {"Type":"Etc","SubType":"NULL"},
25779: {"Type":"Etc","SubType":"NULL"},
25780: {"Type":"Etc","SubType":"NULL"},
25781: {"Type":"Etc","SubType":"NULL"},
25782: {"Type":"Etc","SubType":"NULL"},
25783: {"Type":"Etc","SubType":"NULL"},
25784: {"Type":"Etc","SubType":"NULL"},
25786: {"Type":"Etc","SubType":"NULL"},
25787: {"Type":"Etc","SubType":"NULL"},
25791: {"Type":"Etc","SubType":"NULL"},
25792: {"Type":"Etc","SubType":"NULL"},
25793: {"Type":"Etc","SubType":"NULL"},
25797: {"Type":"Etc","SubType":"NULL"},
25798: {"Type":"Etc","SubType":"NULL"},
25799: {"Type":"Etc","SubType":"NULL"},
25800: {"Type":"Etc","SubType":"NULL"},
25801: {"Type":"Etc","SubType":"NULL"},
25802: {"Type":"Etc","SubType":"NULL"},
25803: {"Type":"Etc","SubType":"NULL"},
25804: {"Type":"Etc","SubType":"NULL"},
25805: {"Type":"Etc","SubType":"NULL"},
25806: {"Type":"Etc","SubType":"NULL"},
25807: {"Type":"Etc","SubType":"NULL"},
25808: {"Type":"Etc","SubType":"NULL"},
25809: {"Type":"Etc","SubType":"NULL"},
25810: {"Type":"Etc","SubType":"NULL"},
25811: {"Type":"Etc","SubType":"NULL"},
25812: {"Type":"Etc","SubType":"NULL"},
25813: {"Type":"Etc","SubType":"NULL"},
25814: {"Type":"Etc","SubType":"NULL"},
25815: {"Type":"Etc","SubType":"NULL"},
25816: {"Type":"Etc","SubType":"NULL"},
25817: {"Type":"Etc","SubType":"NULL"},
25820: {"Type":"Etc","SubType":"NULL"},
25840: {"Type":"Etc","SubType":"NULL"},
25841: {"Type":"Etc","SubType":"NULL"},
25842: {"Type":"Etc","SubType":"NULL"},
25843: {"Type":"Etc","SubType":"NULL"},
25844: {"Type":"Etc","SubType":"NULL"},
25845: {"Type":"Etc","SubType":"NULL"},
25846: {"Type":"Etc","SubType":"NULL"},
25847: {"Type":"Etc","SubType":"NULL"},
25848: {"Type":"Etc","SubType":"NULL"},
25849: {"Type":"Etc","SubType":"NULL"},
25850: {"Type":"Etc","SubType":"NULL"},
25851: {"Type":"Etc","SubType":"NULL"},
25852: {"Type":"Etc","SubType":"NULL"},
25853: {"Type":"Etc","SubType":"NULL"},
25854: {"Type":"Etc","SubType":"NULL"},
25855: {"Type":"Etc","SubType":"NULL"},
25856: {"Type":"Etc","SubType":"NULL"},
25857: {"Type":"Etc","SubType":"NULL"},
25858: {"Type":"Etc","SubType":"NULL"},
25859: {"Type":"Etc","SubType":"NULL"},
25860: {"Type":"Etc","SubType":"NULL"},
25861: {"Type":"Etc","SubType":"NULL"},
25862: {"Type":"Etc","SubType":"NULL"},
25863: {"Type":"Etc","SubType":"NULL"},
25864: {"Type":"Etc","SubType":"NULL"},
25865: {"Type":"Etc","SubType":"NULL"},
25866: {"Type":"Etc","SubType":"NULL"},
25867: {"Type":"Etc","SubType":"NULL"},
25876: {"Type":"Etc","SubType":"NULL"},
25892: {"Type":"Etc","SubType":"NULL"},
25893: {"Type":"Etc","SubType":"NULL"},
25894: {"Type":"Etc","SubType":"NULL"},
25895: {"Type":"Etc","SubType":"NULL"},
25896: {"Type":"Etc","SubType":"NULL"},
25897: {"Type":"Etc","SubType":"NULL"},
25898: {"Type":"Etc","SubType":"NULL"},
25899: {"Type":"Etc","SubType":"NULL"},
25920: {"Type":"Etc","SubType":"NULL"},
25921: {"Type":"Etc","SubType":"NULL"},
25924: {"Type":"Etc","SubType":"NULL"},
25928: {"Type":"Etc","SubType":"NULL"},
25929: {"Type":"Etc","SubType":"NULL"},
25934: {"Type":"Card","SubType":"Enchant"},
25935: {"Type":"Card","SubType":"Enchant"},
25936: {"Type":"Card","SubType":"Enchant"},
25937: {"Type":"Card","SubType":"Enchant"},
25938: {"Type":"Card","SubType":"Enchant"},
25939: {"Type":"Card","SubType":"Enchant"},
25940: {"Type":"Card","SubType":"Enchant"},
26001: {"Type":"Weapon","SubType":"2hSpear"},
26004: {"Type":"Weapon","SubType":"2hSpear"},
26005: {"Type":"Weapon","SubType":"2hSpear"},
26006: {"Type":"Weapon","SubType":"2hSpear"},
26007: {"Type":"Weapon","SubType":"2hSpear"},
26008: {"Type":"Weapon","SubType":"2hSpear"},
26015: {"Type":"Weapon","SubType":"2hSpear"},
26016: {"Type":"Weapon","SubType":"2hSpear"},
26017: {"Type":"Weapon","SubType":"2hSpear"},
26018: {"Type":"Weapon","SubType":"2hSpear"},
26019: {"Type":"Weapon","SubType":"2hSpear"},
26021: {"Type":"Weapon","SubType":"2hSpear"},
26024: {"Type":"Weapon","SubType":"2hSpear"},
26100: {"Type":"Weapon","SubType":"Staff"},
26101: {"Type":"Weapon","SubType":"Staff"},
26102: {"Type":"Weapon","SubType":"Staff"},
26103: {"Type":"Weapon","SubType":"Staff"},
26104: {"Type":"Weapon","SubType":"Staff"},
26105: {"Type":"Weapon","SubType":"Staff"},
26106: {"Type":"Weapon","SubType":"Staff"},
26107: {"Type":"Weapon","SubType":"Staff"},
26108: {"Type":"Weapon","SubType":"Staff"},
26109: {"Type":"Weapon","SubType":"Staff"},
26110: {"Type":"Weapon","SubType":"Staff"},
26111: {"Type":"Weapon","SubType":"Staff"},
26112: {"Type":"Weapon","SubType":"Staff"},
26118: {"Type":"Weapon","SubType":"Staff"},
26119: {"Type":"Weapon","SubType":"Staff"},
26120: {"Type":"Weapon","SubType":"Staff"},
26138: {"Type":"Weapon","SubType":"2hStaff"},
26139: {"Type":"Weapon","SubType":"2hStaff"},
26140: {"Type":"Weapon","SubType":"Staff"},
26142: {"Type":"Weapon","SubType":"Staff"},
26143: {"Type":"Weapon","SubType":"Staff"},
26144: {"Type":"Weapon","SubType":"Staff"},
26145: {"Type":"Weapon","SubType":"Staff"},
26146: {"Type":"Weapon","SubType":"Staff"},
26147: {"Type":"Weapon","SubType":"Staff"},
26148: {"Type":"Weapon","SubType":"Staff"},
26149: {"Type":"Weapon","SubType":"Staff"},
26150: {"Type":"Weapon","SubType":"Staff"},
26151: {"Type":"Weapon","SubType":"Staff"},
26152: {"Type":"Weapon","SubType":"Staff"},
26154: {"Type":"Weapon","SubType":"Staff"},
26155: {"Type":"Weapon","SubType":"Staff"},
26156: {"Type":"Weapon","SubType":"Staff"},
26158: {"Type":"Weapon","SubType":"Staff"},
26159: {"Type":"Weapon","SubType":"Staff"},
26160: {"Type":"Weapon","SubType":"Staff"},
26161: {"Type":"Weapon","SubType":"Staff"},
26162: {"Type":"Weapon","SubType":"Staff"},
26163: {"Type":"Weapon","SubType":"Staff"},
26164: {"Type":"Weapon","SubType":"Staff"},
26165: {"Type":"Weapon","SubType":"Staff"},
26166: {"Type":"Weapon","SubType":"Staff"},
26167: {"Type":"Weapon","SubType":"Staff"},
26168: {"Type":"Weapon","SubType":"Staff"},
26169: {"Type":"Weapon","SubType":"Staff"},
26170: {"Type":"Weapon","SubType":"Staff"},
26171: {"Type":"Weapon","SubType":"Staff"},
26172: {"Type":"Weapon","SubType":"Staff"},
26175: {"Type":"Weapon","SubType":"2hStaff"},
26176: {"Type":"Weapon","SubType":"Staff"},
26177: {"Type":"Weapon","SubType":"Staff"},
26178: {"Type":"Weapon","SubType":"Staff"},
26200: {"Type":"Weapon","SubType":"Whip"},
26201: {"Type":"Weapon","SubType":"Whip"},
26202: {"Type":"Weapon","SubType":"Whip"},
26203: {"Type":"Weapon","SubType":"Whip"},
26204: {"Type":"Weapon","SubType":"Whip"},
26207: {"Type":"Weapon","SubType":"Book"},
26208: {"Type":"Weapon","SubType":"Whip"},
26209: {"Type":"Weapon","SubType":"Whip"},
26210: {"Type":"Weapon","SubType":"Whip"},
26212: {"Type":"Weapon","SubType":"Whip"},
26213: {"Type":"Weapon","SubType":"Whip"},
26215: {"Type":"Weapon","SubType":"Whip"},
26216: {"Type":"Weapon","SubType":"Whip"},
26217: {"Type":"Weapon","SubType":"Whip"},
26218: {"Type":"Weapon","SubType":"Whip"},
26221: {"Type":"Weapon","SubType":"Whip"},
27002: {"Type":"Card","SubType":"NULL"},
27007: {"Type":"Card","SubType":"NULL"},
27008: {"Type":"Card","SubType":"NULL"},
27009: {"Type":"Card","SubType":"NULL"},
27012: {"Type":"Card","SubType":"NULL"},
27013: {"Type":"Card","SubType":"NULL"},
27014: {"Type":"Card","SubType":"NULL"},
27015: {"Type":"Card","SubType":"NULL"},
27016: {"Type":"Card","SubType":"NULL"},
27017: {"Type":"Card","SubType":"NULL"},
27018: {"Type":"Card","SubType":"NULL"},
27019: {"Type":"Card","SubType":"NULL"},
27020: {"Type":"Card","SubType":"NULL"},
27025: {"Type":"Card","SubType":"NULL"},
27026: {"Type":"Card","SubType":"NULL"},
27027: {"Type":"Card","SubType":"NULL"},
27028: {"Type":"Card","SubType":"NULL"},
27029: {"Type":"Card","SubType":"NULL"},
27030: {"Type":"Card","SubType":"NULL"},
27031: {"Type":"Card","SubType":"NULL"},
27032: {"Type":"Card","SubType":"NULL"},
27035: {"Type":"Card","SubType":"NULL"},
27040: {"Type":"Card","SubType":"NULL"},
27055: {"Type":"Card","SubType":"NULL"},
27056: {"Type":"Card","SubType":"NULL"},
27057: {"Type":"Card","SubType":"NULL"},
27058: {"Type":"Card","SubType":"NULL"},
27059: {"Type":"Card","SubType":"NULL"},
27060: {"Type":"Card","SubType":"NULL"},
27061: {"Type":"Card","SubType":"NULL"},
27062: {"Type":"Card","SubType":"NULL"},
27063: {"Type":"Card","SubType":"NULL"},
27064: {"Type":"Card","SubType":"NULL"},
27065: {"Type":"Card","SubType":"NULL"},
27066: {"Type":"Card","SubType":"NULL"},
27067: {"Type":"Card","SubType":"NULL"},
27068: {"Type":"Card","SubType":"NULL"},
27069: {"Type":"Card","SubType":"NULL"},
27070: {"Type":"Card","SubType":"NULL"},
27071: {"Type":"Card","SubType":"NULL"},
27072: {"Type":"Card","SubType":"NULL"},
27073: {"Type":"Card","SubType":"NULL"},
27074: {"Type":"Card","SubType":"NULL"},
27075: {"Type":"Card","SubType":"NULL"},
27076: {"Type":"Card","SubType":"NULL"},
27077: {"Type":"Card","SubType":"NULL"},
27078: {"Type":"Card","SubType":"NULL"},
27079: {"Type":"Card","SubType":"NULL"},
27080: {"Type":"Card","SubType":"NULL"},
27081: {"Type":"Card","SubType":"NULL"},
27082: {"Type":"Card","SubType":"NULL"},
27083: {"Type":"Card","SubType":"NULL"},
27084: {"Type":"Card","SubType":"NULL"},
27085: {"Type":"Card","SubType":"NULL"},
27086: {"Type":"Card","SubType":"NULL"},
27087: {"Type":"Card","SubType":"NULL"},
27088: {"Type":"Card","SubType":"NULL"},
27089: {"Type":"Card","SubType":"NULL"},
27092: {"Type":"Card","SubType":"NULL"},
27101: {"Type":"Card","SubType":"NULL"},
27102: {"Type":"Card","SubType":"NULL"},
27103: {"Type":"Card","SubType":"NULL"},
27104: {"Type":"Card","SubType":"NULL"},
27105: {"Type":"Card","SubType":"NULL"},
27106: {"Type":"Card","SubType":"NULL"},
27107: {"Type":"Card","SubType":"NULL"},
27108: {"Type":"Card","SubType":"NULL"},
27109: {"Type":"Card","SubType":"NULL"},
27110: {"Type":"Card","SubType":"NULL"},
27111: {"Type":"Card","SubType":"NULL"},
27112: {"Type":"Card","SubType":"NULL"},
27113: {"Type":"Card","SubType":"NULL"},
27114: {"Type":"Card","SubType":"NULL"},
27115: {"Type":"Card","SubType":"NULL"},
27116: {"Type":"Card","SubType":"NULL"},
27117: {"Type":"Card","SubType":"NULL"},
27118: {"Type":"Card","SubType":"NULL"},
27119: {"Type":"Card","SubType":"NULL"},
27120: {"Type":"Card","SubType":"NULL"},
27121: {"Type":"Card","SubType":"NULL"},
27122: {"Type":"Card","SubType":"NULL"},
27123: {"Type":"Card","SubType":"NULL"},
27124: {"Type":"Card","SubType":"NULL"},
27125: {"Type":"Card","SubType":"NULL"},
27126: {"Type":"Card","SubType":"NULL"},
27127: {"Type":"Card","SubType":"NULL"},
27128: {"Type":"Card","SubType":"NULL"},
27129: {"Type":"Card","SubType":"NULL"},
27130: {"Type":"Card","SubType":"NULL"},
27131: {"Type":"Card","SubType":"NULL"},
27132: {"Type":"Card","SubType":"NULL"},
27133: {"Type":"Card","SubType":"NULL"},
27134: {"Type":"Card","SubType":"NULL"},
27135: {"Type":"Card","SubType":"NULL"},
27136: {"Type":"Card","SubType":"NULL"},
27137: {"Type":"Card","SubType":"NULL"},
27138: {"Type":"Card","SubType":"NULL"},
27139: {"Type":"Card","SubType":"NULL"},
27140: {"Type":"Card","SubType":"NULL"},
27141: {"Type":"Card","SubType":"NULL"},
27143: {"Type":"Card","SubType":"NULL"},
27146: {"Type":"Card","SubType":"NULL"},
27147: {"Type":"Card","SubType":"NULL"},
27148: {"Type":"Card","SubType":"NULL"},
27149: {"Type":"Card","SubType":"NULL"},
27150: {"Type":"Card","SubType":"NULL"},
27151: {"Type":"Card","SubType":"NULL"},
27152: {"Type":"Card","SubType":"NULL"},
27157: {"Type":"Card","SubType":"NULL"},
27158: {"Type":"Card","SubType":"NULL"},
27159: {"Type":"Card","SubType":"NULL"},
27160: {"Type":"Card","SubType":"NULL"},
27161: {"Type":"Card","SubType":"NULL"},
27162: {"Type":"Card","SubType":"NULL"},
27163: {"Type":"Card","SubType":"NULL"},
27164: {"Type":"Card","SubType":"NULL"},
27165: {"Type":"Card","SubType":"NULL"},
27166: {"Type":"Card","SubType":"NULL"},
27167: {"Type":"Card","SubType":"NULL"},
27168: {"Type":"Card","SubType":"NULL"},
27169: {"Type":"Card","SubType":"NULL"},
27170: {"Type":"Card","SubType":"NULL"},
27171: {"Type":"Card","SubType":"NULL"},
27172: {"Type":"Card","SubType":"NULL"},
27173: {"Type":"Card","SubType":"NULL"},
27174: {"Type":"Card","SubType":"NULL"},
27175: {"Type":"Card","SubType":"NULL"},
27176: {"Type":"Card","SubType":"NULL"},
27177: {"Type":"Card","SubType":"NULL"},
27178: {"Type":"Card","SubType":"NULL"},
27179: {"Type":"Card","SubType":"NULL"},
27180: {"Type":"Card","SubType":"NULL"},
27181: {"Type":"Card","SubType":"NULL"},
27182: {"Type":"Card","SubType":"NULL"},
27183: {"Type":"Card","SubType":"NULL"},
27184: {"Type":"Card","SubType":"NULL"},
27191: {"Type":"Card","SubType":"NULL"},
27196: {"Type":"Card","SubType":"NULL"},
27197: {"Type":"Card","SubType":"NULL"},
27198: {"Type":"Card","SubType":"NULL"},
27199: {"Type":"Card","SubType":"NULL"},
27200: {"Type":"Card","SubType":"NULL"},
27201: {"Type":"Card","SubType":"NULL"},
27202: {"Type":"Card","SubType":"NULL"},
27203: {"Type":"Card","SubType":"NULL"},
27209: {"Type":"Card","SubType":"NULL"},
27210: {"Type":"Card","SubType":"NULL"},
27211: {"Type":"Card","SubType":"NULL"},
27212: {"Type":"Card","SubType":"NULL"},
27213: {"Type":"Card","SubType":"NULL"},
27214: {"Type":"Card","SubType":"NULL"},
27215: {"Type":"Card","SubType":"NULL"},
27216: {"Type":"Card","SubType":"NULL"},
27217: {"Type":"Card","SubType":"NULL"},
27218: {"Type":"Card","SubType":"NULL"},
27219: {"Type":"Card","SubType":"NULL"},
27220: {"Type":"Card","SubType":"NULL"},
27221: {"Type":"Card","SubType":"NULL"},
27222: {"Type":"Card","SubType":"NULL"},
27224: {"Type":"Card","SubType":"NULL"},
27225: {"Type":"Card","SubType":"NULL"},
27228: {"Type":"Card","SubType":"NULL"},
27237: {"Type":"Card","SubType":"NULL"},
27247: {"Type":"Card","SubType":"NULL"},
27248: {"Type":"Card","SubType":"NULL"},
27249: {"Type":"Card","SubType":"NULL"},
27250: {"Type":"Card","SubType":"NULL"},
27251: {"Type":"Card","SubType":"NULL"},
27252: {"Type":"Card","SubType":"NULL"},
27253: {"Type":"Card","SubType":"NULL"},
27254: {"Type":"Card","SubType":"NULL"},
27255: {"Type":"Card","SubType":"NULL"},
27256: {"Type":"Card","SubType":"NULL"},
27257: {"Type":"Card","SubType":"NULL"},
27258: {"Type":"Card","SubType":"NULL"},
27259: {"Type":"Card","SubType":"NULL"},
27260: {"Type":"Card","SubType":"NULL"},
27261: {"Type":"Card","SubType":"NULL"},
27262: {"Type":"Card","SubType":"NULL"},
27263: {"Type":"Card","SubType":"NULL"},
27264: {"Type":"Card","SubType":"NULL"},
27265: {"Type":"Card","SubType":"NULL"},
27286: {"Type":"Card","SubType":"NULL"},
27287: {"Type":"Card","SubType":"NULL"},
27288: {"Type":"Card","SubType":"NULL"},
27289: {"Type":"Card","SubType":"NULL"},
27290: {"Type":"Card","SubType":"NULL"},
27291: {"Type":"Card","SubType":"NULL"},
27292: {"Type":"Card","SubType":"NULL"},
27293: {"Type":"Card","SubType":"NULL"},
27294: {"Type":"Card","SubType":"NULL"},
27295: {"Type":"Card","SubType":"NULL"},
27296: {"Type":"Card","SubType":"NULL"},
27297: {"Type":"Card","SubType":"NULL"},
27298: {"Type":"Card","SubType":"NULL"},
27301: {"Type":"Card","SubType":"NULL"},
27304: {"Type":"Card","SubType":"NULL"},
27305: {"Type":"Card","SubType":"NULL"},
27306: {"Type":"Card","SubType":"NULL"},
27307: {"Type":"Card","SubType":"NULL"},
27308: {"Type":"Card","SubType":"NULL"},
27309: {"Type":"Card","SubType":"NULL"},
27310: {"Type":"Card","SubType":"NULL"},
27311: {"Type":"Card","SubType":"NULL"},
27312: {"Type":"Card","SubType":"NULL"},
27313: {"Type":"Card","SubType":"NULL"},
27314: {"Type":"Card","SubType":"NULL"},
27315: {"Type":"Card","SubType":"NULL"},
27316: {"Type":"Card","SubType":"NULL"},
27317: {"Type":"Card","SubType":"NULL"},
27318: {"Type":"Card","SubType":"NULL"},
27319: {"Type":"Card","SubType":"NULL"},
27320: {"Type":"Card","SubType":"NULL"},
27321: {"Type":"Card","SubType":"NULL"},
27322: {"Type":"Card","SubType":"NULL"},
27323: {"Type":"Card","SubType":"NULL"},
27324: {"Type":"Card","SubType":"NULL"},
27325: {"Type":"Card","SubType":"NULL"},
27326: {"Type":"Card","SubType":"NULL"},
27327: {"Type":"Card","SubType":"NULL"},
27328: {"Type":"Card","SubType":"NULL"},
27329: {"Type":"Card","SubType":"NULL"},
27330: {"Type":"Card","SubType":"NULL"},
27331: {"Type":"Card","SubType":"NULL"},
27332: {"Type":"Card","SubType":"NULL"},
27333: {"Type":"Card","SubType":"NULL"},
27334: {"Type":"Card","SubType":"NULL"},
27335: {"Type":"Card","SubType":"NULL"},
27336: {"Type":"Card","SubType":"NULL"},
27337: {"Type":"Card","SubType":"NULL"},
27338: {"Type":"Card","SubType":"NULL"},
27339: {"Type":"Card","SubType":"NULL"},
27340: {"Type":"Card","SubType":"NULL"},
27341: {"Type":"Card","SubType":"NULL"},
27342: {"Type":"Card","SubType":"NULL"},
27343: {"Type":"Card","SubType":"NULL"},
27344: {"Type":"Card","SubType":"NULL"},
27345: {"Type":"Card","SubType":"NULL"},
27346: {"Type":"Card","SubType":"NULL"},
27347: {"Type":"Card","SubType":"NULL"},
27348: {"Type":"Card","SubType":"NULL"},
27349: {"Type":"Card","SubType":"NULL"},
27350: {"Type":"Card","SubType":"NULL"},
27351: {"Type":"Card","SubType":"NULL"},
27352: {"Type":"Card","SubType":"NULL"},
27353: {"Type":"Card","SubType":"NULL"},
27354: {"Type":"Card","SubType":"NULL"},
27355: {"Type":"Card","SubType":"NULL"},
27356: {"Type":"Card","SubType":"NULL"},
27357: {"Type":"Card","SubType":"NULL"},
27358: {"Type":"Card","SubType":"NULL"},
27359: {"Type":"Card","SubType":"NULL"},
27360: {"Type":"Card","SubType":"NULL"},
27361: {"Type":"Card","SubType":"NULL"},
27362: {"Type":"Card","SubType":"NULL"},
27363: {"Type":"Card","SubType":"NULL"},
27364: {"Type":"Card","SubType":"NULL"},
27365: {"Type":"Card","SubType":"NULL"},
27366: {"Type":"Card","SubType":"NULL"},
27367: {"Type":"Card","SubType":"NULL"},
27368: {"Type":"Card","SubType":"NULL"},
27369: {"Type":"Card","SubType":"NULL"},
27370: {"Type":"Card","SubType":"NULL"},
27371: {"Type":"Card","SubType":"NULL"},
27372: {"Type":"Card","SubType":"NULL"},
27373: {"Type":"Card","SubType":"NULL"},
27374: {"Type":"Card","SubType":"NULL"},
27375: {"Type":"Card","SubType":"NULL"},
27376: {"Type":"Card","SubType":"NULL"},
27377: {"Type":"Card","SubType":"NULL"},
27378: {"Type":"Card","SubType":"NULL"},
27379: {"Type":"Card","SubType":"NULL"},
27380: {"Type":"Card","SubType":"NULL"},
27381: {"Type":"Card","SubType":"NULL"},
27382: {"Type":"Card","SubType":"NULL"},
27383: {"Type":"Card","SubType":"NULL"},
27384: {"Type":"Card","SubType":"NULL"},
27385: {"Type":"Card","SubType":"NULL"},
27386: {"Type":"Card","SubType":"NULL"},
27387: {"Type":"Card","SubType":"NULL"},
27388: {"Type":"Card","SubType":"NULL"},
27389: {"Type":"Card","SubType":"NULL"},
27390: {"Type":"Card","SubType":"NULL"},
27391: {"Type":"Card","SubType":"NULL"},
27392: {"Type":"Card","SubType":"NULL"},
27393: {"Type":"Card","SubType":"NULL"},
27394: {"Type":"Card","SubType":"NULL"},
27395: {"Type":"Card","SubType":"NULL"},
27396: {"Type":"Card","SubType":"NULL"},
27397: {"Type":"Card","SubType":"Enchant"},
27398: {"Type":"Card","SubType":"Enchant"},
27399: {"Type":"Card","SubType":"Enchant"},
27400: {"Type":"Card","SubType":"Enchant"},
27401: {"Type":"Card","SubType":"Enchant"},
27402: {"Type":"Card","SubType":"Enchant"},
27403: {"Type":"Card","SubType":"Enchant"},
27404: {"Type":"Card","SubType":"Enchant"},
27405: {"Type":"Card","SubType":"Enchant"},
27406: {"Type":"Card","SubType":"Enchant"},
27407: {"Type":"Card","SubType":"Enchant"},
27408: {"Type":"Card","SubType":"Enchant"},
27409: {"Type":"Card","SubType":"Enchant"},
27410: {"Type":"Card","SubType":"Enchant"},
27411: {"Type":"Card","SubType":"Enchant"},
27412: {"Type":"Card","SubType":"Enchant"},
27413: {"Type":"Card","SubType":"Enchant"},
27414: {"Type":"Card","SubType":"Enchant"},
27415: {"Type":"Card","SubType":"Enchant"},
27416: {"Type":"Card","SubType":"Enchant"},
27417: {"Type":"Card","SubType":"NULL"},
27421: {"Type":"Card","SubType":"NULL"},
27422: {"Type":"Card","SubType":"NULL"},
27423: {"Type":"Card","SubType":"NULL"},
27424: {"Type":"Card","SubType":"NULL"},
27425: {"Type":"Card","SubType":"NULL"},
27426: {"Type":"Card","SubType":"NULL"},
28000: {"Type":"Weapon","SubType":"Katar"},
28001: {"Type":"Weapon","SubType":"Katar"},
28002: {"Type":"Weapon","SubType":"Katar"},
28005: {"Type":"Weapon","SubType":"Katar"},
28006: {"Type":"Weapon","SubType":"Katar"},
28007: {"Type":"Weapon","SubType":"Katar"},
28008: {"Type":"Weapon","SubType":"Katar"},
28010: {"Type":"Weapon","SubType":"Katar"},
28011: {"Type":"Weapon","SubType":"Katar"},
28014: {"Type":"Weapon","SubType":"Katar"},
28015: {"Type":"Weapon","SubType":"Katar"},
28018: {"Type":"Weapon","SubType":"Katar"},
28019: {"Type":"Weapon","SubType":"Katar"},
28020: {"Type":"Weapon","SubType":"Katar"},
28022: {"Type":"Weapon","SubType":"Katar"},
28023: {"Type":"Weapon","SubType":"Katar"},
28024: {"Type":"Weapon","SubType":"Katar"},
28026: {"Type":"Weapon","SubType":"Katar"},
28027: {"Type":"Weapon","SubType":"Katar"},
28034: {"Type":"Weapon","SubType":"Katar"},
28035: {"Type":"Weapon","SubType":"Katar"},
28036: {"Type":"Weapon","SubType":"Katar"},
28037: {"Type":"Weapon","SubType":"Katar"},
28038: {"Type":"Weapon","SubType":"Katar"},
28039: {"Type":"Weapon","SubType":"Katar"},
28040: {"Type":"Weapon","SubType":"Katar"},
28042: {"Type":"Weapon","SubType":"Katar"},
28044: {"Type":"Weapon","SubType":"Katar"},
28045: {"Type":"Weapon","SubType":"Katar"},
28046: {"Type":"Weapon","SubType":"Katar"},
28047: {"Type":"Weapon","SubType":"Katar"},
28048: {"Type":"Weapon","SubType":"Katar"},
28049: {"Type":"Weapon","SubType":"Katar"},
28053: {"Type":"Weapon","SubType":"Katar"},
28100: {"Type":"Weapon","SubType":"2hAxe"},
28101: {"Type":"Weapon","SubType":"2hAxe"},
28102: {"Type":"Weapon","SubType":"2hAxe"},
28103: {"Type":"Weapon","SubType":"2hAxe"},
28104: {"Type":"Weapon","SubType":"2hAxe"},
28105: {"Type":"Weapon","SubType":"2hAxe"},
28106: {"Type":"Weapon","SubType":"2hAxe"},
28107: {"Type":"Weapon","SubType":"2hAxe"},
28110: {"Type":"Weapon","SubType":"2hAxe"},
28113: {"Type":"Weapon","SubType":"2hAxe"},
28114: {"Type":"Weapon","SubType":"2hAxe"},
28116: {"Type":"Weapon","SubType":"2hAxe"},
28117: {"Type":"Weapon","SubType":"2hAxe"},
28118: {"Type":"Weapon","SubType":"2hAxe"},
28119: {"Type":"Weapon","SubType":"2hAxe"},
28120: {"Type":"Weapon","SubType":"2hAxe"},
28121: {"Type":"Weapon","SubType":"2hAxe"},
28122: {"Type":"Weapon","SubType":"2hAxe"},
28127: {"Type":"Weapon","SubType":"2hAxe"},
28130: {"Type":"Weapon","SubType":"2hAxe"},
28131: {"Type":"Weapon","SubType":"2hSword"},
28132: {"Type":"Weapon","SubType":"2hSword"},
28133: {"Type":"Weapon","SubType":"2hAxe"},
28135: {"Type":"Weapon","SubType":"2hAxe"},
28136: {"Type":"Weapon","SubType":"2hAxe"},
28137: {"Type":"Weapon","SubType":"1hAxe"},
28138: {"Type":"Weapon","SubType":"2hAxe"},
28140: {"Type":"Weapon","SubType":"2hAxe"},
28141: {"Type":"Weapon","SubType":"2hAxe"},
28142: {"Type":"Weapon","SubType":"2hAxe"},
28144: {"Type":"Weapon","SubType":"1hAxe"},
28200: {"Type":"Weapon","SubType":"Grenade"},
28201: {"Type":"Weapon","SubType":"Grenade"},
28202: {"Type":"Weapon","SubType":"Grenade"},
28203: {"Type":"Weapon","SubType":"Rifle"},
28204: {"Type":"Weapon","SubType":"Shotgun"},
28214: {"Type":"Weapon","SubType":"Rifle"},
28215: {"Type":"Weapon","SubType":"Rifle"},
28216: {"Type":"Weapon","SubType":"Gatling"},
28217: {"Type":"Weapon","SubType":"Grenade"},
28218: {"Type":"Weapon","SubType":"Shotgun"},
28223: {"Type":"Weapon","SubType":"Rifle"},
28224: {"Type":"Weapon","SubType":"Shotgun"},
28225: {"Type":"Weapon","SubType":"Gatling"},
28226: {"Type":"Weapon","SubType":"Grenade"},
28227: {"Type":"Weapon","SubType":"Rifle"},
28228: {"Type":"Weapon","SubType":"Rifle"},
28229: {"Type":"Weapon","SubType":"Gatling"},
28230: {"Type":"Weapon","SubType":"Gatling"},
28231: {"Type":"Weapon","SubType":"Grenade"},
28232: {"Type":"Weapon","SubType":"Grenade"},
28233: {"Type":"Weapon","SubType":"Shotgun"},
28234: {"Type":"Weapon","SubType":"Shotgun"},
28235: {"Type":"Weapon","SubType":"Rifle"},
28236: {"Type":"Weapon","SubType":"Rifle"},
28237: {"Type":"Weapon","SubType":"Gatling"},
28238: {"Type":"Weapon","SubType":"Shotgun"},
28239: {"Type":"Weapon","SubType":"Grenade"},
28240: {"Type":"Weapon","SubType":"Rifle"},
28241: {"Type":"Weapon","SubType":"Gatling"},
28242: {"Type":"Weapon","SubType":"Shotgun"},
28243: {"Type":"Weapon","SubType":"Grenade"},
28244: {"Type":"Weapon","SubType":"Shotgun"},
28249: {"Type":"Weapon","SubType":"Rifle"},
28250: {"Type":"Weapon","SubType":"Gatling"},
28251: {"Type":"Weapon","SubType":"Shotgun"},
28252: {"Type":"Weapon","SubType":"Grenade"},
28253: {"Type":"Weapon","SubType":"Rifle"},
28254: {"Type":"Weapon","SubType":"Gatling"},
28255: {"Type":"Weapon","SubType":"Rifle"},
28256: {"Type":"Weapon","SubType":"Shotgun"},
28257: {"Type":"Weapon","SubType":"Grenade"},
28258: {"Type":"Weapon","SubType":"Gatling"},
28261: {"Type":"Weapon","SubType":"Shotgun"},
28300: {"Type":"Armor","SubType":"NULL"},
28301: {"Type":"Armor","SubType":"NULL"},
28302: {"Type":"Armor","SubType":"NULL"},
28303: {"Type":"Armor","SubType":"NULL"},
28304: {"Type":"Armor","SubType":"NULL"},
28305: {"Type":"Armor","SubType":"NULL"},
28306: {"Type":"Armor","SubType":"NULL"},
28310: {"Type":"Armor","SubType":"NULL"},
28311: {"Type":"Armor","SubType":"NULL"},
28312: {"Type":"Armor","SubType":"NULL"},
28313: {"Type":"Armor","SubType":"NULL"},
28314: {"Type":"Armor","SubType":"NULL"},
28315: {"Type":"Armor","SubType":"NULL"},
28316: {"Type":"Armor","SubType":"NULL"},
28317: {"Type":"Armor","SubType":"NULL"},
28318: {"Type":"Armor","SubType":"NULL"},
28319: {"Type":"Armor","SubType":"NULL"},
28320: {"Type":"Armor","SubType":"NULL"},
28321: {"Type":"Armor","SubType":"NULL"},
28322: {"Type":"Armor","SubType":"NULL"},
28323: {"Type":"Armor","SubType":"NULL"},
28324: {"Type":"Armor","SubType":"NULL"},
28326: {"Type":"Armor","SubType":"NULL"},
28327: {"Type":"Armor","SubType":"NULL"},
28332: {"Type":"Armor","SubType":"NULL"},
28333: {"Type":"Armor","SubType":"NULL"},
28340: {"Type":"Armor","SubType":"NULL"},
28341: {"Type":"Armor","SubType":"NULL"},
28342: {"Type":"Armor","SubType":"NULL"},
28346: {"Type":"Armor","SubType":"NULL"},
28347: {"Type":"Armor","SubType":"NULL"},
28348: {"Type":"Armor","SubType":"NULL"},
28349: {"Type":"Armor","SubType":"NULL"},
28350: {"Type":"Armor","SubType":"NULL"},
28351: {"Type":"Armor","SubType":"NULL"},
28352: {"Type":"Armor","SubType":"NULL"},
28353: {"Type":"Armor","SubType":"NULL"},
28354: {"Type":"Armor","SubType":"NULL"},
28355: {"Type":"Armor","SubType":"NULL"},
28356: {"Type":"Armor","SubType":"NULL"},
28357: {"Type":"Armor","SubType":"NULL"},
28358: {"Type":"Armor","SubType":"NULL"},
28359: {"Type":"Armor","SubType":"NULL"},
28368: {"Type":"Armor","SubType":"NULL"},
28369: {"Type":"Armor","SubType":"NULL"},
28370: {"Type":"Armor","SubType":"NULL"},
28371: {"Type":"Armor","SubType":"NULL"},
28372: {"Type":"Armor","SubType":"NULL"},
28374: {"Type":"Armor","SubType":"NULL"},
28377: {"Type":"Armor","SubType":"NULL"},
28379: {"Type":"Armor","SubType":"NULL"},
28380: {"Type":"Armor","SubType":"NULL"},
28381: {"Type":"Armor","SubType":"NULL"},
28382: {"Type":"Armor","SubType":"NULL"},
28386: {"Type":"Armor","SubType":"NULL"},
28387: {"Type":"Armor","SubType":"NULL"},
28388: {"Type":"Armor","SubType":"NULL"},
28391: {"Type":"Shadowgear","SubType":"NULL"},
28392: {"Type":"Shadowgear","SubType":"NULL"},
28394: {"Type":"Armor","SubType":"NULL"},
28410: {"Type":"Armor","SubType":"NULL"},
28411: {"Type":"Armor","SubType":"NULL"},
28412: {"Type":"Armor","SubType":"NULL"},
28413: {"Type":"Armor","SubType":"NULL"},
28414: {"Type":"Armor","SubType":"NULL"},
28415: {"Type":"Armor","SubType":"NULL"},
28416: {"Type":"Armor","SubType":"NULL"},
28417: {"Type":"Armor","SubType":"NULL"},
28418: {"Type":"Armor","SubType":"NULL"},
28419: {"Type":"Armor","SubType":"NULL"},
28420: {"Type":"Armor","SubType":"NULL"},
28421: {"Type":"Armor","SubType":"NULL"},
28422: {"Type":"Armor","SubType":"NULL"},
28423: {"Type":"Armor","SubType":"NULL"},
28424: {"Type":"Armor","SubType":"NULL"},
28425: {"Type":"Armor","SubType":"NULL"},
28426: {"Type":"Armor","SubType":"NULL"},
28427: {"Type":"Armor","SubType":"NULL"},
28428: {"Type":"Armor","SubType":"NULL"},
28429: {"Type":"Armor","SubType":"NULL"},
28430: {"Type":"Armor","SubType":"NULL"},
28431: {"Type":"Armor","SubType":"NULL"},
28432: {"Type":"Armor","SubType":"NULL"},
28433: {"Type":"Armor","SubType":"NULL"},
28434: {"Type":"Armor","SubType":"NULL"},
28435: {"Type":"Armor","SubType":"NULL"},
28436: {"Type":"Armor","SubType":"NULL"},
28437: {"Type":"Armor","SubType":"NULL"},
28438: {"Type":"Armor","SubType":"NULL"},
28439: {"Type":"Armor","SubType":"NULL"},
28440: {"Type":"Armor","SubType":"NULL"},
28441: {"Type":"Armor","SubType":"NULL"},
28442: {"Type":"Armor","SubType":"NULL"},
28443: {"Type":"Armor","SubType":"NULL"},
28444: {"Type":"Armor","SubType":"NULL"},
28445: {"Type":"Armor","SubType":"NULL"},
28446: {"Type":"Armor","SubType":"NULL"},
28447: {"Type":"Armor","SubType":"NULL"},
28448: {"Type":"Armor","SubType":"NULL"},
28449: {"Type":"Armor","SubType":"NULL"},
28450: {"Type":"Armor","SubType":"NULL"},
28451: {"Type":"Armor","SubType":"NULL"},
28452: {"Type":"Armor","SubType":"NULL"},
28453: {"Type":"Armor","SubType":"NULL"},
28454: {"Type":"Armor","SubType":"NULL"},
28455: {"Type":"Armor","SubType":"NULL"},
28456: {"Type":"Armor","SubType":"NULL"},
28457: {"Type":"Armor","SubType":"NULL"},
28458: {"Type":"Armor","SubType":"NULL"},
28459: {"Type":"Armor","SubType":"NULL"},
28460: {"Type":"Armor","SubType":"NULL"},
28461: {"Type":"Armor","SubType":"NULL"},
28462: {"Type":"Armor","SubType":"NULL"},
28463: {"Type":"Armor","SubType":"NULL"},
28464: {"Type":"Armor","SubType":"NULL"},
28465: {"Type":"Armor","SubType":"NULL"},
28466: {"Type":"Armor","SubType":"NULL"},
28467: {"Type":"Armor","SubType":"NULL"},
28468: {"Type":"Armor","SubType":"NULL"},
28469: {"Type":"Armor","SubType":"NULL"},
28470: {"Type":"Armor","SubType":"NULL"},
28471: {"Type":"Armor","SubType":"NULL"},
28472: {"Type":"Armor","SubType":"NULL"},
28473: {"Type":"Armor","SubType":"NULL"},
28474: {"Type":"Armor","SubType":"NULL"},
28475: {"Type":"Armor","SubType":"NULL"},
28476: {"Type":"Armor","SubType":"NULL"},
28477: {"Type":"Armor","SubType":"NULL"},
28478: {"Type":"Armor","SubType":"NULL"},
28479: {"Type":"Armor","SubType":"NULL"},
28480: {"Type":"Armor","SubType":"NULL"},
28481: {"Type":"Armor","SubType":"NULL"},
28482: {"Type":"Armor","SubType":"NULL"},
28483: {"Type":"Armor","SubType":"NULL"},
28484: {"Type":"Armor","SubType":"NULL"},
28485: {"Type":"Armor","SubType":"NULL"},
28491: {"Type":"Armor","SubType":"NULL"},
28492: {"Type":"Armor","SubType":"NULL"},
28495: {"Type":"Armor","SubType":"NULL"},
28496: {"Type":"Armor","SubType":"NULL"},
28499: {"Type":"Armor","SubType":"NULL"},
28500: {"Type":"Armor","SubType":"NULL"},
28501: {"Type":"Armor","SubType":"NULL"},
28502: {"Type":"Armor","SubType":"NULL"},
28503: {"Type":"Armor","SubType":"NULL"},
28505: {"Type":"Armor","SubType":"NULL"},
28506: {"Type":"Armor","SubType":"NULL"},
28507: {"Type":"Armor","SubType":"NULL"},
28508: {"Type":"Armor","SubType":"NULL"},
28509: {"Type":"Armor","SubType":"NULL"},
28510: {"Type":"Armor","SubType":"NULL"},
28511: {"Type":"Armor","SubType":"NULL"},
28513: {"Type":"Armor","SubType":"NULL"},
28514: {"Type":"Armor","SubType":"NULL"},
28515: {"Type":"Armor","SubType":"NULL"},
28516: {"Type":"Armor","SubType":"NULL"},
28517: {"Type":"Armor","SubType":"NULL"},
28518: {"Type":"Armor","SubType":"NULL"},
28519: {"Type":"Armor","SubType":"NULL"},
28520: {"Type":"Armor","SubType":"NULL"},
28521: {"Type":"Armor","SubType":"NULL"},
28522: {"Type":"Armor","SubType":"NULL"},
28523: {"Type":"Armor","SubType":"NULL"},
28531: {"Type":"Armor","SubType":"NULL"},
28533: {"Type":"Armor","SubType":"NULL"},
28534: {"Type":"Armor","SubType":"NULL"},
28535: {"Type":"Armor","SubType":"NULL"},
28536: {"Type":"Armor","SubType":"NULL"},
28537: {"Type":"Armor","SubType":"NULL"},
28538: {"Type":"Armor","SubType":"NULL"},
28539: {"Type":"Armor","SubType":"NULL"},
28540: {"Type":"Armor","SubType":"NULL"},
28541: {"Type":"Armor","SubType":"NULL"},
28542: {"Type":"Armor","SubType":"NULL"},
28543: {"Type":"Armor","SubType":"NULL"},
28544: {"Type":"Armor","SubType":"NULL"},
28545: {"Type":"Armor","SubType":"NULL"},
28546: {"Type":"Armor","SubType":"NULL"},
28547: {"Type":"Armor","SubType":"NULL"},
28548: {"Type":"Armor","SubType":"NULL"},
28549: {"Type":"Armor","SubType":"NULL"},
28551: {"Type":"Armor","SubType":"NULL"},
28552: {"Type":"Armor","SubType":"NULL"},
28553: {"Type":"Armor","SubType":"NULL"},
28560: {"Type":"Armor","SubType":"NULL"},
28561: {"Type":"Armor","SubType":"NULL"},
28562: {"Type":"Armor","SubType":"NULL"},
28563: {"Type":"Armor","SubType":"NULL"},
28564: {"Type":"Armor","SubType":"NULL"},
28565: {"Type":"Armor","SubType":"NULL"},
28566: {"Type":"Armor","SubType":"NULL"},
28567: {"Type":"Armor","SubType":"NULL"},
28573: {"Type":"Armor","SubType":"NULL"},
28575: {"Type":"Armor","SubType":"NULL"},
28577: {"Type":"Armor","SubType":"NULL"},
28578: {"Type":"Armor","SubType":"NULL"},
28579: {"Type":"Armor","SubType":"NULL"},
28580: {"Type":"Armor","SubType":"NULL"},
28581: {"Type":"Armor","SubType":"NULL"},
28582: {"Type":"Armor","SubType":"NULL"},
28583: {"Type":"Armor","SubType":"NULL"},
28584: {"Type":"Armor","SubType":"NULL"},
28585: {"Type":"Armor","SubType":"NULL"},
28586: {"Type":"Armor","SubType":"NULL"},
28587: {"Type":"Armor","SubType":"NULL"},
28588: {"Type":"Armor","SubType":"NULL"},
28589: {"Type":"Armor","SubType":"NULL"},
28590: {"Type":"Armor","SubType":"NULL"},
28591: {"Type":"Armor","SubType":"NULL"},
28592: {"Type":"Armor","SubType":"NULL"},
28593: {"Type":"Armor","SubType":"NULL"},
28594: {"Type":"Armor","SubType":"NULL"},
28595: {"Type":"Armor","SubType":"NULL"},
28596: {"Type":"Armor","SubType":"NULL"},
28597: {"Type":"Armor","SubType":"NULL"},
28598: {"Type":"Armor","SubType":"NULL"},
28600: {"Type":"Weapon","SubType":"Book"},
28601: {"Type":"Weapon","SubType":"Book"},
28602: {"Type":"Weapon","SubType":"Book"},
28604: {"Type":"Weapon","SubType":"Book"},
28605: {"Type":"Weapon","SubType":"Book"},
28606: {"Type":"Weapon","SubType":"Book"},
28607: {"Type":"Weapon","SubType":"Book"},
28608: {"Type":"Weapon","SubType":"Book"},
28609: {"Type":"Weapon","SubType":"Book"},
28610: {"Type":"Weapon","SubType":"Book"},
28611: {"Type":"Weapon","SubType":"Book"},
28612: {"Type":"Weapon","SubType":"Book"},
28613: {"Type":"Weapon","SubType":"Book"},
28614: {"Type":"Weapon","SubType":"Book"},
28615: {"Type":"Weapon","SubType":"Book"},
28616: {"Type":"Weapon","SubType":"Book"},
28617: {"Type":"Weapon","SubType":"Book"},
28618: {"Type":"Weapon","SubType":"Book"},
28619: {"Type":"Weapon","SubType":"Book"},
28625: {"Type":"Weapon","SubType":"Book"},
28626: {"Type":"Weapon","SubType":"Book"},
28627: {"Type":"Weapon","SubType":"Book"},
28628: {"Type":"Weapon","SubType":"Book"},
28629: {"Type":"Weapon","SubType":"Book"},
28630: {"Type":"Weapon","SubType":"Book"},
28631: {"Type":"Weapon","SubType":"Book"},
28632: {"Type":"Weapon","SubType":"Book"},
28633: {"Type":"Weapon","SubType":"Book"},
28635: {"Type":"Weapon","SubType":"Book"},
28636: {"Type":"Weapon","SubType":"Book"},
28637: {"Type":"Weapon","SubType":"Book"},
28643: {"Type":"Weapon","SubType":"Book"},
28645: {"Type":"Weapon","SubType":"Book"},
28646: {"Type":"Weapon","SubType":"Book"},
28700: {"Type":"Weapon","SubType":"Dagger"},
28701: {"Type":"Weapon","SubType":"Dagger"},
28702: {"Type":"Weapon","SubType":"Dagger"},
28703: {"Type":"Weapon","SubType":"Dagger"},
28705: {"Type":"Weapon","SubType":"Dagger"},
28706: {"Type":"Weapon","SubType":"Dagger"},
28708: {"Type":"Weapon","SubType":"Dagger"},
28712: {"Type":"Weapon","SubType":"Dagger"},
28713: {"Type":"Weapon","SubType":"Dagger"},
28714: {"Type":"Weapon","SubType":"Dagger"},
28715: {"Type":"Weapon","SubType":"Dagger"},
28716: {"Type":"Weapon","SubType":"Dagger"},
28717: {"Type":"Weapon","SubType":"Dagger"},
28719: {"Type":"Weapon","SubType":"Dagger"},
28720: {"Type":"Weapon","SubType":"Dagger"},
28721: {"Type":"Weapon","SubType":"Dagger"},
28722: {"Type":"Weapon","SubType":"Dagger"},
28723: {"Type":"Weapon","SubType":"Dagger"},
28724: {"Type":"Weapon","SubType":"Dagger"},
28725: {"Type":"Weapon","SubType":"Dagger"},
28726: {"Type":"Weapon","SubType":"Dagger"},
28737: {"Type":"Weapon","SubType":"Dagger"},
28738: {"Type":"Weapon","SubType":"Dagger"},
28740: {"Type":"Weapon","SubType":"Dagger"},
28744: {"Type":"Weapon","SubType":"Dagger"},
28745: {"Type":"Weapon","SubType":"Dagger"},
28747: {"Type":"Weapon","SubType":"Dagger"},
28748: {"Type":"Weapon","SubType":"Dagger"},
28749: {"Type":"Weapon","SubType":"Dagger"},
28750: {"Type":"Weapon","SubType":"Dagger"},
28751: {"Type":"Weapon","SubType":"Dagger"},
28753: {"Type":"Weapon","SubType":"Dagger"},
28754: {"Type":"Weapon","SubType":"Dagger"},
28755: {"Type":"Weapon","SubType":"Dagger"},
28759: {"Type":"Weapon","SubType":"Dagger"},
28761: {"Type":"Weapon","SubType":"Dagger"},
28762: {"Type":"Weapon","SubType":"Dagger"},
28763: {"Type":"Weapon","SubType":"Dagger"},
28764: {"Type":"Weapon","SubType":"Dagger"},
28765: {"Type":"Weapon","SubType":"Dagger"},
28766: {"Type":"Weapon","SubType":"Dagger"},
28767: {"Type":"Weapon","SubType":"Dagger"},
28768: {"Type":"Weapon","SubType":"Dagger"},
28771: {"Type":"Weapon","SubType":"Dagger"},
28772: {"Type":"Weapon","SubType":"Dagger"},
28774: {"Type":"Weapon","SubType":"Dagger"},
28775: {"Type":"Weapon","SubType":"Dagger"},
28776: {"Type":"Weapon","SubType":"Dagger"},
28777: {"Type":"Weapon","SubType":"Dagger"},
28778: {"Type":"Weapon","SubType":"Dagger"},
28779: {"Type":"Weapon","SubType":"Dagger"},
28780: {"Type":"Weapon","SubType":"Dagger"},
28784: {"Type":"Weapon","SubType":"Dagger"},
28785: {"Type":"Weapon","SubType":"Dagger"},
28786: {"Type":"Weapon","SubType":"Dagger"},
28787: {"Type":"Weapon","SubType":"Dagger"},
28789: {"Type":"Weapon","SubType":"Dagger"},
28900: {"Type":"Armor","SubType":"NULL"},
28901: {"Type":"Armor","SubType":"NULL"},
28902: {"Type":"Armor","SubType":"NULL"},
28903: {"Type":"Armor","SubType":"NULL"},
28904: {"Type":"Armor","SubType":"NULL"},
28905: {"Type":"Armor","SubType":"NULL"},
28906: {"Type":"Armor","SubType":"NULL"},
28907: {"Type":"Armor","SubType":"NULL"},
28908: {"Type":"Armor","SubType":"NULL"},
28909: {"Type":"Armor","SubType":"NULL"},
28910: {"Type":"Armor","SubType":"NULL"},
28912: {"Type":"Armor","SubType":"NULL"},
28913: {"Type":"Armor","SubType":"NULL"},
28914: {"Type":"Armor","SubType":"NULL"},
28915: {"Type":"Armor","SubType":"NULL"},
28916: {"Type":"Armor","SubType":"NULL"},
28917: {"Type":"Armor","SubType":"NULL"},
28918: {"Type":"Armor","SubType":"NULL"},
28920: {"Type":"Armor","SubType":"NULL"},
28921: {"Type":"Armor","SubType":"NULL"},
28922: {"Type":"Armor","SubType":"NULL"},
28927: {"Type":"Armor","SubType":"NULL"},
28928: {"Type":"Armor","SubType":"NULL"},
28929: {"Type":"Armor","SubType":"NULL"},
28941: {"Type":"Armor","SubType":"NULL"},
28942: {"Type":"Armor","SubType":"NULL"},
28943: {"Type":"Armor","SubType":"NULL"},
28944: {"Type":"Armor","SubType":"NULL"},
28945: {"Type":"Armor","SubType":"NULL"},
28946: {"Type":"Armor","SubType":"NULL"},
28947: {"Type":"Armor","SubType":"NULL"},
28948: {"Type":"Armor","SubType":"NULL"},
28949: {"Type":"Armor","SubType":"NULL"},
28950: {"Type":"Armor","SubType":"NULL"},
28951: {"Type":"Armor","SubType":"NULL"},
28953: {"Type":"Armor","SubType":"NULL"},
28955: {"Type":"Armor","SubType":"NULL"},
28956: {"Type":"Armor","SubType":"NULL"},
28962: {"Type":"Armor","SubType":"NULL"},
28970: {"Type":"Armor","SubType":"NULL"},
28972: {"Type":"Armor","SubType":"NULL"},
28973: {"Type":"Armor","SubType":"NULL"},
28974: {"Type":"Armor","SubType":"NULL"},
28977: {"Type":"Armor","SubType":"NULL"},
28979: {"Type":"Armor","SubType":"NULL"},
28980: {"Type":"Armor","SubType":"NULL"},
28982: {"Type":"Armor","SubType":"NULL"},
28983: {"Type":"Armor","SubType":"NULL"},
28984: {"Type":"Armor","SubType":"NULL"},
28985: {"Type":"Armor","SubType":"NULL"},
29000: {"Type":"Card","SubType":"Enchant"},
29001: {"Type":"Card","SubType":"Enchant"},
29002: {"Type":"Card","SubType":"Enchant"},
29003: {"Type":"Card","SubType":"Enchant"},
29004: {"Type":"Card","SubType":"Enchant"},
29005: {"Type":"Card","SubType":"Enchant"},
29006: {"Type":"Card","SubType":"Enchant"},
29007: {"Type":"Card","SubType":"Enchant"},
29008: {"Type":"Card","SubType":"Enchant"},
29009: {"Type":"Card","SubType":"Enchant"},
29010: {"Type":"Card","SubType":"Enchant"},
29011: {"Type":"Card","SubType":"Enchant"},
29013: {"Type":"Card","SubType":"Enchant"},
29014: {"Type":"Card","SubType":"Enchant"},
29015: {"Type":"Card","SubType":"Enchant"},
29016: {"Type":"Card","SubType":"Enchant"},
29017: {"Type":"Card","SubType":"Enchant"},
29018: {"Type":"Card","SubType":"Enchant"},
29019: {"Type":"Card","SubType":"Enchant"},
29020: {"Type":"Card","SubType":"Enchant"},
29021: {"Type":"Card","SubType":"Enchant"},
29022: {"Type":"Card","SubType":"Enchant"},
29023: {"Type":"Card","SubType":"Enchant"},
29024: {"Type":"Card","SubType":"Enchant"},
29025: {"Type":"Card","SubType":"Enchant"},
29026: {"Type":"Card","SubType":"Enchant"},
29027: {"Type":"Card","SubType":"Enchant"},
29028: {"Type":"Card","SubType":"Enchant"},
29029: {"Type":"Card","SubType":"Enchant"},
29030: {"Type":"Card","SubType":"Enchant"},
29031: {"Type":"Card","SubType":"Enchant"},
29032: {"Type":"Card","SubType":"Enchant"},
29033: {"Type":"Card","SubType":"Enchant"},
29040: {"Type":"Card","SubType":"Enchant"},
29041: {"Type":"Card","SubType":"Enchant"},
29045: {"Type":"Card","SubType":"Enchant"},
29046: {"Type":"Card","SubType":"Enchant"},
29047: {"Type":"Card","SubType":"Enchant"},
29048: {"Type":"Card","SubType":"Enchant"},
29049: {"Type":"Card","SubType":"Enchant"},
29050: {"Type":"Card","SubType":"Enchant"},
29051: {"Type":"Card","SubType":"Enchant"},
29052: {"Type":"Card","SubType":"Enchant"},
29053: {"Type":"Card","SubType":"Enchant"},
29054: {"Type":"Card","SubType":"Enchant"},
29055: {"Type":"Card","SubType":"Enchant"},
29056: {"Type":"Card","SubType":"Enchant"},
29057: {"Type":"Card","SubType":"Enchant"},
29061: {"Type":"Card","SubType":"Enchant"},
29062: {"Type":"Card","SubType":"Enchant"},
29063: {"Type":"Card","SubType":"Enchant"},
29064: {"Type":"Card","SubType":"Enchant"},
29065: {"Type":"Card","SubType":"Enchant"},
29066: {"Type":"Card","SubType":"Enchant"},
29067: {"Type":"Card","SubType":"Enchant"},
29068: {"Type":"Card","SubType":"Enchant"},
29069: {"Type":"Card","SubType":"Enchant"},
29070: {"Type":"Card","SubType":"Enchant"},
29071: {"Type":"Card","SubType":"Enchant"},
29072: {"Type":"Card","SubType":"Enchant"},
29073: {"Type":"Card","SubType":"Enchant"},
29074: {"Type":"Card","SubType":"Enchant"},
29075: {"Type":"Card","SubType":"Enchant"},
29076: {"Type":"Card","SubType":"Enchant"},
29077: {"Type":"Card","SubType":"Enchant"},
29078: {"Type":"Card","SubType":"Enchant"},
29079: {"Type":"Card","SubType":"Enchant"},
29080: {"Type":"Card","SubType":"Enchant"},
29081: {"Type":"Card","SubType":"Enchant"},
29082: {"Type":"Card","SubType":"Enchant"},
29083: {"Type":"Card","SubType":"Enchant"},
29084: {"Type":"Card","SubType":"Enchant"},
29085: {"Type":"Card","SubType":"Enchant"},
29086: {"Type":"Card","SubType":"Enchant"},
29087: {"Type":"Card","SubType":"Enchant"},
29088: {"Type":"Card","SubType":"Enchant"},
29089: {"Type":"Card","SubType":"Enchant"},
29090: {"Type":"Card","SubType":"Enchant"},
29091: {"Type":"Card","SubType":"Enchant"},
29092: {"Type":"Card","SubType":"Enchant"},
29093: {"Type":"Card","SubType":"Enchant"},
29094: {"Type":"Card","SubType":"Enchant"},
29095: {"Type":"Card","SubType":"Enchant"},
29096: {"Type":"Card","SubType":"Enchant"},
29097: {"Type":"Card","SubType":"Enchant"},
29098: {"Type":"Card","SubType":"Enchant"},
29099: {"Type":"Card","SubType":"Enchant"},
29100: {"Type":"Card","SubType":"Enchant"},
29101: {"Type":"Card","SubType":"Enchant"},
29102: {"Type":"Card","SubType":"Enchant"},
29103: {"Type":"Card","SubType":"Enchant"},
29104: {"Type":"Card","SubType":"Enchant"},
29105: {"Type":"Card","SubType":"Enchant"},
29106: {"Type":"Card","SubType":"Enchant"},
29107: {"Type":"Card","SubType":"Enchant"},
29108: {"Type":"Card","SubType":"Enchant"},
29109: {"Type":"Card","SubType":"Enchant"},
29110: {"Type":"Card","SubType":"Enchant"},
29111: {"Type":"Card","SubType":"Enchant"},
29112: {"Type":"Card","SubType":"Enchant"},
29113: {"Type":"Card","SubType":"Enchant"},
29114: {"Type":"Card","SubType":"Enchant"},
29115: {"Type":"Card","SubType":"Enchant"},
29116: {"Type":"Card","SubType":"Enchant"},
29117: {"Type":"Card","SubType":"Enchant"},
29118: {"Type":"Card","SubType":"Enchant"},
29119: {"Type":"Card","SubType":"Enchant"},
29120: {"Type":"Card","SubType":"Enchant"},
29121: {"Type":"Card","SubType":"Enchant"},
29122: {"Type":"Card","SubType":"Enchant"},
29123: {"Type":"Card","SubType":"Enchant"},
29124: {"Type":"Card","SubType":"Enchant"},
29125: {"Type":"Card","SubType":"Enchant"},
29126: {"Type":"Card","SubType":"Enchant"},
29127: {"Type":"Card","SubType":"Enchant"},
29128: {"Type":"Card","SubType":"Enchant"},
29129: {"Type":"Card","SubType":"Enchant"},
29130: {"Type":"Card","SubType":"Enchant"},
29131: {"Type":"Card","SubType":"Enchant"},
29132: {"Type":"Card","SubType":"Enchant"},
29133: {"Type":"Card","SubType":"Enchant"},
29134: {"Type":"Card","SubType":"Enchant"},
29135: {"Type":"Card","SubType":"Enchant"},
29136: {"Type":"Card","SubType":"Enchant"},
29137: {"Type":"Card","SubType":"Enchant"},
29138: {"Type":"Card","SubType":"Enchant"},
29139: {"Type":"Card","SubType":"Enchant"},
29140: {"Type":"Card","SubType":"Enchant"},
29141: {"Type":"Card","SubType":"Enchant"},
29142: {"Type":"Card","SubType":"Enchant"},
29143: {"Type":"Card","SubType":"Enchant"},
29144: {"Type":"Card","SubType":"Enchant"},
29145: {"Type":"Card","SubType":"Enchant"},
29146: {"Type":"Card","SubType":"Enchant"},
29147: {"Type":"Card","SubType":"Enchant"},
29148: {"Type":"Card","SubType":"Enchant"},
29149: {"Type":"Card","SubType":"Enchant"},
29150: {"Type":"Card","SubType":"Enchant"},
29151: {"Type":"Card","SubType":"Enchant"},
29152: {"Type":"Card","SubType":"Enchant"},
29153: {"Type":"Card","SubType":"Enchant"},
29154: {"Type":"Card","SubType":"Enchant"},
29155: {"Type":"Card","SubType":"Enchant"},
29156: {"Type":"Card","SubType":"Enchant"},
29157: {"Type":"Card","SubType":"Enchant"},
29158: {"Type":"Card","SubType":"Enchant"},
29159: {"Type":"Card","SubType":"Enchant"},
29160: {"Type":"Card","SubType":"Enchant"},
29161: {"Type":"Card","SubType":"Enchant"},
29162: {"Type":"Card","SubType":"Enchant"},
29166: {"Type":"Card","SubType":"Enchant"},
29167: {"Type":"Card","SubType":"Enchant"},
29168: {"Type":"Card","SubType":"Enchant"},
29169: {"Type":"Card","SubType":"Enchant"},
29170: {"Type":"Card","SubType":"Enchant"},
29171: {"Type":"Card","SubType":"Enchant"},
29172: {"Type":"Card","SubType":"Enchant"},
29173: {"Type":"Card","SubType":"Enchant"},
29174: {"Type":"Card","SubType":"Enchant"},
29175: {"Type":"Card","SubType":"Enchant"},
29176: {"Type":"Card","SubType":"Enchant"},
29177: {"Type":"Card","SubType":"Enchant"},
29178: {"Type":"Card","SubType":"Enchant"},
29179: {"Type":"Card","SubType":"Enchant"},
29180: {"Type":"Card","SubType":"Enchant"},
29181: {"Type":"Card","SubType":"Enchant"},
29182: {"Type":"Card","SubType":"Enchant"},
29183: {"Type":"Card","SubType":"Enchant"},
29184: {"Type":"Card","SubType":"Enchant"},
29185: {"Type":"Card","SubType":"Enchant"},
29186: {"Type":"Card","SubType":"Enchant"},
29187: {"Type":"Card","SubType":"Enchant"},
29188: {"Type":"Card","SubType":"Enchant"},
29189: {"Type":"Card","SubType":"Enchant"},
29190: {"Type":"Card","SubType":"Enchant"},
29191: {"Type":"Card","SubType":"Enchant"},
29192: {"Type":"Card","SubType":"Enchant"},
29193: {"Type":"Card","SubType":"Enchant"},
29194: {"Type":"Card","SubType":"Enchant"},
29195: {"Type":"Card","SubType":"Enchant"},
29196: {"Type":"Card","SubType":"Enchant"},
29197: {"Type":"Card","SubType":"Enchant"},
29198: {"Type":"Card","SubType":"Enchant"},
29199: {"Type":"Card","SubType":"Enchant"},
29200: {"Type":"Card","SubType":"Enchant"},
29201: {"Type":"Card","SubType":"Enchant"},
29202: {"Type":"Card","SubType":"Enchant"},
29203: {"Type":"Card","SubType":"Enchant"},
29204: {"Type":"Card","SubType":"Enchant"},
29205: {"Type":"Card","SubType":"Enchant"},
29206: {"Type":"Card","SubType":"Enchant"},
29207: {"Type":"Card","SubType":"Enchant"},
29208: {"Type":"Card","SubType":"Enchant"},
29209: {"Type":"Card","SubType":"Enchant"},
29210: {"Type":"Card","SubType":"Enchant"},
29211: {"Type":"Card","SubType":"Enchant"},
29212: {"Type":"Card","SubType":"Enchant"},
29213: {"Type":"Card","SubType":"Enchant"},
29214: {"Type":"Card","SubType":"Enchant"},
29215: {"Type":"Card","SubType":"Enchant"},
29216: {"Type":"Card","SubType":"Enchant"},
29217: {"Type":"Card","SubType":"Enchant"},
29218: {"Type":"Card","SubType":"Enchant"},
29219: {"Type":"Card","SubType":"Enchant"},
29220: {"Type":"Card","SubType":"Enchant"},
29221: {"Type":"Card","SubType":"Enchant"},
29222: {"Type":"Card","SubType":"Enchant"},
29223: {"Type":"Card","SubType":"Enchant"},
29224: {"Type":"Card","SubType":"Enchant"},
29225: {"Type":"Card","SubType":"Enchant"},
29226: {"Type":"Card","SubType":"Enchant"},
29227: {"Type":"Card","SubType":"Enchant"},
29228: {"Type":"Card","SubType":"Enchant"},
29229: {"Type":"Card","SubType":"Enchant"},
29230: {"Type":"Card","SubType":"NULL"},
29231: {"Type":"Card","SubType":"Enchant"},
29232: {"Type":"Card","SubType":"Enchant"},
29233: {"Type":"Card","SubType":"Enchant"},
29234: {"Type":"Card","SubType":"Enchant"},
29235: {"Type":"Card","SubType":"Enchant"},
29236: {"Type":"Card","SubType":"Enchant"},
29237: {"Type":"Card","SubType":"Enchant"},
29238: {"Type":"Card","SubType":"Enchant"},
29239: {"Type":"Card","SubType":"Enchant"},
29240: {"Type":"Card","SubType":"Enchant"},
29241: {"Type":"Card","SubType":"Enchant"},
29242: {"Type":"Card","SubType":"Enchant"},
29243: {"Type":"Card","SubType":"Enchant"},
29244: {"Type":"Card","SubType":"Enchant"},
29245: {"Type":"Card","SubType":"Enchant"},
29246: {"Type":"Card","SubType":"Enchant"},
29247: {"Type":"Card","SubType":"Enchant"},
29248: {"Type":"Card","SubType":"Enchant"},
29249: {"Type":"Card","SubType":"Enchant"},
29250: {"Type":"Card","SubType":"Enchant"},
29251: {"Type":"Card","SubType":"Enchant"},
29252: {"Type":"Card","SubType":"Enchant"},
29253: {"Type":"Card","SubType":"Enchant"},
29254: {"Type":"Card","SubType":"Enchant"},
29255: {"Type":"Card","SubType":"Enchant"},
29256: {"Type":"Card","SubType":"Enchant"},
29257: {"Type":"Card","SubType":"Enchant"},
29258: {"Type":"Card","SubType":"Enchant"},
29259: {"Type":"Card","SubType":"Enchant"},
29260: {"Type":"Card","SubType":"Enchant"},
29261: {"Type":"Card","SubType":"Enchant"},
29262: {"Type":"Card","SubType":"Enchant"},
29263: {"Type":"Card","SubType":"Enchant"},
29264: {"Type":"Card","SubType":"Enchant"},
29265: {"Type":"Card","SubType":"Enchant"},
29266: {"Type":"Card","SubType":"Enchant"},
29267: {"Type":"Card","SubType":"Enchant"},
29268: {"Type":"Card","SubType":"Enchant"},
29269: {"Type":"Card","SubType":"Enchant"},
29270: {"Type":"Card","SubType":"Enchant"},
29271: {"Type":"Card","SubType":"Enchant"},
29272: {"Type":"Card","SubType":"Enchant"},
29273: {"Type":"Card","SubType":"Enchant"},
29274: {"Type":"Card","SubType":"Enchant"},
29275: {"Type":"Card","SubType":"Enchant"},
29276: {"Type":"Card","SubType":"Enchant"},
29277: {"Type":"Card","SubType":"Enchant"},
29278: {"Type":"Card","SubType":"Enchant"},
29279: {"Type":"Card","SubType":"Enchant"},
29280: {"Type":"Card","SubType":"Enchant"},
29281: {"Type":"Card","SubType":"Enchant"},
29282: {"Type":"Card","SubType":"Enchant"},
29300: {"Type":"Card","SubType":"Enchant"},
29302: {"Type":"Card","SubType":"Enchant"},
29303: {"Type":"Card","SubType":"Enchant"},
29304: {"Type":"Card","SubType":"Enchant"},
29305: {"Type":"Card","SubType":"Enchant"},
29306: {"Type":"Card","SubType":"Enchant"},
29307: {"Type":"Card","SubType":"Enchant"},
29308: {"Type":"Card","SubType":"Enchant"},
29309: {"Type":"Card","SubType":"Enchant"},
29310: {"Type":"Card","SubType":"Enchant"},
29311: {"Type":"Card","SubType":"Enchant"},
29312: {"Type":"Card","SubType":"Enchant"},
29313: {"Type":"Card","SubType":"Enchant"},
29314: {"Type":"Card","SubType":"Enchant"},
29315: {"Type":"Card","SubType":"Enchant"},
29316: {"Type":"Card","SubType":"Enchant"},
29317: {"Type":"Card","SubType":"Enchant"},
29318: {"Type":"Card","SubType":"Enchant"},
29319: {"Type":"Card","SubType":"Enchant"},
29320: {"Type":"Card","SubType":"Enchant"},
29321: {"Type":"Card","SubType":"Enchant"},
29322: {"Type":"Card","SubType":"Enchant"},
29323: {"Type":"Card","SubType":"Enchant"},
29324: {"Type":"Card","SubType":"Enchant"},
29325: {"Type":"Card","SubType":"Enchant"},
29326: {"Type":"Card","SubType":"Enchant"},
29327: {"Type":"Card","SubType":"Enchant"},
29328: {"Type":"Card","SubType":"Enchant"},
29329: {"Type":"Card","SubType":"Enchant"},
29330: {"Type":"Card","SubType":"Enchant"},
29331: {"Type":"Card","SubType":"Enchant"},
29332: {"Type":"Card","SubType":"Enchant"},
29333: {"Type":"Card","SubType":"Enchant"},
29334: {"Type":"Card","SubType":"Enchant"},
29335: {"Type":"Card","SubType":"Enchant"},
29336: {"Type":"Card","SubType":"Enchant"},
29337: {"Type":"Card","SubType":"Enchant"},
29338: {"Type":"Card","SubType":"Enchant"},
29339: {"Type":"Card","SubType":"Enchant"},
29340: {"Type":"Card","SubType":"Enchant"},
29341: {"Type":"Card","SubType":"Enchant"},
29342: {"Type":"Card","SubType":"Enchant"},
29343: {"Type":"Card","SubType":"Enchant"},
29344: {"Type":"Card","SubType":"Enchant"},
29345: {"Type":"Card","SubType":"Enchant"},
29346: {"Type":"Card","SubType":"Enchant"},
29347: {"Type":"Card","SubType":"Enchant"},
29348: {"Type":"Card","SubType":"Enchant"},
29349: {"Type":"Card","SubType":"Enchant"},
29350: {"Type":"Card","SubType":"Enchant"},
29351: {"Type":"Card","SubType":"Enchant"},
29352: {"Type":"Card","SubType":"Enchant"},
29353: {"Type":"Card","SubType":"Enchant"},
29354: {"Type":"Card","SubType":"Enchant"},
29355: {"Type":"Card","SubType":"Enchant"},
29356: {"Type":"Card","SubType":"Enchant"},
29357: {"Type":"Card","SubType":"Enchant"},
29358: {"Type":"Card","SubType":"Enchant"},
29359: {"Type":"Card","SubType":"Enchant"},
29360: {"Type":"Card","SubType":"Enchant"},
29361: {"Type":"Card","SubType":"Enchant"},
29362: {"Type":"Card","SubType":"Enchant"},
29366: {"Type":"Card","SubType":"Enchant"},
29367: {"Type":"Card","SubType":"Enchant"},
29368: {"Type":"Card","SubType":"Enchant"},
29369: {"Type":"Card","SubType":"Enchant"},
29370: {"Type":"Card","SubType":"Enchant"},
29371: {"Type":"Card","SubType":"Enchant"},
29372: {"Type":"Card","SubType":"Enchant"},
29373: {"Type":"Card","SubType":"Enchant"},
29374: {"Type":"Card","SubType":"Enchant"},
29375: {"Type":"Card","SubType":"Enchant"},
29376: {"Type":"Card","SubType":"Enchant"},
29377: {"Type":"Card","SubType":"Enchant"},
29378: {"Type":"Card","SubType":"Enchant"},
29379: {"Type":"Card","SubType":"Enchant"},
29380: {"Type":"Card","SubType":"Enchant"},
29381: {"Type":"Card","SubType":"Enchant"},
29382: {"Type":"Card","SubType":"Enchant"},
29383: {"Type":"Card","SubType":"Enchant"},
29384: {"Type":"Card","SubType":"Enchant"},
29385: {"Type":"Card","SubType":"Enchant"},
29386: {"Type":"Card","SubType":"Enchant"},
29423: {"Type":"Card","SubType":"Enchant"},
29424: {"Type":"Card","SubType":"Enchant"},
29425: {"Type":"Card","SubType":"Enchant"},
29426: {"Type":"Card","SubType":"Enchant"},
29427: {"Type":"Card","SubType":"Enchant"},
29428: {"Type":"Card","SubType":"Enchant"},
29429: {"Type":"Card","SubType":"Enchant"},
29430: {"Type":"Card","SubType":"Enchant"},
29431: {"Type":"Card","SubType":"Enchant"},
29432: {"Type":"Card","SubType":"Enchant"},
29433: {"Type":"Card","SubType":"Enchant"},
29434: {"Type":"Card","SubType":"Enchant"},
29435: {"Type":"Card","SubType":"Enchant"},
29436: {"Type":"Card","SubType":"Enchant"},
29438: {"Type":"Card","SubType":"Enchant"},
29439: {"Type":"Card","SubType":"Enchant"},
29440: {"Type":"Card","SubType":"Enchant"},
29441: {"Type":"Card","SubType":"Enchant"},
29442: {"Type":"Card","SubType":"Enchant"},
29443: {"Type":"Card","SubType":"Enchant"},
29444: {"Type":"Card","SubType":"Enchant"},
29445: {"Type":"Card","SubType":"Enchant"},
29446: {"Type":"Card","SubType":"Enchant"},
29447: {"Type":"Card","SubType":"Enchant"},
29448: {"Type":"Card","SubType":"Enchant"},
29449: {"Type":"Card","SubType":"Enchant"},
29460: {"Type":"Card","SubType":"Enchant"},
29461: {"Type":"Card","SubType":"Enchant"},
29462: {"Type":"Card","SubType":"Enchant"},
29463: {"Type":"Card","SubType":"Enchant"},
29464: {"Type":"Card","SubType":"Enchant"},
29465: {"Type":"Card","SubType":"Enchant"},
29466: {"Type":"Card","SubType":"Enchant"},
29467: {"Type":"Card","SubType":"Enchant"},
29468: {"Type":"Card","SubType":"Enchant"},
29469: {"Type":"Card","SubType":"Enchant"},
29470: {"Type":"Card","SubType":"Enchant"},
29471: {"Type":"Card","SubType":"Enchant"},
29477: {"Type":"Card","SubType":"Enchant"},
29478: {"Type":"Card","SubType":"Enchant"},
29479: {"Type":"Card","SubType":"Enchant"},
29480: {"Type":"Card","SubType":"Enchant"},
29481: {"Type":"Card","SubType":"Enchant"},
29482: {"Type":"Card","SubType":"Enchant"},
29483: {"Type":"Card","SubType":"Enchant"},
29484: {"Type":"Card","SubType":"Enchant"},
29485: {"Type":"Card","SubType":"Enchant"},
29486: {"Type":"Card","SubType":"Enchant"},
29487: {"Type":"Card","SubType":"Enchant"},
29488: {"Type":"Card","SubType":"Enchant"},
29509: {"Type":"Card","SubType":"Enchant"},
29510: {"Type":"Card","SubType":"Enchant"},
29511: {"Type":"Card","SubType":"Enchant"},
29512: {"Type":"Card","SubType":"Enchant"},
29513: {"Type":"Card","SubType":"Enchant"},
29514: {"Type":"Card","SubType":"Enchant"},
29515: {"Type":"Card","SubType":"Enchant"},
29516: {"Type":"Card","SubType":"Enchant"},
29517: {"Type":"Card","SubType":"Enchant"},
29518: {"Type":"Card","SubType":"Enchant"},
29519: {"Type":"Card","SubType":"Enchant"},
29520: {"Type":"Card","SubType":"Enchant"},
29521: {"Type":"Card","SubType":"Enchant"},
29522: {"Type":"Card","SubType":"Enchant"},
29523: {"Type":"Card","SubType":"Enchant"},
29524: {"Type":"Card","SubType":"Enchant"},
29525: {"Type":"Card","SubType":"Enchant"},
29526: {"Type":"Card","SubType":"Enchant"},
29527: {"Type":"Card","SubType":"Enchant"},
29528: {"Type":"Card","SubType":"Enchant"},
29529: {"Type":"Card","SubType":"Enchant"},
29530: {"Type":"Card","SubType":"Enchant"},
29531: {"Type":"Card","SubType":"Enchant"},
29532: {"Type":"Card","SubType":"Enchant"},
29533: {"Type":"Card","SubType":"Enchant"},
29534: {"Type":"Card","SubType":"Enchant"},
29535: {"Type":"Card","SubType":"Enchant"},
29536: {"Type":"Card","SubType":"Enchant"},
29537: {"Type":"Card","SubType":"Enchant"},
29538: {"Type":"Card","SubType":"Enchant"},
29539: {"Type":"Card","SubType":"Enchant"},
29540: {"Type":"Card","SubType":"Enchant"},
29541: {"Type":"Card","SubType":"Enchant"},
29542: {"Type":"Card","SubType":"Enchant"},
29543: {"Type":"Card","SubType":"Enchant"},
29544: {"Type":"Card","SubType":"Enchant"},
29545: {"Type":"Card","SubType":"Enchant"},
29546: {"Type":"Card","SubType":"Enchant"},
29547: {"Type":"Card","SubType":"Enchant"},
29548: {"Type":"Card","SubType":"Enchant"},
29549: {"Type":"Card","SubType":"Enchant"},
29550: {"Type":"Card","SubType":"Enchant"},
29551: {"Type":"Card","SubType":"Enchant"},
29552: {"Type":"Card","SubType":"Enchant"},
29579: {"Type":"Card","SubType":"Enchant"},
29580: {"Type":"Card","SubType":"Enchant"},
29581: {"Type":"Card","SubType":"Enchant"},
29582: {"Type":"Card","SubType":"Enchant"},
29583: {"Type":"Card","SubType":"Enchant"},
29584: {"Type":"Card","SubType":"Enchant"},
29585: {"Type":"Card","SubType":"Enchant"},
29586: {"Type":"Card","SubType":"Enchant"},
29587: {"Type":"Card","SubType":"Enchant"},
29588: {"Type":"Card","SubType":"Enchant"},
29589: {"Type":"Card","SubType":"Enchant"},
29590: {"Type":"Card","SubType":"Enchant"},
29591: {"Type":"Card","SubType":"Enchant"},
29592: {"Type":"Card","SubType":"Enchant"},
29593: {"Type":"Card","SubType":"Enchant"},
29594: {"Type":"Card","SubType":"Enchant"},
29595: {"Type":"Card","SubType":"Enchant"},
29596: {"Type":"Card","SubType":"Enchant"},
29598: {"Type":"Card","SubType":"Enchant"},
29599: {"Type":"Card","SubType":"Enchant"},
29600: {"Type":"Card","SubType":"Enchant"},
29601: {"Type":"Card","SubType":"Enchant"},
29602: {"Type":"Card","SubType":"Enchant"},
29603: {"Type":"Card","SubType":"Enchant"},
29604: {"Type":"Card","SubType":"Enchant"},
29605: {"Type":"Card","SubType":"Enchant"},
29606: {"Type":"Card","SubType":"Enchant"},
29607: {"Type":"Card","SubType":"Enchant"},
29611: {"Type":"Card","SubType":"Enchant"},
29612: {"Type":"Card","SubType":"Enchant"},
29613: {"Type":"Card","SubType":"Enchant"},
29614: {"Type":"Card","SubType":"Enchant"},
29615: {"Type":"Card","SubType":"Enchant"},
29616: {"Type":"Card","SubType":"Enchant"},
29617: {"Type":"Card","SubType":"Enchant"},
29618: {"Type":"Card","SubType":"Enchant"},
29619: {"Type":"Card","SubType":"Enchant"},
29620: {"Type":"Card","SubType":"Enchant"},
29621: {"Type":"Card","SubType":"Enchant"},
29646: {"Type":"Card","SubType":"Enchant"},
29647: {"Type":"Card","SubType":"Enchant"},
29648: {"Type":"Card","SubType":"Enchant"},
29649: {"Type":"Card","SubType":"Enchant"},
29650: {"Type":"Card","SubType":"Enchant"},
29651: {"Type":"Card","SubType":"Enchant"},
29652: {"Type":"Card","SubType":"Enchant"},
29653: {"Type":"Card","SubType":"Enchant"},
29654: {"Type":"Card","SubType":"Enchant"},
29655: {"Type":"Card","SubType":"Enchant"},
29656: {"Type":"Card","SubType":"Enchant"},
29657: {"Type":"Card","SubType":"Enchant"},
29658: {"Type":"Card","SubType":"Enchant"},
29659: {"Type":"Card","SubType":"Enchant"},
29660: {"Type":"Card","SubType":"Enchant"},
29661: {"Type":"Card","SubType":"Enchant"},
29662: {"Type":"Card","SubType":"Enchant"},
29663: {"Type":"Card","SubType":"Enchant"},
29664: {"Type":"Card","SubType":"Enchant"},
29665: {"Type":"Card","SubType":"Enchant"},
29666: {"Type":"Card","SubType":"Enchant"},
29667: {"Type":"Card","SubType":"Enchant"},
29668: {"Type":"Card","SubType":"Enchant"},
29669: {"Type":"Card","SubType":"Enchant"},
29670: {"Type":"Card","SubType":"Enchant"},
29671: {"Type":"Card","SubType":"Enchant"},
29672: {"Type":"Card","SubType":"Enchant"},
29673: {"Type":"Card","SubType":"Enchant"},
29674: {"Type":"Card","SubType":"Enchant"},
29675: {"Type":"Card","SubType":"Enchant"},
29676: {"Type":"Card","SubType":"Enchant"},
29677: {"Type":"Card","SubType":"Enchant"},
29678: {"Type":"Card","SubType":"Enchant"},
29679: {"Type":"Card","SubType":"Enchant"},
29680: {"Type":"Card","SubType":"Enchant"},
29681: {"Type":"Card","SubType":"Enchant"},
29682: {"Type":"Card","SubType":"Enchant"},
29683: {"Type":"Card","SubType":"Enchant"},
29684: {"Type":"Card","SubType":"Enchant"},
29685: {"Type":"Card","SubType":"Enchant"},
29686: {"Type":"Card","SubType":"Enchant"},
29687: {"Type":"Card","SubType":"Enchant"},
29688: {"Type":"Card","SubType":"Enchant"},
29689: {"Type":"Card","SubType":"Enchant"},
29690: {"Type":"Card","SubType":"Enchant"},
29691: {"Type":"Card","SubType":"Enchant"},
29692: {"Type":"Card","SubType":"Enchant"},
29693: {"Type":"Card","SubType":"Enchant"},
29695: {"Type":"Card","SubType":"Enchant"},
29696: {"Type":"Card","SubType":"Enchant"},
29697: {"Type":"Card","SubType":"Enchant"},
29698: {"Type":"Card","SubType":"Enchant"},
29699: {"Type":"Card","SubType":"Enchant"},
29700: {"Type":"Card","SubType":"Enchant"},
29701: {"Type":"Card","SubType":"Enchant"},
29702: {"Type":"Card","SubType":"Enchant"},
29703: {"Type":"Card","SubType":"Enchant"},
29704: {"Type":"Card","SubType":"Enchant"},
29705: {"Type":"Card","SubType":"Enchant"},
29706: {"Type":"Card","SubType":"Enchant"},
29707: {"Type":"Card","SubType":"Enchant"},
29708: {"Type":"Card","SubType":"Enchant"},
29709: {"Type":"Card","SubType":"Enchant"},
29710: {"Type":"Card","SubType":"Enchant"},
29711: {"Type":"Card","SubType":"Enchant"},
29712: {"Type":"Card","SubType":"Enchant"},
29713: {"Type":"Card","SubType":"Enchant"},
29714: {"Type":"Card","SubType":"Enchant"},
29715: {"Type":"Card","SubType":"Enchant"},
29716: {"Type":"Card","SubType":"Enchant"},
29717: {"Type":"Card","SubType":"Enchant"},
29718: {"Type":"Card","SubType":"Enchant"},
29719: {"Type":"Card","SubType":"Enchant"},
29720: {"Type":"Card","SubType":"Enchant"},
29721: {"Type":"Card","SubType":"Enchant"},
29722: {"Type":"Card","SubType":"Enchant"},
29723: {"Type":"Card","SubType":"Enchant"},
29724: {"Type":"Card","SubType":"Enchant"},
29725: {"Type":"Card","SubType":"Enchant"},
29727: {"Type":"Card","SubType":"Enchant"},
31000: {"Type":"Card","SubType":"NULL"},
31001: {"Type":"Card","SubType":"NULL"},
31002: {"Type":"Card","SubType":"NULL"},
31003: {"Type":"Card","SubType":"NULL"},
31004: {"Type":"Card","SubType":"NULL"},
31005: {"Type":"Card","SubType":"NULL"},
31006: {"Type":"Card","SubType":"NULL"},
31007: {"Type":"Card","SubType":"NULL"},
31008: {"Type":"Card","SubType":"NULL"},
31009: {"Type":"Card","SubType":"NULL"},
31010: {"Type":"Card","SubType":"NULL"},
31011: {"Type":"Card","SubType":"NULL"},
31012: {"Type":"Card","SubType":"NULL"},
31013: {"Type":"Card","SubType":"NULL"},
31014: {"Type":"Card","SubType":"NULL"},
31015: {"Type":"Card","SubType":"NULL"},
31016: {"Type":"Card","SubType":"NULL"},
31017: {"Type":"Card","SubType":"NULL"},
31018: {"Type":"Card","SubType":"NULL"},
31019: {"Type":"Card","SubType":"NULL"},
31020: {"Type":"Card","SubType":"NULL"},
31021: {"Type":"Card","SubType":"NULL"},
31022: {"Type":"Card","SubType":"NULL"},
31023: {"Type":"Card","SubType":"NULL"},
31024: {"Type":"Card","SubType":"NULL"},
31025: {"Type":"Card","SubType":"NULL"},
31026: {"Type":"Card","SubType":"NULL"},
31027: {"Type":"Armor","SubType":"NULL"},
31028: {"Type":"Armor","SubType":"NULL"},
31029: {"Type":"Armor","SubType":"NULL"},
31030: {"Type":"Armor","SubType":"NULL"},
31031: {"Type":"Armor","SubType":"NULL"},
31032: {"Type":"Armor","SubType":"NULL"},
31033: {"Type":"Armor","SubType":"NULL"},
31034: {"Type":"Armor","SubType":"NULL"},
31035: {"Type":"Armor","SubType":"NULL"},
31036: {"Type":"Armor","SubType":"NULL"},
31037: {"Type":"Armor","SubType":"NULL"},
31038: {"Type":"Armor","SubType":"NULL"},
31039: {"Type":"Armor","SubType":"NULL"},
31040: {"Type":"Armor","SubType":"NULL"},
31041: {"Type":"Armor","SubType":"NULL"},
31042: {"Type":"Armor","SubType":"NULL"},
31043: {"Type":"Armor","SubType":"NULL"},
31044: {"Type":"Armor","SubType":"NULL"},
31045: {"Type":"Armor","SubType":"NULL"},
31046: {"Type":"Armor","SubType":"NULL"},
31047: {"Type":"Armor","SubType":"NULL"},
31048: {"Type":"Armor","SubType":"NULL"},
31049: {"Type":"Armor","SubType":"NULL"},
31050: {"Type":"Armor","SubType":"NULL"},
31051: {"Type":"Armor","SubType":"NULL"},
31052: {"Type":"Armor","SubType":"NULL"},
31053: {"Type":"Armor","SubType":"NULL"},
31054: {"Type":"Armor","SubType":"NULL"},
31055: {"Type":"Armor","SubType":"NULL"},
31056: {"Type":"Armor","SubType":"NULL"},
31057: {"Type":"Armor","SubType":"NULL"},
31058: {"Type":"Armor","SubType":"NULL"},
31059: {"Type":"Armor","SubType":"NULL"},
31060: {"Type":"Armor","SubType":"NULL"},
31061: {"Type":"Armor","SubType":"NULL"},
31062: {"Type":"Armor","SubType":"NULL"},
31063: {"Type":"Armor","SubType":"NULL"},
31064: {"Type":"Armor","SubType":"NULL"},
31065: {"Type":"Armor","SubType":"NULL"},
31066: {"Type":"Armor","SubType":"NULL"},
31067: {"Type":"Armor","SubType":"NULL"},
31068: {"Type":"Armor","SubType":"NULL"},
31069: {"Type":"Armor","SubType":"NULL"},
31070: {"Type":"Armor","SubType":"NULL"},
31071: {"Type":"Armor","SubType":"NULL"},
31072: {"Type":"Armor","SubType":"NULL"},
31073: {"Type":"Armor","SubType":"NULL"},
31074: {"Type":"Armor","SubType":"NULL"},
31075: {"Type":"Armor","SubType":"NULL"},
31076: {"Type":"Armor","SubType":"NULL"},
31077: {"Type":"Armor","SubType":"NULL"},
31078: {"Type":"Armor","SubType":"NULL"},
31079: {"Type":"Armor","SubType":"NULL"},
31080: {"Type":"Armor","SubType":"NULL"},
31081: {"Type":"Armor","SubType":"NULL"},
31082: {"Type":"Armor","SubType":"NULL"},
31083: {"Type":"Armor","SubType":"NULL"},
31084: {"Type":"Armor","SubType":"NULL"},
31085: {"Type":"Armor","SubType":"NULL"},
31086: {"Type":"Armor","SubType":"NULL"},
31087: {"Type":"Armor","SubType":"NULL"},
31088: {"Type":"Armor","SubType":"NULL"},
31089: {"Type":"Armor","SubType":"NULL"},
31090: {"Type":"Armor","SubType":"NULL"},
31091: {"Type":"Armor","SubType":"NULL"},
31092: {"Type":"Armor","SubType":"NULL"},
31093: {"Type":"Armor","SubType":"NULL"},
31094: {"Type":"Armor","SubType":"NULL"},
31095: {"Type":"Armor","SubType":"NULL"},
31096: {"Type":"Armor","SubType":"NULL"},
31097: {"Type":"Armor","SubType":"NULL"},
31098: {"Type":"Armor","SubType":"NULL"},
31099: {"Type":"Armor","SubType":"NULL"},
31100: {"Type":"Armor","SubType":"NULL"},
31101: {"Type":"Armor","SubType":"NULL"},
31102: {"Type":"Armor","SubType":"NULL"},
31103: {"Type":"Armor","SubType":"NULL"},
31104: {"Type":"Armor","SubType":"NULL"},
31105: {"Type":"Armor","SubType":"NULL"},
31106: {"Type":"Armor","SubType":"NULL"},
31107: {"Type":"Armor","SubType":"NULL"},
31108: {"Type":"Armor","SubType":"NULL"},
31109: {"Type":"Armor","SubType":"NULL"},
31110: {"Type":"Armor","SubType":"NULL"},
31111: {"Type":"Armor","SubType":"NULL"},
31112: {"Type":"Armor","SubType":"NULL"},
31113: {"Type":"Armor","SubType":"NULL"},
31114: {"Type":"Armor","SubType":"NULL"},
31115: {"Type":"Armor","SubType":"NULL"},
31116: {"Type":"Armor","SubType":"NULL"},
31117: {"Type":"Armor","SubType":"NULL"},
31118: {"Type":"Armor","SubType":"NULL"},
31119: {"Type":"Armor","SubType":"NULL"},
31120: {"Type":"Armor","SubType":"NULL"},
31121: {"Type":"Armor","SubType":"NULL"},
31122: {"Type":"Armor","SubType":"NULL"},
31123: {"Type":"Armor","SubType":"NULL"},
31124: {"Type":"Armor","SubType":"NULL"},
31125: {"Type":"Armor","SubType":"NULL"},
31126: {"Type":"Armor","SubType":"NULL"},
31127: {"Type":"Armor","SubType":"NULL"},
31128: {"Type":"Armor","SubType":"NULL"},
31129: {"Type":"Armor","SubType":"NULL"},
31130: {"Type":"Armor","SubType":"NULL"},
31131: {"Type":"Armor","SubType":"NULL"},
31132: {"Type":"Armor","SubType":"NULL"},
31133: {"Type":"Armor","SubType":"NULL"},
31134: {"Type":"Armor","SubType":"NULL"},
31135: {"Type":"Armor","SubType":"NULL"},
31136: {"Type":"Armor","SubType":"NULL"},
31137: {"Type":"Armor","SubType":"NULL"},
31138: {"Type":"Armor","SubType":"NULL"},
31139: {"Type":"Armor","SubType":"NULL"},
31140: {"Type":"Armor","SubType":"NULL"},
31141: {"Type":"Armor","SubType":"NULL"},
31142: {"Type":"Armor","SubType":"NULL"},
31143: {"Type":"Armor","SubType":"NULL"},
31144: {"Type":"Armor","SubType":"NULL"},
31145: {"Type":"Armor","SubType":"NULL"},
31146: {"Type":"Armor","SubType":"NULL"},
31147: {"Type":"Armor","SubType":"NULL"},
31148: {"Type":"Armor","SubType":"NULL"},
31149: {"Type":"Armor","SubType":"NULL"},
31150: {"Type":"Armor","SubType":"NULL"},
31151: {"Type":"Armor","SubType":"NULL"},
31152: {"Type":"Armor","SubType":"NULL"},
31153: {"Type":"Armor","SubType":"NULL"},
31154: {"Type":"Armor","SubType":"NULL"},
31155: {"Type":"Armor","SubType":"NULL"},
31156: {"Type":"Armor","SubType":"NULL"},
31157: {"Type":"Armor","SubType":"NULL"},
31158: {"Type":"Armor","SubType":"NULL"},
31159: {"Type":"Armor","SubType":"NULL"},
31160: {"Type":"Armor","SubType":"NULL"},
31161: {"Type":"Armor","SubType":"NULL"},
31162: {"Type":"Armor","SubType":"NULL"},
31163: {"Type":"Armor","SubType":"NULL"},
31164: {"Type":"Armor","SubType":"NULL"},
31165: {"Type":"Armor","SubType":"NULL"},
31166: {"Type":"Armor","SubType":"NULL"},
31167: {"Type":"Armor","SubType":"NULL"},
31168: {"Type":"Armor","SubType":"NULL"},
31169: {"Type":"Armor","SubType":"NULL"},
31170: {"Type":"Armor","SubType":"NULL"},
31171: {"Type":"Armor","SubType":"NULL"},
31172: {"Type":"Armor","SubType":"NULL"},
31173: {"Type":"Armor","SubType":"NULL"},
31174: {"Type":"Armor","SubType":"NULL"},
31175: {"Type":"Armor","SubType":"NULL"},
31176: {"Type":"Armor","SubType":"NULL"},
31177: {"Type":"Armor","SubType":"NULL"},
31178: {"Type":"Armor","SubType":"NULL"},
31179: {"Type":"Armor","SubType":"NULL"},
31180: {"Type":"Armor","SubType":"NULL"},
31181: {"Type":"Armor","SubType":"NULL"},
31182: {"Type":"Armor","SubType":"NULL"},
31183: {"Type":"Armor","SubType":"NULL"},
31184: {"Type":"Armor","SubType":"NULL"},
31185: {"Type":"Armor","SubType":"NULL"},
31186: {"Type":"Armor","SubType":"NULL"},
31187: {"Type":"Armor","SubType":"NULL"},
31188: {"Type":"Armor","SubType":"NULL"},
31189: {"Type":"Armor","SubType":"NULL"},
31190: {"Type":"Armor","SubType":"NULL"},
31191: {"Type":"Armor","SubType":"NULL"},
31192: {"Type":"Armor","SubType":"NULL"},
31193: {"Type":"Armor","SubType":"NULL"},
31194: {"Type":"Armor","SubType":"NULL"},
31195: {"Type":"Armor","SubType":"NULL"},
31196: {"Type":"Armor","SubType":"NULL"},
31197: {"Type":"Armor","SubType":"NULL"},
31198: {"Type":"Armor","SubType":"NULL"},
31199: {"Type":"Armor","SubType":"NULL"},
31200: {"Type":"Armor","SubType":"NULL"},
31201: {"Type":"Armor","SubType":"NULL"},
31202: {"Type":"Armor","SubType":"NULL"},
31203: {"Type":"Armor","SubType":"NULL"},
31204: {"Type":"Armor","SubType":"NULL"},
31205: {"Type":"Armor","SubType":"NULL"},
31206: {"Type":"Armor","SubType":"NULL"},
31207: {"Type":"Armor","SubType":"NULL"},
31208: {"Type":"Armor","SubType":"NULL"},
31209: {"Type":"Armor","SubType":"NULL"},
31210: {"Type":"Armor","SubType":"NULL"},
31211: {"Type":"Armor","SubType":"NULL"},
31212: {"Type":"Armor","SubType":"NULL"},
31213: {"Type":"Armor","SubType":"NULL"},
31214: {"Type":"Armor","SubType":"NULL"},
31215: {"Type":"Armor","SubType":"NULL"},
31216: {"Type":"Armor","SubType":"NULL"},
31217: {"Type":"Armor","SubType":"NULL"},
31218: {"Type":"Armor","SubType":"NULL"},
31219: {"Type":"Armor","SubType":"NULL"},
31220: {"Type":"Armor","SubType":"NULL"},
31221: {"Type":"Armor","SubType":"NULL"},
31222: {"Type":"Armor","SubType":"NULL"},
31223: {"Type":"Armor","SubType":"NULL"},
31224: {"Type":"Armor","SubType":"NULL"},
31225: {"Type":"Armor","SubType":"NULL"},
31226: {"Type":"Armor","SubType":"NULL"},
31227: {"Type":"Armor","SubType":"NULL"},
31228: {"Type":"Armor","SubType":"NULL"},
31229: {"Type":"Armor","SubType":"NULL"},
31230: {"Type":"Armor","SubType":"NULL"},
31231: {"Type":"Armor","SubType":"NULL"},
31232: {"Type":"Armor","SubType":"NULL"},
31233: {"Type":"Armor","SubType":"NULL"},
31234: {"Type":"Armor","SubType":"NULL"},
31235: {"Type":"Armor","SubType":"NULL"},
31236: {"Type":"Armor","SubType":"NULL"},
31237: {"Type":"Armor","SubType":"NULL"},
31238: {"Type":"Armor","SubType":"NULL"},
31239: {"Type":"Armor","SubType":"NULL"},
31240: {"Type":"Armor","SubType":"NULL"},
31241: {"Type":"Armor","SubType":"NULL"},
31242: {"Type":"Armor","SubType":"NULL"},
31243: {"Type":"Armor","SubType":"NULL"},
31244: {"Type":"Armor","SubType":"NULL"},
31245: {"Type":"Armor","SubType":"NULL"},
31246: {"Type":"Armor","SubType":"NULL"},
31247: {"Type":"Armor","SubType":"NULL"},
31248: {"Type":"Armor","SubType":"NULL"},
31249: {"Type":"Armor","SubType":"NULL"},
31250: {"Type":"Armor","SubType":"NULL"},
31251: {"Type":"Armor","SubType":"NULL"},
31252: {"Type":"Armor","SubType":"NULL"},
31253: {"Type":"Armor","SubType":"NULL"},
31254: {"Type":"Armor","SubType":"NULL"},
31255: {"Type":"Armor","SubType":"NULL"},
31256: {"Type":"Armor","SubType":"NULL"},
31257: {"Type":"Armor","SubType":"NULL"},
31258: {"Type":"Armor","SubType":"NULL"},
31259: {"Type":"Armor","SubType":"NULL"},
31260: {"Type":"Armor","SubType":"NULL"},
31261: {"Type":"Armor","SubType":"NULL"},
31262: {"Type":"Armor","SubType":"NULL"},
31263: {"Type":"Armor","SubType":"NULL"},
31264: {"Type":"Armor","SubType":"NULL"},
31265: {"Type":"Armor","SubType":"NULL"},
31266: {"Type":"Armor","SubType":"NULL"},
31267: {"Type":"Armor","SubType":"NULL"},
31268: {"Type":"Armor","SubType":"NULL"},
31269: {"Type":"Armor","SubType":"NULL"},
31270: {"Type":"Armor","SubType":"NULL"},
31271: {"Type":"Armor","SubType":"NULL"},
31272: {"Type":"Armor","SubType":"NULL"},
31273: {"Type":"Armor","SubType":"NULL"},
31274: {"Type":"Armor","SubType":"NULL"},
31275: {"Type":"Armor","SubType":"NULL"},
31276: {"Type":"Armor","SubType":"NULL"},
31277: {"Type":"Armor","SubType":"NULL"},
31278: {"Type":"Armor","SubType":"NULL"},
31279: {"Type":"Armor","SubType":"NULL"},
31280: {"Type":"Armor","SubType":"NULL"},
31281: {"Type":"Armor","SubType":"NULL"},
31282: {"Type":"Armor","SubType":"NULL"},
31283: {"Type":"Armor","SubType":"NULL"},
31284: {"Type":"Armor","SubType":"NULL"},
31285: {"Type":"Armor","SubType":"NULL"},
31286: {"Type":"Armor","SubType":"NULL"},
31287: {"Type":"Armor","SubType":"NULL"},
31288: {"Type":"Armor","SubType":"NULL"},
31289: {"Type":"Armor","SubType":"NULL"},
31290: {"Type":"Armor","SubType":"NULL"},
31291: {"Type":"Armor","SubType":"NULL"},
31292: {"Type":"Armor","SubType":"NULL"},
31293: {"Type":"Armor","SubType":"NULL"},
31294: {"Type":"Armor","SubType":"NULL"},
31295: {"Type":"Armor","SubType":"NULL"},
31296: {"Type":"Armor","SubType":"NULL"},
31297: {"Type":"Armor","SubType":"NULL"},
31298: {"Type":"Armor","SubType":"NULL"},
31299: {"Type":"Armor","SubType":"NULL"},
31300: {"Type":"Armor","SubType":"NULL"},
31301: {"Type":"Armor","SubType":"NULL"},
31302: {"Type":"Armor","SubType":"NULL"},
31303: {"Type":"Armor","SubType":"NULL"},
31304: {"Type":"Armor","SubType":"NULL"},
31305: {"Type":"Armor","SubType":"NULL"},
31306: {"Type":"Armor","SubType":"NULL"},
31307: {"Type":"Armor","SubType":"NULL"},
31308: {"Type":"Armor","SubType":"NULL"},
31309: {"Type":"Armor","SubType":"NULL"},
31310: {"Type":"Armor","SubType":"NULL"},
31311: {"Type":"Armor","SubType":"NULL"},
31312: {"Type":"Armor","SubType":"NULL"},
31313: {"Type":"Armor","SubType":"NULL"},
31314: {"Type":"Armor","SubType":"NULL"},
31315: {"Type":"Armor","SubType":"NULL"},
31316: {"Type":"Armor","SubType":"NULL"},
31317: {"Type":"Armor","SubType":"NULL"},
31318: {"Type":"Armor","SubType":"NULL"},
31319: {"Type":"Armor","SubType":"NULL"},
31320: {"Type":"Armor","SubType":"NULL"},
31321: {"Type":"Armor","SubType":"NULL"},
31322: {"Type":"Armor","SubType":"NULL"},
31323: {"Type":"Armor","SubType":"NULL"},
31324: {"Type":"Armor","SubType":"NULL"},
31325: {"Type":"Armor","SubType":"NULL"},
31326: {"Type":"Armor","SubType":"NULL"},
31327: {"Type":"Armor","SubType":"NULL"},
31328: {"Type":"Armor","SubType":"NULL"},
31329: {"Type":"Armor","SubType":"NULL"},
31330: {"Type":"Armor","SubType":"NULL"},
31331: {"Type":"Armor","SubType":"NULL"},
31332: {"Type":"Armor","SubType":"NULL"},
31333: {"Type":"Armor","SubType":"NULL"},
31334: {"Type":"Armor","SubType":"NULL"},
31335: {"Type":"Armor","SubType":"NULL"},
31336: {"Type":"Armor","SubType":"NULL"},
31337: {"Type":"Armor","SubType":"NULL"},
31338: {"Type":"Armor","SubType":"NULL"},
31339: {"Type":"Armor","SubType":"NULL"},
31340: {"Type":"Armor","SubType":"NULL"},
31341: {"Type":"Armor","SubType":"NULL"},
31342: {"Type":"Armor","SubType":"NULL"},
31343: {"Type":"Armor","SubType":"NULL"},
31344: {"Type":"Armor","SubType":"NULL"},
31345: {"Type":"Armor","SubType":"NULL"},
31346: {"Type":"Armor","SubType":"NULL"},
31347: {"Type":"Armor","SubType":"NULL"},
31348: {"Type":"Armor","SubType":"NULL"},
31349: {"Type":"Armor","SubType":"NULL"},
31350: {"Type":"Armor","SubType":"NULL"},
31351: {"Type":"Armor","SubType":"NULL"},
31352: {"Type":"Armor","SubType":"NULL"},
31353: {"Type":"Armor","SubType":"NULL"},
31354: {"Type":"Armor","SubType":"NULL"},
31355: {"Type":"Armor","SubType":"NULL"},
31356: {"Type":"Armor","SubType":"NULL"},
31357: {"Type":"Armor","SubType":"NULL"},
31358: {"Type":"Armor","SubType":"NULL"},
31359: {"Type":"Armor","SubType":"NULL"},
31360: {"Type":"Armor","SubType":"NULL"},
31361: {"Type":"Armor","SubType":"NULL"},
31362: {"Type":"Armor","SubType":"NULL"},
31363: {"Type":"Armor","SubType":"NULL"},
31364: {"Type":"Armor","SubType":"NULL"},
31365: {"Type":"Armor","SubType":"NULL"},
31366: {"Type":"Armor","SubType":"NULL"},
31367: {"Type":"Armor","SubType":"NULL"},
31368: {"Type":"Armor","SubType":"NULL"},
31369: {"Type":"Armor","SubType":"NULL"},
31370: {"Type":"Armor","SubType":"NULL"},
31371: {"Type":"Armor","SubType":"NULL"},
31372: {"Type":"Armor","SubType":"NULL"},
31373: {"Type":"Armor","SubType":"NULL"},
31374: {"Type":"Armor","SubType":"NULL"},
31375: {"Type":"Armor","SubType":"NULL"},
31376: {"Type":"Armor","SubType":"NULL"},
31377: {"Type":"Armor","SubType":"NULL"},
31378: {"Type":"Armor","SubType":"NULL"},
31379: {"Type":"Armor","SubType":"NULL"},
31380: {"Type":"Armor","SubType":"NULL"},
31381: {"Type":"Armor","SubType":"NULL"},
31382: {"Type":"Armor","SubType":"NULL"},
31383: {"Type":"Armor","SubType":"NULL"},
31384: {"Type":"Armor","SubType":"NULL"},
31385: {"Type":"Armor","SubType":"NULL"},
31386: {"Type":"Armor","SubType":"NULL"},
31387: {"Type":"Armor","SubType":"NULL"},
31388: {"Type":"Armor","SubType":"NULL"},
31389: {"Type":"Armor","SubType":"NULL"},
31390: {"Type":"Armor","SubType":"NULL"},
31391: {"Type":"Armor","SubType":"NULL"},
31392: {"Type":"Armor","SubType":"NULL"},
31393: {"Type":"Armor","SubType":"NULL"},
31394: {"Type":"Armor","SubType":"NULL"},
31395: {"Type":"Armor","SubType":"NULL"},
31396: {"Type":"Armor","SubType":"NULL"},
31397: {"Type":"Armor","SubType":"NULL"},
31398: {"Type":"Armor","SubType":"NULL"},
31399: {"Type":"Armor","SubType":"NULL"},
31400: {"Type":"Armor","SubType":"NULL"},
31401: {"Type":"Armor","SubType":"NULL"},
31402: {"Type":"Armor","SubType":"NULL"},
31403: {"Type":"Armor","SubType":"NULL"},
31404: {"Type":"Armor","SubType":"NULL"},
31405: {"Type":"Armor","SubType":"NULL"},
31406: {"Type":"Armor","SubType":"NULL"},
31407: {"Type":"Armor","SubType":"NULL"},
31408: {"Type":"Armor","SubType":"NULL"},
31409: {"Type":"Armor","SubType":"NULL"},
31410: {"Type":"Armor","SubType":"NULL"},
31411: {"Type":"Armor","SubType":"NULL"},
31412: {"Type":"Armor","SubType":"NULL"},
31413: {"Type":"Armor","SubType":"NULL"},
31414: {"Type":"Armor","SubType":"NULL"},
31415: {"Type":"Armor","SubType":"NULL"},
31416: {"Type":"Armor","SubType":"NULL"},
31417: {"Type":"Armor","SubType":"NULL"},
31418: {"Type":"Armor","SubType":"NULL"},
31419: {"Type":"Armor","SubType":"NULL"},
31420: {"Type":"Armor","SubType":"NULL"},
31421: {"Type":"Armor","SubType":"NULL"},
31422: {"Type":"Armor","SubType":"NULL"},
31423: {"Type":"Armor","SubType":"NULL"},
31424: {"Type":"Armor","SubType":"NULL"},
31425: {"Type":"Armor","SubType":"NULL"},
31426: {"Type":"Armor","SubType":"NULL"},
31427: {"Type":"Armor","SubType":"NULL"},
31428: {"Type":"Armor","SubType":"NULL"},
31429: {"Type":"Armor","SubType":"NULL"},
31430: {"Type":"Armor","SubType":"NULL"},
31431: {"Type":"Armor","SubType":"NULL"},
31432: {"Type":"Armor","SubType":"NULL"},
31433: {"Type":"Armor","SubType":"NULL"},
31434: {"Type":"Armor","SubType":"NULL"},
31435: {"Type":"Armor","SubType":"NULL"},
31436: {"Type":"Armor","SubType":"NULL"},
31437: {"Type":"Armor","SubType":"NULL"},
31438: {"Type":"Armor","SubType":"NULL"},
31439: {"Type":"Armor","SubType":"NULL"},
31440: {"Type":"Armor","SubType":"NULL"},
31441: {"Type":"Armor","SubType":"NULL"},
31442: {"Type":"Armor","SubType":"NULL"},
31443: {"Type":"Armor","SubType":"NULL"},
31444: {"Type":"Armor","SubType":"NULL"},
31445: {"Type":"Armor","SubType":"NULL"},
31446: {"Type":"Armor","SubType":"NULL"},
31447: {"Type":"Armor","SubType":"NULL"},
31448: {"Type":"Armor","SubType":"NULL"},
31449: {"Type":"Armor","SubType":"NULL"},
31450: {"Type":"Armor","SubType":"NULL"},
31451: {"Type":"Armor","SubType":"NULL"},
31452: {"Type":"Armor","SubType":"NULL"},
31453: {"Type":"Armor","SubType":"NULL"},
31454: {"Type":"Armor","SubType":"NULL"},
31455: {"Type":"Armor","SubType":"NULL"},
31456: {"Type":"Armor","SubType":"NULL"},
31457: {"Type":"Armor","SubType":"NULL"},
31458: {"Type":"Armor","SubType":"NULL"},
31459: {"Type":"Armor","SubType":"NULL"},
31460: {"Type":"Armor","SubType":"NULL"},
31461: {"Type":"Armor","SubType":"NULL"},
31462: {"Type":"Armor","SubType":"NULL"},
31463: {"Type":"Armor","SubType":"NULL"},
31464: {"Type":"Armor","SubType":"NULL"},
31465: {"Type":"Armor","SubType":"NULL"},
31466: {"Type":"Armor","SubType":"NULL"},
31467: {"Type":"Armor","SubType":"NULL"},
31468: {"Type":"Armor","SubType":"NULL"},
31469: {"Type":"Armor","SubType":"NULL"},
31470: {"Type":"Armor","SubType":"NULL"},
31471: {"Type":"Armor","SubType":"NULL"},
31472: {"Type":"Armor","SubType":"NULL"},
31473: {"Type":"Armor","SubType":"NULL"},
31474: {"Type":"Armor","SubType":"NULL"},
31475: {"Type":"Armor","SubType":"NULL"},
31476: {"Type":"Armor","SubType":"NULL"},
31477: {"Type":"Armor","SubType":"NULL"},
31478: {"Type":"Armor","SubType":"NULL"},
31479: {"Type":"Armor","SubType":"NULL"},
31480: {"Type":"Armor","SubType":"NULL"},
31481: {"Type":"Armor","SubType":"NULL"},
31482: {"Type":"Armor","SubType":"NULL"},
31483: {"Type":"Armor","SubType":"NULL"},
31484: {"Type":"Armor","SubType":"NULL"},
31485: {"Type":"Armor","SubType":"NULL"},
31486: {"Type":"Armor","SubType":"NULL"},
31487: {"Type":"Armor","SubType":"NULL"},
31488: {"Type":"Armor","SubType":"NULL"},
31489: {"Type":"Armor","SubType":"NULL"},
31490: {"Type":"Armor","SubType":"NULL"},
31491: {"Type":"Armor","SubType":"NULL"},
31492: {"Type":"Armor","SubType":"NULL"},
31493: {"Type":"Armor","SubType":"NULL"},
31494: {"Type":"Armor","SubType":"NULL"},
31495: {"Type":"Armor","SubType":"NULL"},
31496: {"Type":"Armor","SubType":"NULL"},
31497: {"Type":"Armor","SubType":"NULL"},
31498: {"Type":"Armor","SubType":"NULL"},
31499: {"Type":"Armor","SubType":"NULL"},
31500: {"Type":"Armor","SubType":"NULL"},
31501: {"Type":"Armor","SubType":"NULL"},
31502: {"Type":"Armor","SubType":"NULL"},
31503: {"Type":"Armor","SubType":"NULL"},
31504: {"Type":"Armor","SubType":"NULL"},
31505: {"Type":"Armor","SubType":"NULL"},
31506: {"Type":"Armor","SubType":"NULL"},
31507: {"Type":"Armor","SubType":"NULL"},
31508: {"Type":"Armor","SubType":"NULL"},
31509: {"Type":"Armor","SubType":"NULL"},
31510: {"Type":"Armor","SubType":"NULL"},
31511: {"Type":"Armor","SubType":"NULL"},
31512: {"Type":"Armor","SubType":"NULL"},
31513: {"Type":"Armor","SubType":"NULL"},
31514: {"Type":"Armor","SubType":"NULL"},
31515: {"Type":"Armor","SubType":"NULL"},
31516: {"Type":"Armor","SubType":"NULL"},
31517: {"Type":"Armor","SubType":"NULL"},
31518: {"Type":"Armor","SubType":"NULL"},
31519: {"Type":"Armor","SubType":"NULL"},
31520: {"Type":"Armor","SubType":"NULL"},
31521: {"Type":"Armor","SubType":"NULL"},
31522: {"Type":"Armor","SubType":"NULL"},
31523: {"Type":"Armor","SubType":"NULL"},
31524: {"Type":"Armor","SubType":"NULL"},
31525: {"Type":"Armor","SubType":"NULL"},
31526: {"Type":"Armor","SubType":"NULL"},
31527: {"Type":"Armor","SubType":"NULL"},
31528: {"Type":"Armor","SubType":"NULL"},
31529: {"Type":"Armor","SubType":"NULL"},
31530: {"Type":"Armor","SubType":"NULL"},
31531: {"Type":"Armor","SubType":"NULL"},
31532: {"Type":"Armor","SubType":"NULL"},
31533: {"Type":"Armor","SubType":"NULL"},
31534: {"Type":"Armor","SubType":"NULL"},
31535: {"Type":"Armor","SubType":"NULL"},
31536: {"Type":"Armor","SubType":"NULL"},
31537: {"Type":"Armor","SubType":"NULL"},
31538: {"Type":"Armor","SubType":"NULL"},
31539: {"Type":"Armor","SubType":"NULL"},
31540: {"Type":"Armor","SubType":"NULL"},
31541: {"Type":"Armor","SubType":"NULL"},
31542: {"Type":"Armor","SubType":"NULL"},
31543: {"Type":"Armor","SubType":"NULL"},
31544: {"Type":"Armor","SubType":"NULL"},
31545: {"Type":"Armor","SubType":"NULL"},
31546: {"Type":"Armor","SubType":"NULL"},
31547: {"Type":"Armor","SubType":"NULL"},
31548: {"Type":"Armor","SubType":"NULL"},
31549: {"Type":"Armor","SubType":"NULL"},
31550: {"Type":"Armor","SubType":"NULL"},
31551: {"Type":"Armor","SubType":"NULL"},
31552: {"Type":"Armor","SubType":"NULL"},
31553: {"Type":"Armor","SubType":"NULL"},
31554: {"Type":"Armor","SubType":"NULL"},
31555: {"Type":"Armor","SubType":"NULL"},
31556: {"Type":"Armor","SubType":"NULL"},
31557: {"Type":"Armor","SubType":"NULL"},
31558: {"Type":"Armor","SubType":"NULL"},
31559: {"Type":"Armor","SubType":"NULL"},
31560: {"Type":"Armor","SubType":"NULL"},
31561: {"Type":"Armor","SubType":"NULL"},
31562: {"Type":"Armor","SubType":"NULL"},
31563: {"Type":"Armor","SubType":"NULL"},
31564: {"Type":"Armor","SubType":"NULL"},
31565: {"Type":"Armor","SubType":"NULL"},
31566: {"Type":"Armor","SubType":"NULL"},
31567: {"Type":"Armor","SubType":"NULL"},
31568: {"Type":"Armor","SubType":"NULL"},
31569: {"Type":"Armor","SubType":"NULL"},
31570: {"Type":"Armor","SubType":"NULL"},
31571: {"Type":"Armor","SubType":"NULL"},
31572: {"Type":"Armor","SubType":"NULL"},
31573: {"Type":"Armor","SubType":"NULL"},
31574: {"Type":"Armor","SubType":"NULL"},
31575: {"Type":"Armor","SubType":"NULL"},
31576: {"Type":"Armor","SubType":"NULL"},
31577: {"Type":"Armor","SubType":"NULL"},
31578: {"Type":"Armor","SubType":"NULL"},
31579: {"Type":"Armor","SubType":"NULL"},
31580: {"Type":"Armor","SubType":"NULL"},
31581: {"Type":"Armor","SubType":"NULL"},
31582: {"Type":"Armor","SubType":"NULL"},
31583: {"Type":"Armor","SubType":"NULL"},
31584: {"Type":"Armor","SubType":"NULL"},
31585: {"Type":"Armor","SubType":"NULL"},
31586: {"Type":"Armor","SubType":"NULL"},
31587: {"Type":"Armor","SubType":"NULL"},
31588: {"Type":"Armor","SubType":"NULL"},
31589: {"Type":"Armor","SubType":"NULL"},
31590: {"Type":"Armor","SubType":"NULL"},
31591: {"Type":"Armor","SubType":"NULL"},
31592: {"Type":"Armor","SubType":"NULL"},
31593: {"Type":"Armor","SubType":"NULL"},
31594: {"Type":"Armor","SubType":"NULL"},
31595: {"Type":"Armor","SubType":"NULL"},
31596: {"Type":"Armor","SubType":"NULL"},
31597: {"Type":"Armor","SubType":"NULL"},
31598: {"Type":"Armor","SubType":"NULL"},
31599: {"Type":"Armor","SubType":"NULL"},
31600: {"Type":"Armor","SubType":"NULL"},
31601: {"Type":"Armor","SubType":"NULL"},
31602: {"Type":"Armor","SubType":"NULL"},
31603: {"Type":"Armor","SubType":"NULL"},
31604: {"Type":"Armor","SubType":"NULL"},
31605: {"Type":"Armor","SubType":"NULL"},
31606: {"Type":"Armor","SubType":"NULL"},
31607: {"Type":"Armor","SubType":"NULL"},
31608: {"Type":"Armor","SubType":"NULL"},
31609: {"Type":"Armor","SubType":"NULL"},
31610: {"Type":"Armor","SubType":"NULL"},
31611: {"Type":"Armor","SubType":"NULL"},
31612: {"Type":"Armor","SubType":"NULL"},
31613: {"Type":"Armor","SubType":"NULL"},
31614: {"Type":"Armor","SubType":"NULL"},
31615: {"Type":"Armor","SubType":"NULL"},
31616: {"Type":"Armor","SubType":"NULL"},
31617: {"Type":"Armor","SubType":"NULL"},
31618: {"Type":"Armor","SubType":"NULL"},
31619: {"Type":"Armor","SubType":"NULL"},
31620: {"Type":"Armor","SubType":"NULL"},
31621: {"Type":"Armor","SubType":"NULL"},
31622: {"Type":"Armor","SubType":"NULL"},
31623: {"Type":"Armor","SubType":"NULL"},
31624: {"Type":"Armor","SubType":"NULL"},
31625: {"Type":"Armor","SubType":"NULL"},
31626: {"Type":"Armor","SubType":"NULL"},
31627: {"Type":"Armor","SubType":"NULL"},
31628: {"Type":"Armor","SubType":"NULL"},
31629: {"Type":"Armor","SubType":"NULL"},
31630: {"Type":"Armor","SubType":"NULL"},
31631: {"Type":"Armor","SubType":"NULL"},
31632: {"Type":"Armor","SubType":"NULL"},
31633: {"Type":"Armor","SubType":"NULL"},
31634: {"Type":"Armor","SubType":"NULL"},
31635: {"Type":"Armor","SubType":"NULL"},
31636: {"Type":"Armor","SubType":"NULL"},
31637: {"Type":"Armor","SubType":"NULL"},
31638: {"Type":"Armor","SubType":"NULL"},
31639: {"Type":"Armor","SubType":"NULL"},
31640: {"Type":"Armor","SubType":"NULL"},
31641: {"Type":"Armor","SubType":"NULL"},
31642: {"Type":"Armor","SubType":"NULL"},
31643: {"Type":"Armor","SubType":"NULL"},
31644: {"Type":"Armor","SubType":"NULL"},
31645: {"Type":"Armor","SubType":"NULL"},
31646: {"Type":"Armor","SubType":"NULL"},
31647: {"Type":"Armor","SubType":"NULL"},
31648: {"Type":"Armor","SubType":"NULL"},
31649: {"Type":"Armor","SubType":"NULL"},
31650: {"Type":"Armor","SubType":"NULL"},
31651: {"Type":"Armor","SubType":"NULL"},
31652: {"Type":"Armor","SubType":"NULL"},
31653: {"Type":"Armor","SubType":"NULL"},
31654: {"Type":"Armor","SubType":"NULL"},
31655: {"Type":"Armor","SubType":"NULL"},
31656: {"Type":"Armor","SubType":"NULL"},
31657: {"Type":"Armor","SubType":"NULL"},
31658: {"Type":"Armor","SubType":"NULL"},
31659: {"Type":"Armor","SubType":"NULL"},
31660: {"Type":"Armor","SubType":"NULL"},
31661: {"Type":"Armor","SubType":"NULL"},
31662: {"Type":"Armor","SubType":"NULL"},
31663: {"Type":"Armor","SubType":"NULL"},
31664: {"Type":"Armor","SubType":"NULL"},
31665: {"Type":"Armor","SubType":"NULL"},
31666: {"Type":"Armor","SubType":"NULL"},
31667: {"Type":"Armor","SubType":"NULL"},
31668: {"Type":"Armor","SubType":"NULL"},
31669: {"Type":"Armor","SubType":"NULL"},
31670: {"Type":"Armor","SubType":"NULL"},
31671: {"Type":"Armor","SubType":"NULL"},
31672: {"Type":"Armor","SubType":"NULL"},
31673: {"Type":"Armor","SubType":"NULL"},
31674: {"Type":"Armor","SubType":"NULL"},
31675: {"Type":"Armor","SubType":"NULL"},
31676: {"Type":"Armor","SubType":"NULL"},
31677: {"Type":"Armor","SubType":"NULL"},
31678: {"Type":"Armor","SubType":"NULL"},
31679: {"Type":"Armor","SubType":"NULL"},
31680: {"Type":"Armor","SubType":"NULL"},
31681: {"Type":"Armor","SubType":"NULL"},
31682: {"Type":"Armor","SubType":"NULL"},
31683: {"Type":"Armor","SubType":"NULL"},
31684: {"Type":"Armor","SubType":"NULL"},
31685: {"Type":"Armor","SubType":"NULL"},
31686: {"Type":"Armor","SubType":"NULL"},
31687: {"Type":"Armor","SubType":"NULL"},
31688: {"Type":"Armor","SubType":"NULL"},
31689: {"Type":"Armor","SubType":"NULL"},
31690: {"Type":"Armor","SubType":"NULL"},
31691: {"Type":"Armor","SubType":"NULL"},
31692: {"Type":"Armor","SubType":"NULL"},
31693: {"Type":"Armor","SubType":"NULL"},
31694: {"Type":"Armor","SubType":"NULL"},
31695: {"Type":"Armor","SubType":"NULL"},
31696: {"Type":"Armor","SubType":"NULL"},
31697: {"Type":"Armor","SubType":"NULL"},
31698: {"Type":"Armor","SubType":"NULL"},
31699: {"Type":"Armor","SubType":"NULL"},
31700: {"Type":"Armor","SubType":"NULL"},
31701: {"Type":"Armor","SubType":"NULL"},
31702: {"Type":"Armor","SubType":"NULL"},
31703: {"Type":"Armor","SubType":"NULL"},
31704: {"Type":"Armor","SubType":"NULL"},
31705: {"Type":"Armor","SubType":"NULL"},
31706: {"Type":"Armor","SubType":"NULL"},
31707: {"Type":"Armor","SubType":"NULL"},
31708: {"Type":"Armor","SubType":"NULL"},
31709: {"Type":"Armor","SubType":"NULL"},
31710: {"Type":"Armor","SubType":"NULL"},
31711: {"Type":"Armor","SubType":"NULL"},
31712: {"Type":"Armor","SubType":"NULL"},
31713: {"Type":"Armor","SubType":"NULL"},
31714: {"Type":"Armor","SubType":"NULL"},
31715: {"Type":"Armor","SubType":"NULL"},
31716: {"Type":"Armor","SubType":"NULL"},
31717: {"Type":"Armor","SubType":"NULL"},
31718: {"Type":"Armor","SubType":"NULL"},
31719: {"Type":"Armor","SubType":"NULL"},
31720: {"Type":"Armor","SubType":"NULL"},
31721: {"Type":"Armor","SubType":"NULL"},
31722: {"Type":"Armor","SubType":"NULL"},
31723: {"Type":"Armor","SubType":"NULL"},
31724: {"Type":"Armor","SubType":"NULL"},
31725: {"Type":"Armor","SubType":"NULL"},
31726: {"Type":"Armor","SubType":"NULL"},
31727: {"Type":"Armor","SubType":"NULL"},
31728: {"Type":"Armor","SubType":"NULL"},
31729: {"Type":"Armor","SubType":"NULL"},
31730: {"Type":"Armor","SubType":"NULL"},
31731: {"Type":"Armor","SubType":"NULL"},
31732: {"Type":"Armor","SubType":"NULL"},
31733: {"Type":"Armor","SubType":"NULL"},
31734: {"Type":"Armor","SubType":"NULL"},
31735: {"Type":"Armor","SubType":"NULL"},
31736: {"Type":"Armor","SubType":"NULL"},
31737: {"Type":"Armor","SubType":"NULL"},
31738: {"Type":"Armor","SubType":"NULL"},
31739: {"Type":"Armor","SubType":"NULL"},
31740: {"Type":"Armor","SubType":"NULL"},
31741: {"Type":"Armor","SubType":"NULL"},
31742: {"Type":"Armor","SubType":"NULL"},
31743: {"Type":"Armor","SubType":"NULL"},
31744: {"Type":"Armor","SubType":"NULL"},
31745: {"Type":"Armor","SubType":"NULL"},
31746: {"Type":"Armor","SubType":"NULL"},
31747: {"Type":"Armor","SubType":"NULL"},
31748: {"Type":"Armor","SubType":"NULL"},
31749: {"Type":"Armor","SubType":"NULL"},
31750: {"Type":"Armor","SubType":"NULL"},
31751: {"Type":"Armor","SubType":"NULL"},
31752: {"Type":"Armor","SubType":"NULL"},
31753: {"Type":"Armor","SubType":"NULL"},
31754: {"Type":"Armor","SubType":"NULL"},
31755: {"Type":"Armor","SubType":"NULL"},
31756: {"Type":"Armor","SubType":"NULL"},
31757: {"Type":"Armor","SubType":"NULL"},
31758: {"Type":"Armor","SubType":"NULL"},
31759: {"Type":"Armor","SubType":"NULL"},
31760: {"Type":"Armor","SubType":"NULL"},
31761: {"Type":"Armor","SubType":"NULL"},
31762: {"Type":"Armor","SubType":"NULL"},
31763: {"Type":"Armor","SubType":"NULL"},
31764: {"Type":"Armor","SubType":"NULL"},
31765: {"Type":"Armor","SubType":"NULL"},
31766: {"Type":"Armor","SubType":"NULL"},
31767: {"Type":"Armor","SubType":"NULL"},
31768: {"Type":"Armor","SubType":"NULL"},
31769: {"Type":"Armor","SubType":"NULL"},
31770: {"Type":"Armor","SubType":"NULL"},
31771: {"Type":"Armor","SubType":"NULL"},
31772: {"Type":"Armor","SubType":"NULL"},
31773: {"Type":"Armor","SubType":"NULL"},
31774: {"Type":"Armor","SubType":"NULL"},
31775: {"Type":"Armor","SubType":"NULL"},
31776: {"Type":"Armor","SubType":"NULL"},
31777: {"Type":"Armor","SubType":"NULL"},
31778: {"Type":"Armor","SubType":"NULL"},
31779: {"Type":"Armor","SubType":"NULL"},
31780: {"Type":"Armor","SubType":"NULL"},
31781: {"Type":"Armor","SubType":"NULL"},
31782: {"Type":"Armor","SubType":"NULL"},
31783: {"Type":"Armor","SubType":"NULL"},
31784: {"Type":"Armor","SubType":"NULL"},
31785: {"Type":"Armor","SubType":"NULL"},
31786: {"Type":"Armor","SubType":"NULL"},
31787: {"Type":"Armor","SubType":"NULL"},
31788: {"Type":"Armor","SubType":"NULL"},
31789: {"Type":"Armor","SubType":"NULL"},
31790: {"Type":"Armor","SubType":"NULL"},
31791: {"Type":"Armor","SubType":"NULL"},
31792: {"Type":"Armor","SubType":"NULL"},
31793: {"Type":"Armor","SubType":"NULL"},
31794: {"Type":"Armor","SubType":"NULL"},
31795: {"Type":"Armor","SubType":"NULL"},
31796: {"Type":"Armor","SubType":"NULL"},
31797: {"Type":"Armor","SubType":"NULL"},
31798: {"Type":"Armor","SubType":"NULL"},
31799: {"Type":"Armor","SubType":"NULL"},
31800: {"Type":"Armor","SubType":"NULL"},
31801: {"Type":"Armor","SubType":"NULL"},
31802: {"Type":"Armor","SubType":"NULL"},
31803: {"Type":"Armor","SubType":"NULL"},
31804: {"Type":"Armor","SubType":"NULL"},
31805: {"Type":"Armor","SubType":"NULL"},
31806: {"Type":"Armor","SubType":"NULL"},
31807: {"Type":"Armor","SubType":"NULL"},
31808: {"Type":"Armor","SubType":"NULL"},
31809: {"Type":"Armor","SubType":"NULL"},
31810: {"Type":"Armor","SubType":"NULL"},
31811: {"Type":"Armor","SubType":"NULL"},
31812: {"Type":"Armor","SubType":"NULL"},
31813: {"Type":"Armor","SubType":"NULL"},
31814: {"Type":"Armor","SubType":"NULL"},
31815: {"Type":"Armor","SubType":"NULL"},
31816: {"Type":"Armor","SubType":"NULL"},
31817: {"Type":"Armor","SubType":"NULL"},
31818: {"Type":"Armor","SubType":"NULL"},
31819: {"Type":"Armor","SubType":"NULL"},
31820: {"Type":"Armor","SubType":"NULL"},
31821: {"Type":"Armor","SubType":"NULL"},
31822: {"Type":"Armor","SubType":"NULL"},
31823: {"Type":"Armor","SubType":"NULL"},
31824: {"Type":"Armor","SubType":"NULL"},
31825: {"Type":"Armor","SubType":"NULL"},
31826: {"Type":"Armor","SubType":"NULL"},
31827: {"Type":"Armor","SubType":"NULL"},
31828: {"Type":"Armor","SubType":"NULL"},
31829: {"Type":"Armor","SubType":"NULL"},
31830: {"Type":"Armor","SubType":"NULL"},
31831: {"Type":"Armor","SubType":"NULL"},
31832: {"Type":"Armor","SubType":"NULL"},
31833: {"Type":"Armor","SubType":"NULL"},
31834: {"Type":"Armor","SubType":"NULL"},
31835: {"Type":"Armor","SubType":"NULL"},
31836: {"Type":"Armor","SubType":"NULL"},
31837: {"Type":"Armor","SubType":"NULL"},
31838: {"Type":"Armor","SubType":"NULL"},
31839: {"Type":"Armor","SubType":"NULL"},
31840: {"Type":"Armor","SubType":"NULL"},
31841: {"Type":"Armor","SubType":"NULL"},
31842: {"Type":"Armor","SubType":"NULL"},
31843: {"Type":"Armor","SubType":"NULL"},
31844: {"Type":"Armor","SubType":"NULL"},
31845: {"Type":"Armor","SubType":"NULL"},
31846: {"Type":"Armor","SubType":"NULL"},
31847: {"Type":"Armor","SubType":"NULL"},
31848: {"Type":"Armor","SubType":"NULL"},
31849: {"Type":"Armor","SubType":"NULL"},
31850: {"Type":"Armor","SubType":"NULL"},
31851: {"Type":"Armor","SubType":"NULL"},
31852: {"Type":"Armor","SubType":"NULL"},
31853: {"Type":"Armor","SubType":"NULL"},
31854: {"Type":"Armor","SubType":"NULL"},
31855: {"Type":"Armor","SubType":"NULL"},
31856: {"Type":"Armor","SubType":"NULL"},
31857: {"Type":"Armor","SubType":"NULL"},
31858: {"Type":"Armor","SubType":"NULL"},
31859: {"Type":"Armor","SubType":"NULL"},
31860: {"Type":"Armor","SubType":"NULL"},
31861: {"Type":"Armor","SubType":"NULL"},
31862: {"Type":"Armor","SubType":"NULL"},
31863: {"Type":"Armor","SubType":"NULL"},
31864: {"Type":"Armor","SubType":"NULL"},
31865: {"Type":"Armor","SubType":"NULL"},
31866: {"Type":"Armor","SubType":"NULL"},
31867: {"Type":"Armor","SubType":"NULL"},
31868: {"Type":"Armor","SubType":"NULL"},
31869: {"Type":"Armor","SubType":"NULL"},
31870: {"Type":"Armor","SubType":"NULL"},
31871: {"Type":"Armor","SubType":"NULL"},
31872: {"Type":"Armor","SubType":"NULL"},
31873: {"Type":"Armor","SubType":"NULL"},
31874: {"Type":"Armor","SubType":"NULL"},
31875: {"Type":"Armor","SubType":"NULL"},
31876: {"Type":"Armor","SubType":"NULL"},
31877: {"Type":"Armor","SubType":"NULL"},
31878: {"Type":"Armor","SubType":"NULL"},
31879: {"Type":"Armor","SubType":"NULL"},
31880: {"Type":"Armor","SubType":"NULL"},
31881: {"Type":"Armor","SubType":"NULL"},
31882: {"Type":"Armor","SubType":"NULL"},
31883: {"Type":"Armor","SubType":"NULL"},
31884: {"Type":"Armor","SubType":"NULL"},
31885: {"Type":"Armor","SubType":"NULL"},
31886: {"Type":"Armor","SubType":"NULL"},
31887: {"Type":"Armor","SubType":"NULL"},
31888: {"Type":"Armor","SubType":"NULL"},
31889: {"Type":"Armor","SubType":"NULL"},
31890: {"Type":"Armor","SubType":"NULL"},
31891: {"Type":"Armor","SubType":"NULL"},
31892: {"Type":"Armor","SubType":"NULL"},
31893: {"Type":"Armor","SubType":"NULL"},
31894: {"Type":"Armor","SubType":"NULL"},
31895: {"Type":"Armor","SubType":"NULL"},
31896: {"Type":"Armor","SubType":"NULL"},
31897: {"Type":"Armor","SubType":"NULL"},
31898: {"Type":"Armor","SubType":"NULL"},
31899: {"Type":"Armor","SubType":"NULL"},
31900: {"Type":"Armor","SubType":"NULL"},
31901: {"Type":"Armor","SubType":"NULL"},
31902: {"Type":"Armor","SubType":"NULL"},
31903: {"Type":"Armor","SubType":"NULL"},
31904: {"Type":"Armor","SubType":"NULL"},
31905: {"Type":"Armor","SubType":"NULL"},
31906: {"Type":"Armor","SubType":"NULL"},
31907: {"Type":"Armor","SubType":"NULL"},
31908: {"Type":"Armor","SubType":"NULL"},
31909: {"Type":"Armor","SubType":"NULL"},
31910: {"Type":"Armor","SubType":"NULL"},
31911: {"Type":"Armor","SubType":"NULL"},
31912: {"Type":"Armor","SubType":"NULL"},
31913: {"Type":"Armor","SubType":"NULL"},
31914: {"Type":"Armor","SubType":"NULL"},
31915: {"Type":"Armor","SubType":"NULL"},
31916: {"Type":"Armor","SubType":"NULL"},
31917: {"Type":"Armor","SubType":"NULL"},
31918: {"Type":"Armor","SubType":"NULL"},
31919: {"Type":"Armor","SubType":"NULL"},
31920: {"Type":"Armor","SubType":"NULL"},
31921: {"Type":"Armor","SubType":"NULL"},
31922: {"Type":"Armor","SubType":"NULL"},
31923: {"Type":"Armor","SubType":"NULL"},
31924: {"Type":"Armor","SubType":"NULL"},
31925: {"Type":"Armor","SubType":"NULL"},
31926: {"Type":"Armor","SubType":"NULL"},
31927: {"Type":"Armor","SubType":"NULL"},
31928: {"Type":"Armor","SubType":"NULL"},
31929: {"Type":"Armor","SubType":"NULL"},
31930: {"Type":"Armor","SubType":"NULL"},
31931: {"Type":"Armor","SubType":"NULL"},
31932: {"Type":"Armor","SubType":"NULL"},
31933: {"Type":"Armor","SubType":"NULL"},
31934: {"Type":"Armor","SubType":"NULL"},
31935: {"Type":"Armor","SubType":"NULL"},
31936: {"Type":"Armor","SubType":"NULL"},
31937: {"Type":"Armor","SubType":"NULL"},
31938: {"Type":"Armor","SubType":"NULL"},
31939: {"Type":"Armor","SubType":"NULL"},
31940: {"Type":"Armor","SubType":"NULL"},
31941: {"Type":"Armor","SubType":"NULL"},
31942: {"Type":"Armor","SubType":"NULL"},
31943: {"Type":"Armor","SubType":"NULL"},
31944: {"Type":"Armor","SubType":"NULL"},
31945: {"Type":"Armor","SubType":"NULL"},
31946: {"Type":"Armor","SubType":"NULL"},
31947: {"Type":"Armor","SubType":"NULL"},
31948: {"Type":"Armor","SubType":"NULL"},
31949: {"Type":"Armor","SubType":"NULL"},
31950: {"Type":"Armor","SubType":"NULL"},
31951: {"Type":"Armor","SubType":"NULL"},
31952: {"Type":"Armor","SubType":"NULL"},
31953: {"Type":"Armor","SubType":"NULL"},
31954: {"Type":"Armor","SubType":"NULL"},
31955: {"Type":"Armor","SubType":"NULL"},
31956: {"Type":"Armor","SubType":"NULL"},
31957: {"Type":"Armor","SubType":"NULL"},
31958: {"Type":"Armor","SubType":"NULL"},
31959: {"Type":"Armor","SubType":"NULL"},
31960: {"Type":"Armor","SubType":"NULL"},
31961: {"Type":"Armor","SubType":"NULL"},
31962: {"Type":"Armor","SubType":"NULL"},
31963: {"Type":"Armor","SubType":"NULL"},
31964: {"Type":"Armor","SubType":"NULL"},
31965: {"Type":"Armor","SubType":"NULL"},
31966: {"Type":"Armor","SubType":"NULL"},
31967: {"Type":"Armor","SubType":"NULL"},
31968: {"Type":"Armor","SubType":"NULL"},
31969: {"Type":"Armor","SubType":"NULL"},
31970: {"Type":"Armor","SubType":"NULL"},
31971: {"Type":"Armor","SubType":"NULL"},
31972: {"Type":"Armor","SubType":"NULL"},
31973: {"Type":"Armor","SubType":"NULL"},
31974: {"Type":"Armor","SubType":"NULL"},
31975: {"Type":"Armor","SubType":"NULL"},
31976: {"Type":"Armor","SubType":"NULL"},
31977: {"Type":"Armor","SubType":"NULL"},
31978: {"Type":"Armor","SubType":"NULL"},
31979: {"Type":"Armor","SubType":"NULL"},
31980: {"Type":"Armor","SubType":"NULL"},
32000: {"Type":"Weapon","SubType":"1hSpear"},
32001: {"Type":"Weapon","SubType":"1hSpear"},
32002: {"Type":"Weapon","SubType":"1hSpear"},
32003: {"Type":"Weapon","SubType":"1hSpear"},
32004: {"Type":"Weapon","SubType":"1hSpear"},
32005: {"Type":"Weapon","SubType":"1hSpear"},
32007: {"Type":"Weapon","SubType":"1hSpear"},
32012: {"Type":"Weapon","SubType":"1hSpear"},
32013: {"Type":"Weapon","SubType":"1hSpear"},
32014: {"Type":"Weapon","SubType":"1hSpear"},
32015: {"Type":"Weapon","SubType":"1hSpear"},
32017: {"Type":"Weapon","SubType":"1hSpear"},
32018: {"Type":"Weapon","SubType":"1hSpear"},
32019: {"Type":"Weapon","SubType":"1hSpear"},
32021: {"Type":"Weapon","SubType":"1hSpear"},
32023: {"Type":"Weapon","SubType":"1hSpear"},
32024: {"Type":"Weapon","SubType":"1hSpear"},
32025: {"Type":"Weapon","SubType":"1hSpear"},
32026: {"Type":"Weapon","SubType":"1hSpear"},
32027: {"Type":"Weapon","SubType":"1hSpear"},
32028: {"Type":"Weapon","SubType":"1hSpear"},
32029: {"Type":"Weapon","SubType":"1hSpear"},
32030: {"Type":"Weapon","SubType":"1hSpear"},
32031: {"Type":"Weapon","SubType":"1hSpear"},
32034: {"Type":"Weapon","SubType":"1hSpear"},
32101: {"Type":"Weapon","SubType":"Musical"},
32102: {"Type":"Weapon","SubType":"Musical"},
32103: {"Type":"Weapon","SubType":"Musical"},
32104: {"Type":"Weapon","SubType":"Musical"},
32105: {"Type":"Weapon","SubType":"Musical"},
32106: {"Type":"Weapon","SubType":"Whip"},
32107: {"Type":"Weapon","SubType":"Musical"},
32108: {"Type":"Weapon","SubType":"Musical"},
32110: {"Type":"Weapon","SubType":"Musical"},
32111: {"Type":"Weapon","SubType":"Musical"},
32112: {"Type":"Weapon","SubType":"Musical"},
32113: {"Type":"Weapon","SubType":"Musical"},
32117: {"Type":"Weapon","SubType":"Musical"},
32202: {"Type":"Armor","SubType":"NULL"},
32203: {"Type":"Armor","SubType":"NULL"},
32204: {"Type":"Armor","SubType":"NULL"},
32206: {"Type":"Armor","SubType":"NULL"},
32207: {"Type":"Armor","SubType":"NULL"},
32208: {"Type":"Armor","SubType":"NULL"},
32209: {"Type":"Armor","SubType":"NULL"},
32210: {"Type":"Armor","SubType":"NULL"},
32219: {"Type":"Armor","SubType":"NULL"},
32221: {"Type":"Armor","SubType":"NULL"},
32222: {"Type":"Armor","SubType":"NULL"},
32227: {"Type":"Armor","SubType":"NULL"},
32228: {"Type":"Armor","SubType":"NULL"},
32229: {"Type":"Armor","SubType":"NULL"},
32230: {"Type":"Armor","SubType":"NULL"},
32231: {"Type":"Armor","SubType":"NULL"},
32232: {"Type":"Armor","SubType":"NULL"},
32233: {"Type":"Armor","SubType":"NULL"},
32234: {"Type":"Armor","SubType":"NULL"},
32237: {"Type":"Armor","SubType":"NULL"},
32238: {"Type":"Armor","SubType":"NULL"},
32239: {"Type":"Armor","SubType":"NULL"},
32242: {"Type":"Armor","SubType":"NULL"},
32243: {"Type":"Armor","SubType":"NULL"},
32245: {"Type":"Armor","SubType":"NULL"},
32246: {"Type":"Armor","SubType":"NULL"},
32247: {"Type":"Armor","SubType":"NULL"},
32248: {"Type":"Armor","SubType":"NULL"},
32249: {"Type":"Armor","SubType":"NULL"},
32250: {"Type":"Armor","SubType":"NULL"},
32251: {"Type":"Armor","SubType":"NULL"},
32252: {"Type":"Armor","SubType":"NULL"},
32253: {"Type":"Armor","SubType":"NULL"},
32258: {"Type":"Armor","SubType":"NULL"},
32259: {"Type":"Armor","SubType":"NULL"},
32261: {"Type":"Armor","SubType":"NULL"},
32262: {"Type":"Armor","SubType":"NULL"},
32263: {"Type":"Armor","SubType":"NULL"},
32264: {"Type":"Armor","SubType":"NULL"},
32265: {"Type":"Armor","SubType":"NULL"},
32266: {"Type":"Armor","SubType":"NULL"},
32267: {"Type":"Armor","SubType":"NULL"},
32270: {"Type":"Armor","SubType":"NULL"},
32278: {"Type":"Armor","SubType":"NULL"},
32281: {"Type":"Armor","SubType":"NULL"},
32282: {"Type":"Armor","SubType":"NULL"},
32285: {"Type":"Armor","SubType":"NULL"},
32286: {"Type":"Armor","SubType":"NULL"},
32287: {"Type":"Armor","SubType":"NULL"},
32288: {"Type":"Armor","SubType":"NULL"},
32293: {"Type":"Armor","SubType":"NULL"},
32294: {"Type":"Armor","SubType":"NULL"},
32295: {"Type":"Armor","SubType":"NULL"},
32296: {"Type":"Armor","SubType":"NULL"},
32300: {"Type":"Weapon","SubType":"Revolve"},
32301: {"Type":"Weapon","SubType":"Revolve"},
32302: {"Type":"Weapon","SubType":"Revolve"},
32303: {"Type":"Weapon","SubType":"Revolve"},
32304: {"Type":"Weapon","SubType":"Revolve"},
32305: {"Type":"Weapon","SubType":"Revolve"},
32350: {"Type":"Weapon","SubType":"1hSword"},
32351: {"Type":"Weapon","SubType":"1hSword"},
32352: {"Type":"Weapon","SubType":"1hSword"},
32353: {"Type":"Weapon","SubType":"1hSword"},
32354: {"Type":"Weapon","SubType":"1hSword"},
32355: {"Type":"Weapon","SubType":"1hSword"},
32358: {"Type":"Weapon","SubType":"1hSword"},
32401: {"Type":"Weapon","SubType":"Mace"},
32402: {"Type":"Weapon","SubType":"Mace"},
32403: {"Type":"Weapon","SubType":"Mace"},
32404: {"Type":"Weapon","SubType":"Mace"},
32405: {"Type":"Weapon","SubType":"Mace"},
32406: {"Type":"Weapon","SubType":"Mace"},
32407: {"Type":"Weapon","SubType":"Mace"},
32408: {"Type":"Weapon","SubType":"Mace"},
100000: {"Type":"DelayConsume","SubType":"NULL"},
100002: {"Type":"Usable","SubType":"NULL"},
100003: {"Type":"DelayConsume","SubType":"NULL"},
100004: {"Type":"DelayConsume","SubType":"NULL"},
100005: {"Type":"Usable","SubType":"NULL"},
100006: {"Type":"Usable","SubType":"NULL"},
100007: {"Type":"Usable","SubType":"NULL"},
100008: {"Type":"Usable","SubType":"NULL"},
100009: {"Type":"DelayConsume","SubType":"NULL"},
100010: {"Type":"DelayConsume","SubType":"NULL"},
100011: {"Type":"DelayConsume","SubType":"NULL"},
100019: {"Type":"Usable","SubType":"NULL"},
100020: {"Type":"Usable","SubType":"NULL"},
100021: {"Type":"Usable","SubType":"NULL"},
100022: {"Type":"Usable","SubType":"NULL"},
100023: {"Type":"DelayConsume","SubType":"NULL"},
100024: {"Type":"Usable","SubType":"NULL"},
100025: {"Type":"DelayConsume","SubType":"NULL"},
100026: {"Type":"Usable","SubType":"NULL"},
100029: {"Type":"Usable","SubType":"NULL"},
100030: {"Type":"Usable","SubType":"NULL"},
100031: {"Type":"Usable","SubType":"NULL"},
100032: {"Type":"Usable","SubType":"NULL"},
100033: {"Type":"Usable","SubType":"NULL"},
100034: {"Type":"Usable","SubType":"NULL"},
100035: {"Type":"Usable","SubType":"NULL"},
100036: {"Type":"Usable","SubType":"NULL"},
100037: {"Type":"Usable","SubType":"NULL"},
100038: {"Type":"Usable","SubType":"NULL"},
100039: {"Type":"Usable","SubType":"NULL"},
100040: {"Type":"Usable","SubType":"NULL"},
100041: {"Type":"Usable","SubType":"NULL"},
100043: {"Type":"DelayConsume","SubType":"NULL"},
100044: {"Type":"DelayConsume","SubType":"NULL"},
100045: {"Type":"Usable","SubType":"NULL"},
100046: {"Type":"Usable","SubType":"NULL"},
100047: {"Type":"Usable","SubType":"NULL"},
100048: {"Type":"Usable","SubType":"NULL"},
100049: {"Type":"Usable","SubType":"NULL"},
100050: {"Type":"Usable","SubType":"NULL"},
100051: {"Type":"Usable","SubType":"NULL"},
100052: {"Type":"Usable","SubType":"NULL"},
100053: {"Type":"DelayConsume","SubType":"NULL"},
100054: {"Type":"Usable","SubType":"NULL"},
100058: {"Type":"DelayConsume","SubType":"NULL"},
100060: {"Type":"DelayConsume","SubType":"NULL"},
100061: {"Type":"Usable","SubType":"NULL"},
100065: {"Type":"DelayConsume","SubType":"NULL"},
100066: {"Type":"DelayConsume","SubType":"NULL"},
100067: {"Type":"DelayConsume","SubType":"NULL"},
100068: {"Type":"DelayConsume","SubType":"NULL"},
100069: {"Type":"DelayConsume","SubType":"NULL"},
100070: {"Type":"DelayConsume","SubType":"NULL"},
100071: {"Type":"DelayConsume","SubType":"NULL"},
100072: {"Type":"DelayConsume","SubType":"NULL"},
100073: {"Type":"DelayConsume","SubType":"NULL"},
100074: {"Type":"DelayConsume","SubType":"NULL"},
100075: {"Type":"Usable","SubType":"NULL"},
100076: {"Type":"Usable","SubType":"NULL"},
100077: {"Type":"Usable","SubType":"NULL"},
100078: {"Type":"Usable","SubType":"NULL"},
100079: {"Type":"Usable","SubType":"NULL"},
100080: {"Type":"Usable","SubType":"NULL"},
100081: {"Type":"Usable","SubType":"NULL"},
100083: {"Type":"Usable","SubType":"NULL"},
100087: {"Type":"Cash","SubType":"NULL"},
100098: {"Type":"Usable","SubType":"NULL"},
100100: {"Type":"Usable","SubType":"NULL"},
100109: {"Type":"Usable","SubType":"NULL"},
100125: {"Type":"DelayConsume","SubType":"NULL"},
100127: {"Type":"Usable","SubType":"NULL"},
100128: {"Type":"DelayConsume","SubType":"NULL"},
100129: {"Type":"DelayConsume","SubType":"NULL"},
100130: {"Type":"DelayConsume","SubType":"NULL"},
100131: {"Type":"DelayConsume","SubType":"NULL"},
100132: {"Type":"DelayConsume","SubType":"NULL"},
100133: {"Type":"DelayConsume","SubType":"NULL"},
100134: {"Type":"DelayConsume","SubType":"NULL"},
100135: {"Type":"DelayConsume","SubType":"NULL"},
100136: {"Type":"DelayConsume","SubType":"NULL"},
100137: {"Type":"DelayConsume","SubType":"NULL"},
100138: {"Type":"DelayConsume","SubType":"NULL"},
100142: {"Type":"DelayConsume","SubType":"NULL"},
100144: {"Type":"DelayConsume","SubType":"NULL"},
100145: {"Type":"DelayConsume","SubType":"NULL"},
100147: {"Type":"Usable","SubType":"NULL"},
100148: {"Type":"Usable","SubType":"NULL"},
100149: {"Type":"Usable","SubType":"NULL"},
100150: {"Type":"Usable","SubType":"NULL"},
100151: {"Type":"DelayConsume","SubType":"NULL"},
100152: {"Type":"Usable","SubType":"NULL"},
100153: {"Type":"Usable","SubType":"NULL"},
100158: {"Type":"Usable","SubType":"NULL"},
100160: {"Type":"Usable","SubType":"NULL"},
100161: {"Type":"Usable","SubType":"NULL"},
100162: {"Type":"Usable","SubType":"NULL"},
100163: {"Type":"Usable","SubType":"NULL"},
100164: {"Type":"DelayConsume","SubType":"NULL"},
100165: {"Type":"DelayConsume","SubType":"NULL"},
100166: {"Type":"DelayConsume","SubType":"NULL"},
100167: {"Type":"DelayConsume","SubType":"NULL"},
100168: {"Type":"DelayConsume","SubType":"NULL"},
100169: {"Type":"DelayConsume","SubType":"NULL"},
100170: {"Type":"Usable","SubType":"NULL"},
100171: {"Type":"Usable","SubType":"NULL"},
100172: {"Type":"Usable","SubType":"NULL"},
100173: {"Type":"Usable","SubType":"NULL"},
100174: {"Type":"Usable","SubType":"NULL"},
100176: {"Type":"Usable","SubType":"NULL"},
100177: {"Type":"Usable","SubType":"NULL"},
100178: {"Type":"Usable","SubType":"NULL"},
100179: {"Type":"Usable","SubType":"NULL"},
100180: {"Type":"Usable","SubType":"NULL"},
100181: {"Type":"Usable","SubType":"NULL"},
100182: {"Type":"Usable","SubType":"NULL"},
100183: {"Type":"Usable","SubType":"NULL"},
100184: {"Type":"Usable","SubType":"NULL"},
100185: {"Type":"Usable","SubType":"NULL"},
100186: {"Type":"Usable","SubType":"NULL"},
100187: {"Type":"Usable","SubType":"NULL"},
100188: {"Type":"Usable","SubType":"NULL"},
100189: {"Type":"Usable","SubType":"NULL"},
100190: {"Type":"Usable","SubType":"NULL"},
100191: {"Type":"Usable","SubType":"NULL"},
100192: {"Type":"Usable","SubType":"NULL"},
100193: {"Type":"Usable","SubType":"NULL"},
100194: {"Type":"Usable","SubType":"NULL"},
100195: {"Type":"Usable","SubType":"NULL"},
100196: {"Type":"Usable","SubType":"NULL"},
100197: {"Type":"Usable","SubType":"NULL"},
100198: {"Type":"Usable","SubType":"NULL"},
100202: {"Type":"Usable","SubType":"NULL"},
100205: {"Type":"DelayConsume","SubType":"NULL"},
100206: {"Type":"DelayConsume","SubType":"NULL"},
100207: {"Type":"DelayConsume","SubType":"NULL"},
100208: {"Type":"DelayConsume","SubType":"NULL"},
100209: {"Type":"DelayConsume","SubType":"NULL"},
100210: {"Type":"DelayConsume","SubType":"NULL"},
100211: {"Type":"DelayConsume","SubType":"NULL"},
100212: {"Type":"DelayConsume","SubType":"NULL"},
100213: {"Type":"DelayConsume","SubType":"NULL"},
100214: {"Type":"Usable","SubType":"NULL"},
100215: {"Type":"Usable","SubType":"NULL"},
100231: {"Type":"Healing","SubType":"NULL"},
100232: {"Type":"Healing","SubType":"NULL"},
100233: {"Type":"Healing","SubType":"NULL"},
100251: {"Type":"DelayConsume","SubType":"NULL"},
100252: {"Type":"DelayConsume","SubType":"NULL"},
100253: {"Type":"Usable","SubType":"NULL"},
100268: {"Type":"DelayConsume","SubType":"NULL"},
100269: {"Type":"DelayConsume","SubType":"NULL"},
100270: {"Type":"DelayConsume","SubType":"NULL"},
100271: {"Type":"DelayConsume","SubType":"NULL"},
100272: {"Type":"DelayConsume","SubType":"NULL"},
100273: {"Type":"DelayConsume","SubType":"NULL"},
100274: {"Type":"DelayConsume","SubType":"NULL"},
100275: {"Type":"DelayConsume","SubType":"NULL"},
100276: {"Type":"DelayConsume","SubType":"NULL"},
100277: {"Type":"DelayConsume","SubType":"NULL"},
100314: {"Type":"Usable","SubType":"NULL"},
100316: {"Type":"Usable","SubType":"NULL"},
100317: {"Type":"Usable","SubType":"NULL"},
100319: {"Type":"Usable","SubType":"NULL"},
100321: {"Type":"DelayConsume","SubType":"NULL"},
100322: {"Type":"DelayConsume","SubType":"NULL"},
100323: {"Type":"Usable","SubType":"NULL"},
100324: {"Type":"Usable","SubType":"NULL"},
100325: {"Type":"Usable","SubType":"NULL"},
100326: {"Type":"Usable","SubType":"NULL"},
100327: {"Type":"DelayConsume","SubType":"NULL"},
100328: {"Type":"DelayConsume","SubType":"NULL"},
100329: {"Type":"DelayConsume","SubType":"NULL"},
100330: {"Type":"DelayConsume","SubType":"NULL"},
100331: {"Type":"DelayConsume","SubType":"NULL"},
100332: {"Type":"Usable","SubType":"NULL"},
100333: {"Type":"Usable","SubType":"NULL"},
100335: {"Type":"Usable","SubType":"NULL"},
100336: {"Type":"Usable","SubType":"NULL"},
100337: {"Type":"Usable","SubType":"NULL"},
100338: {"Type":"DelayConsume","SubType":"NULL"},
100339: {"Type":"DelayConsume","SubType":"NULL"},
100340: {"Type":"DelayConsume","SubType":"NULL"},
100341: {"Type":"DelayConsume","SubType":"NULL"},
100342: {"Type":"Usable","SubType":"NULL"},
100343: {"Type":"Usable","SubType":"NULL"},
100344: {"Type":"Usable","SubType":"NULL"},
100345: {"Type":"Usable","SubType":"NULL"},
100346: {"Type":"Usable","SubType":"NULL"},
100347: {"Type":"Usable","SubType":"NULL"},
100351: {"Type":"Usable","SubType":"NULL"},
100352: {"Type":"Usable","SubType":"NULL"},
100354: {"Type":"DelayConsume","SubType":"NULL"},
100355: {"Type":"DelayConsume","SubType":"NULL"},
100356: {"Type":"Usable","SubType":"NULL"},
100357: {"Type":"Usable","SubType":"NULL"},
100358: {"Type":"Usable","SubType":"NULL"},
100359: {"Type":"Usable","SubType":"NULL"},
100360: {"Type":"DelayConsume","SubType":"NULL"},
100361: {"Type":"DelayConsume","SubType":"NULL"},
100362: {"Type":"DelayConsume","SubType":"NULL"},
100363: {"Type":"DelayConsume","SubType":"NULL"},
100365: {"Type":"DelayConsume","SubType":"NULL"},
100366: {"Type":"DelayConsume","SubType":"NULL"},
100367: {"Type":"DelayConsume","SubType":"NULL"},
100368: {"Type":"DelayConsume","SubType":"NULL"},
100371: {"Type":"Usable","SubType":"NULL"},
100372: {"Type":"Usable","SubType":"NULL"},
100373: {"Type":"Usable","SubType":"NULL"},
100374: {"Type":"Usable","SubType":"NULL"},
100375: {"Type":"Usable","SubType":"NULL"},
100376: {"Type":"DelayConsume","SubType":"NULL"},
100377: {"Type":"DelayConsume","SubType":"NULL"},
100378: {"Type":"DelayConsume","SubType":"NULL"},
100379: {"Type":"DelayConsume","SubType":"NULL"},
100381: {"Type":"DelayConsume","SubType":"NULL"},
100382: {"Type":"DelayConsume","SubType":"NULL"},
100383: {"Type":"DelayConsume","SubType":"NULL"},
100384: {"Type":"DelayConsume","SubType":"NULL"},
100385: {"Type":"DelayConsume","SubType":"NULL"},
100386: {"Type":"DelayConsume","SubType":"NULL"},
100387: {"Type":"DelayConsume","SubType":"NULL"},
100388: {"Type":"DelayConsume","SubType":"NULL"},
100390: {"Type":"DelayConsume","SubType":"NULL"},
100391: {"Type":"DelayConsume","SubType":"NULL"},
100392: {"Type":"DelayConsume","SubType":"NULL"},
100393: {"Type":"DelayConsume","SubType":"NULL"},
100394: {"Type":"DelayConsume","SubType":"NULL"},
100395: {"Type":"DelayConsume","SubType":"NULL"},
100396: {"Type":"DelayConsume","SubType":"NULL"},
100397: {"Type":"DelayConsume","SubType":"NULL"},
100398: {"Type":"DelayConsume","SubType":"NULL"},
100399: {"Type":"DelayConsume","SubType":"NULL"},
100400: {"Type":"DelayConsume","SubType":"NULL"},
100401: {"Type":"DelayConsume","SubType":"NULL"},
100402: {"Type":"DelayConsume","SubType":"NULL"},
100403: {"Type":"DelayConsume","SubType":"NULL"},
100404: {"Type":"DelayConsume","SubType":"NULL"},
100405: {"Type":"DelayConsume","SubType":"NULL"},
100406: {"Type":"DelayConsume","SubType":"NULL"},
100407: {"Type":"DelayConsume","SubType":"NULL"},
100408: {"Type":"DelayConsume","SubType":"NULL"},
100412: {"Type":"DelayConsume","SubType":"NULL"},
100413: {"Type":"DelayConsume","SubType":"NULL"},
100414: {"Type":"DelayConsume","SubType":"NULL"},
100415: {"Type":"DelayConsume","SubType":"NULL"},
100416: {"Type":"DelayConsume","SubType":"NULL"},
100417: {"Type":"DelayConsume","SubType":"NULL"},
100418: {"Type":"DelayConsume","SubType":"NULL"},
100419: {"Type":"DelayConsume","SubType":"NULL"},
100420: {"Type":"DelayConsume","SubType":"NULL"},
100421: {"Type":"DelayConsume","SubType":"NULL"},
100422: {"Type":"DelayConsume","SubType":"NULL"},
100423: {"Type":"DelayConsume","SubType":"NULL"},
100424: {"Type":"DelayConsume","SubType":"NULL"},
100425: {"Type":"DelayConsume","SubType":"NULL"},
100426: {"Type":"DelayConsume","SubType":"NULL"},
100428: {"Type":"Usable","SubType":"NULL"},
100433: {"Type":"DelayConsume","SubType":"NULL"},
100436: {"Type":"DelayConsume","SubType":"NULL"},
100437: {"Type":"Usable","SubType":"NULL"},
100442: {"Type":"Usable","SubType":"NULL"},
100443: {"Type":"Usable","SubType":"NULL"},
100444: {"Type":"Usable","SubType":"NULL"},
100445: {"Type":"Usable","SubType":"NULL"},
100446: {"Type":"Usable","SubType":"NULL"},
100447: {"Type":"Usable","SubType":"NULL"},
100452: {"Type":"DelayConsume","SubType":"NULL"},
100453: {"Type":"DelayConsume","SubType":"NULL"},
100454: {"Type":"DelayConsume","SubType":"NULL"},
100455: {"Type":"DelayConsume","SubType":"NULL"},
100456: {"Type":"DelayConsume","SubType":"NULL"},
100457: {"Type":"DelayConsume","SubType":"NULL"},
100460: {"Type":"Usable","SubType":"NULL"},
100462: {"Type":"Usable","SubType":"NULL"},
100465: {"Type":"Usable","SubType":"NULL"},
100466: {"Type":"DelayConsume","SubType":"NULL"},
100467: {"Type":"DelayConsume","SubType":"NULL"},
100468: {"Type":"DelayConsume","SubType":"NULL"},
100469: {"Type":"Usable","SubType":"NULL"},
100470: {"Type":"Usable","SubType":"NULL"},
100475: {"Type":"Usable","SubType":"NULL"},
100476: {"Type":"DelayConsume","SubType":"NULL"},
100477: {"Type":"Usable","SubType":"NULL"},
100478: {"Type":"Usable","SubType":"NULL"},
100479: {"Type":"DelayConsume","SubType":"NULL"},
100480: {"Type":"DelayConsume","SubType":"NULL"},
100481: {"Type":"DelayConsume","SubType":"NULL"},
100485: {"Type":"DelayConsume","SubType":"NULL"},
100486: {"Type":"DelayConsume","SubType":"NULL"},
100487: {"Type":"DelayConsume","SubType":"NULL"},
100488: {"Type":"DelayConsume","SubType":"NULL"},
100495: {"Type":"Usable","SubType":"NULL"},
100496: {"Type":"Usable","SubType":"NULL"},
100497: {"Type":"Usable","SubType":"NULL"},
100498: {"Type":"Usable","SubType":"NULL"},
100499: {"Type":"Usable","SubType":"NULL"},
100500: {"Type":"Usable","SubType":"NULL"},
100501: {"Type":"Usable","SubType":"NULL"},
100502: {"Type":"Usable","SubType":"NULL"},
100508: {"Type":"Usable","SubType":"NULL"},
100509: {"Type":"Usable","SubType":"NULL"},
100510: {"Type":"Usable","SubType":"NULL"},
100511: {"Type":"Usable","SubType":"NULL"},
100512: {"Type":"Usable","SubType":"NULL"},
100515: {"Type":"Usable","SubType":"NULL"},
100516: {"Type":"Healing","SubType":"NULL"},
100517: {"Type":"Healing","SubType":"NULL"},
100518: {"Type":"Healing","SubType":"NULL"},
100519: {"Type":"Healing","SubType":"NULL"},
100520: {"Type":"Healing","SubType":"NULL"},
100521: {"Type":"Healing","SubType":"NULL"},
100522: {"Type":"Healing","SubType":"NULL"},
100523: {"Type":"Healing","SubType":"NULL"},
100534: {"Type":"Usable","SubType":"NULL"},
100537: {"Type":"Usable","SubType":"NULL"},
100538: {"Type":"Usable","SubType":"NULL"},
100539: {"Type":"Usable","SubType":"NULL"},
100540: {"Type":"Usable","SubType":"NULL"},
100541: {"Type":"Usable","SubType":"NULL"},
100542: {"Type":"Usable","SubType":"NULL"},
100547: {"Type":"Usable","SubType":"NULL"},
100553: {"Type":"Usable","SubType":"NULL"},
100569: {"Type":"Usable","SubType":"NULL"},
100570: {"Type":"Usable","SubType":"NULL"},
100572: {"Type":"DelayConsume","SubType":"NULL"},
100573: {"Type":"Usable","SubType":"NULL"},
100574: {"Type":"Usable","SubType":"NULL"},
100575: {"Type":"Usable","SubType":"NULL"},
100576: {"Type":"Usable","SubType":"NULL"},
100577: {"Type":"Usable","SubType":"NULL"},
100579: {"Type":"DelayConsume","SubType":"NULL"},
100580: {"Type":"DelayConsume","SubType":"NULL"},
100585: {"Type":"Usable","SubType":"NULL"},
100591: {"Type":"DelayConsume","SubType":"NULL"},
100592: {"Type":"DelayConsume","SubType":"NULL"},
100596: {"Type":"DelayConsume","SubType":"NULL"},
100600: {"Type":"DelayConsume","SubType":"NULL"},
100601: {"Type":"DelayConsume","SubType":"NULL"},
100602: {"Type":"DelayConsume","SubType":"NULL"},
100603: {"Type":"Usable","SubType":"NULL"},
100616: {"Type":"Usable","SubType":"NULL"},
100619: {"Type":"DelayConsume","SubType":"NULL"},
100620: {"Type":"DelayConsume","SubType":"NULL"},
100621: {"Type":"DelayConsume","SubType":"NULL"},
100623: {"Type":"DelayConsume","SubType":"NULL"},
100626: {"Type":"DelayConsume","SubType":"NULL"},
100627: {"Type":"DelayConsume","SubType":"NULL"},
100648: {"Type":"DelayConsume","SubType":"NULL"},
100649: {"Type":"DelayConsume","SubType":"NULL"},
100650: {"Type":"DelayConsume","SubType":"NULL"},
100651: {"Type":"DelayConsume","SubType":"NULL"},
100652: {"Type":"DelayConsume","SubType":"NULL"},
100653: {"Type":"DelayConsume","SubType":"NULL"},
100655: {"Type":"Usable","SubType":"NULL"},
100661: {"Type":"DelayConsume","SubType":"NULL"},
100684: {"Type":"DelayConsume","SubType":"NULL"},
100690: {"Type":"Usable","SubType":"NULL"},
100691: {"Type":"DelayConsume","SubType":"NULL"},
100694: {"Type":"DelayConsume","SubType":"NULL"},
100695: {"Type":"DelayConsume","SubType":"NULL"},
100699: {"Type":"DelayConsume","SubType":"NULL"},
100700: {"Type":"DelayConsume","SubType":"NULL"},
100706: {"Type":"Usable","SubType":"NULL"},
100707: {"Type":"Usable","SubType":"NULL"},
100708: {"Type":"Usable","SubType":"NULL"},
100709: {"Type":"Usable","SubType":"NULL"},
100710: {"Type":"DelayConsume","SubType":"NULL"},
100717: {"Type":"Usable","SubType":"NULL"},
100721: {"Type":"Usable","SubType":"NULL"},
100722: {"Type":"DelayConsume","SubType":"NULL"},
100723: {"Type":"DelayConsume","SubType":"NULL"},
100724: {"Type":"Usable","SubType":"NULL"},
100726: {"Type":"Usable","SubType":"NULL"},
100727: {"Type":"Usable","SubType":"NULL"},
100728: {"Type":"Usable","SubType":"NULL"},
100742: {"Type":"Usable","SubType":"NULL"},
100744: {"Type":"DelayConsume","SubType":"NULL"},
100745: {"Type":"DelayConsume","SubType":"NULL"},
100746: {"Type":"DelayConsume","SubType":"NULL"},
100747: {"Type":"DelayConsume","SubType":"NULL"},
100748: {"Type":"DelayConsume","SubType":"NULL"},
100750: {"Type":"Usable","SubType":"NULL"},
100751: {"Type":"Usable","SubType":"NULL"},
100752: {"Type":"Usable","SubType":"NULL"},
100753: {"Type":"DelayConsume","SubType":"NULL"},
100754: {"Type":"Usable","SubType":"NULL"},
100783: {"Type":"DelayConsume","SubType":"NULL"},
100784: {"Type":"DelayConsume","SubType":"NULL"},
100785: {"Type":"Usable","SubType":"NULL"},
100786: {"Type":"DelayConsume","SubType":"NULL"},
100796: {"Type":"Usable","SubType":"NULL"},
100810: {"Type":"Usable","SubType":"NULL"},
100816: {"Type":"Usable","SubType":"NULL"},
100817: {"Type":"DelayConsume","SubType":"NULL"},
100819: {"Type":"DelayConsume","SubType":"NULL"},
100820: {"Type":"DelayConsume","SubType":"NULL"},
100821: {"Type":"DelayConsume","SubType":"NULL"},
100822: {"Type":"DelayConsume","SubType":"NULL"},
100823: {"Type":"DelayConsume","SubType":"NULL"},
100829: {"Type":"Usable","SubType":"NULL"},
100830: {"Type":"Usable","SubType":"NULL"},
100831: {"Type":"Usable","SubType":"NULL"},
100832: {"Type":"Usable","SubType":"NULL"},
100833: {"Type":"Usable","SubType":"NULL"},
100834: {"Type":"DelayConsume","SubType":"NULL"},
100835: {"Type":"DelayConsume","SubType":"NULL"},
100848: {"Type":"Healing","SubType":"NULL"},
100870: {"Type":"Usable","SubType":"NULL"},
100874: {"Type":"Cash","SubType":"NULL"},
100875: {"Type":"Cash","SubType":"NULL"},
100880: {"Type":"Usable","SubType":"NULL"},
100886: {"Type":"Usable","SubType":"NULL"},
100887: {"Type":"DelayConsume","SubType":"NULL"},
100888: {"Type":"DelayConsume","SubType":"NULL"},
100890: {"Type":"DelayConsume","SubType":"NULL"},
100900: {"Type":"Usable","SubType":"NULL"},
100901: {"Type":"Usable","SubType":"NULL"},
100902: {"Type":"Usable","SubType":"NULL"},
100903: {"Type":"Usable","SubType":"NULL"},
100904: {"Type":"Usable","SubType":"NULL"},
100906: {"Type":"Usable","SubType":"NULL"},
100908: {"Type":"Usable","SubType":"NULL"},
100910: {"Type":"Usable","SubType":"NULL"},
100911: {"Type":"Usable","SubType":"NULL"},
100913: {"Type":"Usable","SubType":"NULL"},
100914: {"Type":"Usable","SubType":"NULL"},
100917: {"Type":"DelayConsume","SubType":"NULL"},
100918: {"Type":"DelayConsume","SubType":"NULL"},
100920: {"Type":"Usable","SubType":"NULL"},
100929: {"Type":"Usable","SubType":"NULL"},
100933: {"Type":"Usable","SubType":"NULL"},
100934: {"Type":"Usable","SubType":"NULL"},
100938: {"Type":"DelayConsume","SubType":"NULL"},
100939: {"Type":"DelayConsume","SubType":"NULL"},
100943: {"Type":"Usable","SubType":"NULL"},
100949: {"Type":"Usable","SubType":"NULL"},
100950: {"Type":"Usable","SubType":"NULL"},
100951: {"Type":"Usable","SubType":"NULL"},
100952: {"Type":"Usable","SubType":"NULL"},
100954: {"Type":"Usable","SubType":"NULL"},
100955: {"Type":"Usable","SubType":"NULL"},
100956: {"Type":"Usable","SubType":"NULL"},
100957: {"Type":"Usable","SubType":"NULL"},
100958: {"Type":"Usable","SubType":"NULL"},
100959: {"Type":"Usable","SubType":"NULL"},
100960: {"Type":"Usable","SubType":"NULL"},
100961: {"Type":"Usable","SubType":"NULL"},
100962: {"Type":"Usable","SubType":"NULL"},
100963: {"Type":"Usable","SubType":"NULL"},
100964: {"Type":"Usable","SubType":"NULL"},
100965: {"Type":"Usable","SubType":"NULL"},
100966: {"Type":"Usable","SubType":"NULL"},
100967: {"Type":"Usable","SubType":"NULL"},
100968: {"Type":"Usable","SubType":"NULL"},
100969: {"Type":"Usable","SubType":"NULL"},
100970: {"Type":"Usable","SubType":"NULL"},
100971: {"Type":"Usable","SubType":"NULL"},
100972: {"Type":"Usable","SubType":"NULL"},
100973: {"Type":"Usable","SubType":"NULL"},
100974: {"Type":"Usable","SubType":"NULL"},
100975: {"Type":"Usable","SubType":"NULL"},
100976: {"Type":"Usable","SubType":"NULL"},
100977: {"Type":"Usable","SubType":"NULL"},
100978: {"Type":"Usable","SubType":"NULL"},
100979: {"Type":"Usable","SubType":"NULL"},
100980: {"Type":"Usable","SubType":"NULL"},
100981: {"Type":"Usable","SubType":"NULL"},
100982: {"Type":"Usable","SubType":"NULL"},
100983: {"Type":"Usable","SubType":"NULL"},
100984: {"Type":"Usable","SubType":"NULL"},
100985: {"Type":"Usable","SubType":"NULL"},
100986: {"Type":"Usable","SubType":"NULL"},
100987: {"Type":"Usable","SubType":"NULL"},
100988: {"Type":"Usable","SubType":"NULL"},
100989: {"Type":"Usable","SubType":"NULL"},
100990: {"Type":"Usable","SubType":"NULL"},
100991: {"Type":"Usable","SubType":"NULL"},
100992: {"Type":"Usable","SubType":"NULL"},
100994: {"Type":"Usable","SubType":"NULL"},
100995: {"Type":"Usable","SubType":"NULL"},
100996: {"Type":"Usable","SubType":"NULL"},
100997: {"Type":"Usable","SubType":"NULL"},
100998: {"Type":"Usable","SubType":"NULL"},
100999: {"Type":"Usable","SubType":"NULL"},
101000: {"Type":"Usable","SubType":"NULL"},
101001: {"Type":"Usable","SubType":"NULL"},
101002: {"Type":"Usable","SubType":"NULL"},
101003: {"Type":"Usable","SubType":"NULL"},
101004: {"Type":"Usable","SubType":"NULL"},
101005: {"Type":"Usable","SubType":"NULL"},
101006: {"Type":"Usable","SubType":"NULL"},
101007: {"Type":"Usable","SubType":"NULL"},
101008: {"Type":"Usable","SubType":"NULL"},
101009: {"Type":"Usable","SubType":"NULL"},
101010: {"Type":"Usable","SubType":"NULL"},
101011: {"Type":"Usable","SubType":"NULL"},
101012: {"Type":"Usable","SubType":"NULL"},
101013: {"Type":"Usable","SubType":"NULL"},
101014: {"Type":"Usable","SubType":"NULL"},
101015: {"Type":"Usable","SubType":"NULL"},
101016: {"Type":"Usable","SubType":"NULL"},
101017: {"Type":"Usable","SubType":"NULL"},
101018: {"Type":"Usable","SubType":"NULL"},
101019: {"Type":"Usable","SubType":"NULL"},
101020: {"Type":"Usable","SubType":"NULL"},
101021: {"Type":"Usable","SubType":"NULL"},
101022: {"Type":"Usable","SubType":"NULL"},
101023: {"Type":"Usable","SubType":"NULL"},
101024: {"Type":"Usable","SubType":"NULL"},
101025: {"Type":"Usable","SubType":"NULL"},
101026: {"Type":"Usable","SubType":"NULL"},
101027: {"Type":"Usable","SubType":"NULL"},
101028: {"Type":"Usable","SubType":"NULL"},
101029: {"Type":"Usable","SubType":"NULL"},
101030: {"Type":"Usable","SubType":"NULL"},
101031: {"Type":"Usable","SubType":"NULL"},
101032: {"Type":"Usable","SubType":"NULL"},
101033: {"Type":"Usable","SubType":"NULL"},
101034: {"Type":"Usable","SubType":"NULL"},
101035: {"Type":"Usable","SubType":"NULL"},
101036: {"Type":"Usable","SubType":"NULL"},
101037: {"Type":"Usable","SubType":"NULL"},
101038: {"Type":"Usable","SubType":"NULL"},
101039: {"Type":"Usable","SubType":"NULL"},
101040: {"Type":"Usable","SubType":"NULL"},
101041: {"Type":"Usable","SubType":"NULL"},
101042: {"Type":"Usable","SubType":"NULL"},
101043: {"Type":"Usable","SubType":"NULL"},
101044: {"Type":"Usable","SubType":"NULL"},
101045: {"Type":"Usable","SubType":"NULL"},
101046: {"Type":"Usable","SubType":"NULL"},
101047: {"Type":"Usable","SubType":"NULL"},
101048: {"Type":"Usable","SubType":"NULL"},
101060: {"Type":"DelayConsume","SubType":"NULL"},
101062: {"Type":"DelayConsume","SubType":"NULL"},
101067: {"Type":"Usable","SubType":"NULL"},
101070: {"Type":"Usable","SubType":"NULL"},
101074: {"Type":"Usable","SubType":"NULL"},
101075: {"Type":"DelayConsume","SubType":"NULL"},
101077: {"Type":"DelayConsume","SubType":"NULL"},
101078: {"Type":"DelayConsume","SubType":"NULL"},
101097: {"Type":"Usable","SubType":"NULL"},
101099: {"Type":"Usable","SubType":"NULL"},
101100: {"Type":"Usable","SubType":"NULL"},
101101: {"Type":"Usable","SubType":"NULL"},
101103: {"Type":"Usable","SubType":"NULL"},
101107: {"Type":"Usable","SubType":"NULL"},
101108: {"Type":"Usable","SubType":"NULL"},
101109: {"Type":"Usable","SubType":"NULL"},
101110: {"Type":"Usable","SubType":"NULL"},
101111: {"Type":"Usable","SubType":"NULL"},
101112: {"Type":"Usable","SubType":"NULL"},
101113: {"Type":"Usable","SubType":"NULL"},
101114: {"Type":"Usable","SubType":"NULL"},
101115: {"Type":"Usable","SubType":"NULL"},
101116: {"Type":"Usable","SubType":"NULL"},
101117: {"Type":"Usable","SubType":"NULL"},
101118: {"Type":"Usable","SubType":"NULL"},
101119: {"Type":"Usable","SubType":"NULL"},
101120: {"Type":"Usable","SubType":"NULL"},
101121: {"Type":"Usable","SubType":"NULL"},
101122: {"Type":"Usable","SubType":"NULL"},
101123: {"Type":"Usable","SubType":"NULL"},
101124: {"Type":"Usable","SubType":"NULL"},
101126: {"Type":"Healing","SubType":"NULL"},
101128: {"Type":"Usable","SubType":"NULL"},
101129: {"Type":"Usable","SubType":"NULL"},
101130: {"Type":"Usable","SubType":"NULL"},
101139: {"Type":"Cash","SubType":"NULL"},
101148: {"Type":"Usable","SubType":"NULL"},
101159: {"Type":"Usable","SubType":"NULL"},
101161: {"Type":"Usable","SubType":"NULL"},
101162: {"Type":"Usable","SubType":"NULL"},
101166: {"Type":"Usable","SubType":"NULL"},
101167: {"Type":"Cash","SubType":"NULL"},
101168: {"Type":"Usable","SubType":"NULL"},
101169: {"Type":"Usable","SubType":"NULL"},
101170: {"Type":"Usable","SubType":"NULL"},
101177: {"Type":"DelayConsume","SubType":"NULL"},
101178: {"Type":"DelayConsume","SubType":"NULL"},
101179: {"Type":"DelayConsume","SubType":"NULL"},
101180: {"Type":"DelayConsume","SubType":"NULL"},
101181: {"Type":"DelayConsume","SubType":"NULL"},
101182: {"Type":"DelayConsume","SubType":"NULL"},
101183: {"Type":"Usable","SubType":"NULL"},
101184: {"Type":"DelayConsume","SubType":"NULL"},
101185: {"Type":"DelayConsume","SubType":"NULL"},
101186: {"Type":"DelayConsume","SubType":"NULL"},
101187: {"Type":"DelayConsume","SubType":"NULL"},
101188: {"Type":"DelayConsume","SubType":"NULL"},
101189: {"Type":"DelayConsume","SubType":"NULL"},
101190: {"Type":"DelayConsume","SubType":"NULL"},
101194: {"Type":"Usable","SubType":"NULL"},
101200: {"Type":"Usable","SubType":"NULL"},
101217: {"Type":"DelayConsume","SubType":"NULL"},
101218: {"Type":"DelayConsume","SubType":"NULL"},
101219: {"Type":"DelayConsume","SubType":"NULL"},
101220: {"Type":"DelayConsume","SubType":"NULL"},
101234: {"Type":"Usable","SubType":"NULL"},
101236: {"Type":"Usable","SubType":"NULL"},
101238: {"Type":"Usable","SubType":"NULL"},
101240: {"Type":"Usable","SubType":"NULL"},
101241: {"Type":"Usable","SubType":"NULL"},
101243: {"Type":"DelayConsume","SubType":"NULL"},
101257: {"Type":"DelayConsume","SubType":"NULL"},
101258: {"Type":"DelayConsume","SubType":"NULL"},
101259: {"Type":"DelayConsume","SubType":"NULL"},
101260: {"Type":"DelayConsume","SubType":"NULL"},
101261: {"Type":"DelayConsume","SubType":"NULL"},
101262: {"Type":"DelayConsume","SubType":"NULL"},
101264: {"Type":"DelayConsume","SubType":"NULL"},
101268: {"Type":"Usable","SubType":"NULL"},
101269: {"Type":"Usable","SubType":"NULL"},
101271: {"Type":"Usable","SubType":"NULL"},
101276: {"Type":"Usable","SubType":"NULL"},
101279: {"Type":"Usable","SubType":"NULL"},
101306: {"Type":"DelayConsume","SubType":"NULL"},
101307: {"Type":"DelayConsume","SubType":"NULL"},
101308: {"Type":"DelayConsume","SubType":"NULL"},
101309: {"Type":"DelayConsume","SubType":"NULL"},
101310: {"Type":"DelayConsume","SubType":"NULL"},
101311: {"Type":"DelayConsume","SubType":"NULL"},
101314: {"Type":"Usable","SubType":"NULL"},
101321: {"Type":"Usable","SubType":"NULL"},
101322: {"Type":"Healing","SubType":"NULL"},
101331: {"Type":"Usable","SubType":"NULL"},
101336: {"Type":"Usable","SubType":"NULL"},
101337: {"Type":"Usable","SubType":"NULL"},
101340: {"Type":"DelayConsume","SubType":"NULL"},
101341: {"Type":"DelayConsume","SubType":"NULL"},
101342: {"Type":"DelayConsume","SubType":"NULL"},
101343: {"Type":"DelayConsume","SubType":"NULL"},
101344: {"Type":"DelayConsume","SubType":"NULL"},
101345: {"Type":"DelayConsume","SubType":"NULL"},
101346: {"Type":"DelayConsume","SubType":"NULL"},
101347: {"Type":"DelayConsume","SubType":"NULL"},
101352: {"Type":"Cash","SubType":"NULL"},
101355: {"Type":"DelayConsume","SubType":"NULL"},
101357: {"Type":"Delayconsume","SubType":"NULL"},
101359: {"Type":"DelayConsume","SubType":"NULL"},
101360: {"Type":"DelayConsume","SubType":"NULL"},
101361: {"Type":"DelayConsume","SubType":"NULL"},
101362: {"Type":"DelayConsume","SubType":"NULL"},
101363: {"Type":"DelayConsume","SubType":"NULL"},
101364: {"Type":"DelayConsume","SubType":"NULL"},
101389: {"Type":"DelayConsume","SubType":"NULL"},
101390: {"Type":"DelayConsume","SubType":"NULL"},
101391: {"Type":"Usable","SubType":"NULL"},
101393: {"Type":"Healing","SubType":"NULL"},
101394: {"Type":"Healing","SubType":"NULL"},
101399: {"Type":"Usable","SubType":"NULL"},
101404: {"Type":"Usable","SubType":"NULL"},
101406: {"Type":"Usable","SubType":"NULL"},
101407: {"Type":"Usable","SubType":"NULL"},
101408: {"Type":"Usable","SubType":"NULL"},
101416: {"Type":"Usable","SubType":"NULL"},
101423: {"Type":"DelayConsume","SubType":"NULL"},
101453: {"Type":"DelayConsume","SubType":"NULL"},
101454: {"Type":"DelayConsume","SubType":"NULL"},
101455: {"Type":"DelayConsume","SubType":"NULL"},
101456: {"Type":"DelayConsume","SubType":"NULL"},
101457: {"Type":"DelayConsume","SubType":"NULL"},
101458: {"Type":"DelayConsume","SubType":"NULL"},
101459: {"Type":"DelayConsume","SubType":"NULL"},
101460: {"Type":"Usable","SubType":"NULL"},
101461: {"Type":"Cash","SubType":"NULL"},
101463: {"Type":"Usable","SubType":"NULL"},
101465: {"Type":"Usable","SubType":"NULL"},
101470: {"Type":"DelayConsume","SubType":"NULL"},
101471: {"Type":"DelayConsume","SubType":"NULL"},
101473: {"Type":"Usable","SubType":"NULL"},
101474: {"Type":"Usable","SubType":"NULL"},
101475: {"Type":"Usable","SubType":"NULL"},
101476: {"Type":"Usable","SubType":"NULL"},
101482: {"Type":"DelayConsume","SubType":"NULL"},
101483: {"Type":"DelayConsume","SubType":"NULL"},
101490: {"Type":"Usable","SubType":"NULL"},
101491: {"Type":"Usable","SubType":"NULL"},
101492: {"Type":"Usable","SubType":"NULL"},
101493: {"Type":"Usable","SubType":"NULL"},
101494: {"Type":"Usable","SubType":"NULL"},
101495: {"Type":"Usable","SubType":"NULL"},
101496: {"Type":"Usable","SubType":"NULL"},
101497: {"Type":"Usable","SubType":"NULL"},
101498: {"Type":"Usable","SubType":"NULL"},
101499: {"Type":"Usable","SubType":"NULL"},
101500: {"Type":"Usable","SubType":"NULL"},
101501: {"Type":"Usable","SubType":"NULL"},
101502: {"Type":"Usable","SubType":"NULL"},
101503: {"Type":"Usable","SubType":"NULL"},
101512: {"Type":"Usable","SubType":"NULL"},
101513: {"Type":"Usable","SubType":"NULL"},
101514: {"Type":"Usable","SubType":"NULL"},
101522: {"Type":"Usable","SubType":"NULL"},
101523: {"Type":"Usable","SubType":"NULL"},
101524: {"Type":"Usable","SubType":"NULL"},
101525: {"Type":"Usable","SubType":"NULL"},
101538: {"Type":"Usable","SubType":"NULL"},
101542: {"Type":"DelayConsume","SubType":"NULL"},
101543: {"Type":"Usable","SubType":"NULL"},
101544: {"Type":"Usable","SubType":"NULL"},
101545: {"Type":"Usable","SubType":"NULL"},
101546: {"Type":"Usable","SubType":"NULL"},
101547: {"Type":"DelayConsume","SubType":"NULL"},
101548: {"Type":"Usable","SubType":"NULL"},
101549: {"Type":"Usable","SubType":"NULL"},
101550: {"Type":"Usable","SubType":"NULL"},
101551: {"Type":"Usable","SubType":"NULL"},
101552: {"Type":"DelayConsume","SubType":"NULL"},
101553: {"Type":"Usable","SubType":"NULL"},
101554: {"Type":"Usable","SubType":"NULL"},
101555: {"Type":"DelayConsume","SubType":"NULL"},
101556: {"Type":"Usable","SubType":"NULL"},
101557: {"Type":"Usable","SubType":"NULL"},
101563: {"Type":"DelayConsume","SubType":"NULL"},
101564: {"Type":"DelayConsume","SubType":"NULL"},
101565: {"Type":"DelayConsume","SubType":"NULL"},
101567: {"Type":"Usable","SubType":"NULL"},
101589: {"Type":"Cash","SubType":"NULL"},
101592: {"Type":"Etc","SubType":"NULL"},
101596: {"Type":"Usable","SubType":"NULL"},
101597: {"Type":"Usable","SubType":"NULL"},
101599: {"Type":"Usable","SubType":"NULL"},
101600: {"Type":"Usable","SubType":"NULL"},
101601: {"Type":"Usable","SubType":"NULL"},
101602: {"Type":"Usable","SubType":"NULL"},
101603: {"Type":"Usable","SubType":"NULL"},
101604: {"Type":"Usable","SubType":"NULL"},
101605: {"Type":"Usable","SubType":"NULL"},
101637: {"Type":"DelayConsume","SubType":"NULL"},
101638: {"Type":"Usable","SubType":"NULL"},
101639: {"Type":"DelayConsume","SubType":"NULL"},
101645: {"Type":"DelayConsume","SubType":"NULL"},
101649: {"Type":"Usable","SubType":"NULL"},
101653: {"Type":"Usable","SubType":"NULL"},
101654: {"Type":"DelayConsume","SubType":"NULL"},
101655: {"Type":"Usable","SubType":"NULL"},
101656: {"Type":"Usable","SubType":"NULL"},
101657: {"Type":"DelayConsume","SubType":"NULL"},
101658: {"Type":"Usable","SubType":"NULL"},
101659: {"Type":"Usable","SubType":"NULL"},
101660: {"Type":"Usable","SubType":"NULL"},
101661: {"Type":"Usable","SubType":"NULL"},
101662: {"Type":"DelayConsume","SubType":"NULL"},
101663: {"Type":"Usable","SubType":"NULL"},
101664: {"Type":"Usable","SubType":"NULL"},
101665: {"Type":"DelayConsume","SubType":"NULL"},
101666: {"Type":"Usable","SubType":"NULL"},
101675: {"Type":"Usable","SubType":"NULL"},
101705: {"Type":"Usable","SubType":"NULL"},
101706: {"Type":"Usable","SubType":"NULL"},
101717: {"Type":"Usable","SubType":"NULL"},
101718: {"Type":"Usable","SubType":"NULL"},
101719: {"Type":"Usable","SubType":"NULL"},
101720: {"Type":"Usable","SubType":"NULL"},
101721: {"Type":"Usable","SubType":"NULL"},
101722: {"Type":"Usable","SubType":"NULL"},
101723: {"Type":"Usable","SubType":"NULL"},
101724: {"Type":"Usable","SubType":"NULL"},
101725: {"Type":"Usable","SubType":"NULL"},
101726: {"Type":"Usable","SubType":"NULL"},
101727: {"Type":"DelayConsume","SubType":"NULL"},
101728: {"Type":"DelayConsume","SubType":"NULL"},
101729: {"Type":"DelayConsume","SubType":"NULL"},
101744: {"Type":"Usable","SubType":"NULL"},
101745: {"Type":"DelayConsume","SubType":"NULL"},
101746: {"Type":"Usable","SubType":"NULL"},
101750: {"Type":"Usable","SubType":"NULL"},
101752: {"Type":"Usable","SubType":"NULL"},
101753: {"Type":"Usable","SubType":"NULL"},
101754: {"Type":"Usable","SubType":"NULL"},
101755: {"Type":"Usable","SubType":"NULL"},
101756: {"Type":"Usable","SubType":"NULL"},
101757: {"Type":"Usable","SubType":"NULL"},
101759: {"Type":"Usable","SubType":"NULL"},
101760: {"Type":"Usable","SubType":"NULL"},
101761: {"Type":"Usable","SubType":"NULL"},
101762: {"Type":"Usable","SubType":"NULL"},
101765: {"Type":"Usable","SubType":"NULL"},
101766: {"Type":"Usable","SubType":"NULL"},
101767: {"Type":"Usable","SubType":"NULL"},
101768: {"Type":"Usable","SubType":"NULL"},
101769: {"Type":"DelayConsume","SubType":"NULL"},
101770: {"Type":"DelayConsume","SubType":"NULL"},
101771: {"Type":"DelayConsume","SubType":"NULL"},
101772: {"Type":"DelayConsume","SubType":"NULL"},
101774: {"Type":"Cash","SubType":"NULL"},
101775: {"Type":"Cash","SubType":"NULL"},
101776: {"Type":"Cash","SubType":"NULL"},
101777: {"Type":"Cash","SubType":"NULL"},
101778: {"Type":"Cash","SubType":"NULL"},
101779: {"Type":"Cash","SubType":"NULL"},
101780: {"Type":"Cash","SubType":"NULL"},
101781: {"Type":"Cash","SubType":"NULL"},
101782: {"Type":"Cash","SubType":"NULL"},
101783: {"Type":"Cash","SubType":"NULL"},
101784: {"Type":"Cash","SubType":"NULL"},
101785: {"Type":"Cash","SubType":"NULL"},
101786: {"Type":"Cash","SubType":"NULL"},
101787: {"Type":"Cash","SubType":"NULL"},
101788: {"Type":"Cash","SubType":"NULL"},
101789: {"Type":"Cash","SubType":"NULL"},
101792: {"Type":"DelayConsume","SubType":"NULL"},
101801: {"Type":"DelayConsume","SubType":"NULL"},
101802: {"Type":"Usable","SubType":"NULL"},
101803: {"Type":"Usable","SubType":"NULL"},
101804: {"Type":"Usable","SubType":"NULL"},
101805: {"Type":"Usable","SubType":"NULL"},
101806: {"Type":"DelayConsume","SubType":"NULL"},
101807: {"Type":"Usable","SubType":"NULL"},
101808: {"Type":"Usable","SubType":"NULL"},
101809: {"Type":"Usable","SubType":"NULL"},
101816: {"Type":"DelayConsume","SubType":"NULL"},
101834: {"Type":"Usable","SubType":"NULL"},
101835: {"Type":"Usable","SubType":"NULL"},
101837: {"Type":"Usable","SubType":"NULL"},
101839: {"Type":"Usable","SubType":"NULL"},
101840: {"Type":"Usable","SubType":"NULL"},
101856: {"Type":"DelayConsume","SubType":"NULL"},
101858: {"Type":"Usable","SubType":"NULL"},
101859: {"Type":"Usable","SubType":"NULL"},
101860: {"Type":"Usable","SubType":"NULL"},
101861: {"Type":"Usable","SubType":"NULL"},
101862: {"Type":"DelayConsume","SubType":"NULL"},
101863: {"Type":"Usable","SubType":"NULL"},
101864: {"Type":"Usable","SubType":"NULL"},
101869: {"Type":"Usable","SubType":"NULL"},
101876: {"Type":"Usable","SubType":"NULL"},
101889: {"Type":"Usable","SubType":"NULL"},
101912: {"Type":"Usable","SubType":"NULL"},
101913: {"Type":"Usable","SubType":"NULL"},
101914: {"Type":"Usable","SubType":"NULL"},
101919: {"Type":"DelayConsume","SubType":"NULL"},
101920: {"Type":"Usable","SubType":"NULL"},
101921: {"Type":"Usable","SubType":"NULL"},
101922: {"Type":"DelayConsume","SubType":"NULL"},
101923: {"Type":"Usable","SubType":"NULL"},
101924: {"Type":"Usable","SubType":"NULL"},
101925: {"Type":"Usable","SubType":"NULL"},
101930: {"Type":"Usable","SubType":"NULL"},
101931: {"Type":"Usable","SubType":"NULL"},
101932: {"Type":"Usable","SubType":"NULL"},
101933: {"Type":"DelayConsume","SubType":"NULL"},
101934: {"Type":"DelayConsume","SubType":"NULL"},
101935: {"Type":"DelayConsume","SubType":"NULL"},
101936: {"Type":"DelayConsume","SubType":"NULL"},
101937: {"Type":"DelayConsume","SubType":"NULL"},
101938: {"Type":"DelayConsume","SubType":"NULL"},
101947: {"Type":"Usable","SubType":"NULL"},
101948: {"Type":"Usable","SubType":"NULL"},
101952: {"Type":"Etc","SubType":"NULL"},
101954: {"Type":"Usable","SubType":"NULL"},
102015: {"Type":"Usable","SubType":"NULL"},
102016: {"Type":"Usable","SubType":"NULL"},
102017: {"Type":"DelayConsume","SubType":"NULL"},
102018: {"Type":"DelayConsume","SubType":"NULL"},
102019: {"Type":"DelayConsume","SubType":"NULL"},
102020: {"Type":"DelayConsume","SubType":"NULL"},
102021: {"Type":"DelayConsume","SubType":"NULL"},
102022: {"Type":"DelayConsume","SubType":"NULL"},
102023: {"Type":"DelayConsume","SubType":"NULL"},
102024: {"Type":"DelayConsume","SubType":"NULL"},
102025: {"Type":"DelayConsume","SubType":"NULL"},
102026: {"Type":"DelayConsume","SubType":"NULL"},
102027: {"Type":"DelayConsume","SubType":"NULL"},
102028: {"Type":"DelayConsume","SubType":"NULL"},
102029: {"Type":"DelayConsume","SubType":"NULL"},
102030: {"Type":"DelayConsume","SubType":"NULL"},
102031: {"Type":"DelayConsume","SubType":"NULL"},
102032: {"Type":"DelayConsume","SubType":"NULL"},
102033: {"Type":"DelayConsume","SubType":"NULL"},
102034: {"Type":"DelayConsume","SubType":"NULL"},
102035: {"Type":"DelayConsume","SubType":"NULL"},
102038: {"Type":"Etc","SubType":"NULL"},
102040: {"Type":"DelayConsume","SubType":"NULL"},
102041: {"Type":"DelayConsume","SubType":"NULL"},
102042: {"Type":"DelayConsume","SubType":"NULL"},
102043: {"Type":"DelayConsume","SubType":"NULL"},
102044: {"Type":"DelayConsume","SubType":"NULL"},
102045: {"Type":"DelayConsume","SubType":"NULL"},
102046: {"Type":"DelayConsume","SubType":"NULL"},
102047: {"Type":"DelayConsume","SubType":"NULL"},
102048: {"Type":"DelayConsume","SubType":"NULL"},
102049: {"Type":"DelayConsume","SubType":"NULL"},
102050: {"Type":"DelayConsume","SubType":"NULL"},
102051: {"Type":"DelayConsume","SubType":"NULL"},
102052: {"Type":"DelayConsume","SubType":"NULL"},
102053: {"Type":"DelayConsume","SubType":"NULL"},
102054: {"Type":"DelayConsume","SubType":"NULL"},
102055: {"Type":"DelayConsume","SubType":"NULL"},
102056: {"Type":"DelayConsume","SubType":"NULL"},
102057: {"Type":"DelayConsume","SubType":"NULL"},
102058: {"Type":"DelayConsume","SubType":"NULL"},
102059: {"Type":"DelayConsume","SubType":"NULL"},
102060: {"Type":"DelayConsume","SubType":"NULL"},
102061: {"Type":"DelayConsume","SubType":"NULL"},
102062: {"Type":"DelayConsume","SubType":"NULL"},
102067: {"Type":"Usable","SubType":"NULL"},
102068: {"Type":"Usable","SubType":"NULL"},
102069: {"Type":"Usable","SubType":"NULL"},
102070: {"Type":"Usable","SubType":"NULL"},
102071: {"Type":"Usable","SubType":"NULL"},
102072: {"Type":"DelayConsume","SubType":"NULL"},
102073: {"Type":"DelayConsume","SubType":"NULL"},
102074: {"Type":"Usable","SubType":"NULL"},
102075: {"Type":"DelayConsume","SubType":"NULL"},
102084: {"Type":"DelayConsume","SubType":"NULL"},
102121: {"Type":"Usable","SubType":"NULL"},
102123: {"Type":"Usable","SubType":"NULL"},
102124: {"Type":"DelayConsume","SubType":"NULL"},
102125: {"Type":"Usable","SubType":"NULL"},
102126: {"Type":"DelayConsume","SubType":"NULL"},
102128: {"Type":"Usable","SubType":"NULL"},
102129: {"Type":"Usable","SubType":"NULL"},
102193: {"Type":"Usable","SubType":"NULL"},
102202: {"Type":"Usable","SubType":"NULL"},
102213: {"Type":"DelayConsume","SubType":"NULL"},
102214: {"Type":"DelayConsume","SubType":"NULL"},
102215: {"Type":"DelayConsume","SubType":"NULL"},
102216: {"Type":"DelayConsume","SubType":"NULL"},
102217: {"Type":"DelayConsume","SubType":"NULL"},
102218: {"Type":"DelayConsume","SubType":"NULL"},
102219: {"Type":"DelayConsume","SubType":"NULL"},
102220: {"Type":"DelayConsume","SubType":"NULL"},
102221: {"Type":"DelayConsume","SubType":"NULL"},
102222: {"Type":"DelayConsume","SubType":"NULL"},
102223: {"Type":"DelayConsume","SubType":"NULL"},
102224: {"Type":"DelayConsume","SubType":"NULL"},
102226: {"Type":"Usable","SubType":"NULL"},
102227: {"Type":"DelayConsume","SubType":"NULL"},
102228: {"Type":"DelayConsume","SubType":"NULL"},
102238: {"Type":"DelayConsume","SubType":"NULL"},
102246: {"Type":"Usable","SubType":"NULL"},
102247: {"Type":"Usable","SubType":"NULL"},
102248: {"Type":"Usable","SubType":"NULL"},
102249: {"Type":"Usable","SubType":"NULL"},
102277: {"Type":"DelayConsume","SubType":"NULL"},
102278: {"Type":"DelayConsume","SubType":"NULL"},
102295: {"Type":"DelayConsume","SubType":"NULL"},
102306: {"Type":"DelayConsume","SubType":"NULL"},
102307: {"Type":"Usable","SubType":"NULL"},
102308: {"Type":"DelayConsume","SubType":"NULL"},
102310: {"Type":"DelayConsume","SubType":"NULL"},
102311: {"Type":"DelayConsume","SubType":"NULL"},
102332: {"Type":"Usable","SubType":"NULL"},
102333: {"Type":"Usable","SubType":"NULL"},
102337: {"Type":"Usable","SubType":"NULL"},
102338: {"Type":"DelayConsume","SubType":"NULL"},
102340: {"Type":"Usable","SubType":"NULL"},
102342: {"Type":"DelayConsume","SubType":"NULL"},
102343: {"Type":"DelayConsume","SubType":"NULL"},
102344: {"Type":"DelayConsume","SubType":"NULL"},
102345: {"Type":"Usable","SubType":"NULL"},
102353: {"Type":"Cash","SubType":"NULL"},
102354: {"Type":"Etc","SubType":"NULL"},
102373: {"Type":"DelayConsume","SubType":"NULL"},
102374: {"Type":"DelayConsume","SubType":"NULL"},
102396: {"Type":"DelayConsume","SubType":"NULL"},
102397: {"Type":"DelayConsume","SubType":"NULL"},
102404: {"Type":"Usable","SubType":"NULL"},
102413: {"Type":"Usable","SubType":"NULL"}
}
